
window.RAINFALL_BY_DISTRICT =
{
 "_attribution": "Rainfall derived from Met Office HadUK-Grid 1km gridded observations, 1991-2020 climatology, used under the Open Government Licence v3. Citation: Met Office; Hollis, D.; Carlisle, E.; Kendon, M.; Packman, S.; Doherty, A. HadUK-Grid Gridded Climate Observations on a 1km grid over the UK. Postcode locations from the ONS Postcode Directory; contains OS data (c) Crown copyright and database right, and Royal Mail data (c) Royal Mail copyright and database right.",
 "districts": {
  "AB10": {
   "cells": 12,
   "mm": 797,
   "n": 657,
   "periods": {
    "1961-1990": 751,
    "1981-2010": 770,
    "1991-2020": 797
   },
   "seasons": {
    "djf": 199,
    "jja": 201,
    "mam": 158,
    "son": 240
   },
   "summer_half": 358,
   "winter_half": 439
  },
  "AB11": {
   "cells": 9,
   "mm": 762,
   "n": 632,
   "periods": {
    "1961-1990": 716,
    "1981-2010": 735,
    "1991-2020": 762
   },
   "seasons": {
    "djf": 190,
    "jja": 193,
    "mam": 150,
    "son": 229
   },
   "summer_half": 343,
   "winter_half": 419
  },
  "AB12": {
   "cells": 70,
   "mm": 848,
   "n": 794,
   "periods": {
    "1961-1990": 787,
    "1981-2010": 820,
    "1991-2020": 848
   },
   "seasons": {
    "djf": 214,
    "jja": 217,
    "mam": 164,
    "son": 252
   },
   "summer_half": 381,
   "winter_half": 467
  },
  "AB13": {
   "cells": 10,
   "mm": 851,
   "n": 101,
   "periods": {
    "1961-1990": 807,
    "1981-2010": 834,
    "1991-2020": 851
   },
   "seasons": {
    "djf": 227,
    "jja": 212,
    "mam": 165,
    "son": 246
   },
   "summer_half": 377,
   "winter_half": 474
  },
  "AB14": {
   "cells": 15,
   "mm": 830,
   "n": 143,
   "periods": {
    "1961-1990": 790,
    "1981-2010": 815,
    "1991-2020": 830
   },
   "seasons": {
    "djf": 214,
    "jja": 208,
    "mam": 166,
    "son": 241
   },
   "summer_half": 374,
   "winter_half": 455
  },
  "AB15": {
   "cells": 52,
   "mm": 897,
   "n": 1111,
   "periods": {
    "1961-1990": 850,
    "1981-2010": 879,
    "1991-2020": 897
   },
   "seasons": {
    "djf": 230,
    "jja": 223,
    "mam": 177,
    "son": 268
   },
   "summer_half": 400,
   "winter_half": 498
  },
  "AB16": {
   "cells": 15,
   "mm": 885,
   "n": 768,
   "periods": {
    "1961-1990": 820,
    "1981-2010": 856,
    "1991-2020": 885
   },
   "seasons": {
    "djf": 221,
    "jja": 221,
    "mam": 176,
    "son": 267
   },
   "summer_half": 397,
   "winter_half": 488
  },
  "AB21": {
   "cells": 116,
   "mm": 863,
   "n": 824,
   "periods": {
    "1961-1990": 808,
    "1981-2010": 843,
    "1991-2020": 863
   },
   "seasons": {
    "djf": 211,
    "jja": 217,
    "mam": 171,
    "son": 264
   },
   "summer_half": 388,
   "winter_half": 475
  },
  "AB22": {
   "cells": 16,
   "mm": 823,
   "n": 328,
   "periods": {
    "1961-1990": 762,
    "1981-2010": 793,
    "1991-2020": 823
   },
   "seasons": {
    "djf": 207,
    "jja": 212,
    "mam": 160,
    "son": 244
   },
   "summer_half": 372,
   "winter_half": 451
  },
  "AB23": {
   "cells": 47,
   "mm": 787,
   "n": 345,
   "periods": {
    "1961-1990": 747,
    "1981-2010": 769,
    "1991-2020": 787
   },
   "seasons": {
    "djf": 193,
    "jja": 198,
    "mam": 155,
    "son": 240
   },
   "summer_half": 353,
   "winter_half": 434
  },
  "AB24": {
   "cells": 12,
   "mm": 800,
   "n": 817,
   "periods": {
    "1961-1990": 744,
    "1981-2010": 770,
    "1991-2020": 800
   },
   "seasons": {
    "djf": 205,
    "jja": 207,
    "mam": 155,
    "son": 234
   },
   "summer_half": 362,
   "winter_half": 438
  },
  "AB25": {
   "cells": 10,
   "mm": 824,
   "n": 478,
   "periods": {
    "1961-1990": 771,
    "1981-2010": 795,
    "1991-2020": 824
   },
   "seasons": {
    "djf": 209,
    "jja": 208,
    "mam": 163,
    "son": 244
   },
   "summer_half": 371,
   "winter_half": 453
  },
  "AB30": {
   "cells": 135,
   "mm": 916,
   "n": 321,
   "periods": {
    "1961-1990": 826,
    "1981-2010": 877,
    "1991-2020": 916
   },
   "seasons": {
    "djf": 226,
    "jja": 230,
    "mam": 183,
    "son": 278
   },
   "summer_half": 413,
   "winter_half": 503
  },
  "AB31": {
   "cells": 218,
   "mm": 905,
   "n": 658,
   "periods": {
    "1961-1990": 835,
    "1981-2010": 882,
    "1991-2020": 905
   },
   "seasons": {
    "djf": 229,
    "jja": 222,
    "mam": 184,
    "son": 271
   },
   "summer_half": 405,
   "winter_half": 500
  },
  "AB32": {
   "cells": 72,
   "mm": 860,
   "n": 369,
   "periods": {
    "1961-1990": 812,
    "1981-2010": 841,
    "1991-2020": 860
   },
   "seasons": {
    "djf": 208,
    "jja": 218,
    "mam": 175,
    "son": 259
   },
   "summer_half": 392,
   "winter_half": 467
  },
  "AB33": {
   "cells": 125,
   "mm": 889,
   "n": 272,
   "periods": {
    "1961-1990": 838,
    "1981-2010": 882,
    "1991-2020": 889
   },
   "seasons": {
    "djf": 206,
    "jja": 222,
    "mam": 190,
    "son": 271
   },
   "summer_half": 412,
   "winter_half": 477
  },
  "AB34": {
   "cells": 120,
   "mm": 842,
   "n": 274,
   "periods": {
    "1961-1990": 784,
    "1981-2010": 823,
    "1991-2020": 842
   },
   "seasons": {
    "djf": 199,
    "jja": 216,
    "mam": 171,
    "son": 256
   },
   "summer_half": 387,
   "winter_half": 455
  },
  "AB35": {
   "cells": 50,
   "mm": 899,
   "n": 165,
   "periods": {
    "1961-1990": 873,
    "1981-2010": 898,
    "1991-2020": 899
   },
   "seasons": {
    "djf": 248,
    "jja": 204,
    "mam": 180,
    "son": 267
   },
   "summer_half": 384,
   "winter_half": 515
  },
  "AB36": {
   "cells": 37,
   "mm": 965,
   "n": 47,
   "periods": {
    "1961-1990": 927,
    "1981-2010": 959,
    "1991-2020": 965
   },
   "seasons": {
    "djf": 238,
    "jja": 231,
    "mam": 199,
    "son": 297
   },
   "summer_half": 430,
   "winter_half": 535
  },
  "AB37": {
   "cells": 60,
   "mm": 901,
   "n": 88,
   "periods": {
    "1961-1990": 871,
    "1981-2010": 910,
    "1991-2020": 901
   },
   "seasons": {
    "djf": 221,
    "jja": 236,
    "mam": 181,
    "son": 263
   },
   "summer_half": 417,
   "winter_half": 484
  },
  "AB38": {
   "cells": 67,
   "mm": 910,
   "n": 165,
   "periods": {
    "1961-1990": 862,
    "1981-2010": 912,
    "1991-2020": 910
   },
   "seasons": {
    "djf": 213,
    "jja": 242,
    "mam": 184,
    "son": 272
   },
   "summer_half": 426,
   "winter_half": 485
  },
  "AB39": {
   "cells": 106,
   "mm": 875,
   "n": 553,
   "periods": {
    "1961-1990": 784,
    "1981-2010": 839,
    "1991-2020": 875
   },
   "seasons": {
    "djf": 216,
    "jja": 223,
    "mam": 172,
    "son": 264
   },
   "summer_half": 395,
   "winter_half": 480
  },
  "AB41": {
   "cells": 294,
   "mm": 847,
   "n": 824,
   "periods": {
    "1961-1990": 801,
    "1981-2010": 826,
    "1991-2020": 847
   },
   "seasons": {
    "djf": 207,
    "jja": 206,
    "mam": 169,
    "son": 265
   },
   "summer_half": 375,
   "winter_half": 472
  },
  "AB42": {
   "cells": 281,
   "mm": 856,
   "n": 1254,
   "periods": {
    "1961-1990": 799,
    "1981-2010": 833,
    "1991-2020": 856
   },
   "seasons": {
    "djf": 219,
    "jja": 204,
    "mam": 164,
    "son": 268
   },
   "summer_half": 368,
   "winter_half": 488
  },
  "AB43": {
   "cells": 191,
   "mm": 841,
   "n": 769,
   "periods": {
    "1961-1990": 785,
    "1981-2010": 821,
    "1991-2020": 841
   },
   "seasons": {
    "djf": 212,
    "jja": 202,
    "mam": 160,
    "son": 268
   },
   "summer_half": 361,
   "winter_half": 480
  },
  "AB44": {
   "cells": 5,
   "mm": 772,
   "n": 147,
   "periods": {
    "1961-1990": 751,
    "1981-2010": 762,
    "1991-2020": 772
   },
   "seasons": {
    "djf": 182,
    "jja": 210,
    "mam": 143,
    "son": 238
   },
   "summer_half": 353,
   "winter_half": 420
  },
  "AB45": {
   "cells": 207,
   "mm": 823,
   "n": 614,
   "periods": {
    "1961-1990": 780,
    "1981-2010": 812,
    "1991-2020": 823
   },
   "seasons": {
    "djf": 189,
    "jja": 221,
    "mam": 158,
    "son": 254
   },
   "summer_half": 379,
   "winter_half": 443
  },
  "AB51": {
   "cells": 331,
   "mm": 875,
   "n": 1209,
   "periods": {
    "1961-1990": 828,
    "1981-2010": 859,
    "1991-2020": 875
   },
   "seasons": {
    "djf": 210,
    "jja": 221,
    "mam": 175,
    "son": 269
   },
   "summer_half": 396,
   "winter_half": 479
  },
  "AB52": {
   "cells": 94,
   "mm": 901,
   "n": 250,
   "periods": {
    "1961-1990": 838,
    "1981-2010": 888,
    "1991-2020": 901
   },
   "seasons": {
    "djf": 211,
    "jja": 229,
    "mam": 182,
    "son": 280
   },
   "summer_half": 410,
   "winter_half": 491
  },
  "AB53": {
   "cells": 300,
   "mm": 894,
   "n": 686,
   "periods": {
    "1961-1990": 850,
    "1981-2010": 878,
    "1991-2020": 894
   },
   "seasons": {
    "djf": 210,
    "jja": 229,
    "mam": 171,
    "son": 284
   },
   "summer_half": 399,
   "winter_half": 494
  },
  "AB54": {
   "cells": 298,
   "mm": 914,
   "n": 658,
   "periods": {
    "1961-1990": 886,
    "1981-2010": 914,
    "1991-2020": 914
   },
   "seasons": {
    "djf": 214,
    "jja": 234,
    "mam": 184,
    "son": 283
   },
   "summer_half": 417,
   "winter_half": 497
  },
  "AB55": {
   "cells": 159,
   "mm": 938,
   "n": 428,
   "periods": {
    "1961-1990": 893,
    "1981-2010": 940,
    "1991-2020": 938
   },
   "seasons": {
    "djf": 213,
    "jja": 250,
    "mam": 186,
    "son": 290
   },
   "summer_half": 435,
   "winter_half": 503
  },
  "AB56": {
   "cells": 86,
   "mm": 803,
   "n": 647,
   "periods": {
    "1961-1990": 748,
    "1981-2010": 796,
    "1991-2020": 803
   },
   "seasons": {
    "djf": 179,
    "jja": 220,
    "mam": 150,
    "son": 255
   },
   "summer_half": 370,
   "winter_half": 433
  },
  "AB99": {
   "cells": 1,
   "mm": 838,
   "n": 3,
   "periods": {
    "1961-1990": 791,
    "1981-2010": 809,
    "1991-2020": 838
   },
   "seasons": {
    "djf": 207,
    "jja": 214,
    "mam": 165,
    "son": 253
   },
   "summer_half": 378,
   "winter_half": 460
  },
  "AL1": {
   "cells": 17,
   "mm": 693,
   "n": 1219,
   "periods": {
    "1961-1990": 673,
    "1981-2010": 691,
    "1991-2020": 693
   },
   "seasons": {
    "djf": 186,
    "jja": 167,
    "mam": 138,
    "son": 203
   },
   "summer_half": 305,
   "winter_half": 389
  },
  "AL10": {
   "cells": 16,
   "mm": 660,
   "n": 788,
   "periods": {
    "1961-1990": 650,
    "1981-2010": 662,
    "1991-2020": 660
   },
   "seasons": {
    "djf": 177,
    "jja": 160,
    "mam": 133,
    "son": 191
   },
   "summer_half": 293,
   "winter_half": 368
  },
  "AL2": {
   "cells": 35,
   "mm": 682,
   "n": 732,
   "periods": {
    "1961-1990": 669,
    "1981-2010": 684,
    "1991-2020": 682
   },
   "seasons": {
    "djf": 184,
    "jja": 162,
    "mam": 138,
    "son": 198
   },
   "summer_half": 300,
   "winter_half": 382
  },
  "AL3": {
   "cells": 72,
   "mm": 716,
   "n": 955,
   "periods": {
    "1961-1990": 692,
    "1981-2010": 717,
    "1991-2020": 716
   },
   "seasons": {
    "djf": 192,
    "jja": 171,
    "mam": 145,
    "son": 208
   },
   "summer_half": 316,
   "winter_half": 400
  },
  "AL4": {
   "cells": 54,
   "mm": 673,
   "n": 786,
   "periods": {
    "1961-1990": 660,
    "1981-2010": 675,
    "1991-2020": 673
   },
   "seasons": {
    "djf": 179,
    "jja": 164,
    "mam": 135,
    "son": 195
   },
   "summer_half": 299,
   "winter_half": 374
  },
  "AL5": {
   "cells": 34,
   "mm": 711,
   "n": 1058,
   "periods": {
    "1961-1990": 684,
    "1981-2010": 710,
    "1991-2020": 711
   },
   "seasons": {
    "djf": 186,
    "jja": 173,
    "mam": 144,
    "son": 207
   },
   "summer_half": 317,
   "winter_half": 394
  },
  "AL6": {
   "cells": 40,
   "mm": 667,
   "n": 506,
   "periods": {
    "1961-1990": 652,
    "1981-2010": 668,
    "1991-2020": 667
   },
   "seasons": {
    "djf": 180,
    "jja": 167,
    "mam": 133,
    "son": 188
   },
   "summer_half": 299,
   "winter_half": 368
  },
  "AL7": {
   "cells": 18,
   "mm": 642,
   "n": 892,
   "periods": {
    "1961-1990": 627,
    "1981-2010": 642,
    "1991-2020": 642
   },
   "seasons": {
    "djf": 172,
    "jja": 156,
    "mam": 129,
    "son": 185
   },
   "summer_half": 285,
   "winter_half": 357
  },
  "AL8": {
   "cells": 16,
   "mm": 660,
   "n": 424,
   "periods": {
    "1961-1990": 644,
    "1981-2010": 660,
    "1991-2020": 660
   },
   "seasons": {
    "djf": 178,
    "jja": 162,
    "mam": 131,
    "son": 189
   },
   "summer_half": 293,
   "winter_half": 367
  },
  "AL9": {
   "cells": 43,
   "mm": 666,
   "n": 429,
   "periods": {
    "1961-1990": 656,
    "1981-2010": 667,
    "1991-2020": 666
   },
   "seasons": {
    "djf": 178,
    "jja": 161,
    "mam": 134,
    "son": 194
   },
   "summer_half": 295,
   "winter_half": 372
  },
  "B1": {
   "cells": 5,
   "mm": 755,
   "n": 319,
   "periods": {
    "1961-1990": 713,
    "1981-2010": 744,
    "1991-2020": 755
   },
   "seasons": {
    "djf": 191,
    "jja": 196,
    "mam": 161,
    "son": 207
   },
   "summer_half": 357,
   "winter_half": 398
  },
  "B10": {
   "cells": 9,
   "mm": 737,
   "n": 314,
   "periods": {
    "1961-1990": 702,
    "1981-2010": 725,
    "1991-2020": 737
   },
   "seasons": {
    "djf": 188,
    "jja": 189,
    "mam": 157,
    "son": 202
   },
   "summer_half": 346,
   "winter_half": 390
  },
  "B11": {
   "cells": 14,
   "mm": 748,
   "n": 597,
   "periods": {
    "1961-1990": 711,
    "1981-2010": 737,
    "1991-2020": 748
   },
   "seasons": {
    "djf": 191,
    "jja": 192,
    "mam": 160,
    "son": 204
   },
   "summer_half": 352,
   "winter_half": 396
  },
  "B12": {
   "cells": 11,
   "mm": 762,
   "n": 476,
   "periods": {
    "1961-1990": 724,
    "1981-2010": 751,
    "1991-2020": 762
   },
   "seasons": {
    "djf": 194,
    "jja": 195,
    "mam": 163,
    "son": 210
   },
   "summer_half": 358,
   "winter_half": 404
  },
  "B13": {
   "cells": 15,
   "mm": 791,
   "n": 663,
   "periods": {
    "1961-1990": 753,
    "1981-2010": 781,
    "1991-2020": 791
   },
   "seasons": {
    "djf": 204,
    "jja": 202,
    "mam": 169,
    "son": 216
   },
   "summer_half": 371,
   "winter_half": 420
  },
  "B14": {
   "cells": 18,
   "mm": 799,
   "n": 769,
   "periods": {
    "1961-1990": 761,
    "1981-2010": 791,
    "1991-2020": 799
   },
   "seasons": {
    "djf": 205,
    "jja": 202,
    "mam": 173,
    "son": 219
   },
   "summer_half": 375,
   "winter_half": 424
  },
  "B15": {
   "cells": 14,
   "mm": 802,
   "n": 484,
   "periods": {
    "1961-1990": 758,
    "1981-2010": 792,
    "1991-2020": 802
   },
   "seasons": {
    "djf": 203,
    "jja": 206,
    "mam": 170,
    "son": 223
   },
   "summer_half": 376,
   "winter_half": 426
  },
  "B16": {
   "cells": 9,
   "mm": 789,
   "n": 493,
   "periods": {
    "1961-1990": 742,
    "1981-2010": 778,
    "1991-2020": 789
   },
   "seasons": {
    "djf": 198,
    "jja": 206,
    "mam": 167,
    "son": 218
   },
   "summer_half": 373,
   "winter_half": 416
  },
  "B17": {
   "cells": 13,
   "mm": 816,
   "n": 556,
   "periods": {
    "1961-1990": 771,
    "1981-2010": 807,
    "1991-2020": 816
   },
   "seasons": {
    "djf": 206,
    "jja": 210,
    "mam": 172,
    "son": 228
   },
   "summer_half": 382,
   "winter_half": 434
  },
  "B18": {
   "cells": 10,
   "mm": 755,
   "n": 462,
   "periods": {
    "1961-1990": 713,
    "1981-2010": 743,
    "1991-2020": 755
   },
   "seasons": {
    "djf": 192,
    "jja": 195,
    "mam": 161,
    "son": 207
   },
   "summer_half": 356,
   "winter_half": 399
  },
  "B19": {
   "cells": 9,
   "mm": 746,
   "n": 450,
   "periods": {
    "1961-1990": 708,
    "1981-2010": 733,
    "1991-2020": 746
   },
   "seasons": {
    "djf": 188,
    "jja": 194,
    "mam": 162,
    "son": 202
   },
   "summer_half": 356,
   "winter_half": 390
  },
  "B2": {
   "cells": 4,
   "mm": 750,
   "n": 289,
   "periods": {
    "1961-1990": 711,
    "1981-2010": 738,
    "1991-2020": 750
   },
   "seasons": {
    "djf": 189,
    "jja": 194,
    "mam": 162,
    "son": 205
   },
   "summer_half": 356,
   "winter_half": 395
  },
  "B20": {
   "cells": 12,
   "mm": 746,
   "n": 533,
   "periods": {
    "1961-1990": 709,
    "1981-2010": 734,
    "1991-2020": 746
   },
   "seasons": {
    "djf": 188,
    "jja": 194,
    "mam": 163,
    "son": 201
   },
   "summer_half": 357,
   "winter_half": 389
  },
  "B21": {
   "cells": 8,
   "mm": 771,
   "n": 437,
   "periods": {
    "1961-1990": 734,
    "1981-2010": 760,
    "1991-2020": 771
   },
   "seasons": {
    "djf": 198,
    "jja": 197,
    "mam": 166,
    "son": 211
   },
   "summer_half": 363,
   "winter_half": 408
  },
  "B23": {
   "cells": 15,
   "mm": 730,
   "n": 825,
   "periods": {
    "1961-1990": 705,
    "1981-2010": 718,
    "1991-2020": 730
   },
   "seasons": {
    "djf": 183,
    "jja": 191,
    "mam": 156,
    "son": 200
   },
   "summer_half": 347,
   "winter_half": 383
  },
  "B24": {
   "cells": 16,
   "mm": 723,
   "n": 577,
   "periods": {
    "1961-1990": 697,
    "1981-2010": 711,
    "1991-2020": 723
   },
   "seasons": {
    "djf": 181,
    "jja": 189,
    "mam": 153,
    "son": 199
   },
   "summer_half": 343,
   "winter_half": 381
  },
  "B25": {
   "cells": 9,
   "mm": 713,
   "n": 275,
   "periods": {
    "1961-1990": 682,
    "1981-2010": 702,
    "1991-2020": 713
   },
   "seasons": {
    "djf": 186,
    "jja": 184,
    "mam": 148,
    "son": 195
   },
   "summer_half": 332,
   "winter_half": 381
  },
  "B26": {
   "cells": 18,
   "mm": 717,
   "n": 575,
   "periods": {
    "1961-1990": 685,
    "1981-2010": 705,
    "1991-2020": 717
   },
   "seasons": {
    "djf": 187,
    "jja": 187,
    "mam": 149,
    "son": 194
   },
   "summer_half": 336,
   "winter_half": 381
  },
  "B27": {
   "cells": 11,
   "mm": 738,
   "n": 431,
   "periods": {
    "1961-1990": 696,
    "1981-2010": 723,
    "1991-2020": 738
   },
   "seasons": {
    "djf": 189,
    "jja": 190,
    "mam": 157,
    "son": 202
   },
   "summer_half": 347,
   "winter_half": 392
  },
  "B28": {
   "cells": 13,
   "mm": 773,
   "n": 604,
   "periods": {
    "1961-1990": 728,
    "1981-2010": 758,
    "1991-2020": 773
   },
   "seasons": {
    "djf": 196,
    "jja": 196,
    "mam": 167,
    "son": 214
   },
   "summer_half": 363,
   "winter_half": 410
  },
  "B29": {
   "cells": 18,
   "mm": 797,
   "n": 804,
   "periods": {
    "1961-1990": 764,
    "1981-2010": 795,
    "1991-2020": 797
   },
   "seasons": {
    "djf": 203,
    "jja": 202,
    "mam": 168,
    "son": 224
   },
   "summer_half": 370,
   "winter_half": 427
  },
  "B3": {
   "cells": 4,
   "mm": 754,
   "n": 191,
   "periods": {
    "1961-1990": 714,
    "1981-2010": 742,
    "1991-2020": 754
   },
   "seasons": {
    "djf": 190,
    "jja": 195,
    "mam": 162,
    "son": 206
   },
   "summer_half": 357,
   "winter_half": 397
  },
  "B30": {
   "cells": 18,
   "mm": 807,
   "n": 607,
   "periods": {
    "1961-1990": 772,
    "1981-2010": 803,
    "1991-2020": 807
   },
   "seasons": {
    "djf": 207,
    "jja": 204,
    "mam": 173,
    "son": 223
   },
   "summer_half": 377,
   "winter_half": 430
  },
  "B31": {
   "cells": 25,
   "mm": 815,
   "n": 1162,
   "periods": {
    "1961-1990": 799,
    "1981-2010": 819,
    "1991-2020": 815
   },
   "seasons": {
    "djf": 206,
    "jja": 208,
    "mam": 173,
    "son": 228
   },
   "summer_half": 381,
   "winter_half": 434
  },
  "B32": {
   "cells": 22,
   "mm": 811,
   "n": 760,
   "periods": {
    "1961-1990": 787,
    "1981-2010": 810,
    "1991-2020": 811
   },
   "seasons": {
    "djf": 203,
    "jja": 208,
    "mam": 171,
    "son": 228
   },
   "summer_half": 380,
   "winter_half": 431
  },
  "B33": {
   "cells": 15,
   "mm": 718,
   "n": 690,
   "periods": {
    "1961-1990": 690,
    "1981-2010": 707,
    "1991-2020": 718
   },
   "seasons": {
    "djf": 190,
    "jja": 191,
    "mam": 148,
    "son": 189
   },
   "summer_half": 339,
   "winter_half": 379
  },
  "B34": {
   "cells": 9,
   "mm": 737,
   "n": 326,
   "periods": {
    "1961-1990": 707,
    "1981-2010": 725,
    "1991-2020": 737
   },
   "seasons": {
    "djf": 187,
    "jja": 194,
    "mam": 156,
    "son": 200
   },
   "summer_half": 350,
   "winter_half": 387
  },
  "B35": {
   "cells": 6,
   "mm": 698,
   "n": 292,
   "periods": {
    "1961-1990": 666,
    "1981-2010": 683,
    "1991-2020": 698
   },
   "seasons": {
    "djf": 176,
    "jja": 184,
    "mam": 148,
    "son": 189
   },
   "summer_half": 333,
   "winter_half": 365
  },
  "B36": {
   "cells": 16,
   "mm": 725,
   "n": 574,
   "periods": {
    "1961-1990": 694,
    "1981-2010": 712,
    "1991-2020": 725
   },
   "seasons": {
    "djf": 184,
    "jja": 193,
    "mam": 152,
    "son": 196
   },
   "summer_half": 345,
   "winter_half": 380
  },
  "B37": {
   "cells": 17,
   "mm": 711,
   "n": 729,
   "periods": {
    "1961-1990": 695,
    "1981-2010": 707,
    "1991-2020": 711
   },
   "seasons": {
    "djf": 184,
    "jja": 193,
    "mam": 145,
    "son": 190
   },
   "summer_half": 337,
   "winter_half": 374
  },
  "B38": {
   "cells": 23,
   "mm": 832,
   "n": 472,
   "periods": {
    "1961-1990": 803,
    "1981-2010": 827,
    "1991-2020": 832
   },
   "seasons": {
    "djf": 211,
    "jja": 214,
    "mam": 180,
    "son": 226
   },
   "summer_half": 395,
   "winter_half": 437
  },
  "B4": {
   "cells": 7,
   "mm": 743,
   "n": 202,
   "periods": {
    "1961-1990": 705,
    "1981-2010": 729,
    "1991-2020": 743
   },
   "seasons": {
    "djf": 188,
    "jja": 193,
    "mam": 160,
    "son": 202
   },
   "summer_half": 353,
   "winter_half": 390
  },
  "B40": {
   "cells": 7,
   "mm": 710,
   "n": 14,
   "periods": {
    "1961-1990": 697,
    "1981-2010": 708,
    "1991-2020": 710
   },
   "seasons": {
    "djf": 183,
    "jja": 192,
    "mam": 144,
    "son": 191
   },
   "summer_half": 336,
   "winter_half": 374
  },
  "B42": {
   "cells": 15,
   "mm": 729,
   "n": 439,
   "periods": {
    "1961-1990": 695,
    "1981-2010": 716,
    "1991-2020": 729
   },
   "seasons": {
    "djf": 184,
    "jja": 188,
    "mam": 160,
    "son": 197
   },
   "summer_half": 348,
   "winter_half": 381
  },
  "B43": {
   "cells": 17,
   "mm": 758,
   "n": 547,
   "periods": {
    "1961-1990": 720,
    "1981-2010": 745,
    "1991-2020": 758
   },
   "seasons": {
    "djf": 193,
    "jja": 192,
    "mam": 165,
    "son": 208
   },
   "summer_half": 357,
   "winter_half": 401
  },
  "B44": {
   "cells": 13,
   "mm": 741,
   "n": 637,
   "periods": {
    "1961-1990": 704,
    "1981-2010": 727,
    "1991-2020": 741
   },
   "seasons": {
    "djf": 185,
    "jja": 190,
    "mam": 165,
    "son": 201
   },
   "summer_half": 355,
   "winter_half": 386
  },
  "B45": {
   "cells": 29,
   "mm": 847,
   "n": 710,
   "periods": {
    "1961-1990": 820,
    "1981-2010": 841,
    "1991-2020": 847
   },
   "seasons": {
    "djf": 209,
    "jja": 217,
    "mam": 184,
    "son": 236
   },
   "summer_half": 401,
   "winter_half": 445
  },
  "B46": {
   "cells": 63,
   "mm": 700,
   "n": 481,
   "periods": {
    "1961-1990": 673,
    "1981-2010": 694,
    "1991-2020": 700
   },
   "seasons": {
    "djf": 173,
    "jja": 190,
    "mam": 146,
    "son": 191
   },
   "summer_half": 336,
   "winter_half": 364
  },
  "B47": {
   "cells": 14,
   "mm": 782,
   "n": 241,
   "periods": {
    "1961-1990": 753,
    "1981-2010": 775,
    "1991-2020": 782
   },
   "seasons": {
    "djf": 200,
    "jja": 194,
    "mam": 172,
    "son": 216
   },
   "summer_half": 366,
   "winter_half": 416
  },
  "B48": {
   "cells": 36,
   "mm": 789,
   "n": 208,
   "periods": {
    "1961-1990": 762,
    "1981-2010": 783,
    "1991-2020": 789
   },
   "seasons": {
    "djf": 198,
    "jja": 200,
    "mam": 173,
    "son": 218
   },
   "summer_half": 372,
   "winter_half": 416
  },
  "B49": {
   "cells": 69,
   "mm": 712,
   "n": 394,
   "periods": {
    "1961-1990": 658,
    "1981-2010": 693,
    "1991-2020": 712
   },
   "seasons": {
    "djf": 167,
    "jja": 190,
    "mam": 157,
    "son": 197
   },
   "summer_half": 347,
   "winter_half": 364
  },
  "B5": {
   "cells": 11,
   "mm": 767,
   "n": 429,
   "periods": {
    "1961-1990": 727,
    "1981-2010": 756,
    "1991-2020": 767
   },
   "seasons": {
    "djf": 195,
    "jja": 197,
    "mam": 164,
    "son": 211
   },
   "summer_half": 361,
   "winter_half": 406
  },
  "B50": {
   "cells": 20,
   "mm": 639,
   "n": 212,
   "periods": {
    "1961-1990": 598,
    "1981-2010": 625,
    "1991-2020": 639
   },
   "seasons": {
    "djf": 147,
    "jja": 171,
    "mam": 145,
    "son": 176
   },
   "summer_half": 316,
   "winter_half": 323
  },
  "B6": {
   "cells": 14,
   "mm": 735,
   "n": 419,
   "periods": {
    "1961-1990": 702,
    "1981-2010": 723,
    "1991-2020": 735
   },
   "seasons": {
    "djf": 184,
    "jja": 192,
    "mam": 159,
    "son": 200
   },
   "summer_half": 351,
   "winter_half": 384
  },
  "B60": {
   "cells": 63,
   "mm": 744,
   "n": 849,
   "periods": {
    "1961-1990": 691,
    "1981-2010": 727,
    "1991-2020": 744
   },
   "seasons": {
    "djf": 183,
    "jja": 196,
    "mam": 161,
    "son": 205
   },
   "summer_half": 357,
   "winter_half": 387
  },
  "B61": {
   "cells": 51,
   "mm": 753,
   "n": 744,
   "periods": {
    "1961-1990": 698,
    "1981-2010": 734,
    "1991-2020": 753
   },
   "seasons": {
    "djf": 185,
    "jja": 196,
    "mam": 163,
    "son": 209
   },
   "summer_half": 359,
   "winter_half": 394
  },
  "B62": {
   "cells": 35,
   "mm": 810,
   "n": 578,
   "periods": {
    "1961-1990": 788,
    "1981-2010": 799,
    "1991-2020": 810
   },
   "seasons": {
    "djf": 201,
    "jja": 205,
    "mam": 173,
    "son": 230
   },
   "summer_half": 379,
   "winter_half": 431
  },
  "B63": {
   "cells": 17,
   "mm": 753,
   "n": 782,
   "periods": {
    "1961-1990": 733,
    "1981-2010": 741,
    "1991-2020": 753
   },
   "seasons": {
    "djf": 186,
    "jja": 187,
    "mam": 166,
    "son": 214
   },
   "summer_half": 353,
   "winter_half": 400
  },
  "B64": {
   "cells": 12,
   "mm": 730,
   "n": 474,
   "periods": {
    "1961-1990": 703,
    "1981-2010": 717,
    "1991-2020": 730
   },
   "seasons": {
    "djf": 179,
    "jja": 186,
    "mam": 162,
    "son": 204
   },
   "summer_half": 348,
   "winter_half": 383
  },
  "B65": {
   "cells": 13,
   "mm": 787,
   "n": 517,
   "periods": {
    "1961-1990": 757,
    "1981-2010": 775,
    "1991-2020": 787
   },
   "seasons": {
    "djf": 193,
    "jja": 203,
    "mam": 170,
    "son": 220
   },
   "summer_half": 373,
   "winter_half": 414
  },
  "B66": {
   "cells": 10,
   "mm": 774,
   "n": 568,
   "periods": {
    "1961-1990": 735,
    "1981-2010": 763,
    "1991-2020": 774
   },
   "seasons": {
    "djf": 196,
    "jja": 199,
    "mam": 165,
    "son": 213
   },
   "summer_half": 364,
   "winter_half": 410
  },
  "B67": {
   "cells": 12,
   "mm": 790,
   "n": 524,
   "periods": {
    "1961-1990": 755,
    "1981-2010": 780,
    "1991-2020": 790
   },
   "seasons": {
    "djf": 199,
    "jja": 203,
    "mam": 169,
    "son": 218
   },
   "summer_half": 373,
   "winter_half": 417
  },
  "B68": {
   "cells": 13,
   "mm": 786,
   "n": 588,
   "periods": {
    "1961-1990": 759,
    "1981-2010": 778,
    "1991-2020": 786
   },
   "seasons": {
    "djf": 198,
    "jja": 201,
    "mam": 169,
    "son": 219
   },
   "summer_half": 370,
   "winter_half": 416
  },
  "B69": {
   "cells": 18,
   "mm": 781,
   "n": 728,
   "periods": {
    "1961-1990": 745,
    "1981-2010": 770,
    "1991-2020": 781
   },
   "seasons": {
    "djf": 193,
    "jja": 203,
    "mam": 168,
    "son": 217
   },
   "summer_half": 371,
   "winter_half": 410
  },
  "B7": {
   "cells": 10,
   "mm": 755,
   "n": 272,
   "periods": {
    "1961-1990": 719,
    "1981-2010": 742,
    "1991-2020": 755
   },
   "seasons": {
    "djf": 189,
    "jja": 196,
    "mam": 162,
    "son": 208
   },
   "summer_half": 357,
   "winter_half": 398
  },
  "B70": {
   "cells": 16,
   "mm": 749,
   "n": 834,
   "periods": {
    "1961-1990": 712,
    "1981-2010": 738,
    "1991-2020": 749
   },
   "seasons": {
    "djf": 186,
    "jja": 195,
    "mam": 163,
    "son": 205
   },
   "summer_half": 358,
   "winter_half": 391
  },
  "B71": {
   "cells": 18,
   "mm": 751,
   "n": 687,
   "periods": {
    "1961-1990": 713,
    "1981-2010": 740,
    "1991-2020": 751
   },
   "seasons": {
    "djf": 189,
    "jja": 192,
    "mam": 162,
    "son": 207
   },
   "summer_half": 354,
   "winter_half": 396
  },
  "B72": {
   "cells": 10,
   "mm": 737,
   "n": 240,
   "periods": {
    "1961-1990": 706,
    "1981-2010": 721,
    "1991-2020": 737
   },
   "seasons": {
    "djf": 186,
    "jja": 192,
    "mam": 158,
    "son": 201
   },
   "summer_half": 350,
   "winter_half": 387
  },
  "B73": {
   "cells": 13,
   "mm": 738,
   "n": 543,
   "periods": {
    "1961-1990": 704,
    "1981-2010": 723,
    "1991-2020": 738
   },
   "seasons": {
    "djf": 185,
    "jja": 193,
    "mam": 158,
    "son": 202
   },
   "summer_half": 351,
   "winter_half": 387
  },
  "B74": {
   "cells": 24,
   "mm": 758,
   "n": 759,
   "periods": {
    "1961-1990": 720,
    "1981-2010": 741,
    "1991-2020": 758
   },
   "seasons": {
    "djf": 191,
    "jja": 194,
    "mam": 167,
    "son": 206
   },
   "summer_half": 361,
   "winter_half": 397
  },
  "B75": {
   "cells": 32,
   "mm": 743,
   "n": 655,
   "periods": {
    "1961-1990": 707,
    "1981-2010": 725,
    "1991-2020": 743
   },
   "seasons": {
    "djf": 188,
    "jja": 193,
    "mam": 161,
    "son": 201
   },
   "summer_half": 355,
   "winter_half": 389
  },
  "B76": {
   "cells": 43,
   "mm": 702,
   "n": 530,
   "periods": {
    "1961-1990": 666,
    "1981-2010": 686,
    "1991-2020": 702
   },
   "seasons": {
    "djf": 176,
    "jja": 186,
    "mam": 150,
    "son": 191
   },
   "summer_half": 336,
   "winter_half": 367
  },
  "B77": {
   "cells": 24,
   "mm": 665,
   "n": 1011,
   "periods": {
    "1961-1990": 634,
    "1981-2010": 652,
    "1991-2020": 665
   },
   "seasons": {
    "djf": 165,
    "jja": 175,
    "mam": 143,
    "son": 181
   },
   "summer_half": 319,
   "winter_half": 347
  },
  "B78": {
   "cells": 73,
   "mm": 674,
   "n": 649,
   "periods": {
    "1961-1990": 642,
    "1981-2010": 660,
    "1991-2020": 674
   },
   "seasons": {
    "djf": 167,
    "jja": 178,
    "mam": 145,
    "son": 183
   },
   "summer_half": 324,
   "winter_half": 350
  },
  "B79": {
   "cells": 78,
   "mm": 653,
   "n": 708,
   "periods": {
    "1961-1990": 622,
    "1981-2010": 641,
    "1991-2020": 653
   },
   "seasons": {
    "djf": 159,
    "jja": 176,
    "mam": 138,
    "son": 180
   },
   "summer_half": 314,
   "winter_half": 339
  },
  "B8": {
   "cells": 12,
   "mm": 754,
   "n": 578,
   "periods": {
    "1961-1990": 720,
    "1981-2010": 741,
    "1991-2020": 754
   },
   "seasons": {
    "djf": 190,
    "jja": 195,
    "mam": 161,
    "son": 208
   },
   "summer_half": 356,
   "winter_half": 398
  },
  "B80": {
   "cells": 25,
   "mm": 738,
   "n": 217,
   "periods": {
    "1961-1990": 681,
    "1981-2010": 719,
    "1991-2020": 738
   },
   "seasons": {
    "djf": 177,
    "jja": 192,
    "mam": 164,
    "son": 205
   },
   "summer_half": 356,
   "winter_half": 383
  },
  "B9": {
   "cells": 11,
   "mm": 740,
   "n": 394,
   "periods": {
    "1961-1990": 707,
    "1981-2010": 728,
    "1991-2020": 740
   },
   "seasons": {
    "djf": 189,
    "jja": 191,
    "mam": 158,
    "son": 203
   },
   "summer_half": 349,
   "winter_half": 392
  },
  "B90": {
   "cells": 34,
   "mm": 788,
   "n": 1086,
   "periods": {
    "1961-1990": 733,
    "1981-2010": 769,
    "1991-2020": 788
   },
   "seasons": {
    "djf": 199,
    "jja": 199,
    "mam": 172,
    "son": 219
   },
   "summer_half": 371,
   "winter_half": 418
  },
  "B91": {
   "cells": 26,
   "mm": 784,
   "n": 853,
   "periods": {
    "1961-1990": 719,
    "1981-2010": 760,
    "1991-2020": 784
   },
   "seasons": {
    "djf": 195,
    "jja": 207,
    "mam": 168,
    "son": 214
   },
   "summer_half": 375,
   "winter_half": 409
  },
  "B92": {
   "cells": 46,
   "mm": 737,
   "n": 733,
   "periods": {
    "1961-1990": 693,
    "1981-2010": 722,
    "1991-2020": 737
   },
   "seasons": {
    "djf": 186,
    "jja": 195,
    "mam": 155,
    "son": 202
   },
   "summer_half": 350,
   "winter_half": 388
  },
  "B93": {
   "cells": 33,
   "mm": 752,
   "n": 514,
   "periods": {
    "1961-1990": 696,
    "1981-2010": 738,
    "1991-2020": 752
   },
   "seasons": {
    "djf": 187,
    "jja": 196,
    "mam": 162,
    "son": 207
   },
   "summer_half": 358,
   "winter_half": 394
  },
  "B94": {
   "cells": 70,
   "mm": 777,
   "n": 340,
   "periods": {
    "1961-1990": 729,
    "1981-2010": 766,
    "1991-2020": 777
   },
   "seasons": {
    "djf": 194,
    "jja": 196,
    "mam": 171,
    "son": 215
   },
   "summer_half": 367,
   "winter_half": 410
  },
  "B95": {
   "cells": 66,
   "mm": 735,
   "n": 325,
   "periods": {
    "1961-1990": 683,
    "1981-2010": 721,
    "1991-2020": 735
   },
   "seasons": {
    "djf": 178,
    "jja": 194,
    "mam": 162,
    "son": 201
   },
   "summer_half": 355,
   "winter_half": 380
  },
  "B96": {
   "cells": 48,
   "mm": 711,
   "n": 211,
   "periods": {
    "1961-1990": 652,
    "1981-2010": 690,
    "1991-2020": 711
   },
   "seasons": {
    "djf": 172,
    "jja": 187,
    "mam": 156,
    "son": 196
   },
   "summer_half": 343,
   "winter_half": 368
  },
  "B97": {
   "cells": 36,
   "mm": 760,
   "n": 809,
   "periods": {
    "1961-1990": 709,
    "1981-2010": 744,
    "1991-2020": 760
   },
   "seasons": {
    "djf": 185,
    "jja": 199,
    "mam": 167,
    "son": 209
   },
   "summer_half": 366,
   "winter_half": 394
  },
  "B98": {
   "cells": 38,
   "mm": 763,
   "n": 818,
   "periods": {
    "1961-1990": 717,
    "1981-2010": 749,
    "1991-2020": 763
   },
   "seasons": {
    "djf": 186,
    "jja": 195,
    "mam": 168,
    "son": 213
   },
   "summer_half": 363,
   "winter_half": 399
  },
  "B99": {
   "cells": 1,
   "mm": 730,
   "n": 48,
   "periods": {
    "1961-1990": 694,
    "1981-2010": 717,
    "1991-2020": 730
   },
   "seasons": {
    "djf": 184,
    "jja": 189,
    "mam": 158,
    "son": 198
   },
   "summer_half": 348,
   "winter_half": 382
  },
  "BA1": {
   "cells": 62,
   "mm": 888,
   "n": 1526,
   "periods": {
    "1961-1990": 811,
    "1981-2010": 867,
    "1991-2020": 888
   },
   "seasons": {
    "djf": 251,
    "jja": 207,
    "mam": 180,
    "son": 250
   },
   "summer_half": 387,
   "winter_half": 501
  },
  "BA10": {
   "cells": 34,
   "mm": 931,
   "n": 179,
   "periods": {
    "1961-1990": 899,
    "1981-2010": 943,
    "1991-2020": 931
   },
   "seasons": {
    "djf": 253,
    "jja": 218,
    "mam": 188,
    "son": 273
   },
   "summer_half": 406,
   "winter_half": 526
  },
  "BA11": {
   "cells": 123,
   "mm": 934,
   "n": 1178,
   "periods": {
    "1961-1990": 891,
    "1981-2010": 929,
    "1991-2020": 934
   },
   "seasons": {
    "djf": 272,
    "jja": 200,
    "mam": 188,
    "son": 274
   },
   "summer_half": 387,
   "winter_half": 546
  },
  "BA12": {
   "cells": 163,
   "mm": 954,
   "n": 1144,
   "periods": {
    "1961-1990": 885,
    "1981-2010": 932,
    "1991-2020": 954
   },
   "seasons": {
    "djf": 279,
    "jja": 204,
    "mam": 189,
    "son": 282
   },
   "summer_half": 393,
   "winter_half": 561
  },
  "BA13": {
   "cells": 53,
   "mm": 810,
   "n": 642,
   "periods": {
    "1961-1990": 756,
    "1981-2010": 793,
    "1991-2020": 810
   },
   "seasons": {
    "djf": 231,
    "jja": 176,
    "mam": 165,
    "son": 238
   },
   "summer_half": 341,
   "winter_half": 469
  },
  "BA14": {
   "cells": 76,
   "mm": 765,
   "n": 1478,
   "periods": {
    "1961-1990": 716,
    "1981-2010": 750,
    "1991-2020": 765
   },
   "seasons": {
    "djf": 213,
    "jja": 174,
    "mam": 158,
    "son": 220
   },
   "summer_half": 332,
   "winter_half": 434
  },
  "BA15": {
   "cells": 39,
   "mm": 870,
   "n": 470,
   "periods": {
    "1961-1990": 812,
    "1981-2010": 850,
    "1991-2020": 870
   },
   "seasons": {
    "djf": 244,
    "jja": 200,
    "mam": 177,
    "son": 249
   },
   "summer_half": 377,
   "winter_half": 493
  },
  "BA16": {
   "cells": 23,
   "mm": 778,
   "n": 374,
   "periods": {
    "1961-1990": 736,
    "1981-2010": 753,
    "1991-2020": 778
   },
   "seasons": {
    "djf": 207,
    "jja": 192,
    "mam": 153,
    "son": 225
   },
   "summer_half": 346,
   "winter_half": 432
  },
  "BA2": {
   "cells": 150,
   "mm": 870,
   "n": 2211,
   "periods": {
    "1961-1990": 820,
    "1981-2010": 862,
    "1991-2020": 870
   },
   "seasons": {
    "djf": 248,
    "jja": 195,
    "mam": 176,
    "son": 251
   },
   "summer_half": 371,
   "winter_half": 499
  },
  "BA20": {
   "cells": 14,
   "mm": 834,
   "n": 491,
   "periods": {
    "1961-1990": 772,
    "1981-2010": 815,
    "1991-2020": 834
   },
   "seasons": {
    "djf": 237,
    "jja": 175,
    "mam": 169,
    "son": 252
   },
   "summer_half": 345,
   "winter_half": 490
  },
  "BA21": {
   "cells": 24,
   "mm": 834,
   "n": 773,
   "periods": {
    "1961-1990": 771,
    "1981-2010": 810,
    "1991-2020": 834
   },
   "seasons": {
    "djf": 236,
    "jja": 181,
    "mam": 167,
    "son": 250
   },
   "summer_half": 348,
   "winter_half": 486
  },
  "BA22": {
   "cells": 155,
   "mm": 831,
   "n": 805,
   "periods": {
    "1961-1990": 773,
    "1981-2010": 808,
    "1991-2020": 831
   },
   "seasons": {
    "djf": 231,
    "jja": 182,
    "mam": 168,
    "son": 251
   },
   "summer_half": 350,
   "winter_half": 482
  },
  "BA3": {
   "cells": 123,
   "mm": 1090,
   "n": 1285,
   "periods": {
    "1961-1990": 1050,
    "1981-2010": 1089,
    "1991-2020": 1090
   },
   "seasons": {
    "djf": 321,
    "jja": 233,
    "mam": 220,
    "son": 316
   },
   "summer_half": 453,
   "winter_half": 637
  },
  "BA4": {
   "cells": 131,
   "mm": 977,
   "n": 834,
   "periods": {
    "1961-1990": 929,
    "1981-2010": 967,
    "1991-2020": 977
   },
   "seasons": {
    "djf": 265,
    "jja": 232,
    "mam": 196,
    "son": 284
   },
   "summer_half": 428,
   "winter_half": 549
  },
  "BA5": {
   "cells": 93,
   "mm": 1020,
   "n": 786,
   "periods": {
    "1961-1990": 964,
    "1981-2010": 1005,
    "1991-2020": 1020
   },
   "seasons": {
    "djf": 275,
    "jja": 245,
    "mam": 204,
    "son": 295
   },
   "summer_half": 449,
   "winter_half": 571
  },
  "BA6": {
   "cells": 63,
   "mm": 823,
   "n": 555,
   "periods": {
    "1961-1990": 775,
    "1981-2010": 798,
    "1991-2020": 823
   },
   "seasons": {
    "djf": 220,
    "jja": 204,
    "mam": 161,
    "son": 239
   },
   "summer_half": 364,
   "winter_half": 459
  },
  "BA7": {
   "cells": 25,
   "mm": 813,
   "n": 202,
   "periods": {
    "1961-1990": 764,
    "1981-2010": 792,
    "1991-2020": 813
   },
   "seasons": {
    "djf": 214,
    "jja": 198,
    "mam": 163,
    "son": 239
   },
   "summer_half": 361,
   "winter_half": 453
  },
  "BA8": {
   "cells": 36,
   "mm": 864,
   "n": 212,
   "periods": {
    "1961-1990": 804,
    "1981-2010": 842,
    "1991-2020": 864
   },
   "seasons": {
    "djf": 247,
    "jja": 184,
    "mam": 176,
    "son": 257
   },
   "summer_half": 360,
   "winter_half": 504
  },
  "BA9": {
   "cells": 66,
   "mm": 903,
   "n": 373,
   "periods": {
    "1961-1990": 852,
    "1981-2010": 893,
    "1991-2020": 903
   },
   "seasons": {
    "djf": 250,
    "jja": 203,
    "mam": 184,
    "son": 266
   },
   "summer_half": 387,
   "winter_half": 516
  },
  "BB1": {
   "cells": 57,
   "mm": 1192,
   "n": 1305,
   "periods": {
    "1961-1990": 1153,
    "1981-2010": 1170,
    "1991-2020": 1192
   },
   "seasons": {
    "djf": 345,
    "jja": 282,
    "mam": 219,
    "son": 345
   },
   "summer_half": 502,
   "winter_half": 691
  },
  "BB10": {
   "cells": 48,
   "mm": 1228,
   "n": 892,
   "periods": {
    "1961-1990": 1208,
    "1981-2010": 1206,
    "1991-2020": 1228
   },
   "seasons": {
    "djf": 370,
    "jja": 279,
    "mam": 230,
    "son": 349
   },
   "summer_half": 509,
   "winter_half": 719
  },
  "BB11": {
   "cells": 29,
   "mm": 1246,
   "n": 838,
   "periods": {
    "1961-1990": 1235,
    "1981-2010": 1242,
    "1991-2020": 1246
   },
   "seasons": {
    "djf": 372,
    "jja": 283,
    "mam": 235,
    "son": 356
   },
   "summer_half": 518,
   "winter_half": 728
  },
  "BB12": {
   "cells": 58,
   "mm": 1202,
   "n": 978,
   "periods": {
    "1961-1990": 1175,
    "1981-2010": 1180,
    "1991-2020": 1202
   },
   "seasons": {
    "djf": 356,
    "jja": 278,
    "mam": 223,
    "son": 345
   },
   "summer_half": 501,
   "winter_half": 701
  },
  "BB18": {
   "cells": 32,
   "mm": 1182,
   "n": 571,
   "periods": {
    "1961-1990": 1151,
    "1981-2010": 1167,
    "1991-2020": 1182
   },
   "seasons": {
    "djf": 364,
    "jja": 270,
    "mam": 217,
    "son": 331
   },
   "summer_half": 487,
   "winter_half": 695
  },
  "BB2": {
   "cells": 52,
   "mm": 1175,
   "n": 1412,
   "periods": {
    "1961-1990": 1128,
    "1981-2010": 1154,
    "1991-2020": 1175
   },
   "seasons": {
    "djf": 339,
    "jja": 282,
    "mam": 215,
    "son": 338
   },
   "summer_half": 497,
   "winter_half": 677
  },
  "BB3": {
   "cells": 41,
   "mm": 1384,
   "n": 926,
   "periods": {
    "1961-1990": 1346,
    "1981-2010": 1361,
    "1991-2020": 1384
   },
   "seasons": {
    "djf": 404,
    "jja": 321,
    "mam": 258,
    "son": 401
   },
   "summer_half": 578,
   "winter_half": 806
  },
  "BB4": {
   "cells": 54,
   "mm": 1401,
   "n": 1337,
   "periods": {
    "1961-1990": 1361,
    "1981-2010": 1380,
    "1991-2020": 1401
   },
   "seasons": {
    "djf": 426,
    "jja": 312,
    "mam": 264,
    "son": 399
   },
   "summer_half": 577,
   "winter_half": 824
  },
  "BB5": {
   "cells": 46,
   "mm": 1231,
   "n": 1554,
   "periods": {
    "1961-1990": 1212,
    "1981-2010": 1222,
    "1991-2020": 1231
   },
   "seasons": {
    "djf": 372,
    "jja": 279,
    "mam": 228,
    "son": 352
   },
   "summer_half": 507,
   "winter_half": 724
  },
  "BB6": {
   "cells": 22,
   "mm": 1178,
   "n": 373,
   "periods": {
    "1961-1990": 1129,
    "1981-2010": 1150,
    "1991-2020": 1178
   },
   "seasons": {
    "djf": 349,
    "jja": 276,
    "mam": 214,
    "son": 339
   },
   "summer_half": 490,
   "winter_half": 688
  },
  "BB7": {
   "cells": 182,
   "mm": 1346,
   "n": 1222,
   "periods": {
    "1961-1990": 1294,
    "1981-2010": 1309,
    "1991-2020": 1346
   },
   "seasons": {
    "djf": 411,
    "jja": 305,
    "mam": 244,
    "son": 386
   },
   "summer_half": 549,
   "winter_half": 797
  },
  "BB8": {
   "cells": 43,
   "mm": 1182,
   "n": 782,
   "periods": {
    "1961-1990": 1170,
    "1981-2010": 1165,
    "1991-2020": 1182
   },
   "seasons": {
    "djf": 355,
    "jja": 269,
    "mam": 221,
    "son": 337
   },
   "summer_half": 490,
   "winter_half": 692
  },
  "BB9": {
   "cells": 40,
   "mm": 1300,
   "n": 1396,
   "periods": {
    "1961-1990": 1271,
    "1981-2010": 1282,
    "1991-2020": 1300
   },
   "seasons": {
    "djf": 388,
    "jja": 301,
    "mam": 241,
    "son": 371
   },
   "summer_half": 542,
   "winter_half": 758
  },
  "BD1": {
   "cells": 8,
   "mm": 871,
   "n": 474,
   "periods": {
    "1961-1990": 837,
    "1981-2010": 850,
    "1991-2020": 871
   },
   "seasons": {
    "djf": 250,
    "jja": 206,
    "mam": 174,
    "son": 240
   },
   "summer_half": 380,
   "winter_half": 491
  },
  "BD10": {
   "cells": 15,
   "mm": 829,
   "n": 715,
   "periods": {
    "1961-1990": 801,
    "1981-2010": 812,
    "1991-2020": 829
   },
   "seasons": {
    "djf": 230,
    "jja": 205,
    "mam": 166,
    "son": 228
   },
   "summer_half": 371,
   "winter_half": 458
  },
  "BD11": {
   "cells": 13,
   "mm": 865,
   "n": 310,
   "periods": {
    "1961-1990": 839,
    "1981-2010": 846,
    "1991-2020": 865
   },
   "seasons": {
    "djf": 232,
    "jja": 219,
    "mam": 177,
    "son": 237
   },
   "summer_half": 396,
   "winter_half": 469
  },
  "BD12": {
   "cells": 15,
   "mm": 854,
   "n": 607,
   "periods": {
    "1961-1990": 832,
    "1981-2010": 839,
    "1991-2020": 854
   },
   "seasons": {
    "djf": 237,
    "jja": 212,
    "mam": 172,
    "son": 234
   },
   "summer_half": 383,
   "winter_half": 471
  },
  "BD13": {
   "cells": 42,
   "mm": 1126,
   "n": 970,
   "periods": {
    "1961-1990": 1071,
    "1981-2010": 1091,
    "1991-2020": 1126
   },
   "seasons": {
    "djf": 337,
    "jja": 256,
    "mam": 221,
    "son": 313
   },
   "summer_half": 476,
   "winter_half": 649
  },
  "BD14": {
   "cells": 8,
   "mm": 1028,
   "n": 240,
   "periods": {
    "1961-1990": 983,
    "1981-2010": 1001,
    "1991-2020": 1028
   },
   "seasons": {
    "djf": 297,
    "jja": 241,
    "mam": 203,
    "son": 287
   },
   "summer_half": 444,
   "winter_half": 584
  },
  "BD15": {
   "cells": 16,
   "mm": 1029,
   "n": 443,
   "periods": {
    "1961-1990": 993,
    "1981-2010": 1001,
    "1991-2020": 1029
   },
   "seasons": {
    "djf": 308,
    "jja": 236,
    "mam": 204,
    "son": 281
   },
   "summer_half": 440,
   "winter_half": 589
  },
  "BD16": {
   "cells": 35,
   "mm": 912,
   "n": 833,
   "periods": {
    "1961-1990": 884,
    "1981-2010": 887,
    "1991-2020": 912
   },
   "seasons": {
    "djf": 267,
    "jja": 212,
    "mam": 179,
    "son": 254
   },
   "summer_half": 390,
   "winter_half": 521
  },
  "BD17": {
   "cells": 22,
   "mm": 829,
   "n": 629,
   "periods": {
    "1961-1990": 806,
    "1981-2010": 810,
    "1991-2020": 829
   },
   "seasons": {
    "djf": 233,
    "jja": 200,
    "mam": 164,
    "son": 232
   },
   "summer_half": 365,
   "winter_half": 464
  },
  "BD18": {
   "cells": 16,
   "mm": 856,
   "n": 731,
   "periods": {
    "1961-1990": 831,
    "1981-2010": 838,
    "1991-2020": 856
   },
   "seasons": {
    "djf": 247,
    "jja": 204,
    "mam": 170,
    "son": 236
   },
   "summer_half": 374,
   "winter_half": 482
  },
  "BD19": {
   "cells": 23,
   "mm": 814,
   "n": 703,
   "periods": {
    "1961-1990": 800,
    "1981-2010": 799,
    "1991-2020": 814
   },
   "seasons": {
    "djf": 217,
    "jja": 209,
    "mam": 165,
    "son": 223
   },
   "summer_half": 374,
   "winter_half": 439
  },
  "BD2": {
   "cells": 14,
   "mm": 894,
   "n": 734,
   "periods": {
    "1961-1990": 864,
    "1981-2010": 875,
    "1991-2020": 894
   },
   "seasons": {
    "djf": 255,
    "jja": 216,
    "mam": 179,
    "son": 244
   },
   "summer_half": 394,
   "winter_half": 499
  },
  "BD20": {
   "cells": 93,
   "mm": 1039,
   "n": 1381,
   "periods": {
    "1961-1990": 1015,
    "1981-2010": 1021,
    "1991-2020": 1039
   },
   "seasons": {
    "djf": 307,
    "jja": 243,
    "mam": 195,
    "son": 294
   },
   "summer_half": 438,
   "winter_half": 601
  },
  "BD21": {
   "cells": 21,
   "mm": 1038,
   "n": 950,
   "periods": {
    "1961-1990": 999,
    "1981-2010": 1007,
    "1991-2020": 1038
   },
   "seasons": {
    "djf": 311,
    "jja": 233,
    "mam": 200,
    "son": 294
   },
   "summer_half": 433,
   "winter_half": 605
  },
  "BD22": {
   "cells": 70,
   "mm": 1175,
   "n": 1072,
   "periods": {
    "1961-1990": 1157,
    "1981-2010": 1153,
    "1991-2020": 1175
   },
   "seasons": {
    "djf": 358,
    "jja": 265,
    "mam": 220,
    "son": 332
   },
   "summer_half": 486,
   "winter_half": 690
  },
  "BD23": {
   "cells": 271,
   "mm": 1233,
   "n": 1449,
   "periods": {
    "1961-1990": 1170,
    "1981-2010": 1203,
    "1991-2020": 1233
   },
   "seasons": {
    "djf": 379,
    "jja": 274,
    "mam": 230,
    "son": 349
   },
   "summer_half": 505,
   "winter_half": 728
  },
  "BD24": {
   "cells": 60,
   "mm": 1435,
   "n": 337,
   "periods": {
    "1961-1990": 1338,
    "1981-2010": 1385,
    "1991-2020": 1435
   },
   "seasons": {
    "djf": 445,
    "jja": 314,
    "mam": 265,
    "son": 411
   },
   "summer_half": 579,
   "winter_half": 856
  },
  "BD3": {
   "cells": 11,
   "mm": 886,
   "n": 579,
   "periods": {
    "1961-1990": 853,
    "1981-2010": 864,
    "1991-2020": 886
   },
   "seasons": {
    "djf": 251,
    "jja": 213,
    "mam": 179,
    "son": 242
   },
   "summer_half": 392,
   "winter_half": 493
  },
  "BD4": {
   "cells": 27,
   "mm": 877,
   "n": 969,
   "periods": {
    "1961-1990": 845,
    "1981-2010": 855,
    "1991-2020": 877
   },
   "seasons": {
    "djf": 243,
    "jja": 215,
    "mam": 179,
    "son": 241
   },
   "summer_half": 394,
   "winter_half": 484
  },
  "BD5": {
   "cells": 10,
   "mm": 925,
   "n": 624,
   "periods": {
    "1961-1990": 890,
    "1981-2010": 902,
    "1991-2020": 925
   },
   "seasons": {
    "djf": 262,
    "jja": 222,
    "mam": 185,
    "son": 255
   },
   "summer_half": 407,
   "winter_half": 517
  },
  "BD6": {
   "cells": 13,
   "mm": 966,
   "n": 740,
   "periods": {
    "1961-1990": 932,
    "1981-2010": 945,
    "1991-2020": 966
   },
   "seasons": {
    "djf": 270,
    "jja": 236,
    "mam": 192,
    "son": 267
   },
   "summer_half": 428,
   "winter_half": 537
  },
  "BD7": {
   "cells": 13,
   "mm": 957,
   "n": 630,
   "periods": {
    "1961-1990": 920,
    "1981-2010": 934,
    "1991-2020": 957
   },
   "seasons": {
    "djf": 273,
    "jja": 227,
    "mam": 189,
    "son": 267
   },
   "summer_half": 417,
   "winter_half": 540
  },
  "BD8": {
   "cells": 12,
   "mm": 937,
   "n": 629,
   "periods": {
    "1961-1990": 903,
    "1981-2010": 916,
    "1991-2020": 937
   },
   "seasons": {
    "djf": 275,
    "jja": 219,
    "mam": 185,
    "son": 259
   },
   "summer_half": 404,
   "winter_half": 534
  },
  "BD9": {
   "cells": 13,
   "mm": 927,
   "n": 540,
   "periods": {
    "1961-1990": 895,
    "1981-2010": 907,
    "1991-2020": 927
   },
   "seasons": {
    "djf": 271,
    "jja": 219,
    "mam": 183,
    "son": 253
   },
   "summer_half": 403,
   "winter_half": 524
  },
  "BD97": {
   "cells": 2,
   "mm": 842,
   "n": 4,
   "periods": {
    "1961-1990": 822,
    "1981-2010": 824,
    "1991-2020": 842
   },
   "seasons": {
    "djf": 249,
    "jja": 193,
    "mam": 169,
    "son": 232
   },
   "summer_half": 362,
   "winter_half": 480
  },
  "BD98": {
   "cells": 2,
   "mm": 840,
   "n": 3,
   "periods": {
    "1961-1990": 810,
    "1981-2010": 822,
    "1991-2020": 840
   },
   "seasons": {
    "djf": 242,
    "jja": 199,
    "mam": 168,
    "son": 231
   },
   "summer_half": 367,
   "winter_half": 473
  },
  "BD99": {
   "cells": 3,
   "mm": 892,
   "n": 5,
   "periods": {
    "1961-1990": 857,
    "1981-2010": 872,
    "1991-2020": 892
   },
   "seasons": {
    "djf": 258,
    "jja": 209,
    "mam": 177,
    "son": 248
   },
   "summer_half": 386,
   "winter_half": 506
  },
  "BH1": {
   "cells": 9,
   "mm": 881,
   "n": 595,
   "periods": {
    "1961-1990": 791,
    "1981-2010": 839,
    "1991-2020": 881
   },
   "seasons": {
    "djf": 268,
    "jja": 165,
    "mam": 169,
    "son": 279
   },
   "summer_half": 334,
   "winter_half": 547
  },
  "BH10": {
   "cells": 12,
   "mm": 890,
   "n": 512,
   "periods": {
    "1961-1990": 805,
    "1981-2010": 852,
    "1991-2020": 890
   },
   "seasons": {
    "djf": 272,
    "jja": 164,
    "mam": 170,
    "son": 284
   },
   "summer_half": 334,
   "winter_half": 556
  },
  "BH11": {
   "cells": 13,
   "mm": 896,
   "n": 518,
   "periods": {
    "1961-1990": 811,
    "1981-2010": 860,
    "1991-2020": 896
   },
   "seasons": {
    "djf": 276,
    "jja": 163,
    "mam": 171,
    "son": 286
   },
   "summer_half": 334,
   "winter_half": 562
  },
  "BH12": {
   "cells": 15,
   "mm": 912,
   "n": 750,
   "periods": {
    "1961-1990": 822,
    "1981-2010": 871,
    "1991-2020": 912
   },
   "seasons": {
    "djf": 279,
    "jja": 166,
    "mam": 173,
    "son": 293
   },
   "summer_half": 340,
   "winter_half": 573
  },
  "BH13": {
   "cells": 6,
   "mm": 902,
   "n": 297,
   "periods": {
    "1961-1990": 811,
    "1981-2010": 859,
    "1991-2020": 902
   },
   "seasons": {
    "djf": 275,
    "jja": 166,
    "mam": 170,
    "son": 292
   },
   "summer_half": 336,
   "winter_half": 566
  },
  "BH14": {
   "cells": 14,
   "mm": 913,
   "n": 604,
   "periods": {
    "1961-1990": 815,
    "1981-2010": 871,
    "1991-2020": 913
   },
   "seasons": {
    "djf": 278,
    "jja": 166,
    "mam": 170,
    "son": 298
   },
   "summer_half": 336,
   "winter_half": 577
  },
  "BH15": {
   "cells": 16,
   "mm": 888,
   "n": 839,
   "periods": {
    "1961-1990": 792,
    "1981-2010": 854,
    "1991-2020": 888
   },
   "seasons": {
    "djf": 277,
    "jja": 161,
    "mam": 165,
    "son": 286
   },
   "summer_half": 326,
   "winter_half": 562
  },
  "BH16": {
   "cells": 33,
   "mm": 904,
   "n": 410,
   "periods": {
    "1961-1990": 823,
    "1981-2010": 873,
    "1991-2020": 904
   },
   "seasons": {
    "djf": 280,
    "jja": 165,
    "mam": 172,
    "son": 287
   },
   "summer_half": 337,
   "winter_half": 567
  },
  "BH17": {
   "cells": 14,
   "mm": 903,
   "n": 437,
   "periods": {
    "1961-1990": 804,
    "1981-2010": 868,
    "1991-2020": 903
   },
   "seasons": {
    "djf": 281,
    "jja": 163,
    "mam": 172,
    "son": 286
   },
   "summer_half": 335,
   "winter_half": 567
  },
  "BH18": {
   "cells": 10,
   "mm": 940,
   "n": 297,
   "periods": {
    "1961-1990": 839,
    "1981-2010": 906,
    "1991-2020": 940
   },
   "seasons": {
    "djf": 292,
    "jja": 171,
    "mam": 181,
    "son": 297
   },
   "summer_half": 352,
   "winter_half": 588
  },
  "BH19": {
   "cells": 27,
   "mm": 917,
   "n": 554,
   "periods": {
    "1961-1990": 852,
    "1981-2010": 886,
    "1991-2020": 917
   },
   "seasons": {
    "djf": 286,
    "jja": 173,
    "mam": 170,
    "son": 288
   },
   "summer_half": 343,
   "winter_half": 574
  },
  "BH2": {
   "cells": 4,
   "mm": 872,
   "n": 275,
   "periods": {
    "1961-1990": 785,
    "1981-2010": 831,
    "1991-2020": 872
   },
   "seasons": {
    "djf": 265,
    "jja": 162,
    "mam": 168,
    "son": 276
   },
   "summer_half": 331,
   "winter_half": 541
  },
  "BH20": {
   "cells": 133,
   "mm": 941,
   "n": 723,
   "periods": {
    "1961-1990": 871,
    "1981-2010": 908,
    "1991-2020": 941
   },
   "seasons": {
    "djf": 293,
    "jja": 175,
    "mam": 176,
    "son": 297
   },
   "summer_half": 351,
   "winter_half": 590
  },
  "BH21": {
   "cells": 172,
   "mm": 915,
   "n": 1489,
   "periods": {
    "1961-1990": 836,
    "1981-2010": 875,
    "1991-2020": 915
   },
   "seasons": {
    "djf": 277,
    "jja": 173,
    "mam": 180,
    "son": 284
   },
   "summer_half": 353,
   "winter_half": 562
  },
  "BH22": {
   "cells": 27,
   "mm": 902,
   "n": 716,
   "periods": {
    "1961-1990": 824,
    "1981-2010": 864,
    "1991-2020": 902
   },
   "seasons": {
    "djf": 276,
    "jja": 166,
    "mam": 176,
    "son": 284
   },
   "summer_half": 342,
   "winter_half": 560
  },
  "BH23": {
   "cells": 76,
   "mm": 855,
   "n": 1589,
   "periods": {
    "1961-1990": 783,
    "1981-2010": 823,
    "1991-2020": 855
   },
   "seasons": {
    "djf": 260,
    "jja": 159,
    "mam": 163,
    "son": 274
   },
   "summer_half": 322,
   "winter_half": 533
  },
  "BH24": {
   "cells": 92,
   "mm": 910,
   "n": 810,
   "periods": {
    "1961-1990": 830,
    "1981-2010": 865,
    "1991-2020": 910
   },
   "seasons": {
    "djf": 277,
    "jja": 173,
    "mam": 178,
    "son": 283
   },
   "summer_half": 350,
   "winter_half": 559
  },
  "BH25": {
   "cells": 26,
   "mm": 855,
   "n": 801,
   "periods": {
    "1961-1990": 801,
    "1981-2010": 827,
    "1991-2020": 855
   },
   "seasons": {
    "djf": 258,
    "jja": 166,
    "mam": 160,
    "son": 271
   },
   "summer_half": 326,
   "winter_half": 529
  },
  "BH3": {
   "cells": 6,
   "mm": 888,
   "n": 130,
   "periods": {
    "1961-1990": 800,
    "1981-2010": 847,
    "1991-2020": 888
   },
   "seasons": {
    "djf": 269,
    "jja": 166,
    "mam": 170,
    "son": 283
   },
   "summer_half": 336,
   "winter_half": 552
  },
  "BH31": {
   "cells": 12,
   "mm": 927,
   "n": 302,
   "periods": {
    "1961-1990": 839,
    "1981-2010": 886,
    "1991-2020": 927
   },
   "seasons": {
    "djf": 270,
    "jja": 185,
    "mam": 191,
    "son": 281
   },
   "summer_half": 376,
   "winter_half": 551
  },
  "BH4": {
   "cells": 7,
   "mm": 889,
   "n": 232,
   "periods": {
    "1961-1990": 802,
    "1981-2010": 846,
    "1991-2020": 889
   },
   "seasons": {
    "djf": 271,
    "jja": 165,
    "mam": 170,
    "son": 283
   },
   "summer_half": 335,
   "winter_half": 554
  },
  "BH5": {
   "cells": 6,
   "mm": 880,
   "n": 251,
   "periods": {
    "1961-1990": 788,
    "1981-2010": 838,
    "1991-2020": 880
   },
   "seasons": {
    "djf": 270,
    "jja": 164,
    "mam": 167,
    "son": 279
   },
   "summer_half": 331,
   "winter_half": 549
  },
  "BH6": {
   "cells": 11,
   "mm": 828,
   "n": 526,
   "periods": {
    "1961-1990": 745,
    "1981-2010": 794,
    "1991-2020": 828
   },
   "seasons": {
    "djf": 251,
    "jja": 149,
    "mam": 157,
    "son": 271
   },
   "summer_half": 306,
   "winter_half": 522
  },
  "BH7": {
   "cells": 10,
   "mm": 858,
   "n": 290,
   "periods": {
    "1961-1990": 776,
    "1981-2010": 824,
    "1991-2020": 858
   },
   "seasons": {
    "djf": 265,
    "jja": 157,
    "mam": 162,
    "son": 274
   },
   "summer_half": 319,
   "winter_half": 539
  },
  "BH8": {
   "cells": 15,
   "mm": 871,
   "n": 646,
   "periods": {
    "1961-1990": 789,
    "1981-2010": 836,
    "1991-2020": 871
   },
   "seasons": {
    "djf": 266,
    "jja": 161,
    "mam": 166,
    "son": 277
   },
   "summer_half": 328,
   "winter_half": 544
  },
  "BH9": {
   "cells": 12,
   "mm": 882,
   "n": 666,
   "periods": {
    "1961-1990": 798,
    "1981-2010": 844,
    "1991-2020": 882
   },
   "seasons": {
    "djf": 269,
    "jja": 163,
    "mam": 169,
    "son": 281
   },
   "summer_half": 332,
   "winter_half": 550
  },
  "BL0": {
   "cells": 25,
   "mm": 1388,
   "n": 564,
   "periods": {
    "1961-1990": 1317,
    "1981-2010": 1344,
    "1991-2020": 1388
   },
   "seasons": {
    "djf": 421,
    "jja": 310,
    "mam": 270,
    "son": 387
   },
   "summer_half": 580,
   "winter_half": 808
  },
  "BL1": {
   "cells": 33,
   "mm": 1304,
   "n": 1853,
   "periods": {
    "1961-1990": 1245,
    "1981-2010": 1276,
    "1991-2020": 1304
   },
   "seasons": {
    "djf": 372,
    "jja": 304,
    "mam": 243,
    "son": 385
   },
   "summer_half": 547,
   "winter_half": 757
  },
  "BL11": {
   "cells": 2,
   "mm": 1105,
   "n": 23,
   "periods": {
    "1961-1990": 1048,
    "1981-2010": 1078,
    "1991-2020": 1105
   },
   "seasons": {
    "djf": 313,
    "jja": 252,
    "mam": 204,
    "son": 336
   },
   "summer_half": 455,
   "winter_half": 649
  },
  "BL2": {
   "cells": 28,
   "mm": 1223,
   "n": 1152,
   "periods": {
    "1961-1990": 1170,
    "1981-2010": 1200,
    "1991-2020": 1223
   },
   "seasons": {
    "djf": 357,
    "jja": 278,
    "mam": 230,
    "son": 359
   },
   "summer_half": 508,
   "winter_half": 715
  },
  "BL3": {
   "cells": 28,
   "mm": 1151,
   "n": 1384,
   "periods": {
    "1961-1990": 1108,
    "1981-2010": 1124,
    "1991-2020": 1151
   },
   "seasons": {
    "djf": 329,
    "jja": 273,
    "mam": 215,
    "son": 333
   },
   "summer_half": 489,
   "winter_half": 662
  },
  "BL4": {
   "cells": 21,
   "mm": 1118,
   "n": 849,
   "periods": {
    "1961-1990": 1077,
    "1981-2010": 1096,
    "1991-2020": 1118
   },
   "seasons": {
    "djf": 316,
    "jja": 273,
    "mam": 210,
    "son": 319
   },
   "summer_half": 483,
   "winter_half": 635
  },
  "BL5": {
   "cells": 34,
   "mm": 1160,
   "n": 704,
   "periods": {
    "1961-1990": 1115,
    "1981-2010": 1130,
    "1991-2020": 1160
   },
   "seasons": {
    "djf": 325,
    "jja": 279,
    "mam": 218,
    "son": 337
   },
   "summer_half": 498,
   "winter_half": 662
  },
  "BL6": {
   "cells": 43,
   "mm": 1241,
   "n": 1016,
   "periods": {
    "1961-1990": 1191,
    "1981-2010": 1210,
    "1991-2020": 1241
   },
   "seasons": {
    "djf": 347,
    "jja": 300,
    "mam": 233,
    "son": 361
   },
   "summer_half": 533,
   "winter_half": 709
  },
  "BL7": {
   "cells": 41,
   "mm": 1481,
   "n": 507,
   "periods": {
    "1961-1990": 1410,
    "1981-2010": 1454,
    "1991-2020": 1481
   },
   "seasons": {
    "djf": 440,
    "jja": 334,
    "mam": 280,
    "son": 428
   },
   "summer_half": 614,
   "winter_half": 868
  },
  "BL78": {
   "cells": 2,
   "mm": 1117,
   "n": 5,
   "periods": {
    "1961-1990": 1071,
    "1981-2010": 1093,
    "1991-2020": 1117
   },
   "seasons": {
    "djf": 321,
    "jja": 260,
    "mam": 208,
    "son": 329
   },
   "summer_half": 467,
   "winter_half": 650
  },
  "BL8": {
   "cells": 37,
   "mm": 1327,
   "n": 1012,
   "periods": {
    "1961-1990": 1273,
    "1981-2010": 1298,
    "1991-2020": 1327
   },
   "seasons": {
    "djf": 399,
    "jja": 297,
    "mam": 257,
    "son": 375
   },
   "summer_half": 554,
   "winter_half": 774
  },
  "BL9": {
   "cells": 43,
   "mm": 1229,
   "n": 1331,
   "periods": {
    "1961-1990": 1176,
    "1981-2010": 1198,
    "1991-2020": 1229
   },
   "seasons": {
    "djf": 359,
    "jja": 287,
    "mam": 237,
    "son": 345
   },
   "summer_half": 524,
   "winter_half": 704
  },
  "BN1": {
   "cells": 36,
   "mm": 885,
   "n": 1579,
   "periods": {
    "1961-1990": 839,
    "1981-2010": 865,
    "1991-2020": 885
   },
   "seasons": {
    "djf": 269,
    "jja": 184,
    "mam": 157,
    "son": 275
   },
   "summer_half": 341,
   "winter_half": 544
  },
  "BN10": {
   "cells": 12,
   "mm": 805,
   "n": 537,
   "periods": {
    "1961-1990": 766,
    "1981-2010": 789,
    "1991-2020": 805
   },
   "seasons": {
    "djf": 246,
    "jja": 166,
    "mam": 139,
    "son": 255
   },
   "summer_half": 305,
   "winter_half": 500
  },
  "BN11": {
   "cells": 10,
   "mm": 768,
   "n": 1096,
   "periods": {
    "1961-1990": 723,
    "1981-2010": 741,
    "1991-2020": 768
   },
   "seasons": {
    "djf": 229,
    "jja": 161,
    "mam": 138,
    "son": 239
   },
   "summer_half": 299,
   "winter_half": 468
  },
  "BN12": {
   "cells": 13,
   "mm": 792,
   "n": 688,
   "periods": {
    "1961-1990": 740,
    "1981-2010": 764,
    "1991-2020": 792
   },
   "seasons": {
    "djf": 243,
    "jja": 159,
    "mam": 143,
    "son": 248
   },
   "summer_half": 302,
   "winter_half": 491
  },
  "BN13": {
   "cells": 29,
   "mm": 846,
   "n": 772,
   "periods": {
    "1961-1990": 789,
    "1981-2010": 819,
    "1991-2020": 846
   },
   "seasons": {
    "djf": 253,
    "jja": 171,
    "mam": 156,
    "son": 266
   },
   "summer_half": 327,
   "winter_half": 519
  },
  "BN14": {
   "cells": 24,
   "mm": 875,
   "n": 750,
   "periods": {
    "1961-1990": 815,
    "1981-2010": 845,
    "1991-2020": 875
   },
   "seasons": {
    "djf": 265,
    "jja": 180,
    "mam": 158,
    "son": 273
   },
   "summer_half": 337,
   "winter_half": 538
  },
  "BN15": {
   "cells": 19,
   "mm": 811,
   "n": 744,
   "periods": {
    "1961-1990": 775,
    "1981-2010": 784,
    "1991-2020": 811
   },
   "seasons": {
    "djf": 246,
    "jja": 169,
    "mam": 145,
    "son": 252
   },
   "summer_half": 313,
   "winter_half": 498
  },
  "BN16": {
   "cells": 22,
   "mm": 807,
   "n": 1021,
   "periods": {
    "1961-1990": 751,
    "1981-2010": 785,
    "1991-2020": 807
   },
   "seasons": {
    "djf": 245,
    "jja": 163,
    "mam": 146,
    "son": 253
   },
   "summer_half": 310,
   "winter_half": 497
  },
  "BN17": {
   "cells": 21,
   "mm": 779,
   "n": 767,
   "periods": {
    "1961-1990": 727,
    "1981-2010": 759,
    "1991-2020": 779
   },
   "seasons": {
    "djf": 234,
    "jja": 160,
    "mam": 141,
    "son": 243
   },
   "summer_half": 302,
   "winter_half": 477
  },
  "BN18": {
   "cells": 73,
   "mm": 866,
   "n": 586,
   "periods": {
    "1961-1990": 807,
    "1981-2010": 838,
    "1991-2020": 866
   },
   "seasons": {
    "djf": 267,
    "jja": 173,
    "mam": 159,
    "son": 267
   },
   "summer_half": 332,
   "winter_half": 534
  },
  "BN2": {
   "cells": 35,
   "mm": 843,
   "n": 1609,
   "periods": {
    "1961-1990": 801,
    "1981-2010": 824,
    "1991-2020": 843
   },
   "seasons": {
    "djf": 255,
    "jja": 175,
    "mam": 149,
    "son": 264
   },
   "summer_half": 324,
   "winter_half": 519
  },
  "BN20": {
   "cells": 32,
   "mm": 857,
   "n": 728,
   "periods": {
    "1961-1990": 820,
    "1981-2010": 839,
    "1991-2020": 857
   },
   "seasons": {
    "djf": 263,
    "jja": 173,
    "mam": 148,
    "son": 273
   },
   "summer_half": 321,
   "winter_half": 536
  },
  "BN21": {
   "cells": 9,
   "mm": 822,
   "n": 932,
   "periods": {
    "1961-1990": 797,
    "1981-2010": 817,
    "1991-2020": 822
   },
   "seasons": {
    "djf": 253,
    "jja": 166,
    "mam": 142,
    "son": 261
   },
   "summer_half": 308,
   "winter_half": 514
  },
  "BN22": {
   "cells": 16,
   "mm": 823,
   "n": 828,
   "periods": {
    "1961-1990": 787,
    "1981-2010": 815,
    "1991-2020": 823
   },
   "seasons": {
    "djf": 254,
    "jja": 165,
    "mam": 144,
    "son": 261
   },
   "summer_half": 309,
   "winter_half": 515
  },
  "BN23": {
   "cells": 14,
   "mm": 823,
   "n": 688,
   "periods": {
    "1961-1990": 781,
    "1981-2010": 817,
    "1991-2020": 823
   },
   "seasons": {
    "djf": 255,
    "jja": 161,
    "mam": 145,
    "son": 261
   },
   "summer_half": 306,
   "winter_half": 516
  },
  "BN24": {
   "cells": 21,
   "mm": 825,
   "n": 384,
   "periods": {
    "1961-1990": 776,
    "1981-2010": 821,
    "1991-2020": 825
   },
   "seasons": {
    "djf": 256,
    "jja": 163,
    "mam": 145,
    "son": 261
   },
   "summer_half": 308,
   "winter_half": 517
  },
  "BN25": {
   "cells": 23,
   "mm": 802,
   "n": 884,
   "periods": {
    "1961-1990": 755,
    "1981-2010": 781,
    "1991-2020": 802
   },
   "seasons": {
    "djf": 243,
    "jja": 162,
    "mam": 141,
    "son": 256
   },
   "summer_half": 303,
   "winter_half": 499
  },
  "BN26": {
   "cells": 58,
   "mm": 849,
   "n": 524,
   "periods": {
    "1961-1990": 796,
    "1981-2010": 835,
    "1991-2020": 849
   },
   "seasons": {
    "djf": 260,
    "jja": 171,
    "mam": 148,
    "son": 270
   },
   "summer_half": 319,
   "winter_half": 530
  },
  "BN27": {
   "cells": 92,
   "mm": 840,
   "n": 1136,
   "periods": {
    "1961-1990": 779,
    "1981-2010": 818,
    "1991-2020": 840
   },
   "seasons": {
    "djf": 255,
    "jja": 178,
    "mam": 144,
    "son": 263
   },
   "summer_half": 322,
   "winter_half": 518
  },
  "BN3": {
   "cells": 18,
   "mm": 829,
   "n": 1445,
   "periods": {
    "1961-1990": 789,
    "1981-2010": 806,
    "1991-2020": 829
   },
   "seasons": {
    "djf": 252,
    "jja": 172,
    "mam": 146,
    "son": 259
   },
   "summer_half": 318,
   "winter_half": 511
  },
  "BN41": {
   "cells": 8,
   "mm": 834,
   "n": 400,
   "periods": {
    "1961-1990": 796,
    "1981-2010": 803,
    "1991-2020": 834
   },
   "seasons": {
    "djf": 254,
    "jja": 171,
    "mam": 147,
    "son": 262
   },
   "summer_half": 318,
   "winter_half": 516
  },
  "BN42": {
   "cells": 7,
   "mm": 814,
   "n": 219,
   "periods": {
    "1961-1990": 777,
    "1981-2010": 783,
    "1991-2020": 814
   },
   "seasons": {
    "djf": 248,
    "jja": 167,
    "mam": 144,
    "son": 256
   },
   "summer_half": 311,
   "winter_half": 504
  },
  "BN43": {
   "cells": 14,
   "mm": 824,
   "n": 529,
   "periods": {
    "1961-1990": 792,
    "1981-2010": 788,
    "1991-2020": 824
   },
   "seasons": {
    "djf": 251,
    "jja": 171,
    "mam": 147,
    "son": 255
   },
   "summer_half": 317,
   "winter_half": 506
  },
  "BN44": {
   "cells": 30,
   "mm": 893,
   "n": 263,
   "periods": {
    "1961-1990": 843,
    "1981-2010": 863,
    "1991-2020": 893
   },
   "seasons": {
    "djf": 277,
    "jja": 175,
    "mam": 162,
    "son": 279
   },
   "summer_half": 337,
   "winter_half": 556
  },
  "BN45": {
   "cells": 11,
   "mm": 954,
   "n": 42,
   "periods": {
    "1961-1990": 900,
    "1981-2010": 925,
    "1991-2020": 954
   },
   "seasons": {
    "djf": 294,
    "jja": 193,
    "mam": 170,
    "son": 297
   },
   "summer_half": 363,
   "winter_half": 592
  },
  "BN5": {
   "cells": 43,
   "mm": 858,
   "n": 287,
   "periods": {
    "1961-1990": 811,
    "1981-2010": 837,
    "1991-2020": 858
   },
   "seasons": {
    "djf": 264,
    "jja": 172,
    "mam": 155,
    "son": 266
   },
   "summer_half": 328,
   "winter_half": 531
  },
  "BN50": {
   "cells": 1,
   "mm": 764,
   "n": 63,
   "periods": {
    "1961-1990": 731,
    "1981-2010": 752,
    "1991-2020": 764
   },
   "seasons": {
    "djf": 231,
    "jja": 163,
    "mam": 133,
    "son": 237
   },
   "summer_half": 296,
   "winter_half": 468
  },
  "BN51": {
   "cells": 1,
   "mm": 802,
   "n": 9,
   "periods": {
    "1961-1990": 754,
    "1981-2010": 781,
    "1991-2020": 802
   },
   "seasons": {
    "djf": 244,
    "jja": 165,
    "mam": 144,
    "son": 249
   },
   "summer_half": 309,
   "winter_half": 494
  },
  "BN52": {
   "cells": 1,
   "mm": 804,
   "n": 60,
   "periods": {
    "1961-1990": 765,
    "1981-2010": 785,
    "1991-2020": 804
   },
   "seasons": {
    "djf": 242,
    "jja": 166,
    "mam": 143,
    "son": 252
   },
   "summer_half": 310,
   "winter_half": 494
  },
  "BN6": {
   "cells": 66,
   "mm": 911,
   "n": 622,
   "periods": {
    "1961-1990": 855,
    "1981-2010": 881,
    "1991-2020": 911
   },
   "seasons": {
    "djf": 281,
    "jja": 183,
    "mam": 163,
    "son": 284
   },
   "summer_half": 346,
   "winter_half": 565
  },
  "BN7": {
   "cells": 52,
   "mm": 910,
   "n": 748,
   "periods": {
    "1961-1990": 857,
    "1981-2010": 890,
    "1991-2020": 910
   },
   "seasons": {
    "djf": 281,
    "jja": 186,
    "mam": 158,
    "son": 285
   },
   "summer_half": 344,
   "winter_half": 566
  },
  "BN8": {
   "cells": 137,
   "mm": 866,
   "n": 693,
   "periods": {
    "1961-1990": 806,
    "1981-2010": 844,
    "1991-2020": 866
   },
   "seasons": {
    "djf": 268,
    "jja": 176,
    "mam": 150,
    "son": 273
   },
   "summer_half": 326,
   "winter_half": 540
  },
  "BN88": {
   "cells": 2,
   "mm": 798,
   "n": 8,
   "periods": {
    "1961-1990": 763,
    "1981-2010": 783,
    "1991-2020": 798
   },
   "seasons": {
    "djf": 241,
    "jja": 170,
    "mam": 140,
    "son": 248
   },
   "summer_half": 309,
   "winter_half": 489
  },
  "BN9": {
   "cells": 16,
   "mm": 789,
   "n": 417,
   "periods": {
    "1961-1990": 749,
    "1981-2010": 777,
    "1991-2020": 789
   },
   "seasons": {
    "djf": 242,
    "jja": 160,
    "mam": 136,
    "son": 251
   },
   "summer_half": 296,
   "winter_half": 493
  },
  "BN95": {
   "cells": 1,
   "mm": 756,
   "n": 1,
   "periods": {
    "1961-1990": 720,
    "1981-2010": 732,
    "1991-2020": 756
   },
   "seasons": {
    "djf": 227,
    "jja": 158,
    "mam": 135,
    "son": 236
   },
   "summer_half": 294,
   "winter_half": 462
  },
  "BN99": {
   "cells": 5,
   "mm": 781,
   "n": 437,
   "periods": {
    "1961-1990": 734,
    "1981-2010": 753,
    "1991-2020": 781
   },
   "seasons": {
    "djf": 233,
    "jja": 161,
    "mam": 141,
    "son": 246
   },
   "summer_half": 302,
   "winter_half": 479
  },
  "BR1": {
   "cells": 22,
   "mm": 650,
   "n": 1259,
   "periods": {
    "1961-1990": 641,
    "1981-2010": 642,
    "1991-2020": 650
   },
   "seasons": {
    "djf": 174,
    "jja": 155,
    "mam": 132,
    "son": 190
   },
   "summer_half": 286,
   "winter_half": 364
  },
  "BR2": {
   "cells": 34,
   "mm": 698,
   "n": 1005,
   "periods": {
    "1961-1990": 684,
    "1981-2010": 690,
    "1991-2020": 698
   },
   "seasons": {
    "djf": 195,
    "jja": 156,
    "mam": 143,
    "son": 204
   },
   "summer_half": 298,
   "winter_half": 400
  },
  "BR3": {
   "cells": 20,
   "mm": 662,
   "n": 1126,
   "periods": {
    "1961-1990": 645,
    "1981-2010": 656,
    "1991-2020": 662
   },
   "seasons": {
    "djf": 177,
    "jja": 157,
    "mam": 134,
    "son": 193
   },
   "summer_half": 291,
   "winter_half": 370
  },
  "BR4": {
   "cells": 13,
   "mm": 695,
   "n": 372,
   "periods": {
    "1961-1990": 677,
    "1981-2010": 686,
    "1991-2020": 695
   },
   "seasons": {
    "djf": 195,
    "jja": 156,
    "mam": 141,
    "son": 203
   },
   "summer_half": 297,
   "winter_half": 397
  },
  "BR5": {
   "cells": 26,
   "mm": 690,
   "n": 933,
   "periods": {
    "1961-1990": 669,
    "1981-2010": 677,
    "1991-2020": 690
   },
   "seasons": {
    "djf": 193,
    "jja": 155,
    "mam": 139,
    "son": 204
   },
   "summer_half": 293,
   "winter_half": 397
  },
  "BR6": {
   "cells": 45,
   "mm": 756,
   "n": 1136,
   "periods": {
    "1961-1990": 735,
    "1981-2010": 745,
    "1991-2020": 756
   },
   "seasons": {
    "djf": 218,
    "jja": 162,
    "mam": 153,
    "son": 223
   },
   "summer_half": 314,
   "winter_half": 441
  },
  "BR7": {
   "cells": 17,
   "mm": 671,
   "n": 460,
   "periods": {
    "1961-1990": 655,
    "1981-2010": 658,
    "1991-2020": 671
   },
   "seasons": {
    "djf": 182,
    "jja": 154,
    "mam": 135,
    "son": 200
   },
   "summer_half": 289,
   "winter_half": 382
  },
  "BR8": {
   "cells": 22,
   "mm": 655,
   "n": 488,
   "periods": {
    "1961-1990": 636,
    "1981-2010": 643,
    "1991-2020": 655
   },
   "seasons": {
    "djf": 179,
    "jja": 149,
    "mam": 133,
    "son": 194
   },
   "summer_half": 282,
   "winter_half": 374
  },
  "BS1": {
   "cells": 8,
   "mm": 867,
   "n": 803,
   "periods": {
    "1961-1990": 804,
    "1981-2010": 855,
    "1991-2020": 867
   },
   "seasons": {
    "djf": 250,
    "jja": 200,
    "mam": 173,
    "son": 244
   },
   "summer_half": 372,
   "winter_half": 494
  },
  "BS10": {
   "cells": 27,
   "mm": 838,
   "n": 775,
   "periods": {
    "1961-1990": 787,
    "1981-2010": 826,
    "1991-2020": 838
   },
   "seasons": {
    "djf": 234,
    "jja": 198,
    "mam": 168,
    "son": 239
   },
   "summer_half": 365,
   "winter_half": 473
  },
  "BS11": {
   "cells": 18,
   "mm": 808,
   "n": 573,
   "periods": {
    "1961-1990": 761,
    "1981-2010": 799,
    "1991-2020": 808
   },
   "seasons": {
    "djf": 230,
    "jja": 186,
    "mam": 164,
    "son": 229
   },
   "summer_half": 349,
   "winter_half": 459
  },
  "BS13": {
   "cells": 15,
   "mm": 911,
   "n": 775,
   "periods": {
    "1961-1990": 860,
    "1981-2010": 914,
    "1991-2020": 911
   },
   "seasons": {
    "djf": 264,
    "jja": 206,
    "mam": 185,
    "son": 255
   },
   "summer_half": 391,
   "winter_half": 519
  },
  "BS14": {
   "cells": 20,
   "mm": 911,
   "n": 724,
   "periods": {
    "1961-1990": 855,
    "1981-2010": 899,
    "1991-2020": 911
   },
   "seasons": {
    "djf": 268,
    "jja": 203,
    "mam": 185,
    "son": 255
   },
   "summer_half": 388,
   "winter_half": 523
  },
  "BS15": {
   "cells": 21,
   "mm": 878,
   "n": 1161,
   "periods": {
    "1961-1990": 816,
    "1981-2010": 863,
    "1991-2020": 878
   },
   "seasons": {
    "djf": 257,
    "jja": 201,
    "mam": 168,
    "son": 252
   },
   "summer_half": 369,
   "winter_half": 509
  },
  "BS16": {
   "cells": 49,
   "mm": 873,
   "n": 2037,
   "periods": {
    "1961-1990": 808,
    "1981-2010": 852,
    "1991-2020": 873
   },
   "seasons": {
    "djf": 248,
    "jja": 206,
    "mam": 169,
    "son": 250
   },
   "summer_half": 375,
   "winter_half": 498
  },
  "BS2": {
   "cells": 12,
   "mm": 869,
   "n": 659,
   "periods": {
    "1961-1990": 805,
    "1981-2010": 858,
    "1991-2020": 869
   },
   "seasons": {
    "djf": 252,
    "jja": 200,
    "mam": 174,
    "son": 243
   },
   "summer_half": 374,
   "winter_half": 495
  },
  "BS20": {
   "cells": 36,
   "mm": 873,
   "n": 860,
   "periods": {
    "1961-1990": 813,
    "1981-2010": 866,
    "1991-2020": 873
   },
   "seasons": {
    "djf": 246,
    "jja": 205,
    "mam": 174,
    "son": 248
   },
   "summer_half": 379,
   "winter_half": 495
  },
  "BS21": {
   "cells": 39,
   "mm": 871,
   "n": 695,
   "periods": {
    "1961-1990": 828,
    "1981-2010": 884,
    "1991-2020": 871
   },
   "seasons": {
    "djf": 243,
    "jja": 203,
    "mam": 169,
    "son": 256
   },
   "summer_half": 372,
   "winter_half": 499
  },
  "BS22": {
   "cells": 28,
   "mm": 899,
   "n": 946,
   "periods": {
    "1961-1990": 828,
    "1981-2010": 881,
    "1991-2020": 899
   },
   "seasons": {
    "djf": 250,
    "jja": 208,
    "mam": 176,
    "son": 264
   },
   "summer_half": 385,
   "winter_half": 514
  },
  "BS23": {
   "cells": 15,
   "mm": 890,
   "n": 1029,
   "periods": {
    "1961-1990": 813,
    "1981-2010": 863,
    "1991-2020": 890
   },
   "seasons": {
    "djf": 242,
    "jja": 205,
    "mam": 177,
    "son": 265
   },
   "summer_half": 383,
   "winter_half": 507
  },
  "BS24": {
   "cells": 56,
   "mm": 881,
   "n": 697,
   "periods": {
    "1961-1990": 823,
    "1981-2010": 867,
    "1991-2020": 881
   },
   "seasons": {
    "djf": 241,
    "jja": 206,
    "mam": 173,
    "son": 260
   },
   "summer_half": 379,
   "winter_half": 502
  },
  "BS25": {
   "cells": 28,
   "mm": 978,
   "n": 283,
   "periods": {
    "1961-1990": 908,
    "1981-2010": 972,
    "1991-2020": 978
   },
   "seasons": {
    "djf": 266,
    "jja": 240,
    "mam": 192,
    "son": 280
   },
   "summer_half": 432,
   "winter_half": 546
  },
  "BS26": {
   "cells": 37,
   "mm": 878,
   "n": 226,
   "periods": {
    "1961-1990": 829,
    "1981-2010": 871,
    "1991-2020": 878
   },
   "seasons": {
    "djf": 234,
    "jja": 213,
    "mam": 170,
    "son": 260
   },
   "summer_half": 384,
   "winter_half": 494
  },
  "BS27": {
   "cells": 21,
   "mm": 933,
   "n": 301,
   "periods": {
    "1961-1990": 864,
    "1981-2010": 915,
    "1991-2020": 933
   },
   "seasons": {
    "djf": 249,
    "jja": 229,
    "mam": 184,
    "son": 271
   },
   "summer_half": 413,
   "winter_half": 520
  },
  "BS28": {
   "cells": 34,
   "mm": 822,
   "n": 205,
   "periods": {
    "1961-1990": 791,
    "1981-2010": 810,
    "1991-2020": 822
   },
   "seasons": {
    "djf": 217,
    "jja": 206,
    "mam": 162,
    "son": 237
   },
   "summer_half": 368,
   "winter_half": 454
  },
  "BS29": {
   "cells": 12,
   "mm": 948,
   "n": 135,
   "periods": {
    "1961-1990": 881,
    "1981-2010": 937,
    "1991-2020": 948
   },
   "seasons": {
    "djf": 261,
    "jja": 228,
    "mam": 185,
    "son": 274
   },
   "summer_half": 413,
   "winter_half": 535
  },
  "BS3": {
   "cells": 15,
   "mm": 868,
   "n": 979,
   "periods": {
    "1961-1990": 808,
    "1981-2010": 860,
    "1991-2020": 868
   },
   "seasons": {
    "djf": 252,
    "jja": 197,
    "mam": 174,
    "son": 244
   },
   "summer_half": 372,
   "winter_half": 496
  },
  "BS30": {
   "cells": 45,
   "mm": 863,
   "n": 758,
   "periods": {
    "1961-1990": 789,
    "1981-2010": 838,
    "1991-2020": 863
   },
   "seasons": {
    "djf": 248,
    "jja": 201,
    "mam": 168,
    "son": 246
   },
   "summer_half": 370,
   "winter_half": 494
  },
  "BS31": {
   "cells": 28,
   "mm": 821,
   "n": 687,
   "periods": {
    "1961-1990": 776,
    "1981-2010": 813,
    "1991-2020": 821
   },
   "seasons": {
    "djf": 239,
    "jja": 187,
    "mam": 166,
    "son": 228
   },
   "summer_half": 353,
   "winter_half": 468
  },
  "BS32": {
   "cells": 30,
   "mm": 809,
   "n": 429,
   "periods": {
    "1961-1990": 750,
    "1981-2010": 791,
    "1991-2020": 809
   },
   "seasons": {
    "djf": 227,
    "jja": 192,
    "mam": 160,
    "son": 230
   },
   "summer_half": 352,
   "winter_half": 457
  },
  "BS34": {
   "cells": 23,
   "mm": 841,
   "n": 916,
   "periods": {
    "1961-1990": 791,
    "1981-2010": 826,
    "1991-2020": 841
   },
   "seasons": {
    "djf": 236,
    "jja": 198,
    "mam": 165,
    "son": 242
   },
   "summer_half": 363,
   "winter_half": 478
  },
  "BS35": {
   "cells": 80,
   "mm": 831,
   "n": 757,
   "periods": {
    "1961-1990": 761,
    "1981-2010": 810,
    "1991-2020": 831
   },
   "seasons": {
    "djf": 235,
    "jja": 194,
    "mam": 169,
    "son": 233
   },
   "summer_half": 363,
   "winter_half": 468
  },
  "BS36": {
   "cells": 28,
   "mm": 848,
   "n": 506,
   "periods": {
    "1961-1990": 787,
    "1981-2010": 828,
    "1991-2020": 848
   },
   "seasons": {
    "djf": 241,
    "jja": 202,
    "mam": 165,
    "son": 240
   },
   "summer_half": 366,
   "winter_half": 481
  },
  "BS37": {
   "cells": 69,
   "mm": 874,
   "n": 1063,
   "periods": {
    "1961-1990": 809,
    "1981-2010": 852,
    "1991-2020": 874
   },
   "seasons": {
    "djf": 250,
    "jja": 199,
    "mam": 177,
    "son": 248
   },
   "summer_half": 377,
   "winter_half": 498
  },
  "BS39": {
   "cells": 73,
   "mm": 970,
   "n": 623,
   "periods": {
    "1961-1990": 917,
    "1981-2010": 968,
    "1991-2020": 970
   },
   "seasons": {
    "djf": 284,
    "jja": 209,
    "mam": 194,
    "son": 282
   },
   "summer_half": 404,
   "winter_half": 566
  },
  "BS4": {
   "cells": 22,
   "mm": 889,
   "n": 1108,
   "periods": {
    "1961-1990": 829,
    "1981-2010": 878,
    "1991-2020": 889
   },
   "seasons": {
    "djf": 266,
    "jja": 196,
    "mam": 179,
    "son": 247
   },
   "summer_half": 375,
   "winter_half": 514
  },
  "BS40": {
   "cells": 133,
   "mm": 1028,
   "n": 720,
   "periods": {
    "1961-1990": 970,
    "1981-2010": 1026,
    "1991-2020": 1028
   },
   "seasons": {
    "djf": 295,
    "jja": 231,
    "mam": 205,
    "son": 296
   },
   "summer_half": 436,
   "winter_half": 592
  },
  "BS41": {
   "cells": 21,
   "mm": 969,
   "n": 196,
   "periods": {
    "1961-1990": 916,
    "1981-2010": 977,
    "1991-2020": 969
   },
   "seasons": {
    "djf": 277,
    "jja": 223,
    "mam": 195,
    "son": 274
   },
   "summer_half": 418,
   "winter_half": 551
  },
  "BS48": {
   "cells": 60,
   "mm": 944,
   "n": 768,
   "periods": {
    "1961-1990": 882,
    "1981-2010": 944,
    "1991-2020": 944
   },
   "seasons": {
    "djf": 261,
    "jja": 222,
    "mam": 186,
    "son": 274
   },
   "summer_half": 409,
   "winter_half": 535
  },
  "BS49": {
   "cells": 26,
   "mm": 904,
   "n": 345,
   "periods": {
    "1961-1990": 852,
    "1981-2010": 900,
    "1991-2020": 904
   },
   "seasons": {
    "djf": 249,
    "jja": 214,
    "mam": 175,
    "son": 267
   },
   "summer_half": 388,
   "winter_half": 516
  },
  "BS5": {
   "cells": 16,
   "mm": 874,
   "n": 1307,
   "periods": {
    "1961-1990": 811,
    "1981-2010": 862,
    "1991-2020": 874
   },
   "seasons": {
    "djf": 256,
    "jja": 199,
    "mam": 174,
    "son": 245
   },
   "summer_half": 373,
   "winter_half": 501
  },
  "BS6": {
   "cells": 10,
   "mm": 892,
   "n": 781,
   "periods": {
    "1961-1990": 826,
    "1981-2010": 880,
    "1991-2020": 892
   },
   "seasons": {
    "djf": 252,
    "jja": 213,
    "mam": 178,
    "son": 249
   },
   "summer_half": 391,
   "winter_half": 501
  },
  "BS7": {
   "cells": 14,
   "mm": 873,
   "n": 790,
   "periods": {
    "1961-1990": 813,
    "1981-2010": 862,
    "1991-2020": 873
   },
   "seasons": {
    "djf": 244,
    "jja": 210,
    "mam": 174,
    "son": 246
   },
   "summer_half": 383,
   "winter_half": 490
  },
  "BS8": {
   "cells": 25,
   "mm": 932,
   "n": 824,
   "periods": {
    "1961-1990": 866,
    "1981-2010": 922,
    "1991-2020": 932
   },
   "seasons": {
    "djf": 262,
    "jja": 219,
    "mam": 184,
    "son": 267
   },
   "summer_half": 403,
   "winter_half": 529
  },
  "BS9": {
   "cells": 18,
   "mm": 854,
   "n": 887,
   "periods": {
    "1961-1990": 795,
    "1981-2010": 843,
    "1991-2020": 854
   },
   "seasons": {
    "djf": 239,
    "jja": 204,
    "mam": 171,
    "son": 240
   },
   "summer_half": 376,
   "winter_half": 479
  },
  "BS98": {
   "cells": 1,
   "mm": 856,
   "n": 1,
   "periods": {
    "1961-1990": 794,
    "1981-2010": 845,
    "1991-2020": 856
   },
   "seasons": {
    "djf": 248,
    "jja": 197,
    "mam": 171,
    "son": 241
   },
   "summer_half": 368,
   "winter_half": 488
  },
  "BS99": {
   "cells": 2,
   "mm": 889,
   "n": 89,
   "periods": {
    "1961-1990": 831,
    "1981-2010": 887,
    "1991-2020": 889
   },
   "seasons": {
    "djf": 257,
    "jja": 203,
    "mam": 178,
    "son": 251
   },
   "summer_half": 381,
   "winter_half": 508
  },
  "BT1": {
   "cells": 5,
   "mm": 740,
   "n": 367,
   "periods": {
    "1961-1990": 710,
    "1981-2010": 724,
    "1991-2020": 740
   },
   "seasons": {
    "djf": 181,
    "jja": 195,
    "mam": 144,
    "son": 219
   },
   "summer_half": 339,
   "winter_half": 401
  },
  "BT10": {
   "cells": 7,
   "mm": 726,
   "n": 209,
   "periods": {
    "1961-1990": 698,
    "1981-2010": 715,
    "1991-2020": 726
   },
   "seasons": {
    "djf": 184,
    "jja": 179,
    "mam": 150,
    "son": 213
   },
   "summer_half": 329,
   "winter_half": 397
  },
  "BT11": {
   "cells": 12,
   "mm": 718,
   "n": 475,
   "periods": {
    "1961-1990": 687,
    "1981-2010": 704,
    "1991-2020": 718
   },
   "seasons": {
    "djf": 184,
    "jja": 174,
    "mam": 147,
    "son": 213
   },
   "summer_half": 321,
   "winter_half": 397
  },
  "BT12": {
   "cells": 14,
   "mm": 721,
   "n": 631,
   "periods": {
    "1961-1990": 686,
    "1981-2010": 704,
    "1991-2020": 721
   },
   "seasons": {
    "djf": 179,
    "jja": 184,
    "mam": 144,
    "son": 214
   },
   "summer_half": 328,
   "winter_half": 394
  },
  "BT13": {
   "cells": 12,
   "mm": 742,
   "n": 565,
   "periods": {
    "1961-1990": 707,
    "1981-2010": 722,
    "1991-2020": 742
   },
   "seasons": {
    "djf": 182,
    "jja": 194,
    "mam": 146,
    "son": 219
   },
   "summer_half": 341,
   "winter_half": 401
  },
  "BT14": {
   "cells": 21,
   "mm": 753,
   "n": 636,
   "periods": {
    "1961-1990": 724,
    "1981-2010": 735,
    "1991-2020": 753
   },
   "seasons": {
    "djf": 187,
    "jja": 195,
    "mam": 146,
    "son": 225
   },
   "summer_half": 341,
   "winter_half": 412
  },
  "BT15": {
   "cells": 16,
   "mm": 760,
   "n": 614,
   "periods": {
    "1961-1990": 732,
    "1981-2010": 742,
    "1991-2020": 760
   },
   "seasons": {
    "djf": 195,
    "jja": 194,
    "mam": 142,
    "son": 229
   },
   "summer_half": 336,
   "winter_half": 424
  },
  "BT16": {
   "cells": 21,
   "mm": 736,
   "n": 401,
   "periods": {
    "1961-1990": 706,
    "1981-2010": 721,
    "1991-2020": 736
   },
   "seasons": {
    "djf": 182,
    "jja": 192,
    "mam": 145,
    "son": 218
   },
   "summer_half": 337,
   "winter_half": 399
  },
  "BT17": {
   "cells": 31,
   "mm": 762,
   "n": 568,
   "periods": {
    "1961-1990": 747,
    "1981-2010": 755,
    "1991-2020": 762
   },
   "seasons": {
    "djf": 199,
    "jja": 182,
    "mam": 158,
    "son": 222
   },
   "summer_half": 340,
   "winter_half": 422
  },
  "BT18": {
   "cells": 10,
   "mm": 755,
   "n": 389,
   "periods": {
    "1961-1990": 731,
    "1981-2010": 742,
    "1991-2020": 755
   },
   "seasons": {
    "djf": 188,
    "jja": 195,
    "mam": 148,
    "son": 224
   },
   "summer_half": 342,
   "winter_half": 412
  },
  "BT19": {
   "cells": 40,
   "mm": 822,
   "n": 876,
   "periods": {
    "1961-1990": 782,
    "1981-2010": 807,
    "1991-2020": 822
   },
   "seasons": {
    "djf": 202,
    "jja": 216,
    "mam": 163,
    "son": 241
   },
   "summer_half": 378,
   "winter_half": 443
  },
  "BT2": {
   "cells": 2,
   "mm": 730,
   "n": 108,
   "periods": {
    "1961-1990": 699,
    "1981-2010": 714,
    "1991-2020": 730
   },
   "seasons": {
    "djf": 178,
    "jja": 193,
    "mam": 143,
    "son": 216
   },
   "summer_half": 337,
   "winter_half": 393
  },
  "BT20": {
   "cells": 10,
   "mm": 857,
   "n": 670,
   "periods": {
    "1961-1990": 811,
    "1981-2010": 835,
    "1991-2020": 857
   },
   "seasons": {
    "djf": 212,
    "jja": 227,
    "mam": 168,
    "son": 250
   },
   "summer_half": 395,
   "winter_half": 462
  },
  "BT21": {
   "cells": 26,
   "mm": 804,
   "n": 244,
   "periods": {
    "1961-1990": 770,
    "1981-2010": 793,
    "1991-2020": 804
   },
   "seasons": {
    "djf": 195,
    "jja": 215,
    "mam": 162,
    "son": 232
   },
   "summer_half": 377,
   "winter_half": 426
  },
  "BT22": {
   "cells": 161,
   "mm": 768,
   "n": 583,
   "periods": {
    "1961-1990": 752,
    "1981-2010": 756,
    "1991-2020": 768
   },
   "seasons": {
    "djf": 189,
    "jja": 205,
    "mam": 155,
    "son": 219
   },
   "summer_half": 360,
   "winter_half": 408
  },
  "BT23": {
   "cells": 180,
   "mm": 743,
   "n": 1459,
   "periods": {
    "1961-1990": 718,
    "1981-2010": 730,
    "1991-2020": 743
   },
   "seasons": {
    "djf": 180,
    "jja": 196,
    "mam": 149,
    "son": 217
   },
   "summer_half": 346,
   "winter_half": 397
  },
  "BT24": {
   "cells": 147,
   "mm": 731,
   "n": 501,
   "periods": {
    "1961-1990": 709,
    "1981-2010": 724,
    "1991-2020": 731
   },
   "seasons": {
    "djf": 184,
    "jja": 186,
    "mam": 153,
    "son": 207
   },
   "summer_half": 339,
   "winter_half": 391
  },
  "BT25": {
   "cells": 146,
   "mm": 1034,
   "n": 442,
   "periods": {
    "1961-1990": 1004,
    "1981-2010": 1034,
    "1991-2020": 1034
   },
   "seasons": {
    "djf": 288,
    "jja": 230,
    "mam": 214,
    "son": 302
   },
   "summer_half": 444,
   "winter_half": 590
  },
  "BT26": {
   "cells": 70,
   "mm": 949,
   "n": 268,
   "periods": {
    "1961-1990": 923,
    "1981-2010": 944,
    "1991-2020": 949
   },
   "seasons": {
    "djf": 255,
    "jja": 218,
    "mam": 197,
    "son": 278
   },
   "summer_half": 416,
   "winter_half": 533
  },
  "BT27": {
   "cells": 90,
   "mm": 814,
   "n": 582,
   "periods": {
    "1961-1990": 775,
    "1981-2010": 797,
    "1991-2020": 814
   },
   "seasons": {
    "djf": 213,
    "jja": 199,
    "mam": 168,
    "son": 234
   },
   "summer_half": 367,
   "winter_half": 447
  },
  "BT28": {
   "cells": 112,
   "mm": 917,
   "n": 1024,
   "periods": {
    "1961-1990": 871,
    "1981-2010": 902,
    "1991-2020": 917
   },
   "seasons": {
    "djf": 240,
    "jja": 225,
    "mam": 183,
    "son": 270
   },
   "summer_half": 408,
   "winter_half": 510
  },
  "BT29": {
   "cells": 96,
   "mm": 836,
   "n": 376,
   "periods": {
    "1961-1990": 808,
    "1981-2010": 827,
    "1991-2020": 836
   },
   "seasons": {
    "djf": 216,
    "jja": 209,
    "mam": 163,
    "son": 249
   },
   "summer_half": 371,
   "winter_half": 465
  },
  "BT3": {
   "cells": 17,
   "mm": 750,
   "n": 95,
   "periods": {
    "1961-1990": 730,
    "1981-2010": 736,
    "1991-2020": 750
   },
   "seasons": {
    "djf": 193,
    "jja": 190,
    "mam": 142,
    "son": 225
   },
   "summer_half": 332,
   "winter_half": 418
  },
  "BT30": {
   "cells": 306,
   "mm": 718,
   "n": 1101,
   "periods": {
    "1961-1990": 696,
    "1981-2010": 708,
    "1991-2020": 718
   },
   "seasons": {
    "djf": 178,
    "jja": 186,
    "mam": 149,
    "son": 205
   },
   "summer_half": 336,
   "winter_half": 383
  },
  "BT31": {
   "cells": 120,
   "mm": 876,
   "n": 291,
   "periods": {
    "1961-1990": 838,
    "1981-2010": 865,
    "1991-2020": 876
   },
   "seasons": {
    "djf": 245,
    "jja": 197,
    "mam": 187,
    "son": 246
   },
   "summer_half": 385,
   "winter_half": 491
  },
  "BT32": {
   "cells": 181,
   "mm": 1207,
   "n": 712,
   "periods": {
    "1961-1990": 1137,
    "1981-2010": 1202,
    "1991-2020": 1207
   },
   "seasons": {
    "djf": 358,
    "jja": 262,
    "mam": 248,
    "son": 340
   },
   "summer_half": 510,
   "winter_half": 698
  },
  "BT33": {
   "cells": 39,
   "mm": 763,
   "n": 313,
   "periods": {
    "1961-1990": 730,
    "1981-2010": 753,
    "1991-2020": 763
   },
   "seasons": {
    "djf": 203,
    "jja": 186,
    "mam": 162,
    "son": 213
   },
   "summer_half": 347,
   "winter_half": 416
  },
  "BT34": {
   "cells": 365,
   "mm": 1126,
   "n": 1510,
   "periods": {
    "1961-1990": 1050,
    "1981-2010": 1107,
    "1991-2020": 1126
   },
   "seasons": {
    "djf": 339,
    "jja": 242,
    "mam": 229,
    "son": 316
   },
   "summer_half": 471,
   "winter_half": 655
  },
  "BT35": {
   "cells": 360,
   "mm": 1886,
   "n": 1262,
   "periods": {
    "1961-1990": 1750,
    "1981-2010": 1849,
    "1991-2020": 1886
   },
   "seasons": {
    "djf": 637,
    "jja": 349,
    "mam": 363,
    "son": 537
   },
   "summer_half": 711,
   "winter_half": 1175
  },
  "BT36": {
   "cells": 51,
   "mm": 805,
   "n": 1051,
   "periods": {
    "1961-1990": 771,
    "1981-2010": 785,
    "1991-2020": 805
   },
   "seasons": {
    "djf": 201,
    "jja": 206,
    "mam": 156,
    "son": 242
   },
   "summer_half": 362,
   "winter_half": 442
  },
  "BT37": {
   "cells": 14,
   "mm": 816,
   "n": 595,
   "periods": {
    "1961-1990": 780,
    "1981-2010": 798,
    "1991-2020": 816
   },
   "seasons": {
    "djf": 207,
    "jja": 206,
    "mam": 160,
    "son": 244
   },
   "summer_half": 366,
   "winter_half": 451
  },
  "BT38": {
   "cells": 69,
   "mm": 913,
   "n": 924,
   "periods": {
    "1961-1990": 859,
    "1981-2010": 892,
    "1991-2020": 913
   },
   "seasons": {
    "djf": 236,
    "jja": 232,
    "mam": 175,
    "son": 270
   },
   "summer_half": 407,
   "winter_half": 506
  },
  "BT39": {
   "cells": 94,
   "mm": 787,
   "n": 634,
   "periods": {
    "1961-1990": 758,
    "1981-2010": 772,
    "1991-2020": 787
   },
   "seasons": {
    "djf": 199,
    "jja": 200,
    "mam": 152,
    "son": 236
   },
   "summer_half": 352,
   "winter_half": 435
  },
  "BT4": {
   "cells": 16,
   "mm": 752,
   "n": 641,
   "periods": {
    "1961-1990": 732,
    "1981-2010": 740,
    "1991-2020": 752
   },
   "seasons": {
    "djf": 185,
    "jja": 195,
    "mam": 148,
    "son": 223
   },
   "summer_half": 344,
   "winter_half": 409
  },
  "BT40": {
   "cells": 117,
   "mm": 904,
   "n": 731,
   "periods": {
    "1961-1990": 858,
    "1981-2010": 889,
    "1991-2020": 904
   },
   "seasons": {
    "djf": 235,
    "jja": 226,
    "mam": 168,
    "son": 276
   },
   "summer_half": 393,
   "winter_half": 511
  },
  "BT41": {
   "cells": 3,
   "mm": 820,
   "n": 1055,
   "periods": {
    "1961-1990": 782,
    "1981-2010": 807,
    "1991-2020": 820
   },
   "seasons": {
    "djf": 208,
    "jja": 207,
    "mam": 155,
    "son": 250
   },
   "summer_half": 362,
   "winter_half": 458
  },
  "BT44": {
   "cells": 23,
   "mm": 847,
   "n": 694,
   "periods": {
    "1961-1990": 831,
    "1981-2010": 837,
    "1991-2020": 847
   },
   "seasons": {
    "djf": 224,
    "jja": 204,
    "mam": 157,
    "son": 262
   },
   "summer_half": 361,
   "winter_half": 486
  },
  "BT45": {
   "cells": 10,
   "mm": 866,
   "n": 1019,
   "periods": {
    "1961-1990": 789,
    "1981-2010": 833,
    "1991-2020": 866
   },
   "seasons": {
    "djf": 248,
    "jja": 190,
    "mam": 162,
    "son": 266
   },
   "summer_half": 352,
   "winter_half": 514
  },
  "BT5": {
   "cells": 26,
   "mm": 751,
   "n": 841,
   "periods": {
    "1961-1990": 726,
    "1981-2010": 736,
    "1991-2020": 751
   },
   "seasons": {
    "djf": 183,
    "jja": 198,
    "mam": 147,
    "son": 222
   },
   "summer_half": 346,
   "winter_half": 405
  },
  "BT6": {
   "cells": 20,
   "mm": 740,
   "n": 559,
   "periods": {
    "1961-1990": 710,
    "1981-2010": 724,
    "1991-2020": 740
   },
   "seasons": {
    "djf": 180,
    "jja": 196,
    "mam": 146,
    "son": 218
   },
   "summer_half": 342,
   "winter_half": 398
  },
  "BT60": {
   "cells": 360,
   "mm": 1937,
   "n": 954,
   "periods": {
    "1961-1990": 1804,
    "1981-2010": 1902,
    "1991-2020": 1937
   },
   "seasons": {
    "djf": 647,
    "jja": 370,
    "mam": 368,
    "son": 552
   },
   "summer_half": 738,
   "winter_half": 1199
  },
  "BT61": {
   "cells": 105,
   "mm": 1690,
   "n": 470,
   "periods": {
    "1961-1990": 1549,
    "1981-2010": 1661,
    "1991-2020": 1690
   },
   "seasons": {
    "djf": 555,
    "jja": 328,
    "mam": 314,
    "son": 493
   },
   "summer_half": 643,
   "winter_half": 1048
  },
  "BT62": {
   "cells": 163,
   "mm": 1323,
   "n": 767,
   "periods": {
    "1961-1990": 1247,
    "1981-2010": 1310,
    "1991-2020": 1323
   },
   "seasons": {
    "djf": 418,
    "jja": 268,
    "mam": 252,
    "son": 385
   },
   "summer_half": 521,
   "winter_half": 803
  },
  "BT63": {
   "cells": 90,
   "mm": 1121,
   "n": 507,
   "periods": {
    "1961-1990": 1080,
    "1981-2010": 1122,
    "1991-2020": 1121
   },
   "seasons": {
    "djf": 343,
    "jja": 236,
    "mam": 220,
    "son": 321
   },
   "summer_half": 457,
   "winter_half": 664
  },
  "BT64": {
   "cells": 4,
   "mm": 1159,
   "n": 83,
   "periods": {
    "1961-1990": 1109,
    "1981-2010": 1160,
    "1991-2020": 1159
   },
   "seasons": {
    "djf": 364,
    "jja": 229,
    "mam": 238,
    "son": 328
   },
   "summer_half": 467,
   "winter_half": 692
  },
  "BT65": {
   "cells": 7,
   "mm": 1159,
   "n": 108,
   "periods": {
    "1961-1990": 1115,
    "1981-2010": 1164,
    "1991-2020": 1159
   },
   "seasons": {
    "djf": 362,
    "jja": 231,
    "mam": 239,
    "son": 328
   },
   "summer_half": 470,
   "winter_half": 689
  },
  "BT66": {
   "cells": 81,
   "mm": 1003,
   "n": 780,
   "periods": {
    "1961-1990": 965,
    "1981-2010": 1006,
    "1991-2020": 1003
   },
   "seasons": {
    "djf": 305,
    "jja": 210,
    "mam": 199,
    "son": 289
   },
   "summer_half": 409,
   "winter_half": 595
  },
  "BT67": {
   "cells": 98,
   "mm": 892,
   "n": 506,
   "periods": {
    "1961-1990": 841,
    "1981-2010": 885,
    "1991-2020": 892
   },
   "seasons": {
    "djf": 248,
    "jja": 207,
    "mam": 172,
    "son": 265
   },
   "summer_half": 379,
   "winter_half": 513
  },
  "BT68": {
   "cells": 22,
   "mm": 2460,
   "n": 50,
   "periods": {
    "1961-1990": 2310,
    "1981-2010": 2394,
    "1991-2020": 2460
   },
   "seasons": {
    "djf": 768,
    "jja": 528,
    "mam": 466,
    "son": 698
   },
   "summer_half": 994,
   "winter_half": 1466
  },
  "BT69": {
   "cells": 45,
   "mm": 3091,
   "n": 91,
   "periods": {
    "1961-1990": 2904,
    "1981-2010": 3005,
    "1991-2020": 3091
   },
   "seasons": {
    "djf": 988,
    "jja": 637,
    "mam": 574,
    "son": 891
   },
   "summer_half": 1211,
   "winter_half": 1880
  },
  "BT7": {
   "cells": 8,
   "mm": 725,
   "n": 390,
   "periods": {
    "1961-1990": 694,
    "1981-2010": 710,
    "1991-2020": 725
   },
   "seasons": {
    "djf": 177,
    "jja": 190,
    "mam": 144,
    "son": 214
   },
   "summer_half": 333,
   "winter_half": 392
  },
  "BT70": {
   "cells": 265,
   "mm": 2258,
   "n": 648,
   "periods": {
    "1961-1990": 2124,
    "1981-2010": 2214,
    "1991-2020": 2258
   },
   "seasons": {
    "djf": 720,
    "jja": 444,
    "mam": 420,
    "son": 674
   },
   "summer_half": 864,
   "winter_half": 1394
  },
  "BT71": {
   "cells": 262,
   "mm": 1388,
   "n": 1065,
   "periods": {
    "1961-1990": 1316,
    "1981-2010": 1376,
    "1991-2020": 1388
   },
   "seasons": {
    "djf": 438,
    "jja": 274,
    "mam": 262,
    "son": 414
   },
   "summer_half": 537,
   "winter_half": 852
  },
  "BT74": {
   "cells": 8,
   "mm": 1048,
   "n": 751,
   "periods": {
    "1961-1990": 1047,
    "1981-2010": 1033,
    "1991-2020": 1048
   },
   "seasons": {
    "djf": 290,
    "jja": 219,
    "mam": 201,
    "son": 338
   },
   "summer_half": 420,
   "winter_half": 628
  },
  "BT75": {
   "cells": 65,
   "mm": 1671,
   "n": 136,
   "periods": {
    "1961-1990": 1597,
    "1981-2010": 1654,
    "1991-2020": 1671
   },
   "seasons": {
    "djf": 477,
    "jja": 367,
    "mam": 310,
    "son": 516
   },
   "summer_half": 678,
   "winter_half": 993
  },
  "BT76": {
   "cells": 52,
   "mm": 2209,
   "n": 75,
   "periods": {
    "1961-1990": 2135,
    "1981-2010": 2182,
    "1991-2020": 2209
   },
   "seasons": {
    "djf": 644,
    "jja": 483,
    "mam": 406,
    "son": 676
   },
   "summer_half": 889,
   "winter_half": 1319
  },
  "BT77": {
   "cells": 31,
   "mm": 2796,
   "n": 50,
   "periods": {
    "1961-1990": 2690,
    "1981-2010": 2768,
    "1991-2020": 2796
   },
   "seasons": {
    "djf": 830,
    "jja": 597,
    "mam": 536,
    "son": 833
   },
   "summer_half": 1133,
   "winter_half": 1663
  },
  "BT78": {
   "cells": 274,
   "mm": 1115,
   "n": 1158,
   "periods": {
    "1961-1990": 1091,
    "1981-2010": 1113,
    "1991-2020": 1115
   },
   "seasons": {
    "djf": 310,
    "jja": 236,
    "mam": 212,
    "son": 357
   },
   "summer_half": 448,
   "winter_half": 667
  },
  "BT79": {
   "cells": 257,
   "mm": 1290,
   "n": 936,
   "periods": {
    "1961-1990": 1245,
    "1981-2010": 1276,
    "1991-2020": 1290
   },
   "seasons": {
    "djf": 367,
    "jja": 271,
    "mam": 240,
    "son": 412
   },
   "summer_half": 511,
   "winter_half": 779
  },
  "BT8": {
   "cells": 47,
   "mm": 724,
   "n": 650,
   "periods": {
    "1961-1990": 694,
    "1981-2010": 712,
    "1991-2020": 724
   },
   "seasons": {
    "djf": 179,
    "jja": 188,
    "mam": 146,
    "son": 210
   },
   "summer_half": 334,
   "winter_half": 389
  },
  "BT80": {
   "cells": 112,
   "mm": 1012,
   "n": 669,
   "periods": {
    "1961-1990": 958,
    "1981-2010": 986,
    "1991-2020": 1012
   },
   "seasons": {
    "djf": 301,
    "jja": 209,
    "mam": 191,
    "son": 312
   },
   "summer_half": 400,
   "winter_half": 612
  },
  "BT81": {
   "cells": 44,
   "mm": 893,
   "n": 296,
   "periods": {
    "1961-1990": 878,
    "1981-2010": 887,
    "1991-2020": 893
   },
   "seasons": {
    "djf": 244,
    "jja": 188,
    "mam": 173,
    "son": 288
   },
   "summer_half": 360,
   "winter_half": 532
  },
  "BT82": {
   "cells": 49,
   "mm": 1027,
   "n": 713,
   "periods": {
    "1961-1990": 1001,
    "1981-2010": 1021,
    "1991-2020": 1027
   },
   "seasons": {
    "djf": 294,
    "jja": 206,
    "mam": 199,
    "son": 327
   },
   "summer_half": 406,
   "winter_half": 621
  },
  "BT9": {
   "cells": 16,
   "mm": 719,
   "n": 589,
   "periods": {
    "1961-1990": 688,
    "1981-2010": 706,
    "1991-2020": 719
   },
   "seasons": {
    "djf": 179,
    "jja": 182,
    "mam": 146,
    "son": 213
   },
   "summer_half": 327,
   "winter_half": 392
  },
  "BT92": {
   "cells": 139,
   "mm": 1109,
   "n": 1295,
   "periods": {
    "1961-1990": 1054,
    "1981-2010": 1079,
    "1991-2020": 1109
   },
   "seasons": {
    "djf": 307,
    "jja": 233,
    "mam": 212,
    "son": 356
   },
   "summer_half": 446,
   "winter_half": 663
  },
  "BT94": {
   "cells": 121,
   "mm": 1234,
   "n": 897,
   "periods": {
    "1961-1990": 1196,
    "1981-2010": 1210,
    "1991-2020": 1234
   },
   "seasons": {
    "djf": 339,
    "jja": 269,
    "mam": 239,
    "son": 387
   },
   "summer_half": 508,
   "winter_half": 726
  },
  "CA1": {
   "cells": 17,
   "mm": 836,
   "n": 674,
   "periods": {
    "1961-1990": 807,
    "1981-2010": 813,
    "1991-2020": 836
   },
   "seasons": {
    "djf": 222,
    "jja": 227,
    "mam": 150,
    "son": 238
   },
   "summer_half": 376,
   "winter_half": 459
  },
  "CA10": {
   "cells": 250,
   "mm": 1237,
   "n": 692,
   "periods": {
    "1961-1990": 1121,
    "1981-2010": 1184,
    "1991-2020": 1237
   },
   "seasons": {
    "djf": 401,
    "jja": 263,
    "mam": 219,
    "son": 354
   },
   "summer_half": 481,
   "winter_half": 755
  },
  "CA11": {
   "cells": 187,
   "mm": 1283,
   "n": 1114,
   "periods": {
    "1961-1990": 1188,
    "1981-2010": 1241,
    "1991-2020": 1283
   },
   "seasons": {
    "djf": 412,
    "jja": 265,
    "mam": 234,
    "son": 371
   },
   "summer_half": 499,
   "winter_half": 783
  },
  "CA12": {
   "cells": 71,
   "mm": 1909,
   "n": 469,
   "periods": {
    "1961-1990": 1733,
    "1981-2010": 1827,
    "1991-2020": 1909
   },
   "seasons": {
    "djf": 619,
    "jja": 379,
    "mam": 335,
    "son": 576
   },
   "summer_half": 714,
   "winter_half": 1195
  },
  "CA13": {
   "cells": 99,
   "mm": 1347,
   "n": 614,
   "periods": {
    "1961-1990": 1229,
    "1981-2010": 1291,
    "1991-2020": 1347
   },
   "seasons": {
    "djf": 385,
    "jja": 297,
    "mam": 242,
    "son": 423
   },
   "summer_half": 539,
   "winter_half": 808
  },
  "CA14": {
   "cells": 79,
   "mm": 1238,
   "n": 1307,
   "periods": {
    "1961-1990": 1147,
    "1981-2010": 1197,
    "1991-2020": 1238
   },
   "seasons": {
    "djf": 337,
    "jja": 286,
    "mam": 228,
    "son": 386
   },
   "summer_half": 514,
   "winter_half": 724
  },
  "CA15": {
   "cells": 44,
   "mm": 1061,
   "n": 576,
   "periods": {
    "1961-1990": 958,
    "1981-2010": 1010,
    "1991-2020": 1061
   },
   "seasons": {
    "djf": 284,
    "jja": 253,
    "mam": 196,
    "son": 329
   },
   "summer_half": 448,
   "winter_half": 613
  },
  "CA16": {
   "cells": 82,
   "mm": 1059,
   "n": 267,
   "periods": {
    "1961-1990": 956,
    "1981-2010": 1005,
    "1991-2020": 1059
   },
   "seasons": {
    "djf": 333,
    "jja": 243,
    "mam": 184,
    "son": 300
   },
   "summer_half": 427,
   "winter_half": 633
  },
  "CA17": {
   "cells": 76,
   "mm": 1233,
   "n": 230,
   "periods": {
    "1961-1990": 1127,
    "1981-2010": 1190,
    "1991-2020": 1233
   },
   "seasons": {
    "djf": 404,
    "jja": 268,
    "mam": 218,
    "son": 343
   },
   "summer_half": 487,
   "winter_half": 746
  },
  "CA18": {
   "cells": 7,
   "mm": 1507,
   "n": 25,
   "periods": {
    "1961-1990": 1424,
    "1981-2010": 1448,
    "1991-2020": 1507
   },
   "seasons": {
    "djf": 432,
    "jja": 336,
    "mam": 269,
    "son": 470
   },
   "summer_half": 605,
   "winter_half": 902
  },
  "CA19": {
   "cells": 33,
   "mm": 1567,
   "n": 68,
   "periods": {
    "1961-1990": 1474,
    "1981-2010": 1505,
    "1991-2020": 1567
   },
   "seasons": {
    "djf": 444,
    "jja": 352,
    "mam": 280,
    "son": 490
   },
   "summer_half": 632,
   "winter_half": 934
  },
  "CA2": {
   "cells": 28,
   "mm": 837,
   "n": 954,
   "periods": {
    "1961-1990": 802,
    "1981-2010": 811,
    "1991-2020": 837
   },
   "seasons": {
    "djf": 218,
    "jja": 231,
    "mam": 149,
    "son": 239
   },
   "summer_half": 380,
   "winter_half": 457
  },
  "CA20": {
   "cells": 36,
   "mm": 1383,
   "n": 196,
   "periods": {
    "1961-1990": 1254,
    "1981-2010": 1301,
    "1991-2020": 1383
   },
   "seasons": {
    "djf": 377,
    "jja": 325,
    "mam": 246,
    "son": 434
   },
   "summer_half": 571,
   "winter_half": 811
  },
  "CA21": {
   "cells": 6,
   "mm": 1227,
   "n": 37,
   "periods": {
    "1961-1990": 1111,
    "1981-2010": 1163,
    "1991-2020": 1227
   },
   "seasons": {
    "djf": 332,
    "jja": 284,
    "mam": 216,
    "son": 395
   },
   "summer_half": 500,
   "winter_half": 727
  },
  "CA22": {
   "cells": 34,
   "mm": 1353,
   "n": 267,
   "periods": {
    "1961-1990": 1269,
    "1981-2010": 1302,
    "1991-2020": 1353
   },
   "seasons": {
    "djf": 370,
    "jja": 314,
    "mam": 243,
    "son": 426
   },
   "summer_half": 557,
   "winter_half": 796
  },
  "CA23": {
   "cells": 15,
   "mm": 1649,
   "n": 73,
   "periods": {
    "1961-1990": 1570,
    "1981-2010": 1596,
    "1991-2020": 1649
   },
   "seasons": {
    "djf": 464,
    "jja": 373,
    "mam": 302,
    "son": 510
   },
   "summer_half": 675,
   "winter_half": 974
  },
  "CA24": {
   "cells": 5,
   "mm": 1202,
   "n": 38,
   "periods": {
    "1961-1990": 1197,
    "1981-2010": 1179,
    "1991-2020": 1202
   },
   "seasons": {
    "djf": 320,
    "jja": 285,
    "mam": 221,
    "son": 377
   },
   "summer_half": 505,
   "winter_half": 696
  },
  "CA25": {
   "cells": 11,
   "mm": 1339,
   "n": 227,
   "periods": {
    "1961-1990": 1307,
    "1981-2010": 1304,
    "1991-2020": 1339
   },
   "seasons": {
    "djf": 363,
    "jja": 310,
    "mam": 245,
    "son": 420
   },
   "summer_half": 555,
   "winter_half": 784
  },
  "CA26": {
   "cells": 15,
   "mm": 1455,
   "n": 116,
   "periods": {
    "1961-1990": 1371,
    "1981-2010": 1407,
    "1991-2020": 1455
   },
   "seasons": {
    "djf": 389,
    "jja": 339,
    "mam": 269,
    "son": 458
   },
   "summer_half": 608,
   "winter_half": 847
  },
  "CA27": {
   "cells": 4,
   "mm": 1071,
   "n": 56,
   "periods": {
    "1961-1990": 1087,
    "1981-2010": 1079,
    "1991-2020": 1071
   },
   "seasons": {
    "djf": 288,
    "jja": 251,
    "mam": 196,
    "son": 337
   },
   "summer_half": 447,
   "winter_half": 624
  },
  "CA28": {
   "cells": 32,
   "mm": 1185,
   "n": 966,
   "periods": {
    "1961-1990": 1131,
    "1981-2010": 1148,
    "1991-2020": 1185
   },
   "seasons": {
    "djf": 314,
    "jja": 281,
    "mam": 217,
    "son": 373
   },
   "summer_half": 498,
   "winter_half": 687
  },
  "CA3": {
   "cells": 19,
   "mm": 875,
   "n": 535,
   "periods": {
    "1961-1990": 827,
    "1981-2010": 841,
    "1991-2020": 875
   },
   "seasons": {
    "djf": 234,
    "jja": 235,
    "mam": 159,
    "son": 248
   },
   "summer_half": 394,
   "winter_half": 482
  },
  "CA4": {
   "cells": 138,
   "mm": 926,
   "n": 477,
   "periods": {
    "1961-1990": 879,
    "1981-2010": 899,
    "1991-2020": 926
   },
   "seasons": {
    "djf": 263,
    "jja": 235,
    "mam": 165,
    "son": 263
   },
   "summer_half": 400,
   "winter_half": 525
  },
  "CA5": {
   "cells": 116,
   "mm": 922,
   "n": 354,
   "periods": {
    "1961-1990": 862,
    "1981-2010": 887,
    "1991-2020": 922
   },
   "seasons": {
    "djf": 254,
    "jja": 237,
    "mam": 166,
    "son": 265
   },
   "summer_half": 404,
   "winter_half": 518
  },
  "CA6": {
   "cells": 228,
   "mm": 1031,
   "n": 518,
   "periods": {
    "1961-1990": 962,
    "1981-2010": 995,
    "1991-2020": 1031
   },
   "seasons": {
    "djf": 282,
    "jja": 265,
    "mam": 193,
    "son": 291
   },
   "summer_half": 458,
   "winter_half": 573
  },
  "CA7": {
   "cells": 329,
   "mm": 1050,
   "n": 1227,
   "periods": {
    "1961-1990": 968,
    "1981-2010": 1009,
    "1991-2020": 1050
   },
   "seasons": {
    "djf": 294,
    "jja": 256,
    "mam": 191,
    "son": 310
   },
   "summer_half": 446,
   "winter_half": 604
  },
  "CA8": {
   "cells": 177,
   "mm": 1027,
   "n": 616,
   "periods": {
    "1961-1990": 983,
    "1981-2010": 1001,
    "1991-2020": 1027
   },
   "seasons": {
    "djf": 285,
    "jja": 259,
    "mam": 194,
    "son": 288
   },
   "summer_half": 453,
   "winter_half": 573
  },
  "CA9": {
   "cells": 48,
   "mm": 1388,
   "n": 177,
   "periods": {
    "1961-1990": 1258,
    "1981-2010": 1350,
    "1991-2020": 1388
   },
   "seasons": {
    "djf": 449,
    "jja": 285,
    "mam": 261,
    "son": 392
   },
   "summer_half": 547,
   "winter_half": 842
  },
  "CA95": {
   "cells": 1,
   "mm": 1015,
   "n": 4,
   "periods": {
    "1961-1990": 945,
    "1981-2010": 982,
    "1991-2020": 1015
   },
   "seasons": {
    "djf": 278,
    "jja": 226,
    "mam": 185,
    "son": 326
   },
   "summer_half": 411,
   "winter_half": 604
  },
  "CB1": {
   "cells": 22,
   "mm": 560,
   "n": 1158,
   "periods": {
    "1961-1990": 544,
    "1981-2010": 564,
    "1991-2020": 560
   },
   "seasons": {
    "djf": 134,
    "jja": 158,
    "mam": 111,
    "son": 157
   },
   "summer_half": 269,
   "winter_half": 291
  },
  "CB10": {
   "cells": 98,
   "mm": 617,
   "n": 576,
   "periods": {
    "1961-1990": 592,
    "1981-2010": 615,
    "1991-2020": 617
   },
   "seasons": {
    "djf": 153,
    "jja": 167,
    "mam": 121,
    "son": 175
   },
   "summer_half": 288,
   "winter_half": 329
  },
  "CB11": {
   "cells": 86,
   "mm": 638,
   "n": 551,
   "periods": {
    "1961-1990": 604,
    "1981-2010": 636,
    "1991-2020": 638
   },
   "seasons": {
    "djf": 163,
    "jja": 166,
    "mam": 126,
    "son": 182
   },
   "summer_half": 292,
   "winter_half": 346
  },
  "CB2": {
   "cells": 18,
   "mm": 564,
   "n": 587,
   "periods": {
    "1961-1990": 551,
    "1981-2010": 571,
    "1991-2020": 564
   },
   "seasons": {
    "djf": 132,
    "jja": 161,
    "mam": 112,
    "son": 159
   },
   "summer_half": 273,
   "winter_half": 291
  },
  "CB21": {
   "cells": 89,
   "mm": 599,
   "n": 446,
   "periods": {
    "1961-1990": 571,
    "1981-2010": 598,
    "1991-2020": 599
   },
   "seasons": {
    "djf": 145,
    "jja": 168,
    "mam": 117,
    "son": 170
   },
   "summer_half": 285,
   "winter_half": 314
  },
  "CB22": {
   "cells": 71,
   "mm": 563,
   "n": 610,
   "periods": {
    "1961-1990": 538,
    "1981-2010": 561,
    "1991-2020": 563
   },
   "seasons": {
    "djf": 130,
    "jja": 158,
    "mam": 112,
    "son": 163
   },
   "summer_half": 270,
   "winter_half": 293
  },
  "CB23": {
   "cells": 126,
   "mm": 583,
   "n": 884,
   "periods": {
    "1961-1990": 563,
    "1981-2010": 581,
    "1991-2020": 583
   },
   "seasons": {
    "djf": 138,
    "jja": 159,
    "mam": 118,
    "son": 167
   },
   "summer_half": 278,
   "winter_half": 305
  },
  "CB24": {
   "cells": 86,
   "mm": 557,
   "n": 816,
   "periods": {
    "1961-1990": 529,
    "1981-2010": 550,
    "1991-2020": 557
   },
   "seasons": {
    "djf": 132,
    "jja": 154,
    "mam": 115,
    "son": 157
   },
   "summer_half": 268,
   "winter_half": 288
  },
  "CB25": {
   "cells": 63,
   "mm": 562,
   "n": 422,
   "periods": {
    "1961-1990": 540,
    "1981-2010": 561,
    "1991-2020": 562
   },
   "seasons": {
    "djf": 131,
    "jja": 161,
    "mam": 112,
    "son": 158
   },
   "summer_half": 273,
   "winter_half": 289
  },
  "CB3": {
   "cells": 22,
   "mm": 570,
   "n": 411,
   "periods": {
    "1961-1990": 554,
    "1981-2010": 575,
    "1991-2020": 570
   },
   "seasons": {
    "djf": 136,
    "jja": 156,
    "mam": 117,
    "son": 161
   },
   "summer_half": 273,
   "winter_half": 297
  },
  "CB4": {
   "cells": 16,
   "mm": 569,
   "n": 905,
   "periods": {
    "1961-1990": 552,
    "1981-2010": 573,
    "1991-2020": 569
   },
   "seasons": {
    "djf": 136,
    "jja": 155,
    "mam": 118,
    "son": 160
   },
   "summer_half": 273,
   "winter_half": 297
  },
  "CB5": {
   "cells": 14,
   "mm": 569,
   "n": 279,
   "periods": {
    "1961-1990": 553,
    "1981-2010": 574,
    "1991-2020": 569
   },
   "seasons": {
    "djf": 136,
    "jja": 158,
    "mam": 115,
    "son": 161
   },
   "summer_half": 273,
   "winter_half": 297
  },
  "CB6": {
   "cells": 148,
   "mm": 582,
   "n": 922,
   "periods": {
    "1961-1990": 550,
    "1981-2010": 576,
    "1991-2020": 582
   },
   "seasons": {
    "djf": 135,
    "jja": 169,
    "mam": 115,
    "son": 163
   },
   "summer_half": 284,
   "winter_half": 298
  },
  "CB7": {
   "cells": 113,
   "mm": 570,
   "n": 746,
   "periods": {
    "1961-1990": 543,
    "1981-2010": 570,
    "1991-2020": 570
   },
   "seasons": {
    "djf": 136,
    "jja": 161,
    "mam": 115,
    "son": 159
   },
   "summer_half": 276,
   "winter_half": 294
  },
  "CB8": {
   "cells": 189,
   "mm": 610,
   "n": 1072,
   "periods": {
    "1961-1990": 596,
    "1981-2010": 617,
    "1991-2020": 610
   },
   "seasons": {
    "djf": 149,
    "jja": 170,
    "mam": 122,
    "son": 169
   },
   "summer_half": 292,
   "winter_half": 318
  },
  "CB9": {
   "cells": 68,
   "mm": 623,
   "n": 842,
   "periods": {
    "1961-1990": 587,
    "1981-2010": 620,
    "1991-2020": 623
   },
   "seasons": {
    "djf": 154,
    "jja": 171,
    "mam": 122,
    "son": 175
   },
   "summer_half": 293,
   "winter_half": 330
  },
  "CF10": {
   "cells": 12,
   "mm": 1138,
   "n": 631,
   "periods": {
    "1961-1990": 1020,
    "1981-2010": 1098,
    "1991-2020": 1138
   },
   "seasons": {
    "djf": 335,
    "jja": 254,
    "mam": 223,
    "son": 326
   },
   "summer_half": 477,
   "winter_half": 662
  },
  "CF11": {
   "cells": 19,
   "mm": 1149,
   "n": 868,
   "periods": {
    "1961-1990": 1043,
    "1981-2010": 1115,
    "1991-2020": 1149
   },
   "seasons": {
    "djf": 338,
    "jja": 256,
    "mam": 224,
    "son": 331
   },
   "summer_half": 480,
   "winter_half": 669
  },
  "CF14": {
   "cells": 41,
   "mm": 1279,
   "n": 1658,
   "periods": {
    "1961-1990": 1164,
    "1981-2010": 1254,
    "1991-2020": 1279
   },
   "seasons": {
    "djf": 389,
    "jja": 274,
    "mam": 248,
    "son": 367
   },
   "summer_half": 522,
   "winter_half": 756
  },
  "CF15": {
   "cells": 35,
   "mm": 1414,
   "n": 511,
   "periods": {
    "1961-1990": 1298,
    "1981-2010": 1392,
    "1991-2020": 1414
   },
   "seasons": {
    "djf": 433,
    "jja": 300,
    "mam": 270,
    "son": 411
   },
   "summer_half": 570,
   "winter_half": 843
  },
  "CF23": {
   "cells": 21,
   "mm": 1199,
   "n": 910,
   "periods": {
    "1961-1990": 1079,
    "1981-2010": 1165,
    "1991-2020": 1199
   },
   "seasons": {
    "djf": 359,
    "jja": 265,
    "mam": 232,
    "son": 343
   },
   "summer_half": 497,
   "winter_half": 702
  },
  "CF24": {
   "cells": 17,
   "mm": 1145,
   "n": 1054,
   "periods": {
    "1961-1990": 1021,
    "1981-2010": 1103,
    "1991-2020": 1145
   },
   "seasons": {
    "djf": 339,
    "jja": 257,
    "mam": 224,
    "son": 325
   },
   "summer_half": 481,
   "winter_half": 665
  },
  "CF3": {
   "cells": 34,
   "mm": 1158,
   "n": 922,
   "periods": {
    "1961-1990": 1047,
    "1981-2010": 1130,
    "1991-2020": 1158
   },
   "seasons": {
    "djf": 352,
    "jja": 250,
    "mam": 221,
    "son": 335
   },
   "summer_half": 471,
   "winter_half": 686
  },
  "CF30": {
   "cells": 1,
   "mm": 1193,
   "n": 10,
   "periods": {
    "1961-1990": 1076,
    "1981-2010": 1163,
    "1991-2020": 1193
   },
   "seasons": {
    "djf": 361,
    "jja": 261,
    "mam": 227,
    "son": 344
   },
   "summer_half": 488,
   "winter_half": 705
  },
  "CF31": {
   "cells": 25,
   "mm": 1289,
   "n": 979,
   "periods": {
    "1961-1990": 1174,
    "1981-2010": 1246,
    "1991-2020": 1289
   },
   "seasons": {
    "djf": 370,
    "jja": 291,
    "mam": 234,
    "son": 395
   },
   "summer_half": 525,
   "winter_half": 765
  },
  "CF32": {
   "cells": 82,
   "mm": 1578,
   "n": 800,
   "periods": {
    "1961-1990": 1458,
    "1981-2010": 1537,
    "1991-2020": 1578
   },
   "seasons": {
    "djf": 465,
    "jja": 351,
    "mam": 291,
    "son": 472
   },
   "summer_half": 642,
   "winter_half": 937
  },
  "CF33": {
   "cells": 22,
   "mm": 1260,
   "n": 309,
   "periods": {
    "1961-1990": 1176,
    "1981-2010": 1219,
    "1991-2020": 1260
   },
   "seasons": {
    "djf": 352,
    "jja": 290,
    "mam": 231,
    "son": 386
   },
   "summer_half": 521,
   "winter_half": 738
  },
  "CF34": {
   "cells": 27,
   "mm": 1927,
   "n": 417,
   "periods": {
    "1961-1990": 1799,
    "1981-2010": 1890,
    "1991-2020": 1927
   },
   "seasons": {
    "djf": 572,
    "jja": 447,
    "mam": 346,
    "son": 562
   },
   "summer_half": 793,
   "winter_half": 1134
  },
  "CF35": {
   "cells": 64,
   "mm": 1467,
   "n": 484,
   "periods": {
    "1961-1990": 1342,
    "1981-2010": 1432,
    "1991-2020": 1467
   },
   "seasons": {
    "djf": 432,
    "jja": 324,
    "mam": 270,
    "son": 441
   },
   "summer_half": 594,
   "winter_half": 873
  },
  "CF36": {
   "cells": 14,
   "mm": 1108,
   "n": 415,
   "periods": {
    "1961-1990": 1029,
    "1981-2010": 1077,
    "1991-2020": 1108
   },
   "seasons": {
    "djf": 312,
    "jja": 254,
    "mam": 204,
    "son": 338
   },
   "summer_half": 458,
   "winter_half": 650
  },
  "CF37": {
   "cells": 49,
   "mm": 1765,
   "n": 885,
   "periods": {
    "1961-1990": 1588,
    "1981-2010": 1734,
    "1991-2020": 1765
   },
   "seasons": {
    "djf": 576,
    "jja": 346,
    "mam": 327,
    "son": 516
   },
   "summer_half": 673,
   "winter_half": 1092
  },
  "CF38": {
   "cells": 21,
   "mm": 1549,
   "n": 448,
   "periods": {
    "1961-1990": 1418,
    "1981-2010": 1525,
    "1991-2020": 1549
   },
   "seasons": {
    "djf": 483,
    "jja": 320,
    "mam": 291,
    "son": 455
   },
   "summer_half": 611,
   "winter_half": 938
  },
  "CF39": {
   "cells": 31,
   "mm": 1958,
   "n": 556,
   "periods": {
    "1961-1990": 1782,
    "1981-2010": 1926,
    "1991-2020": 1958
   },
   "seasons": {
    "djf": 621,
    "jja": 399,
    "mam": 360,
    "son": 578
   },
   "summer_half": 759,
   "winter_half": 1199
  },
  "CF40": {
   "cells": 16,
   "mm": 2109,
   "n": 479,
   "periods": {
    "1961-1990": 1936,
    "1981-2010": 2096,
    "1991-2020": 2109
   },
   "seasons": {
    "djf": 681,
    "jja": 411,
    "mam": 388,
    "son": 629
   },
   "summer_half": 799,
   "winter_half": 1311
  },
  "CF41": {
   "cells": 10,
   "mm": 2285,
   "n": 249,
   "periods": {
    "1961-1990": 2116,
    "1981-2010": 2291,
    "1991-2020": 2285
   },
   "seasons": {
    "djf": 751,
    "jja": 430,
    "mam": 419,
    "son": 686
   },
   "summer_half": 849,
   "winter_half": 1436
  },
  "CF42": {
   "cells": 15,
   "mm": 2504,
   "n": 310,
   "periods": {
    "1961-1990": 2296,
    "1981-2010": 2485,
    "1991-2020": 2504
   },
   "seasons": {
    "djf": 835,
    "jja": 473,
    "mam": 454,
    "son": 741
   },
   "summer_half": 927,
   "winter_half": 1577
  },
  "CF43": {
   "cells": 14,
   "mm": 2263,
   "n": 257,
   "periods": {
    "1961-1990": 2067,
    "1981-2010": 2247,
    "1991-2020": 2263
   },
   "seasons": {
    "djf": 756,
    "jja": 423,
    "mam": 415,
    "son": 669
   },
   "summer_half": 838,
   "winter_half": 1425
  },
  "CF44": {
   "cells": 58,
   "mm": 1908,
   "n": 1015,
   "periods": {
    "1961-1990": 1816,
    "1981-2010": 1935,
    "1991-2020": 1908
   },
   "seasons": {
    "djf": 643,
    "jja": 351,
    "mam": 350,
    "son": 565
   },
   "summer_half": 701,
   "winter_half": 1207
  },
  "CF45": {
   "cells": 20,
   "mm": 1892,
   "n": 437,
   "periods": {
    "1961-1990": 1682,
    "1981-2010": 1854,
    "1991-2020": 1892
   },
   "seasons": {
    "djf": 640,
    "jja": 357,
    "mam": 349,
    "son": 546
   },
   "summer_half": 706,
   "winter_half": 1186
  },
  "CF46": {
   "cells": 31,
   "mm": 1712,
   "n": 348,
   "periods": {
    "1961-1990": 1515,
    "1981-2010": 1684,
    "1991-2020": 1712
   },
   "seasons": {
    "djf": 569,
    "jja": 324,
    "mam": 319,
    "son": 500
   },
   "summer_half": 643,
   "winter_half": 1069
  },
  "CF47": {
   "cells": 15,
   "mm": 1500,
   "n": 633,
   "periods": {
    "1961-1990": 1411,
    "1981-2010": 1484,
    "1991-2020": 1500
   },
   "seasons": {
    "djf": 495,
    "jja": 275,
    "mam": 289,
    "son": 440
   },
   "summer_half": 564,
   "winter_half": 936
  },
  "CF48": {
   "cells": 55,
   "mm": 1652,
   "n": 752,
   "periods": {
    "1961-1990": 1539,
    "1981-2010": 1638,
    "1991-2020": 1652
   },
   "seasons": {
    "djf": 546,
    "jja": 310,
    "mam": 313,
    "son": 484
   },
   "summer_half": 623,
   "winter_half": 1030
  },
  "CF5": {
   "cells": 67,
   "mm": 1201,
   "n": 1443,
   "periods": {
    "1961-1990": 1113,
    "1981-2010": 1171,
    "1991-2020": 1201
   },
   "seasons": {
    "djf": 356,
    "jja": 264,
    "mam": 231,
    "son": 350
   },
   "summer_half": 495,
   "winter_half": 706
  },
  "CF61": {
   "cells": 15,
   "mm": 1023,
   "n": 230,
   "periods": {
    "1961-1990": 949,
    "1981-2010": 979,
    "1991-2020": 1023
   },
   "seasons": {
    "djf": 302,
    "jja": 231,
    "mam": 190,
    "son": 300
   },
   "summer_half": 420,
   "winter_half": 602
  },
  "CF62": {
   "cells": 56,
   "mm": 1035,
   "n": 906,
   "periods": {
    "1961-1990": 970,
    "1981-2010": 1015,
    "1991-2020": 1035
   },
   "seasons": {
    "djf": 296,
    "jja": 240,
    "mam": 191,
    "son": 309
   },
   "summer_half": 431,
   "winter_half": 604
  },
  "CF63": {
   "cells": 12,
   "mm": 1003,
   "n": 478,
   "periods": {
    "1961-1990": 935,
    "1981-2010": 988,
    "1991-2020": 1003
   },
   "seasons": {
    "djf": 286,
    "jja": 230,
    "mam": 191,
    "son": 295
   },
   "summer_half": 422,
   "winter_half": 581
  },
  "CF64": {
   "cells": 30,
   "mm": 1030,
   "n": 923,
   "periods": {
    "1961-1990": 966,
    "1981-2010": 1019,
    "1991-2020": 1030
   },
   "seasons": {
    "djf": 295,
    "jja": 238,
    "mam": 200,
    "son": 298
   },
   "summer_half": 438,
   "winter_half": 592
  },
  "CF71": {
   "cells": 58,
   "mm": 1218,
   "n": 284,
   "periods": {
    "1961-1990": 1134,
    "1981-2010": 1184,
    "1991-2020": 1218
   },
   "seasons": {
    "djf": 349,
    "jja": 277,
    "mam": 226,
    "son": 365
   },
   "summer_half": 503,
   "winter_half": 715
  },
  "CF72": {
   "cells": 51,
   "mm": 1463,
   "n": 687,
   "periods": {
    "1961-1990": 1337,
    "1981-2010": 1434,
    "1991-2020": 1463
   },
   "seasons": {
    "djf": 437,
    "jja": 319,
    "mam": 273,
    "son": 435
   },
   "summer_half": 592,
   "winter_half": 871
  },
  "CF81": {
   "cells": 19,
   "mm": 1603,
   "n": 386,
   "periods": {
    "1961-1990": 1511,
    "1981-2010": 1604,
    "1991-2020": 1603
   },
   "seasons": {
    "djf": 516,
    "jja": 309,
    "mam": 300,
    "son": 478
   },
   "summer_half": 609,
   "winter_half": 994
  },
  "CF82": {
   "cells": 20,
   "mm": 1549,
   "n": 501,
   "periods": {
    "1961-1990": 1406,
    "1981-2010": 1537,
    "1991-2020": 1549
   },
   "seasons": {
    "djf": 500,
    "jja": 295,
    "mam": 290,
    "son": 464
   },
   "summer_half": 585,
   "winter_half": 964
  },
  "CF83": {
   "cells": 55,
   "mm": 1504,
   "n": 1207,
   "periods": {
    "1961-1990": 1359,
    "1981-2010": 1478,
    "1991-2020": 1504
   },
   "seasons": {
    "djf": 469,
    "jja": 305,
    "mam": 290,
    "son": 440
   },
   "summer_half": 595,
   "winter_half": 909
  },
  "CF91": {
   "cells": 1,
   "mm": 1118,
   "n": 14,
   "periods": {
    "1961-1990": 1020,
    "1981-2010": 1088,
    "1991-2020": 1118
   },
   "seasons": {
    "djf": 326,
    "jja": 252,
    "mam": 218,
    "son": 322
   },
   "summer_half": 470,
   "winter_half": 647
  },
  "CF95": {
   "cells": 1,
   "mm": 1186,
   "n": 5,
   "periods": {
    "1961-1990": 1051,
    "1981-2010": 1137,
    "1991-2020": 1186
   },
   "seasons": {
    "djf": 353,
    "jja": 261,
    "mam": 233,
    "son": 339
   },
   "summer_half": 493,
   "winter_half": 692
  },
  "CF99": {
   "cells": 1,
   "mm": 1087,
   "n": 1,
   "periods": {
    "1961-1990": 987,
    "1981-2010": 1056,
    "1991-2020": 1087
   },
   "seasons": {
    "djf": 315,
    "jja": 248,
    "mam": 212,
    "son": 313
   },
   "summer_half": 460,
   "winter_half": 627
  },
  "CH1": {
   "cells": 49,
   "mm": 733,
   "n": 1050,
   "periods": {
    "1961-1990": 704,
    "1981-2010": 718,
    "1991-2020": 733
   },
   "seasons": {
    "djf": 180,
    "jja": 194,
    "mam": 145,
    "son": 215
   },
   "summer_half": 339,
   "winter_half": 394
  },
  "CH2": {
   "cells": 50,
   "mm": 739,
   "n": 852,
   "periods": {
    "1961-1990": 710,
    "1981-2010": 722,
    "1991-2020": 739
   },
   "seasons": {
    "djf": 180,
    "jja": 195,
    "mam": 146,
    "son": 218
   },
   "summer_half": 341,
   "winter_half": 398
  },
  "CH25": {
   "cells": 1,
   "mm": 785,
   "n": 37,
   "periods": {
    "1961-1990": 745,
    "1981-2010": 770,
    "1991-2020": 785
   },
   "seasons": {
    "djf": 199,
    "jja": 198,
    "mam": 154,
    "son": 233
   },
   "summer_half": 352,
   "winter_half": 433
  },
  "CH26": {
   "cells": 1,
   "mm": 794,
   "n": 7,
   "periods": {
    "1961-1990": 762,
    "1981-2010": 772,
    "1991-2020": 794
   },
   "seasons": {
    "djf": 201,
    "jja": 208,
    "mam": 148,
    "son": 238
   },
   "summer_half": 356,
   "winter_half": 439
  },
  "CH27": {
   "cells": 1,
   "mm": 806,
   "n": 21,
   "periods": {
    "1961-1990": 770,
    "1981-2010": 792,
    "1991-2020": 806
   },
   "seasons": {
    "djf": 207,
    "jja": 202,
    "mam": 157,
    "son": 240
   },
   "summer_half": 359,
   "winter_half": 447
  },
  "CH28": {
   "cells": 1,
   "mm": 736,
   "n": 5,
   "periods": {
    "1961-1990": 726,
    "1981-2010": 725,
    "1991-2020": 736
   },
   "seasons": {
    "djf": 183,
    "jja": 191,
    "mam": 142,
    "son": 221
   },
   "summer_half": 332,
   "winter_half": 404
  },
  "CH29": {
   "cells": 1,
   "mm": 766,
   "n": 20,
   "periods": {
    "1961-1990": 736,
    "1981-2010": 753,
    "1991-2020": 766
   },
   "seasons": {
    "djf": 191,
    "jja": 197,
    "mam": 148,
    "son": 230
   },
   "summer_half": 345,
   "winter_half": 421
  },
  "CH3": {
   "cells": 153,
   "mm": 720,
   "n": 1110,
   "periods": {
    "1961-1990": 698,
    "1981-2010": 709,
    "1991-2020": 720
   },
   "seasons": {
    "djf": 174,
    "jja": 193,
    "mam": 146,
    "son": 207
   },
   "summer_half": 339,
   "winter_half": 381
  },
  "CH30": {
   "cells": 1,
   "mm": 773,
   "n": 1,
   "periods": {
    "1961-1990": 750,
    "1981-2010": 757,
    "1991-2020": 773
   },
   "seasons": {
    "djf": 193,
    "jja": 200,
    "mam": 148,
    "son": 232
   },
   "summer_half": 348,
   "winter_half": 425
  },
  "CH31": {
   "cells": 1,
   "mm": 745,
   "n": 9,
   "periods": {
    "1961-1990": 728,
    "1981-2010": 730,
    "1991-2020": 745
   },
   "seasons": {
    "djf": 186,
    "jja": 188,
    "mam": 146,
    "son": 225
   },
   "summer_half": 333,
   "winter_half": 412
  },
  "CH32": {
   "cells": 1,
   "mm": 822,
   "n": 14,
   "periods": {
    "1961-1990": 778,
    "1981-2010": 804,
    "1991-2020": 822
   },
   "seasons": {
    "djf": 211,
    "jja": 202,
    "mam": 171,
    "son": 238
   },
   "summer_half": 373,
   "winter_half": 449
  },
  "CH33": {
   "cells": 1,
   "mm": 743,
   "n": 7,
   "periods": {
    "1961-1990": 709,
    "1981-2010": 723,
    "1991-2020": 743
   },
   "seasons": {
    "djf": 182,
    "jja": 194,
    "mam": 145,
    "son": 221
   },
   "summer_half": 339,
   "winter_half": 403
  },
  "CH34": {
   "cells": 3,
   "mm": 752,
   "n": 64,
   "periods": {
    "1961-1990": 728,
    "1981-2010": 739,
    "1991-2020": 752
   },
   "seasons": {
    "djf": 186,
    "jja": 194,
    "mam": 148,
    "son": 223
   },
   "summer_half": 342,
   "winter_half": 410
  },
  "CH4": {
   "cells": 69,
   "mm": 756,
   "n": 921,
   "periods": {
    "1961-1990": 722,
    "1981-2010": 744,
    "1991-2020": 756
   },
   "seasons": {
    "djf": 189,
    "jja": 199,
    "mam": 152,
    "son": 215
   },
   "summer_half": 352,
   "winter_half": 404
  },
  "CH41": {
   "cells": 13,
   "mm": 764,
   "n": 790,
   "periods": {
    "1961-1990": 732,
    "1981-2010": 751,
    "1991-2020": 764
   },
   "seasons": {
    "djf": 192,
    "jja": 194,
    "mam": 150,
    "son": 229
   },
   "summer_half": 344,
   "winter_half": 421
  },
  "CH42": {
   "cells": 12,
   "mm": 806,
   "n": 688,
   "periods": {
    "1961-1990": 766,
    "1981-2010": 789,
    "1991-2020": 806
   },
   "seasons": {
    "djf": 199,
    "jja": 205,
    "mam": 161,
    "son": 241
   },
   "summer_half": 366,
   "winter_half": 440
  },
  "CH43": {
   "cells": 19,
   "mm": 780,
   "n": 934,
   "periods": {
    "1961-1990": 753,
    "1981-2010": 765,
    "1991-2020": 780
   },
   "seasons": {
    "djf": 196,
    "jja": 201,
    "mam": 150,
    "son": 234
   },
   "summer_half": 351,
   "winter_half": 430
  },
  "CH44": {
   "cells": 10,
   "mm": 772,
   "n": 772,
   "periods": {
    "1961-1990": 739,
    "1981-2010": 758,
    "1991-2020": 772
   },
   "seasons": {
    "djf": 196,
    "jja": 195,
    "mam": 151,
    "son": 231
   },
   "summer_half": 345,
   "winter_half": 427
  },
  "CH45": {
   "cells": 11,
   "mm": 772,
   "n": 758,
   "periods": {
    "1961-1990": 743,
    "1981-2010": 760,
    "1991-2020": 772
   },
   "seasons": {
    "djf": 196,
    "jja": 195,
    "mam": 150,
    "son": 232
   },
   "summer_half": 345,
   "winter_half": 427
  },
  "CH46": {
   "cells": 13,
   "mm": 733,
   "n": 593,
   "periods": {
    "1961-1990": 720,
    "1981-2010": 722,
    "1991-2020": 733
   },
   "seasons": {
    "djf": 182,
    "jja": 190,
    "mam": 141,
    "son": 221
   },
   "summer_half": 331,
   "winter_half": 402
  },
  "CH47": {
   "cells": 10,
   "mm": 758,
   "n": 343,
   "periods": {
    "1961-1990": 734,
    "1981-2010": 745,
    "1991-2020": 758
   },
   "seasons": {
    "djf": 189,
    "jja": 196,
    "mam": 146,
    "son": 228
   },
   "summer_half": 342,
   "winter_half": 416
  },
  "CH48": {
   "cells": 17,
   "mm": 784,
   "n": 502,
   "periods": {
    "1961-1990": 752,
    "1981-2010": 768,
    "1991-2020": 784
   },
   "seasons": {
    "djf": 195,
    "jja": 202,
    "mam": 152,
    "son": 235
   },
   "summer_half": 354,
   "winter_half": 431
  },
  "CH49": {
   "cells": 19,
   "mm": 773,
   "n": 673,
   "periods": {
    "1961-1990": 751,
    "1981-2010": 757,
    "1991-2020": 773
   },
   "seasons": {
    "djf": 192,
    "jja": 201,
    "mam": 148,
    "son": 233
   },
   "summer_half": 348,
   "winter_half": 425
  },
  "CH5": {
   "cells": 49,
   "mm": 749,
   "n": 1165,
   "periods": {
    "1961-1990": 723,
    "1981-2010": 740,
    "1991-2020": 749
   },
   "seasons": {
    "djf": 190,
    "jja": 185,
    "mam": 155,
    "son": 219
   },
   "summer_half": 340,
   "winter_half": 409
  },
  "CH6": {
   "cells": 27,
   "mm": 801,
   "n": 444,
   "periods": {
    "1961-1990": 782,
    "1981-2010": 793,
    "1991-2020": 801
   },
   "seasons": {
    "djf": 214,
    "jja": 192,
    "mam": 160,
    "son": 234
   },
   "summer_half": 352,
   "winter_half": 449
  },
  "CH60": {
   "cells": 11,
   "mm": 760,
   "n": 461,
   "periods": {
    "1961-1990": 741,
    "1981-2010": 743,
    "1991-2020": 760
   },
   "seasons": {
    "djf": 189,
    "jja": 193,
    "mam": 148,
    "son": 229
   },
   "summer_half": 341,
   "winter_half": 419
  },
  "CH61": {
   "cells": 17,
   "mm": 796,
   "n": 418,
   "periods": {
    "1961-1990": 770,
    "1981-2010": 775,
    "1991-2020": 796
   },
   "seasons": {
    "djf": 197,
    "jja": 206,
    "mam": 152,
    "son": 242
   },
   "summer_half": 358,
   "winter_half": 439
  },
  "CH62": {
   "cells": 20,
   "mm": 805,
   "n": 821,
   "periods": {
    "1961-1990": 771,
    "1981-2010": 788,
    "1991-2020": 805
   },
   "seasons": {
    "djf": 206,
    "jja": 203,
    "mam": 156,
    "son": 241
   },
   "summer_half": 359,
   "winter_half": 447
  },
  "CH63": {
   "cells": 32,
   "mm": 808,
   "n": 822,
   "periods": {
    "1961-1990": 773,
    "1981-2010": 789,
    "1991-2020": 808
   },
   "seasons": {
    "djf": 202,
    "jja": 207,
    "mam": 158,
    "son": 242
   },
   "summer_half": 365,
   "winter_half": 444
  },
  "CH64": {
   "cells": 40,
   "mm": 751,
   "n": 642,
   "periods": {
    "1961-1990": 721,
    "1981-2010": 733,
    "1991-2020": 751
   },
   "seasons": {
    "djf": 188,
    "jja": 194,
    "mam": 145,
    "son": 224
   },
   "summer_half": 339,
   "winter_half": 412
  },
  "CH65": {
   "cells": 24,
   "mm": 745,
   "n": 819,
   "periods": {
    "1961-1990": 720,
    "1981-2010": 732,
    "1991-2020": 745
   },
   "seasons": {
    "djf": 186,
    "jja": 192,
    "mam": 146,
    "son": 222
   },
   "summer_half": 337,
   "winter_half": 408
  },
  "CH66": {
   "cells": 29,
   "mm": 750,
   "n": 994,
   "periods": {
    "1961-1990": 731,
    "1981-2010": 737,
    "1991-2020": 750
   },
   "seasons": {
    "djf": 190,
    "jja": 192,
    "mam": 144,
    "son": 225
   },
   "summer_half": 335,
   "winter_half": 415
  },
  "CH7": {
   "cells": 170,
   "mm": 901,
   "n": 1584,
   "periods": {
    "1961-1990": 863,
    "1981-2010": 887,
    "1991-2020": 901
   },
   "seasons": {
    "djf": 237,
    "jja": 215,
    "mam": 182,
    "son": 266
   },
   "summer_half": 398,
   "winter_half": 504
  },
  "CH70": {
   "cells": 1,
   "mm": 707,
   "n": 42,
   "periods": {
    "1961-1990": 671,
    "1981-2010": 690,
    "1991-2020": 707
   },
   "seasons": {
    "djf": 175,
    "jja": 188,
    "mam": 140,
    "son": 204
   },
   "summer_half": 328,
   "winter_half": 380
  },
  "CH8": {
   "cells": 93,
   "mm": 837,
   "n": 681,
   "periods": {
    "1961-1990": 810,
    "1981-2010": 828,
    "1991-2020": 837
   },
   "seasons": {
    "djf": 217,
    "jja": 209,
    "mam": 163,
    "son": 248
   },
   "summer_half": 372,
   "winter_half": 465
  },
  "CH88": {
   "cells": 1,
   "mm": 697,
   "n": 1,
   "periods": {
    "1961-1990": 665,
    "1981-2010": 679,
    "1991-2020": 697
   },
   "seasons": {
    "djf": 170,
    "jja": 187,
    "mam": 138,
    "son": 203
   },
   "summer_half": 325,
   "winter_half": 372
  },
  "CH99": {
   "cells": 3,
   "mm": 743,
   "n": 17,
   "periods": {
    "1961-1990": 708,
    "1981-2010": 723,
    "1991-2020": 743
   },
   "seasons": {
    "djf": 183,
    "jja": 199,
    "mam": 147,
    "son": 214
   },
   "summer_half": 346,
   "winter_half": 397
  },
  "CM0": {
   "cells": 73,
   "mm": 535,
   "n": 561,
   "periods": {
    "1961-1990": 522,
    "1981-2010": 527,
    "1991-2020": 535
   },
   "seasons": {
    "djf": 133,
    "jja": 133,
    "mam": 108,
    "son": 160
   },
   "summer_half": 241,
   "winter_half": 293
  },
  "CM1": {
   "cells": 93,
   "mm": 588,
   "n": 1558,
   "periods": {
    "1961-1990": 569,
    "1981-2010": 582,
    "1991-2020": 588
   },
   "seasons": {
    "djf": 150,
    "jja": 147,
    "mam": 121,
    "son": 170
   },
   "summer_half": 268,
   "winter_half": 321
  },
  "CM11": {
   "cells": 38,
   "mm": 602,
   "n": 450,
   "periods": {
    "1961-1990": 581,
    "1981-2010": 589,
    "1991-2020": 602
   },
   "seasons": {
    "djf": 154,
    "jja": 150,
    "mam": 121,
    "son": 177
   },
   "summer_half": 271,
   "winter_half": 331
  },
  "CM12": {
   "cells": 25,
   "mm": 610,
   "n": 508,
   "periods": {
    "1961-1990": 594,
    "1981-2010": 602,
    "1991-2020": 610
   },
   "seasons": {
    "djf": 156,
    "jja": 152,
    "mam": 124,
    "son": 178
   },
   "summer_half": 276,
   "winter_half": 335
  },
  "CM13": {
   "cells": 58,
   "mm": 607,
   "n": 701,
   "periods": {
    "1961-1990": 602,
    "1981-2010": 608,
    "1991-2020": 607
   },
   "seasons": {
    "djf": 154,
    "jja": 149,
    "mam": 123,
    "son": 181
   },
   "summer_half": 272,
   "winter_half": 336
  },
  "CM14": {
   "cells": 32,
   "mm": 623,
   "n": 618,
   "periods": {
    "1961-1990": 623,
    "1981-2010": 626,
    "1991-2020": 623
   },
   "seasons": {
    "djf": 157,
    "jja": 155,
    "mam": 126,
    "son": 185
   },
   "summer_half": 281,
   "winter_half": 342
  },
  "CM15": {
   "cells": 45,
   "mm": 626,
   "n": 596,
   "periods": {
    "1961-1990": 617,
    "1981-2010": 623,
    "1991-2020": 626
   },
   "seasons": {
    "djf": 160,
    "jja": 156,
    "mam": 125,
    "son": 185
   },
   "summer_half": 280,
   "winter_half": 346
  },
  "CM16": {
   "cells": 61,
   "mm": 646,
   "n": 639,
   "periods": {
    "1961-1990": 619,
    "1981-2010": 639,
    "1991-2020": 646
   },
   "seasons": {
    "djf": 166,
    "jja": 164,
    "mam": 129,
    "son": 188
   },
   "summer_half": 293,
   "winter_half": 354
  },
  "CM17": {
   "cells": 38,
   "mm": 642,
   "n": 530,
   "periods": {
    "1961-1990": 615,
    "1981-2010": 639,
    "1991-2020": 642
   },
   "seasons": {
    "djf": 164,
    "jja": 166,
    "mam": 127,
    "son": 185
   },
   "summer_half": 293,
   "winter_half": 350
  },
  "CM18": {
   "cells": 12,
   "mm": 638,
   "n": 431,
   "periods": {
    "1961-1990": 607,
    "1981-2010": 633,
    "1991-2020": 638
   },
   "seasons": {
    "djf": 163,
    "jja": 166,
    "mam": 125,
    "son": 183
   },
   "summer_half": 291,
   "winter_half": 346
  },
  "CM19": {
   "cells": 25,
   "mm": 627,
   "n": 394,
   "periods": {
    "1961-1990": 605,
    "1981-2010": 625,
    "1991-2020": 627
   },
   "seasons": {
    "djf": 162,
    "jja": 159,
    "mam": 122,
    "son": 183
   },
   "summer_half": 281,
   "winter_half": 346
  },
  "CM2": {
   "cells": 54,
   "mm": 584,
   "n": 1313,
   "periods": {
    "1961-1990": 563,
    "1981-2010": 573,
    "1991-2020": 584
   },
   "seasons": {
    "djf": 149,
    "jja": 143,
    "mam": 118,
    "son": 174
   },
   "summer_half": 261,
   "winter_half": 323
  },
  "CM20": {
   "cells": 19,
   "mm": 603,
   "n": 632,
   "periods": {
    "1961-1990": 575,
    "1981-2010": 603,
    "1991-2020": 603
   },
   "seasons": {
    "djf": 152,
    "jja": 157,
    "mam": 119,
    "son": 176
   },
   "summer_half": 276,
   "winter_half": 328
  },
  "CM21": {
   "cells": 24,
   "mm": 644,
   "n": 320,
   "periods": {
    "1961-1990": 608,
    "1981-2010": 642,
    "1991-2020": 644
   },
   "seasons": {
    "djf": 164,
    "jja": 165,
    "mam": 127,
    "son": 188
   },
   "summer_half": 292,
   "winter_half": 353
  },
  "CM22": {
   "cells": 95,
   "mm": 635,
   "n": 555,
   "periods": {
    "1961-1990": 610,
    "1981-2010": 630,
    "1991-2020": 635
   },
   "seasons": {
    "djf": 161,
    "jja": 162,
    "mam": 127,
    "son": 184
   },
   "summer_half": 289,
   "winter_half": 345
  },
  "CM23": {
   "cells": 52,
   "mm": 647,
   "n": 1193,
   "periods": {
    "1961-1990": 614,
    "1981-2010": 641,
    "1991-2020": 647
   },
   "seasons": {
    "djf": 166,
    "jja": 167,
    "mam": 127,
    "son": 187
   },
   "summer_half": 293,
   "winter_half": 353
  },
  "CM24": {
   "cells": 20,
   "mm": 648,
   "n": 274,
   "periods": {
    "1961-1990": 614,
    "1981-2010": 641,
    "1991-2020": 648
   },
   "seasons": {
    "djf": 166,
    "jja": 167,
    "mam": 129,
    "son": 187
   },
   "summer_half": 296,
   "winter_half": 353
  },
  "CM3": {
   "cells": 240,
   "mm": 588,
   "n": 1589,
   "periods": {
    "1961-1990": 570,
    "1981-2010": 579,
    "1991-2020": 588
   },
   "seasons": {
    "djf": 149,
    "jja": 147,
    "mam": 120,
    "son": 172
   },
   "summer_half": 267,
   "winter_half": 321
  },
  "CM4": {
   "cells": 66,
   "mm": 615,
   "n": 442,
   "periods": {
    "1961-1990": 591,
    "1981-2010": 603,
    "1991-2020": 615
   },
   "seasons": {
    "djf": 158,
    "jja": 153,
    "mam": 123,
    "son": 181
   },
   "summer_half": 276,
   "winter_half": 338
  },
  "CM5": {
   "cells": 95,
   "mm": 621,
   "n": 449,
   "periods": {
    "1961-1990": 611,
    "1981-2010": 617,
    "1991-2020": 621
   },
   "seasons": {
    "djf": 161,
    "jja": 154,
    "mam": 125,
    "son": 181
   },
   "summer_half": 279,
   "winter_half": 342
  },
  "CM6": {
   "cells": 163,
   "mm": 620,
   "n": 987,
   "periods": {
    "1961-1990": 596,
    "1981-2010": 615,
    "1991-2020": 620
   },
   "seasons": {
    "djf": 157,
    "jja": 161,
    "mam": 125,
    "son": 177
   },
   "summer_half": 286,
   "winter_half": 334
  },
  "CM7": {
   "cells": 110,
   "mm": 616,
   "n": 1345,
   "periods": {
    "1961-1990": 579,
    "1981-2010": 609,
    "1991-2020": 616
   },
   "seasons": {
    "djf": 156,
    "jja": 162,
    "mam": 122,
    "son": 176
   },
   "summer_half": 284,
   "winter_half": 332
  },
  "CM77": {
   "cells": 58,
   "mm": 604,
   "n": 461,
   "periods": {
    "1961-1990": 576,
    "1981-2010": 599,
    "1991-2020": 604
   },
   "seasons": {
    "djf": 152,
    "jja": 156,
    "mam": 123,
    "son": 173
   },
   "summer_half": 279,
   "winter_half": 325
  },
  "CM8": {
   "cells": 56,
   "mm": 589,
   "n": 920,
   "periods": {
    "1961-1990": 565,
    "1981-2010": 585,
    "1991-2020": 589
   },
   "seasons": {
    "djf": 148,
    "jja": 150,
    "mam": 120,
    "son": 171
   },
   "summer_half": 270,
   "winter_half": 319
  },
  "CM9": {
   "cells": 116,
   "mm": 562,
   "n": 1055,
   "periods": {
    "1961-1990": 544,
    "1981-2010": 555,
    "1991-2020": 562
   },
   "seasons": {
    "djf": 142,
    "jja": 143,
    "mam": 112,
    "son": 166
   },
   "summer_half": 255,
   "winter_half": 308
  },
  "CM92": {
   "cells": 1,
   "mm": 638,
   "n": 18,
   "periods": {
    "1961-1990": 619,
    "1981-2010": 639,
    "1991-2020": 638
   },
   "seasons": {
    "djf": 167,
    "jja": 159,
    "mam": 124,
    "son": 187
   },
   "summer_half": 283,
   "winter_half": 355
  },
  "CM98": {
   "cells": 1,
   "mm": 567,
   "n": 19,
   "periods": {
    "1961-1990": 547,
    "1981-2010": 559,
    "1991-2020": 567
   },
   "seasons": {
    "djf": 142,
    "jja": 142,
    "mam": 116,
    "son": 167
   },
   "summer_half": 258,
   "winter_half": 309
  },
  "CM99": {
   "cells": 1,
   "mm": 572,
   "n": 70,
   "periods": {
    "1961-1990": 551,
    "1981-2010": 563,
    "1991-2020": 572
   },
   "seasons": {
    "djf": 145,
    "jja": 141,
    "mam": 116,
    "son": 170
   },
   "summer_half": 257,
   "winter_half": 315
  },
  "CO1": {
   "cells": 11,
   "mm": 604,
   "n": 595,
   "periods": {
    "1961-1990": 558,
    "1981-2010": 594,
    "1991-2020": 604
   },
   "seasons": {
    "djf": 152,
    "jja": 150,
    "mam": 120,
    "son": 182
   },
   "summer_half": 270,
   "winter_half": 334
  },
  "CO10": {
   "cells": 253,
   "mm": 612,
   "n": 1678,
   "periods": {
    "1961-1990": 578,
    "1981-2010": 611,
    "1991-2020": 612
   },
   "seasons": {
    "djf": 153,
    "jja": 165,
    "mam": 122,
    "son": 172
   },
   "summer_half": 288,
   "winter_half": 324
  },
  "CO11": {
   "cells": 53,
   "mm": 576,
   "n": 576,
   "periods": {
    "1961-1990": 561,
    "1981-2010": 575,
    "1991-2020": 576
   },
   "seasons": {
    "djf": 145,
    "jja": 148,
    "mam": 115,
    "son": 168
   },
   "summer_half": 263,
   "winter_half": 313
  },
  "CO12": {
   "cells": 35,
   "mm": 569,
   "n": 642,
   "periods": {
    "1961-1990": 547,
    "1981-2010": 564,
    "1991-2020": 569
   },
   "seasons": {
    "djf": 144,
    "jja": 149,
    "mam": 111,
    "son": 166
   },
   "summer_half": 260,
   "winter_half": 310
  },
  "CO13": {
   "cells": 21,
   "mm": 566,
   "n": 441,
   "periods": {
    "1961-1990": 550,
    "1981-2010": 559,
    "1991-2020": 566
   },
   "seasons": {
    "djf": 147,
    "jja": 143,
    "mam": 110,
    "son": 166
   },
   "summer_half": 253,
   "winter_half": 313
  },
  "CO14": {
   "cells": 8,
   "mm": 553,
   "n": 246,
   "periods": {
    "1961-1990": 536,
    "1981-2010": 546,
    "1991-2020": 553
   },
   "seasons": {
    "djf": 145,
    "jja": 138,
    "mam": 105,
    "son": 166
   },
   "summer_half": 243,
   "winter_half": 310
  },
  "CO15": {
   "cells": 24,
   "mm": 558,
   "n": 1365,
   "periods": {
    "1961-1990": 541,
    "1981-2010": 554,
    "1991-2020": 558
   },
   "seasons": {
    "djf": 140,
    "jja": 145,
    "mam": 112,
    "son": 162
   },
   "summer_half": 256,
   "winter_half": 302
  },
  "CO16": {
   "cells": 81,
   "mm": 554,
   "n": 819,
   "periods": {
    "1961-1990": 539,
    "1981-2010": 551,
    "1991-2020": 554
   },
   "seasons": {
    "djf": 140,
    "jja": 141,
    "mam": 110,
    "son": 163
   },
   "summer_half": 251,
   "winter_half": 303
  },
  "CO2": {
   "cells": 43,
   "mm": 579,
   "n": 944,
   "periods": {
    "1961-1990": 557,
    "1981-2010": 576,
    "1991-2020": 579
   },
   "seasons": {
    "djf": 146,
    "jja": 146,
    "mam": 115,
    "son": 172
   },
   "summer_half": 261,
   "winter_half": 318
  },
  "CO3": {
   "cells": 31,
   "mm": 582,
   "n": 866,
   "periods": {
    "1961-1990": 549,
    "1981-2010": 575,
    "1991-2020": 582
   },
   "seasons": {
    "djf": 147,
    "jja": 149,
    "mam": 119,
    "son": 167
   },
   "summer_half": 268,
   "winter_half": 314
  },
  "CO4": {
   "cells": 58,
   "mm": 593,
   "n": 1191,
   "periods": {
    "1961-1990": 563,
    "1981-2010": 585,
    "1991-2020": 593
   },
   "seasons": {
    "djf": 150,
    "jja": 153,
    "mam": 121,
    "son": 169
   },
   "summer_half": 274,
   "winter_half": 320
  },
  "CO5": {
   "cells": 107,
   "mm": 578,
   "n": 976,
   "periods": {
    "1961-1990": 548,
    "1981-2010": 568,
    "1991-2020": 578
   },
   "seasons": {
    "djf": 145,
    "jja": 149,
    "mam": 117,
    "son": 168
   },
   "summer_half": 265,
   "winter_half": 313
  },
  "CO6": {
   "cells": 178,
   "mm": 591,
   "n": 1028,
   "periods": {
    "1961-1990": 557,
    "1981-2010": 583,
    "1991-2020": 591
   },
   "seasons": {
    "djf": 148,
    "jja": 152,
    "mam": 122,
    "son": 170
   },
   "summer_half": 273,
   "winter_half": 318
  },
  "CO7": {
   "cells": 151,
   "mm": 581,
   "n": 1338,
   "periods": {
    "1961-1990": 560,
    "1981-2010": 576,
    "1991-2020": 581
   },
   "seasons": {
    "djf": 147,
    "jja": 149,
    "mam": 117,
    "son": 168
   },
   "summer_half": 266,
   "winter_half": 315
  },
  "CO8": {
   "cells": 31,
   "mm": 600,
   "n": 126,
   "periods": {
    "1961-1990": 560,
    "1981-2010": 592,
    "1991-2020": 600
   },
   "seasons": {
    "djf": 150,
    "jja": 159,
    "mam": 118,
    "son": 173
   },
   "summer_half": 277,
   "winter_half": 323
  },
  "CO9": {
   "cells": 139,
   "mm": 613,
   "n": 928,
   "periods": {
    "1961-1990": 569,
    "1981-2010": 607,
    "1991-2020": 613
   },
   "seasons": {
    "djf": 154,
    "jja": 166,
    "mam": 120,
    "son": 172
   },
   "summer_half": 286,
   "winter_half": 327
  },
  "CR0": {
   "cells": 51,
   "mm": 705,
   "n": 2789,
   "periods": {
    "1961-1990": 681,
    "1981-2010": 692,
    "1991-2020": 705
   },
   "seasons": {
    "djf": 198,
    "jja": 158,
    "mam": 143,
    "son": 206
   },
   "summer_half": 301,
   "winter_half": 404
  },
  "CR2": {
   "cells": 26,
   "mm": 768,
   "n": 996,
   "periods": {
    "1961-1990": 730,
    "1981-2010": 746,
    "1991-2020": 768
   },
   "seasons": {
    "djf": 223,
    "jja": 164,
    "mam": 155,
    "son": 226
   },
   "summer_half": 319,
   "winter_half": 449
  },
  "CR3": {
   "cells": 34,
   "mm": 853,
   "n": 772,
   "periods": {
    "1961-1990": 803,
    "1981-2010": 828,
    "1991-2020": 853
   },
   "seasons": {
    "djf": 249,
    "jja": 182,
    "mam": 168,
    "son": 254
   },
   "summer_half": 351,
   "winter_half": 503
  },
  "CR4": {
   "cells": 19,
   "mm": 616,
   "n": 912,
   "periods": {
    "1961-1990": 606,
    "1981-2010": 609,
    "1991-2020": 616
   },
   "seasons": {
    "djf": 162,
    "jja": 149,
    "mam": 126,
    "son": 179
   },
   "summer_half": 276,
   "winter_half": 340
  },
  "CR5": {
   "cells": 27,
   "mm": 815,
   "n": 699,
   "periods": {
    "1961-1990": 778,
    "1981-2010": 797,
    "1991-2020": 815
   },
   "seasons": {
    "djf": 237,
    "jja": 173,
    "mam": 158,
    "son": 246
   },
   "summer_half": 332,
   "winter_half": 483
  },
  "CR6": {
   "cells": 25,
   "mm": 843,
   "n": 257,
   "periods": {
    "1961-1990": 799,
    "1981-2010": 821,
    "1991-2020": 843
   },
   "seasons": {
    "djf": 245,
    "jja": 178,
    "mam": 169,
    "son": 250
   },
   "summer_half": 347,
   "winter_half": 495
  },
  "CR7": {
   "cells": 9,
   "mm": 633,
   "n": 609,
   "periods": {
    "1961-1990": 622,
    "1981-2010": 628,
    "1991-2020": 633
   },
   "seasons": {
    "djf": 169,
    "jja": 150,
    "mam": 130,
    "son": 184
   },
   "summer_half": 280,
   "winter_half": 354
  },
  "CR8": {
   "cells": 21,
   "mm": 791,
   "n": 800,
   "periods": {
    "1961-1990": 736,
    "1981-2010": 765,
    "1991-2020": 791
   },
   "seasons": {
    "djf": 230,
    "jja": 166,
    "mam": 157,
    "son": 238
   },
   "summer_half": 323,
   "winter_half": 468
  },
  "CR9": {
   "cells": 18,
   "mm": 677,
   "n": 126,
   "periods": {
    "1961-1990": 654,
    "1981-2010": 664,
    "1991-2020": 677
   },
   "seasons": {
    "djf": 187,
    "jja": 154,
    "mam": 138,
    "son": 198
   },
   "summer_half": 292,
   "winter_half": 385
  },
  "CR90": {
   "cells": 1,
   "mm": 648,
   "n": 45,
   "periods": {
    "1961-1990": 627,
    "1981-2010": 634,
    "1991-2020": 648
   },
   "seasons": {
    "djf": 175,
    "jja": 153,
    "mam": 131,
    "son": 188
   },
   "summer_half": 284,
   "winter_half": 363
  },
  "CT1": {
   "cells": 16,
   "mm": 677,
   "n": 935,
   "periods": {
    "1961-1990": 641,
    "1981-2010": 661,
    "1991-2020": 677
   },
   "seasons": {
    "djf": 187,
    "jja": 152,
    "mam": 129,
    "son": 210
   },
   "summer_half": 281,
   "winter_half": 396
  },
  "CT10": {
   "cells": 16,
   "mm": 616,
   "n": 742,
   "periods": {
    "1961-1990": 596,
    "1981-2010": 606,
    "1991-2020": 616
   },
   "seasons": {
    "djf": 157,
    "jja": 149,
    "mam": 115,
    "son": 194
   },
   "summer_half": 264,
   "winter_half": 351
  },
  "CT11": {
   "cells": 9,
   "mm": 653,
   "n": 861,
   "periods": {
    "1961-1990": 621,
    "1981-2010": 637,
    "1991-2020": 653
   },
   "seasons": {
    "djf": 170,
    "jja": 163,
    "mam": 117,
    "son": 203
   },
   "summer_half": 280,
   "winter_half": 373
  },
  "CT12": {
   "cells": 36,
   "mm": 634,
   "n": 597,
   "periods": {
    "1961-1990": 595,
    "1981-2010": 612,
    "1991-2020": 634
   },
   "seasons": {
    "djf": 164,
    "jja": 150,
    "mam": 122,
    "son": 197
   },
   "summer_half": 273,
   "winter_half": 361
  },
  "CT13": {
   "cells": 33,
   "mm": 651,
   "n": 386,
   "periods": {
    "1961-1990": 614,
    "1981-2010": 627,
    "1991-2020": 651
   },
   "seasons": {
    "djf": 177,
    "jja": 146,
    "mam": 121,
    "son": 207
   },
   "summer_half": 267,
   "winter_half": 385
  },
  "CT14": {
   "cells": 55,
   "mm": 736,
   "n": 1182,
   "periods": {
    "1961-1990": 694,
    "1981-2010": 704,
    "1991-2020": 736
   },
   "seasons": {
    "djf": 212,
    "jja": 155,
    "mam": 134,
    "son": 235
   },
   "summer_half": 289,
   "winter_half": 447
  },
  "CT15": {
   "cells": 104,
   "mm": 854,
   "n": 607,
   "periods": {
    "1961-1990": 811,
    "1981-2010": 827,
    "1991-2020": 854
   },
   "seasons": {
    "djf": 250,
    "jja": 175,
    "mam": 156,
    "son": 273
   },
   "summer_half": 331,
   "winter_half": 523
  },
  "CT16": {
   "cells": 19,
   "mm": 878,
   "n": 655,
   "periods": {
    "1961-1990": 825,
    "1981-2010": 843,
    "1991-2020": 878
   },
   "seasons": {
    "djf": 259,
    "jja": 175,
    "mam": 160,
    "son": 283
   },
   "summer_half": 335,
   "winter_half": 542
  },
  "CT17": {
   "cells": 15,
   "mm": 879,
   "n": 534,
   "periods": {
    "1961-1990": 830,
    "1981-2010": 844,
    "1991-2020": 879
   },
   "seasons": {
    "djf": 263,
    "jja": 175,
    "mam": 160,
    "son": 281
   },
   "summer_half": 335,
   "winter_half": 545
  },
  "CT18": {
   "cells": 55,
   "mm": 882,
   "n": 451,
   "periods": {
    "1961-1990": 835,
    "1981-2010": 863,
    "1991-2020": 882
   },
   "seasons": {
    "djf": 259,
    "jja": 185,
    "mam": 158,
    "son": 281
   },
   "summer_half": 343,
   "winter_half": 539
  },
  "CT19": {
   "cells": 14,
   "mm": 802,
   "n": 642,
   "periods": {
    "1961-1990": 740,
    "1981-2010": 777,
    "1991-2020": 802
   },
   "seasons": {
    "djf": 234,
    "jja": 170,
    "mam": 143,
    "son": 255
   },
   "summer_half": 313,
   "winter_half": 488
  },
  "CT2": {
   "cells": 43,
   "mm": 678,
   "n": 763,
   "periods": {
    "1961-1990": 645,
    "1981-2010": 663,
    "1991-2020": 678
   },
   "seasons": {
    "djf": 183,
    "jja": 156,
    "mam": 130,
    "son": 209
   },
   "summer_half": 287,
   "winter_half": 392
  },
  "CT20": {
   "cells": 10,
   "mm": 789,
   "n": 827,
   "periods": {
    "1961-1990": 731,
    "1981-2010": 764,
    "1991-2020": 789
   },
   "seasons": {
    "djf": 230,
    "jja": 167,
    "mam": 140,
    "son": 251
   },
   "summer_half": 308,
   "winter_half": 482
  },
  "CT21": {
   "cells": 39,
   "mm": 771,
   "n": 668,
   "periods": {
    "1961-1990": 733,
    "1981-2010": 751,
    "1991-2020": 771
   },
   "seasons": {
    "djf": 223,
    "jja": 164,
    "mam": 135,
    "son": 249
   },
   "summer_half": 300,
   "winter_half": 471
  },
  "CT3": {
   "cells": 126,
   "mm": 664,
   "n": 788,
   "periods": {
    "1961-1990": 640,
    "1981-2010": 651,
    "1991-2020": 664
   },
   "seasons": {
    "djf": 183,
    "jja": 149,
    "mam": 128,
    "son": 205
   },
   "summer_half": 276,
   "winter_half": 388
  },
  "CT4": {
   "cells": 186,
   "mm": 810,
   "n": 810,
   "periods": {
    "1961-1990": 767,
    "1981-2010": 787,
    "1991-2020": 810
   },
   "seasons": {
    "djf": 237,
    "jja": 171,
    "mam": 151,
    "son": 251
   },
   "summer_half": 322,
   "winter_half": 487
  },
  "CT5": {
   "cells": 31,
   "mm": 632,
   "n": 991,
   "periods": {
    "1961-1990": 607,
    "1981-2010": 619,
    "1991-2020": 632
   },
   "seasons": {
    "djf": 165,
    "jja": 149,
    "mam": 120,
    "son": 197
   },
   "summer_half": 269,
   "winter_half": 362
  },
  "CT50": {
   "cells": 1,
   "mm": 780,
   "n": 5,
   "periods": {
    "1961-1990": 720,
    "1981-2010": 755,
    "1991-2020": 780
   },
   "seasons": {
    "djf": 226,
    "jja": 167,
    "mam": 139,
    "son": 249
   },
   "summer_half": 306,
   "winter_half": 474
  },
  "CT6": {
   "cells": 32,
   "mm": 594,
   "n": 1064,
   "periods": {
    "1961-1990": 578,
    "1981-2010": 591,
    "1991-2020": 594
   },
   "seasons": {
    "djf": 154,
    "jja": 142,
    "mam": 117,
    "son": 182
   },
   "summer_half": 259,
   "winter_half": 336
  },
  "CT7": {
   "cells": 26,
   "mm": 622,
   "n": 414,
   "periods": {
    "1961-1990": 590,
    "1981-2010": 605,
    "1991-2020": 622
   },
   "seasons": {
    "djf": 161,
    "jja": 147,
    "mam": 122,
    "son": 192
   },
   "summer_half": 269,
   "winter_half": 353
  },
  "CT8": {
   "cells": 5,
   "mm": 608,
   "n": 217,
   "periods": {
    "1961-1990": 571,
    "1981-2010": 588,
    "1991-2020": 608
   },
   "seasons": {
    "djf": 155,
    "jja": 146,
    "mam": 119,
    "son": 189
   },
   "summer_half": 265,
   "winter_half": 343
  },
  "CT9": {
   "cells": 21,
   "mm": 607,
   "n": 1212,
   "periods": {
    "1961-1990": 579,
    "1981-2010": 593,
    "1991-2020": 607
   },
   "seasons": {
    "djf": 153,
    "jja": 146,
    "mam": 117,
    "son": 190
   },
   "summer_half": 264,
   "winter_half": 343
  },
  "CV1": {
   "cells": 9,
   "mm": 683,
   "n": 761,
   "periods": {
    "1961-1990": 648,
    "1981-2010": 670,
    "1991-2020": 683
   },
   "seasons": {
    "djf": 170,
    "jja": 176,
    "mam": 146,
    "son": 190
   },
   "summer_half": 322,
   "winter_half": 360
  },
  "CV10": {
   "cells": 63,
   "mm": 708,
   "n": 1042,
   "periods": {
    "1961-1990": 675,
    "1981-2010": 703,
    "1991-2020": 708
   },
   "seasons": {
    "djf": 173,
    "jja": 190,
    "mam": 150,
    "son": 196
   },
   "summer_half": 340,
   "winter_half": 369
  },
  "CV11": {
   "cells": 32,
   "mm": 677,
   "n": 954,
   "periods": {
    "1961-1990": 646,
    "1981-2010": 674,
    "1991-2020": 677
   },
   "seasons": {
    "djf": 167,
    "jja": 180,
    "mam": 143,
    "son": 187
   },
   "summer_half": 324,
   "winter_half": 354
  },
  "CV12": {
   "cells": 25,
   "mm": 698,
   "n": 664,
   "periods": {
    "1961-1990": 662,
    "1981-2010": 689,
    "1991-2020": 698
   },
   "seasons": {
    "djf": 171,
    "jja": 186,
    "mam": 149,
    "son": 192
   },
   "summer_half": 336,
   "winter_half": 362
  },
  "CV13": {
   "cells": 89,
   "mm": 695,
   "n": 371,
   "periods": {
    "1961-1990": 646,
    "1981-2010": 677,
    "1991-2020": 695
   },
   "seasons": {
    "djf": 167,
    "jja": 193,
    "mam": 143,
    "son": 193
   },
   "summer_half": 336,
   "winter_half": 359
  },
  "CV2": {
   "cells": 32,
   "mm": 705,
   "n": 1239,
   "periods": {
    "1961-1990": 667,
    "1981-2010": 694,
    "1991-2020": 705
   },
   "seasons": {
    "djf": 177,
    "jja": 189,
    "mam": 151,
    "son": 188
   },
   "summer_half": 340,
   "winter_half": 365
  },
  "CV21": {
   "cells": 27,
   "mm": 668,
   "n": 995,
   "periods": {
    "1961-1990": 644,
    "1981-2010": 664,
    "1991-2020": 668
   },
   "seasons": {
    "djf": 161,
    "jja": 179,
    "mam": 142,
    "son": 186
   },
   "summer_half": 321,
   "winter_half": 347
  },
  "CV22": {
   "cells": 27,
   "mm": 658,
   "n": 842,
   "periods": {
    "1961-1990": 644,
    "1981-2010": 657,
    "1991-2020": 658
   },
   "seasons": {
    "djf": 161,
    "jja": 179,
    "mam": 137,
    "son": 181
   },
   "summer_half": 316,
   "winter_half": 341
  },
  "CV23": {
   "cells": 192,
   "mm": 670,
   "n": 882,
   "periods": {
    "1961-1990": 650,
    "1981-2010": 669,
    "1991-2020": 670
   },
   "seasons": {
    "djf": 162,
    "jja": 180,
    "mam": 142,
    "son": 185
   },
   "summer_half": 322,
   "winter_half": 347
  },
  "CV3": {
   "cells": 40,
   "mm": 666,
   "n": 1364,
   "periods": {
    "1961-1990": 638,
    "1981-2010": 665,
    "1991-2020": 666
   },
   "seasons": {
    "djf": 163,
    "jja": 172,
    "mam": 143,
    "son": 187
   },
   "summer_half": 315,
   "winter_half": 351
  },
  "CV31": {
   "cells": 22,
   "mm": 648,
   "n": 809,
   "periods": {
    "1961-1990": 618,
    "1981-2010": 642,
    "1991-2020": 648
   },
   "seasons": {
    "djf": 153,
    "jja": 177,
    "mam": 142,
    "son": 176
   },
   "summer_half": 319,
   "winter_half": 329
  },
  "CV32": {
   "cells": 21,
   "mm": 662,
   "n": 919,
   "periods": {
    "1961-1990": 636,
    "1981-2010": 663,
    "1991-2020": 662
   },
   "seasons": {
    "djf": 159,
    "jja": 177,
    "mam": 144,
    "son": 182
   },
   "summer_half": 321,
   "winter_half": 341
  },
  "CV33": {
   "cells": 64,
   "mm": 646,
   "n": 343,
   "periods": {
    "1961-1990": 615,
    "1981-2010": 639,
    "1991-2020": 646
   },
   "seasons": {
    "djf": 152,
    "jja": 175,
    "mam": 143,
    "son": 176
   },
   "summer_half": 318,
   "winter_half": 328
  },
  "CV34": {
   "cells": 29,
   "mm": 695,
   "n": 1000,
   "periods": {
    "1961-1990": 653,
    "1981-2010": 685,
    "1991-2020": 695
   },
   "seasons": {
    "djf": 164,
    "jja": 187,
    "mam": 151,
    "son": 193
   },
   "summer_half": 337,
   "winter_half": 357
  },
  "CV35": {
   "cells": 198,
   "mm": 678,
   "n": 985,
   "periods": {
    "1961-1990": 638,
    "1981-2010": 667,
    "1991-2020": 678
   },
   "seasons": {
    "djf": 162,
    "jja": 182,
    "mam": 150,
    "son": 185
   },
   "summer_half": 332,
   "winter_half": 347
  },
  "CV36": {
   "cells": 83,
   "mm": 654,
   "n": 415,
   "periods": {
    "1961-1990": 630,
    "1981-2010": 642,
    "1991-2020": 654
   },
   "seasons": {
    "djf": 163,
    "jja": 165,
    "mam": 145,
    "son": 180
   },
   "summer_half": 310,
   "winter_half": 343
  },
  "CV37": {
   "cells": 166,
   "mm": 641,
   "n": 1598,
   "periods": {
    "1961-1990": 607,
    "1981-2010": 631,
    "1991-2020": 641
   },
   "seasons": {
    "djf": 148,
    "jja": 176,
    "mam": 142,
    "son": 174
   },
   "summer_half": 318,
   "winter_half": 323
  },
  "CV4": {
   "cells": 24,
   "mm": 696,
   "n": 687,
   "periods": {
    "1961-1990": 657,
    "1981-2010": 689,
    "1991-2020": 696
   },
   "seasons": {
    "djf": 176,
    "jja": 174,
    "mam": 150,
    "son": 196
   },
   "summer_half": 324,
   "winter_half": 372
  },
  "CV47": {
   "cells": 96,
   "mm": 675,
   "n": 645,
   "periods": {
    "1961-1990": 643,
    "1981-2010": 665,
    "1991-2020": 675
   },
   "seasons": {
    "djf": 160,
    "jja": 178,
    "mam": 149,
    "son": 187
   },
   "summer_half": 327,
   "winter_half": 348
  },
  "CV5": {
   "cells": 33,
   "mm": 712,
   "n": 910,
   "periods": {
    "1961-1990": 674,
    "1981-2010": 699,
    "1991-2020": 712
   },
   "seasons": {
    "djf": 180,
    "jja": 185,
    "mam": 150,
    "son": 198
   },
   "summer_half": 335,
   "winter_half": 377
  },
  "CV6": {
   "cells": 32,
   "mm": 706,
   "n": 1539,
   "periods": {
    "1961-1990": 670,
    "1981-2010": 693,
    "1991-2020": 706
   },
   "seasons": {
    "djf": 177,
    "jja": 189,
    "mam": 149,
    "son": 192
   },
   "summer_half": 338,
   "winter_half": 369
  },
  "CV7": {
   "cells": 120,
   "mm": 733,
   "n": 796,
   "periods": {
    "1961-1990": 698,
    "1981-2010": 725,
    "1991-2020": 733
   },
   "seasons": {
    "djf": 183,
    "jja": 196,
    "mam": 152,
    "son": 203
   },
   "summer_half": 348,
   "winter_half": 385
  },
  "CV8": {
   "cells": 82,
   "mm": 682,
   "n": 807,
   "periods": {
    "1961-1990": 655,
    "1981-2010": 685,
    "1991-2020": 682
   },
   "seasons": {
    "djf": 169,
    "jja": 178,
    "mam": 147,
    "son": 189
   },
   "summer_half": 325,
   "winter_half": 358
  },
  "CV9": {
   "cells": 82,
   "mm": 678,
   "n": 679,
   "periods": {
    "1961-1990": 640,
    "1981-2010": 668,
    "1991-2020": 678
   },
   "seasons": {
    "djf": 164,
    "jja": 187,
    "mam": 142,
    "son": 185
   },
   "summer_half": 329,
   "winter_half": 349
  },
  "CW1": {
   "cells": 48,
   "mm": 720,
   "n": 1174,
   "periods": {
    "1961-1990": 713,
    "1981-2010": 716,
    "1991-2020": 720
   },
   "seasons": {
    "djf": 177,
    "jja": 199,
    "mam": 142,
    "son": 202
   },
   "summer_half": 341,
   "winter_half": 378
  },
  "CW10": {
   "cells": 52,
   "mm": 764,
   "n": 453,
   "periods": {
    "1961-1990": 741,
    "1981-2010": 750,
    "1991-2020": 764
   },
   "seasons": {
    "djf": 192,
    "jja": 206,
    "mam": 154,
    "son": 212
   },
   "summer_half": 359,
   "winter_half": 405
  },
  "CW11": {
   "cells": 65,
   "mm": 745,
   "n": 823,
   "periods": {
    "1961-1990": 727,
    "1981-2010": 735,
    "1991-2020": 745
   },
   "seasons": {
    "djf": 186,
    "jja": 201,
    "mam": 150,
    "son": 209
   },
   "summer_half": 351,
   "winter_half": 394
  },
  "CW12": {
   "cells": 83,
   "mm": 824,
   "n": 1066,
   "periods": {
    "1961-1990": 808,
    "1981-2010": 814,
    "1991-2020": 824
   },
   "seasons": {
    "djf": 211,
    "jja": 219,
    "mam": 165,
    "son": 229
   },
   "summer_half": 384,
   "winter_half": 441
  },
  "CW2": {
   "cells": 52,
   "mm": 731,
   "n": 1043,
   "periods": {
    "1961-1990": 710,
    "1981-2010": 724,
    "1991-2020": 731
   },
   "seasons": {
    "djf": 181,
    "jja": 201,
    "mam": 145,
    "son": 204
   },
   "summer_half": 345,
   "winter_half": 385
  },
  "CW3": {
   "cells": 56,
   "mm": 763,
   "n": 348,
   "periods": {
    "1961-1990": 725,
    "1981-2010": 751,
    "1991-2020": 763
   },
   "seasons": {
    "djf": 190,
    "jja": 203,
    "mam": 157,
    "son": 213
   },
   "summer_half": 359,
   "winter_half": 403
  },
  "CW4": {
   "cells": 36,
   "mm": 782,
   "n": 344,
   "periods": {
    "1961-1990": 754,
    "1981-2010": 764,
    "1991-2020": 782
   },
   "seasons": {
    "djf": 197,
    "jja": 206,
    "mam": 157,
    "son": 221
   },
   "summer_half": 363,
   "winter_half": 419
  },
  "CW5": {
   "cells": 136,
   "mm": 735,
   "n": 1008,
   "periods": {
    "1961-1990": 713,
    "1981-2010": 724,
    "1991-2020": 735
   },
   "seasons": {
    "djf": 181,
    "jja": 197,
    "mam": 148,
    "son": 208
   },
   "summer_half": 346,
   "winter_half": 389
  },
  "CW6": {
   "cells": 107,
   "mm": 776,
   "n": 557,
   "periods": {
    "1961-1990": 761,
    "1981-2010": 762,
    "1991-2020": 776
   },
   "seasons": {
    "djf": 188,
    "jja": 205,
    "mam": 157,
    "son": 226
   },
   "summer_half": 361,
   "winter_half": 415
  },
  "CW7": {
   "cells": 49,
   "mm": 764,
   "n": 870,
   "periods": {
    "1961-1990": 742,
    "1981-2010": 753,
    "1991-2020": 764
   },
   "seasons": {
    "djf": 188,
    "jja": 203,
    "mam": 156,
    "son": 216
   },
   "summer_half": 359,
   "winter_half": 405
  },
  "CW8": {
   "cells": 77,
   "mm": 804,
   "n": 1116,
   "periods": {
    "1961-1990": 788,
    "1981-2010": 790,
    "1991-2020": 804
   },
   "seasons": {
    "djf": 203,
    "jja": 209,
    "mam": 162,
    "son": 230
   },
   "summer_half": 372,
   "winter_half": 433
  },
  "CW9": {
   "cells": 79,
   "mm": 817,
   "n": 1054,
   "periods": {
    "1961-1990": 792,
    "1981-2010": 802,
    "1991-2020": 817
   },
   "seasons": {
    "djf": 209,
    "jja": 211,
    "mam": 164,
    "son": 233
   },
   "summer_half": 375,
   "winter_half": 442
  },
  "CW98": {
   "cells": 1,
   "mm": 734,
   "n": 2,
   "periods": {
    "1961-1990": 719,
    "1981-2010": 728,
    "1991-2020": 734
   },
   "seasons": {
    "djf": 181,
    "jja": 205,
    "mam": 142,
    "son": 205
   },
   "summer_half": 348,
   "winter_half": 386
  },
  "DA1": {
   "cells": 25,
   "mm": 588,
   "n": 1268,
   "periods": {
    "1961-1990": 567,
    "1981-2010": 571,
    "1991-2020": 588
   },
   "seasons": {
    "djf": 154,
    "jja": 142,
    "mam": 119,
    "son": 173
   },
   "summer_half": 260,
   "winter_half": 327
  },
  "DA10": {
   "cells": 11,
   "mm": 580,
   "n": 286,
   "periods": {
    "1961-1990": 556,
    "1981-2010": 568,
    "1991-2020": 580
   },
   "seasons": {
    "djf": 151,
    "jja": 139,
    "mam": 118,
    "son": 172
   },
   "summer_half": 257,
   "winter_half": 323
  },
  "DA11": {
   "cells": 17,
   "mm": 574,
   "n": 851,
   "periods": {
    "1961-1990": 553,
    "1981-2010": 560,
    "1991-2020": 574
   },
   "seasons": {
    "djf": 149,
    "jja": 135,
    "mam": 119,
    "son": 172
   },
   "summer_half": 254,
   "winter_half": 321
  },
  "DA12": {
   "cells": 36,
   "mm": 606,
   "n": 979,
   "periods": {
    "1961-1990": 596,
    "1981-2010": 596,
    "1991-2020": 606
   },
   "seasons": {
    "djf": 160,
    "jja": 138,
    "mam": 123,
    "son": 184
   },
   "summer_half": 261,
   "winter_half": 344
  },
  "DA13": {
   "cells": 43,
   "mm": 676,
   "n": 377,
   "periods": {
    "1961-1990": 669,
    "1981-2010": 669,
    "1991-2020": 676
   },
   "seasons": {
    "djf": 188,
    "jja": 148,
    "mam": 137,
    "son": 204
   },
   "summer_half": 285,
   "winter_half": 391
  },
  "DA14": {
   "cells": 16,
   "mm": 618,
   "n": 510,
   "periods": {
    "1961-1990": 596,
    "1981-2010": 601,
    "1991-2020": 618
   },
   "seasons": {
    "djf": 166,
    "jja": 142,
    "mam": 125,
    "son": 185
   },
   "summer_half": 267,
   "winter_half": 351
  },
  "DA15": {
   "cells": 14,
   "mm": 607,
   "n": 499,
   "periods": {
    "1961-1990": 593,
    "1981-2010": 593,
    "1991-2020": 607
   },
   "seasons": {
    "djf": 162,
    "jja": 140,
    "mam": 125,
    "son": 180
   },
   "summer_half": 265,
   "winter_half": 341
  },
  "DA16": {
   "cells": 14,
   "mm": 611,
   "n": 567,
   "periods": {
    "1961-1990": 601,
    "1981-2010": 602,
    "1991-2020": 611
   },
   "seasons": {
    "djf": 162,
    "jja": 145,
    "mam": 127,
    "son": 177
   },
   "summer_half": 272,
   "winter_half": 339
  },
  "DA17": {
   "cells": 13,
   "mm": 582,
   "n": 342,
   "periods": {
    "1961-1990": 556,
    "1981-2010": 564,
    "1991-2020": 582
   },
   "seasons": {
    "djf": 152,
    "jja": 142,
    "mam": 117,
    "son": 171
   },
   "summer_half": 259,
   "winter_half": 323
  },
  "DA18": {
   "cells": 4,
   "mm": 558,
   "n": 68,
   "periods": {
    "1961-1990": 531,
    "1981-2010": 539,
    "1991-2020": 558
   },
   "seasons": {
    "djf": 144,
    "jja": 137,
    "mam": 112,
    "son": 165
   },
   "summer_half": 249,
   "winter_half": 309
  },
  "DA2": {
   "cells": 35,
   "mm": 623,
   "n": 515,
   "periods": {
    "1961-1990": 598,
    "1981-2010": 609,
    "1991-2020": 623
   },
   "seasons": {
    "djf": 165,
    "jja": 146,
    "mam": 126,
    "son": 186
   },
   "summer_half": 271,
   "winter_half": 351
  },
  "DA3": {
   "cells": 25,
   "mm": 667,
   "n": 354,
   "periods": {
    "1961-1990": 660,
    "1981-2010": 660,
    "1991-2020": 667
   },
   "seasons": {
    "djf": 183,
    "jja": 148,
    "mam": 136,
    "son": 201
   },
   "summer_half": 284,
   "winter_half": 383
  },
  "DA4": {
   "cells": 31,
   "mm": 676,
   "n": 243,
   "periods": {
    "1961-1990": 652,
    "1981-2010": 666,
    "1991-2020": 676
   },
   "seasons": {
    "djf": 193,
    "jja": 147,
    "mam": 137,
    "son": 200
   },
   "summer_half": 283,
   "winter_half": 393
  },
  "DA5": {
   "cells": 16,
   "mm": 602,
   "n": 439,
   "periods": {
    "1961-1990": 581,
    "1981-2010": 585,
    "1991-2020": 602
   },
   "seasons": {
    "djf": 161,
    "jja": 142,
    "mam": 123,
    "son": 176
   },
   "summer_half": 265,
   "winter_half": 337
  },
  "DA6": {
   "cells": 7,
   "mm": 599,
   "n": 250,
   "periods": {
    "1961-1990": 584,
    "1981-2010": 587,
    "1991-2020": 599
   },
   "seasons": {
    "djf": 160,
    "jja": 142,
    "mam": 123,
    "son": 174
   },
   "summer_half": 265,
   "winter_half": 334
  },
  "DA7": {
   "cells": 14,
   "mm": 603,
   "n": 674,
   "periods": {
    "1961-1990": 586,
    "1981-2010": 590,
    "1991-2020": 603
   },
   "seasons": {
    "djf": 160,
    "jja": 145,
    "mam": 123,
    "son": 175
   },
   "summer_half": 268,
   "winter_half": 335
  },
  "DA8": {
   "cells": 12,
   "mm": 583,
   "n": 653,
   "periods": {
    "1961-1990": 559,
    "1981-2010": 566,
    "1991-2020": 583
   },
   "seasons": {
    "djf": 154,
    "jja": 142,
    "mam": 117,
    "son": 170
   },
   "summer_half": 259,
   "winter_half": 324
  },
  "DA9": {
   "cells": 9,
   "mm": 587,
   "n": 338,
   "periods": {
    "1961-1990": 563,
    "1981-2010": 577,
    "1991-2020": 587
   },
   "seasons": {
    "djf": 152,
    "jja": 143,
    "mam": 117,
    "son": 174
   },
   "summer_half": 261,
   "winter_half": 327
  },
  "DD1": {
   "cells": 8,
   "mm": 728,
   "n": 599,
   "periods": {
    "1961-1990": 669,
    "1981-2010": 698,
    "1991-2020": 728
   },
   "seasons": {
    "djf": 177,
    "jja": 206,
    "mam": 144,
    "son": 202
   },
   "summer_half": 350,
   "winter_half": 378
  },
  "DD10": {
   "cells": 96,
   "mm": 773,
   "n": 686,
   "periods": {
    "1961-1990": 691,
    "1981-2010": 732,
    "1991-2020": 773
   },
   "seasons": {
    "djf": 185,
    "jja": 206,
    "mam": 152,
    "son": 230
   },
   "summer_half": 359,
   "winter_half": 414
  },
  "DD11": {
   "cells": 118,
   "mm": 763,
   "n": 943,
   "periods": {
    "1961-1990": 677,
    "1981-2010": 714,
    "1991-2020": 763
   },
   "seasons": {
    "djf": 184,
    "jja": 208,
    "mam": 150,
    "son": 220
   },
   "summer_half": 358,
   "winter_half": 404
  },
  "DD2": {
   "cells": 66,
   "mm": 812,
   "n": 1261,
   "periods": {
    "1961-1990": 731,
    "1981-2010": 776,
    "1991-2020": 812
   },
   "seasons": {
    "djf": 203,
    "jja": 226,
    "mam": 159,
    "son": 223
   },
   "summer_half": 386,
   "winter_half": 426
  },
  "DD3": {
   "cells": 41,
   "mm": 849,
   "n": 1116,
   "periods": {
    "1961-1990": 773,
    "1981-2010": 814,
    "1991-2020": 849
   },
   "seasons": {
    "djf": 210,
    "jja": 232,
    "mam": 167,
    "son": 239
   },
   "summer_half": 399,
   "winter_half": 449
  },
  "DD4": {
   "cells": 47,
   "mm": 842,
   "n": 1155,
   "periods": {
    "1961-1990": 773,
    "1981-2010": 809,
    "1991-2020": 842
   },
   "seasons": {
    "djf": 213,
    "jja": 225,
    "mam": 165,
    "son": 240
   },
   "summer_half": 389,
   "winter_half": 453
  },
  "DD5": {
   "cells": 49,
   "mm": 810,
   "n": 980,
   "periods": {
    "1961-1990": 746,
    "1981-2010": 779,
    "1991-2020": 810
   },
   "seasons": {
    "djf": 200,
    "jja": 219,
    "mam": 162,
    "son": 229
   },
   "summer_half": 381,
   "winter_half": 429
  },
  "DD6": {
   "cells": 34,
   "mm": 751,
   "n": 355,
   "periods": {
    "1961-1990": 690,
    "1981-2010": 722,
    "1991-2020": 751
   },
   "seasons": {
    "djf": 186,
    "jja": 213,
    "mam": 147,
    "son": 205
   },
   "summer_half": 360,
   "winter_half": 391
  },
  "DD7": {
   "cells": 27,
   "mm": 729,
   "n": 377,
   "periods": {
    "1961-1990": 668,
    "1981-2010": 697,
    "1991-2020": 729
   },
   "seasons": {
    "djf": 180,
    "jja": 194,
    "mam": 152,
    "son": 204
   },
   "summer_half": 346,
   "winter_half": 383
  },
  "DD8": {
   "cells": 323,
   "mm": 878,
   "n": 1219,
   "periods": {
    "1961-1990": 793,
    "1981-2010": 831,
    "1991-2020": 878
   },
   "seasons": {
    "djf": 225,
    "jja": 227,
    "mam": 175,
    "son": 252
   },
   "summer_half": 401,
   "winter_half": 477
  },
  "DD9": {
   "cells": 131,
   "mm": 888,
   "n": 430,
   "periods": {
    "1961-1990": 802,
    "1981-2010": 841,
    "1991-2020": 888
   },
   "seasons": {
    "djf": 230,
    "jja": 226,
    "mam": 176,
    "son": 255
   },
   "summer_half": 403,
   "winter_half": 485
  },
  "DE1": {
   "cells": 10,
   "mm": 705,
   "n": 700,
   "periods": {
    "1961-1990": 675,
    "1981-2010": 698,
    "1991-2020": 705
   },
   "seasons": {
    "djf": 175,
    "jja": 196,
    "mam": 142,
    "son": 192
   },
   "summer_half": 338,
   "winter_half": 367
  },
  "DE11": {
   "cells": 38,
   "mm": 695,
   "n": 1083,
   "periods": {
    "1961-1990": 654,
    "1981-2010": 677,
    "1991-2020": 695
   },
   "seasons": {
    "djf": 167,
    "jja": 189,
    "mam": 147,
    "son": 193
   },
   "summer_half": 336,
   "winter_half": 360
  },
  "DE12": {
   "cells": 84,
   "mm": 692,
   "n": 568,
   "periods": {
    "1961-1990": 646,
    "1981-2010": 674,
    "1991-2020": 692
   },
   "seasons": {
    "djf": 167,
    "jja": 188,
    "mam": 143,
    "son": 194
   },
   "summer_half": 331,
   "winter_half": 361
  },
  "DE13": {
   "cells": 129,
   "mm": 707,
   "n": 989,
   "periods": {
    "1961-1990": 678,
    "1981-2010": 698,
    "1991-2020": 707
   },
   "seasons": {
    "djf": 174,
    "jja": 188,
    "mam": 152,
    "son": 194
   },
   "summer_half": 339,
   "winter_half": 368
  },
  "DE14": {
   "cells": 22,
   "mm": 679,
   "n": 800,
   "periods": {
    "1961-1990": 645,
    "1981-2010": 666,
    "1991-2020": 679
   },
   "seasons": {
    "djf": 166,
    "jja": 181,
    "mam": 143,
    "son": 188
   },
   "summer_half": 325,
   "winter_half": 354
  },
  "DE15": {
   "cells": 37,
   "mm": 699,
   "n": 544,
   "periods": {
    "1961-1990": 662,
    "1981-2010": 679,
    "1991-2020": 699
   },
   "seasons": {
    "djf": 170,
    "jja": 188,
    "mam": 148,
    "son": 194
   },
   "summer_half": 336,
   "winter_half": 364
  },
  "DE21": {
   "cells": 43,
   "mm": 706,
   "n": 1260,
   "periods": {
    "1961-1990": 680,
    "1981-2010": 700,
    "1991-2020": 706
   },
   "seasons": {
    "djf": 174,
    "jja": 195,
    "mam": 143,
    "son": 194
   },
   "summer_half": 338,
   "winter_half": 368
  },
  "DE22": {
   "cells": 40,
   "mm": 756,
   "n": 1086,
   "periods": {
    "1961-1990": 732,
    "1981-2010": 754,
    "1991-2020": 756
   },
   "seasons": {
    "djf": 190,
    "jja": 205,
    "mam": 153,
    "son": 209
   },
   "summer_half": 358,
   "winter_half": 399
  },
  "DE23": {
   "cells": 21,
   "mm": 686,
   "n": 1089,
   "periods": {
    "1961-1990": 650,
    "1981-2010": 673,
    "1991-2020": 686
   },
   "seasons": {
    "djf": 169,
    "jja": 192,
    "mam": 140,
    "son": 185
   },
   "summer_half": 332,
   "winter_half": 354
  },
  "DE24": {
   "cells": 27,
   "mm": 650,
   "n": 1190,
   "periods": {
    "1961-1990": 619,
    "1981-2010": 639,
    "1991-2020": 650
   },
   "seasons": {
    "djf": 159,
    "jja": 188,
    "mam": 130,
    "son": 174
   },
   "summer_half": 318,
   "winter_half": 333
  },
  "DE3": {
   "cells": 15,
   "mm": 703,
   "n": 461,
   "periods": {
    "1961-1990": 671,
    "1981-2010": 692,
    "1991-2020": 703
   },
   "seasons": {
    "djf": 176,
    "jja": 189,
    "mam": 147,
    "son": 190
   },
   "summer_half": 337,
   "winter_half": 366
  },
  "DE4": {
   "cells": 141,
   "mm": 966,
   "n": 1023,
   "periods": {
    "1961-1990": 927,
    "1981-2010": 955,
    "1991-2020": 966
   },
   "seasons": {
    "djf": 265,
    "jja": 236,
    "mam": 196,
    "son": 269
   },
   "summer_half": 432,
   "winter_half": 534
  },
  "DE45": {
   "cells": 73,
   "mm": 1005,
   "n": 312,
   "periods": {
    "1961-1990": 967,
    "1981-2010": 990,
    "1991-2020": 1005
   },
   "seasons": {
    "djf": 285,
    "jja": 235,
    "mam": 205,
    "son": 281
   },
   "summer_half": 440,
   "winter_half": 565
  },
  "DE5": {
   "cells": 31,
   "mm": 784,
   "n": 537,
   "periods": {
    "1961-1990": 757,
    "1981-2010": 776,
    "1991-2020": 784
   },
   "seasons": {
    "djf": 200,
    "jja": 202,
    "mam": 161,
    "son": 221
   },
   "summer_half": 363,
   "winter_half": 421
  },
  "DE55": {
   "cells": 89,
   "mm": 819,
   "n": 1241,
   "periods": {
    "1961-1990": 780,
    "1981-2010": 799,
    "1991-2020": 819
   },
   "seasons": {
    "djf": 215,
    "jja": 201,
    "mam": 169,
    "son": 234
   },
   "summer_half": 370,
   "winter_half": 449
  },
  "DE56": {
   "cells": 89,
   "mm": 843,
   "n": 912,
   "periods": {
    "1961-1990": 809,
    "1981-2010": 836,
    "1991-2020": 843
   },
   "seasons": {
    "djf": 219,
    "jja": 217,
    "mam": 169,
    "son": 238
   },
   "summer_half": 386,
   "winter_half": 457
  },
  "DE6": {
   "cells": 263,
   "mm": 887,
   "n": 788,
   "periods": {
    "1961-1990": 855,
    "1981-2010": 883,
    "1991-2020": 887
   },
   "seasons": {
    "djf": 239,
    "jja": 218,
    "mam": 181,
    "son": 249
   },
   "summer_half": 399,
   "winter_half": 488
  },
  "DE65": {
   "cells": 74,
   "mm": 705,
   "n": 552,
   "periods": {
    "1961-1990": 668,
    "1981-2010": 690,
    "1991-2020": 705
   },
   "seasons": {
    "djf": 175,
    "jja": 189,
    "mam": 147,
    "son": 194
   },
   "summer_half": 336,
   "winter_half": 369
  },
  "DE7": {
   "cells": 61,
   "mm": 723,
   "n": 1147,
   "periods": {
    "1961-1990": 695,
    "1981-2010": 714,
    "1991-2020": 723
   },
   "seasons": {
    "djf": 177,
    "jja": 201,
    "mam": 145,
    "son": 200
   },
   "summer_half": 346,
   "winter_half": 377
  },
  "DE72": {
   "cells": 54,
   "mm": 669,
   "n": 452,
   "periods": {
    "1961-1990": 641,
    "1981-2010": 662,
    "1991-2020": 669
   },
   "seasons": {
    "djf": 163,
    "jja": 188,
    "mam": 135,
    "son": 183
   },
   "summer_half": 323,
   "winter_half": 346
  },
  "DE73": {
   "cells": 56,
   "mm": 687,
   "n": 535,
   "periods": {
    "1961-1990": 646,
    "1981-2010": 674,
    "1991-2020": 687
   },
   "seasons": {
    "djf": 169,
    "jja": 192,
    "mam": 140,
    "son": 186
   },
   "summer_half": 332,
   "winter_half": 355
  },
  "DE74": {
   "cells": 37,
   "mm": 648,
   "n": 340,
   "periods": {
    "1961-1990": 612,
    "1981-2010": 637,
    "1991-2020": 648
   },
   "seasons": {
    "djf": 156,
    "jja": 184,
    "mam": 134,
    "son": 174
   },
   "summer_half": 318,
   "winter_half": 331
  },
  "DE75": {
   "cells": 19,
   "mm": 743,
   "n": 345,
   "periods": {
    "1961-1990": 724,
    "1981-2010": 735,
    "1991-2020": 743
   },
   "seasons": {
    "djf": 186,
    "jja": 195,
    "mam": 153,
    "son": 208
   },
   "summer_half": 348,
   "winter_half": 394
  },
  "DE99": {
   "cells": 1,
   "mm": 676,
   "n": 1,
   "periods": {
    "1961-1990": 645,
    "1981-2010": 666,
    "1991-2020": 676
   },
   "seasons": {
    "djf": 167,
    "jja": 191,
    "mam": 135,
    "son": 182
   },
   "summer_half": 326,
   "winter_half": 350
  },
  "DG1": {
   "cells": 126,
   "mm": 1233,
   "n": 1064,
   "periods": {
    "1961-1990": 1086,
    "1981-2010": 1168,
    "1991-2020": 1233
   },
   "seasons": {
    "djf": 359,
    "jja": 282,
    "mam": 233,
    "son": 359
   },
   "summer_half": 515,
   "winter_half": 718
  },
  "DG10": {
   "cells": 55,
   "mm": 1468,
   "n": 220,
   "periods": {
    "1961-1990": 1337,
    "1981-2010": 1419,
    "1991-2020": 1468
   },
   "seasons": {
    "djf": 473,
    "jja": 299,
    "mam": 278,
    "son": 417
   },
   "summer_half": 577,
   "winter_half": 890
  },
  "DG11": {
   "cells": 264,
   "mm": 1249,
   "n": 651,
   "periods": {
    "1961-1990": 1135,
    "1981-2010": 1196,
    "1991-2020": 1249
   },
   "seasons": {
    "djf": 352,
    "jja": 309,
    "mam": 237,
    "son": 350
   },
   "summer_half": 546,
   "winter_half": 702
  },
  "DG12": {
   "cells": 67,
   "mm": 1039,
   "n": 479,
   "periods": {
    "1961-1990": 946,
    "1981-2010": 985,
    "1991-2020": 1039
   },
   "seasons": {
    "djf": 279,
    "jja": 273,
    "mam": 189,
    "son": 298
   },
   "summer_half": 461,
   "winter_half": 578
  },
  "DG13": {
   "cells": 59,
   "mm": 1557,
   "n": 141,
   "periods": {
    "1961-1990": 1360,
    "1981-2010": 1491,
    "1991-2020": 1557
   },
   "seasons": {
    "djf": 473,
    "jja": 356,
    "mam": 297,
    "son": 431
   },
   "summer_half": 653,
   "winter_half": 904
  },
  "DG14": {
   "cells": 42,
   "mm": 1235,
   "n": 77,
   "periods": {
    "1961-1990": 1135,
    "1981-2010": 1196,
    "1991-2020": 1235
   },
   "seasons": {
    "djf": 347,
    "jja": 313,
    "mam": 236,
    "son": 339
   },
   "summer_half": 549,
   "winter_half": 687
  },
  "DG16": {
   "cells": 22,
   "mm": 968,
   "n": 148,
   "periods": {
    "1961-1990": 892,
    "1981-2010": 924,
    "1991-2020": 968
   },
   "seasons": {
    "djf": 260,
    "jja": 251,
    "mam": 179,
    "son": 277
   },
   "summer_half": 430,
   "winter_half": 537
  },
  "DG2": {
   "cells": 218,
   "mm": 1351,
   "n": 889,
   "periods": {
    "1961-1990": 1209,
    "1981-2010": 1292,
    "1991-2020": 1351
   },
   "seasons": {
    "djf": 406,
    "jja": 294,
    "mam": 256,
    "son": 395
   },
   "summer_half": 550,
   "winter_half": 801
  },
  "DG3": {
   "cells": 120,
   "mm": 1456,
   "n": 266,
   "periods": {
    "1961-1990": 1276,
    "1981-2010": 1391,
    "1991-2020": 1456
   },
   "seasons": {
    "djf": 458,
    "jja": 300,
    "mam": 270,
    "son": 427
   },
   "summer_half": 571,
   "winter_half": 885
  },
  "DG4": {
   "cells": 44,
   "mm": 1566,
   "n": 171,
   "periods": {
    "1961-1990": 1396,
    "1981-2010": 1524,
    "1991-2020": 1566
   },
   "seasons": {
    "djf": 503,
    "jja": 300,
    "mam": 294,
    "son": 468
   },
   "summer_half": 595,
   "winter_half": 971
  },
  "DG5": {
   "cells": 38,
   "mm": 1306,
   "n": 217,
   "periods": {
    "1961-1990": 1199,
    "1981-2010": 1265,
    "1991-2020": 1306
   },
   "seasons": {
    "djf": 381,
    "jja": 290,
    "mam": 254,
    "son": 380
   },
   "summer_half": 544,
   "winter_half": 762
  },
  "DG6": {
   "cells": 85,
   "mm": 1321,
   "n": 264,
   "periods": {
    "1961-1990": 1215,
    "1981-2010": 1273,
    "1991-2020": 1321
   },
   "seasons": {
    "djf": 377,
    "jja": 298,
    "mam": 248,
    "son": 399
   },
   "summer_half": 546,
   "winter_half": 776
  },
  "DG7": {
   "cells": 312,
   "mm": 1497,
   "n": 677,
   "periods": {
    "1961-1990": 1343,
    "1981-2010": 1443,
    "1991-2020": 1497
   },
   "seasons": {
    "djf": 462,
    "jja": 309,
    "mam": 284,
    "son": 442
   },
   "summer_half": 593,
   "winter_half": 904
  },
  "DG8": {
   "cells": 345,
   "mm": 1314,
   "n": 833,
   "periods": {
    "1961-1990": 1220,
    "1981-2010": 1282,
    "1991-2020": 1314
   },
   "seasons": {
    "djf": 384,
    "jja": 278,
    "mam": 251,
    "son": 401
   },
   "summer_half": 529,
   "winter_half": 785
  },
  "DG9": {
   "cells": 205,
   "mm": 1147,
   "n": 808,
   "periods": {
    "1961-1990": 1103,
    "1981-2010": 1129,
    "1991-2020": 1147
   },
   "seasons": {
    "djf": 320,
    "jja": 254,
    "mam": 219,
    "son": 354
   },
   "summer_half": 473,
   "winter_half": 674
  },
  "DH1": {
   "cells": 52,
   "mm": 707,
   "n": 1332,
   "periods": {
    "1961-1990": 673,
    "1981-2010": 679,
    "1991-2020": 707
   },
   "seasons": {
    "djf": 165,
    "jja": 197,
    "mam": 144,
    "son": 201
   },
   "summer_half": 341,
   "winter_half": 366
  },
  "DH2": {
   "cells": 33,
   "mm": 716,
   "n": 712,
   "periods": {
    "1961-1990": 672,
    "1981-2010": 688,
    "1991-2020": 716
   },
   "seasons": {
    "djf": 164,
    "jja": 199,
    "mam": 147,
    "son": 206
   },
   "summer_half": 346,
   "winter_half": 370
  },
  "DH3": {
   "cells": 39,
   "mm": 706,
   "n": 769,
   "periods": {
    "1961-1990": 661,
    "1981-2010": 678,
    "1991-2020": 706
   },
   "seasons": {
    "djf": 164,
    "jja": 193,
    "mam": 146,
    "son": 204
   },
   "summer_half": 339,
   "winter_half": 367
  },
  "DH4": {
   "cells": 37,
   "mm": 697,
   "n": 963,
   "periods": {
    "1961-1990": 653,
    "1981-2010": 670,
    "1991-2020": 697
   },
   "seasons": {
    "djf": 160,
    "jja": 194,
    "mam": 144,
    "son": 198
   },
   "summer_half": 339,
   "winter_half": 358
  },
  "DH5": {
   "cells": 23,
   "mm": 715,
   "n": 554,
   "periods": {
    "1961-1990": 670,
    "1981-2010": 687,
    "1991-2020": 715
   },
   "seasons": {
    "djf": 163,
    "jja": 202,
    "mam": 145,
    "son": 204
   },
   "summer_half": 348,
   "winter_half": 367
  },
  "DH6": {
   "cells": 96,
   "mm": 723,
   "n": 1039,
   "periods": {
    "1961-1990": 672,
    "1981-2010": 693,
    "1991-2020": 723
   },
   "seasons": {
    "djf": 166,
    "jja": 202,
    "mam": 147,
    "son": 207
   },
   "summer_half": 349,
   "winter_half": 373
  },
  "DH7": {
   "cells": 116,
   "mm": 766,
   "n": 1261,
   "periods": {
    "1961-1990": 701,
    "1981-2010": 733,
    "1991-2020": 766
   },
   "seasons": {
    "djf": 187,
    "jja": 212,
    "mam": 154,
    "son": 213
   },
   "summer_half": 366,
   "winter_half": 400
  },
  "DH8": {
   "cells": 135,
   "mm": 847,
   "n": 1328,
   "periods": {
    "1961-1990": 811,
    "1981-2010": 826,
    "1991-2020": 847
   },
   "seasons": {
    "djf": 225,
    "jja": 216,
    "mam": 171,
    "son": 235
   },
   "summer_half": 387,
   "winter_half": 460
  },
  "DH9": {
   "cells": 49,
   "mm": 768,
   "n": 1209,
   "periods": {
    "1961-1990": 730,
    "1981-2010": 743,
    "1991-2020": 768
   },
   "seasons": {
    "djf": 175,
    "jja": 219,
    "mam": 163,
    "son": 211
   },
   "summer_half": 382,
   "winter_half": 386
  },
  "DH97": {
   "cells": 1,
   "mm": 688,
   "n": 1,
   "periods": {
    "1961-1990": 658,
    "1981-2010": 659,
    "1991-2020": 688
   },
   "seasons": {
    "djf": 158,
    "jja": 193,
    "mam": 141,
    "son": 196
   },
   "summer_half": 334,
   "winter_half": 354
  },
  "DH98": {
   "cells": 1,
   "mm": 688,
   "n": 1,
   "periods": {
    "1961-1990": 658,
    "1981-2010": 659,
    "1991-2020": 688
   },
   "seasons": {
    "djf": 158,
    "jja": 193,
    "mam": 141,
    "son": 196
   },
   "summer_half": 334,
   "winter_half": 354
  },
  "DH99": {
   "cells": 2,
   "mm": 686,
   "n": 3,
   "periods": {
    "1961-1990": 656,
    "1981-2010": 657,
    "1991-2020": 686
   },
   "seasons": {
    "djf": 159,
    "jja": 191,
    "mam": 141,
    "son": 195
   },
   "summer_half": 332,
   "winter_half": 354
  },
  "DL1": {
   "cells": 40,
   "mm": 651,
   "n": 1412,
   "periods": {
    "1961-1990": 617,
    "1981-2010": 637,
    "1991-2020": 651
   },
   "seasons": {
    "djf": 148,
    "jja": 194,
    "mam": 129,
    "son": 179
   },
   "summer_half": 323,
   "winter_half": 327
  },
  "DL10": {
   "cells": 124,
   "mm": 722,
   "n": 843,
   "periods": {
    "1961-1990": 680,
    "1981-2010": 701,
    "1991-2020": 722
   },
   "seasons": {
    "djf": 187,
    "jja": 193,
    "mam": 144,
    "son": 199
   },
   "summer_half": 337,
   "winter_half": 385
  },
  "DL11": {
   "cells": 176,
   "mm": 1003,
   "n": 453,
   "periods": {
    "1961-1990": 932,
    "1981-2010": 971,
    "1991-2020": 1003
   },
   "seasons": {
    "djf": 309,
    "jja": 227,
    "mam": 191,
    "son": 275
   },
   "summer_half": 418,
   "winter_half": 584
  },
  "DL12": {
   "cells": 178,
   "mm": 990,
   "n": 726,
   "periods": {
    "1961-1990": 937,
    "1981-2010": 963,
    "1991-2020": 990
   },
   "seasons": {
    "djf": 304,
    "jja": 222,
    "mam": 193,
    "son": 270
   },
   "summer_half": 415,
   "winter_half": 575
  },
  "DL13": {
   "cells": 188,
   "mm": 949,
   "n": 961,
   "periods": {
    "1961-1990": 898,
    "1981-2010": 924,
    "1991-2020": 949
   },
   "seasons": {
    "djf": 271,
    "jja": 224,
    "mam": 188,
    "son": 266
   },
   "summer_half": 412,
   "winter_half": 537
  },
  "DL14": {
   "cells": 90,
   "mm": 748,
   "n": 1187,
   "periods": {
    "1961-1990": 692,
    "1981-2010": 723,
    "1991-2020": 748
   },
   "seasons": {
    "djf": 187,
    "jja": 205,
    "mam": 150,
    "son": 206
   },
   "summer_half": 355,
   "winter_half": 393
  },
  "DL15": {
   "cells": 61,
   "mm": 796,
   "n": 707,
   "periods": {
    "1961-1990": 735,
    "1981-2010": 764,
    "1991-2020": 796
   },
   "seasons": {
    "djf": 202,
    "jja": 212,
    "mam": 159,
    "son": 223
   },
   "summer_half": 371,
   "winter_half": 425
  },
  "DL16": {
   "cells": 32,
   "mm": 733,
   "n": 601,
   "periods": {
    "1961-1990": 673,
    "1981-2010": 703,
    "1991-2020": 733
   },
   "seasons": {
    "djf": 176,
    "jja": 206,
    "mam": 150,
    "son": 201
   },
   "summer_half": 356,
   "winter_half": 377
  },
  "DL17": {
   "cells": 46,
   "mm": 722,
   "n": 537,
   "periods": {
    "1961-1990": 655,
    "1981-2010": 691,
    "1991-2020": 722
   },
   "seasons": {
    "djf": 172,
    "jja": 205,
    "mam": 145,
    "son": 201
   },
   "summer_half": 350,
   "winter_half": 372
  },
  "DL2": {
   "cells": 193,
   "mm": 675,
   "n": 844,
   "periods": {
    "1961-1990": 634,
    "1981-2010": 655,
    "1991-2020": 675
   },
   "seasons": {
    "djf": 161,
    "jja": 193,
    "mam": 135,
    "son": 186
   },
   "summer_half": 328,
   "winter_half": 347
  },
  "DL3": {
   "cells": 28,
   "mm": 669,
   "n": 1151,
   "periods": {
    "1961-1990": 630,
    "1981-2010": 649,
    "1991-2020": 669
   },
   "seasons": {
    "djf": 159,
    "jja": 193,
    "mam": 132,
    "son": 185
   },
   "summer_half": 326,
   "winter_half": 344
  },
  "DL4": {
   "cells": 15,
   "mm": 744,
   "n": 302,
   "periods": {
    "1961-1990": 692,
    "1981-2010": 716,
    "1991-2020": 744
   },
   "seasons": {
    "djf": 175,
    "jja": 221,
    "mam": 153,
    "son": 196
   },
   "summer_half": 374,
   "winter_half": 371
  },
  "DL5": {
   "cells": 31,
   "mm": 692,
   "n": 801,
   "periods": {
    "1961-1990": 643,
    "1981-2010": 665,
    "1991-2020": 692
   },
   "seasons": {
    "djf": 157,
    "jja": 206,
    "mam": 142,
    "son": 186
   },
   "summer_half": 348,
   "winter_half": 343
  },
  "DL6": {
   "cells": 158,
   "mm": 714,
   "n": 683,
   "periods": {
    "1961-1990": 681,
    "1981-2010": 704,
    "1991-2020": 714
   },
   "seasons": {
    "djf": 168,
    "jja": 202,
    "mam": 141,
    "son": 204
   },
   "summer_half": 343,
   "winter_half": 371
  },
  "DL7": {
   "cells": 114,
   "mm": 680,
   "n": 751,
   "periods": {
    "1961-1990": 636,
    "1981-2010": 661,
    "1991-2020": 680
   },
   "seasons": {
    "djf": 164,
    "jja": 189,
    "mam": 134,
    "son": 194
   },
   "summer_half": 323,
   "winter_half": 357
  },
  "DL8": {
   "cells": 269,
   "mm": 976,
   "n": 1168,
   "periods": {
    "1961-1990": 909,
    "1981-2010": 951,
    "1991-2020": 976
   },
   "seasons": {
    "djf": 300,
    "jja": 220,
    "mam": 188,
    "son": 267
   },
   "summer_half": 408,
   "winter_half": 568
  },
  "DL9": {
   "cells": 20,
   "mm": 794,
   "n": 397,
   "periods": {
    "1961-1990": 750,
    "1981-2010": 774,
    "1991-2020": 794
   },
   "seasons": {
    "djf": 207,
    "jja": 215,
    "mam": 157,
    "son": 215
   },
   "summer_half": 372,
   "winter_half": 422
  },
  "DL98": {
   "cells": 1,
   "mm": 663,
   "n": 7,
   "periods": {
    "1961-1990": 624,
    "1981-2010": 646,
    "1991-2020": 663
   },
   "seasons": {
    "djf": 157,
    "jja": 193,
    "mam": 133,
    "son": 179
   },
   "summer_half": 326,
   "winter_half": 336
  },
  "DN1": {
   "cells": 7,
   "mm": 613,
   "n": 479,
   "periods": {
    "1961-1990": 598,
    "1981-2010": 600,
    "1991-2020": 613
   },
   "seasons": {
    "djf": 136,
    "jja": 181,
    "mam": 126,
    "son": 170
   },
   "summer_half": 307,
   "winter_half": 306
  },
  "DN10": {
   "cells": 100,
   "mm": 597,
   "n": 565,
   "periods": {
    "1961-1990": 583,
    "1981-2010": 589,
    "1991-2020": 597
   },
   "seasons": {
    "djf": 132,
    "jja": 181,
    "mam": 121,
    "son": 164
   },
   "summer_half": 301,
   "winter_half": 296
  },
  "DN11": {
   "cells": 58,
   "mm": 626,
   "n": 838,
   "periods": {
    "1961-1990": 615,
    "1981-2010": 616,
    "1991-2020": 626
   },
   "seasons": {
    "djf": 142,
    "jja": 181,
    "mam": 131,
    "son": 173
   },
   "summer_half": 312,
   "winter_half": 314
  },
  "DN12": {
   "cells": 26,
   "mm": 631,
   "n": 628,
   "periods": {
    "1961-1990": 633,
    "1981-2010": 627,
    "1991-2020": 631
   },
   "seasons": {
    "djf": 142,
    "jja": 180,
    "mam": 132,
    "son": 177
   },
   "summer_half": 312,
   "winter_half": 319
  },
  "DN14": {
   "cells": 220,
   "mm": 609,
   "n": 1690,
   "periods": {
    "1961-1990": 586,
    "1981-2010": 594,
    "1991-2020": 609
   },
   "seasons": {
    "djf": 135,
    "jja": 181,
    "mam": 125,
    "son": 168
   },
   "summer_half": 306,
   "winter_half": 303
  },
  "DN15": {
   "cells": 89,
   "mm": 642,
   "n": 990,
   "periods": {
    "1961-1990": 609,
    "1981-2010": 626,
    "1991-2020": 642
   },
   "seasons": {
    "djf": 144,
    "jja": 186,
    "mam": 132,
    "son": 180
   },
   "summer_half": 318,
   "winter_half": 324
  },
  "DN16": {
   "cells": 24,
   "mm": 652,
   "n": 749,
   "periods": {
    "1961-1990": 617,
    "1981-2010": 636,
    "1991-2020": 652
   },
   "seasons": {
    "djf": 144,
    "jja": 187,
    "mam": 138,
    "son": 183
   },
   "summer_half": 325,
   "winter_half": 327
  },
  "DN17": {
   "cells": 98,
   "mm": 632,
   "n": 966,
   "periods": {
    "1961-1990": 595,
    "1981-2010": 611,
    "1991-2020": 632
   },
   "seasons": {
    "djf": 138,
    "jja": 192,
    "mam": 127,
    "son": 175
   },
   "summer_half": 319,
   "winter_half": 314
  },
  "DN18": {
   "cells": 31,
   "mm": 672,
   "n": 368,
   "periods": {
    "1961-1990": 637,
    "1981-2010": 656,
    "1991-2020": 672
   },
   "seasons": {
    "djf": 160,
    "jja": 189,
    "mam": 136,
    "son": 188
   },
   "summer_half": 324,
   "winter_half": 348
  },
  "DN19": {
   "cells": 33,
   "mm": 637,
   "n": 239,
   "periods": {
    "1961-1990": 602,
    "1981-2010": 626,
    "1991-2020": 637
   },
   "seasons": {
    "djf": 148,
    "jja": 180,
    "mam": 129,
    "son": 179
   },
   "summer_half": 309,
   "winter_half": 328
  },
  "DN2": {
   "cells": 15,
   "mm": 600,
   "n": 575,
   "periods": {
    "1961-1990": 588,
    "1981-2010": 585,
    "1991-2020": 600
   },
   "seasons": {
    "djf": 133,
    "jja": 176,
    "mam": 126,
    "son": 166
   },
   "summer_half": 301,
   "winter_half": 299
  },
  "DN20": {
   "cells": 78,
   "mm": 663,
   "n": 674,
   "periods": {
    "1961-1990": 632,
    "1981-2010": 653,
    "1991-2020": 663
   },
   "seasons": {
    "djf": 155,
    "jja": 192,
    "mam": 133,
    "son": 183
   },
   "summer_half": 325,
   "winter_half": 338
  },
  "DN21": {
   "cells": 216,
   "mm": 638,
   "n": 1371,
   "periods": {
    "1961-1990": 602,
    "1981-2010": 621,
    "1991-2020": 638
   },
   "seasons": {
    "djf": 145,
    "jja": 192,
    "mam": 127,
    "son": 173
   },
   "summer_half": 320,
   "winter_half": 318
  },
  "DN22": {
   "cells": 181,
   "mm": 621,
   "n": 1245,
   "periods": {
    "1961-1990": 599,
    "1981-2010": 607,
    "1991-2020": 621
   },
   "seasons": {
    "djf": 139,
    "jja": 186,
    "mam": 125,
    "son": 171
   },
   "summer_half": 311,
   "winter_half": 310
  },
  "DN3": {
   "cells": 39,
   "mm": 596,
   "n": 737,
   "periods": {
    "1961-1990": 579,
    "1981-2010": 578,
    "1991-2020": 596
   },
   "seasons": {
    "djf": 129,
    "jja": 178,
    "mam": 124,
    "son": 165
   },
   "summer_half": 302,
   "winter_half": 294
  },
  "DN31": {
   "cells": 12,
   "mm": 585,
   "n": 456,
   "periods": {
    "1961-1990": 573,
    "1981-2010": 576,
    "1991-2020": 585
   },
   "seasons": {
    "djf": 141,
    "jja": 170,
    "mam": 113,
    "son": 161
   },
   "summer_half": 283,
   "winter_half": 303
  },
  "DN32": {
   "cells": 14,
   "mm": 570,
   "n": 654,
   "periods": {
    "1961-1990": 554,
    "1981-2010": 562,
    "1991-2020": 570
   },
   "seasons": {
    "djf": 138,
    "jja": 166,
    "mam": 110,
    "son": 156
   },
   "summer_half": 276,
   "winter_half": 294
  },
  "DN33": {
   "cells": 12,
   "mm": 607,
   "n": 556,
   "periods": {
    "1961-1990": 596,
    "1981-2010": 600,
    "1991-2020": 607
   },
   "seasons": {
    "djf": 150,
    "jja": 168,
    "mam": 120,
    "son": 168
   },
   "summer_half": 289,
   "winter_half": 318
  },
  "DN34": {
   "cells": 11,
   "mm": 613,
   "n": 470,
   "periods": {
    "1961-1990": 605,
    "1981-2010": 604,
    "1991-2020": 613
   },
   "seasons": {
    "djf": 152,
    "jja": 171,
    "mam": 120,
    "son": 170
   },
   "summer_half": 291,
   "winter_half": 322
  },
  "DN35": {
   "cells": 14,
   "mm": 580,
   "n": 814,
   "periods": {
    "1961-1990": 559,
    "1981-2010": 574,
    "1991-2020": 580
   },
   "seasons": {
    "djf": 139,
    "jja": 168,
    "mam": 112,
    "son": 161
   },
   "summer_half": 280,
   "winter_half": 300
  },
  "DN36": {
   "cells": 67,
   "mm": 613,
   "n": 661,
   "periods": {
    "1961-1990": 597,
    "1981-2010": 606,
    "1991-2020": 613
   },
   "seasons": {
    "djf": 149,
    "jja": 171,
    "mam": 122,
    "son": 172
   },
   "summer_half": 293,
   "winter_half": 321
  },
  "DN37": {
   "cells": 76,
   "mm": 638,
   "n": 673,
   "periods": {
    "1961-1990": 624,
    "1981-2010": 632,
    "1991-2020": 638
   },
   "seasons": {
    "djf": 155,
    "jja": 178,
    "mam": 128,
    "son": 176
   },
   "summer_half": 306,
   "winter_half": 332
  },
  "DN38": {
   "cells": 27,
   "mm": 644,
   "n": 105,
   "periods": {
    "1961-1990": 623,
    "1981-2010": 635,
    "1991-2020": 644
   },
   "seasons": {
    "djf": 152,
    "jja": 185,
    "mam": 127,
    "son": 179
   },
   "summer_half": 312,
   "winter_half": 331
  },
  "DN39": {
   "cells": 28,
   "mm": 649,
   "n": 114,
   "periods": {
    "1961-1990": 615,
    "1981-2010": 633,
    "1991-2020": 649
   },
   "seasons": {
    "djf": 153,
    "jja": 185,
    "mam": 131,
    "son": 181
   },
   "summer_half": 316,
   "winter_half": 333
  },
  "DN4": {
   "cells": 37,
   "mm": 611,
   "n": 1322,
   "periods": {
    "1961-1990": 596,
    "1981-2010": 597,
    "1991-2020": 611
   },
   "seasons": {
    "djf": 136,
    "jja": 180,
    "mam": 125,
    "son": 169
   },
   "summer_half": 305,
   "winter_half": 306
  },
  "DN40": {
   "cells": 40,
   "mm": 623,
   "n": 453,
   "periods": {
    "1961-1990": 599,
    "1981-2010": 613,
    "1991-2020": 623
   },
   "seasons": {
    "djf": 146,
    "jja": 180,
    "mam": 123,
    "son": 174
   },
   "summer_half": 303,
   "winter_half": 320
  },
  "DN41": {
   "cells": 36,
   "mm": 625,
   "n": 245,
   "periods": {
    "1961-1990": 612,
    "1981-2010": 620,
    "1991-2020": 625
   },
   "seasons": {
    "djf": 147,
    "jja": 181,
    "mam": 122,
    "son": 174
   },
   "summer_half": 303,
   "winter_half": 321
  },
  "DN5": {
   "cells": 74,
   "mm": 622,
   "n": 972,
   "periods": {
    "1961-1990": 614,
    "1981-2010": 615,
    "1991-2020": 622
   },
   "seasons": {
    "djf": 138,
    "jja": 183,
    "mam": 128,
    "son": 174
   },
   "summer_half": 311,
   "winter_half": 311
  },
  "DN6": {
   "cells": 73,
   "mm": 605,
   "n": 857,
   "periods": {
    "1961-1990": 598,
    "1981-2010": 597,
    "1991-2020": 605
   },
   "seasons": {
    "djf": 132,
    "jja": 178,
    "mam": 125,
    "son": 170
   },
   "summer_half": 303,
   "winter_half": 302
  },
  "DN7": {
   "cells": 53,
   "mm": 600,
   "n": 662,
   "periods": {
    "1961-1990": 584,
    "1981-2010": 584,
    "1991-2020": 600
   },
   "seasons": {
    "djf": 126,
    "jja": 185,
    "mam": 123,
    "son": 165
   },
   "summer_half": 308,
   "winter_half": 292
  },
  "DN8": {
   "cells": 39,
   "mm": 610,
   "n": 493,
   "periods": {
    "1961-1990": 581,
    "1981-2010": 591,
    "1991-2020": 610
   },
   "seasons": {
    "djf": 131,
    "jja": 189,
    "mam": 124,
    "son": 166
   },
   "summer_half": 313,
   "winter_half": 296
  },
  "DN9": {
   "cells": 101,
   "mm": 606,
   "n": 686,
   "periods": {
    "1961-1990": 577,
    "1981-2010": 586,
    "1991-2020": 606
   },
   "seasons": {
    "djf": 135,
    "jja": 184,
    "mam": 122,
    "son": 165
   },
   "summer_half": 306,
   "winter_half": 299
  },
  "DT1": {
   "cells": 13,
   "mm": 1093,
   "n": 792,
   "periods": {
    "1961-1990": 970,
    "1981-2010": 1030,
    "1991-2020": 1093
   },
   "seasons": {
    "djf": 342,
    "jja": 200,
    "mam": 208,
    "son": 343
   },
   "summer_half": 408,
   "winter_half": 685
  },
  "DT10": {
   "cells": 84,
   "mm": 878,
   "n": 478,
   "periods": {
    "1961-1990": 810,
    "1981-2010": 845,
    "1991-2020": 878
   },
   "seasons": {
    "djf": 261,
    "jja": 170,
    "mam": 174,
    "son": 272
   },
   "summer_half": 344,
   "winter_half": 533
  },
  "DT11": {
   "cells": 196,
   "mm": 963,
   "n": 1088,
   "periods": {
    "1961-1990": 885,
    "1981-2010": 926,
    "1991-2020": 963
   },
   "seasons": {
    "djf": 293,
    "jja": 181,
    "mam": 189,
    "son": 300
   },
   "summer_half": 370,
   "winter_half": 593
  },
  "DT2": {
   "cells": 351,
   "mm": 1062,
   "n": 1140,
   "periods": {
    "1961-1990": 968,
    "1981-2010": 1020,
    "1991-2020": 1062
   },
   "seasons": {
    "djf": 324,
    "jja": 200,
    "mam": 207,
    "son": 331
   },
   "summer_half": 407,
   "winter_half": 655
  },
  "DT3": {
   "cells": 65,
   "mm": 888,
   "n": 703,
   "periods": {
    "1961-1990": 813,
    "1981-2010": 856,
    "1991-2020": 888
   },
   "seasons": {
    "djf": 264,
    "jja": 171,
    "mam": 173,
    "son": 281
   },
   "summer_half": 343,
   "winter_half": 545
  },
  "DT4": {
   "cells": 18,
   "mm": 807,
   "n": 995,
   "periods": {
    "1961-1990": 749,
    "1981-2010": 772,
    "1991-2020": 807
   },
   "seasons": {
    "djf": 240,
    "jja": 152,
    "mam": 158,
    "son": 257
   },
   "summer_half": 310,
   "winter_half": 497
  },
  "DT5": {
   "cells": 10,
   "mm": 807,
   "n": 315,
   "periods": {
    "1961-1990": 768,
    "1981-2010": 783,
    "1991-2020": 807
   },
   "seasons": {
    "djf": 245,
    "jja": 162,
    "mam": 155,
    "son": 245
   },
   "summer_half": 317,
   "winter_half": 490
  },
  "DT6": {
   "cells": 137,
   "mm": 979,
   "n": 994,
   "periods": {
    "1961-1990": 889,
    "1981-2010": 945,
    "1991-2020": 979
   },
   "seasons": {
    "djf": 286,
    "jja": 195,
    "mam": 195,
    "son": 303
   },
   "summer_half": 390,
   "winter_half": 589
  },
  "DT7": {
   "cells": 25,
   "mm": 1004,
   "n": 284,
   "periods": {
    "1961-1990": 921,
    "1981-2010": 967,
    "1991-2020": 1004
   },
   "seasons": {
    "djf": 290,
    "jja": 205,
    "mam": 208,
    "son": 300
   },
   "summer_half": 413,
   "winter_half": 591
  },
  "DT8": {
   "cells": 51,
   "mm": 1134,
   "n": 234,
   "periods": {
    "1961-1990": 1024,
    "1981-2010": 1093,
    "1991-2020": 1134
   },
   "seasons": {
    "djf": 331,
    "jja": 227,
    "mam": 221,
    "son": 355
   },
   "summer_half": 448,
   "winter_half": 685
  },
  "DT9": {
   "cells": 143,
   "mm": 890,
   "n": 915,
   "periods": {
    "1961-1990": 817,
    "1981-2010": 863,
    "1991-2020": 890
   },
   "seasons": {
    "djf": 259,
    "jja": 182,
    "mam": 178,
    "son": 271
   },
   "summer_half": 361,
   "winter_half": 529
  },
  "DY1": {
   "cells": 18,
   "mm": 753,
   "n": 797,
   "periods": {
    "1961-1990": 719,
    "1981-2010": 738,
    "1991-2020": 753
   },
   "seasons": {
    "djf": 179,
    "jja": 202,
    "mam": 163,
    "son": 209
   },
   "summer_half": 364,
   "winter_half": 388
  },
  "DY10": {
   "cells": 70,
   "mm": 701,
   "n": 999,
   "periods": {
    "1961-1990": 662,
    "1981-2010": 682,
    "1991-2020": 701
   },
   "seasons": {
    "djf": 175,
    "jja": 181,
    "mam": 148,
    "son": 196
   },
   "summer_half": 329,
   "winter_half": 371
  },
  "DY11": {
   "cells": 44,
   "mm": 697,
   "n": 810,
   "periods": {
    "1961-1990": 657,
    "1981-2010": 678,
    "1991-2020": 697
   },
   "seasons": {
    "djf": 175,
    "jja": 180,
    "mam": 148,
    "son": 193
   },
   "summer_half": 329,
   "winter_half": 368
  },
  "DY12": {
   "cells": 83,
   "mm": 746,
   "n": 578,
   "periods": {
    "1961-1990": 697,
    "1981-2010": 726,
    "1991-2020": 746
   },
   "seasons": {
    "djf": 196,
    "jja": 187,
    "mam": 159,
    "son": 205
   },
   "summer_half": 346,
   "winter_half": 400
  },
  "DY13": {
   "cells": 50,
   "mm": 680,
   "n": 686,
   "periods": {
    "1961-1990": 632,
    "1981-2010": 659,
    "1991-2020": 680
   },
   "seasons": {
    "djf": 173,
    "jja": 174,
    "mam": 145,
    "son": 188
   },
   "summer_half": 320,
   "winter_half": 361
  },
  "DY14": {
   "cells": 135,
   "mm": 797,
   "n": 603,
   "periods": {
    "1961-1990": 738,
    "1981-2010": 773,
    "1991-2020": 797
   },
   "seasons": {
    "djf": 207,
    "jja": 198,
    "mam": 169,
    "son": 222
   },
   "summer_half": 368,
   "winter_half": 429
  },
  "DY2": {
   "cells": 18,
   "mm": 747,
   "n": 752,
   "periods": {
    "1961-1990": 713,
    "1981-2010": 732,
    "1991-2020": 747
   },
   "seasons": {
    "djf": 181,
    "jja": 196,
    "mam": 161,
    "son": 208
   },
   "summer_half": 357,
   "winter_half": 390
  },
  "DY3": {
   "cells": 36,
   "mm": 741,
   "n": 812,
   "periods": {
    "1961-1990": 708,
    "1981-2010": 727,
    "1991-2020": 741
   },
   "seasons": {
    "djf": 181,
    "jja": 194,
    "mam": 161,
    "son": 205
   },
   "summer_half": 355,
   "winter_half": 386
  },
  "DY4": {
   "cells": 19,
   "mm": 761,
   "n": 972,
   "periods": {
    "1961-1990": 717,
    "1981-2010": 747,
    "1991-2020": 761
   },
   "seasons": {
    "djf": 184,
    "jja": 202,
    "mam": 164,
    "son": 211
   },
   "summer_half": 366,
   "winter_half": 395
  },
  "DY5": {
   "cells": 22,
   "mm": 727,
   "n": 944,
   "periods": {
    "1961-1990": 690,
    "1981-2010": 709,
    "1991-2020": 727
   },
   "seasons": {
    "djf": 181,
    "jja": 188,
    "mam": 156,
    "son": 203
   },
   "summer_half": 344,
   "winter_half": 383
  },
  "DY6": {
   "cells": 20,
   "mm": 708,
   "n": 751,
   "periods": {
    "1961-1990": 675,
    "1981-2010": 696,
    "1991-2020": 708
   },
   "seasons": {
    "djf": 177,
    "jja": 183,
    "mam": 151,
    "son": 198
   },
   "summer_half": 333,
   "winter_half": 375
  },
  "DY7": {
   "cells": 72,
   "mm": 731,
   "n": 343,
   "periods": {
    "1961-1990": 693,
    "1981-2010": 716,
    "1991-2020": 731
   },
   "seasons": {
    "djf": 184,
    "jja": 188,
    "mam": 156,
    "son": 203
   },
   "summer_half": 344,
   "winter_half": 386
  },
  "DY8": {
   "cells": 24,
   "mm": 731,
   "n": 1200,
   "periods": {
    "1961-1990": 698,
    "1981-2010": 712,
    "1991-2020": 731
   },
   "seasons": {
    "djf": 183,
    "jja": 188,
    "mam": 155,
    "son": 205
   },
   "summer_half": 343,
   "winter_half": 388
  },
  "DY9": {
   "cells": 52,
   "mm": 756,
   "n": 846,
   "periods": {
    "1961-1990": 723,
    "1981-2010": 737,
    "1991-2020": 756
   },
   "seasons": {
    "djf": 188,
    "jja": 196,
    "mam": 160,
    "son": 211
   },
   "summer_half": 356,
   "winter_half": 400
  },
  "E1": {
   "cells": 12,
   "mm": 616,
   "n": 1519,
   "periods": {
    "1961-1990": 601,
    "1981-2010": 606,
    "1991-2020": 616
   },
   "seasons": {
    "djf": 157,
    "jja": 156,
    "mam": 123,
    "son": 180
   },
   "summer_half": 278,
   "winter_half": 337
  },
  "E10": {
   "cells": 11,
   "mm": 605,
   "n": 605,
   "periods": {
    "1961-1990": 602,
    "1981-2010": 598,
    "1991-2020": 605
   },
   "seasons": {
    "djf": 156,
    "jja": 151,
    "mam": 120,
    "son": 178
   },
   "summer_half": 271,
   "winter_half": 334
  },
  "E11": {
   "cells": 16,
   "mm": 611,
   "n": 842,
   "periods": {
    "1961-1990": 602,
    "1981-2010": 605,
    "1991-2020": 611
   },
   "seasons": {
    "djf": 158,
    "jja": 150,
    "mam": 122,
    "son": 180
   },
   "summer_half": 273,
   "winter_half": 338
  },
  "E12": {
   "cells": 11,
   "mm": 600,
   "n": 396,
   "periods": {
    "1961-1990": 590,
    "1981-2010": 593,
    "1991-2020": 600
   },
   "seasons": {
    "djf": 155,
    "jja": 147,
    "mam": 122,
    "son": 176
   },
   "summer_half": 268,
   "winter_half": 332
  },
  "E13": {
   "cells": 10,
   "mm": 588,
   "n": 581,
   "periods": {
    "1961-1990": 577,
    "1981-2010": 579,
    "1991-2020": 588
   },
   "seasons": {
    "djf": 151,
    "jja": 145,
    "mam": 119,
    "son": 173
   },
   "summer_half": 265,
   "winter_half": 324
  },
  "E14": {
   "cells": 14,
   "mm": 598,
   "n": 1908,
   "periods": {
    "1961-1990": 581,
    "1981-2010": 586,
    "1991-2020": 598
   },
   "seasons": {
    "djf": 151,
    "jja": 150,
    "mam": 121,
    "son": 176
   },
   "summer_half": 271,
   "winter_half": 327
  },
  "E15": {
   "cells": 12,
   "mm": 601,
   "n": 816,
   "periods": {
    "1961-1990": 591,
    "1981-2010": 591,
    "1991-2020": 601
   },
   "seasons": {
    "djf": 154,
    "jja": 149,
    "mam": 119,
    "son": 178
   },
   "summer_half": 269,
   "winter_half": 332
  },
  "E16": {
   "cells": 15,
   "mm": 578,
   "n": 1058,
   "periods": {
    "1961-1990": 564,
    "1981-2010": 568,
    "1991-2020": 578
   },
   "seasons": {
    "djf": 148,
    "jja": 144,
    "mam": 118,
    "son": 169
   },
   "summer_half": 262,
   "winter_half": 316
  },
  "E17": {
   "cells": 20,
   "mm": 614,
   "n": 1533,
   "periods": {
    "1961-1990": 610,
    "1981-2010": 611,
    "1991-2020": 614
   },
   "seasons": {
    "djf": 161,
    "jja": 152,
    "mam": 122,
    "son": 178
   },
   "summer_half": 274,
   "winter_half": 339
  },
  "E18": {
   "cells": 7,
   "mm": 628,
   "n": 366,
   "periods": {
    "1961-1990": 613,
    "1981-2010": 621,
    "1991-2020": 628
   },
   "seasons": {
    "djf": 164,
    "jja": 155,
    "mam": 126,
    "son": 183
   },
   "summer_half": 281,
   "winter_half": 348
  },
  "E1W": {
   "cells": 6,
   "mm": 617,
   "n": 433,
   "periods": {
    "1961-1990": 602,
    "1981-2010": 606,
    "1991-2020": 617
   },
   "seasons": {
    "djf": 157,
    "jja": 157,
    "mam": 124,
    "son": 179
   },
   "summer_half": 281,
   "winter_half": 336
  },
  "E2": {
   "cells": 6,
   "mm": 622,
   "n": 981,
   "periods": {
    "1961-1990": 609,
    "1981-2010": 613,
    "1991-2020": 622
   },
   "seasons": {
    "djf": 160,
    "jja": 156,
    "mam": 123,
    "son": 183
   },
   "summer_half": 279,
   "winter_half": 343
  },
  "E20": {
   "cells": 5,
   "mm": 605,
   "n": 228,
   "periods": {
    "1961-1990": 595,
    "1981-2010": 596,
    "1991-2020": 605
   },
   "seasons": {
    "djf": 155,
    "jja": 152,
    "mam": 119,
    "son": 179
   },
   "summer_half": 271,
   "winter_half": 334
  },
  "E22": {
   "cells": 3,
   "mm": 611,
   "n": 18,
   "periods": {
    "1961-1990": 593,
    "1981-2010": 598,
    "1991-2020": 611
   },
   "seasons": {
    "djf": 153,
    "jja": 153,
    "mam": 125,
    "son": 181
   },
   "summer_half": 278,
   "winter_half": 334
  },
  "E3": {
   "cells": 12,
   "mm": 612,
   "n": 1176,
   "periods": {
    "1961-1990": 599,
    "1981-2010": 603,
    "1991-2020": 612
   },
   "seasons": {
    "djf": 156,
    "jja": 154,
    "mam": 121,
    "son": 181
   },
   "summer_half": 275,
   "winter_half": 337
  },
  "E4": {
   "cells": 23,
   "mm": 658,
   "n": 970,
   "periods": {
    "1961-1990": 636,
    "1981-2010": 651,
    "1991-2020": 658
   },
   "seasons": {
    "djf": 176,
    "jja": 162,
    "mam": 128,
    "son": 192
   },
   "summer_half": 290,
   "winter_half": 368
  },
  "E5": {
   "cells": 9,
   "mm": 607,
   "n": 665,
   "periods": {
    "1961-1990": 608,
    "1981-2010": 602,
    "1991-2020": 607
   },
   "seasons": {
    "djf": 157,
    "jja": 152,
    "mam": 122,
    "son": 176
   },
   "summer_half": 274,
   "winter_half": 333
  },
  "E6": {
   "cells": 15,
   "mm": 582,
   "n": 924,
   "periods": {
    "1961-1990": 569,
    "1981-2010": 573,
    "1991-2020": 582
   },
   "seasons": {
    "djf": 150,
    "jja": 143,
    "mam": 119,
    "son": 170
   },
   "summer_half": 262,
   "winter_half": 320
  },
  "E7": {
   "cells": 8,
   "mm": 599,
   "n": 539,
   "periods": {
    "1961-1990": 591,
    "1981-2010": 592,
    "1991-2020": 599
   },
   "seasons": {
    "djf": 155,
    "jja": 147,
    "mam": 121,
    "son": 176
   },
   "summer_half": 268,
   "winter_half": 331
  },
  "E8": {
   "cells": 8,
   "mm": 617,
   "n": 733,
   "periods": {
    "1961-1990": 611,
    "1981-2010": 609,
    "1991-2020": 617
   },
   "seasons": {
    "djf": 159,
    "jja": 155,
    "mam": 123,
    "son": 180
   },
   "summer_half": 278,
   "winter_half": 339
  },
  "E9": {
   "cells": 10,
   "mm": 620,
   "n": 685,
   "periods": {
    "1961-1990": 612,
    "1981-2010": 613,
    "1991-2020": 620
   },
   "seasons": {
    "djf": 159,
    "jja": 157,
    "mam": 122,
    "son": 182
   },
   "summer_half": 279,
   "winter_half": 341
  },
  "E98": {
   "cells": 1,
   "mm": 623,
   "n": 56,
   "periods": {
    "1961-1990": 608,
    "1981-2010": 612,
    "1991-2020": 623
   },
   "seasons": {
    "djf": 159,
    "jja": 159,
    "mam": 125,
    "son": 180
   },
   "summer_half": 284,
   "winter_half": 339
  },
  "EC1A": {
   "cells": 4,
   "mm": 622,
   "n": 166,
   "periods": {
    "1961-1990": 608,
    "1981-2010": 609,
    "1991-2020": 622
   },
   "seasons": {
    "djf": 161,
    "jja": 157,
    "mam": 123,
    "son": 180
   },
   "summer_half": 280,
   "winter_half": 342
  },
  "EC1M": {
   "cells": 4,
   "mm": 622,
   "n": 169,
   "periods": {
    "1961-1990": 608,
    "1981-2010": 609,
    "1991-2020": 622
   },
   "seasons": {
    "djf": 161,
    "jja": 157,
    "mam": 123,
    "son": 180
   },
   "summer_half": 280,
   "winter_half": 342
  },
  "EC1N": {
   "cells": 2,
   "mm": 624,
   "n": 155,
   "periods": {
    "1961-1990": 610,
    "1981-2010": 611,
    "1991-2020": 624
   },
   "seasons": {
    "djf": 162,
    "jja": 158,
    "mam": 124,
    "son": 181
   },
   "summer_half": 281,
   "winter_half": 343
  },
  "EC1P": {
   "cells": 1,
   "mm": 626,
   "n": 256,
   "periods": {
    "1961-1990": 609,
    "1981-2010": 613,
    "1991-2020": 626
   },
   "seasons": {
    "djf": 163,
    "jja": 158,
    "mam": 124,
    "son": 181
   },
   "summer_half": 282,
   "winter_half": 344
  },
  "EC1R": {
   "cells": 3,
   "mm": 631,
   "n": 267,
   "periods": {
    "1961-1990": 615,
    "1981-2010": 618,
    "1991-2020": 631
   },
   "seasons": {
    "djf": 165,
    "jja": 159,
    "mam": 125,
    "son": 183
   },
   "summer_half": 284,
   "winter_half": 347
  },
  "EC1V": {
   "cells": 4,
   "mm": 625,
   "n": 484,
   "periods": {
    "1961-1990": 609,
    "1981-2010": 613,
    "1991-2020": 625
   },
   "seasons": {
    "djf": 162,
    "jja": 157,
    "mam": 124,
    "son": 181
   },
   "summer_half": 281,
   "winter_half": 343
  },
  "EC1Y": {
   "cells": 3,
   "mm": 622,
   "n": 177,
   "periods": {
    "1961-1990": 607,
    "1981-2010": 609,
    "1991-2020": 622
   },
   "seasons": {
    "djf": 161,
    "jja": 157,
    "mam": 124,
    "son": 180
   },
   "summer_half": 280,
   "winter_half": 341
  },
  "EC2A": {
   "cells": 5,
   "mm": 619,
   "n": 341,
   "periods": {
    "1961-1990": 604,
    "1981-2010": 607,
    "1991-2020": 619
   },
   "seasons": {
    "djf": 160,
    "jja": 156,
    "mam": 123,
    "son": 180
   },
   "summer_half": 279,
   "winter_half": 340
  },
  "EC2M": {
   "cells": 3,
   "mm": 622,
   "n": 161,
   "periods": {
    "1961-1990": 608,
    "1981-2010": 610,
    "1991-2020": 622
   },
   "seasons": {
    "djf": 161,
    "jja": 157,
    "mam": 124,
    "son": 181
   },
   "summer_half": 280,
   "winter_half": 342
  },
  "EC2N": {
   "cells": 3,
   "mm": 622,
   "n": 46,
   "periods": {
    "1961-1990": 608,
    "1981-2010": 610,
    "1991-2020": 622
   },
   "seasons": {
    "djf": 161,
    "jja": 157,
    "mam": 124,
    "son": 181
   },
   "summer_half": 280,
   "winter_half": 342
  },
  "EC2P": {
   "cells": 2,
   "mm": 624,
   "n": 66,
   "periods": {
    "1961-1990": 610,
    "1981-2010": 612,
    "1991-2020": 624
   },
   "seasons": {
    "djf": 162,
    "jja": 157,
    "mam": 124,
    "son": 181
   },
   "summer_half": 281,
   "winter_half": 343
  },
  "EC2R": {
   "cells": 2,
   "mm": 624,
   "n": 72,
   "periods": {
    "1961-1990": 610,
    "1981-2010": 612,
    "1991-2020": 624
   },
   "seasons": {
    "djf": 162,
    "jja": 157,
    "mam": 124,
    "son": 181
   },
   "summer_half": 281,
   "winter_half": 343
  },
  "EC2V": {
   "cells": 2,
   "mm": 624,
   "n": 102,
   "periods": {
    "1961-1990": 610,
    "1981-2010": 612,
    "1991-2020": 624
   },
   "seasons": {
    "djf": 162,
    "jja": 157,
    "mam": 124,
    "son": 181
   },
   "summer_half": 281,
   "winter_half": 343
  },
  "EC2Y": {
   "cells": 3,
   "mm": 622,
   "n": 90,
   "periods": {
    "1961-1990": 607,
    "1981-2010": 609,
    "1991-2020": 622
   },
   "seasons": {
    "djf": 161,
    "jja": 157,
    "mam": 124,
    "son": 180
   },
   "summer_half": 280,
   "winter_half": 341
  },
  "EC3A": {
   "cells": 2,
   "mm": 621,
   "n": 66,
   "periods": {
    "1961-1990": 606,
    "1981-2010": 609,
    "1991-2020": 621
   },
   "seasons": {
    "djf": 161,
    "jja": 157,
    "mam": 124,
    "son": 180
   },
   "summer_half": 280,
   "winter_half": 341
  },
  "EC3M": {
   "cells": 3,
   "mm": 605,
   "n": 80,
   "periods": {
    "1961-1990": 592,
    "1981-2010": 593,
    "1991-2020": 605
   },
   "seasons": {
    "djf": 155,
    "jja": 152,
    "mam": 121,
    "son": 176
   },
   "summer_half": 273,
   "winter_half": 331
  },
  "EC3N": {
   "cells": 2,
   "mm": 610,
   "n": 82,
   "periods": {
    "1961-1990": 597,
    "1981-2010": 599,
    "1991-2020": 610
   },
   "seasons": {
    "djf": 156,
    "jja": 154,
    "mam": 122,
    "son": 178
   },
   "summer_half": 276,
   "winter_half": 334
  },
  "EC3P": {
   "cells": 2,
   "mm": 621,
   "n": 25,
   "periods": {
    "1961-1990": 606,
    "1981-2010": 609,
    "1991-2020": 621
   },
   "seasons": {
    "djf": 161,
    "jja": 157,
    "mam": 124,
    "son": 180
   },
   "summer_half": 280,
   "winter_half": 341
  },
  "EC3R": {
   "cells": 3,
   "mm": 608,
   "n": 79,
   "periods": {
    "1961-1990": 594,
    "1981-2010": 595,
    "1991-2020": 608
   },
   "seasons": {
    "djf": 156,
    "jja": 153,
    "mam": 121,
    "son": 177
   },
   "summer_half": 274,
   "winter_half": 333
  },
  "EC3V": {
   "cells": 5,
   "mm": 612,
   "n": 78,
   "periods": {
    "1961-1990": 599,
    "1981-2010": 601,
    "1991-2020": 612
   },
   "seasons": {
    "djf": 158,
    "jja": 154,
    "mam": 122,
    "son": 178
   },
   "summer_half": 276,
   "winter_half": 336
  },
  "EC4A": {
   "cells": 2,
   "mm": 624,
   "n": 111,
   "periods": {
    "1961-1990": 610,
    "1981-2010": 611,
    "1991-2020": 624
   },
   "seasons": {
    "djf": 162,
    "jja": 158,
    "mam": 124,
    "son": 181
   },
   "summer_half": 281,
   "winter_half": 343
  },
  "EC4M": {
   "cells": 4,
   "mm": 616,
   "n": 93,
   "periods": {
    "1961-1990": 603,
    "1981-2010": 603,
    "1991-2020": 616
   },
   "seasons": {
    "djf": 159,
    "jja": 155,
    "mam": 123,
    "son": 179
   },
   "summer_half": 278,
   "winter_half": 338
  },
  "EC4N": {
   "cells": 3,
   "mm": 614,
   "n": 69,
   "periods": {
    "1961-1990": 601,
    "1981-2010": 601,
    "1991-2020": 614
   },
   "seasons": {
    "djf": 159,
    "jja": 154,
    "mam": 122,
    "son": 179
   },
   "summer_half": 277,
   "winter_half": 337
  },
  "EC4P": {
   "cells": 1,
   "mm": 626,
   "n": 43,
   "periods": {
    "1961-1990": 609,
    "1981-2010": 613,
    "1991-2020": 626
   },
   "seasons": {
    "djf": 163,
    "jja": 158,
    "mam": 124,
    "son": 181
   },
   "summer_half": 282,
   "winter_half": 344
  },
  "EC4R": {
   "cells": 2,
   "mm": 609,
   "n": 56,
   "periods": {
    "1961-1990": 596,
    "1981-2010": 597,
    "1991-2020": 609
   },
   "seasons": {
    "djf": 158,
    "jja": 153,
    "mam": 122,
    "son": 177
   },
   "summer_half": 275,
   "winter_half": 335
  },
  "EC4V": {
   "cells": 5,
   "mm": 613,
   "n": 110,
   "periods": {
    "1961-1990": 601,
    "1981-2010": 600,
    "1991-2020": 613
   },
   "seasons": {
    "djf": 159,
    "jja": 154,
    "mam": 122,
    "son": 179
   },
   "summer_half": 276,
   "winter_half": 337
  },
  "EC4Y": {
   "cells": 3,
   "mm": 617,
   "n": 125,
   "periods": {
    "1961-1990": 605,
    "1981-2010": 604,
    "1991-2020": 617
   },
   "seasons": {
    "djf": 160,
    "jja": 155,
    "mam": 123,
    "son": 179
   },
   "summer_half": 277,
   "winter_half": 340
  },
  "EH1": {
   "cells": 8,
   "mm": 727,
   "n": 323,
   "periods": {
    "1961-1990": 640,
    "1981-2010": 704,
    "1991-2020": 727
   },
   "seasons": {
    "djf": 181,
    "jja": 212,
    "mam": 139,
    "son": 195
   },
   "summer_half": 352,
   "winter_half": 376
  },
  "EH10": {
   "cells": 19,
   "mm": 826,
   "n": 864,
   "periods": {
    "1961-1990": 734,
    "1981-2010": 804,
    "1991-2020": 826
   },
   "seasons": {
    "djf": 218,
    "jja": 226,
    "mam": 161,
    "son": 221
   },
   "summer_half": 388,
   "winter_half": 439
  },
  "EH11": {
   "cells": 15,
   "mm": 748,
   "n": 948,
   "periods": {
    "1961-1990": 652,
    "1981-2010": 719,
    "1991-2020": 748
   },
   "seasons": {
    "djf": 191,
    "jja": 212,
    "mam": 147,
    "son": 198
   },
   "summer_half": 358,
   "winter_half": 390
  },
  "EH12": {
   "cells": 33,
   "mm": 775,
   "n": 1229,
   "periods": {
    "1961-1990": 669,
    "1981-2010": 744,
    "1991-2020": 775
   },
   "seasons": {
    "djf": 202,
    "jja": 217,
    "mam": 149,
    "son": 206
   },
   "summer_half": 366,
   "winter_half": 408
  },
  "EH13": {
   "cells": 11,
   "mm": 853,
   "n": 378,
   "periods": {
    "1961-1990": 753,
    "1981-2010": 828,
    "1991-2020": 853
   },
   "seasons": {
    "djf": 232,
    "jja": 227,
    "mam": 167,
    "son": 228
   },
   "summer_half": 394,
   "winter_half": 459
  },
  "EH14": {
   "cells": 45,
   "mm": 875,
   "n": 1011,
   "periods": {
    "1961-1990": 772,
    "1981-2010": 849,
    "1991-2020": 875
   },
   "seasons": {
    "djf": 233,
    "jja": 229,
    "mam": 178,
    "son": 236
   },
   "summer_half": 407,
   "winter_half": 469
  },
  "EH15": {
   "cells": 12,
   "mm": 687,
   "n": 623,
   "periods": {
    "1961-1990": 610,
    "1981-2010": 673,
    "1991-2020": 687
   },
   "seasons": {
    "djf": 167,
    "jja": 204,
    "mam": 131,
    "son": 185
   },
   "summer_half": 335,
   "winter_half": 352
  },
  "EH16": {
   "cells": 23,
   "mm": 752,
   "n": 886,
   "periods": {
    "1961-1990": 666,
    "1981-2010": 736,
    "1991-2020": 752
   },
   "seasons": {
    "djf": 189,
    "jja": 219,
    "mam": 143,
    "son": 201
   },
   "summer_half": 362,
   "winter_half": 391
  },
  "EH17": {
   "cells": 14,
   "mm": 786,
   "n": 597,
   "periods": {
    "1961-1990": 693,
    "1981-2010": 768,
    "1991-2020": 786
   },
   "seasons": {
    "djf": 203,
    "jja": 220,
    "mam": 150,
    "son": 214
   },
   "summer_half": 370,
   "winter_half": 416
  },
  "EH18": {
   "cells": 12,
   "mm": 808,
   "n": 106,
   "periods": {
    "1961-1990": 708,
    "1981-2010": 784,
    "1991-2020": 808
   },
   "seasons": {
    "djf": 210,
    "jja": 217,
    "mam": 151,
    "son": 230
   },
   "summer_half": 369,
   "winter_half": 440
  },
  "EH19": {
   "cells": 13,
   "mm": 786,
   "n": 428,
   "periods": {
    "1961-1990": 686,
    "1981-2010": 760,
    "1991-2020": 786
   },
   "seasons": {
    "djf": 201,
    "jja": 220,
    "mam": 146,
    "son": 218
   },
   "summer_half": 366,
   "winter_half": 420
  },
  "EH2": {
   "cells": 5,
   "mm": 736,
   "n": 196,
   "periods": {
    "1961-1990": 648,
    "1981-2010": 712,
    "1991-2020": 736
   },
   "seasons": {
    "djf": 185,
    "jja": 213,
    "mam": 141,
    "son": 197
   },
   "summer_half": 354,
   "winter_half": 381
  },
  "EH20": {
   "cells": 9,
   "mm": 844,
   "n": 235,
   "periods": {
    "1961-1990": 746,
    "1981-2010": 823,
    "1991-2020": 844
   },
   "seasons": {
    "djf": 223,
    "jja": 225,
    "mam": 164,
    "son": 232
   },
   "summer_half": 389,
   "winter_half": 455
  },
  "EH21": {
   "cells": 24,
   "mm": 702,
   "n": 770,
   "periods": {
    "1961-1990": 622,
    "1981-2010": 682,
    "1991-2020": 702
   },
   "seasons": {
    "djf": 161,
    "jja": 205,
    "mam": 139,
    "son": 196
   },
   "summer_half": 344,
   "winter_half": 357
  },
  "EH22": {
   "cells": 52,
   "mm": 761,
   "n": 1117,
   "periods": {
    "1961-1990": 670,
    "1981-2010": 739,
    "1991-2020": 761
   },
   "seasons": {
    "djf": 189,
    "jja": 218,
    "mam": 147,
    "son": 206
   },
   "summer_half": 365,
   "winter_half": 396
  },
  "EH23": {
   "cells": 53,
   "mm": 846,
   "n": 302,
   "periods": {
    "1961-1990": 764,
    "1981-2010": 830,
    "1991-2020": 846
   },
   "seasons": {
    "djf": 216,
    "jja": 235,
    "mam": 170,
    "son": 225
   },
   "summer_half": 405,
   "winter_half": 441
  },
  "EH24": {
   "cells": 11,
   "mm": 848,
   "n": 79,
   "periods": {
    "1961-1990": 745,
    "1981-2010": 827,
    "1991-2020": 848
   },
   "seasons": {
    "djf": 224,
    "jja": 232,
    "mam": 163,
    "son": 230
   },
   "summer_half": 395,
   "winter_half": 454
  },
  "EH25": {
   "cells": 17,
   "mm": 894,
   "n": 144,
   "periods": {
    "1961-1990": 792,
    "1981-2010": 876,
    "1991-2020": 894
   },
   "seasons": {
    "djf": 243,
    "jja": 232,
    "mam": 177,
    "son": 242
   },
   "summer_half": 409,
   "winter_half": 485
  },
  "EH26": {
   "cells": 55,
   "mm": 1028,
   "n": 566,
   "periods": {
    "1961-1990": 918,
    "1981-2010": 1008,
    "1991-2020": 1028
   },
   "seasons": {
    "djf": 291,
    "jja": 260,
    "mam": 196,
    "son": 281
   },
   "summer_half": 456,
   "winter_half": 572
  },
  "EH27": {
   "cells": 19,
   "mm": 925,
   "n": 75,
   "periods": {
    "1961-1990": 822,
    "1981-2010": 903,
    "1991-2020": 925
   },
   "seasons": {
    "djf": 257,
    "jja": 236,
    "mam": 178,
    "son": 254
   },
   "summer_half": 414,
   "winter_half": 511
  },
  "EH28": {
   "cells": 20,
   "mm": 824,
   "n": 142,
   "periods": {
    "1961-1990": 718,
    "1981-2010": 796,
    "1991-2020": 824
   },
   "seasons": {
    "djf": 224,
    "jja": 220,
    "mam": 159,
    "son": 220
   },
   "summer_half": 379,
   "winter_half": 444
  },
  "EH29": {
   "cells": 12,
   "mm": 822,
   "n": 127,
   "periods": {
    "1961-1990": 715,
    "1981-2010": 794,
    "1991-2020": 822
   },
   "seasons": {
    "djf": 225,
    "jja": 221,
    "mam": 155,
    "son": 221
   },
   "summer_half": 376,
   "winter_half": 445
  },
  "EH3": {
   "cells": 11,
   "mm": 734,
   "n": 747,
   "periods": {
    "1961-1990": 646,
    "1981-2010": 710,
    "1991-2020": 734
   },
   "seasons": {
    "djf": 185,
    "jja": 212,
    "mam": 140,
    "son": 196
   },
   "summer_half": 353,
   "winter_half": 381
  },
  "EH30": {
   "cells": 18,
   "mm": 812,
   "n": 305,
   "periods": {
    "1961-1990": 706,
    "1981-2010": 784,
    "1991-2020": 812
   },
   "seasons": {
    "djf": 221,
    "jja": 221,
    "mam": 154,
    "son": 216
   },
   "summer_half": 375,
   "winter_half": 437
  },
  "EH31": {
   "cells": 6,
   "mm": 636,
   "n": 103,
   "periods": {
    "1961-1990": 583,
    "1981-2010": 619,
    "1991-2020": 636
   },
   "seasons": {
    "djf": 146,
    "jja": 192,
    "mam": 121,
    "son": 178
   },
   "summer_half": 312,
   "winter_half": 324
  },
  "EH32": {
   "cells": 30,
   "mm": 647,
   "n": 561,
   "periods": {
    "1961-1990": 582,
    "1981-2010": 626,
    "1991-2020": 647
   },
   "seasons": {
    "djf": 149,
    "jja": 201,
    "mam": 117,
    "son": 180
   },
   "summer_half": 318,
   "winter_half": 329
  },
  "EH33": {
   "cells": 27,
   "mm": 697,
   "n": 400,
   "periods": {
    "1961-1990": 628,
    "1981-2010": 674,
    "1991-2020": 697
   },
   "seasons": {
    "djf": 162,
    "jja": 209,
    "mam": 131,
    "son": 195
   },
   "summer_half": 340,
   "winter_half": 357
  },
  "EH34": {
   "cells": 28,
   "mm": 692,
   "n": 88,
   "periods": {
    "1961-1990": 630,
    "1981-2010": 670,
    "1991-2020": 692
   },
   "seasons": {
    "djf": 164,
    "jja": 207,
    "mam": 130,
    "son": 191
   },
   "summer_half": 337,
   "winter_half": 355
  },
  "EH35": {
   "cells": 7,
   "mm": 684,
   "n": 73,
   "periods": {
    "1961-1990": 621,
    "1981-2010": 666,
    "1991-2020": 684
   },
   "seasons": {
    "djf": 165,
    "jja": 199,
    "mam": 134,
    "son": 185
   },
   "summer_half": 333,
   "winter_half": 351
  },
  "EH36": {
   "cells": 8,
   "mm": 816,
   "n": 11,
   "periods": {
    "1961-1990": 750,
    "1981-2010": 793,
    "1991-2020": 816
   },
   "seasons": {
    "djf": 210,
    "jja": 219,
    "mam": 156,
    "son": 230
   },
   "summer_half": 376,
   "winter_half": 440
  },
  "EH37": {
   "cells": 36,
   "mm": 814,
   "n": 95,
   "periods": {
    "1961-1990": 747,
    "1981-2010": 801,
    "1991-2020": 814
   },
   "seasons": {
    "djf": 207,
    "jja": 215,
    "mam": 162,
    "son": 230
   },
   "summer_half": 377,
   "winter_half": 437
  },
  "EH38": {
   "cells": 8,
   "mm": 918,
   "n": 11,
   "periods": {
    "1961-1990": 860,
    "1981-2010": 909,
    "1991-2020": 918
   },
   "seasons": {
    "djf": 262,
    "jja": 207,
    "mam": 192,
    "son": 257
   },
   "summer_half": 399,
   "winter_half": 519
  },
  "EH39": {
   "cells": 67,
   "mm": 650,
   "n": 417,
   "periods": {
    "1961-1990": 599,
    "1981-2010": 630,
    "1991-2020": 650
   },
   "seasons": {
    "djf": 147,
    "jja": 196,
    "mam": 122,
    "son": 184
   },
   "summer_half": 319,
   "winter_half": 331
  },
  "EH4": {
   "cells": 25,
   "mm": 777,
   "n": 1701,
   "periods": {
    "1961-1990": 670,
    "1981-2010": 744,
    "1991-2020": 777
   },
   "seasons": {
    "djf": 201,
    "jja": 223,
    "mam": 147,
    "son": 207
   },
   "summer_half": 370,
   "winter_half": 407
  },
  "EH40": {
   "cells": 13,
   "mm": 658,
   "n": 68,
   "periods": {
    "1961-1990": 599,
    "1981-2010": 639,
    "1991-2020": 658
   },
   "seasons": {
    "djf": 149,
    "jja": 199,
    "mam": 128,
    "son": 182
   },
   "summer_half": 327,
   "winter_half": 331
  },
  "EH41": {
   "cells": 81,
   "mm": 734,
   "n": 472,
   "periods": {
    "1961-1990": 666,
    "1981-2010": 708,
    "1991-2020": 734
   },
   "seasons": {
    "djf": 177,
    "jja": 213,
    "mam": 140,
    "son": 204
   },
   "summer_half": 353,
   "winter_half": 381
  },
  "EH42": {
   "cells": 49,
   "mm": 707,
   "n": 363,
   "periods": {
    "1961-1990": 639,
    "1981-2010": 681,
    "1991-2020": 707
   },
   "seasons": {
    "djf": 165,
    "jja": 206,
    "mam": 140,
    "son": 196
   },
   "summer_half": 346,
   "winter_half": 361
  },
  "EH43": {
   "cells": 6,
   "mm": 974,
   "n": 27,
   "periods": {
    "1961-1990": 872,
    "1981-2010": 932,
    "1991-2020": 974
   },
   "seasons": {
    "djf": 288,
    "jja": 221,
    "mam": 192,
    "son": 273
   },
   "summer_half": 413,
   "winter_half": 561
  },
  "EH44": {
   "cells": 19,
   "mm": 1040,
   "n": 107,
   "periods": {
    "1961-1990": 925,
    "1981-2010": 1004,
    "1991-2020": 1040
   },
   "seasons": {
    "djf": 314,
    "jja": 236,
    "mam": 204,
    "son": 287
   },
   "summer_half": 440,
   "winter_half": 601
  },
  "EH45": {
   "cells": 57,
   "mm": 994,
   "n": 354,
   "periods": {
    "1961-1990": 901,
    "1981-2010": 963,
    "1991-2020": 994
   },
   "seasons": {
    "djf": 293,
    "jja": 233,
    "mam": 190,
    "son": 278
   },
   "summer_half": 422,
   "winter_half": 572
  },
  "EH46": {
   "cells": 43,
   "mm": 1031,
   "n": 110,
   "periods": {
    "1961-1990": 935,
    "1981-2010": 1008,
    "1991-2020": 1031
   },
   "seasons": {
    "djf": 296,
    "jja": 254,
    "mam": 196,
    "son": 285
   },
   "summer_half": 451,
   "winter_half": 581
  },
  "EH47": {
   "cells": 42,
   "mm": 1102,
   "n": 741,
   "periods": {
    "1961-1990": 982,
    "1981-2010": 1083,
    "1991-2020": 1102
   },
   "seasons": {
    "djf": 325,
    "jja": 257,
    "mam": 214,
    "son": 306
   },
   "summer_half": 471,
   "winter_half": 631
  },
  "EH48": {
   "cells": 61,
   "mm": 1056,
   "n": 936,
   "periods": {
    "1961-1990": 947,
    "1981-2010": 1034,
    "1991-2020": 1056
   },
   "seasons": {
    "djf": 308,
    "jja": 246,
    "mam": 207,
    "son": 296
   },
   "summer_half": 452,
   "winter_half": 603
  },
  "EH49": {
   "cells": 47,
   "mm": 913,
   "n": 432,
   "periods": {
    "1961-1990": 817,
    "1981-2010": 886,
    "1991-2020": 913
   },
   "seasons": {
    "djf": 257,
    "jja": 229,
    "mam": 171,
    "son": 256
   },
   "summer_half": 400,
   "winter_half": 513
  },
  "EH5": {
   "cells": 9,
   "mm": 736,
   "n": 638,
   "periods": {
    "1961-1990": 643,
    "1981-2010": 710,
    "1991-2020": 736
   },
   "seasons": {
    "djf": 187,
    "jja": 213,
    "mam": 139,
    "son": 197
   },
   "summer_half": 352,
   "winter_half": 384
  },
  "EH51": {
   "cells": 10,
   "mm": 881,
   "n": 424,
   "periods": {
    "1961-1990": 788,
    "1981-2010": 854,
    "1991-2020": 881
   },
   "seasons": {
    "djf": 242,
    "jja": 230,
    "mam": 159,
    "son": 251
   },
   "summer_half": 388,
   "winter_half": 492
  },
  "EH52": {
   "cells": 46,
   "mm": 884,
   "n": 583,
   "periods": {
    "1961-1990": 787,
    "1981-2010": 864,
    "1991-2020": 884
   },
   "seasons": {
    "djf": 245,
    "jja": 219,
    "mam": 168,
    "son": 251
   },
   "summer_half": 387,
   "winter_half": 497
  },
  "EH53": {
   "cells": 21,
   "mm": 911,
   "n": 322,
   "periods": {
    "1961-1990": 814,
    "1981-2010": 896,
    "1991-2020": 911
   },
   "seasons": {
    "djf": 254,
    "jja": 216,
    "mam": 171,
    "son": 270
   },
   "summer_half": 387,
   "winter_half": 525
  },
  "EH54": {
   "cells": 39,
   "mm": 952,
   "n": 973,
   "periods": {
    "1961-1990": 849,
    "1981-2010": 937,
    "1991-2020": 952
   },
   "seasons": {
    "djf": 271,
    "jja": 223,
    "mam": 186,
    "son": 272
   },
   "summer_half": 409,
   "winter_half": 544
  },
  "EH55": {
   "cells": 45,
   "mm": 1144,
   "n": 284,
   "periods": {
    "1961-1990": 1006,
    "1981-2010": 1120,
    "1991-2020": 1144
   },
   "seasons": {
    "djf": 338,
    "jja": 266,
    "mam": 220,
    "son": 321
   },
   "summer_half": 486,
   "winter_half": 659
  },
  "EH6": {
   "cells": 9,
   "mm": 686,
   "n": 1017,
   "periods": {
    "1961-1990": 605,
    "1981-2010": 666,
    "1991-2020": 686
   },
   "seasons": {
    "djf": 166,
    "jja": 205,
    "mam": 130,
    "son": 185
   },
   "summer_half": 335,
   "winter_half": 351
  },
  "EH7": {
   "cells": 13,
   "mm": 705,
   "n": 776,
   "periods": {
    "1961-1990": 622,
    "1981-2010": 685,
    "1991-2020": 705
   },
   "seasons": {
    "djf": 173,
    "jja": 208,
    "mam": 134,
    "son": 190
   },
   "summer_half": 342,
   "winter_half": 363
  },
  "EH8": {
   "cells": 11,
   "mm": 717,
   "n": 560,
   "periods": {
    "1961-1990": 636,
    "1981-2010": 698,
    "1991-2020": 717
   },
   "seasons": {
    "djf": 176,
    "jja": 211,
    "mam": 137,
    "son": 192
   },
   "summer_half": 348,
   "winter_half": 368
  },
  "EH9": {
   "cells": 11,
   "mm": 747,
   "n": 514,
   "periods": {
    "1961-1990": 665,
    "1981-2010": 725,
    "1991-2020": 747
   },
   "seasons": {
    "djf": 187,
    "jja": 219,
    "mam": 142,
    "son": 198
   },
   "summer_half": 361,
   "winter_half": 386
  },
  "EH91": {
   "cells": 2,
   "mm": 755,
   "n": 20,
   "periods": {
    "1961-1990": 660,
    "1981-2010": 727,
    "1991-2020": 755
   },
   "seasons": {
    "djf": 193,
    "jja": 213,
    "mam": 147,
    "son": 202
   },
   "summer_half": 360,
   "winter_half": 395
  },
  "EH95": {
   "cells": 1,
   "mm": 754,
   "n": 6,
   "periods": {
    "1961-1990": 650,
    "1981-2010": 721,
    "1991-2020": 754
   },
   "seasons": {
    "djf": 191,
    "jja": 218,
    "mam": 142,
    "son": 203
   },
   "summer_half": 360,
   "winter_half": 394
  },
  "EH99": {
   "cells": 2,
   "mm": 719,
   "n": 2,
   "periods": {
    "1961-1990": 634,
    "1981-2010": 696,
    "1991-2020": 719
   },
   "seasons": {
    "djf": 178,
    "jja": 210,
    "mam": 139,
    "son": 192
   },
   "summer_half": 349,
   "winter_half": 370
  },
  "EN1": {
   "cells": 17,
   "mm": 652,
   "n": 967,
   "periods": {
    "1961-1990": 633,
    "1981-2010": 645,
    "1991-2020": 652
   },
   "seasons": {
    "djf": 178,
    "jja": 160,
    "mam": 127,
    "son": 187
   },
   "summer_half": 287,
   "winter_half": 365
  },
  "EN10": {
   "cells": 21,
   "mm": 647,
   "n": 432,
   "periods": {
    "1961-1990": 633,
    "1981-2010": 645,
    "1991-2020": 647
   },
   "seasons": {
    "djf": 169,
    "jja": 163,
    "mam": 129,
    "son": 186
   },
   "summer_half": 292,
   "winter_half": 355
  },
  "EN11": {
   "cells": 18,
   "mm": 639,
   "n": 654,
   "periods": {
    "1961-1990": 621,
    "1981-2010": 638,
    "1991-2020": 639
   },
   "seasons": {
    "djf": 167,
    "jja": 161,
    "mam": 126,
    "son": 185
   },
   "summer_half": 287,
   "winter_half": 352
  },
  "EN2": {
   "cells": 28,
   "mm": 673,
   "n": 833,
   "periods": {
    "1961-1990": 652,
    "1981-2010": 667,
    "1991-2020": 673
   },
   "seasons": {
    "djf": 182,
    "jja": 167,
    "mam": 132,
    "son": 192
   },
   "summer_half": 299,
   "winter_half": 374
  },
  "EN3": {
   "cells": 16,
   "mm": 651,
   "n": 1004,
   "periods": {
    "1961-1990": 627,
    "1981-2010": 642,
    "1991-2020": 651
   },
   "seasons": {
    "djf": 177,
    "jja": 161,
    "mam": 123,
    "son": 189
   },
   "summer_half": 284,
   "winter_half": 367
  },
  "EN4": {
   "cells": 22,
   "mm": 703,
   "n": 565,
   "periods": {
    "1961-1990": 686,
    "1981-2010": 699,
    "1991-2020": 703
   },
   "seasons": {
    "djf": 190,
    "jja": 172,
    "mam": 139,
    "son": 202
   },
   "summer_half": 311,
   "winter_half": 392
  },
  "EN5": {
   "cells": 29,
   "mm": 704,
   "n": 1051,
   "periods": {
    "1961-1990": 702,
    "1981-2010": 701,
    "1991-2020": 704
   },
   "seasons": {
    "djf": 190,
    "jja": 170,
    "mam": 139,
    "son": 204
   },
   "summer_half": 310,
   "winter_half": 395
  },
  "EN6": {
   "cells": 40,
   "mm": 680,
   "n": 876,
   "periods": {
    "1961-1990": 674,
    "1981-2010": 679,
    "1991-2020": 680
   },
   "seasons": {
    "djf": 181,
    "jja": 166,
    "mam": 136,
    "son": 198
   },
   "summer_half": 301,
   "winter_half": 379
  },
  "EN7": {
   "cells": 24,
   "mm": 677,
   "n": 515,
   "periods": {
    "1961-1990": 666,
    "1981-2010": 672,
    "1991-2020": 677
   },
   "seasons": {
    "djf": 182,
    "jja": 168,
    "mam": 133,
    "son": 195
   },
   "summer_half": 301,
   "winter_half": 377
  },
  "EN8": {
   "cells": 17,
   "mm": 638,
   "n": 918,
   "periods": {
    "1961-1990": 618,
    "1981-2010": 631,
    "1991-2020": 638
   },
   "seasons": {
    "djf": 169,
    "jja": 160,
    "mam": 125,
    "son": 184
   },
   "summer_half": 285,
   "winter_half": 352
  },
  "EN9": {
   "cells": 46,
   "mm": 638,
   "n": 686,
   "periods": {
    "1961-1990": 614,
    "1981-2010": 630,
    "1991-2020": 638
   },
   "seasons": {
    "djf": 167,
    "jja": 160,
    "mam": 125,
    "son": 186
   },
   "summer_half": 285,
   "winter_half": 352
  },
  "EX1": {
   "cells": 17,
   "mm": 857,
   "n": 890,
   "periods": {
    "1961-1990": 800,
    "1981-2010": 824,
    "1991-2020": 857
   },
   "seasons": {
    "djf": 258,
    "jja": 174,
    "mam": 173,
    "son": 251
   },
   "summer_half": 347,
   "winter_half": 510
  },
  "EX10": {
   "cells": 54,
   "mm": 1012,
   "n": 831,
   "periods": {
    "1961-1990": 927,
    "1981-2010": 969,
    "1991-2020": 1012
   },
   "seasons": {
    "djf": 290,
    "jja": 215,
    "mam": 210,
    "son": 297
   },
   "summer_half": 425,
   "winter_half": 587
  },
  "EX11": {
   "cells": 40,
   "mm": 964,
   "n": 337,
   "periods": {
    "1961-1990": 909,
    "1981-2010": 922,
    "1991-2020": 964
   },
   "seasons": {
    "djf": 281,
    "jja": 196,
    "mam": 201,
    "son": 285
   },
   "summer_half": 398,
   "winter_half": 566
  },
  "EX12": {
   "cells": 29,
   "mm": 990,
   "n": 496,
   "periods": {
    "1961-1990": 907,
    "1981-2010": 951,
    "1991-2020": 990
   },
   "seasons": {
    "djf": 282,
    "jja": 216,
    "mam": 202,
    "son": 290
   },
   "summer_half": 418,
   "winter_half": 572
  },
  "EX13": {
   "cells": 120,
   "mm": 1091,
   "n": 604,
   "periods": {
    "1961-1990": 987,
    "1981-2010": 1050,
    "1991-2020": 1091
   },
   "seasons": {
    "djf": 324,
    "jja": 215,
    "mam": 222,
    "son": 330
   },
   "summer_half": 437,
   "winter_half": 654
  },
  "EX14": {
   "cells": 184,
   "mm": 1103,
   "n": 971,
   "periods": {
    "1961-1990": 1029,
    "1981-2010": 1071,
    "1991-2020": 1103
   },
   "seasons": {
    "djf": 326,
    "jja": 222,
    "mam": 222,
    "son": 332
   },
   "summer_half": 445,
   "winter_half": 658
  },
  "EX15": {
   "cells": 171,
   "mm": 1001,
   "n": 907,
   "periods": {
    "1961-1990": 947,
    "1981-2010": 973,
    "1991-2020": 1001
   },
   "seasons": {
    "djf": 296,
    "jja": 209,
    "mam": 200,
    "son": 295
   },
   "summer_half": 410,
   "winter_half": 591
  },
  "EX16": {
   "cells": 288,
   "mm": 1120,
   "n": 1350,
   "periods": {
    "1961-1990": 1061,
    "1981-2010": 1104,
    "1991-2020": 1120
   },
   "seasons": {
    "djf": 345,
    "jja": 231,
    "mam": 219,
    "son": 325
   },
   "summer_half": 450,
   "winter_half": 670
  },
  "EX17": {
   "cells": 249,
   "mm": 964,
   "n": 1006,
   "periods": {
    "1961-1990": 930,
    "1981-2010": 953,
    "1991-2020": 964
   },
   "seasons": {
    "djf": 295,
    "jja": 199,
    "mam": 191,
    "son": 279
   },
   "summer_half": 390,
   "winter_half": 574
  },
  "EX18": {
   "cells": 84,
   "mm": 1091,
   "n": 197,
   "periods": {
    "1961-1990": 1038,
    "1981-2010": 1078,
    "1991-2020": 1091
   },
   "seasons": {
    "djf": 338,
    "jja": 233,
    "mam": 203,
    "son": 317
   },
   "summer_half": 436,
   "winter_half": 654
  },
  "EX19": {
   "cells": 78,
   "mm": 1108,
   "n": 220,
   "periods": {
    "1961-1990": 1042,
    "1981-2010": 1092,
    "1991-2020": 1108
   },
   "seasons": {
    "djf": 345,
    "jja": 234,
    "mam": 205,
    "son": 324
   },
   "summer_half": 439,
   "winter_half": 669
  },
  "EX2": {
   "cells": 45,
   "mm": 895,
   "n": 1436,
   "periods": {
    "1961-1990": 839,
    "1981-2010": 861,
    "1991-2020": 895
   },
   "seasons": {
    "djf": 283,
    "jja": 167,
    "mam": 181,
    "son": 263
   },
   "summer_half": 348,
   "winter_half": 546
  },
  "EX20": {
   "cells": 298,
   "mm": 1244,
   "n": 1060,
   "periods": {
    "1961-1990": 1176,
    "1981-2010": 1218,
    "1991-2020": 1244
   },
   "seasons": {
    "djf": 405,
    "jja": 244,
    "mam": 234,
    "son": 361
   },
   "summer_half": 478,
   "winter_half": 766
  },
  "EX21": {
   "cells": 128,
   "mm": 1227,
   "n": 285,
   "periods": {
    "1961-1990": 1153,
    "1981-2010": 1200,
    "1991-2020": 1227
   },
   "seasons": {
    "djf": 384,
    "jja": 257,
    "mam": 226,
    "son": 360
   },
   "summer_half": 482,
   "winter_half": 744
  },
  "EX22": {
   "cells": 231,
   "mm": 1281,
   "n": 616,
   "periods": {
    "1961-1990": 1203,
    "1981-2010": 1253,
    "1991-2020": 1281
   },
   "seasons": {
    "djf": 394,
    "jja": 277,
    "mam": 230,
    "son": 379
   },
   "summer_half": 508,
   "winter_half": 773
  },
  "EX23": {
   "cells": 143,
   "mm": 1186,
   "n": 700,
   "periods": {
    "1961-1990": 1121,
    "1981-2010": 1172,
    "1991-2020": 1186
   },
   "seasons": {
    "djf": 356,
    "jja": 264,
    "mam": 212,
    "son": 354
   },
   "summer_half": 476,
   "winter_half": 710
  },
  "EX24": {
   "cells": 45,
   "mm": 1104,
   "n": 213,
   "periods": {
    "1961-1990": 1000,
    "1981-2010": 1060,
    "1991-2020": 1104
   },
   "seasons": {
    "djf": 321,
    "jja": 227,
    "mam": 226,
    "son": 331
   },
   "summer_half": 452,
   "winter_half": 652
  },
  "EX3": {
   "cells": 15,
   "mm": 837,
   "n": 225,
   "periods": {
    "1961-1990": 796,
    "1981-2010": 806,
    "1991-2020": 837
   },
   "seasons": {
    "djf": 255,
    "jja": 164,
    "mam": 173,
    "son": 245
   },
   "summer_half": 337,
   "winter_half": 500
  },
  "EX31": {
   "cells": 180,
   "mm": 1292,
   "n": 986,
   "periods": {
    "1961-1990": 1185,
    "1981-2010": 1261,
    "1991-2020": 1292
   },
   "seasons": {
    "djf": 386,
    "jja": 288,
    "mam": 232,
    "son": 387
   },
   "summer_half": 519,
   "winter_half": 773
  },
  "EX32": {
   "cells": 109,
   "mm": 1274,
   "n": 841,
   "periods": {
    "1961-1990": 1186,
    "1981-2010": 1246,
    "1991-2020": 1274
   },
   "seasons": {
    "djf": 382,
    "jja": 287,
    "mam": 228,
    "son": 377
   },
   "summer_half": 515,
   "winter_half": 759
  },
  "EX33": {
   "cells": 39,
   "mm": 1072,
   "n": 371,
   "periods": {
    "1961-1990": 974,
    "1981-2010": 1039,
    "1991-2020": 1072
   },
   "seasons": {
    "djf": 305,
    "jja": 246,
    "mam": 200,
    "son": 321
   },
   "summer_half": 446,
   "winter_half": 626
  },
  "EX34": {
   "cells": 69,
   "mm": 1277,
   "n": 666,
   "periods": {
    "1961-1990": 1169,
    "1981-2010": 1243,
    "1991-2020": 1277
   },
   "seasons": {
    "djf": 370,
    "jja": 286,
    "mam": 228,
    "son": 394
   },
   "summer_half": 514,
   "winter_half": 764
  },
  "EX35": {
   "cells": 32,
   "mm": 1493,
   "n": 119,
   "periods": {
    "1961-1990": 1320,
    "1981-2010": 1457,
    "1991-2020": 1493
   },
   "seasons": {
    "djf": 489,
    "jja": 299,
    "mam": 264,
    "son": 441
   },
   "summer_half": 562,
   "winter_half": 930
  },
  "EX36": {
   "cells": 146,
   "mm": 1298,
   "n": 416,
   "periods": {
    "1961-1990": 1231,
    "1981-2010": 1279,
    "1991-2020": 1298
   },
   "seasons": {
    "djf": 403,
    "jja": 276,
    "mam": 239,
    "son": 380
   },
   "summer_half": 515,
   "winter_half": 783
  },
  "EX37": {
   "cells": 105,
   "mm": 1092,
   "n": 202,
   "periods": {
    "1961-1990": 1038,
    "1981-2010": 1084,
    "1991-2020": 1092
   },
   "seasons": {
    "djf": 331,
    "jja": 238,
    "mam": 201,
    "son": 323
   },
   "summer_half": 439,
   "winter_half": 653
  },
  "EX38": {
   "cells": 82,
   "mm": 1197,
   "n": 313,
   "periods": {
    "1961-1990": 1117,
    "1981-2010": 1178,
    "1991-2020": 1197
   },
   "seasons": {
    "djf": 371,
    "jja": 255,
    "mam": 219,
    "son": 352
   },
   "summer_half": 474,
   "winter_half": 723
  },
  "EX39": {
   "cells": 196,
   "mm": 1212,
   "n": 1391,
   "periods": {
    "1961-1990": 1126,
    "1981-2010": 1181,
    "1991-2020": 1212
   },
   "seasons": {
    "djf": 375,
    "jja": 257,
    "mam": 215,
    "son": 365
   },
   "summer_half": 472,
   "winter_half": 740
  },
  "EX4": {
   "cells": 53,
   "mm": 916,
   "n": 1465,
   "periods": {
    "1961-1990": 869,
    "1981-2010": 884,
    "1991-2020": 916
   },
   "seasons": {
    "djf": 280,
    "jja": 183,
    "mam": 185,
    "son": 268
   },
   "summer_half": 368,
   "winter_half": 548
  },
  "EX5": {
   "cells": 207,
   "mm": 891,
   "n": 1149,
   "periods": {
    "1961-1990": 843,
    "1981-2010": 856,
    "1991-2020": 891
   },
   "seasons": {
    "djf": 261,
    "jja": 185,
    "mam": 181,
    "son": 263
   },
   "summer_half": 367,
   "winter_half": 524
  },
  "EX6": {
   "cells": 197,
   "mm": 1017,
   "n": 727,
   "periods": {
    "1961-1990": 953,
    "1981-2010": 988,
    "1991-2020": 1017
   },
   "seasons": {
    "djf": 327,
    "jja": 188,
    "mam": 205,
    "son": 297
   },
   "summer_half": 393,
   "winter_half": 624
  },
  "EX7": {
   "cells": 24,
   "mm": 950,
   "n": 500,
   "periods": {
    "1961-1990": 883,
    "1981-2010": 917,
    "1991-2020": 950
   },
   "seasons": {
    "djf": 290,
    "jja": 181,
    "mam": 196,
    "son": 282
   },
   "summer_half": 377,
   "winter_half": 573
  },
  "EX8": {
   "cells": 24,
   "mm": 831,
   "n": 1092,
   "periods": {
    "1961-1990": 787,
    "1981-2010": 817,
    "1991-2020": 831
   },
   "seasons": {
    "djf": 247,
    "jja": 165,
    "mam": 175,
    "son": 243
   },
   "summer_half": 341,
   "winter_half": 491
  },
  "EX9": {
   "cells": 21,
   "mm": 844,
   "n": 314,
   "periods": {
    "1961-1990": 784,
    "1981-2010": 818,
    "1991-2020": 844
   },
   "seasons": {
    "djf": 249,
    "jja": 170,
    "mam": 178,
    "son": 246
   },
   "summer_half": 349,
   "winter_half": 495
  },
  "FK1": {
   "cells": 81,
   "mm": 1151,
   "n": 881,
   "periods": {
    "1961-1990": 1032,
    "1981-2010": 1129,
    "1991-2020": 1151
   },
   "seasons": {
    "djf": 350,
    "jja": 269,
    "mam": 216,
    "son": 316
   },
   "summer_half": 485,
   "winter_half": 666
  },
  "FK10": {
   "cells": 54,
   "mm": 975,
   "n": 893,
   "periods": {
    "1961-1990": 889,
    "1981-2010": 965,
    "1991-2020": 975
   },
   "seasons": {
    "djf": 292,
    "jja": 236,
    "mam": 181,
    "son": 267
   },
   "summer_half": 416,
   "winter_half": 559
  },
  "FK11": {
   "cells": 4,
   "mm": 1064,
   "n": 75,
   "periods": {
    "1961-1990": 976,
    "1981-2010": 1047,
    "1991-2020": 1064
   },
   "seasons": {
    "djf": 317,
    "jja": 255,
    "mam": 203,
    "son": 289
   },
   "summer_half": 458,
   "winter_half": 606
  },
  "FK12": {
   "cells": 7,
   "mm": 1043,
   "n": 151,
   "periods": {
    "1961-1990": 958,
    "1981-2010": 1033,
    "1991-2020": 1043
   },
   "seasons": {
    "djf": 310,
    "jja": 251,
    "mam": 197,
    "son": 285
   },
   "summer_half": 448,
   "winter_half": 595
  },
  "FK13": {
   "cells": 10,
   "mm": 1059,
   "n": 186,
   "periods": {
    "1961-1990": 989,
    "1981-2010": 1051,
    "1991-2020": 1059
   },
   "seasons": {
    "djf": 308,
    "jja": 262,
    "mam": 199,
    "son": 291
   },
   "summer_half": 460,
   "winter_half": 598
  },
  "FK14": {
   "cells": 41,
   "mm": 1325,
   "n": 172,
   "periods": {
    "1961-1990": 1183,
    "1981-2010": 1308,
    "1991-2020": 1325
   },
   "seasons": {
    "djf": 416,
    "jja": 295,
    "mam": 250,
    "son": 364
   },
   "summer_half": 545,
   "winter_half": 780
  },
  "FK15": {
   "cells": 50,
   "mm": 1250,
   "n": 358,
   "periods": {
    "1961-1990": 1142,
    "1981-2010": 1231,
    "1991-2020": 1250
   },
   "seasons": {
    "djf": 392,
    "jja": 277,
    "mam": 239,
    "son": 342
   },
   "summer_half": 516,
   "winter_half": 734
  },
  "FK16": {
   "cells": 14,
   "mm": 1249,
   "n": 74,
   "periods": {
    "1961-1990": 1140,
    "1981-2010": 1233,
    "1991-2020": 1249
   },
   "seasons": {
    "djf": 396,
    "jja": 272,
    "mam": 235,
    "son": 346
   },
   "summer_half": 508,
   "winter_half": 742
  },
  "FK17": {
   "cells": 30,
   "mm": 1767,
   "n": 131,
   "periods": {
    "1961-1990": 1604,
    "1981-2010": 1758,
    "1991-2020": 1767
   },
   "seasons": {
    "djf": 589,
    "jja": 340,
    "mam": 331,
    "son": 508
   },
   "summer_half": 671,
   "winter_half": 1096
  },
  "FK18": {
   "cells": 4,
   "mm": 2130,
   "n": 8,
   "periods": {
    "1961-1990": 1977,
    "1981-2010": 2114,
    "1991-2020": 2130
   },
   "seasons": {
    "djf": 724,
    "jja": 365,
    "mam": 424,
    "son": 618
   },
   "summer_half": 789,
   "winter_half": 1342
  },
  "FK19": {
   "cells": 17,
   "mm": 1950,
   "n": 28,
   "periods": {
    "1961-1990": 1768,
    "1981-2010": 1948,
    "1991-2020": 1950
   },
   "seasons": {
    "djf": 675,
    "jja": 328,
    "mam": 375,
    "son": 572
   },
   "summer_half": 704,
   "winter_half": 1246
  },
  "FK2": {
   "cells": 67,
   "mm": 1018,
   "n": 1234,
   "periods": {
    "1961-1990": 908,
    "1981-2010": 998,
    "1991-2020": 1018
   },
   "seasons": {
    "djf": 313,
    "jja": 236,
    "mam": 189,
    "son": 280
   },
   "summer_half": 425,
   "winter_half": 593
  },
  "FK20": {
   "cells": 9,
   "mm": 2665,
   "n": 23,
   "periods": {
    "1961-1990": 2376,
    "1981-2010": 2626,
    "1991-2020": 2665
   },
   "seasons": {
    "djf": 938,
    "jja": 437,
    "mam": 528,
    "son": 762
   },
   "summer_half": 965,
   "winter_half": 1700
  },
  "FK21": {
   "cells": 22,
   "mm": 1794,
   "n": 53,
   "periods": {
    "1961-1990": 1638,
    "1981-2010": 1795,
    "1991-2020": 1794
   },
   "seasons": {
    "djf": 640,
    "jja": 295,
    "mam": 348,
    "son": 511
   },
   "summer_half": 643,
   "winter_half": 1150
  },
  "FK3": {
   "cells": 14,
   "mm": 898,
   "n": 458,
   "periods": {
    "1961-1990": 800,
    "1981-2010": 875,
    "1991-2020": 898
   },
   "seasons": {
    "djf": 275,
    "jja": 212,
    "mam": 164,
    "son": 246
   },
   "summer_half": 377,
   "winter_half": 521
  },
  "FK4": {
   "cells": 25,
   "mm": 1241,
   "n": 339,
   "periods": {
    "1961-1990": 1132,
    "1981-2010": 1226,
    "1991-2020": 1241
   },
   "seasons": {
    "djf": 388,
    "jja": 272,
    "mam": 234,
    "son": 347
   },
   "summer_half": 506,
   "winter_half": 735
  },
  "FK5": {
   "cells": 22,
   "mm": 1124,
   "n": 460,
   "periods": {
    "1961-1990": 1006,
    "1981-2010": 1109,
    "1991-2020": 1124
   },
   "seasons": {
    "djf": 354,
    "jja": 250,
    "mam": 209,
    "son": 312
   },
   "summer_half": 459,
   "winter_half": 666
  },
  "FK6": {
   "cells": 29,
   "mm": 1390,
   "n": 349,
   "periods": {
    "1961-1990": 1277,
    "1981-2010": 1384,
    "1991-2020": 1390
   },
   "seasons": {
    "djf": 443,
    "jja": 292,
    "mam": 264,
    "son": 391
   },
   "summer_half": 556,
   "winter_half": 834
  },
  "FK7": {
   "cells": 66,
   "mm": 1179,
   "n": 864,
   "periods": {
    "1961-1990": 1087,
    "1981-2010": 1176,
    "1991-2020": 1179
   },
   "seasons": {
    "djf": 369,
    "jja": 248,
    "mam": 226,
    "son": 337
   },
   "summer_half": 474,
   "winter_half": 706
  },
  "FK8": {
   "cells": 115,
   "mm": 1481,
   "n": 639,
   "periods": {
    "1961-1990": 1356,
    "1981-2010": 1469,
    "1991-2020": 1481
   },
   "seasons": {
    "djf": 488,
    "jja": 288,
    "mam": 283,
    "son": 422
   },
   "summer_half": 571,
   "winter_half": 910
  },
  "FK9": {
   "cells": 46,
   "mm": 1088,
   "n": 409,
   "periods": {
    "1961-1990": 1017,
    "1981-2010": 1080,
    "1991-2020": 1088
   },
   "seasons": {
    "djf": 342,
    "jja": 239,
    "mam": 205,
    "son": 303
   },
   "summer_half": 443,
   "winter_half": 645
  },
  "FY1": {
   "cells": 13,
   "mm": 942,
   "n": 952,
   "periods": {
    "1961-1990": 910,
    "1981-2010": 938,
    "1991-2020": 942
   },
   "seasons": {
    "djf": 255,
    "jja": 223,
    "mam": 169,
    "son": 295
   },
   "summer_half": 392,
   "winter_half": 550
  },
  "FY2": {
   "cells": 11,
   "mm": 965,
   "n": 559,
   "periods": {
    "1961-1990": 924,
    "1981-2010": 949,
    "1991-2020": 965
   },
   "seasons": {
    "djf": 263,
    "jja": 229,
    "mam": 174,
    "son": 299
   },
   "summer_half": 403,
   "winter_half": 562
  },
  "FY3": {
   "cells": 22,
   "mm": 951,
   "n": 782,
   "periods": {
    "1961-1990": 922,
    "1981-2010": 949,
    "1991-2020": 951
   },
   "seasons": {
    "djf": 256,
    "jja": 224,
    "mam": 172,
    "son": 299
   },
   "summer_half": 396,
   "winter_half": 555
  },
  "FY4": {
   "cells": 28,
   "mm": 905,
   "n": 1122,
   "periods": {
    "1961-1990": 882,
    "1981-2010": 910,
    "1991-2020": 905
   },
   "seasons": {
    "djf": 244,
    "jja": 215,
    "mam": 162,
    "son": 284
   },
   "summer_half": 378,
   "winter_half": 527
  },
  "FY5": {
   "cells": 21,
   "mm": 954,
   "n": 1179,
   "periods": {
    "1961-1990": 909,
    "1981-2010": 930,
    "1991-2020": 954
   },
   "seasons": {
    "djf": 261,
    "jja": 229,
    "mam": 171,
    "son": 293
   },
   "summer_half": 400,
   "winter_half": 554
  },
  "FY6": {
   "cells": 53,
   "mm": 974,
   "n": 856,
   "periods": {
    "1961-1990": 929,
    "1981-2010": 957,
    "1991-2020": 974
   },
   "seasons": {
    "djf": 263,
    "jja": 233,
    "mam": 174,
    "son": 303
   },
   "summer_half": 407,
   "winter_half": 566
  },
  "FY7": {
   "cells": 12,
   "mm": 912,
   "n": 648,
   "periods": {
    "1961-1990": 889,
    "1981-2010": 899,
    "1991-2020": 912
   },
   "seasons": {
    "djf": 251,
    "jja": 223,
    "mam": 158,
    "son": 279
   },
   "summer_half": 381,
   "winter_half": 531
  },
  "FY8": {
   "cells": 32,
   "mm": 900,
   "n": 1294,
   "periods": {
    "1961-1990": 875,
    "1981-2010": 898,
    "1991-2020": 900
   },
   "seasons": {
    "djf": 242,
    "jja": 217,
    "mam": 162,
    "son": 280
   },
   "summer_half": 379,
   "winter_half": 521
  },
  "G1": {
   "cells": 6,
   "mm": 1042,
   "n": 380,
   "periods": {
    "1961-1990": 957,
    "1981-2010": 1028,
    "1991-2020": 1042
   },
   "seasons": {
    "djf": 317,
    "jja": 229,
    "mam": 197,
    "son": 299
   },
   "summer_half": 426,
   "winter_half": 616
  },
  "G11": {
   "cells": 5,
   "mm": 1113,
   "n": 498,
   "periods": {
    "1961-1990": 1019,
    "1981-2010": 1111,
    "1991-2020": 1113
   },
   "seasons": {
    "djf": 342,
    "jja": 243,
    "mam": 208,
    "son": 319
   },
   "summer_half": 451,
   "winter_half": 662
  },
  "G12": {
   "cells": 9,
   "mm": 1118,
   "n": 658,
   "periods": {
    "1961-1990": 1031,
    "1981-2010": 1123,
    "1991-2020": 1118
   },
   "seasons": {
    "djf": 342,
    "jja": 244,
    "mam": 210,
    "son": 323
   },
   "summer_half": 454,
   "winter_half": 664
  },
  "G13": {
   "cells": 15,
   "mm": 1179,
   "n": 877,
   "periods": {
    "1961-1990": 1082,
    "1981-2010": 1183,
    "1991-2020": 1179
   },
   "seasons": {
    "djf": 365,
    "jja": 254,
    "mam": 219,
    "son": 339
   },
   "summer_half": 474,
   "winter_half": 705
  },
  "G14": {
   "cells": 10,
   "mm": 1144,
   "n": 428,
   "periods": {
    "1961-1990": 1044,
    "1981-2010": 1142,
    "1991-2020": 1144
   },
   "seasons": {
    "djf": 358,
    "jja": 246,
    "mam": 212,
    "son": 328
   },
   "summer_half": 459,
   "winter_half": 686
  },
  "G15": {
   "cells": 11,
   "mm": 1253,
   "n": 408,
   "periods": {
    "1961-1990": 1149,
    "1981-2010": 1256,
    "1991-2020": 1253
   },
   "seasons": {
    "djf": 388,
    "jja": 269,
    "mam": 234,
    "son": 362
   },
   "summer_half": 503,
   "winter_half": 750
  },
  "G2": {
   "cells": 6,
   "mm": 1044,
   "n": 529,
   "periods": {
    "1961-1990": 959,
    "1981-2010": 1031,
    "1991-2020": 1044
   },
   "seasons": {
    "djf": 317,
    "jja": 230,
    "mam": 197,
    "son": 300
   },
   "summer_half": 427,
   "winter_half": 617
  },
  "G20": {
   "cells": 13,
   "mm": 1136,
   "n": 746,
   "periods": {
    "1961-1990": 1052,
    "1981-2010": 1143,
    "1991-2020": 1136
   },
   "seasons": {
    "djf": 347,
    "jja": 248,
    "mam": 214,
    "son": 326
   },
   "summer_half": 463,
   "winter_half": 673
  },
  "G21": {
   "cells": 17,
   "mm": 1121,
   "n": 631,
   "periods": {
    "1961-1990": 1037,
    "1981-2010": 1115,
    "1991-2020": 1121
   },
   "seasons": {
    "djf": 333,
    "jja": 255,
    "mam": 213,
    "son": 320
   },
   "summer_half": 468,
   "winter_half": 653
  },
  "G22": {
   "cells": 9,
   "mm": 1135,
   "n": 422,
   "periods": {
    "1961-1990": 1060,
    "1981-2010": 1139,
    "1991-2020": 1135
   },
   "seasons": {
    "djf": 340,
    "jja": 253,
    "mam": 216,
    "son": 326
   },
   "summer_half": 469,
   "winter_half": 666
  },
  "G23": {
   "cells": 9,
   "mm": 1224,
   "n": 148,
   "periods": {
    "1961-1990": 1138,
    "1981-2010": 1238,
    "1991-2020": 1224
   },
   "seasons": {
    "djf": 376,
    "jja": 266,
    "mam": 231,
    "son": 352
   },
   "summer_half": 497,
   "winter_half": 728
  },
  "G3": {
   "cells": 11,
   "mm": 1060,
   "n": 482,
   "periods": {
    "1961-1990": 973,
    "1981-2010": 1050,
    "1991-2020": 1060
   },
   "seasons": {
    "djf": 324,
    "jja": 232,
    "mam": 199,
    "son": 305
   },
   "summer_half": 431,
   "winter_half": 629
  },
  "G31": {
   "cells": 10,
   "mm": 1055,
   "n": 659,
   "periods": {
    "1961-1990": 957,
    "1981-2010": 1035,
    "1991-2020": 1055
   },
   "seasons": {
    "djf": 325,
    "jja": 233,
    "mam": 203,
    "son": 293
   },
   "summer_half": 436,
   "winter_half": 619
  },
  "G32": {
   "cells": 22,
   "mm": 1056,
   "n": 989,
   "periods": {
    "1961-1990": 953,
    "1981-2010": 1033,
    "1991-2020": 1056
   },
   "seasons": {
    "djf": 327,
    "jja": 234,
    "mam": 204,
    "son": 292
   },
   "summer_half": 437,
   "winter_half": 619
  },
  "G33": {
   "cells": 30,
   "mm": 1137,
   "n": 1117,
   "periods": {
    "1961-1990": 1044,
    "1981-2010": 1124,
    "1991-2020": 1137
   },
   "seasons": {
    "djf": 342,
    "jja": 262,
    "mam": 214,
    "son": 319
   },
   "summer_half": 476,
   "winter_half": 661
  },
  "G34": {
   "cells": 8,
   "mm": 1055,
   "n": 208,
   "periods": {
    "1961-1990": 965,
    "1981-2010": 1035,
    "1991-2020": 1055
   },
   "seasons": {
    "djf": 316,
    "jja": 251,
    "mam": 196,
    "son": 292
   },
   "summer_half": 447,
   "winter_half": 608
  },
  "G4": {
   "cells": 10,
   "mm": 1078,
   "n": 340,
   "periods": {
    "1961-1990": 991,
    "1981-2010": 1067,
    "1991-2020": 1078
   },
   "seasons": {
    "djf": 328,
    "jja": 238,
    "mam": 204,
    "son": 308
   },
   "summer_half": 442,
   "winter_half": 636
  },
  "G40": {
   "cells": 10,
   "mm": 1032,
   "n": 436,
   "periods": {
    "1961-1990": 940,
    "1981-2010": 1013,
    "1991-2020": 1032
   },
   "seasons": {
    "djf": 319,
    "jja": 225,
    "mam": 197,
    "son": 291
   },
   "summer_half": 422,
   "winter_half": 609
  },
  "G41": {
   "cells": 13,
   "mm": 1083,
   "n": 817,
   "periods": {
    "1961-1990": 990,
    "1981-2010": 1066,
    "1991-2020": 1083
   },
   "seasons": {
    "djf": 336,
    "jja": 227,
    "mam": 207,
    "son": 313
   },
   "summer_half": 435,
   "winter_half": 649
  },
  "G42": {
   "cells": 9,
   "mm": 1049,
   "n": 652,
   "periods": {
    "1961-1990": 964,
    "1981-2010": 1034,
    "1991-2020": 1049
   },
   "seasons": {
    "djf": 320,
    "jja": 225,
    "mam": 200,
    "son": 303
   },
   "summer_half": 426,
   "winter_half": 623
  },
  "G43": {
   "cells": 15,
   "mm": 1151,
   "n": 432,
   "periods": {
    "1961-1990": 1047,
    "1981-2010": 1133,
    "1991-2020": 1151
   },
   "seasons": {
    "djf": 366,
    "jja": 240,
    "mam": 213,
    "son": 332
   },
   "summer_half": 453,
   "winter_half": 698
  },
  "G44": {
   "cells": 13,
   "mm": 1099,
   "n": 618,
   "periods": {
    "1961-1990": 1006,
    "1981-2010": 1084,
    "1991-2020": 1099
   },
   "seasons": {
    "djf": 340,
    "jja": 234,
    "mam": 208,
    "son": 317
   },
   "summer_half": 442,
   "winter_half": 657
  },
  "G45": {
   "cells": 9,
   "mm": 1145,
   "n": 306,
   "periods": {
    "1961-1990": 1046,
    "1981-2010": 1129,
    "1991-2020": 1145
   },
   "seasons": {
    "djf": 355,
    "jja": 246,
    "mam": 218,
    "son": 327
   },
   "summer_half": 464,
   "winter_half": 681
  },
  "G46": {
   "cells": 16,
   "mm": 1237,
   "n": 676,
   "periods": {
    "1961-1990": 1122,
    "1981-2010": 1217,
    "1991-2020": 1237
   },
   "seasons": {
    "djf": 401,
    "jja": 249,
    "mam": 230,
    "son": 357
   },
   "summer_half": 479,
   "winter_half": 758
  },
  "G5": {
   "cells": 8,
   "mm": 1029,
   "n": 355,
   "periods": {
    "1961-1990": 944,
    "1981-2010": 1014,
    "1991-2020": 1029
   },
   "seasons": {
    "djf": 316,
    "jja": 223,
    "mam": 195,
    "son": 296
   },
   "summer_half": 418,
   "winter_half": 611
  },
  "G51": {
   "cells": 16,
   "mm": 1118,
   "n": 676,
   "periods": {
    "1961-1990": 1020,
    "1981-2010": 1106,
    "1991-2020": 1118
   },
   "seasons": {
    "djf": 349,
    "jja": 242,
    "mam": 209,
    "son": 318
   },
   "summer_half": 451,
   "winter_half": 667
  },
  "G52": {
   "cells": 16,
   "mm": 1135,
   "n": 762,
   "periods": {
    "1961-1990": 1031,
    "1981-2010": 1120,
    "1991-2020": 1135
   },
   "seasons": {
    "djf": 361,
    "jja": 240,
    "mam": 212,
    "son": 322
   },
   "summer_half": 452,
   "winter_half": 684
  },
  "G53": {
   "cells": 17,
   "mm": 1239,
   "n": 743,
   "periods": {
    "1961-1990": 1125,
    "1981-2010": 1220,
    "1991-2020": 1239
   },
   "seasons": {
    "djf": 407,
    "jja": 242,
    "mam": 231,
    "son": 359
   },
   "summer_half": 473,
   "winter_half": 766
  },
  "G58": {
   "cells": 2,
   "mm": 1134,
   "n": 13,
   "periods": {
    "1961-1990": 1034,
    "1981-2010": 1117,
    "1991-2020": 1134
   },
   "seasons": {
    "djf": 353,
    "jja": 243,
    "mam": 212,
    "son": 326
   },
   "summer_half": 455,
   "winter_half": 679
  },
  "G60": {
   "cells": 8,
   "mm": 1269,
   "n": 140,
   "periods": {
    "1961-1990": 1156,
    "1981-2010": 1253,
    "1991-2020": 1269
   },
   "seasons": {
    "djf": 405,
    "jja": 256,
    "mam": 236,
    "son": 373
   },
   "summer_half": 492,
   "winter_half": 778
  },
  "G61": {
   "cells": 21,
   "mm": 1297,
   "n": 789,
   "periods": {
    "1961-1990": 1197,
    "1981-2010": 1307,
    "1991-2020": 1297
   },
   "seasons": {
    "djf": 398,
    "jja": 281,
    "mam": 244,
    "son": 374
   },
   "summer_half": 525,
   "winter_half": 772
  },
  "G62": {
   "cells": 28,
   "mm": 1440,
   "n": 456,
   "periods": {
    "1961-1990": 1311,
    "1981-2010": 1427,
    "1991-2020": 1440
   },
   "seasons": {
    "djf": 445,
    "jja": 307,
    "mam": 273,
    "son": 415
   },
   "summer_half": 579,
   "winter_half": 861
  },
  "G63": {
   "cells": 108,
   "mm": 1570,
   "n": 403,
   "periods": {
    "1961-1990": 1410,
    "1981-2010": 1544,
    "1991-2020": 1570
   },
   "seasons": {
    "djf": 511,
    "jja": 314,
    "mam": 302,
    "son": 443
   },
   "summer_half": 616,
   "winter_half": 954
  },
  "G64": {
   "cells": 32,
   "mm": 1278,
   "n": 770,
   "periods": {
    "1961-1990": 1185,
    "1981-2010": 1290,
    "1991-2020": 1278
   },
   "seasons": {
    "djf": 389,
    "jja": 279,
    "mam": 243,
    "son": 367
   },
   "summer_half": 522,
   "winter_half": 756
  },
  "G65": {
   "cells": 28,
   "mm": 1433,
   "n": 402,
   "periods": {
    "1961-1990": 1329,
    "1981-2010": 1435,
    "1991-2020": 1433
   },
   "seasons": {
    "djf": 436,
    "jja": 322,
    "mam": 270,
    "son": 405
   },
   "summer_half": 592,
   "winter_half": 841
  },
  "G66": {
   "cells": 55,
   "mm": 1345,
   "n": 1267,
   "periods": {
    "1961-1990": 1253,
    "1981-2010": 1357,
    "1991-2020": 1345
   },
   "seasons": {
    "djf": 404,
    "jja": 300,
    "mam": 259,
    "son": 382
   },
   "summer_half": 559,
   "winter_half": 786
  },
  "G67": {
   "cells": 33,
   "mm": 1298,
   "n": 617,
   "periods": {
    "1961-1990": 1188,
    "1981-2010": 1291,
    "1991-2020": 1298
   },
   "seasons": {
    "djf": 385,
    "jja": 304,
    "mam": 245,
    "son": 365
   },
   "summer_half": 549,
   "winter_half": 749
  },
  "G68": {
   "cells": 27,
   "mm": 1354,
   "n": 328,
   "periods": {
    "1961-1990": 1244,
    "1981-2010": 1349,
    "1991-2020": 1354
   },
   "seasons": {
    "djf": 407,
    "jja": 311,
    "mam": 255,
    "son": 381
   },
   "summer_half": 566,
   "winter_half": 788
  },
  "G69": {
   "cells": 40,
   "mm": 1107,
   "n": 992,
   "periods": {
    "1961-1990": 1015,
    "1981-2010": 1094,
    "1991-2020": 1107
   },
   "seasons": {
    "djf": 333,
    "jja": 258,
    "mam": 207,
    "son": 309
   },
   "summer_half": 465,
   "winter_half": 642
  },
  "G70": {
   "cells": 1,
   "mm": 1349,
   "n": 6,
   "periods": {
    "1961-1990": 1238,
    "1981-2010": 1338,
    "1991-2020": 1349
   },
   "seasons": {
    "djf": 395,
    "jja": 320,
    "mam": 255,
    "son": 378
   },
   "summer_half": 576,
   "winter_half": 773
  },
  "G71": {
   "cells": 27,
   "mm": 982,
   "n": 912,
   "periods": {
    "1961-1990": 880,
    "1981-2010": 959,
    "1991-2020": 982
   },
   "seasons": {
    "djf": 297,
    "jja": 228,
    "mam": 184,
    "son": 274
   },
   "summer_half": 412,
   "winter_half": 570
  },
  "G72": {
   "cells": 45,
   "mm": 1071,
   "n": 1282,
   "periods": {
    "1961-1990": 969,
    "1981-2010": 1052,
    "1991-2020": 1071
   },
   "seasons": {
    "djf": 331,
    "jja": 238,
    "mam": 200,
    "son": 303
   },
   "summer_half": 437,
   "winter_half": 634
  },
  "G73": {
   "cells": 18,
   "mm": 1085,
   "n": 885,
   "periods": {
    "1961-1990": 989,
    "1981-2010": 1068,
    "1991-2020": 1085
   },
   "seasons": {
    "djf": 335,
    "jja": 237,
    "mam": 205,
    "son": 308
   },
   "summer_half": 442,
   "winter_half": 643
  },
  "G74": {
   "cells": 30,
   "mm": 1257,
   "n": 936,
   "periods": {
    "1961-1990": 1159,
    "1981-2010": 1242,
    "1991-2020": 1257
   },
   "seasons": {
    "djf": 397,
    "jja": 263,
    "mam": 239,
    "son": 358
   },
   "summer_half": 502,
   "winter_half": 755
  },
  "G75": {
   "cells": 33,
   "mm": 1374,
   "n": 881,
   "periods": {
    "1961-1990": 1258,
    "1981-2010": 1359,
    "1991-2020": 1374
   },
   "seasons": {
    "djf": 443,
    "jja": 282,
    "mam": 258,
    "son": 391
   },
   "summer_half": 540,
   "winter_half": 834
  },
  "G76": {
   "cells": 49,
   "mm": 1432,
   "n": 624,
   "periods": {
    "1961-1990": 1305,
    "1981-2010": 1404,
    "1991-2020": 1432
   },
   "seasons": {
    "djf": 453,
    "jja": 295,
    "mam": 272,
    "son": 412
   },
   "summer_half": 567,
   "winter_half": 865
  },
  "G77": {
   "cells": 42,
   "mm": 1530,
   "n": 696,
   "periods": {
    "1961-1990": 1386,
    "1981-2010": 1495,
    "1991-2020": 1530
   },
   "seasons": {
    "djf": 484,
    "jja": 313,
    "mam": 290,
    "son": 442
   },
   "summer_half": 603,
   "winter_half": 926
  },
  "G78": {
   "cells": 51,
   "mm": 1581,
   "n": 709,
   "periods": {
    "1961-1990": 1456,
    "1981-2010": 1551,
    "1991-2020": 1581
   },
   "seasons": {
    "djf": 503,
    "jja": 321,
    "mam": 303,
    "son": 453
   },
   "summer_half": 624,
   "winter_half": 957
  },
  "G79": {
   "cells": 1,
   "mm": 1261,
   "n": 2,
   "periods": {
    "1961-1990": 1164,
    "1981-2010": 1246,
    "1991-2020": 1261
   },
   "seasons": {
    "djf": 392,
    "jja": 261,
    "mam": 247,
    "son": 361
   },
   "summer_half": 507,
   "winter_half": 754
  },
  "G81": {
   "cells": 25,
   "mm": 1268,
   "n": 989,
   "periods": {
    "1961-1990": 1152,
    "1981-2010": 1259,
    "1991-2020": 1268
   },
   "seasons": {
    "djf": 394,
    "jja": 270,
    "mam": 237,
    "son": 367
   },
   "summer_half": 507,
   "winter_half": 761
  },
  "G82": {
   "cells": 37,
   "mm": 1524,
   "n": 810,
   "periods": {
    "1961-1990": 1409,
    "1981-2010": 1513,
    "1991-2020": 1524
   },
   "seasons": {
    "djf": 497,
    "jja": 303,
    "mam": 280,
    "son": 445
   },
   "summer_half": 582,
   "winter_half": 942
  },
  "G83": {
   "cells": 65,
   "mm": 1955,
   "n": 626,
   "periods": {
    "1961-1990": 1806,
    "1981-2010": 1934,
    "1991-2020": 1955
   },
   "seasons": {
    "djf": 647,
    "jja": 368,
    "mam": 367,
    "son": 573
   },
   "summer_half": 736,
   "winter_half": 1220
  },
  "G84": {
   "cells": 44,
   "mm": 1804,
   "n": 872,
   "periods": {
    "1961-1990": 1656,
    "1981-2010": 1791,
    "1991-2020": 1804
   },
   "seasons": {
    "djf": 591,
    "jja": 345,
    "mam": 343,
    "son": 525
   },
   "summer_half": 688,
   "winter_half": 1116
  },
  "G90": {
   "cells": 2,
   "mm": 1094,
   "n": 32,
   "periods": {
    "1961-1990": 1006,
    "1981-2010": 1082,
    "1991-2020": 1094
   },
   "seasons": {
    "djf": 330,
    "jja": 245,
    "mam": 207,
    "son": 312
   },
   "summer_half": 452,
   "winter_half": 641
  },
  "GL1": {
   "cells": 15,
   "mm": 719,
   "n": 1036,
   "periods": {
    "1961-1990": 630,
    "1981-2010": 672,
    "1991-2020": 719
   },
   "seasons": {
    "djf": 185,
    "jja": 184,
    "mam": 148,
    "son": 203
   },
   "summer_half": 331,
   "winter_half": 388
  },
  "GL10": {
   "cells": 49,
   "mm": 805,
   "n": 506,
   "periods": {
    "1961-1990": 724,
    "1981-2010": 774,
    "1991-2020": 805
   },
   "seasons": {
    "djf": 218,
    "jja": 189,
    "mam": 170,
    "son": 229
   },
   "summer_half": 358,
   "winter_half": 447
  },
  "GL11": {
   "cells": 55,
   "mm": 865,
   "n": 623,
   "periods": {
    "1961-1990": 804,
    "1981-2010": 848,
    "1991-2020": 865
   },
   "seasons": {
    "djf": 241,
    "jja": 201,
    "mam": 175,
    "son": 248
   },
   "summer_half": 376,
   "winter_half": 489
  },
  "GL12": {
   "cells": 83,
   "mm": 873,
   "n": 469,
   "periods": {
    "1961-1990": 812,
    "1981-2010": 856,
    "1991-2020": 873
   },
   "seasons": {
    "djf": 243,
    "jja": 203,
    "mam": 178,
    "son": 249
   },
   "summer_half": 381,
   "winter_half": 493
  },
  "GL13": {
   "cells": 48,
   "mm": 792,
   "n": 243,
   "periods": {
    "1961-1990": 733,
    "1981-2010": 779,
    "1991-2020": 792
   },
   "seasons": {
    "djf": 220,
    "jja": 189,
    "mam": 158,
    "son": 226
   },
   "summer_half": 347,
   "winter_half": 446
  },
  "GL14": {
   "cells": 64,
   "mm": 888,
   "n": 668,
   "periods": {
    "1961-1990": 815,
    "1981-2010": 854,
    "1991-2020": 888
   },
   "seasons": {
    "djf": 260,
    "jja": 191,
    "mam": 185,
    "son": 252
   },
   "summer_half": 376,
   "winter_half": 512
  },
  "GL15": {
   "cells": 97,
   "mm": 979,
   "n": 811,
   "periods": {
    "1961-1990": 885,
    "1981-2010": 951,
    "1991-2020": 979
   },
   "seasons": {
    "djf": 292,
    "jja": 204,
    "mam": 203,
    "son": 281
   },
   "summer_half": 406,
   "winter_half": 573
  },
  "GL16": {
   "cells": 46,
   "mm": 1025,
   "n": 498,
   "periods": {
    "1961-1990": 915,
    "1981-2010": 990,
    "1991-2020": 1025
   },
   "seasons": {
    "djf": 299,
    "jja": 214,
    "mam": 219,
    "son": 292
   },
   "summer_half": 434,
   "winter_half": 592
  },
  "GL17": {
   "cells": 58,
   "mm": 905,
   "n": 528,
   "periods": {
    "1961-1990": 825,
    "1981-2010": 868,
    "1991-2020": 905
   },
   "seasons": {
    "djf": 263,
    "jja": 195,
    "mam": 188,
    "son": 259
   },
   "summer_half": 383,
   "winter_half": 522
  },
  "GL18": {
   "cells": 75,
   "mm": 740,
   "n": 329,
   "periods": {
    "1961-1990": 676,
    "1981-2010": 707,
    "1991-2020": 740
   },
   "seasons": {
    "djf": 202,
    "jja": 169,
    "mam": 155,
    "son": 215
   },
   "summer_half": 324,
   "winter_half": 417
  },
  "GL19": {
   "cells": 121,
   "mm": 721,
   "n": 390,
   "periods": {
    "1961-1990": 647,
    "1981-2010": 681,
    "1991-2020": 721
   },
   "seasons": {
    "djf": 190,
    "jja": 175,
    "mam": 153,
    "son": 203
   },
   "summer_half": 327,
   "winter_half": 393
  },
  "GL2": {
   "cells": 145,
   "mm": 735,
   "n": 1499,
   "periods": {
    "1961-1990": 655,
    "1981-2010": 694,
    "1991-2020": 735
   },
   "seasons": {
    "djf": 195,
    "jja": 177,
    "mam": 155,
    "son": 208
   },
   "summer_half": 331,
   "winter_half": 403
  },
  "GL20": {
   "cells": 96,
   "mm": 683,
   "n": 998,
   "periods": {
    "1961-1990": 620,
    "1981-2010": 654,
    "1991-2020": 683
   },
   "seasons": {
    "djf": 172,
    "jja": 175,
    "mam": 148,
    "son": 187
   },
   "summer_half": 324,
   "winter_half": 359
  },
  "GL3": {
   "cells": 36,
   "mm": 768,
   "n": 1065,
   "periods": {
    "1961-1990": 694,
    "1981-2010": 737,
    "1991-2020": 768
   },
   "seasons": {
    "djf": 200,
    "jja": 193,
    "mam": 162,
    "son": 212
   },
   "summer_half": 356,
   "winter_half": 412
  },
  "GL4": {
   "cells": 58,
   "mm": 833,
   "n": 1163,
   "periods": {
    "1961-1990": 747,
    "1981-2010": 797,
    "1991-2020": 833
   },
   "seasons": {
    "djf": 216,
    "jja": 202,
    "mam": 173,
    "son": 242
   },
   "summer_half": 375,
   "winter_half": 458
  },
  "GL5": {
   "cells": 37,
   "mm": 882,
   "n": 1103,
   "periods": {
    "1961-1990": 798,
    "1981-2010": 853,
    "1991-2020": 882
   },
   "seasons": {
    "djf": 247,
    "jja": 200,
    "mam": 184,
    "son": 250
   },
   "summer_half": 384,
   "winter_half": 498
  },
  "GL50": {
   "cells": 14,
   "mm": 754,
   "n": 929,
   "periods": {
    "1961-1990": 667,
    "1981-2010": 735,
    "1991-2020": 754
   },
   "seasons": {
    "djf": 192,
    "jja": 190,
    "mam": 163,
    "son": 208
   },
   "summer_half": 354,
   "winter_half": 400
  },
  "GL51": {
   "cells": 48,
   "mm": 731,
   "n": 1566,
   "periods": {
    "1961-1990": 649,
    "1981-2010": 707,
    "1991-2020": 731
   },
   "seasons": {
    "djf": 186,
    "jja": 187,
    "mam": 156,
    "son": 201
   },
   "summer_half": 343,
   "winter_half": 388
  },
  "GL52": {
   "cells": 48,
   "mm": 749,
   "n": 1381,
   "periods": {
    "1961-1990": 679,
    "1981-2010": 723,
    "1991-2020": 749
   },
   "seasons": {
    "djf": 189,
    "jja": 187,
    "mam": 162,
    "son": 210
   },
   "summer_half": 349,
   "winter_half": 399
  },
  "GL53": {
   "cells": 46,
   "mm": 918,
   "n": 749,
   "periods": {
    "1961-1990": 817,
    "1981-2010": 884,
    "1991-2020": 918
   },
   "seasons": {
    "djf": 244,
    "jja": 213,
    "mam": 195,
    "son": 265
   },
   "summer_half": 408,
   "winter_half": 509
  },
  "GL54": {
   "cells": 272,
   "mm": 874,
   "n": 1067,
   "periods": {
    "1961-1990": 807,
    "1981-2010": 845,
    "1991-2020": 874
   },
   "seasons": {
    "djf": 238,
    "jja": 196,
    "mam": 189,
    "son": 251
   },
   "summer_half": 385,
   "winter_half": 489
  },
  "GL55": {
   "cells": 48,
   "mm": 703,
   "n": 292,
   "periods": {
    "1961-1990": 678,
    "1981-2010": 695,
    "1991-2020": 703
   },
   "seasons": {
    "djf": 175,
    "jja": 180,
    "mam": 159,
    "son": 190
   },
   "summer_half": 339,
   "winter_half": 365
  },
  "GL56": {
   "cells": 102,
   "mm": 760,
   "n": 530,
   "periods": {
    "1961-1990": 714,
    "1981-2010": 738,
    "1991-2020": 760
   },
   "seasons": {
    "djf": 200,
    "jja": 182,
    "mam": 166,
    "son": 213
   },
   "summer_half": 347,
   "winter_half": 413
  },
  "GL6": {
   "cells": 114,
   "mm": 921,
   "n": 1045,
   "periods": {
    "1961-1990": 834,
    "1981-2010": 890,
    "1991-2020": 921
   },
   "seasons": {
    "djf": 253,
    "jja": 214,
    "mam": 190,
    "son": 264
   },
   "summer_half": 404,
   "winter_half": 517
  },
  "GL7": {
   "cells": 285,
   "mm": 799,
   "n": 1688,
   "periods": {
    "1961-1990": 751,
    "1981-2010": 779,
    "1991-2020": 799
   },
   "seasons": {
    "djf": 223,
    "jja": 182,
    "mam": 169,
    "son": 225
   },
   "summer_half": 351,
   "winter_half": 448
  },
  "GL8": {
   "cells": 77,
   "mm": 898,
   "n": 338,
   "periods": {
    "1961-1990": 836,
    "1981-2010": 871,
    "1991-2020": 898
   },
   "seasons": {
    "djf": 253,
    "jja": 204,
    "mam": 185,
    "son": 256
   },
   "summer_half": 389,
   "winter_half": 509
  },
  "GL9": {
   "cells": 37,
   "mm": 907,
   "n": 112,
   "periods": {
    "1961-1990": 852,
    "1981-2010": 887,
    "1991-2020": 907
   },
   "seasons": {
    "djf": 257,
    "jja": 207,
    "mam": 187,
    "son": 255
   },
   "summer_half": 394,
   "winter_half": 512
  },
  "GU1": {
   "cells": 21,
   "mm": 752,
   "n": 1044,
   "periods": {
    "1961-1990": 703,
    "1981-2010": 719,
    "1991-2020": 752
   },
   "seasons": {
    "djf": 212,
    "jja": 162,
    "mam": 150,
    "son": 228
   },
   "summer_half": 312,
   "winter_half": 440
  },
  "GU10": {
   "cells": 126,
   "mm": 806,
   "n": 983,
   "periods": {
    "1961-1990": 763,
    "1981-2010": 791,
    "1991-2020": 806
   },
   "seasons": {
    "djf": 238,
    "jja": 163,
    "mam": 158,
    "son": 247
   },
   "summer_half": 321,
   "winter_half": 485
  },
  "GU11": {
   "cells": 23,
   "mm": 766,
   "n": 691,
   "periods": {
    "1961-1990": 726,
    "1981-2010": 754,
    "1991-2020": 766
   },
   "seasons": {
    "djf": 218,
    "jja": 161,
    "mam": 149,
    "son": 237
   },
   "summer_half": 310,
   "winter_half": 455
  },
  "GU12": {
   "cells": 22,
   "mm": 763,
   "n": 795,
   "periods": {
    "1961-1990": 723,
    "1981-2010": 750,
    "1991-2020": 763
   },
   "seasons": {
    "djf": 218,
    "jja": 163,
    "mam": 149,
    "son": 233
   },
   "summer_half": 312,
   "winter_half": 451
  },
  "GU14": {
   "cells": 27,
   "mm": 726,
   "n": 1353,
   "periods": {
    "1961-1990": 685,
    "1981-2010": 707,
    "1991-2020": 726
   },
   "seasons": {
    "djf": 203,
    "jja": 157,
    "mam": 143,
    "son": 223
   },
   "summer_half": 300,
   "winter_half": 426
  },
  "GU15": {
   "cells": 23,
   "mm": 735,
   "n": 890,
   "periods": {
    "1961-1990": 701,
    "1981-2010": 724,
    "1991-2020": 735
   },
   "seasons": {
    "djf": 202,
    "jja": 166,
    "mam": 146,
    "son": 222
   },
   "summer_half": 312,
   "winter_half": 423
  },
  "GU16": {
   "cells": 24,
   "mm": 750,
   "n": 609,
   "periods": {
    "1961-1990": 709,
    "1981-2010": 735,
    "1991-2020": 750
   },
   "seasons": {
    "djf": 209,
    "jja": 166,
    "mam": 147,
    "son": 228
   },
   "summer_half": 313,
   "winter_half": 437
  },
  "GU17": {
   "cells": 17,
   "mm": 713,
   "n": 301,
   "periods": {
    "1961-1990": 679,
    "1981-2010": 701,
    "1991-2020": 713
   },
   "seasons": {
    "djf": 197,
    "jja": 159,
    "mam": 142,
    "son": 215
   },
   "summer_half": 301,
   "winter_half": 411
  },
  "GU18": {
   "cells": 7,
   "mm": 720,
   "n": 145,
   "periods": {
    "1961-1990": 676,
    "1981-2010": 702,
    "1991-2020": 720
   },
   "seasons": {
    "djf": 196,
    "jja": 164,
    "mam": 143,
    "son": 217
   },
   "summer_half": 307,
   "winter_half": 413
  },
  "GU19": {
   "cells": 10,
   "mm": 746,
   "n": 175,
   "periods": {
    "1961-1990": 697,
    "1981-2010": 728,
    "1991-2020": 746
   },
   "seasons": {
    "djf": 203,
    "jja": 170,
    "mam": 148,
    "son": 225
   },
   "summer_half": 318,
   "winter_half": 428
  },
  "GU2": {
   "cells": 17,
   "mm": 757,
   "n": 677,
   "periods": {
    "1961-1990": 714,
    "1981-2010": 730,
    "1991-2020": 757
   },
   "seasons": {
    "djf": 215,
    "jja": 162,
    "mam": 152,
    "son": 227
   },
   "summer_half": 315,
   "winter_half": 442
  },
  "GU20": {
   "cells": 12,
   "mm": 727,
   "n": 159,
   "periods": {
    "1961-1990": 683,
    "1981-2010": 709,
    "1991-2020": 727
   },
   "seasons": {
    "djf": 199,
    "jja": 166,
    "mam": 144,
    "son": 218
   },
   "summer_half": 311,
   "winter_half": 416
  },
  "GU21": {
   "cells": 30,
   "mm": 682,
   "n": 1155,
   "periods": {
    "1961-1990": 650,
    "1981-2010": 667,
    "1991-2020": 682
   },
   "seasons": {
    "djf": 182,
    "jja": 156,
    "mam": 138,
    "son": 207
   },
   "summer_half": 293,
   "winter_half": 389
  },
  "GU22": {
   "cells": 33,
   "mm": 686,
   "n": 945,
   "periods": {
    "1961-1990": 647,
    "1981-2010": 668,
    "1991-2020": 686
   },
   "seasons": {
    "djf": 184,
    "jja": 156,
    "mam": 138,
    "son": 207
   },
   "summer_half": 295,
   "winter_half": 391
  },
  "GU23": {
   "cells": 35,
   "mm": 690,
   "n": 276,
   "periods": {
    "1961-1990": 654,
    "1981-2010": 671,
    "1991-2020": 690
   },
   "seasons": {
    "djf": 188,
    "jja": 157,
    "mam": 138,
    "son": 207
   },
   "summer_half": 295,
   "winter_half": 395
  },
  "GU24": {
   "cells": 51,
   "mm": 693,
   "n": 545,
   "periods": {
    "1961-1990": 662,
    "1981-2010": 678,
    "1991-2020": 693
   },
   "seasons": {
    "djf": 191,
    "jja": 155,
    "mam": 139,
    "son": 208
   },
   "summer_half": 294,
   "winter_half": 399
  },
  "GU25": {
   "cells": 16,
   "mm": 688,
   "n": 221,
   "periods": {
    "1961-1990": 663,
    "1981-2010": 675,
    "1991-2020": 688
   },
   "seasons": {
    "djf": 187,
    "jja": 159,
    "mam": 138,
    "son": 204
   },
   "summer_half": 296,
   "winter_half": 392
  },
  "GU26": {
   "cells": 18,
   "mm": 975,
   "n": 281,
   "periods": {
    "1961-1990": 911,
    "1981-2010": 947,
    "1991-2020": 975
   },
   "seasons": {
    "djf": 298,
    "jja": 192,
    "mam": 184,
    "son": 300
   },
   "summer_half": 376,
   "winter_half": 599
  },
  "GU27": {
   "cells": 59,
   "mm": 954,
   "n": 622,
   "periods": {
    "1961-1990": 877,
    "1981-2010": 918,
    "1991-2020": 954
   },
   "seasons": {
    "djf": 293,
    "jja": 186,
    "mam": 179,
    "son": 295
   },
   "summer_half": 366,
   "winter_half": 588
  },
  "GU28": {
   "cells": 106,
   "mm": 939,
   "n": 354,
   "periods": {
    "1961-1990": 855,
    "1981-2010": 903,
    "1991-2020": 939
   },
   "seasons": {
    "djf": 293,
    "jja": 181,
    "mam": 173,
    "son": 292
   },
   "summer_half": 354,
   "winter_half": 585
  },
  "GU29": {
   "cells": 66,
   "mm": 981,
   "n": 428,
   "periods": {
    "1961-1990": 891,
    "1981-2010": 940,
    "1991-2020": 981
   },
   "seasons": {
    "djf": 306,
    "jja": 189,
    "mam": 180,
    "son": 306
   },
   "summer_half": 369,
   "winter_half": 612
  },
  "GU3": {
   "cells": 61,
   "mm": 746,
   "n": 411,
   "periods": {
    "1961-1990": 707,
    "1981-2010": 725,
    "1991-2020": 746
   },
   "seasons": {
    "djf": 213,
    "jja": 160,
    "mam": 149,
    "son": 223
   },
   "summer_half": 309,
   "winter_half": 436
  },
  "GU30": {
   "cells": 44,
   "mm": 1016,
   "n": 302,
   "periods": {
    "1961-1990": 948,
    "1981-2010": 991,
    "1991-2020": 1016
   },
   "seasons": {
    "djf": 299,
    "jja": 206,
    "mam": 206,
    "son": 305
   },
   "summer_half": 411,
   "winter_half": 605
  },
  "GU31": {
   "cells": 70,
   "mm": 995,
   "n": 433,
   "periods": {
    "1961-1990": 928,
    "1981-2010": 962,
    "1991-2020": 995
   },
   "seasons": {
    "djf": 308,
    "jja": 193,
    "mam": 185,
    "son": 309
   },
   "summer_half": 378,
   "winter_half": 617
  },
  "GU32": {
   "cells": 77,
   "mm": 1037,
   "n": 557,
   "periods": {
    "1961-1990": 961,
    "1981-2010": 1004,
    "1991-2020": 1037
   },
   "seasons": {
    "djf": 315,
    "jja": 207,
    "mam": 198,
    "son": 317
   },
   "summer_half": 405,
   "winter_half": 632
  },
  "GU33": {
   "cells": 48,
   "mm": 995,
   "n": 347,
   "periods": {
    "1961-1990": 921,
    "1981-2010": 972,
    "1991-2020": 995
   },
   "seasons": {
    "djf": 304,
    "jja": 197,
    "mam": 189,
    "son": 305
   },
   "summer_half": 386,
   "winter_half": 609
  },
  "GU34": {
   "cells": 163,
   "mm": 943,
   "n": 1225,
   "periods": {
    "1961-1990": 876,
    "1981-2010": 913,
    "1991-2020": 943
   },
   "seasons": {
    "djf": 284,
    "jja": 190,
    "mam": 184,
    "son": 286
   },
   "summer_half": 374,
   "winter_half": 570
  },
  "GU35": {
   "cells": 49,
   "mm": 900,
   "n": 756,
   "periods": {
    "1961-1990": 849,
    "1981-2010": 882,
    "1991-2020": 900
   },
   "seasons": {
    "djf": 274,
    "jja": 174,
    "mam": 174,
    "son": 278
   },
   "summer_half": 348,
   "winter_half": 551
  },
  "GU4": {
   "cells": 47,
   "mm": 772,
   "n": 493,
   "periods": {
    "1961-1990": 723,
    "1981-2010": 741,
    "1991-2020": 772
   },
   "seasons": {
    "djf": 218,
    "jja": 167,
    "mam": 152,
    "son": 234
   },
   "summer_half": 319,
   "winter_half": 452
  },
  "GU46": {
   "cells": 10,
   "mm": 696,
   "n": 343,
   "periods": {
    "1961-1990": 663,
    "1981-2010": 684,
    "1991-2020": 696
   },
   "seasons": {
    "djf": 192,
    "jja": 156,
    "mam": 141,
    "son": 207
   },
   "summer_half": 297,
   "winter_half": 399
  },
  "GU47": {
   "cells": 12,
   "mm": 670,
   "n": 412,
   "periods": {
    "1961-1990": 640,
    "1981-2010": 663,
    "1991-2020": 670
   },
   "seasons": {
    "djf": 187,
    "jja": 148,
    "mam": 138,
    "son": 197
   },
   "summer_half": 286,
   "winter_half": 384
  },
  "GU5": {
   "cells": 61,
   "mm": 840,
   "n": 394,
   "periods": {
    "1961-1990": 792,
    "1981-2010": 815,
    "1991-2020": 840
   },
   "seasons": {
    "djf": 247,
    "jja": 175,
    "mam": 164,
    "son": 254
   },
   "summer_half": 339,
   "winter_half": 501
  },
  "GU51": {
   "cells": 23,
   "mm": 728,
   "n": 824,
   "periods": {
    "1961-1990": 688,
    "1981-2010": 710,
    "1991-2020": 728
   },
   "seasons": {
    "djf": 205,
    "jja": 157,
    "mam": 145,
    "son": 221
   },
   "summer_half": 302,
   "winter_half": 426
  },
  "GU52": {
   "cells": 14,
   "mm": 751,
   "n": 444,
   "periods": {
    "1961-1990": 711,
    "1981-2010": 735,
    "1991-2020": 751
   },
   "seasons": {
    "djf": 217,
    "jja": 157,
    "mam": 149,
    "son": 227
   },
   "summer_half": 307,
   "winter_half": 444
  },
  "GU6": {
   "cells": 57,
   "mm": 859,
   "n": 571,
   "periods": {
    "1961-1990": 813,
    "1981-2010": 839,
    "1991-2020": 859
   },
   "seasons": {
    "djf": 256,
    "jja": 174,
    "mam": 166,
    "son": 264
   },
   "summer_half": 339,
   "winter_half": 520
  },
  "GU7": {
   "cells": 24,
   "mm": 788,
   "n": 791,
   "periods": {
    "1961-1990": 744,
    "1981-2010": 765,
    "1991-2020": 788
   },
   "seasons": {
    "djf": 231,
    "jja": 163,
    "mam": 155,
    "son": 239
   },
   "summer_half": 318,
   "winter_half": 470
  },
  "GU8": {
   "cells": 118,
   "mm": 845,
   "n": 666,
   "periods": {
    "1961-1990": 794,
    "1981-2010": 820,
    "1991-2020": 845
   },
   "seasons": {
    "djf": 257,
    "jja": 168,
    "mam": 164,
    "son": 255
   },
   "summer_half": 332,
   "winter_half": 513
  },
  "GU9": {
   "cells": 25,
   "mm": 784,
   "n": 990,
   "periods": {
    "1961-1990": 750,
    "1981-2010": 777,
    "1991-2020": 784
   },
   "seasons": {
    "djf": 225,
    "jja": 164,
    "mam": 155,
    "son": 241
   },
   "summer_half": 319,
   "winter_half": 466
  },
  "HA0": {
   "cells": 17,
   "mm": 671,
   "n": 856,
   "periods": {
    "1961-1990": 652,
    "1981-2010": 662,
    "1991-2020": 671
   },
   "seasons": {
    "djf": 177,
    "jja": 160,
    "mam": 135,
    "son": 198
   },
   "summer_half": 295,
   "winter_half": 375
  },
  "HA1": {
   "cells": 14,
   "mm": 681,
   "n": 964,
   "periods": {
    "1961-1990": 665,
    "1981-2010": 673,
    "1991-2020": 681
   },
   "seasons": {
    "djf": 182,
    "jja": 161,
    "mam": 140,
    "son": 198
   },
   "summer_half": 302,
   "winter_half": 380
  },
  "HA2": {
   "cells": 19,
   "mm": 678,
   "n": 966,
   "periods": {
    "1961-1990": 659,
    "1981-2010": 667,
    "1991-2020": 678
   },
   "seasons": {
    "djf": 182,
    "jja": 159,
    "mam": 139,
    "son": 198
   },
   "summer_half": 298,
   "winter_half": 380
  },
  "HA3": {
   "cells": 23,
   "mm": 674,
   "n": 1263,
   "periods": {
    "1961-1990": 665,
    "1981-2010": 670,
    "1991-2020": 674
   },
   "seasons": {
    "djf": 183,
    "jja": 158,
    "mam": 137,
    "son": 196
   },
   "summer_half": 295,
   "winter_half": 379
  },
  "HA4": {
   "cells": 21,
   "mm": 669,
   "n": 1138,
   "periods": {
    "1961-1990": 638,
    "1981-2010": 650,
    "1991-2020": 669
   },
   "seasons": {
    "djf": 176,
    "jja": 158,
    "mam": 138,
    "son": 196
   },
   "summer_half": 296,
   "winter_half": 373
  },
  "HA5": {
   "cells": 20,
   "mm": 680,
   "n": 1093,
   "periods": {
    "1961-1990": 668,
    "1981-2010": 672,
    "1991-2020": 680
   },
   "seasons": {
    "djf": 184,
    "jja": 157,
    "mam": 139,
    "son": 200
   },
   "summer_half": 296,
   "winter_half": 384
  },
  "HA6": {
   "cells": 17,
   "mm": 680,
   "n": 721,
   "periods": {
    "1961-1990": 672,
    "1981-2010": 675,
    "1991-2020": 680
   },
   "seasons": {
    "djf": 181,
    "jja": 158,
    "mam": 137,
    "son": 203
   },
   "summer_half": 296,
   "winter_half": 384
  },
  "HA7": {
   "cells": 21,
   "mm": 699,
   "n": 850,
   "periods": {
    "1961-1990": 689,
    "1981-2010": 693,
    "1991-2020": 699
   },
   "seasons": {
    "djf": 191,
    "jja": 162,
    "mam": 140,
    "son": 205
   },
   "summer_half": 302,
   "winter_half": 396
  },
  "HA8": {
   "cells": 21,
   "mm": 687,
   "n": 1404,
   "periods": {
    "1961-1990": 678,
    "1981-2010": 683,
    "1991-2020": 687
   },
   "seasons": {
    "djf": 187,
    "jja": 164,
    "mam": 136,
    "son": 200
   },
   "summer_half": 300,
   "winter_half": 387
  },
  "HA9": {
   "cells": 15,
   "mm": 669,
   "n": 1012,
   "periods": {
    "1961-1990": 652,
    "1981-2010": 666,
    "1991-2020": 669
   },
   "seasons": {
    "djf": 177,
    "jja": 162,
    "mam": 132,
    "son": 198
   },
   "summer_half": 294,
   "winter_half": 375
  },
  "HD1": {
   "cells": 13,
   "mm": 909,
   "n": 841,
   "periods": {
    "1961-1990": 907,
    "1981-2010": 903,
    "1991-2020": 909
   },
   "seasons": {
    "djf": 270,
    "jja": 208,
    "mam": 185,
    "son": 247
   },
   "summer_half": 392,
   "winter_half": 517
  },
  "HD2": {
   "cells": 23,
   "mm": 920,
   "n": 633,
   "periods": {
    "1961-1990": 908,
    "1981-2010": 909,
    "1991-2020": 920
   },
   "seasons": {
    "djf": 265,
    "jja": 217,
    "mam": 185,
    "son": 253
   },
   "summer_half": 402,
   "winter_half": 518
  },
  "HD3": {
   "cells": 26,
   "mm": 1108,
   "n": 723,
   "periods": {
    "1961-1990": 1096,
    "1981-2010": 1095,
    "1991-2020": 1108
   },
   "seasons": {
    "djf": 338,
    "jja": 246,
    "mam": 220,
    "son": 305
   },
   "summer_half": 466,
   "winter_half": 642
  },
  "HD4": {
   "cells": 34,
   "mm": 993,
   "n": 733,
   "periods": {
    "1961-1990": 999,
    "1981-2010": 993,
    "1991-2020": 993
   },
   "seasons": {
    "djf": 296,
    "jja": 226,
    "mam": 201,
    "son": 270
   },
   "summer_half": 427,
   "winter_half": 566
  },
  "HD5": {
   "cells": 25,
   "mm": 838,
   "n": 720,
   "periods": {
    "1961-1990": 834,
    "1981-2010": 832,
    "1991-2020": 838
   },
   "seasons": {
    "djf": 234,
    "jja": 204,
    "mam": 172,
    "son": 228
   },
   "summer_half": 376,
   "winter_half": 462
  },
  "HD6": {
   "cells": 25,
   "mm": 883,
   "n": 799,
   "periods": {
    "1961-1990": 865,
    "1981-2010": 870,
    "1991-2020": 883
   },
   "seasons": {
    "djf": 249,
    "jja": 213,
    "mam": 177,
    "son": 245
   },
   "summer_half": 390,
   "winter_half": 493
  },
  "HD7": {
   "cells": 38,
   "mm": 1285,
   "n": 601,
   "periods": {
    "1961-1990": 1248,
    "1981-2010": 1255,
    "1991-2020": 1285
   },
   "seasons": {
    "djf": 396,
    "jja": 284,
    "mam": 253,
    "son": 352
   },
   "summer_half": 537,
   "winter_half": 748
  },
  "HD8": {
   "cells": 77,
   "mm": 894,
   "n": 944,
   "periods": {
    "1961-1990": 872,
    "1981-2010": 889,
    "1991-2020": 894
   },
   "seasons": {
    "djf": 247,
    "jja": 219,
    "mam": 186,
    "son": 242
   },
   "summer_half": 405,
   "winter_half": 489
  },
  "HD9": {
   "cells": 69,
   "mm": 1220,
   "n": 1205,
   "periods": {
    "1961-1990": 1188,
    "1981-2010": 1209,
    "1991-2020": 1220
   },
   "seasons": {
    "djf": 377,
    "jja": 261,
    "mam": 247,
    "son": 335
   },
   "summer_half": 508,
   "winter_half": 712
  },
  "HG1": {
   "cells": 17,
   "mm": 790,
   "n": 940,
   "periods": {
    "1961-1990": 748,
    "1981-2010": 771,
    "1991-2020": 790
   },
   "seasons": {
    "djf": 207,
    "jja": 204,
    "mam": 159,
    "son": 219
   },
   "summer_half": 364,
   "winter_half": 426
  },
  "HG2": {
   "cells": 21,
   "mm": 786,
   "n": 726,
   "periods": {
    "1961-1990": 751,
    "1981-2010": 768,
    "1991-2020": 786
   },
   "seasons": {
    "djf": 205,
    "jja": 203,
    "mam": 160,
    "son": 218
   },
   "summer_half": 363,
   "winter_half": 423
  },
  "HG3": {
   "cells": 267,
   "mm": 930,
   "n": 1205,
   "periods": {
    "1961-1990": 886,
    "1981-2010": 902,
    "1991-2020": 930
   },
   "seasons": {
    "djf": 263,
    "jja": 222,
    "mam": 185,
    "son": 259
   },
   "summer_half": 407,
   "winter_half": 522
  },
  "HG4": {
   "cells": 218,
   "mm": 835,
   "n": 1014,
   "periods": {
    "1961-1990": 791,
    "1981-2010": 812,
    "1991-2020": 835
   },
   "seasons": {
    "djf": 232,
    "jja": 206,
    "mam": 168,
    "son": 229
   },
   "summer_half": 374,
   "winter_half": 461
  },
  "HG5": {
   "cells": 60,
   "mm": 720,
   "n": 632,
   "periods": {
    "1961-1990": 677,
    "1981-2010": 699,
    "1991-2020": 720
   },
   "seasons": {
    "djf": 178,
    "jja": 194,
    "mam": 147,
    "son": 201
   },
   "summer_half": 341,
   "winter_half": 379
  },
  "HP1": {
   "cells": 30,
   "mm": 747,
   "n": 686,
   "periods": {
    "1961-1990": 723,
    "1981-2010": 745,
    "1991-2020": 747
   },
   "seasons": {
    "djf": 205,
    "jja": 174,
    "mam": 154,
    "son": 216
   },
   "summer_half": 327,
   "winter_half": 420
  },
  "HP10": {
   "cells": 40,
   "mm": 766,
   "n": 565,
   "periods": {
    "1961-1990": 749,
    "1981-2010": 755,
    "1991-2020": 766
   },
   "seasons": {
    "djf": 213,
    "jja": 170,
    "mam": 155,
    "son": 228
   },
   "summer_half": 325,
   "winter_half": 441
  },
  "HP11": {
   "cells": 13,
   "mm": 784,
   "n": 492,
   "periods": {
    "1961-1990": 757,
    "1981-2010": 768,
    "1991-2020": 784
   },
   "seasons": {
    "djf": 222,
    "jja": 170,
    "mam": 158,
    "son": 233
   },
   "summer_half": 329,
   "winter_half": 455
  },
  "HP12": {
   "cells": 14,
   "mm": 820,
   "n": 491,
   "periods": {
    "1961-1990": 786,
    "1981-2010": 806,
    "1991-2020": 820
   },
   "seasons": {
    "djf": 228,
    "jja": 181,
    "mam": 168,
    "son": 242
   },
   "summer_half": 349,
   "winter_half": 471
  },
  "HP13": {
   "cells": 18,
   "mm": 788,
   "n": 847,
   "periods": {
    "1961-1990": 759,
    "1981-2010": 775,
    "1991-2020": 788
   },
   "seasons": {
    "djf": 222,
    "jja": 172,
    "mam": 160,
    "son": 234
   },
   "summer_half": 331,
   "winter_half": 456
  },
  "HP14": {
   "cells": 76,
   "mm": 824,
   "n": 541,
   "periods": {
    "1961-1990": 786,
    "1981-2010": 815,
    "1991-2020": 824
   },
   "seasons": {
    "djf": 226,
    "jja": 180,
    "mam": 174,
    "son": 243
   },
   "summer_half": 354,
   "winter_half": 469
  },
  "HP15": {
   "cells": 23,
   "mm": 829,
   "n": 423,
   "periods": {
    "1961-1990": 803,
    "1981-2010": 821,
    "1991-2020": 829
   },
   "seasons": {
    "djf": 235,
    "jja": 180,
    "mam": 170,
    "son": 245
   },
   "summer_half": 350,
   "winter_half": 479
  },
  "HP16": {
   "cells": 48,
   "mm": 813,
   "n": 374,
   "periods": {
    "1961-1990": 780,
    "1981-2010": 805,
    "1991-2020": 813
   },
   "seasons": {
    "djf": 226,
    "jja": 179,
    "mam": 171,
    "son": 237
   },
   "summer_half": 349,
   "winter_half": 463
  },
  "HP17": {
   "cells": 53,
   "mm": 666,
   "n": 372,
   "periods": {
    "1961-1990": 641,
    "1981-2010": 662,
    "1991-2020": 666
   },
   "seasons": {
    "djf": 172,
    "jja": 157,
    "mam": 142,
    "son": 195
   },
   "summer_half": 299,
   "winter_half": 367
  },
  "HP18": {
   "cells": 135,
   "mm": 655,
   "n": 694,
   "periods": {
    "1961-1990": 629,
    "1981-2010": 646,
    "1991-2020": 655
   },
   "seasons": {
    "djf": 165,
    "jja": 159,
    "mam": 142,
    "son": 190
   },
   "summer_half": 301,
   "winter_half": 355
  },
  "HP19": {
   "cells": 12,
   "mm": 623,
   "n": 594,
   "periods": {
    "1961-1990": 614,
    "1981-2010": 627,
    "1991-2020": 623
   },
   "seasons": {
    "djf": 158,
    "jja": 150,
    "mam": 134,
    "son": 182
   },
   "summer_half": 284,
   "winter_half": 340
  },
  "HP2": {
   "cells": 31,
   "mm": 747,
   "n": 988,
   "periods": {
    "1961-1990": 723,
    "1981-2010": 745,
    "1991-2020": 747
   },
   "seasons": {
    "djf": 203,
    "jja": 175,
    "mam": 153,
    "son": 216
   },
   "summer_half": 328,
   "winter_half": 419
  },
  "HP20": {
   "cells": 10,
   "mm": 622,
   "n": 531,
   "periods": {
    "1961-1990": 615,
    "1981-2010": 625,
    "1991-2020": 622
   },
   "seasons": {
    "djf": 158,
    "jja": 149,
    "mam": 134,
    "son": 181
   },
   "summer_half": 283,
   "winter_half": 339
  },
  "HP21": {
   "cells": 13,
   "mm": 620,
   "n": 725,
   "periods": {
    "1961-1990": 613,
    "1981-2010": 622,
    "1991-2020": 620
   },
   "seasons": {
    "djf": 157,
    "jja": 149,
    "mam": 133,
    "son": 181
   },
   "summer_half": 283,
   "winter_half": 338
  },
  "HP22": {
   "cells": 109,
   "mm": 683,
   "n": 968,
   "periods": {
    "1961-1990": 665,
    "1981-2010": 679,
    "1991-2020": 683
   },
   "seasons": {
    "djf": 176,
    "jja": 161,
    "mam": 146,
    "son": 200
   },
   "summer_half": 307,
   "winter_half": 376
  },
  "HP23": {
   "cells": 62,
   "mm": 760,
   "n": 576,
   "periods": {
    "1961-1990": 740,
    "1981-2010": 759,
    "1991-2020": 760
   },
   "seasons": {
    "djf": 202,
    "jja": 172,
    "mam": 159,
    "son": 227
   },
   "summer_half": 331,
   "winter_half": 429
  },
  "HP27": {
   "cells": 46,
   "mm": 740,
   "n": 446,
   "periods": {
    "1961-1990": 701,
    "1981-2010": 731,
    "1991-2020": 740
   },
   "seasons": {
    "djf": 196,
    "jja": 173,
    "mam": 157,
    "son": 214
   },
   "summer_half": 330,
   "winter_half": 410
  },
  "HP3": {
   "cells": 42,
   "mm": 762,
   "n": 763,
   "periods": {
    "1961-1990": 738,
    "1981-2010": 758,
    "1991-2020": 762
   },
   "seasons": {
    "djf": 213,
    "jja": 175,
    "mam": 154,
    "son": 220
   },
   "summer_half": 329,
   "winter_half": 433
  },
  "HP4": {
   "cells": 52,
   "mm": 777,
   "n": 736,
   "periods": {
    "1961-1990": 750,
    "1981-2010": 777,
    "1991-2020": 777
   },
   "seasons": {
    "djf": 211,
    "jja": 182,
    "mam": 161,
    "son": 224
   },
   "summer_half": 342,
   "winter_half": 434
  },
  "HP5": {
   "cells": 55,
   "mm": 792,
   "n": 730,
   "periods": {
    "1961-1990": 758,
    "1981-2010": 786,
    "1991-2020": 792
   },
   "seasons": {
    "djf": 223,
    "jja": 177,
    "mam": 163,
    "son": 229
   },
   "summer_half": 340,
   "winter_half": 452
  },
  "HP6": {
   "cells": 18,
   "mm": 811,
   "n": 431,
   "periods": {
    "1961-1990": 769,
    "1981-2010": 800,
    "1991-2020": 811
   },
   "seasons": {
    "djf": 230,
    "jja": 179,
    "mam": 165,
    "son": 236
   },
   "summer_half": 344,
   "winter_half": 466
  },
  "HP7": {
   "cells": 33,
   "mm": 801,
   "n": 359,
   "periods": {
    "1961-1990": 767,
    "1981-2010": 792,
    "1991-2020": 801
   },
   "seasons": {
    "djf": 226,
    "jja": 176,
    "mam": 164,
    "son": 235
   },
   "summer_half": 339,
   "winter_half": 461
  },
  "HP8": {
   "cells": 23,
   "mm": 759,
   "n": 220,
   "periods": {
    "1961-1990": 737,
    "1981-2010": 752,
    "1991-2020": 759
   },
   "seasons": {
    "djf": 212,
    "jja": 170,
    "mam": 156,
    "son": 222
   },
   "summer_half": 325,
   "winter_half": 434
  },
  "HP9": {
   "cells": 30,
   "mm": 743,
   "n": 554,
   "periods": {
    "1961-1990": 727,
    "1981-2010": 734,
    "1991-2020": 743
   },
   "seasons": {
    "djf": 204,
    "jja": 166,
    "mam": 152,
    "son": 221
   },
   "summer_half": 317,
   "winter_half": 425
  },
  "HR1": {
   "cells": 172,
   "mm": 721,
   "n": 1121,
   "periods": {
    "1961-1990": 666,
    "1981-2010": 695,
    "1991-2020": 721
   },
   "seasons": {
    "djf": 193,
    "jja": 168,
    "mam": 158,
    "son": 202
   },
   "summer_half": 326,
   "winter_half": 395
  },
  "HR2": {
   "cells": 335,
   "mm": 883,
   "n": 1312,
   "periods": {
    "1961-1990": 806,
    "1981-2010": 851,
    "1991-2020": 883
   },
   "seasons": {
    "djf": 257,
    "jja": 185,
    "mam": 188,
    "son": 253
   },
   "summer_half": 373,
   "winter_half": 510
  },
  "HR3": {
   "cells": 162,
   "mm": 881,
   "n": 435,
   "periods": {
    "1961-1990": 821,
    "1981-2010": 851,
    "1991-2020": 881
   },
   "seasons": {
    "djf": 260,
    "jja": 182,
    "mam": 188,
    "son": 250
   },
   "summer_half": 370,
   "winter_half": 511
  },
  "HR4": {
   "cells": 151,
   "mm": 739,
   "n": 946,
   "periods": {
    "1961-1990": 690,
    "1981-2010": 715,
    "1991-2020": 739
   },
   "seasons": {
    "djf": 201,
    "jja": 169,
    "mam": 160,
    "son": 209
   },
   "summer_half": 329,
   "winter_half": 410
  },
  "HR5": {
   "cells": 82,
   "mm": 997,
   "n": 247,
   "periods": {
    "1961-1990": 928,
    "1981-2010": 977,
    "1991-2020": 997
   },
   "seasons": {
    "djf": 297,
    "jja": 209,
    "mam": 207,
    "son": 284
   },
   "summer_half": 416,
   "winter_half": 581
  },
  "HR6": {
   "cells": 213,
   "mm": 777,
   "n": 803,
   "periods": {
    "1961-1990": 737,
    "1981-2010": 765,
    "1991-2020": 777
   },
   "seasons": {
    "djf": 210,
    "jja": 181,
    "mam": 168,
    "son": 219
   },
   "summer_half": 349,
   "winter_half": 429
  },
  "HR7": {
   "cells": 89,
   "mm": 791,
   "n": 280,
   "periods": {
    "1961-1990": 723,
    "1981-2010": 765,
    "1991-2020": 791
   },
   "seasons": {
    "djf": 204,
    "jja": 191,
    "mam": 172,
    "son": 223
   },
   "summer_half": 364,
   "winter_half": 428
  },
  "HR8": {
   "cells": 145,
   "mm": 738,
   "n": 575,
   "periods": {
    "1961-1990": 687,
    "1981-2010": 720,
    "1991-2020": 738
   },
   "seasons": {
    "djf": 190,
    "jja": 177,
    "mam": 161,
    "son": 210
   },
   "summer_half": 338,
   "winter_half": 400
  },
  "HR9": {
   "cells": 160,
   "mm": 801,
   "n": 832,
   "periods": {
    "1961-1990": 724,
    "1981-2010": 772,
    "1991-2020": 801
   },
   "seasons": {
    "djf": 222,
    "jja": 177,
    "mam": 169,
    "son": 233
   },
   "summer_half": 346,
   "winter_half": 455
  },
  "HS1": {
   "cells": 6,
   "mm": 1332,
   "n": 266,
   "periods": {
    "1961-1990": 1236,
    "1981-2010": 1337,
    "1991-2020": 1332
   },
   "seasons": {
    "djf": 433,
    "jja": 242,
    "mam": 265,
    "son": 392
   },
   "summer_half": 507,
   "winter_half": 825
  },
  "HS2": {
   "cells": 187,
   "mm": 1422,
   "n": 364,
   "periods": {
    "1961-1990": 1317,
    "1981-2010": 1421,
    "1991-2020": 1422
   },
   "seasons": {
    "djf": 461,
    "jja": 260,
    "mam": 277,
    "son": 424
   },
   "summer_half": 537,
   "winter_half": 884
  },
  "HS3": {
   "cells": 36,
   "mm": 1821,
   "n": 76,
   "periods": {
    "1961-1990": 1726,
    "1981-2010": 1803,
    "1991-2020": 1821
   },
   "seasons": {
    "djf": 572,
    "jja": 361,
    "mam": 346,
    "son": 542
   },
   "summer_half": 707,
   "winter_half": 1114
  },
  "HS4": {
   "cells": 2,
   "mm": 1520,
   "n": 9,
   "periods": {
    "1961-1990": 1442,
    "1981-2010": 1521,
    "1991-2020": 1520
   },
   "seasons": {
    "djf": 474,
    "jja": 307,
    "mam": 283,
    "son": 456
   },
   "summer_half": 590,
   "winter_half": 930
  },
  "HS5": {
   "cells": 7,
   "mm": 1586,
   "n": 14,
   "periods": {
    "1961-1990": 1525,
    "1981-2010": 1582,
    "1991-2020": 1586
   },
   "seasons": {
    "djf": 476,
    "jja": 313,
    "mam": 296,
    "son": 501
   },
   "summer_half": 609,
   "winter_half": 977
  },
  "HS6": {
   "cells": 49,
   "mm": 1420,
   "n": 80,
   "periods": {
    "1961-1990": 1227,
    "1981-2010": 1319,
    "1991-2020": 1420
   },
   "seasons": {
    "djf": 438,
    "jja": 285,
    "mam": 260,
    "son": 438
   },
   "summer_half": 545,
   "winter_half": 875
  },
  "HS7": {
   "cells": 20,
   "mm": 1370,
   "n": 45,
   "periods": {
    "1961-1990": 1274,
    "1981-2010": 1350,
    "1991-2020": 1370
   },
   "seasons": {
    "djf": 431,
    "jja": 263,
    "mam": 248,
    "son": 427
   },
   "summer_half": 512,
   "winter_half": 858
  },
  "HS8": {
   "cells": 54,
   "mm": 1431,
   "n": 76,
   "periods": {
    "1961-1990": 1372,
    "1981-2010": 1421,
    "1991-2020": 1431
   },
   "seasons": {
    "djf": 462,
    "jja": 279,
    "mam": 266,
    "son": 424
   },
   "summer_half": 545,
   "winter_half": 886
  },
  "HS9": {
   "cells": 23,
   "mm": 1500,
   "n": 50,
   "periods": {
    "1961-1990": 1504,
    "1981-2010": 1470,
    "1991-2020": 1500
   },
   "seasons": {
    "djf": 463,
    "jja": 299,
    "mam": 275,
    "son": 463
   },
   "summer_half": 574,
   "winter_half": 926
  },
  "HU1": {
   "cells": 5,
   "mm": 681,
   "n": 292,
   "periods": {
    "1961-1990": 646,
    "1981-2010": 668,
    "1991-2020": 681
   },
   "seasons": {
    "djf": 158,
    "jja": 194,
    "mam": 139,
    "son": 190
   },
   "summer_half": 333,
   "winter_half": 348
  },
  "HU10": {
   "cells": 19,
   "mm": 701,
   "n": 539,
   "periods": {
    "1961-1990": 668,
    "1981-2010": 690,
    "1991-2020": 701
   },
   "seasons": {
    "djf": 157,
    "jja": 204,
    "mam": 143,
    "son": 197
   },
   "summer_half": 347,
   "winter_half": 354
  },
  "HU11": {
   "cells": 102,
   "mm": 658,
   "n": 419,
   "periods": {
    "1961-1990": 632,
    "1981-2010": 646,
    "1991-2020": 658
   },
   "seasons": {
    "djf": 153,
    "jja": 189,
    "mam": 130,
    "son": 186
   },
   "summer_half": 319,
   "winter_half": 339
  },
  "HU12": {
   "cells": 131,
   "mm": 624,
   "n": 779,
   "periods": {
    "1961-1990": 606,
    "1981-2010": 609,
    "1991-2020": 624
   },
   "seasons": {
    "djf": 148,
    "jja": 179,
    "mam": 122,
    "son": 175
   },
   "summer_half": 301,
   "winter_half": 323
  },
  "HU13": {
   "cells": 10,
   "mm": 677,
   "n": 431,
   "periods": {
    "1961-1990": 648,
    "1981-2010": 667,
    "1991-2020": 677
   },
   "seasons": {
    "djf": 159,
    "jja": 191,
    "mam": 137,
    "son": 190
   },
   "summer_half": 328,
   "winter_half": 349
  },
  "HU14": {
   "cells": 15,
   "mm": 677,
   "n": 241,
   "periods": {
    "1961-1990": 650,
    "1981-2010": 665,
    "1991-2020": 677
   },
   "seasons": {
    "djf": 157,
    "jja": 187,
    "mam": 140,
    "son": 193
   },
   "summer_half": 327,
   "winter_half": 350
  },
  "HU15": {
   "cells": 74,
   "mm": 667,
   "n": 691,
   "periods": {
    "1961-1990": 648,
    "1981-2010": 656,
    "1991-2020": 667
   },
   "seasons": {
    "djf": 158,
    "jja": 188,
    "mam": 134,
    "son": 187
   },
   "summer_half": 322,
   "winter_half": 345
  },
  "HU16": {
   "cells": 29,
   "mm": 700,
   "n": 492,
   "periods": {
    "1961-1990": 672,
    "1981-2010": 687,
    "1991-2020": 700
   },
   "seasons": {
    "djf": 167,
    "jja": 194,
    "mam": 142,
    "son": 197
   },
   "summer_half": 336,
   "winter_half": 364
  },
  "HU17": {
   "cells": 102,
   "mm": 691,
   "n": 1315,
   "periods": {
    "1961-1990": 662,
    "1981-2010": 677,
    "1991-2020": 691
   },
   "seasons": {
    "djf": 164,
    "jja": 196,
    "mam": 137,
    "son": 194
   },
   "summer_half": 333,
   "winter_half": 357
  },
  "HU18": {
   "cells": 15,
   "mm": 668,
   "n": 271,
   "periods": {
    "1961-1990": 641,
    "1981-2010": 660,
    "1991-2020": 668
   },
   "seasons": {
    "djf": 164,
    "jja": 184,
    "mam": 133,
    "son": 186
   },
   "summer_half": 317,
   "winter_half": 350
  },
  "HU19": {
   "cells": 21,
   "mm": 598,
   "n": 199,
   "periods": {
    "1961-1990": 593,
    "1981-2010": 594,
    "1991-2020": 598
   },
   "seasons": {
    "djf": 146,
    "jja": 166,
    "mam": 117,
    "son": 170
   },
   "summer_half": 283,
   "winter_half": 315
  },
  "HU2": {
   "cells": 8,
   "mm": 686,
   "n": 193,
   "periods": {
    "1961-1990": 650,
    "1981-2010": 672,
    "1991-2020": 686
   },
   "seasons": {
    "djf": 160,
    "jja": 194,
    "mam": 140,
    "son": 191
   },
   "summer_half": 334,
   "winter_half": 352
  },
  "HU20": {
   "cells": 10,
   "mm": 751,
   "n": 34,
   "periods": {
    "1961-1990": 726,
    "1981-2010": 739,
    "1991-2020": 751
   },
   "seasons": {
    "djf": 187,
    "jja": 200,
    "mam": 154,
    "son": 210
   },
   "summer_half": 354,
   "winter_half": 397
  },
  "HU3": {
   "cells": 14,
   "mm": 685,
   "n": 754,
   "periods": {
    "1961-1990": 649,
    "1981-2010": 672,
    "1991-2020": 685
   },
   "seasons": {
    "djf": 160,
    "jja": 194,
    "mam": 140,
    "son": 191
   },
   "summer_half": 334,
   "winter_half": 351
  },
  "HU4": {
   "cells": 11,
   "mm": 676,
   "n": 422,
   "periods": {
    "1961-1990": 640,
    "1981-2010": 664,
    "1991-2020": 676
   },
   "seasons": {
    "djf": 156,
    "jja": 193,
    "mam": 137,
    "son": 189
   },
   "summer_half": 331,
   "winter_half": 345
  },
  "HU5": {
   "cells": 18,
   "mm": 686,
   "n": 1046,
   "periods": {
    "1961-1990": 651,
    "1981-2010": 673,
    "1991-2020": 686
   },
   "seasons": {
    "djf": 161,
    "jja": 194,
    "mam": 139,
    "son": 192
   },
   "summer_half": 333,
   "winter_half": 353
  },
  "HU6": {
   "cells": 16,
   "mm": 673,
   "n": 661,
   "periods": {
    "1961-1990": 641,
    "1981-2010": 659,
    "1991-2020": 673
   },
   "seasons": {
    "djf": 160,
    "jja": 187,
    "mam": 134,
    "son": 191
   },
   "summer_half": 321,
   "winter_half": 351
  },
  "HU7": {
   "cells": 23,
   "mm": 659,
   "n": 762,
   "periods": {
    "1961-1990": 629,
    "1981-2010": 645,
    "1991-2020": 659
   },
   "seasons": {
    "djf": 157,
    "jja": 185,
    "mam": 130,
    "son": 188
   },
   "summer_half": 315,
   "winter_half": 345
  },
  "HU8": {
   "cells": 17,
   "mm": 662,
   "n": 749,
   "periods": {
    "1961-1990": 630,
    "1981-2010": 648,
    "1991-2020": 662
   },
   "seasons": {
    "djf": 155,
    "jja": 188,
    "mam": 133,
    "son": 186
   },
   "summer_half": 321,
   "winter_half": 341
  },
  "HU9": {
   "cells": 19,
   "mm": 659,
   "n": 1069,
   "periods": {
    "1961-1990": 626,
    "1981-2010": 645,
    "1991-2020": 659
   },
   "seasons": {
    "djf": 155,
    "jja": 188,
    "mam": 132,
    "son": 185
   },
   "summer_half": 320,
   "winter_half": 339
  },
  "HX1": {
   "cells": 7,
   "mm": 942,
   "n": 904,
   "periods": {
    "1961-1990": 937,
    "1981-2010": 943,
    "1991-2020": 942
   },
   "seasons": {
    "djf": 280,
    "jja": 214,
    "mam": 184,
    "son": 264
   },
   "summer_half": 398,
   "winter_half": 544
  },
  "HX2": {
   "cells": 49,
   "mm": 1108,
   "n": 1126,
   "periods": {
    "1961-1990": 1055,
    "1981-2010": 1086,
    "1991-2020": 1108
   },
   "seasons": {
    "djf": 334,
    "jja": 246,
    "mam": 215,
    "son": 312
   },
   "summer_half": 462,
   "winter_half": 646
  },
  "HX3": {
   "cells": 49,
   "mm": 954,
   "n": 1443,
   "periods": {
    "1961-1990": 930,
    "1981-2010": 942,
    "1991-2020": 954
   },
   "seasons": {
    "djf": 277,
    "jja": 223,
    "mam": 188,
    "son": 266
   },
   "summer_half": 411,
   "winter_half": 543
  },
  "HX4": {
   "cells": 29,
   "mm": 1145,
   "n": 439,
   "periods": {
    "1961-1990": 1132,
    "1981-2010": 1134,
    "1991-2020": 1145
   },
   "seasons": {
    "djf": 349,
    "jja": 251,
    "mam": 227,
    "son": 317
   },
   "summer_half": 478,
   "winter_half": 666
  },
  "HX5": {
   "cells": 11,
   "mm": 952,
   "n": 296,
   "periods": {
    "1961-1990": 934,
    "1981-2010": 941,
    "1991-2020": 952
   },
   "seasons": {
    "djf": 282,
    "jja": 216,
    "mam": 190,
    "son": 264
   },
   "summer_half": 406,
   "winter_half": 546
  },
  "HX6": {
   "cells": 38,
   "mm": 1209,
   "n": 792,
   "periods": {
    "1961-1990": 1161,
    "1981-2010": 1193,
    "1991-2020": 1209
   },
   "seasons": {
    "djf": 371,
    "jja": 268,
    "mam": 235,
    "son": 336
   },
   "summer_half": 502,
   "winter_half": 707
  },
  "HX7": {
   "cells": 51,
   "mm": 1303,
   "n": 709,
   "periods": {
    "1961-1990": 1284,
    "1981-2010": 1299,
    "1991-2020": 1303
   },
   "seasons": {
    "djf": 405,
    "jja": 282,
    "mam": 249,
    "son": 368
   },
   "summer_half": 531,
   "winter_half": 772
  },
  "IG1": {
   "cells": 15,
   "mm": 602,
   "n": 913,
   "periods": {
    "1961-1990": 588,
    "1981-2010": 591,
    "1991-2020": 602
   },
   "seasons": {
    "djf": 155,
    "jja": 148,
    "mam": 121,
    "son": 177
   },
   "summer_half": 269,
   "winter_half": 333
  },
  "IG10": {
   "cells": 23,
   "mm": 660,
   "n": 740,
   "periods": {
    "1961-1990": 634,
    "1981-2010": 647,
    "1991-2020": 660
   },
   "seasons": {
    "djf": 172,
    "jja": 165,
    "mam": 130,
    "son": 193
   },
   "summer_half": 295,
   "winter_half": 365
  },
  "IG11": {
   "cells": 16,
   "mm": 583,
   "n": 1023,
   "periods": {
    "1961-1990": 562,
    "1981-2010": 567,
    "1991-2020": 583
   },
   "seasons": {
    "djf": 152,
    "jja": 143,
    "mam": 118,
    "son": 171
   },
   "summer_half": 261,
   "winter_half": 322
  },
  "IG2": {
   "cells": 11,
   "mm": 616,
   "n": 412,
   "periods": {
    "1961-1990": 597,
    "1981-2010": 601,
    "1991-2020": 616
   },
   "seasons": {
    "djf": 159,
    "jja": 153,
    "mam": 123,
    "son": 182
   },
   "summer_half": 276,
   "winter_half": 340
  },
  "IG3": {
   "cells": 9,
   "mm": 603,
   "n": 488,
   "periods": {
    "1961-1990": 586,
    "1981-2010": 587,
    "1991-2020": 603
   },
   "seasons": {
    "djf": 156,
    "jja": 149,
    "mam": 121,
    "son": 177
   },
   "summer_half": 270,
   "winter_half": 333
  },
  "IG4": {
   "cells": 5,
   "mm": 610,
   "n": 139,
   "periods": {
    "1961-1990": 594,
    "1981-2010": 603,
    "1991-2020": 610
   },
   "seasons": {
    "djf": 157,
    "jja": 151,
    "mam": 122,
    "son": 181
   },
   "summer_half": 273,
   "winter_half": 338
  },
  "IG5": {
   "cells": 9,
   "mm": 622,
   "n": 238,
   "periods": {
    "1961-1990": 600,
    "1981-2010": 612,
    "1991-2020": 622
   },
   "seasons": {
    "djf": 160,
    "jja": 155,
    "mam": 124,
    "son": 183
   },
   "summer_half": 278,
   "winter_half": 343
  },
  "IG6": {
   "cells": 15,
   "mm": 664,
   "n": 568,
   "periods": {
    "1961-1990": 631,
    "1981-2010": 651,
    "1991-2020": 664
   },
   "seasons": {
    "djf": 170,
    "jja": 172,
    "mam": 126,
    "son": 196
   },
   "summer_half": 298,
   "winter_half": 366
  },
  "IG7": {
   "cells": 27,
   "mm": 667,
   "n": 499,
   "periods": {
    "1961-1990": 628,
    "1981-2010": 655,
    "1991-2020": 667
   },
   "seasons": {
    "djf": 171,
    "jja": 171,
    "mam": 129,
    "son": 196
   },
   "summer_half": 300,
   "winter_half": 366
  },
  "IG8": {
   "cells": 19,
   "mm": 649,
   "n": 791,
   "periods": {
    "1961-1990": 624,
    "1981-2010": 639,
    "1991-2020": 649
   },
   "seasons": {
    "djf": 169,
    "jja": 162,
    "mam": 130,
    "son": 190
   },
   "summer_half": 291,
   "winter_half": 358
  },
  "IG9": {
   "cells": 7,
   "mm": 657,
   "n": 292,
   "periods": {
    "1961-1990": 627,
    "1981-2010": 643,
    "1991-2020": 657
   },
   "seasons": {
    "djf": 171,
    "jja": 164,
    "mam": 131,
    "son": 191
   },
   "summer_half": 294,
   "winter_half": 362
  },
  "IP1": {
   "cells": 22,
   "mm": 593,
   "n": 1111,
   "periods": {
    "1961-1990": 565,
    "1981-2010": 588,
    "1991-2020": 593
   },
   "seasons": {
    "djf": 153,
    "jja": 150,
    "mam": 119,
    "son": 171
   },
   "summer_half": 269,
   "winter_half": 323
  },
  "IP10": {
   "cells": 45,
   "mm": 612,
   "n": 191,
   "periods": {
    "1961-1990": 575,
    "1981-2010": 604,
    "1991-2020": 612
   },
   "seasons": {
    "djf": 158,
    "jja": 158,
    "mam": 122,
    "son": 175
   },
   "summer_half": 279,
   "winter_half": 333
  },
  "IP11": {
   "cells": 28,
   "mm": 602,
   "n": 977,
   "periods": {
    "1961-1990": 580,
    "1981-2010": 601,
    "1991-2020": 602
   },
   "seasons": {
    "djf": 155,
    "jja": 158,
    "mam": 124,
    "son": 166
   },
   "summer_half": 282,
   "winter_half": 321
  },
  "IP12": {
   "cells": 158,
   "mm": 616,
   "n": 1058,
   "periods": {
    "1961-1990": 590,
    "1981-2010": 616,
    "1991-2020": 616
   },
   "seasons": {
    "djf": 158,
    "jja": 159,
    "mam": 123,
    "son": 177
   },
   "summer_half": 281,
   "winter_half": 335
  },
  "IP13": {
   "cells": 246,
   "mm": 642,
   "n": 1183,
   "periods": {
    "1961-1990": 604,
    "1981-2010": 641,
    "1991-2020": 642
   },
   "seasons": {
    "djf": 161,
    "jja": 173,
    "mam": 128,
    "son": 180
   },
   "summer_half": 301,
   "winter_half": 341
  },
  "IP14": {
   "cells": 247,
   "mm": 620,
   "n": 1622,
   "periods": {
    "1961-1990": 588,
    "1981-2010": 619,
    "1991-2020": 620
   },
   "seasons": {
    "djf": 153,
    "jja": 167,
    "mam": 126,
    "son": 174
   },
   "summer_half": 293,
   "winter_half": 327
  },
  "IP15": {
   "cells": 7,
   "mm": 611,
   "n": 165,
   "periods": {
    "1961-1990": 579,
    "1981-2010": 605,
    "1991-2020": 611
   },
   "seasons": {
    "djf": 155,
    "jja": 157,
    "mam": 123,
    "son": 175
   },
   "summer_half": 281,
   "winter_half": 330
  },
  "IP16": {
   "cells": 36,
   "mm": 626,
   "n": 322,
   "periods": {
    "1961-1990": 590,
    "1981-2010": 621,
    "1991-2020": 626
   },
   "seasons": {
    "djf": 156,
    "jja": 164,
    "mam": 127,
    "son": 179
   },
   "summer_half": 290,
   "winter_half": 335
  },
  "IP17": {
   "cells": 149,
   "mm": 635,
   "n": 732,
   "periods": {
    "1961-1990": 598,
    "1981-2010": 628,
    "1991-2020": 635
   },
   "seasons": {
    "djf": 158,
    "jja": 166,
    "mam": 129,
    "son": 181
   },
   "summer_half": 295,
   "winter_half": 340
  },
  "IP18": {
   "cells": 17,
   "mm": 613,
   "n": 295,
   "periods": {
    "1961-1990": 574,
    "1981-2010": 612,
    "1991-2020": 613
   },
   "seasons": {
    "djf": 148,
    "jja": 154,
    "mam": 119,
    "son": 193
   },
   "summer_half": 273,
   "winter_half": 340
  },
  "IP19": {
   "cells": 132,
   "mm": 625,
   "n": 599,
   "periods": {
    "1961-1990": 594,
    "1981-2010": 624,
    "1991-2020": 625
   },
   "seasons": {
    "djf": 152,
    "jja": 165,
    "mam": 129,
    "son": 179
   },
   "summer_half": 294,
   "winter_half": 331
  },
  "IP2": {
   "cells": 16,
   "mm": 597,
   "n": 718,
   "periods": {
    "1961-1990": 570,
    "1981-2010": 594,
    "1991-2020": 597
   },
   "seasons": {
    "djf": 154,
    "jja": 153,
    "mam": 119,
    "son": 171
   },
   "summer_half": 272,
   "winter_half": 325
  },
  "IP20": {
   "cells": 73,
   "mm": 634,
   "n": 324,
   "periods": {
    "1961-1990": 597,
    "1981-2010": 638,
    "1991-2020": 634
   },
   "seasons": {
    "djf": 153,
    "jja": 175,
    "mam": 127,
    "son": 180
   },
   "summer_half": 302,
   "winter_half": 332
  },
  "IP21": {
   "cells": 156,
   "mm": 635,
   "n": 530,
   "periods": {
    "1961-1990": 600,
    "1981-2010": 635,
    "1991-2020": 635
   },
   "seasons": {
    "djf": 157,
    "jja": 174,
    "mam": 128,
    "son": 177
   },
   "summer_half": 302,
   "winter_half": 333
  },
  "IP22": {
   "cells": 171,
   "mm": 626,
   "n": 870,
   "periods": {
    "1961-1990": 605,
    "1981-2010": 627,
    "1991-2020": 626
   },
   "seasons": {
    "djf": 154,
    "jja": 171,
    "mam": 128,
    "son": 174
   },
   "summer_half": 299,
   "winter_half": 327
  },
  "IP23": {
   "cells": 89,
   "mm": 612,
   "n": 339,
   "periods": {
    "1961-1990": 583,
    "1981-2010": 612,
    "1991-2020": 612
   },
   "seasons": {
    "djf": 151,
    "jja": 166,
    "mam": 124,
    "son": 170
   },
   "summer_half": 290,
   "winter_half": 321
  },
  "IP24": {
   "cells": 95,
   "mm": 661,
   "n": 792,
   "periods": {
    "1961-1990": 637,
    "1981-2010": 665,
    "1991-2020": 661
   },
   "seasons": {
    "djf": 162,
    "jja": 184,
    "mam": 132,
    "son": 183
   },
   "summer_half": 316,
   "winter_half": 345
  },
  "IP25": {
   "cells": 110,
   "mm": 700,
   "n": 632,
   "periods": {
    "1961-1990": 665,
    "1981-2010": 696,
    "1991-2020": 700
   },
   "seasons": {
    "djf": 175,
    "jja": 186,
    "mam": 140,
    "son": 199
   },
   "summer_half": 326,
   "winter_half": 374
  },
  "IP26": {
   "cells": 90,
   "mm": 648,
   "n": 339,
   "periods": {
    "1961-1990": 622,
    "1981-2010": 641,
    "1991-2020": 648
   },
   "seasons": {
    "djf": 154,
    "jja": 181,
    "mam": 129,
    "son": 184
   },
   "summer_half": 310,
   "winter_half": 338
  },
  "IP27": {
   "cells": 61,
   "mm": 625,
   "n": 515,
   "periods": {
    "1961-1990": 599,
    "1981-2010": 622,
    "1991-2020": 625
   },
   "seasons": {
    "djf": 147,
    "jja": 180,
    "mam": 125,
    "son": 174
   },
   "summer_half": 305,
   "winter_half": 321
  },
  "IP28": {
   "cells": 129,
   "mm": 588,
   "n": 887,
   "periods": {
    "1961-1990": 566,
    "1981-2010": 592,
    "1991-2020": 588
   },
   "seasons": {
    "djf": 140,
    "jja": 168,
    "mam": 119,
    "son": 162
   },
   "summer_half": 287,
   "winter_half": 302
  },
  "IP29": {
   "cells": 129,
   "mm": 643,
   "n": 408,
   "periods": {
    "1961-1990": 611,
    "1981-2010": 643,
    "1991-2020": 643
   },
   "seasons": {
    "djf": 160,
    "jja": 177,
    "mam": 130,
    "son": 177
   },
   "summer_half": 307,
   "winter_half": 336
  },
  "IP3": {
   "cells": 18,
   "mm": 611,
   "n": 764,
   "periods": {
    "1961-1990": 580,
    "1981-2010": 604,
    "1991-2020": 611
   },
   "seasons": {
    "djf": 160,
    "jja": 159,
    "mam": 115,
    "son": 177
   },
   "summer_half": 274,
   "winter_half": 337
  },
  "IP30": {
   "cells": 118,
   "mm": 628,
   "n": 601,
   "periods": {
    "1961-1990": 590,
    "1981-2010": 624,
    "1991-2020": 628
   },
   "seasons": {
    "djf": 155,
    "jja": 173,
    "mam": 127,
    "son": 174
   },
   "summer_half": 300,
   "winter_half": 328
  },
  "IP31": {
   "cells": 145,
   "mm": 618,
   "n": 790,
   "periods": {
    "1961-1990": 598,
    "1981-2010": 617,
    "1991-2020": 618
   },
   "seasons": {
    "djf": 150,
    "jja": 172,
    "mam": 124,
    "son": 172
   },
   "summer_half": 296,
   "winter_half": 322
  },
  "IP32": {
   "cells": 16,
   "mm": 619,
   "n": 457,
   "periods": {
    "1961-1990": 597,
    "1981-2010": 621,
    "1991-2020": 619
   },
   "seasons": {
    "djf": 151,
    "jja": 171,
    "mam": 126,
    "son": 171
   },
   "summer_half": 297,
   "winter_half": 322
  },
  "IP33": {
   "cells": 18,
   "mm": 630,
   "n": 814,
   "periods": {
    "1961-1990": 608,
    "1981-2010": 633,
    "1991-2020": 630
   },
   "seasons": {
    "djf": 154,
    "jja": 175,
    "mam": 127,
    "son": 173
   },
   "summer_half": 302,
   "winter_half": 328
  },
  "IP4": {
   "cells": 19,
   "mm": 605,
   "n": 946,
   "periods": {
    "1961-1990": 572,
    "1981-2010": 597,
    "1991-2020": 605
   },
   "seasons": {
    "djf": 161,
    "jja": 151,
    "mam": 116,
    "son": 177
   },
   "summer_half": 267,
   "winter_half": 337
  },
  "IP5": {
   "cells": 22,
   "mm": 637,
   "n": 457,
   "periods": {
    "1961-1990": 597,
    "1981-2010": 626,
    "1991-2020": 637
   },
   "seasons": {
    "djf": 164,
    "jja": 164,
    "mam": 124,
    "son": 185
   },
   "summer_half": 288,
   "winter_half": 349
  },
  "IP6": {
   "cells": 129,
   "mm": 632,
   "n": 788,
   "periods": {
    "1961-1990": 598,
    "1981-2010": 628,
    "1991-2020": 632
   },
   "seasons": {
    "djf": 160,
    "jja": 166,
    "mam": 128,
    "son": 178
   },
   "summer_half": 294,
   "winter_half": 337
  },
  "IP7": {
   "cells": 133,
   "mm": 609,
   "n": 716,
   "periods": {
    "1961-1990": 576,
    "1981-2010": 606,
    "1991-2020": 609
   },
   "seasons": {
    "djf": 150,
    "jja": 160,
    "mam": 127,
    "son": 172
   },
   "summer_half": 287,
   "winter_half": 322
  },
  "IP8": {
   "cells": 81,
   "mm": 596,
   "n": 482,
   "periods": {
    "1961-1990": 569,
    "1981-2010": 594,
    "1991-2020": 596
   },
   "seasons": {
    "djf": 150,
    "jja": 156,
    "mam": 121,
    "son": 170
   },
   "summer_half": 276,
   "winter_half": 320
  },
  "IP9": {
   "cells": 75,
   "mm": 599,
   "n": 497,
   "periods": {
    "1961-1990": 576,
    "1981-2010": 595,
    "1991-2020": 599
   },
   "seasons": {
    "djf": 154,
    "jja": 154,
    "mam": 118,
    "son": 173
   },
   "summer_half": 272,
   "winter_half": 327
  },
  "IP98": {
   "cells": 1,
   "mm": 615,
   "n": 7,
   "periods": {
    "1961-1990": 594,
    "1981-2010": 618,
    "1991-2020": 615
   },
   "seasons": {
    "djf": 152,
    "jja": 170,
    "mam": 126,
    "son": 167
   },
   "summer_half": 296,
   "winter_half": 319
  },
  "IV1": {
   "cells": 18,
   "mm": 814,
   "n": 286,
   "periods": {
    "1961-1990": 731,
    "1981-2010": 803,
    "1991-2020": 814
   },
   "seasons": {
    "djf": 230,
    "jja": 197,
    "mam": 163,
    "son": 224
   },
   "summer_half": 360,
   "winter_half": 454
  },
  "IV10": {
   "cells": 10,
   "mm": 768,
   "n": 83,
   "periods": {
    "1961-1990": 720,
    "1981-2010": 766,
    "1991-2020": 768
   },
   "seasons": {
    "djf": 209,
    "jja": 191,
    "mam": 154,
    "son": 214
   },
   "summer_half": 345,
   "winter_half": 423
  },
  "IV11": {
   "cells": 6,
   "mm": 767,
   "n": 45,
   "periods": {
    "1961-1990": 711,
    "1981-2010": 754,
    "1991-2020": 767
   },
   "seasons": {
    "djf": 202,
    "jja": 190,
    "mam": 155,
    "son": 220
   },
   "summer_half": 344,
   "winter_half": 423
  },
  "IV12": {
   "cells": 63,
   "mm": 777,
   "n": 438,
   "periods": {
    "1961-1990": 719,
    "1981-2010": 774,
    "1991-2020": 777
   },
   "seasons": {
    "djf": 186,
    "jja": 215,
    "mam": 158,
    "son": 219
   },
   "summer_half": 372,
   "winter_half": 405
  },
  "IV13": {
   "cells": 12,
   "mm": 1049,
   "n": 20,
   "periods": {
    "1961-1990": 950,
    "1981-2010": 1031,
    "1991-2020": 1049
   },
   "seasons": {
    "djf": 307,
    "jja": 236,
    "mam": 219,
    "son": 287
   },
   "summer_half": 455,
   "winter_half": 594
  },
  "IV14": {
   "cells": 17,
   "mm": 1060,
   "n": 75,
   "periods": {
    "1961-1990": 975,
    "1981-2010": 1059,
    "1991-2020": 1060
   },
   "seasons": {
    "djf": 349,
    "jja": 203,
    "mam": 219,
    "son": 289
   },
   "summer_half": 422,
   "winter_half": 638
  },
  "IV15": {
   "cells": 16,
   "mm": 952,
   "n": 220,
   "periods": {
    "1961-1990": 861,
    "1981-2010": 938,
    "1991-2020": 952
   },
   "seasons": {
    "djf": 295,
    "jja": 194,
    "mam": 199,
    "son": 264
   },
   "summer_half": 393,
   "winter_half": 560
  },
  "IV16": {
   "cells": 14,
   "mm": 839,
   "n": 56,
   "periods": {
    "1961-1990": 782,
    "1981-2010": 832,
    "1991-2020": 839
   },
   "seasons": {
    "djf": 255,
    "jja": 170,
    "mam": 173,
    "son": 241
   },
   "summer_half": 344,
   "winter_half": 496
  },
  "IV17": {
   "cells": 24,
   "mm": 886,
   "n": 181,
   "periods": {
    "1961-1990": 823,
    "1981-2010": 870,
    "1991-2020": 886
   },
   "seasons": {
    "djf": 258,
    "jja": 192,
    "mam": 186,
    "son": 250
   },
   "summer_half": 378,
   "winter_half": 507
  },
  "IV18": {
   "cells": 33,
   "mm": 724,
   "n": 199,
   "periods": {
    "1961-1990": 657,
    "1981-2010": 707,
    "1991-2020": 724
   },
   "seasons": {
    "djf": 194,
    "jja": 178,
    "mam": 147,
    "son": 205
   },
   "summer_half": 326,
   "winter_half": 399
  },
  "IV19": {
   "cells": 42,
   "mm": 774,
   "n": 198,
   "periods": {
    "1961-1990": 684,
    "1981-2010": 751,
    "1991-2020": 774
   },
   "seasons": {
    "djf": 217,
    "jja": 186,
    "mam": 157,
    "son": 214
   },
   "summer_half": 343,
   "winter_half": 431
  },
  "IV2": {
   "cells": 134,
   "mm": 867,
   "n": 1264,
   "periods": {
    "1961-1990": 791,
    "1981-2010": 863,
    "1991-2020": 867
   },
   "seasons": {
    "djf": 243,
    "jja": 210,
    "mam": 175,
    "son": 238
   },
   "summer_half": 385,
   "winter_half": 481
  },
  "IV20": {
   "cells": 30,
   "mm": 678,
   "n": 118,
   "periods": {
    "1961-1990": 606,
    "1981-2010": 659,
    "1991-2020": 678
   },
   "seasons": {
    "djf": 170,
    "jja": 184,
    "mam": 135,
    "son": 190
   },
   "summer_half": 318,
   "winter_half": 360
  },
  "IV21": {
   "cells": 25,
   "mm": 1606,
   "n": 49,
   "periods": {
    "1961-1990": 1653,
    "1981-2010": 1695,
    "1991-2020": 1606
   },
   "seasons": {
    "djf": 527,
    "jja": 291,
    "mam": 300,
    "son": 488
   },
   "summer_half": 591,
   "winter_half": 1015
  },
  "IV22": {
   "cells": 50,
   "mm": 1752,
   "n": 78,
   "periods": {
    "1961-1990": 1684,
    "1981-2010": 1769,
    "1991-2020": 1752
   },
   "seasons": {
    "djf": 582,
    "jja": 302,
    "mam": 345,
    "son": 524
   },
   "summer_half": 647,
   "winter_half": 1106
  },
  "IV23": {
   "cells": 38,
   "mm": 1659,
   "n": 50,
   "periods": {
    "1961-1990": 1565,
    "1981-2010": 1675,
    "1991-2020": 1659
   },
   "seasons": {
    "djf": 569,
    "jja": 277,
    "mam": 338,
    "son": 473
   },
   "summer_half": 616,
   "winter_half": 1043
  },
  "IV24": {
   "cells": 19,
   "mm": 1005,
   "n": 45,
   "periods": {
    "1961-1990": 898,
    "1981-2010": 991,
    "1991-2020": 1005
   },
   "seasons": {
    "djf": 305,
    "jja": 202,
    "mam": 211,
    "son": 287
   },
   "summer_half": 413,
   "winter_half": 592
  },
  "IV25": {
   "cells": 36,
   "mm": 864,
   "n": 145,
   "periods": {
    "1961-1990": 771,
    "1981-2010": 842,
    "1991-2020": 864
   },
   "seasons": {
    "djf": 237,
    "jja": 198,
    "mam": 181,
    "son": 248
   },
   "summer_half": 379,
   "winter_half": 485
  },
  "IV26": {
   "cells": 21,
   "mm": 1428,
   "n": 73,
   "periods": {
    "1961-1990": 1384,
    "1981-2010": 1442,
    "1991-2020": 1428
   },
   "seasons": {
    "djf": 456,
    "jja": 267,
    "mam": 280,
    "son": 425
   },
   "summer_half": 547,
   "winter_half": 881
  },
  "IV27": {
   "cells": 104,
   "mm": 1391,
   "n": 191,
   "periods": {
    "1961-1990": 1301,
    "1981-2010": 1390,
    "1991-2020": 1391
   },
   "seasons": {
    "djf": 441,
    "jja": 257,
    "mam": 278,
    "son": 415
   },
   "summer_half": 535,
   "winter_half": 856
  },
  "IV28": {
   "cells": 17,
   "mm": 1080,
   "n": 22,
   "periods": {
    "1961-1990": 988,
    "1981-2010": 1062,
    "1991-2020": 1080
   },
   "seasons": {
    "djf": 322,
    "jja": 217,
    "mam": 223,
    "son": 317
   },
   "summer_half": 440,
   "winter_half": 640
  },
  "IV3": {
   "cells": 31,
   "mm": 850,
   "n": 465,
   "periods": {
    "1961-1990": 755,
    "1981-2010": 835,
    "1991-2020": 850
   },
   "seasons": {
    "djf": 243,
    "jja": 202,
    "mam": 172,
    "son": 234
   },
   "summer_half": 373,
   "winter_half": 476
  },
  "IV30": {
   "cells": 124,
   "mm": 741,
   "n": 1098,
   "periods": {
    "1961-1990": 684,
    "1981-2010": 737,
    "1991-2020": 741
   },
   "seasons": {
    "djf": 161,
    "jja": 219,
    "mam": 142,
    "son": 218
   },
   "summer_half": 361,
   "winter_half": 380
  },
  "IV31": {
   "cells": 11,
   "mm": 671,
   "n": 267,
   "periods": {
    "1961-1990": 622,
    "1981-2010": 668,
    "1991-2020": 671
   },
   "seasons": {
    "djf": 147,
    "jja": 193,
    "mam": 131,
    "son": 200
   },
   "summer_half": 325,
   "winter_half": 347
  },
  "IV32": {
   "cells": 36,
   "mm": 781,
   "n": 173,
   "periods": {
    "1961-1990": 731,
    "1981-2010": 781,
    "1991-2020": 781
   },
   "seasons": {
    "djf": 169,
    "jja": 222,
    "mam": 151,
    "son": 240
   },
   "summer_half": 372,
   "winter_half": 408
  },
  "IV36": {
   "cells": 73,
   "mm": 742,
   "n": 482,
   "periods": {
    "1961-1990": 683,
    "1981-2010": 729,
    "1991-2020": 742
   },
   "seasons": {
    "djf": 165,
    "jja": 214,
    "mam": 148,
    "son": 215
   },
   "summer_half": 362,
   "winter_half": 380
  },
  "IV4": {
   "cells": 54,
   "mm": 1058,
   "n": 130,
   "periods": {
    "1961-1990": 937,
    "1981-2010": 1037,
    "1991-2020": 1058
   },
   "seasons": {
    "djf": 357,
    "jja": 197,
    "mam": 215,
    "son": 289
   },
   "summer_half": 412,
   "winter_half": 646
  },
  "IV40": {
   "cells": 40,
   "mm": 2249,
   "n": 124,
   "periods": {
    "1961-1990": 2041,
    "1981-2010": 2222,
    "1991-2020": 2249
   },
   "seasons": {
    "djf": 752,
    "jja": 382,
    "mam": 444,
    "son": 671
   },
   "summer_half": 827,
   "winter_half": 1423
  },
  "IV41": {
   "cells": 1,
   "mm": 1906,
   "n": 13,
   "periods": {
    "1961-1990": 1711,
    "1981-2010": 1880,
    "1991-2020": 1906
   },
   "seasons": {
    "djf": 623,
    "jja": 347,
    "mam": 377,
    "son": 559
   },
   "summer_half": 724,
   "winter_half": 1182
  },
  "IV42": {
   "cells": 6,
   "mm": 2230,
   "n": 7,
   "periods": {
    "1961-1990": 2066,
    "1981-2010": 2177,
    "1991-2020": 2230
   },
   "seasons": {
    "djf": 733,
    "jja": 381,
    "mam": 436,
    "son": 680
   },
   "summer_half": 817,
   "winter_half": 1413
  },
  "IV43": {
   "cells": 5,
   "mm": 2108,
   "n": 10,
   "periods": {
    "1961-1990": 1995,
    "1981-2010": 2103,
    "1991-2020": 2108
   },
   "seasons": {
    "djf": 648,
    "jja": 399,
    "mam": 409,
    "son": 651
   },
   "summer_half": 809,
   "winter_half": 1300
  },
  "IV44": {
   "cells": 6,
   "mm": 2087,
   "n": 10,
   "periods": {
    "1961-1990": 1975,
    "1981-2010": 2092,
    "1991-2020": 2087
   },
   "seasons": {
    "djf": 647,
    "jja": 397,
    "mam": 404,
    "son": 640
   },
   "summer_half": 801,
   "winter_half": 1286
  },
  "IV45": {
   "cells": 7,
   "mm": 2090,
   "n": 12,
   "periods": {
    "1961-1990": 1943,
    "1981-2010": 2083,
    "1991-2020": 2090
   },
   "seasons": {
    "djf": 651,
    "jja": 399,
    "mam": 402,
    "son": 639
   },
   "summer_half": 801,
   "winter_half": 1289
  },
  "IV46": {
   "cells": 2,
   "mm": 1752,
   "n": 3,
   "periods": {
    "1961-1990": 1644,
    "1981-2010": 1762,
    "1991-2020": 1752
   },
   "seasons": {
    "djf": 590,
    "jja": 326,
    "mam": 346,
    "son": 490
   },
   "summer_half": 672,
   "winter_half": 1080
  },
  "IV47": {
   "cells": 13,
   "mm": 2583,
   "n": 19,
   "periods": {
    "1961-1990": 2325,
    "1981-2010": 2534,
    "1991-2020": 2583
   },
   "seasons": {
    "djf": 832,
    "jja": 488,
    "mam": 485,
    "son": 777
   },
   "summer_half": 974,
   "winter_half": 1609
  },
  "IV48": {
   "cells": 1,
   "mm": 2694,
   "n": 2,
   "periods": {
    "1961-1990": 2313,
    "1981-2010": 2575,
    "1991-2020": 2694
   },
   "seasons": {
    "djf": 921,
    "jja": 407,
    "mam": 517,
    "son": 849
   },
   "summer_half": 924,
   "winter_half": 1770
  },
  "IV49": {
   "cells": 15,
   "mm": 2351,
   "n": 44,
   "periods": {
    "1961-1990": 2196,
    "1981-2010": 2321,
    "1991-2020": 2351
   },
   "seasons": {
    "djf": 769,
    "jja": 406,
    "mam": 455,
    "son": 721
   },
   "summer_half": 861,
   "winter_half": 1490
  },
  "IV5": {
   "cells": 15,
   "mm": 830,
   "n": 42,
   "periods": {
    "1961-1990": 730,
    "1981-2010": 802,
    "1991-2020": 830
   },
   "seasons": {
    "djf": 247,
    "jja": 186,
    "mam": 172,
    "son": 225
   },
   "summer_half": 358,
   "winter_half": 472
  },
  "IV51": {
   "cells": 80,
   "mm": 1836,
   "n": 234,
   "periods": {
    "1961-1990": 1736,
    "1981-2010": 1812,
    "1991-2020": 1836
   },
   "seasons": {
    "djf": 603,
    "jja": 315,
    "mam": 347,
    "son": 571
   },
   "summer_half": 662,
   "winter_half": 1174
  },
  "IV52": {
   "cells": 4,
   "mm": 1649,
   "n": 20,
   "periods": {
    "1961-1990": 1465,
    "1981-2010": 1625,
    "1991-2020": 1649
   },
   "seasons": {
    "djf": 542,
    "jja": 295,
    "mam": 316,
    "son": 496
   },
   "summer_half": 611,
   "winter_half": 1038
  },
  "IV53": {
   "cells": 6,
   "mm": 1905,
   "n": 11,
   "periods": {
    "1961-1990": 1747,
    "1981-2010": 1916,
    "1991-2020": 1905
   },
   "seasons": {
    "djf": 625,
    "jja": 342,
    "mam": 376,
    "son": 563
   },
   "summer_half": 717,
   "winter_half": 1188
  },
  "IV54": {
   "cells": 28,
   "mm": 1968,
   "n": 60,
   "periods": {
    "1961-1990": 1844,
    "1981-2010": 1974,
    "1991-2020": 1968
   },
   "seasons": {
    "djf": 647,
    "jja": 344,
    "mam": 392,
    "son": 586
   },
   "summer_half": 735,
   "winter_half": 1233
  },
  "IV55": {
   "cells": 36,
   "mm": 1879,
   "n": 57,
   "periods": {
    "1961-1990": 1717,
    "1981-2010": 1838,
    "1991-2020": 1879
   },
   "seasons": {
    "djf": 607,
    "jja": 359,
    "mam": 349,
    "son": 564
   },
   "summer_half": 708,
   "winter_half": 1171
  },
  "IV56": {
   "cells": 11,
   "mm": 2178,
   "n": 14,
   "periods": {
    "1961-1990": 2005,
    "1981-2010": 2149,
    "1991-2020": 2178
   },
   "seasons": {
    "djf": 704,
    "jja": 403,
    "mam": 407,
    "son": 663
   },
   "summer_half": 811,
   "winter_half": 1367
  },
  "IV6": {
   "cells": 46,
   "mm": 925,
   "n": 129,
   "periods": {
    "1961-1990": 813,
    "1981-2010": 900,
    "1991-2020": 925
   },
   "seasons": {
    "djf": 290,
    "jja": 194,
    "mam": 189,
    "son": 253
   },
   "summer_half": 383,
   "winter_half": 543
  },
  "IV63": {
   "cells": 31,
   "mm": 1297,
   "n": 69,
   "periods": {
    "1961-1990": 1163,
    "1981-2010": 1291,
    "1991-2020": 1297
   },
   "seasons": {
    "djf": 450,
    "jja": 227,
    "mam": 260,
    "son": 360
   },
   "summer_half": 487,
   "winter_half": 810
  },
  "IV7": {
   "cells": 50,
   "mm": 880,
   "n": 156,
   "periods": {
    "1961-1990": 801,
    "1981-2010": 866,
    "1991-2020": 880
   },
   "seasons": {
    "djf": 249,
    "jja": 204,
    "mam": 178,
    "son": 248
   },
   "summer_half": 382,
   "winter_half": 498
  },
  "IV8": {
   "cells": 12,
   "mm": 843,
   "n": 33,
   "periods": {
    "1961-1990": 780,
    "1981-2010": 831,
    "1991-2020": 843
   },
   "seasons": {
    "djf": 234,
    "jja": 208,
    "mam": 169,
    "son": 231
   },
   "summer_half": 378,
   "winter_half": 465
  },
  "IV9": {
   "cells": 8,
   "mm": 780,
   "n": 47,
   "periods": {
    "1961-1990": 724,
    "1981-2010": 775,
    "1991-2020": 780
   },
   "seasons": {
    "djf": 211,
    "jja": 195,
    "mam": 157,
    "son": 217
   },
   "summer_half": 352,
   "winter_half": 428
  },
  "IV99": {
   "cells": 1,
   "mm": 744,
   "n": 5,
   "periods": {
    "1961-1990": 654,
    "1981-2010": 741,
    "1991-2020": 744
   },
   "seasons": {
    "djf": 207,
    "jja": 183,
    "mam": 149,
    "son": 205
   },
   "summer_half": 332,
   "winter_half": 412
  },
  "KA1": {
   "cells": 69,
   "mm": 1193,
   "n": 1024,
   "periods": {
    "1961-1990": 1096,
    "1981-2010": 1159,
    "1991-2020": 1193
   },
   "seasons": {
    "djf": 344,
    "jja": 275,
    "mam": 212,
    "son": 362
   },
   "summer_half": 487,
   "winter_half": 706
  },
  "KA10": {
   "cells": 17,
   "mm": 1024,
   "n": 433,
   "periods": {
    "1961-1990": 925,
    "1981-2010": 988,
    "1991-2020": 1024
   },
   "seasons": {
    "djf": 302,
    "jja": 238,
    "mam": 182,
    "son": 302
   },
   "summer_half": 420,
   "winter_half": 604
  },
  "KA11": {
   "cells": 39,
   "mm": 1151,
   "n": 541,
   "periods": {
    "1961-1990": 1056,
    "1981-2010": 1119,
    "1991-2020": 1151
   },
   "seasons": {
    "djf": 332,
    "jja": 267,
    "mam": 213,
    "son": 338
   },
   "summer_half": 481,
   "winter_half": 670
  },
  "KA12": {
   "cells": 14,
   "mm": 1121,
   "n": 588,
   "periods": {
    "1961-1990": 1026,
    "1981-2010": 1090,
    "1991-2020": 1121
   },
   "seasons": {
    "djf": 323,
    "jja": 259,
    "mam": 212,
    "son": 327
   },
   "summer_half": 471,
   "winter_half": 649
  },
  "KA13": {
   "cells": 36,
   "mm": 1306,
   "n": 462,
   "periods": {
    "1961-1990": 1220,
    "1981-2010": 1290,
    "1991-2020": 1306
   },
   "seasons": {
    "djf": 381,
    "jja": 292,
    "mam": 246,
    "son": 386
   },
   "summer_half": 539,
   "winter_half": 767
  },
  "KA14": {
   "cells": 5,
   "mm": 1691,
   "n": 37,
   "periods": {
    "1961-1990": 1554,
    "1981-2010": 1654,
    "1991-2020": 1691
   },
   "seasons": {
    "djf": 526,
    "jja": 340,
    "mam": 326,
    "son": 499
   },
   "summer_half": 666,
   "winter_half": 1025
  },
  "KA15": {
   "cells": 37,
   "mm": 1600,
   "n": 245,
   "periods": {
    "1961-1990": 1488,
    "1981-2010": 1586,
    "1991-2020": 1600
   },
   "seasons": {
    "djf": 490,
    "jja": 335,
    "mam": 305,
    "son": 470
   },
   "summer_half": 641,
   "winter_half": 959
  },
  "KA16": {
   "cells": 15,
   "mm": 1381,
   "n": 111,
   "periods": {
    "1961-1990": 1270,
    "1981-2010": 1348,
    "1991-2020": 1381
   },
   "seasons": {
    "djf": 414,
    "jja": 304,
    "mam": 258,
    "son": 406
   },
   "summer_half": 562,
   "winter_half": 819
  },
  "KA17": {
   "cells": 18,
   "mm": 1412,
   "n": 140,
   "periods": {
    "1961-1990": 1297,
    "1981-2010": 1376,
    "1991-2020": 1412
   },
   "seasons": {
    "djf": 430,
    "jja": 312,
    "mam": 266,
    "son": 404
   },
   "summer_half": 578,
   "winter_half": 834
  },
  "KA18": {
   "cells": 111,
   "mm": 1300,
   "n": 738,
   "periods": {
    "1961-1990": 1182,
    "1981-2010": 1265,
    "1991-2020": 1300
   },
   "seasons": {
    "djf": 404,
    "jja": 272,
    "mam": 246,
    "son": 378
   },
   "summer_half": 518,
   "winter_half": 782
  },
  "KA19": {
   "cells": 112,
   "mm": 1287,
   "n": 316,
   "periods": {
    "1961-1990": 1200,
    "1981-2010": 1267,
    "1991-2020": 1287
   },
   "seasons": {
    "djf": 386,
    "jja": 271,
    "mam": 240,
    "son": 391
   },
   "summer_half": 511,
   "winter_half": 777
  },
  "KA2": {
   "cells": 35,
   "mm": 1129,
   "n": 227,
   "periods": {
    "1961-1990": 1036,
    "1981-2010": 1097,
    "1991-2020": 1129
   },
   "seasons": {
    "djf": 324,
    "jja": 264,
    "mam": 201,
    "son": 339
   },
   "summer_half": 466,
   "winter_half": 663
  },
  "KA20": {
   "cells": 14,
   "mm": 1181,
   "n": 265,
   "periods": {
    "1961-1990": 1115,
    "1981-2010": 1175,
    "1991-2020": 1181
   },
   "seasons": {
    "djf": 340,
    "jja": 267,
    "mam": 224,
    "son": 349
   },
   "summer_half": 491,
   "winter_half": 690
  },
  "KA21": {
   "cells": 12,
   "mm": 1281,
   "n": 373,
   "periods": {
    "1961-1990": 1215,
    "1981-2010": 1277,
    "1991-2020": 1281
   },
   "seasons": {
    "djf": 372,
    "jja": 286,
    "mam": 245,
    "son": 378
   },
   "summer_half": 530,
   "winter_half": 751
  },
  "KA22": {
   "cells": 13,
   "mm": 1248,
   "n": 319,
   "periods": {
    "1961-1990": 1176,
    "1981-2010": 1236,
    "1991-2020": 1248
   },
   "seasons": {
    "djf": 362,
    "jja": 276,
    "mam": 240,
    "son": 370
   },
   "summer_half": 516,
   "winter_half": 732
  },
  "KA23": {
   "cells": 20,
   "mm": 1256,
   "n": 190,
   "periods": {
    "1961-1990": 1155,
    "1981-2010": 1232,
    "1991-2020": 1256
   },
   "seasons": {
    "djf": 366,
    "jja": 276,
    "mam": 243,
    "son": 371
   },
   "summer_half": 519,
   "winter_half": 736
  },
  "KA24": {
   "cells": 46,
   "mm": 1579,
   "n": 226,
   "periods": {
    "1961-1990": 1461,
    "1981-2010": 1549,
    "1991-2020": 1579
   },
   "seasons": {
    "djf": 474,
    "jja": 336,
    "mam": 301,
    "son": 468
   },
   "summer_half": 637,
   "winter_half": 942
  },
  "KA25": {
   "cells": 14,
   "mm": 1854,
   "n": 225,
   "periods": {
    "1961-1990": 1692,
    "1981-2010": 1801,
    "1991-2020": 1854
   },
   "seasons": {
    "djf": 579,
    "jja": 370,
    "mam": 359,
    "son": 546
   },
   "summer_half": 729,
   "winter_half": 1125
  },
  "KA26": {
   "cells": 139,
   "mm": 1379,
   "n": 402,
   "periods": {
    "1961-1990": 1272,
    "1981-2010": 1367,
    "1991-2020": 1379
   },
   "seasons": {
    "djf": 409,
    "jja": 284,
    "mam": 262,
    "son": 424
   },
   "summer_half": 546,
   "winter_half": 833
  },
  "KA27": {
   "cells": 66,
   "mm": 1610,
   "n": 205,
   "periods": {
    "1961-1990": 1509,
    "1981-2010": 1566,
    "1991-2020": 1610
   },
   "seasons": {
    "djf": 506,
    "jja": 317,
    "mam": 316,
    "son": 471
   },
   "summer_half": 632,
   "winter_half": 977
  },
  "KA28": {
   "cells": 6,
   "mm": 1291,
   "n": 72,
   "periods": {
    "1961-1990": 1198,
    "1981-2010": 1265,
    "1991-2020": 1291
   },
   "seasons": {
    "djf": 390,
    "jja": 275,
    "mam": 248,
    "son": 377
   },
   "summer_half": 523,
   "winter_half": 768
  },
  "KA29": {
   "cells": 8,
   "mm": 1476,
   "n": 66,
   "periods": {
    "1961-1990": 1360,
    "1981-2010": 1451,
    "1991-2020": 1476
   },
   "seasons": {
    "djf": 443,
    "jja": 316,
    "mam": 289,
    "son": 428
   },
   "summer_half": 605,
   "winter_half": 871
  },
  "KA3": {
   "cells": 128,
   "mm": 1390,
   "n": 1192,
   "periods": {
    "1961-1990": 1293,
    "1981-2010": 1365,
    "1991-2020": 1390
   },
   "seasons": {
    "djf": 410,
    "jja": 314,
    "mam": 261,
    "son": 406
   },
   "summer_half": 575,
   "winter_half": 816
  },
  "KA30": {
   "cells": 13,
   "mm": 1598,
   "n": 361,
   "periods": {
    "1961-1990": 1409,
    "1981-2010": 1540,
    "1991-2020": 1598
   },
   "seasons": {
    "djf": 489,
    "jja": 335,
    "mam": 310,
    "son": 465
   },
   "summer_half": 645,
   "winter_half": 953
  },
  "KA4": {
   "cells": 28,
   "mm": 1361,
   "n": 171,
   "periods": {
    "1961-1990": 1254,
    "1981-2010": 1329,
    "1991-2020": 1361
   },
   "seasons": {
    "djf": 405,
    "jja": 306,
    "mam": 250,
    "son": 400
   },
   "summer_half": 556,
   "winter_half": 804
  },
  "KA5": {
   "cells": 94,
   "mm": 1166,
   "n": 422,
   "periods": {
    "1961-1990": 1080,
    "1981-2010": 1135,
    "1991-2020": 1166
   },
   "seasons": {
    "djf": 338,
    "jja": 271,
    "mam": 211,
    "son": 346
   },
   "summer_half": 482,
   "winter_half": 684
  },
  "KA6": {
   "cells": 122,
   "mm": 1223,
   "n": 529,
   "periods": {
    "1961-1990": 1122,
    "1981-2010": 1191,
    "1991-2020": 1223
   },
   "seasons": {
    "djf": 374,
    "jja": 260,
    "mam": 223,
    "son": 366
   },
   "summer_half": 483,
   "winter_half": 740
  },
  "KA7": {
   "cells": 35,
   "mm": 1073,
   "n": 918,
   "periods": {
    "1961-1990": 1006,
    "1981-2010": 1054,
    "1991-2020": 1073
   },
   "seasons": {
    "djf": 316,
    "jja": 238,
    "mam": 197,
    "son": 323
   },
   "summer_half": 434,
   "winter_half": 639
  },
  "KA8": {
   "cells": 13,
   "mm": 995,
   "n": 537,
   "periods": {
    "1961-1990": 916,
    "1981-2010": 970,
    "1991-2020": 995
   },
   "seasons": {
    "djf": 287,
    "jja": 228,
    "mam": 180,
    "son": 301
   },
   "summer_half": 408,
   "winter_half": 587
  },
  "KA9": {
   "cells": 28,
   "mm": 1012,
   "n": 449,
   "periods": {
    "1961-1990": 925,
    "1981-2010": 986,
    "1991-2020": 1012
   },
   "seasons": {
    "djf": 284,
    "jja": 236,
    "mam": 182,
    "son": 309
   },
   "summer_half": 419,
   "winter_half": 593
  },
  "KT1": {
   "cells": 10,
   "mm": 626,
   "n": 682,
   "periods": {
    "1961-1990": 599,
    "1981-2010": 617,
    "1991-2020": 626
   },
   "seasons": {
    "djf": 164,
    "jja": 149,
    "mam": 125,
    "son": 188
   },
   "summer_half": 274,
   "winter_half": 352
  },
  "KT10": {
   "cells": 24,
   "mm": 654,
   "n": 628,
   "periods": {
    "1961-1990": 621,
    "1981-2010": 639,
    "1991-2020": 654
   },
   "seasons": {
    "djf": 175,
    "jja": 153,
    "mam": 131,
    "son": 194
   },
   "summer_half": 285,
   "winter_half": 369
  },
  "KT11": {
   "cells": 39,
   "mm": 681,
   "n": 523,
   "periods": {
    "1961-1990": 647,
    "1981-2010": 665,
    "1991-2020": 681
   },
   "seasons": {
    "djf": 186,
    "jja": 156,
    "mam": 136,
    "son": 204
   },
   "summer_half": 292,
   "winter_half": 390
  },
  "KT12": {
   "cells": 24,
   "mm": 641,
   "n": 1004,
   "periods": {
    "1961-1990": 603,
    "1981-2010": 628,
    "1991-2020": 641
   },
   "seasons": {
    "djf": 170,
    "jja": 150,
    "mam": 128,
    "son": 193
   },
   "summer_half": 278,
   "winter_half": 363
  },
  "KT13": {
   "cells": 20,
   "mm": 653,
   "n": 796,
   "periods": {
    "1961-1990": 623,
    "1981-2010": 639,
    "1991-2020": 653
   },
   "seasons": {
    "djf": 173,
    "jja": 155,
    "mam": 128,
    "son": 197
   },
   "summer_half": 283,
   "winter_half": 370
  },
  "KT14": {
   "cells": 12,
   "mm": 656,
   "n": 398,
   "periods": {
    "1961-1990": 625,
    "1981-2010": 640,
    "1991-2020": 656
   },
   "seasons": {
    "djf": 173,
    "jja": 157,
    "mam": 131,
    "son": 195
   },
   "summer_half": 288,
   "winter_half": 368
  },
  "KT15": {
   "cells": 17,
   "mm": 656,
   "n": 759,
   "periods": {
    "1961-1990": 628,
    "1981-2010": 642,
    "1991-2020": 656
   },
   "seasons": {
    "djf": 174,
    "jja": 156,
    "mam": 129,
    "son": 196
   },
   "summer_half": 286,
   "winter_half": 370
  },
  "KT16": {
   "cells": 38,
   "mm": 664,
   "n": 634,
   "periods": {
    "1961-1990": 636,
    "1981-2010": 651,
    "1991-2020": 664
   },
   "seasons": {
    "djf": 179,
    "jja": 154,
    "mam": 132,
    "son": 198
   },
   "summer_half": 286,
   "winter_half": 378
  },
  "KT17": {
   "cells": 19,
   "mm": 680,
   "n": 735,
   "periods": {
    "1961-1990": 670,
    "1981-2010": 671,
    "1991-2020": 680
   },
   "seasons": {
    "djf": 188,
    "jja": 151,
    "mam": 135,
    "son": 205
   },
   "summer_half": 286,
   "winter_half": 394
  },
  "KT18": {
   "cells": 27,
   "mm": 748,
   "n": 510,
   "periods": {
    "1961-1990": 721,
    "1981-2010": 733,
    "1991-2020": 748
   },
   "seasons": {
    "djf": 213,
    "jja": 161,
    "mam": 149,
    "son": 225
   },
   "summer_half": 310,
   "winter_half": 438
  },
  "KT19": {
   "cells": 18,
   "mm": 663,
   "n": 730,
   "periods": {
    "1961-1990": 646,
    "1981-2010": 653,
    "1991-2020": 663
   },
   "seasons": {
    "djf": 181,
    "jja": 152,
    "mam": 132,
    "son": 198
   },
   "summer_half": 283,
   "winter_half": 379
  },
  "KT2": {
   "cells": 15,
   "mm": 644,
   "n": 684,
   "periods": {
    "1961-1990": 616,
    "1981-2010": 633,
    "1991-2020": 644
   },
   "seasons": {
    "djf": 172,
    "jja": 152,
    "mam": 128,
    "son": 192
   },
   "summer_half": 280,
   "winter_half": 364
  },
  "KT20": {
   "cells": 35,
   "mm": 834,
   "n": 675,
   "periods": {
    "1961-1990": 796,
    "1981-2010": 814,
    "1991-2020": 834
   },
   "seasons": {
    "djf": 244,
    "jja": 174,
    "mam": 163,
    "son": 253
   },
   "summer_half": 337,
   "winter_half": 497
  },
  "KT21": {
   "cells": 12,
   "mm": 720,
   "n": 377,
   "periods": {
    "1961-1990": 688,
    "1981-2010": 703,
    "1991-2020": 720
   },
   "seasons": {
    "djf": 202,
    "jja": 158,
    "mam": 143,
    "son": 217
   },
   "summer_half": 301,
   "winter_half": 419
  },
  "KT22": {
   "cells": 37,
   "mm": 739,
   "n": 908,
   "periods": {
    "1961-1990": 701,
    "1981-2010": 721,
    "1991-2020": 739
   },
   "seasons": {
    "djf": 208,
    "jja": 161,
    "mam": 146,
    "son": 224
   },
   "summer_half": 307,
   "winter_half": 432
  },
  "KT23": {
   "cells": 16,
   "mm": 774,
   "n": 376,
   "periods": {
    "1961-1990": 735,
    "1981-2010": 755,
    "1991-2020": 774
   },
   "seasons": {
    "djf": 221,
    "jja": 167,
    "mam": 152,
    "son": 234
   },
   "summer_half": 319,
   "winter_half": 455
  },
  "KT24": {
   "cells": 30,
   "mm": 781,
   "n": 388,
   "periods": {
    "1961-1990": 744,
    "1981-2010": 758,
    "1991-2020": 781
   },
   "seasons": {
    "djf": 223,
    "jja": 172,
    "mam": 155,
    "son": 231
   },
   "summer_half": 327,
   "winter_half": 455
  },
  "KT3": {
   "cells": 14,
   "mm": 629,
   "n": 749,
   "periods": {
    "1961-1990": 602,
    "1981-2010": 616,
    "1991-2020": 629
   },
   "seasons": {
    "djf": 167,
    "jja": 149,
    "mam": 126,
    "son": 187
   },
   "summer_half": 276,
   "winter_half": 354
  },
  "KT4": {
   "cells": 13,
   "mm": 639,
   "n": 519,
   "periods": {
    "1961-1990": 621,
    "1981-2010": 630,
    "1991-2020": 639
   },
   "seasons": {
    "djf": 172,
    "jja": 150,
    "mam": 128,
    "son": 189
   },
   "summer_half": 279,
   "winter_half": 361
  },
  "KT5": {
   "cells": 10,
   "mm": 630,
   "n": 373,
   "periods": {
    "1961-1990": 604,
    "1981-2010": 620,
    "1991-2020": 630
   },
   "seasons": {
    "djf": 167,
    "jja": 150,
    "mam": 126,
    "son": 188
   },
   "summer_half": 276,
   "winter_half": 355
  },
  "KT6": {
   "cells": 11,
   "mm": 631,
   "n": 748,
   "periods": {
    "1961-1990": 605,
    "1981-2010": 620,
    "1991-2020": 631
   },
   "seasons": {
    "djf": 166,
    "jja": 151,
    "mam": 125,
    "son": 189
   },
   "summer_half": 276,
   "winter_half": 355
  },
  "KT7": {
   "cells": 8,
   "mm": 623,
   "n": 259,
   "periods": {
    "1961-1990": 596,
    "1981-2010": 610,
    "1991-2020": 623
   },
   "seasons": {
    "djf": 164,
    "jja": 149,
    "mam": 125,
    "son": 186
   },
   "summer_half": 273,
   "winter_half": 350
  },
  "KT8": {
   "cells": 12,
   "mm": 623,
   "n": 432,
   "periods": {
    "1961-1990": 595,
    "1981-2010": 609,
    "1991-2020": 623
   },
   "seasons": {
    "djf": 164,
    "jja": 148,
    "mam": 125,
    "son": 186
   },
   "summer_half": 273,
   "winter_half": 350
  },
  "KT9": {
   "cells": 15,
   "mm": 672,
   "n": 395,
   "periods": {
    "1961-1990": 648,
    "1981-2010": 659,
    "1991-2020": 672
   },
   "seasons": {
    "djf": 181,
    "jja": 159,
    "mam": 133,
    "son": 199
   },
   "summer_half": 292,
   "winter_half": 380
  },
  "KW1": {
   "cells": 78,
   "mm": 875,
   "n": 356,
   "periods": {
    "1961-1990": 826,
    "1981-2010": 877,
    "1991-2020": 875
   },
   "seasons": {
    "djf": 240,
    "jja": 193,
    "mam": 172,
    "son": 271
   },
   "summer_half": 365,
   "winter_half": 510
  },
  "KW10": {
   "cells": 6,
   "mm": 903,
   "n": 63,
   "periods": {
    "1961-1990": 838,
    "1981-2010": 895,
    "1991-2020": 903
   },
   "seasons": {
    "djf": 254,
    "jja": 196,
    "mam": 193,
    "son": 261
   },
   "summer_half": 388,
   "winter_half": 514
  },
  "KW11": {
   "cells": 6,
   "mm": 1169,
   "n": 6,
   "periods": {
    "1961-1990": 1118,
    "1981-2010": 1172,
    "1991-2020": 1169
   },
   "seasons": {
    "djf": 361,
    "jja": 220,
    "mam": 243,
    "son": 345
   },
   "summer_half": 463,
   "winter_half": 706
  },
  "KW12": {
   "cells": 20,
   "mm": 992,
   "n": 48,
   "periods": {
    "1961-1990": 940,
    "1981-2010": 1000,
    "1991-2020": 992
   },
   "seasons": {
    "djf": 279,
    "jja": 208,
    "mam": 201,
    "son": 303
   },
   "summer_half": 410,
   "winter_half": 582
  },
  "KW13": {
   "cells": 3,
   "mm": 1050,
   "n": 3,
   "periods": {
    "1961-1990": 967,
    "1981-2010": 1042,
    "1991-2020": 1050
   },
   "seasons": {
    "djf": 320,
    "jja": 208,
    "mam": 210,
    "son": 312
   },
   "summer_half": 418,
   "winter_half": 632
  },
  "KW14": {
   "cells": 88,
   "mm": 978,
   "n": 457,
   "periods": {
    "1961-1990": 910,
    "1981-2010": 974,
    "1991-2020": 978
   },
   "seasons": {
    "djf": 283,
    "jja": 200,
    "mam": 190,
    "son": 305
   },
   "summer_half": 390,
   "winter_half": 588
  },
  "KW15": {
   "cells": 30,
   "mm": 1104,
   "n": 364,
   "periods": {
    "1961-1990": 1046,
    "1981-2010": 1092,
    "1991-2020": 1104
   },
   "seasons": {
    "djf": 350,
    "jja": 188,
    "mam": 216,
    "son": 351
   },
   "summer_half": 404,
   "winter_half": 700
  },
  "KW16": {
   "cells": 51,
   "mm": 1093,
   "n": 141,
   "periods": {
    "1961-1990": 1033,
    "1981-2010": 1076,
    "1991-2020": 1093
   },
   "seasons": {
    "djf": 338,
    "jja": 194,
    "mam": 214,
    "son": 346
   },
   "summer_half": 409,
   "winter_half": 684
  },
  "KW17": {
   "cells": 151,
   "mm": 1056,
   "n": 231,
   "periods": {
    "1961-1990": 1016,
    "1981-2010": 1047,
    "1991-2020": 1056
   },
   "seasons": {
    "djf": 328,
    "jja": 187,
    "mam": 203,
    "son": 338
   },
   "summer_half": 390,
   "winter_half": 666
  },
  "KW2": {
   "cells": 1,
   "mm": 830,
   "n": 2,
   "periods": {
    "1961-1990": 795,
    "1981-2010": 833,
    "1991-2020": 830
   },
   "seasons": {
    "djf": 216,
    "jja": 189,
    "mam": 174,
    "son": 251
   },
   "summer_half": 364,
   "winter_half": 467
  },
  "KW3": {
   "cells": 13,
   "mm": 791,
   "n": 37,
   "periods": {
    "1961-1990": 757,
    "1981-2010": 790,
    "1991-2020": 791
   },
   "seasons": {
    "djf": 195,
    "jja": 179,
    "mam": 174,
    "son": 243
   },
   "summer_half": 353,
   "winter_half": 438
  },
  "KW5": {
   "cells": 9,
   "mm": 924,
   "n": 12,
   "periods": {
    "1961-1990": 882,
    "1981-2010": 925,
    "1991-2020": 924
   },
   "seasons": {
    "djf": 259,
    "jja": 196,
    "mam": 191,
    "son": 279
   },
   "summer_half": 387,
   "winter_half": 537
  },
  "KW6": {
   "cells": 10,
   "mm": 938,
   "n": 18,
   "periods": {
    "1961-1990": 892,
    "1981-2010": 939,
    "1991-2020": 938
   },
   "seasons": {
    "djf": 280,
    "jja": 184,
    "mam": 195,
    "son": 279
   },
   "summer_half": 379,
   "winter_half": 560
  },
  "KW7": {
   "cells": 3,
   "mm": 856,
   "n": 5,
   "periods": {
    "1961-1990": 818,
    "1981-2010": 857,
    "1991-2020": 856
   },
   "seasons": {
    "djf": 253,
    "jja": 164,
    "mam": 168,
    "son": 270
   },
   "summer_half": 333,
   "winter_half": 523
  },
  "KW8": {
   "cells": 10,
   "mm": 934,
   "n": 38,
   "periods": {
    "1961-1990": 935,
    "1981-2010": 956,
    "1991-2020": 934
   },
   "seasons": {
    "djf": 261,
    "jja": 176,
    "mam": 210,
    "son": 287
   },
   "summer_half": 386,
   "winter_half": 548
  },
  "KW9": {
   "cells": 15,
   "mm": 881,
   "n": 72,
   "periods": {
    "1961-1990": 821,
    "1981-2010": 875,
    "1991-2020": 881
   },
   "seasons": {
    "djf": 251,
    "jja": 179,
    "mam": 193,
    "son": 258
   },
   "summer_half": 372,
   "winter_half": 509
  },
  "KY1": {
   "cells": 39,
   "mm": 802,
   "n": 806,
   "periods": {
    "1961-1990": 740,
    "1981-2010": 786,
    "1991-2020": 802
   },
   "seasons": {
    "djf": 211,
    "jja": 212,
    "mam": 158,
    "son": 221
   },
   "summer_half": 370,
   "winter_half": 432
  },
  "KY10": {
   "cells": 47,
   "mm": 717,
   "n": 388,
   "periods": {
    "1961-1990": 673,
    "1981-2010": 703,
    "1991-2020": 717
   },
   "seasons": {
    "djf": 169,
    "jja": 209,
    "mam": 139,
    "son": 200
   },
   "summer_half": 348,
   "winter_half": 369
  },
  "KY11": {
   "cells": 56,
   "mm": 857,
   "n": 1391,
   "periods": {
    "1961-1990": 756,
    "1981-2010": 831,
    "1991-2020": 857
   },
   "seasons": {
    "djf": 231,
    "jja": 227,
    "mam": 163,
    "son": 236
   },
   "summer_half": 390,
   "winter_half": 467
  },
  "KY12": {
   "cells": 100,
   "mm": 986,
   "n": 1135,
   "periods": {
    "1961-1990": 880,
    "1981-2010": 958,
    "1991-2020": 986
   },
   "seasons": {
    "djf": 285,
    "jja": 248,
    "mam": 185,
    "son": 268
   },
   "summer_half": 433,
   "winter_half": 553
  },
  "KY13": {
   "cells": 94,
   "mm": 1166,
   "n": 405,
   "periods": {
    "1961-1990": 1042,
    "1981-2010": 1143,
    "1991-2020": 1166
   },
   "seasons": {
    "djf": 356,
    "jja": 269,
    "mam": 217,
    "son": 324
   },
   "summer_half": 486,
   "winter_half": 680
  },
  "KY14": {
   "cells": 68,
   "mm": 885,
   "n": 275,
   "periods": {
    "1961-1990": 805,
    "1981-2010": 864,
    "1991-2020": 885
   },
   "seasons": {
    "djf": 247,
    "jja": 222,
    "mam": 171,
    "son": 245
   },
   "summer_half": 393,
   "winter_half": 492
  },
  "KY15": {
   "cells": 162,
   "mm": 827,
   "n": 763,
   "periods": {
    "1961-1990": 757,
    "1981-2010": 801,
    "1991-2020": 827
   },
   "seasons": {
    "djf": 215,
    "jja": 220,
    "mam": 161,
    "son": 230
   },
   "summer_half": 381,
   "winter_half": 446
  },
  "KY16": {
   "cells": 84,
   "mm": 753,
   "n": 725,
   "periods": {
    "1961-1990": 694,
    "1981-2010": 733,
    "1991-2020": 753
   },
   "seasons": {
    "djf": 188,
    "jja": 207,
    "mam": 149,
    "son": 209
   },
   "summer_half": 355,
   "winter_half": 397
  },
  "KY2": {
   "cells": 41,
   "mm": 880,
   "n": 631,
   "periods": {
    "1961-1990": 800,
    "1981-2010": 858,
    "1991-2020": 880
   },
   "seasons": {
    "djf": 238,
    "jja": 228,
    "mam": 171,
    "son": 243
   },
   "summer_half": 399,
   "winter_half": 482
  },
  "KY3": {
   "cells": 27,
   "mm": 864,
   "n": 350,
   "periods": {
    "1961-1990": 766,
    "1981-2010": 840,
    "1991-2020": 864
   },
   "seasons": {
    "djf": 230,
    "jja": 234,
    "mam": 163,
    "son": 237
   },
   "summer_half": 397,
   "winter_half": 467
  },
  "KY4": {
   "cells": 40,
   "mm": 1052,
   "n": 513,
   "periods": {
    "1961-1990": 938,
    "1981-2010": 1024,
    "1991-2020": 1052
   },
   "seasons": {
    "djf": 298,
    "jja": 261,
    "mam": 201,
    "son": 292
   },
   "summer_half": 462,
   "winter_half": 591
  },
  "KY5": {
   "cells": 44,
   "mm": 959,
   "n": 497,
   "periods": {
    "1961-1990": 863,
    "1981-2010": 931,
    "1991-2020": 959
   },
   "seasons": {
    "djf": 274,
    "jja": 232,
    "mam": 187,
    "son": 266
   },
   "summer_half": 419,
   "winter_half": 540
  },
  "KY6": {
   "cells": 33,
   "mm": 965,
   "n": 467,
   "periods": {
    "1961-1990": 865,
    "1981-2010": 931,
    "1991-2020": 965
   },
   "seasons": {
    "djf": 268,
    "jja": 234,
    "mam": 189,
    "son": 274
   },
   "summer_half": 423,
   "winter_half": 542
  },
  "KY7": {
   "cells": 41,
   "mm": 874,
   "n": 845,
   "periods": {
    "1961-1990": 795,
    "1981-2010": 855,
    "1991-2020": 874
   },
   "seasons": {
    "djf": 236,
    "jja": 225,
    "mam": 170,
    "son": 243
   },
   "summer_half": 395,
   "winter_half": 479
  },
  "KY8": {
   "cells": 67,
   "mm": 802,
   "n": 989,
   "periods": {
    "1961-1990": 771,
    "1981-2010": 797,
    "1991-2020": 802
   },
   "seasons": {
    "djf": 205,
    "jja": 212,
    "mam": 160,
    "son": 225
   },
   "summer_half": 372,
   "winter_half": 429
  },
  "KY9": {
   "cells": 25,
   "mm": 814,
   "n": 120,
   "periods": {
    "1961-1990": 765,
    "1981-2010": 800,
    "1991-2020": 814
   },
   "seasons": {
    "djf": 201,
    "jja": 223,
    "mam": 161,
    "son": 230
   },
   "summer_half": 384,
   "winter_half": 431
  },
  "KY99": {
   "cells": 3,
   "mm": 897,
   "n": 14,
   "periods": {
    "1961-1990": 788,
    "1981-2010": 865,
    "1991-2020": 897
   },
   "seasons": {
    "djf": 252,
    "jja": 234,
    "mam": 173,
    "son": 239
   },
   "summer_half": 407,
   "winter_half": 491
  },
  "L1": {
   "cells": 5,
   "mm": 855,
   "n": 460,
   "periods": {
    "1961-1990": 805,
    "1981-2010": 838,
    "1991-2020": 855
   },
   "seasons": {
    "djf": 219,
    "jja": 216,
    "mam": 168,
    "son": 252
   },
   "summer_half": 384,
   "winter_half": 471
  },
  "L10": {
   "cells": 11,
   "mm": 905,
   "n": 293,
   "periods": {
    "1961-1990": 847,
    "1981-2010": 882,
    "1991-2020": 905
   },
   "seasons": {
    "djf": 235,
    "jja": 230,
    "mam": 166,
    "son": 274
   },
   "summer_half": 396,
   "winter_half": 509
  },
  "L11": {
   "cells": 14,
   "mm": 902,
   "n": 549,
   "periods": {
    "1961-1990": 846,
    "1981-2010": 880,
    "1991-2020": 902
   },
   "seasons": {
    "djf": 234,
    "jja": 226,
    "mam": 171,
    "son": 271
   },
   "summer_half": 397,
   "winter_half": 505
  },
  "L12": {
   "cells": 17,
   "mm": 914,
   "n": 587,
   "periods": {
    "1961-1990": 859,
    "1981-2010": 893,
    "1991-2020": 914
   },
   "seasons": {
    "djf": 239,
    "jja": 230,
    "mam": 173,
    "son": 272
   },
   "summer_half": 403,
   "winter_half": 511
  },
  "L13": {
   "cells": 13,
   "mm": 904,
   "n": 562,
   "periods": {
    "1961-1990": 849,
    "1981-2010": 884,
    "1991-2020": 904
   },
   "seasons": {
    "djf": 235,
    "jja": 228,
    "mam": 173,
    "son": 268
   },
   "summer_half": 401,
   "winter_half": 503
  },
  "L14": {
   "cells": 13,
   "mm": 928,
   "n": 479,
   "periods": {
    "1961-1990": 876,
    "1981-2010": 907,
    "1991-2020": 928
   },
   "seasons": {
    "djf": 243,
    "jja": 235,
    "mam": 177,
    "son": 273
   },
   "summer_half": 412,
   "winter_half": 516
  },
  "L15": {
   "cells": 11,
   "mm": 921,
   "n": 472,
   "periods": {
    "1961-1990": 861,
    "1981-2010": 900,
    "1991-2020": 921
   },
   "seasons": {
    "djf": 235,
    "jja": 240,
    "mam": 176,
    "son": 271
   },
   "summer_half": 416,
   "winter_half": 506
  },
  "L16": {
   "cells": 9,
   "mm": 930,
   "n": 245,
   "periods": {
    "1961-1990": 870,
    "1981-2010": 907,
    "1991-2020": 930
   },
   "seasons": {
    "djf": 239,
    "jja": 241,
    "mam": 178,
    "son": 272
   },
   "summer_half": 419,
   "winter_half": 512
  },
  "L17": {
   "cells": 9,
   "mm": 870,
   "n": 458,
   "periods": {
    "1961-1990": 816,
    "1981-2010": 851,
    "1991-2020": 870
   },
   "seasons": {
    "djf": 219,
    "jja": 225,
    "mam": 170,
    "son": 257
   },
   "summer_half": 395,
   "winter_half": 475
  },
  "L18": {
   "cells": 14,
   "mm": 914,
   "n": 556,
   "periods": {
    "1961-1990": 852,
    "1981-2010": 891,
    "1991-2020": 914
   },
   "seasons": {
    "djf": 231,
    "jja": 240,
    "mam": 177,
    "son": 267
   },
   "summer_half": 416,
   "winter_half": 498
  },
  "L19": {
   "cells": 12,
   "mm": 868,
   "n": 491,
   "periods": {
    "1961-1990": 815,
    "1981-2010": 847,
    "1991-2020": 868
   },
   "seasons": {
    "djf": 217,
    "jja": 229,
    "mam": 170,
    "son": 252
   },
   "summer_half": 399,
   "winter_half": 469
  },
  "L2": {
   "cells": 2,
   "mm": 843,
   "n": 174,
   "periods": {
    "1961-1990": 793,
    "1981-2010": 825,
    "1991-2020": 843
   },
   "seasons": {
    "djf": 215,
    "jja": 214,
    "mam": 166,
    "son": 248
   },
   "summer_half": 379,
   "winter_half": 463
  },
  "L20": {
   "cells": 14,
   "mm": 875,
   "n": 984,
   "periods": {
    "1961-1990": 829,
    "1981-2010": 860,
    "1991-2020": 875
   },
   "seasons": {
    "djf": 231,
    "jja": 210,
    "mam": 170,
    "son": 264
   },
   "summer_half": 380,
   "winter_half": 495
  },
  "L21": {
   "cells": 11,
   "mm": 876,
   "n": 572,
   "periods": {
    "1961-1990": 839,
    "1981-2010": 867,
    "1991-2020": 876
   },
   "seasons": {
    "djf": 230,
    "jja": 205,
    "mam": 170,
    "son": 271
   },
   "summer_half": 374,
   "winter_half": 502
  },
  "L22": {
   "cells": 5,
   "mm": 805,
   "n": 280,
   "periods": {
    "1961-1990": 791,
    "1981-2010": 805,
    "1991-2020": 805
   },
   "seasons": {
    "djf": 204,
    "jja": 195,
    "mam": 150,
    "son": 256
   },
   "summer_half": 345,
   "winter_half": 460
  },
  "L23": {
   "cells": 14,
   "mm": 812,
   "n": 700,
   "periods": {
    "1961-1990": 807,
    "1981-2010": 814,
    "1991-2020": 812
   },
   "seasons": {
    "djf": 207,
    "jja": 200,
    "mam": 150,
    "son": 255
   },
   "summer_half": 350,
   "winter_half": 462
  },
  "L24": {
   "cells": 17,
   "mm": 845,
   "n": 402,
   "periods": {
    "1961-1990": 801,
    "1981-2010": 823,
    "1991-2020": 845
   },
   "seasons": {
    "djf": 212,
    "jja": 222,
    "mam": 164,
    "son": 247
   },
   "summer_half": 386,
   "winter_half": 458
  },
  "L25": {
   "cells": 17,
   "mm": 916,
   "n": 858,
   "periods": {
    "1961-1990": 855,
    "1981-2010": 890,
    "1991-2020": 916
   },
   "seasons": {
    "djf": 233,
    "jja": 238,
    "mam": 177,
    "son": 267
   },
   "summer_half": 416,
   "winter_half": 500
  },
  "L26": {
   "cells": 12,
   "mm": 888,
   "n": 362,
   "periods": {
    "1961-1990": 832,
    "1981-2010": 862,
    "1991-2020": 888
   },
   "seasons": {
    "djf": 226,
    "jja": 232,
    "mam": 171,
    "son": 259
   },
   "summer_half": 403,
   "winter_half": 485
  },
  "L27": {
   "cells": 6,
   "mm": 892,
   "n": 156,
   "periods": {
    "1961-1990": 826,
    "1981-2010": 865,
    "1991-2020": 892
   },
   "seasons": {
    "djf": 227,
    "jja": 230,
    "mam": 172,
    "son": 263
   },
   "summer_half": 402,
   "winter_half": 490
  },
  "L28": {
   "cells": 7,
   "mm": 912,
   "n": 116,
   "periods": {
    "1961-1990": 861,
    "1981-2010": 892,
    "1991-2020": 912
   },
   "seasons": {
    "djf": 239,
    "jja": 230,
    "mam": 173,
    "son": 270
   },
   "summer_half": 403,
   "winter_half": 509
  },
  "L29": {
   "cells": 8,
   "mm": 848,
   "n": 22,
   "periods": {
    "1961-1990": 828,
    "1981-2010": 843,
    "1991-2020": 848
   },
   "seasons": {
    "djf": 219,
    "jja": 209,
    "mam": 159,
    "son": 262
   },
   "summer_half": 367,
   "winter_half": 481
  },
  "L3": {
   "cells": 8,
   "mm": 852,
   "n": 575,
   "periods": {
    "1961-1990": 802,
    "1981-2010": 835,
    "1991-2020": 852
   },
   "seasons": {
    "djf": 219,
    "jja": 215,
    "mam": 167,
    "son": 251
   },
   "summer_half": 382,
   "winter_half": 470
  },
  "L30": {
   "cells": 12,
   "mm": 883,
   "n": 460,
   "periods": {
    "1961-1990": 839,
    "1981-2010": 871,
    "1991-2020": 883
   },
   "seasons": {
    "djf": 230,
    "jja": 214,
    "mam": 168,
    "son": 271
   },
   "summer_half": 382,
   "winter_half": 501
  },
  "L31": {
   "cells": 30,
   "mm": 901,
   "n": 790,
   "periods": {
    "1961-1990": 851,
    "1981-2010": 888,
    "1991-2020": 901
   },
   "seasons": {
    "djf": 233,
    "jja": 225,
    "mam": 166,
    "son": 277
   },
   "summer_half": 391,
   "winter_half": 510
  },
  "L32": {
   "cells": 13,
   "mm": 923,
   "n": 540,
   "periods": {
    "1961-1990": 862,
    "1981-2010": 902,
    "1991-2020": 923
   },
   "seasons": {
    "djf": 241,
    "jja": 235,
    "mam": 166,
    "son": 281
   },
   "summer_half": 401,
   "winter_half": 522
  },
  "L33": {
   "cells": 23,
   "mm": 922,
   "n": 547,
   "periods": {
    "1961-1990": 863,
    "1981-2010": 905,
    "1991-2020": 922
   },
   "seasons": {
    "djf": 241,
    "jja": 232,
    "mam": 170,
    "son": 280
   },
   "summer_half": 401,
   "winter_half": 521
  },
  "L34": {
   "cells": 25,
   "mm": 916,
   "n": 471,
   "periods": {
    "1961-1990": 866,
    "1981-2010": 896,
    "1991-2020": 916
   },
   "seasons": {
    "djf": 241,
    "jja": 229,
    "mam": 173,
    "son": 273
   },
   "summer_half": 402,
   "winter_half": 514
  },
  "L35": {
   "cells": 25,
   "mm": 903,
   "n": 747,
   "periods": {
    "1961-1990": 853,
    "1981-2010": 879,
    "1991-2020": 903
   },
   "seasons": {
    "djf": 234,
    "jja": 229,
    "mam": 174,
    "son": 266
   },
   "summer_half": 403,
   "winter_half": 500
  },
  "L36": {
   "cells": 17,
   "mm": 910,
   "n": 972,
   "periods": {
    "1961-1990": 854,
    "1981-2010": 887,
    "1991-2020": 910
   },
   "seasons": {
    "djf": 236,
    "jja": 230,
    "mam": 175,
    "son": 269
   },
   "summer_half": 405,
   "winter_half": 506
  },
  "L37": {
   "cells": 24,
   "mm": 837,
   "n": 687,
   "periods": {
    "1961-1990": 832,
    "1981-2010": 831,
    "1991-2020": 837
   },
   "seasons": {
    "djf": 222,
    "jja": 201,
    "mam": 156,
    "son": 258
   },
   "summer_half": 357,
   "winter_half": 480
  },
  "L38": {
   "cells": 10,
   "mm": 810,
   "n": 99,
   "periods": {
    "1961-1990": 822,
    "1981-2010": 808,
    "1991-2020": 810
   },
   "seasons": {
    "djf": 214,
    "jja": 197,
    "mam": 150,
    "son": 247
   },
   "summer_half": 348,
   "winter_half": 462
  },
  "L39": {
   "cells": 76,
   "mm": 926,
   "n": 760,
   "periods": {
    "1961-1990": 889,
    "1981-2010": 913,
    "1991-2020": 926
   },
   "seasons": {
    "djf": 240,
    "jja": 233,
    "mam": 169,
    "son": 284
   },
   "summer_half": 402,
   "winter_half": 524
  },
  "L4": {
   "cells": 14,
   "mm": 880,
   "n": 797,
   "periods": {
    "1961-1990": 830,
    "1981-2010": 863,
    "1991-2020": 880
   },
   "seasons": {
    "djf": 232,
    "jja": 216,
    "mam": 170,
    "son": 262
   },
   "summer_half": 386,
   "winter_half": 494
  },
  "L40": {
   "cells": 95,
   "mm": 954,
   "n": 572,
   "periods": {
    "1961-1990": 917,
    "1981-2010": 937,
    "1991-2020": 954
   },
   "seasons": {
    "djf": 252,
    "jja": 242,
    "mam": 170,
    "son": 291
   },
   "summer_half": 412,
   "winter_half": 543
  },
  "L5": {
   "cells": 7,
   "mm": 852,
   "n": 436,
   "periods": {
    "1961-1990": 804,
    "1981-2010": 837,
    "1991-2020": 852
   },
   "seasons": {
    "djf": 221,
    "jja": 212,
    "mam": 167,
    "son": 252
   },
   "summer_half": 379,
   "winter_half": 474
  },
  "L6": {
   "cells": 9,
   "mm": 887,
   "n": 504,
   "periods": {
    "1961-1990": 835,
    "1981-2010": 870,
    "1991-2020": 887
   },
   "seasons": {
    "djf": 232,
    "jja": 219,
    "mam": 173,
    "son": 262
   },
   "summer_half": 392,
   "winter_half": 495
  },
  "L67": {
   "cells": 1,
   "mm": 905,
   "n": 1,
   "periods": {
    "1961-1990": 849,
    "1981-2010": 883,
    "1991-2020": 905
   },
   "seasons": {
    "djf": 235,
    "jja": 227,
    "mam": 171,
    "son": 271
   },
   "summer_half": 398,
   "winter_half": 506
  },
  "L68": {
   "cells": 1,
   "mm": 904,
   "n": 1,
   "periods": {
    "1961-1990": 850,
    "1981-2010": 884,
    "1991-2020": 904
   },
   "seasons": {
    "djf": 235,
    "jja": 225,
    "mam": 170,
    "son": 273
   },
   "summer_half": 395,
   "winter_half": 509
  },
  "L69": {
   "cells": 8,
   "mm": 878,
   "n": 228,
   "periods": {
    "1961-1990": 827,
    "1981-2010": 861,
    "1991-2020": 878
   },
   "seasons": {
    "djf": 227,
    "jja": 220,
    "mam": 171,
    "son": 260
   },
   "summer_half": 391,
   "winter_half": 487
  },
  "L7": {
   "cells": 10,
   "mm": 899,
   "n": 460,
   "periods": {
    "1961-1990": 846,
    "1981-2010": 881,
    "1991-2020": 899
   },
   "seasons": {
    "djf": 233,
    "jja": 228,
    "mam": 174,
    "son": 264
   },
   "summer_half": 402,
   "winter_half": 497
  },
  "L70": {
   "cells": 6,
   "mm": 858,
   "n": 15,
   "periods": {
    "1961-1990": 807,
    "1981-2010": 841,
    "1991-2020": 858
   },
   "seasons": {
    "djf": 220,
    "jja": 218,
    "mam": 165,
    "son": 255
   },
   "summer_half": 383,
   "winter_half": 475
  },
  "L71": {
   "cells": 2,
   "mm": 870,
   "n": 12,
   "periods": {
    "1961-1990": 820,
    "1981-2010": 853,
    "1991-2020": 870
   },
   "seasons": {
    "djf": 224,
    "jja": 216,
    "mam": 169,
    "son": 262
   },
   "summer_half": 385,
   "winter_half": 485
  },
  "L72": {
   "cells": 2,
   "mm": 845,
   "n": 33,
   "periods": {
    "1961-1990": 813,
    "1981-2010": 836,
    "1991-2020": 845
   },
   "seasons": {
    "djf": 216,
    "jja": 210,
    "mam": 157,
    "son": 263
   },
   "summer_half": 367,
   "winter_half": 478
  },
  "L75": {
   "cells": 4,
   "mm": 867,
   "n": 12,
   "periods": {
    "1961-1990": 819,
    "1981-2010": 851,
    "1991-2020": 867
   },
   "seasons": {
    "djf": 226,
    "jja": 213,
    "mam": 169,
    "son": 259
   },
   "summer_half": 382,
   "winter_half": 485
  },
  "L8": {
   "cells": 9,
   "mm": 869,
   "n": 699,
   "periods": {
    "1961-1990": 817,
    "1981-2010": 851,
    "1991-2020": 869
   },
   "seasons": {
    "djf": 221,
    "jja": 221,
    "mam": 170,
    "son": 256
   },
   "summer_half": 391,
   "winter_half": 478
  },
  "L9": {
   "cells": 16,
   "mm": 903,
   "n": 628,
   "periods": {
    "1961-1990": 850,
    "1981-2010": 883,
    "1991-2020": 903
   },
   "seasons": {
    "djf": 236,
    "jja": 225,
    "mam": 171,
    "son": 272
   },
   "summer_half": 396,
   "winter_half": 507
  },
  "LA1": {
   "cells": 28,
   "mm": 1120,
   "n": 1370,
   "periods": {
    "1961-1990": 1080,
    "1981-2010": 1101,
    "1991-2020": 1120
   },
   "seasons": {
    "djf": 309,
    "jja": 268,
    "mam": 197,
    "son": 346
   },
   "summer_half": 465,
   "winter_half": 655
  },
  "LA10": {
   "cells": 77,
   "mm": 1679,
   "n": 221,
   "periods": {
    "1961-1990": 1559,
    "1981-2010": 1617,
    "1991-2020": 1679
   },
   "seasons": {
    "djf": 544,
    "jja": 361,
    "mam": 307,
    "son": 467
   },
   "summer_half": 668,
   "winter_half": 1011
  },
  "LA11": {
   "cells": 81,
   "mm": 1319,
   "n": 438,
   "periods": {
    "1961-1990": 1276,
    "1981-2010": 1273,
    "1991-2020": 1319
   },
   "seasons": {
    "djf": 385,
    "jja": 299,
    "mam": 238,
    "son": 396
   },
   "summer_half": 537,
   "winter_half": 781
  },
  "LA12": {
   "cells": 160,
   "mm": 1491,
   "n": 957,
   "periods": {
    "1961-1990": 1389,
    "1981-2010": 1421,
    "1991-2020": 1491
   },
   "seasons": {
    "djf": 441,
    "jja": 336,
    "mam": 265,
    "son": 448
   },
   "summer_half": 601,
   "winter_half": 890
  },
  "LA13": {
   "cells": 27,
   "mm": 1109,
   "n": 500,
   "periods": {
    "1961-1990": 1058,
    "1981-2010": 1063,
    "1991-2020": 1109
   },
   "seasons": {
    "djf": 307,
    "jja": 257,
    "mam": 198,
    "son": 347
   },
   "summer_half": 455,
   "winter_half": 654
  },
  "LA14": {
   "cells": 26,
   "mm": 1061,
   "n": 1187,
   "periods": {
    "1961-1990": 1013,
    "1981-2010": 1014,
    "1991-2020": 1061
   },
   "seasons": {
    "djf": 291,
    "jja": 246,
    "mam": 191,
    "son": 333
   },
   "summer_half": 437,
   "winter_half": 624
  },
  "LA15": {
   "cells": 14,
   "mm": 1167,
   "n": 267,
   "periods": {
    "1961-1990": 1129,
    "1981-2010": 1124,
    "1991-2020": 1167
   },
   "seasons": {
    "djf": 325,
    "jja": 276,
    "mam": 203,
    "son": 362
   },
   "summer_half": 480,
   "winter_half": 687
  },
  "LA16": {
   "cells": 6,
   "mm": 1133,
   "n": 112,
   "periods": {
    "1961-1990": 1113,
    "1981-2010": 1084,
    "1991-2020": 1133
   },
   "seasons": {
    "djf": 308,
    "jja": 269,
    "mam": 202,
    "son": 354
   },
   "summer_half": 470,
   "winter_half": 662
  },
  "LA17": {
   "cells": 20,
   "mm": 1451,
   "n": 61,
   "periods": {
    "1961-1990": 1377,
    "1981-2010": 1372,
    "1991-2020": 1451
   },
   "seasons": {
    "djf": 428,
    "jja": 323,
    "mam": 249,
    "son": 451
   },
   "summer_half": 572,
   "winter_half": 879
  },
  "LA18": {
   "cells": 40,
   "mm": 1504,
   "n": 300,
   "periods": {
    "1961-1990": 1411,
    "1981-2010": 1427,
    "1991-2020": 1504
   },
   "seasons": {
    "djf": 426,
    "jja": 350,
    "mam": 268,
    "son": 460
   },
   "summer_half": 618,
   "winter_half": 886
  },
  "LA19": {
   "cells": 31,
   "mm": 1226,
   "n": 71,
   "periods": {
    "1961-1990": 1161,
    "1981-2010": 1171,
    "1991-2020": 1226
   },
   "seasons": {
    "djf": 348,
    "jja": 282,
    "mam": 224,
    "son": 372
   },
   "summer_half": 506,
   "winter_half": 720
  },
  "LA2": {
   "cells": 245,
   "mm": 1223,
   "n": 987,
   "periods": {
    "1961-1990": 1182,
    "1981-2010": 1202,
    "1991-2020": 1223
   },
   "seasons": {
    "djf": 358,
    "jja": 285,
    "mam": 219,
    "son": 362
   },
   "summer_half": 504,
   "winter_half": 720
  },
  "LA20": {
   "cells": 39,
   "mm": 1852,
   "n": 88,
   "periods": {
    "1961-1990": 1747,
    "1981-2010": 1780,
    "1991-2020": 1852
   },
   "seasons": {
    "djf": 553,
    "jja": 392,
    "mam": 338,
    "son": 569
   },
   "summer_half": 731,
   "winter_half": 1122
  },
  "LA21": {
   "cells": 28,
   "mm": 2346,
   "n": 93,
   "periods": {
    "1961-1990": 2151,
    "1981-2010": 2250,
    "1991-2020": 2346
   },
   "seasons": {
    "djf": 750,
    "jja": 466,
    "mam": 428,
    "son": 702
   },
   "summer_half": 894,
   "winter_half": 1452
  },
  "LA22": {
   "cells": 76,
   "mm": 2301,
   "n": 392,
   "periods": {
    "1961-1990": 2099,
    "1981-2010": 2210,
    "1991-2020": 2301
   },
   "seasons": {
    "djf": 765,
    "jja": 445,
    "mam": 413,
    "son": 678
   },
   "summer_half": 858,
   "winter_half": 1443
  },
  "LA23": {
   "cells": 52,
   "mm": 1823,
   "n": 491,
   "periods": {
    "1961-1990": 1667,
    "1981-2010": 1752,
    "1991-2020": 1823
   },
   "seasons": {
    "djf": 588,
    "jja": 371,
    "mam": 330,
    "son": 533
   },
   "summer_half": 701,
   "winter_half": 1122
  },
  "LA3": {
   "cells": 31,
   "mm": 1022,
   "n": 751,
   "periods": {
    "1961-1990": 988,
    "1981-2010": 1014,
    "1991-2020": 1022
   },
   "seasons": {
    "djf": 286,
    "jja": 240,
    "mam": 182,
    "son": 315
   },
   "summer_half": 421,
   "winter_half": 601
  },
  "LA4": {
   "cells": 10,
   "mm": 1040,
   "n": 745,
   "periods": {
    "1961-1990": 999,
    "1981-2010": 1032,
    "1991-2020": 1040
   },
   "seasons": {
    "djf": 289,
    "jja": 247,
    "mam": 184,
    "son": 320
   },
   "summer_half": 431,
   "winter_half": 609
  },
  "LA5": {
   "cells": 48,
   "mm": 1121,
   "n": 587,
   "periods": {
    "1961-1990": 1096,
    "1981-2010": 1105,
    "1991-2020": 1121
   },
   "seasons": {
    "djf": 321,
    "jja": 267,
    "mam": 201,
    "son": 332
   },
   "summer_half": 468,
   "winter_half": 653
  },
  "LA6": {
   "cells": 182,
   "mm": 1337,
   "n": 676,
   "periods": {
    "1961-1990": 1278,
    "1981-2010": 1304,
    "1991-2020": 1337
   },
   "seasons": {
    "djf": 388,
    "jja": 319,
    "mam": 243,
    "son": 387
   },
   "summer_half": 561,
   "winter_half": 776
  },
  "LA7": {
   "cells": 34,
   "mm": 1263,
   "n": 210,
   "periods": {
    "1961-1990": 1209,
    "1981-2010": 1223,
    "1991-2020": 1263
   },
   "seasons": {
    "djf": 369,
    "jja": 295,
    "mam": 227,
    "son": 373
   },
   "summer_half": 522,
   "winter_half": 742
  },
  "LA8": {
   "cells": 193,
   "mm": 1587,
   "n": 500,
   "periods": {
    "1961-1990": 1475,
    "1981-2010": 1531,
    "1991-2020": 1587
   },
   "seasons": {
    "djf": 497,
    "jja": 345,
    "mam": 282,
    "son": 464
   },
   "summer_half": 627,
   "winter_half": 961
  },
  "LA9": {
   "cells": 34,
   "mm": 1472,
   "n": 942,
   "periods": {
    "1961-1990": 1390,
    "1981-2010": 1431,
    "1991-2020": 1472
   },
   "seasons": {
    "djf": 457,
    "jja": 325,
    "mam": 262,
    "son": 428
   },
   "summer_half": 586,
   "winter_half": 885
  },
  "LD1": {
   "cells": 149,
   "mm": 1161,
   "n": 424,
   "periods": {
    "1961-1990": 1095,
    "1981-2010": 1155,
    "1991-2020": 1161
   },
   "seasons": {
    "djf": 364,
    "jja": 240,
    "mam": 233,
    "son": 324
   },
   "summer_half": 473,
   "winter_half": 688
  },
  "LD2": {
   "cells": 129,
   "mm": 1180,
   "n": 286,
   "periods": {
    "1961-1990": 1096,
    "1981-2010": 1168,
    "1991-2020": 1180
   },
   "seasons": {
    "djf": 381,
    "jja": 230,
    "mam": 235,
    "son": 334
   },
   "summer_half": 466,
   "winter_half": 715
  },
  "LD3": {
   "cells": 304,
   "mm": 1308,
   "n": 876,
   "periods": {
    "1961-1990": 1223,
    "1981-2010": 1297,
    "1991-2020": 1308
   },
   "seasons": {
    "djf": 430,
    "jja": 245,
    "mam": 251,
    "son": 381
   },
   "summer_half": 497,
   "winter_half": 811
  },
  "LD4": {
   "cells": 29,
   "mm": 1470,
   "n": 58,
   "periods": {
    "1961-1990": 1371,
    "1981-2010": 1453,
    "1991-2020": 1470
   },
   "seasons": {
    "djf": 490,
    "jja": 272,
    "mam": 282,
    "son": 427
   },
   "summer_half": 553,
   "winter_half": 917
  },
  "LD5": {
   "cells": 29,
   "mm": 1698,
   "n": 71,
   "periods": {
    "1961-1990": 1572,
    "1981-2010": 1682,
    "1991-2020": 1698
   },
   "seasons": {
    "djf": 568,
    "jja": 317,
    "mam": 325,
    "son": 489
   },
   "summer_half": 641,
   "winter_half": 1057
  },
  "LD6": {
   "cells": 41,
   "mm": 1342,
   "n": 115,
   "periods": {
    "1961-1990": 1276,
    "1981-2010": 1340,
    "1991-2020": 1342
   },
   "seasons": {
    "djf": 446,
    "jja": 249,
    "mam": 267,
    "son": 380
   },
   "summer_half": 517,
   "winter_half": 826
  },
  "LD7": {
   "cells": 77,
   "mm": 1065,
   "n": 196,
   "periods": {
    "1961-1990": 1046,
    "1981-2010": 1071,
    "1991-2020": 1065
   },
   "seasons": {
    "djf": 320,
    "jja": 218,
    "mam": 223,
    "son": 305
   },
   "summer_half": 441,
   "winter_half": 624
  },
  "LD8": {
   "cells": 71,
   "mm": 991,
   "n": 193,
   "periods": {
    "1961-1990": 946,
    "1981-2010": 984,
    "1991-2020": 991
   },
   "seasons": {
    "djf": 293,
    "jja": 205,
    "mam": 210,
    "son": 282
   },
   "summer_half": 416,
   "winter_half": 575
  },
  "LE1": {
   "cells": 8,
   "mm": 660,
   "n": 720,
   "periods": {
    "1961-1990": 622,
    "1981-2010": 645,
    "1991-2020": 660
   },
   "seasons": {
    "djf": 160,
    "jja": 186,
    "mam": 130,
    "son": 185
   },
   "summer_half": 316,
   "winter_half": 344
  },
  "LE10": {
   "cells": 55,
   "mm": 682,
   "n": 1189,
   "periods": {
    "1961-1990": 650,
    "1981-2010": 679,
    "1991-2020": 682
   },
   "seasons": {
    "djf": 164,
    "jja": 186,
    "mam": 142,
    "son": 190
   },
   "summer_half": 329,
   "winter_half": 354
  },
  "LE11": {
   "cells": 28,
   "mm": 715,
   "n": 1209,
   "periods": {
    "1961-1990": 657,
    "1981-2010": 693,
    "1991-2020": 715
   },
   "seasons": {
    "djf": 173,
    "jja": 199,
    "mam": 151,
    "son": 191
   },
   "summer_half": 350,
   "winter_half": 365
  },
  "LE12": {
   "cells": 167,
   "mm": 668,
   "n": 1604,
   "periods": {
    "1961-1990": 621,
    "1981-2010": 649,
    "1991-2020": 668
   },
   "seasons": {
    "djf": 161,
    "jja": 189,
    "mam": 136,
    "son": 181
   },
   "summer_half": 325,
   "winter_half": 343
  },
  "LE13": {
   "cells": 21,
   "mm": 643,
   "n": 649,
   "periods": {
    "1961-1990": 613,
    "1981-2010": 633,
    "1991-2020": 643
   },
   "seasons": {
    "djf": 153,
    "jja": 178,
    "mam": 135,
    "son": 177
   },
   "summer_half": 313,
   "winter_half": 330
  },
  "LE14": {
   "cells": 197,
   "mm": 664,
   "n": 686,
   "periods": {
    "1961-1990": 632,
    "1981-2010": 653,
    "1991-2020": 664
   },
   "seasons": {
    "djf": 156,
    "jja": 188,
    "mam": 139,
    "son": 181
   },
   "summer_half": 326,
   "winter_half": 338
  },
  "LE15": {
   "cells": 177,
   "mm": 699,
   "n": 1115,
   "periods": {
    "1961-1990": 651,
    "1981-2010": 682,
    "1991-2020": 699
   },
   "seasons": {
    "djf": 168,
    "jja": 190,
    "mam": 150,
    "son": 192
   },
   "summer_half": 339,
   "winter_half": 359
  },
  "LE16": {
   "cells": 141,
   "mm": 689,
   "n": 1076,
   "periods": {
    "1961-1990": 642,
    "1981-2010": 678,
    "1991-2020": 689
   },
   "seasons": {
    "djf": 165,
    "jja": 189,
    "mam": 147,
    "son": 189
   },
   "summer_half": 335,
   "winter_half": 354
  },
  "LE17": {
   "cells": 147,
   "mm": 706,
   "n": 821,
   "periods": {
    "1961-1990": 659,
    "1981-2010": 691,
    "1991-2020": 706
   },
   "seasons": {
    "djf": 170,
    "jja": 193,
    "mam": 149,
    "son": 195
   },
   "summer_half": 342,
   "winter_half": 365
  },
  "LE18": {
   "cells": 19,
   "mm": 662,
   "n": 745,
   "periods": {
    "1961-1990": 627,
    "1981-2010": 647,
    "1991-2020": 662
   },
   "seasons": {
    "djf": 158,
    "jja": 183,
    "mam": 141,
    "son": 181
   },
   "summer_half": 323,
   "winter_half": 339
  },
  "LE19": {
   "cells": 27,
   "mm": 680,
   "n": 513,
   "periods": {
    "1961-1990": 637,
    "1981-2010": 658,
    "1991-2020": 680
   },
   "seasons": {
    "djf": 166,
    "jja": 194,
    "mam": 140,
    "son": 180
   },
   "summer_half": 334,
   "winter_half": 346
  },
  "LE2": {
   "cells": 48,
   "mm": 665,
   "n": 2064,
   "periods": {
    "1961-1990": 631,
    "1981-2010": 652,
    "1991-2020": 665
   },
   "seasons": {
    "djf": 158,
    "jja": 187,
    "mam": 138,
    "son": 182
   },
   "summer_half": 325,
   "winter_half": 340
  },
  "LE21": {
   "cells": 2,
   "mm": 669,
   "n": 12,
   "periods": {
    "1961-1990": 629,
    "1981-2010": 651,
    "1991-2020": 669
   },
   "seasons": {
    "djf": 164,
    "jja": 192,
    "mam": 130,
    "son": 183
   },
   "summer_half": 322,
   "winter_half": 347
  },
  "LE3": {
   "cells": 39,
   "mm": 685,
   "n": 1833,
   "periods": {
    "1961-1990": 636,
    "1981-2010": 663,
    "1991-2020": 685
   },
   "seasons": {
    "djf": 167,
    "jja": 193,
    "mam": 140,
    "son": 185
   },
   "summer_half": 333,
   "winter_half": 352
  },
  "LE4": {
   "cells": 41,
   "mm": 660,
   "n": 1863,
   "periods": {
    "1961-1990": 621,
    "1981-2010": 646,
    "1991-2020": 660
   },
   "seasons": {
    "djf": 159,
    "jja": 184,
    "mam": 137,
    "son": 181
   },
   "summer_half": 321,
   "winter_half": 340
  },
  "LE41": {
   "cells": 1,
   "mm": 689,
   "n": 22,
   "periods": {
    "1961-1990": 641,
    "1981-2010": 664,
    "1991-2020": 689
   },
   "seasons": {
    "djf": 171,
    "jja": 203,
    "mam": 137,
    "son": 179
   },
   "summer_half": 340,
   "winter_half": 349
  },
  "LE5": {
   "cells": 28,
   "mm": 663,
   "n": 1473,
   "periods": {
    "1961-1990": 637,
    "1981-2010": 660,
    "1991-2020": 663
   },
   "seasons": {
    "djf": 157,
    "jja": 190,
    "mam": 136,
    "son": 181
   },
   "summer_half": 325,
   "winter_half": 338
  },
  "LE6": {
   "cells": 23,
   "mm": 732,
   "n": 257,
   "periods": {
    "1961-1990": 671,
    "1981-2010": 711,
    "1991-2020": 732
   },
   "seasons": {
    "djf": 179,
    "jja": 203,
    "mam": 152,
    "son": 199
   },
   "summer_half": 355,
   "winter_half": 377
  },
  "LE65": {
   "cells": 36,
   "mm": 713,
   "n": 468,
   "periods": {
    "1961-1990": 667,
    "1981-2010": 698,
    "1991-2020": 713
   },
   "seasons": {
    "djf": 170,
    "jja": 197,
    "mam": 151,
    "son": 196
   },
   "summer_half": 347,
   "winter_half": 366
  },
  "LE67": {
   "cells": 122,
   "mm": 755,
   "n": 1559,
   "periods": {
    "1961-1990": 698,
    "1981-2010": 738,
    "1991-2020": 755
   },
   "seasons": {
    "djf": 180,
    "jja": 210,
    "mam": 157,
    "son": 209
   },
   "summer_half": 366,
   "winter_half": 389
  },
  "LE7": {
   "cells": 169,
   "mm": 693,
   "n": 1236,
   "periods": {
    "1961-1990": 656,
    "1981-2010": 682,
    "1991-2020": 693
   },
   "seasons": {
    "djf": 165,
    "jja": 193,
    "mam": 144,
    "son": 192
   },
   "summer_half": 336,
   "winter_half": 357
  },
  "LE8": {
   "cells": 82,
   "mm": 679,
   "n": 886,
   "periods": {
    "1961-1990": 636,
    "1981-2010": 660,
    "1991-2020": 679
   },
   "seasons": {
    "djf": 162,
    "jja": 189,
    "mam": 143,
    "son": 185
   },
   "summer_half": 332,
   "winter_half": 347
  },
  "LE87": {
   "cells": 4,
   "mm": 665,
   "n": 40,
   "periods": {
    "1961-1990": 628,
    "1981-2010": 648,
    "1991-2020": 665
   },
   "seasons": {
    "djf": 161,
    "jja": 187,
    "mam": 133,
    "son": 184
   },
   "summer_half": 320,
   "winter_half": 345
  },
  "LE9": {
   "cells": 100,
   "mm": 682,
   "n": 1278,
   "periods": {
    "1961-1990": 638,
    "1981-2010": 664,
    "1991-2020": 682
   },
   "seasons": {
    "djf": 165,
    "jja": 193,
    "mam": 141,
    "son": 183
   },
   "summer_half": 334,
   "winter_half": 348
  },
  "LE94": {
   "cells": 1,
   "mm": 684,
   "n": 4,
   "periods": {
    "1961-1990": 623,
    "1981-2010": 669,
    "1991-2020": 684
   },
   "seasons": {
    "djf": 164,
    "jja": 187,
    "mam": 149,
    "son": 184
   },
   "summer_half": 336,
   "winter_half": 348
  },
  "LE95": {
   "cells": 1,
   "mm": 689,
   "n": 3,
   "periods": {
    "1961-1990": 641,
    "1981-2010": 664,
    "1991-2020": 689
   },
   "seasons": {
    "djf": 171,
    "jja": 203,
    "mam": 137,
    "son": 179
   },
   "summer_half": 340,
   "winter_half": 349
  },
  "LL11": {
   "cells": 67,
   "mm": 954,
   "n": 1297,
   "periods": {
    "1961-1990": 932,
    "1981-2010": 954,
    "1991-2020": 954
   },
   "seasons": {
    "djf": 263,
    "jja": 214,
    "mam": 199,
    "son": 278
   },
   "summer_half": 413,
   "winter_half": 541
  },
  "LL12": {
   "cells": 60,
   "mm": 784,
   "n": 889,
   "periods": {
    "1961-1990": 757,
    "1981-2010": 777,
    "1991-2020": 784
   },
   "seasons": {
    "djf": 206,
    "jja": 189,
    "mam": 168,
    "son": 222
   },
   "summer_half": 356,
   "winter_half": 427
  },
  "LL13": {
   "cells": 115,
   "mm": 723,
   "n": 1040,
   "periods": {
    "1961-1990": 703,
    "1981-2010": 716,
    "1991-2020": 723
   },
   "seasons": {
    "djf": 185,
    "jja": 178,
    "mam": 153,
    "son": 207
   },
   "summer_half": 332,
   "winter_half": 391
  },
  "LL14": {
   "cells": 76,
   "mm": 915,
   "n": 1047,
   "periods": {
    "1961-1990": 879,
    "1981-2010": 904,
    "1991-2020": 915
   },
   "seasons": {
    "djf": 259,
    "jja": 200,
    "mam": 196,
    "son": 259
   },
   "summer_half": 397,
   "winter_half": 518
  },
  "LL15": {
   "cells": 111,
   "mm": 942,
   "n": 457,
   "periods": {
    "1961-1990": 900,
    "1981-2010": 943,
    "1991-2020": 942
   },
   "seasons": {
    "djf": 279,
    "jja": 204,
    "mam": 186,
    "son": 274
   },
   "summer_half": 390,
   "winter_half": 552
  },
  "LL16": {
   "cells": 168,
   "mm": 944,
   "n": 651,
   "periods": {
    "1961-1990": 904,
    "1981-2010": 945,
    "1991-2020": 944
   },
   "seasons": {
    "djf": 276,
    "jja": 203,
    "mam": 183,
    "son": 283
   },
   "summer_half": 386,
   "winter_half": 559
  },
  "LL17": {
   "cells": 47,
   "mm": 813,
   "n": 235,
   "periods": {
    "1961-1990": 775,
    "1981-2010": 811,
    "1991-2020": 813
   },
   "seasons": {
    "djf": 224,
    "jja": 187,
    "mam": 153,
    "son": 249
   },
   "summer_half": 340,
   "winter_half": 473
  },
  "LL18": {
   "cells": 59,
   "mm": 746,
   "n": 1225,
   "periods": {
    "1961-1990": 719,
    "1981-2010": 744,
    "1991-2020": 746
   },
   "seasons": {
    "djf": 201,
    "jja": 179,
    "mam": 140,
    "son": 227
   },
   "summer_half": 319,
   "winter_half": 427
  },
  "LL19": {
   "cells": 19,
   "mm": 720,
   "n": 605,
   "periods": {
    "1961-1990": 696,
    "1981-2010": 715,
    "1991-2020": 720
   },
   "seasons": {
    "djf": 183,
    "jja": 181,
    "mam": 138,
    "son": 218
   },
   "summer_half": 319,
   "winter_half": 401
  },
  "LL20": {
   "cells": 71,
   "mm": 1102,
   "n": 384,
   "periods": {
    "1961-1990": 1042,
    "1981-2010": 1095,
    "1991-2020": 1102
   },
   "seasons": {
    "djf": 330,
    "jja": 226,
    "mam": 232,
    "son": 313
   },
   "summer_half": 458,
   "winter_half": 644
  },
  "LL21": {
   "cells": 133,
   "mm": 1195,
   "n": 368,
   "periods": {
    "1961-1990": 1122,
    "1981-2010": 1185,
    "1991-2020": 1195
   },
   "seasons": {
    "djf": 377,
    "jja": 244,
    "mam": 230,
    "son": 343
   },
   "summer_half": 475,
   "winter_half": 720
  },
  "LL22": {
   "cells": 139,
   "mm": 1025,
   "n": 652,
   "periods": {
    "1961-1990": 976,
    "1981-2010": 1017,
    "1991-2020": 1025
   },
   "seasons": {
    "djf": 296,
    "jja": 218,
    "mam": 194,
    "son": 316
   },
   "summer_half": 412,
   "winter_half": 613
  },
  "LL23": {
   "cells": 79,
   "mm": 1661,
   "n": 199,
   "periods": {
    "1961-1990": 1536,
    "1981-2010": 1628,
    "1991-2020": 1661
   },
   "seasons": {
    "djf": 569,
    "jja": 301,
    "mam": 317,
    "son": 474
   },
   "summer_half": 618,
   "winter_half": 1043
  },
  "LL24": {
   "cells": 73,
   "mm": 1853,
   "n": 193,
   "periods": {
    "1961-1990": 1714,
    "1981-2010": 1817,
    "1991-2020": 1853
   },
   "seasons": {
    "djf": 615,
    "jja": 356,
    "mam": 344,
    "son": 538
   },
   "summer_half": 700,
   "winter_half": 1153
  },
  "LL25": {
   "cells": 14,
   "mm": 2230,
   "n": 47,
   "periods": {
    "1961-1990": 2076,
    "1981-2010": 2182,
    "1991-2020": 2230
   },
   "seasons": {
    "djf": 733,
    "jja": 443,
    "mam": 416,
    "son": 638
   },
   "summer_half": 858,
   "winter_half": 1372
  },
  "LL26": {
   "cells": 55,
   "mm": 1525,
   "n": 208,
   "periods": {
    "1961-1990": 1465,
    "1981-2010": 1528,
    "1991-2020": 1525
   },
   "seasons": {
    "djf": 508,
    "jja": 276,
    "mam": 291,
    "son": 450
   },
   "summer_half": 567,
   "winter_half": 958
  },
  "LL27": {
   "cells": 15,
   "mm": 1760,
   "n": 47,
   "periods": {
    "1961-1990": 1689,
    "1981-2010": 1770,
    "1991-2020": 1760
   },
   "seasons": {
    "djf": 596,
    "jja": 307,
    "mam": 330,
    "son": 527
   },
   "summer_half": 636,
   "winter_half": 1123
  },
  "LL28": {
   "cells": 44,
   "mm": 1067,
   "n": 448,
   "periods": {
    "1961-1990": 1010,
    "1981-2010": 1041,
    "1991-2020": 1067
   },
   "seasons": {
    "djf": 323,
    "jja": 216,
    "mam": 200,
    "son": 327
   },
   "summer_half": 416,
   "winter_half": 651
  },
  "LL29": {
   "cells": 30,
   "mm": 989,
   "n": 617,
   "periods": {
    "1961-1990": 906,
    "1981-2010": 957,
    "1991-2020": 989
   },
   "seasons": {
    "djf": 282,
    "jja": 218,
    "mam": 185,
    "son": 304
   },
   "summer_half": 403,
   "winter_half": 586
  },
  "LL30": {
   "cells": 20,
   "mm": 858,
   "n": 680,
   "periods": {
    "1961-1990": 810,
    "1981-2010": 827,
    "1991-2020": 858
   },
   "seasons": {
    "djf": 251,
    "jja": 180,
    "mam": 160,
    "son": 267
   },
   "summer_half": 340,
   "winter_half": 517
  },
  "LL31": {
   "cells": 14,
   "mm": 883,
   "n": 281,
   "periods": {
    "1961-1990": 826,
    "1981-2010": 847,
    "1991-2020": 883
   },
   "seasons": {
    "djf": 260,
    "jja": 184,
    "mam": 166,
    "son": 273
   },
   "summer_half": 350,
   "winter_half": 533
  },
  "LL32": {
   "cells": 39,
   "mm": 1237,
   "n": 279,
   "periods": {
    "1961-1990": 1173,
    "1981-2010": 1211,
    "1991-2020": 1237
   },
   "seasons": {
    "djf": 397,
    "jja": 233,
    "mam": 225,
    "son": 381
   },
   "summer_half": 458,
   "winter_half": 779
  },
  "LL33": {
   "cells": 14,
   "mm": 1181,
   "n": 167,
   "periods": {
    "1961-1990": 1106,
    "1981-2010": 1146,
    "1991-2020": 1181
   },
   "seasons": {
    "djf": 353,
    "jja": 235,
    "mam": 227,
    "son": 365
   },
   "summer_half": 462,
   "winter_half": 719
  },
  "LL34": {
   "cells": 9,
   "mm": 1041,
   "n": 186,
   "periods": {
    "1961-1990": 977,
    "1981-2010": 1009,
    "1991-2020": 1041
   },
   "seasons": {
    "djf": 321,
    "jja": 211,
    "mam": 204,
    "son": 305
   },
   "summer_half": 415,
   "winter_half": 626
  },
  "LL35": {
   "cells": 12,
   "mm": 1221,
   "n": 99,
   "periods": {
    "1961-1990": 1179,
    "1981-2010": 1193,
    "1991-2020": 1221
   },
   "seasons": {
    "djf": 341,
    "jja": 286,
    "mam": 222,
    "son": 372
   },
   "summer_half": 508,
   "winter_half": 712
  },
  "LL36": {
   "cells": 55,
   "mm": 1498,
   "n": 246,
   "periods": {
    "1961-1990": 1409,
    "1981-2010": 1468,
    "1991-2020": 1498
   },
   "seasons": {
    "djf": 426,
    "jja": 337,
    "mam": 274,
    "son": 461
   },
   "summer_half": 611,
   "winter_half": 887
  },
  "LL37": {
   "cells": 9,
   "mm": 1501,
   "n": 40,
   "periods": {
    "1961-1990": 1400,
    "1981-2010": 1461,
    "1991-2020": 1501
   },
   "seasons": {
    "djf": 425,
    "jja": 340,
    "mam": 267,
    "son": 469
   },
   "summer_half": 607,
   "winter_half": 894
  },
  "LL38": {
   "cells": 4,
   "mm": 1390,
   "n": 47,
   "periods": {
    "1961-1990": 1290,
    "1981-2010": 1345,
    "1991-2020": 1390
   },
   "seasons": {
    "djf": 403,
    "jja": 293,
    "mam": 254,
    "son": 441
   },
   "summer_half": 546,
   "winter_half": 844
  },
  "LL39": {
   "cells": 8,
   "mm": 1510,
   "n": 19,
   "periods": {
    "1961-1990": 1403,
    "1981-2010": 1460,
    "1991-2020": 1510
   },
   "seasons": {
    "djf": 439,
    "jja": 320,
    "mam": 279,
    "son": 471
   },
   "summer_half": 599,
   "winter_half": 910
  },
  "LL40": {
   "cells": 90,
   "mm": 1904,
   "n": 354,
   "periods": {
    "1961-1990": 1774,
    "1981-2010": 1861,
    "1991-2020": 1904
   },
   "seasons": {
    "djf": 590,
    "jja": 396,
    "mam": 352,
    "son": 565
   },
   "summer_half": 748,
   "winter_half": 1155
  },
  "LL41": {
   "cells": 54,
   "mm": 2106,
   "n": 376,
   "periods": {
    "1961-1990": 2007,
    "1981-2010": 2059,
    "1991-2020": 2106
   },
   "seasons": {
    "djf": 638,
    "jja": 454,
    "mam": 392,
    "son": 622
   },
   "summer_half": 846,
   "winter_half": 1260
  },
  "LL42": {
   "cells": 12,
   "mm": 1367,
   "n": 151,
   "periods": {
    "1961-1990": 1260,
    "1981-2010": 1316,
    "1991-2020": 1367
   },
   "seasons": {
    "djf": 377,
    "jja": 315,
    "mam": 235,
    "son": 439
   },
   "summer_half": 550,
   "winter_half": 817
  },
  "LL43": {
   "cells": 7,
   "mm": 1125,
   "n": 29,
   "periods": {
    "1961-1990": 1074,
    "1981-2010": 1094,
    "1991-2020": 1125
   },
   "seasons": {
    "djf": 357,
    "jja": 246,
    "mam": 203,
    "son": 320
   },
   "summer_half": 449,
   "winter_half": 676
  },
  "LL44": {
   "cells": 9,
   "mm": 1173,
   "n": 52,
   "periods": {
    "1961-1990": 1145,
    "1981-2010": 1149,
    "1991-2020": 1173
   },
   "seasons": {
    "djf": 367,
    "jja": 260,
    "mam": 215,
    "son": 332
   },
   "summer_half": 475,
   "winter_half": 699
  },
  "LL45": {
   "cells": 15,
   "mm": 1256,
   "n": 54,
   "periods": {
    "1961-1990": 1220,
    "1981-2010": 1238,
    "1991-2020": 1256
   },
   "seasons": {
    "djf": 352,
    "jja": 291,
    "mam": 230,
    "son": 383
   },
   "summer_half": 521,
   "winter_half": 735
  },
  "LL46": {
   "cells": 17,
   "mm": 1222,
   "n": 94,
   "periods": {
    "1961-1990": 1185,
    "1981-2010": 1197,
    "1991-2020": 1222
   },
   "seasons": {
    "djf": 331,
    "jja": 293,
    "mam": 225,
    "son": 373
   },
   "summer_half": 517,
   "winter_half": 704
  },
  "LL47": {
   "cells": 16,
   "mm": 1481,
   "n": 47,
   "periods": {
    "1961-1990": 1424,
    "1981-2010": 1462,
    "1991-2020": 1481
   },
   "seasons": {
    "djf": 424,
    "jja": 339,
    "mam": 270,
    "son": 448
   },
   "summer_half": 609,
   "winter_half": 872
  },
  "LL48": {
   "cells": 21,
   "mm": 1724,
   "n": 160,
   "periods": {
    "1961-1990": 1652,
    "1981-2010": 1693,
    "1991-2020": 1724
   },
   "seasons": {
    "djf": 499,
    "jja": 390,
    "mam": 322,
    "son": 514
   },
   "summer_half": 712,
   "winter_half": 1013
  },
  "LL49": {
   "cells": 23,
   "mm": 1501,
   "n": 194,
   "periods": {
    "1961-1990": 1434,
    "1981-2010": 1472,
    "1991-2020": 1501
   },
   "seasons": {
    "djf": 434,
    "jja": 340,
    "mam": 280,
    "son": 447
   },
   "summer_half": 620,
   "winter_half": 880
  },
  "LL51": {
   "cells": 25,
   "mm": 1775,
   "n": 45,
   "periods": {
    "1961-1990": 1704,
    "1981-2010": 1751,
    "1991-2020": 1775
   },
   "seasons": {
    "djf": 517,
    "jja": 392,
    "mam": 329,
    "son": 537
   },
   "summer_half": 721,
   "winter_half": 1054
  },
  "LL52": {
   "cells": 27,
   "mm": 1387,
   "n": 160,
   "periods": {
    "1961-1990": 1368,
    "1981-2010": 1382,
    "1991-2020": 1387
   },
   "seasons": {
    "djf": 397,
    "jja": 305,
    "mam": 264,
    "son": 421
   },
   "summer_half": 569,
   "winter_half": 818
  },
  "LL53": {
   "cells": 227,
   "mm": 1143,
   "n": 812,
   "periods": {
    "1961-1990": 1091,
    "1981-2010": 1114,
    "1991-2020": 1143
   },
   "seasons": {
    "djf": 315,
    "jja": 243,
    "mam": 220,
    "son": 365
   },
   "summer_half": 463,
   "winter_half": 680
  },
  "LL54": {
   "cells": 107,
   "mm": 1633,
   "n": 522,
   "periods": {
    "1961-1990": 1575,
    "1981-2010": 1619,
    "1991-2020": 1633
   },
   "seasons": {
    "djf": 471,
    "jja": 351,
    "mam": 299,
    "son": 511
   },
   "summer_half": 651,
   "winter_half": 982
  },
  "LL55": {
   "cells": 84,
   "mm": 1880,
   "n": 742,
   "periods": {
    "1961-1990": 1799,
    "1981-2010": 1840,
    "1991-2020": 1880
   },
   "seasons": {
    "djf": 558,
    "jja": 395,
    "mam": 345,
    "son": 582
   },
   "summer_half": 740,
   "winter_half": 1140
  },
  "LL56": {
   "cells": 11,
   "mm": 1222,
   "n": 74,
   "periods": {
    "1961-1990": 1220,
    "1981-2010": 1222,
    "1991-2020": 1222
   },
   "seasons": {
    "djf": 337,
    "jja": 266,
    "mam": 226,
    "son": 393
   },
   "summer_half": 492,
   "winter_half": 730
  },
  "LL57": {
   "cells": 66,
   "mm": 1516,
   "n": 904,
   "periods": {
    "1961-1990": 1480,
    "1981-2010": 1509,
    "1991-2020": 1516
   },
   "seasons": {
    "djf": 444,
    "jja": 307,
    "mam": 285,
    "son": 480
   },
   "summer_half": 592,
   "winter_half": 924
  },
  "LL58": {
   "cells": 30,
   "mm": 1036,
   "n": 192,
   "periods": {
    "1961-1990": 987,
    "1981-2010": 1006,
    "1991-2020": 1036
   },
   "seasons": {
    "djf": 300,
    "jja": 208,
    "mam": 197,
    "son": 330
   },
   "summer_half": 405,
   "winter_half": 631
  },
  "LL59": {
   "cells": 23,
   "mm": 1099,
   "n": 201,
   "periods": {
    "1961-1990": 1064,
    "1981-2010": 1080,
    "1991-2020": 1099
   },
   "seasons": {
    "djf": 306,
    "jja": 233,
    "mam": 203,
    "son": 358
   },
   "summer_half": 436,
   "winter_half": 664
  },
  "LL60": {
   "cells": 24,
   "mm": 1135,
   "n": 111,
   "periods": {
    "1961-1990": 1103,
    "1981-2010": 1134,
    "1991-2020": 1135
   },
   "seasons": {
    "djf": 310,
    "jja": 252,
    "mam": 213,
    "son": 361
   },
   "summer_half": 465,
   "winter_half": 671
  },
  "LL61": {
   "cells": 41,
   "mm": 1103,
   "n": 248,
   "periods": {
    "1961-1990": 1076,
    "1981-2010": 1099,
    "1991-2020": 1103
   },
   "seasons": {
    "djf": 300,
    "jja": 248,
    "mam": 203,
    "son": 352
   },
   "summer_half": 451,
   "winter_half": 652
  },
  "LL62": {
   "cells": 39,
   "mm": 1067,
   "n": 119,
   "periods": {
    "1961-1990": 1046,
    "1981-2010": 1075,
    "1991-2020": 1067
   },
   "seasons": {
    "djf": 287,
    "jja": 222,
    "mam": 218,
    "son": 340
   },
   "summer_half": 440,
   "winter_half": 627
  },
  "LL63": {
   "cells": 29,
   "mm": 1019,
   "n": 105,
   "periods": {
    "1961-1990": 1002,
    "1981-2010": 1012,
    "1991-2020": 1019
   },
   "seasons": {
    "djf": 272,
    "jja": 215,
    "mam": 204,
    "son": 328
   },
   "summer_half": 419,
   "winter_half": 600
  },
  "LL64": {
   "cells": 2,
   "mm": 900,
   "n": 58,
   "periods": {
    "1961-1990": 886,
    "1981-2010": 885,
    "1991-2020": 900
   },
   "seasons": {
    "djf": 241,
    "jja": 192,
    "mam": 174,
    "son": 293
   },
   "summer_half": 366,
   "winter_half": 534
  },
  "LL65": {
   "cells": 152,
   "mm": 987,
   "n": 922,
   "periods": {
    "1961-1990": 973,
    "1981-2010": 985,
    "1991-2020": 987
   },
   "seasons": {
    "djf": 273,
    "jja": 206,
    "mam": 190,
    "son": 318
   },
   "summer_half": 396,
   "winter_half": 591
  },
  "LL66": {
   "cells": 16,
   "mm": 1026,
   "n": 22,
   "periods": {
    "1961-1990": 999,
    "1981-2010": 1016,
    "1991-2020": 1026
   },
   "seasons": {
    "djf": 296,
    "jja": 211,
    "mam": 196,
    "son": 323
   },
   "summer_half": 407,
   "winter_half": 619
  },
  "LL67": {
   "cells": 11,
   "mm": 982,
   "n": 61,
   "periods": {
    "1961-1990": 945,
    "1981-2010": 975,
    "1991-2020": 982
   },
   "seasons": {
    "djf": 283,
    "jja": 193,
    "mam": 193,
    "son": 314
   },
   "summer_half": 385,
   "winter_half": 597
  },
  "LL68": {
   "cells": 48,
   "mm": 1038,
   "n": 235,
   "periods": {
    "1961-1990": 1001,
    "1981-2010": 1025,
    "1991-2020": 1038
   },
   "seasons": {
    "djf": 302,
    "jja": 212,
    "mam": 194,
    "son": 330
   },
   "summer_half": 406,
   "winter_half": 632
  },
  "LL69": {
   "cells": 8,
   "mm": 1086,
   "n": 35,
   "periods": {
    "1961-1990": 1034,
    "1981-2010": 1066,
    "1991-2020": 1086
   },
   "seasons": {
    "djf": 318,
    "jja": 227,
    "mam": 199,
    "son": 342
   },
   "summer_half": 426,
   "winter_half": 660
  },
  "LL70": {
   "cells": 11,
   "mm": 1072,
   "n": 20,
   "periods": {
    "1961-1990": 1021,
    "1981-2010": 1054,
    "1991-2020": 1072
   },
   "seasons": {
    "djf": 308,
    "jja": 214,
    "mam": 201,
    "son": 348
   },
   "summer_half": 415,
   "winter_half": 657
  },
  "LL71": {
   "cells": 39,
   "mm": 1085,
   "n": 86,
   "periods": {
    "1961-1990": 1053,
    "1981-2010": 1072,
    "1991-2020": 1085
   },
   "seasons": {
    "djf": 306,
    "jja": 223,
    "mam": 203,
    "son": 352
   },
   "summer_half": 427,
   "winter_half": 659
  },
  "LL72": {
   "cells": 6,
   "mm": 1094,
   "n": 44,
   "periods": {
    "1961-1990": 1042,
    "1981-2010": 1078,
    "1991-2020": 1094
   },
   "seasons": {
    "djf": 315,
    "jja": 212,
    "mam": 214,
    "son": 352
   },
   "summer_half": 426,
   "winter_half": 668
  },
  "LL73": {
   "cells": 5,
   "mm": 1125,
   "n": 13,
   "periods": {
    "1961-1990": 1073,
    "1981-2010": 1108,
    "1991-2020": 1125
   },
   "seasons": {
    "djf": 325,
    "jja": 222,
    "mam": 218,
    "son": 360
   },
   "summer_half": 441,
   "winter_half": 685
  },
  "LL74": {
   "cells": 8,
   "mm": 1128,
   "n": 80,
   "periods": {
    "1961-1990": 1075,
    "1981-2010": 1108,
    "1991-2020": 1128
   },
   "seasons": {
    "djf": 324,
    "jja": 229,
    "mam": 213,
    "son": 362
   },
   "summer_half": 442,
   "winter_half": 687
  },
  "LL75": {
   "cells": 15,
   "mm": 1103,
   "n": 60,
   "periods": {
    "1961-1990": 1053,
    "1981-2010": 1082,
    "1991-2020": 1103
   },
   "seasons": {
    "djf": 310,
    "jja": 230,
    "mam": 202,
    "son": 361
   },
   "summer_half": 433,
   "winter_half": 670
  },
  "LL76": {
   "cells": 3,
   "mm": 1153,
   "n": 9,
   "periods": {
    "1961-1990": 1090,
    "1981-2010": 1134,
    "1991-2020": 1153
   },
   "seasons": {
    "djf": 326,
    "jja": 237,
    "mam": 212,
    "son": 378
   },
   "summer_half": 449,
   "winter_half": 704
  },
  "LL77": {
   "cells": 48,
   "mm": 1143,
   "n": 255,
   "periods": {
    "1961-1990": 1092,
    "1981-2010": 1147,
    "1991-2020": 1143
   },
   "seasons": {
    "djf": 312,
    "jja": 244,
    "mam": 213,
    "son": 375
   },
   "summer_half": 457,
   "winter_half": 686
  },
  "LL78": {
   "cells": 8,
   "mm": 1173,
   "n": 22,
   "periods": {
    "1961-1990": 1115,
    "1981-2010": 1156,
    "1991-2020": 1173
   },
   "seasons": {
    "djf": 334,
    "jja": 239,
    "mam": 219,
    "son": 381
   },
   "summer_half": 459,
   "winter_half": 715
  },
  "LN1": {
   "cells": 85,
   "mm": 625,
   "n": 927,
   "periods": {
    "1961-1990": 592,
    "1981-2010": 610,
    "1991-2020": 625
   },
   "seasons": {
    "djf": 142,
    "jja": 187,
    "mam": 128,
    "son": 168
   },
   "summer_half": 314,
   "winter_half": 311
  },
  "LN10": {
   "cells": 48,
   "mm": 622,
   "n": 205,
   "periods": {
    "1961-1990": 593,
    "1981-2010": 610,
    "1991-2020": 622
   },
   "seasons": {
    "djf": 143,
    "jja": 180,
    "mam": 123,
    "son": 176
   },
   "summer_half": 304,
   "winter_half": 319
  },
  "LN11": {
   "cells": 238,
   "mm": 679,
   "n": 1184,
   "periods": {
    "1961-1990": 653,
    "1981-2010": 668,
    "1991-2020": 679
   },
   "seasons": {
    "djf": 165,
    "jja": 188,
    "mam": 135,
    "son": 190
   },
   "summer_half": 323,
   "winter_half": 355
  },
  "LN12": {
   "cells": 39,
   "mm": 636,
   "n": 439,
   "periods": {
    "1961-1990": 618,
    "1981-2010": 626,
    "1991-2020": 636
   },
   "seasons": {
    "djf": 155,
    "jja": 177,
    "mam": 125,
    "son": 180
   },
   "summer_half": 301,
   "winter_half": 335
  },
  "LN13": {
   "cells": 105,
   "mm": 660,
   "n": 337,
   "periods": {
    "1961-1990": 647,
    "1981-2010": 652,
    "1991-2020": 660
   },
   "seasons": {
    "djf": 160,
    "jja": 183,
    "mam": 132,
    "son": 186
   },
   "summer_half": 314,
   "winter_half": 346
  },
  "LN2": {
   "cells": 67,
   "mm": 646,
   "n": 1162,
   "periods": {
    "1961-1990": 604,
    "1981-2010": 624,
    "1991-2020": 646
   },
   "seasons": {
    "djf": 147,
    "jja": 190,
    "mam": 131,
    "son": 178
   },
   "summer_half": 321,
   "winter_half": 325
  },
  "LN3": {
   "cells": 58,
   "mm": 627,
   "n": 296,
   "periods": {
    "1961-1990": 587,
    "1981-2010": 610,
    "1991-2020": 627
   },
   "seasons": {
    "djf": 145,
    "jja": 183,
    "mam": 126,
    "son": 172
   },
   "summer_half": 309,
   "winter_half": 318
  },
  "LN4": {
   "cells": 221,
   "mm": 605,
   "n": 1140,
   "periods": {
    "1961-1990": 573,
    "1981-2010": 592,
    "1991-2020": 605
   },
   "seasons": {
    "djf": 140,
    "jja": 175,
    "mam": 124,
    "son": 166
   },
   "summer_half": 299,
   "winter_half": 306
  },
  "LN5": {
   "cells": 103,
   "mm": 624,
   "n": 1034,
   "periods": {
    "1961-1990": 589,
    "1981-2010": 609,
    "1991-2020": 624
   },
   "seasons": {
    "djf": 144,
    "jja": 183,
    "mam": 128,
    "son": 170
   },
   "summer_half": 310,
   "winter_half": 314
  },
  "LN6": {
   "cells": 94,
   "mm": 629,
   "n": 1482,
   "periods": {
    "1961-1990": 594,
    "1981-2010": 614,
    "1991-2020": 629
   },
   "seasons": {
    "djf": 145,
    "jja": 189,
    "mam": 127,
    "son": 167
   },
   "summer_half": 316,
   "winter_half": 312
  },
  "LN7": {
   "cells": 69,
   "mm": 658,
   "n": 271,
   "periods": {
    "1961-1990": 642,
    "1981-2010": 652,
    "1991-2020": 658
   },
   "seasons": {
    "djf": 154,
    "jja": 188,
    "mam": 132,
    "son": 184
   },
   "summer_half": 320,
   "winter_half": 338
  },
  "LN8": {
   "cells": 212,
   "mm": 684,
   "n": 685,
   "periods": {
    "1961-1990": 650,
    "1981-2010": 670,
    "1991-2020": 684
   },
   "seasons": {
    "djf": 161,
    "jja": 196,
    "mam": 136,
    "son": 191
   },
   "summer_half": 333,
   "winter_half": 352
  },
  "LN9": {
   "cells": 92,
   "mm": 696,
   "n": 404,
   "periods": {
    "1961-1990": 663,
    "1981-2010": 681,
    "1991-2020": 696
   },
   "seasons": {
    "djf": 166,
    "jja": 195,
    "mam": 139,
    "son": 196
   },
   "summer_half": 334,
   "winter_half": 362
  },
  "LS1": {
   "cells": 6,
   "mm": 662,
   "n": 523,
   "periods": {
    "1961-1990": 662,
    "1981-2010": 657,
    "1991-2020": 662
   },
   "seasons": {
    "djf": 169,
    "jja": 171,
    "mam": 137,
    "son": 185
   },
   "summer_half": 308,
   "winter_half": 354
  },
  "LS10": {
   "cells": 24,
   "mm": 696,
   "n": 910,
   "periods": {
    "1961-1990": 691,
    "1981-2010": 693,
    "1991-2020": 696
   },
   "seasons": {
    "djf": 174,
    "jja": 185,
    "mam": 145,
    "son": 191
   },
   "summer_half": 330,
   "winter_half": 366
  },
  "LS11": {
   "cells": 17,
   "mm": 679,
   "n": 977,
   "periods": {
    "1961-1990": 673,
    "1981-2010": 674,
    "1991-2020": 679
   },
   "seasons": {
    "djf": 173,
    "jja": 176,
    "mam": 142,
    "son": 188
   },
   "summer_half": 318,
   "winter_half": 362
  },
  "LS12": {
   "cells": 28,
   "mm": 714,
   "n": 1229,
   "periods": {
    "1961-1990": 693,
    "1981-2010": 700,
    "1991-2020": 714
   },
   "seasons": {
    "djf": 188,
    "jja": 178,
    "mam": 148,
    "son": 200
   },
   "summer_half": 326,
   "winter_half": 388
  },
  "LS13": {
   "cells": 17,
   "mm": 758,
   "n": 901,
   "periods": {
    "1961-1990": 732,
    "1981-2010": 742,
    "1991-2020": 758
   },
   "seasons": {
    "djf": 202,
    "jja": 189,
    "mam": 156,
    "son": 211
   },
   "summer_half": 345,
   "winter_half": 413
  },
  "LS14": {
   "cells": 33,
   "mm": 699,
   "n": 1004,
   "periods": {
    "1961-1990": 699,
    "1981-2010": 693,
    "1991-2020": 699
   },
   "seasons": {
    "djf": 172,
    "jja": 187,
    "mam": 145,
    "son": 194
   },
   "summer_half": 333,
   "winter_half": 367
  },
  "LS15": {
   "cells": 37,
   "mm": 687,
   "n": 1008,
   "periods": {
    "1961-1990": 682,
    "1981-2010": 681,
    "1991-2020": 687
   },
   "seasons": {
    "djf": 166,
    "jja": 187,
    "mam": 143,
    "son": 191
   },
   "summer_half": 330,
   "winter_half": 357
  },
  "LS16": {
   "cells": 38,
   "mm": 782,
   "n": 1029,
   "periods": {
    "1961-1990": 787,
    "1981-2010": 772,
    "1991-2020": 782
   },
   "seasons": {
    "djf": 203,
    "jja": 200,
    "mam": 158,
    "son": 220
   },
   "summer_half": 359,
   "winter_half": 423
  },
  "LS17": {
   "cells": 81,
   "mm": 727,
   "n": 1263,
   "periods": {
    "1961-1990": 735,
    "1981-2010": 721,
    "1991-2020": 727
   },
   "seasons": {
    "djf": 183,
    "jja": 193,
    "mam": 148,
    "son": 202
   },
   "summer_half": 341,
   "winter_half": 385
  },
  "LS18": {
   "cells": 18,
   "mm": 785,
   "n": 531,
   "periods": {
    "1961-1990": 771,
    "1981-2010": 770,
    "1991-2020": 785
   },
   "seasons": {
    "djf": 209,
    "jja": 196,
    "mam": 160,
    "son": 220
   },
   "summer_half": 356,
   "winter_half": 430
  },
  "LS19": {
   "cells": 19,
   "mm": 837,
   "n": 566,
   "periods": {
    "1961-1990": 813,
    "1981-2010": 818,
    "1991-2020": 837
   },
   "seasons": {
    "djf": 228,
    "jja": 208,
    "mam": 169,
    "son": 232
   },
   "summer_half": 377,
   "winter_half": 460
  },
  "LS2": {
   "cells": 7,
   "mm": 667,
   "n": 374,
   "periods": {
    "1961-1990": 669,
    "1981-2010": 662,
    "1991-2020": 667
   },
   "seasons": {
    "djf": 171,
    "jja": 171,
    "mam": 137,
    "son": 188
   },
   "summer_half": 308,
   "winter_half": 359
  },
  "LS20": {
   "cells": 17,
   "mm": 837,
   "n": 352,
   "periods": {
    "1961-1990": 813,
    "1981-2010": 816,
    "1991-2020": 837
   },
   "seasons": {
    "djf": 225,
    "jja": 210,
    "mam": 167,
    "son": 236
   },
   "summer_half": 377,
   "winter_half": 460
  },
  "LS21": {
   "cells": 84,
   "mm": 891,
   "n": 651,
   "periods": {
    "1961-1990": 860,
    "1981-2010": 862,
    "1991-2020": 891
   },
   "seasons": {
    "djf": 242,
    "jja": 222,
    "mam": 177,
    "son": 250
   },
   "summer_half": 399,
   "winter_half": 492
  },
  "LS22": {
   "cells": 62,
   "mm": 643,
   "n": 567,
   "periods": {
    "1961-1990": 624,
    "1981-2010": 629,
    "1991-2020": 643
   },
   "seasons": {
    "djf": 156,
    "jja": 176,
    "mam": 134,
    "son": 176
   },
   "summer_half": 311,
   "winter_half": 332
  },
  "LS23": {
   "cells": 31,
   "mm": 648,
   "n": 368,
   "periods": {
    "1961-1990": 628,
    "1981-2010": 631,
    "1991-2020": 648
   },
   "seasons": {
    "djf": 154,
    "jja": 178,
    "mam": 136,
    "son": 179
   },
   "summer_half": 314,
   "winter_half": 333
  },
  "LS24": {
   "cells": 92,
   "mm": 635,
   "n": 417,
   "periods": {
    "1961-1990": 614,
    "1981-2010": 618,
    "1991-2020": 635
   },
   "seasons": {
    "djf": 150,
    "jja": 177,
    "mam": 132,
    "son": 176
   },
   "summer_half": 309,
   "winter_half": 326
  },
  "LS25": {
   "cells": 100,
   "mm": 643,
   "n": 1224,
   "periods": {
    "1961-1990": 627,
    "1981-2010": 630,
    "1991-2020": 643
   },
   "seasons": {
    "djf": 150,
    "jja": 181,
    "mam": 134,
    "son": 178
   },
   "summer_half": 315,
   "winter_half": 328
  },
  "LS26": {
   "cells": 46,
   "mm": 674,
   "n": 798,
   "periods": {
    "1961-1990": 660,
    "1981-2010": 668,
    "1991-2020": 674
   },
   "seasons": {
    "djf": 158,
    "jja": 189,
    "mam": 141,
    "son": 186
   },
   "summer_half": 331,
   "winter_half": 344
  },
  "LS27": {
   "cells": 24,
   "mm": 770,
   "n": 1113,
   "periods": {
    "1961-1990": 745,
    "1981-2010": 755,
    "1991-2020": 770
   },
   "seasons": {
    "djf": 199,
    "jja": 201,
    "mam": 160,
    "son": 210
   },
   "summer_half": 361,
   "winter_half": 409
  },
  "LS28": {
   "cells": 27,
   "mm": 825,
   "n": 1147,
   "periods": {
    "1961-1990": 791,
    "1981-2010": 806,
    "1991-2020": 825
   },
   "seasons": {
    "djf": 227,
    "jja": 202,
    "mam": 168,
    "son": 228
   },
   "summer_half": 371,
   "winter_half": 455
  },
  "LS29": {
   "cells": 70,
   "mm": 965,
   "n": 1242,
   "periods": {
    "1961-1990": 926,
    "1981-2010": 937,
    "1991-2020": 965
   },
   "seasons": {
    "djf": 273,
    "jja": 231,
    "mam": 186,
    "son": 275
   },
   "summer_half": 417,
   "winter_half": 548
  },
  "LS3": {
   "cells": 4,
   "mm": 666,
   "n": 120,
   "periods": {
    "1961-1990": 666,
    "1981-2010": 659,
    "1991-2020": 666
   },
   "seasons": {
    "djf": 172,
    "jja": 169,
    "mam": 137,
    "son": 188
   },
   "summer_half": 306,
   "winter_half": 360
  },
  "LS4": {
   "cells": 5,
   "mm": 671,
   "n": 208,
   "periods": {
    "1961-1990": 667,
    "1981-2010": 662,
    "1991-2020": 671
   },
   "seasons": {
    "djf": 174,
    "jja": 170,
    "mam": 139,
    "son": 189
   },
   "summer_half": 308,
   "winter_half": 363
  },
  "LS5": {
   "cells": 9,
   "mm": 702,
   "n": 212,
   "periods": {
    "1961-1990": 699,
    "1981-2010": 693,
    "1991-2020": 702
   },
   "seasons": {
    "djf": 182,
    "jja": 179,
    "mam": 144,
    "son": 197
   },
   "summer_half": 323,
   "winter_half": 379
  },
  "LS6": {
   "cells": 16,
   "mm": 709,
   "n": 885,
   "periods": {
    "1961-1990": 712,
    "1981-2010": 702,
    "1991-2020": 709
   },
   "seasons": {
    "djf": 182,
    "jja": 182,
    "mam": 145,
    "son": 200
   },
   "summer_half": 327,
   "winter_half": 382
  },
  "LS7": {
   "cells": 14,
   "mm": 703,
   "n": 688,
   "periods": {
    "1961-1990": 704,
    "1981-2010": 698,
    "1991-2020": 703
   },
   "seasons": {
    "djf": 179,
    "jja": 183,
    "mam": 144,
    "son": 197
   },
   "summer_half": 327,
   "winter_half": 377
  },
  "LS8": {
   "cells": 22,
   "mm": 708,
   "n": 936,
   "periods": {
    "1961-1990": 717,
    "1981-2010": 706,
    "1991-2020": 708
   },
   "seasons": {
    "djf": 179,
    "jja": 186,
    "mam": 146,
    "son": 198
   },
   "summer_half": 332,
   "winter_half": 377
  },
  "LS88": {
   "cells": 2,
   "mm": 670,
   "n": 32,
   "periods": {
    "1961-1990": 675,
    "1981-2010": 672,
    "1991-2020": 670
   },
   "seasons": {
    "djf": 166,
    "jja": 181,
    "mam": 139,
    "son": 184
   },
   "summer_half": 320,
   "winter_half": 350
  },
  "LS9": {
   "cells": 23,
   "mm": 669,
   "n": 902,
   "periods": {
    "1961-1990": 672,
    "1981-2010": 670,
    "1991-2020": 669
   },
   "seasons": {
    "djf": 164,
    "jja": 180,
    "mam": 139,
    "son": 186
   },
   "summer_half": 320,
   "winter_half": 350
  },
  "LS98": {
   "cells": 1,
   "mm": 679,
   "n": 1,
   "periods": {
    "1961-1990": 685,
    "1981-2010": 681,
    "1991-2020": 679
   },
   "seasons": {
    "djf": 170,
    "jja": 181,
    "mam": 141,
    "son": 186
   },
   "summer_half": 322,
   "winter_half": 356
  },
  "LS99": {
   "cells": 2,
   "mm": 670,
   "n": 3,
   "periods": {
    "1961-1990": 675,
    "1981-2010": 672,
    "1991-2020": 670
   },
   "seasons": {
    "djf": 166,
    "jja": 181,
    "mam": 139,
    "son": 184
   },
   "summer_half": 320,
   "winter_half": 350
  },
  "LU1": {
   "cells": 39,
   "mm": 715,
   "n": 952,
   "periods": {
    "1961-1990": 682,
    "1981-2010": 720,
    "1991-2020": 715
   },
   "seasons": {
    "djf": 187,
    "jja": 174,
    "mam": 148,
    "son": 207
   },
   "summer_half": 322,
   "winter_half": 394
  },
  "LU2": {
   "cells": 51,
   "mm": 685,
   "n": 999,
   "periods": {
    "1961-1990": 653,
    "1981-2010": 682,
    "1991-2020": 685
   },
   "seasons": {
    "djf": 178,
    "jja": 170,
    "mam": 143,
    "son": 195
   },
   "summer_half": 313,
   "winter_half": 372
  },
  "LU3": {
   "cells": 25,
   "mm": 654,
   "n": 839,
   "periods": {
    "1961-1990": 624,
    "1981-2010": 657,
    "1991-2020": 654
   },
   "seasons": {
    "djf": 167,
    "jja": 163,
    "mam": 139,
    "son": 186
   },
   "summer_half": 302,
   "winter_half": 352
  },
  "LU4": {
   "cells": 21,
   "mm": 662,
   "n": 733,
   "periods": {
    "1961-1990": 634,
    "1981-2010": 669,
    "1991-2020": 662
   },
   "seasons": {
    "djf": 168,
    "jja": 164,
    "mam": 139,
    "son": 191
   },
   "summer_half": 303,
   "winter_half": 359
  },
  "LU5": {
   "cells": 40,
   "mm": 654,
   "n": 830,
   "periods": {
    "1961-1990": 632,
    "1981-2010": 658,
    "1991-2020": 654
   },
   "seasons": {
    "djf": 164,
    "jja": 159,
    "mam": 139,
    "son": 192
   },
   "summer_half": 298,
   "winter_half": 355
  },
  "LU6": {
   "cells": 54,
   "mm": 721,
   "n": 712,
   "periods": {
    "1961-1990": 692,
    "1981-2010": 724,
    "1991-2020": 721
   },
   "seasons": {
    "djf": 187,
    "jja": 171,
    "mam": 151,
    "son": 212
   },
   "summer_half": 322,
   "winter_half": 399
  },
  "LU7": {
   "cells": 120,
   "mm": 670,
   "n": 1399,
   "periods": {
    "1961-1990": 654,
    "1981-2010": 667,
    "1991-2020": 670
   },
   "seasons": {
    "djf": 169,
    "jja": 164,
    "mam": 142,
    "son": 196
   },
   "summer_half": 306,
   "winter_half": 365
  },
  "M1": {
   "cells": 6,
   "mm": 901,
   "n": 548,
   "periods": {
    "1961-1990": 873,
    "1981-2010": 883,
    "1991-2020": 901
   },
   "seasons": {
    "djf": 240,
    "jja": 232,
    "mam": 175,
    "son": 254
   },
   "summer_half": 407,
   "winter_half": 495
  },
  "M11": {
   "cells": 13,
   "mm": 925,
   "n": 759,
   "periods": {
    "1961-1990": 890,
    "1981-2010": 906,
    "1991-2020": 925
   },
   "seasons": {
    "djf": 248,
    "jja": 238,
    "mam": 180,
    "son": 259
   },
   "summer_half": 418,
   "winter_half": 507
  },
  "M12": {
   "cells": 12,
   "mm": 899,
   "n": 504,
   "periods": {
    "1961-1990": 867,
    "1981-2010": 881,
    "1991-2020": 899
   },
   "seasons": {
    "djf": 239,
    "jja": 233,
    "mam": 175,
    "son": 251
   },
   "summer_half": 408,
   "winter_half": 490
  },
  "M13": {
   "cells": 10,
   "mm": 892,
   "n": 489,
   "periods": {
    "1961-1990": 862,
    "1981-2010": 876,
    "1991-2020": 892
   },
   "seasons": {
    "djf": 238,
    "jja": 231,
    "mam": 174,
    "son": 250
   },
   "summer_half": 405,
   "winter_half": 487
  },
  "M14": {
   "cells": 13,
   "mm": 867,
   "n": 1041,
   "periods": {
    "1961-1990": 842,
    "1981-2010": 854,
    "1991-2020": 867
   },
   "seasons": {
    "djf": 230,
    "jja": 226,
    "mam": 168,
    "son": 242
   },
   "summer_half": 395,
   "winter_half": 473
  },
  "M15": {
   "cells": 9,
   "mm": 877,
   "n": 631,
   "periods": {
    "1961-1990": 854,
    "1981-2010": 861,
    "1991-2020": 877
   },
   "seasons": {
    "djf": 233,
    "jja": 227,
    "mam": 169,
    "son": 248
   },
   "summer_half": 396,
   "winter_half": 480
  },
  "M16": {
   "cells": 10,
   "mm": 868,
   "n": 868,
   "periods": {
    "1961-1990": 849,
    "1981-2010": 852,
    "1991-2020": 868
   },
   "seasons": {
    "djf": 229,
    "jja": 225,
    "mam": 167,
    "son": 246
   },
   "summer_half": 392,
   "winter_half": 475
  },
  "M17": {
   "cells": 15,
   "mm": 874,
   "n": 162,
   "periods": {
    "1961-1990": 860,
    "1981-2010": 856,
    "1991-2020": 874
   },
   "seasons": {
    "djf": 235,
    "jja": 222,
    "mam": 167,
    "son": 250
   },
   "summer_half": 389,
   "winter_half": 485
  },
  "M18": {
   "cells": 9,
   "mm": 900,
   "n": 596,
   "periods": {
    "1961-1990": 869,
    "1981-2010": 881,
    "1991-2020": 900
   },
   "seasons": {
    "djf": 240,
    "jja": 234,
    "mam": 175,
    "son": 251
   },
   "summer_half": 409,
   "winter_half": 491
  },
  "M19": {
   "cells": 13,
   "mm": 883,
   "n": 807,
   "periods": {
    "1961-1990": 857,
    "1981-2010": 865,
    "1991-2020": 883
   },
   "seasons": {
    "djf": 233,
    "jja": 231,
    "mam": 171,
    "son": 248
   },
   "summer_half": 403,
   "winter_half": 480
  },
  "M2": {
   "cells": 3,
   "mm": 899,
   "n": 213,
   "periods": {
    "1961-1990": 872,
    "1981-2010": 881,
    "1991-2020": 899
   },
   "seasons": {
    "djf": 240,
    "jja": 231,
    "mam": 174,
    "son": 254
   },
   "summer_half": 405,
   "winter_half": 494
  },
  "M20": {
   "cells": 15,
   "mm": 848,
   "n": 1145,
   "periods": {
    "1961-1990": 829,
    "1981-2010": 832,
    "1991-2020": 848
   },
   "seasons": {
    "djf": 222,
    "jja": 223,
    "mam": 163,
    "son": 241
   },
   "summer_half": 386,
   "winter_half": 463
  },
  "M21": {
   "cells": 11,
   "mm": 875,
   "n": 726,
   "periods": {
    "1961-1990": 857,
    "1981-2010": 858,
    "1991-2020": 875
   },
   "seasons": {
    "djf": 228,
    "jja": 229,
    "mam": 169,
    "son": 249
   },
   "summer_half": 397,
   "winter_half": 478
  },
  "M22": {
   "cells": 16,
   "mm": 860,
   "n": 1211,
   "periods": {
    "1961-1990": 830,
    "1981-2010": 839,
    "1991-2020": 860
   },
   "seasons": {
    "djf": 224,
    "jja": 222,
    "mam": 163,
    "son": 250
   },
   "summer_half": 386,
   "winter_half": 474
  },
  "M23": {
   "cells": 17,
   "mm": 860,
   "n": 820,
   "periods": {
    "1961-1990": 833,
    "1981-2010": 839,
    "1991-2020": 860
   },
   "seasons": {
    "djf": 224,
    "jja": 221,
    "mam": 160,
    "son": 255
   },
   "summer_half": 381,
   "winter_half": 479
  },
  "M24": {
   "cells": 30,
   "mm": 1119,
   "n": 1268,
   "periods": {
    "1961-1990": 1059,
    "1981-2010": 1082,
    "1991-2020": 1119
   },
   "seasons": {
    "djf": 319,
    "jja": 268,
    "mam": 215,
    "son": 317
   },
   "summer_half": 483,
   "winter_half": 636
  },
  "M25": {
   "cells": 16,
   "mm": 1055,
   "n": 786,
   "periods": {
    "1961-1990": 1005,
    "1981-2010": 1025,
    "1991-2020": 1055
   },
   "seasons": {
    "djf": 294,
    "jja": 259,
    "mam": 204,
    "son": 299
   },
   "summer_half": 463,
   "winter_half": 593
  },
  "M26": {
   "cells": 26,
   "mm": 1079,
   "n": 863,
   "periods": {
    "1961-1990": 1045,
    "1981-2010": 1062,
    "1991-2020": 1079
   },
   "seasons": {
    "djf": 310,
    "jja": 258,
    "mam": 204,
    "son": 306
   },
   "summer_half": 463,
   "winter_half": 616
  },
  "M27": {
   "cells": 22,
   "mm": 995,
   "n": 1104,
   "periods": {
    "1961-1990": 962,
    "1981-2010": 977,
    "1991-2020": 995
   },
   "seasons": {
    "djf": 274,
    "jja": 248,
    "mam": 188,
    "son": 284
   },
   "summer_half": 436,
   "winter_half": 559
  },
  "M28": {
   "cells": 32,
   "mm": 983,
   "n": 1120,
   "periods": {
    "1961-1990": 954,
    "1981-2010": 965,
    "1991-2020": 983
   },
   "seasons": {
    "djf": 268,
    "jja": 247,
    "mam": 187,
    "son": 281
   },
   "summer_half": 434,
   "winter_half": 549
  },
  "M29": {
   "cells": 24,
   "mm": 936,
   "n": 568,
   "periods": {
    "1961-1990": 918,
    "1981-2010": 920,
    "1991-2020": 936
   },
   "seasons": {
    "djf": 253,
    "jja": 234,
    "mam": 182,
    "son": 268
   },
   "summer_half": 416,
   "winter_half": 521
  },
  "M3": {
   "cells": 8,
   "mm": 899,
   "n": 642,
   "periods": {
    "1961-1990": 872,
    "1981-2010": 880,
    "1991-2020": 899
   },
   "seasons": {
    "djf": 240,
    "jja": 230,
    "mam": 174,
    "son": 255
   },
   "summer_half": 404,
   "winter_half": 495
  },
  "M30": {
   "cells": 24,
   "mm": 903,
   "n": 954,
   "periods": {
    "1961-1990": 889,
    "1981-2010": 884,
    "1991-2020": 903
   },
   "seasons": {
    "djf": 244,
    "jja": 228,
    "mam": 172,
    "son": 259
   },
   "summer_half": 400,
   "winter_half": 503
  },
  "M31": {
   "cells": 13,
   "mm": 827,
   "n": 267,
   "periods": {
    "1961-1990": 819,
    "1981-2010": 807,
    "1991-2020": 827
   },
   "seasons": {
    "djf": 219,
    "jja": 211,
    "mam": 160,
    "son": 237
   },
   "summer_half": 371,
   "winter_half": 456
  },
  "M32": {
   "cells": 14,
   "mm": 865,
   "n": 680,
   "periods": {
    "1961-1990": 857,
    "1981-2010": 847,
    "1991-2020": 865
   },
   "seasons": {
    "djf": 229,
    "jja": 222,
    "mam": 165,
    "son": 248
   },
   "summer_half": 387,
   "winter_half": 478
  },
  "M33": {
   "cells": 19,
   "mm": 841,
   "n": 1558,
   "periods": {
    "1961-1990": 837,
    "1981-2010": 822,
    "1991-2020": 841
   },
   "seasons": {
    "djf": 221,
    "jja": 216,
    "mam": 159,
    "son": 245
   },
   "summer_half": 375,
   "winter_half": 466
  },
  "M34": {
   "cells": 21,
   "mm": 958,
   "n": 1284,
   "periods": {
    "1961-1990": 918,
    "1981-2010": 936,
    "1991-2020": 958
   },
   "seasons": {
    "djf": 261,
    "jja": 244,
    "mam": 184,
    "son": 269
   },
   "summer_half": 429,
   "winter_half": 530
  },
  "M35": {
   "cells": 12,
   "mm": 1014,
   "n": 530,
   "periods": {
    "1961-1990": 971,
    "1981-2010": 989,
    "1991-2020": 1014
   },
   "seasons": {
    "djf": 277,
    "jja": 255,
    "mam": 198,
    "son": 285
   },
   "summer_half": 453,
   "winter_half": 561
  },
  "M38": {
   "cells": 7,
   "mm": 1086,
   "n": 328,
   "periods": {
    "1961-1990": 1049,
    "1981-2010": 1064,
    "1991-2020": 1086
   },
   "seasons": {
    "djf": 302,
    "jja": 269,
    "mam": 205,
    "son": 310
   },
   "summer_half": 474,
   "winter_half": 612
  },
  "M4": {
   "cells": 6,
   "mm": 914,
   "n": 529,
   "periods": {
    "1961-1990": 883,
    "1981-2010": 895,
    "1991-2020": 914
   },
   "seasons": {
    "djf": 244,
    "jja": 234,
    "mam": 178,
    "son": 258
   },
   "summer_half": 412,
   "winter_half": 502
  },
  "M40": {
   "cells": 22,
   "mm": 982,
   "n": 1393,
   "periods": {
    "1961-1990": 942,
    "1981-2010": 958,
    "1991-2020": 982
   },
   "seasons": {
    "djf": 266,
    "jja": 248,
    "mam": 191,
    "son": 276
   },
   "summer_half": 439,
   "winter_half": 543
  },
  "M41": {
   "cells": 22,
   "mm": 857,
   "n": 1021,
   "periods": {
    "1961-1990": 853,
    "1981-2010": 838,
    "1991-2020": 857
   },
   "seasons": {
    "djf": 229,
    "jja": 218,
    "mam": 165,
    "son": 245
   },
   "summer_half": 382,
   "winter_half": 474
  },
  "M43": {
   "cells": 11,
   "mm": 965,
   "n": 624,
   "periods": {
    "1961-1990": 925,
    "1981-2010": 944,
    "1991-2020": 965
   },
   "seasons": {
    "djf": 262,
    "jja": 245,
    "mam": 187,
    "son": 271
   },
   "summer_half": 432,
   "winter_half": 532
  },
  "M44": {
   "cells": 19,
   "mm": 844,
   "n": 478,
   "periods": {
    "1961-1990": 828,
    "1981-2010": 825,
    "1991-2020": 844
   },
   "seasons": {
    "djf": 223,
    "jja": 216,
    "mam": 164,
    "son": 241
   },
   "summer_half": 380,
   "winter_half": 463
  },
  "M45": {
   "cells": 15,
   "mm": 1097,
   "n": 648,
   "periods": {
    "1961-1990": 1062,
    "1981-2010": 1077,
    "1991-2020": 1097
   },
   "seasons": {
    "djf": 311,
    "jja": 265,
    "mam": 211,
    "son": 310
   },
   "summer_half": 476,
   "winter_half": 621
  },
  "M46": {
   "cells": 13,
   "mm": 1029,
   "n": 576,
   "periods": {
    "1961-1990": 1004,
    "1981-2010": 1009,
    "1991-2020": 1029
   },
   "seasons": {
    "djf": 284,
    "jja": 251,
    "mam": 199,
    "son": 294
   },
   "summer_half": 450,
   "winter_half": 578
  },
  "M5": {
   "cells": 13,
   "mm": 897,
   "n": 640,
   "periods": {
    "1961-1990": 876,
    "1981-2010": 878,
    "1991-2020": 897
   },
   "seasons": {
    "djf": 242,
    "jja": 227,
    "mam": 172,
    "son": 257
   },
   "summer_half": 399,
   "winter_half": 498
  },
  "M50": {
   "cells": 9,
   "mm": 880,
   "n": 203,
   "periods": {
    "1961-1990": 862,
    "1981-2010": 861,
    "1991-2020": 880
   },
   "seasons": {
    "djf": 237,
    "jja": 223,
    "mam": 168,
    "son": 252
   },
   "summer_half": 391,
   "winter_half": 489
  },
  "M6": {
   "cells": 15,
   "mm": 925,
   "n": 834,
   "periods": {
    "1961-1990": 901,
    "1981-2010": 905,
    "1991-2020": 925
   },
   "seasons": {
    "djf": 251,
    "jja": 233,
    "mam": 177,
    "son": 265
   },
   "summer_half": 410,
   "winter_half": 516
  },
  "M60": {
   "cells": 7,
   "mm": 904,
   "n": 134,
   "periods": {
    "1961-1990": 874,
    "1981-2010": 885,
    "1991-2020": 904
   },
   "seasons": {
    "djf": 241,
    "jja": 232,
    "mam": 175,
    "son": 255
   },
   "summer_half": 407,
   "winter_half": 497
  },
  "M61": {
   "cells": 2,
   "mm": 908,
   "n": 88,
   "periods": {
    "1961-1990": 878,
    "1981-2010": 889,
    "1991-2020": 908
   },
   "seasons": {
    "djf": 242,
    "jja": 233,
    "mam": 176,
    "son": 256
   },
   "summer_half": 409,
   "winter_half": 499
  },
  "M7": {
   "cells": 14,
   "mm": 959,
   "n": 780,
   "periods": {
    "1961-1990": 921,
    "1981-2010": 936,
    "1991-2020": 959
   },
   "seasons": {
    "djf": 260,
    "jja": 241,
    "mam": 185,
    "son": 273
   },
   "summer_half": 427,
   "winter_half": 533
  },
  "M8": {
   "cells": 12,
   "mm": 971,
   "n": 804,
   "periods": {
    "1961-1990": 930,
    "1981-2010": 945,
    "1991-2020": 971
   },
   "seasons": {
    "djf": 263,
    "jja": 244,
    "mam": 188,
    "son": 275
   },
   "summer_half": 433,
   "winter_half": 538
  },
  "M9": {
   "cells": 17,
   "mm": 1034,
   "n": 1085,
   "periods": {
    "1961-1990": 988,
    "1981-2010": 1006,
    "1991-2020": 1034
   },
   "seasons": {
    "djf": 285,
    "jja": 256,
    "mam": 201,
    "son": 292
   },
   "summer_half": 457,
   "winter_half": 577
  },
  "M90": {
   "cells": 7,
   "mm": 851,
   "n": 82,
   "periods": {
    "1961-1990": 814,
    "1981-2010": 828,
    "1991-2020": 851
   },
   "seasons": {
    "djf": 221,
    "jja": 221,
    "mam": 164,
    "son": 245
   },
   "summer_half": 385,
   "winter_half": 466
  },
  "M99": {
   "cells": 3,
   "mm": 911,
   "n": 11,
   "periods": {
    "1961-1990": 881,
    "1981-2010": 891,
    "1991-2020": 911
   },
   "seasons": {
    "djf": 243,
    "jja": 234,
    "mam": 177,
    "son": 257
   },
   "summer_half": 410,
   "winter_half": 500
  },
  "ME1": {
   "cells": 27,
   "mm": 655,
   "n": 890,
   "periods": {
    "1961-1990": 635,
    "1981-2010": 645,
    "1991-2020": 655
   },
   "seasons": {
    "djf": 184,
    "jja": 140,
    "mam": 133,
    "son": 198
   },
   "summer_half": 273,
   "winter_half": 382
  },
  "ME10": {
   "cells": 24,
   "mm": 588,
   "n": 1184,
   "periods": {
    "1961-1990": 583,
    "1981-2010": 588,
    "1991-2020": 588
   },
   "seasons": {
    "djf": 161,
    "jja": 131,
    "mam": 117,
    "son": 179
   },
   "summer_half": 248,
   "winter_half": 340
  },
  "ME11": {
   "cells": 6,
   "mm": 536,
   "n": 104,
   "periods": {
    "1961-1990": 537,
    "1981-2010": 535,
    "1991-2020": 536
   },
   "seasons": {
    "djf": 132,
    "jja": 133,
    "mam": 113,
    "son": 159
   },
   "summer_half": 246,
   "winter_half": 290
  },
  "ME12": {
   "cells": 48,
   "mm": 538,
   "n": 945,
   "periods": {
    "1961-1990": 547,
    "1981-2010": 537,
    "1991-2020": 538
   },
   "seasons": {
    "djf": 132,
    "jja": 132,
    "mam": 111,
    "son": 163
   },
   "summer_half": 243,
   "winter_half": 295
  },
  "ME13": {
   "cells": 125,
   "mm": 712,
   "n": 1063,
   "periods": {
    "1961-1990": 695,
    "1981-2010": 700,
    "1991-2020": 712
   },
   "seasons": {
    "djf": 198,
    "jja": 156,
    "mam": 140,
    "son": 217
   },
   "summer_half": 296,
   "winter_half": 415
  },
  "ME14": {
   "cells": 51,
   "mm": 711,
   "n": 1073,
   "periods": {
    "1961-1990": 703,
    "1981-2010": 702,
    "1991-2020": 711
   },
   "seasons": {
    "djf": 199,
    "jja": 152,
    "mam": 143,
    "son": 216
   },
   "summer_half": 295,
   "winter_half": 415
  },
  "ME15": {
   "cells": 51,
   "mm": 685,
   "n": 1385,
   "periods": {
    "1961-1990": 669,
    "1981-2010": 676,
    "1991-2020": 685
   },
   "seasons": {
    "djf": 191,
    "jja": 148,
    "mam": 135,
    "son": 212
   },
   "summer_half": 283,
   "winter_half": 402
  },
  "ME16": {
   "cells": 21,
   "mm": 680,
   "n": 795,
   "periods": {
    "1961-1990": 657,
    "1981-2010": 664,
    "1991-2020": 680
   },
   "seasons": {
    "djf": 191,
    "jja": 146,
    "mam": 137,
    "son": 206
   },
   "summer_half": 283,
   "winter_half": 398
  },
  "ME17": {
   "cells": 133,
   "mm": 731,
   "n": 1104,
   "periods": {
    "1961-1990": 715,
    "1981-2010": 723,
    "1991-2020": 731
   },
   "seasons": {
    "djf": 206,
    "jja": 158,
    "mam": 144,
    "son": 222
   },
   "summer_half": 302,
   "winter_half": 428
  },
  "ME18": {
   "cells": 39,
   "mm": 689,
   "n": 315,
   "periods": {
    "1961-1990": 666,
    "1981-2010": 678,
    "1991-2020": 689
   },
   "seasons": {
    "djf": 196,
    "jja": 146,
    "mam": 137,
    "son": 210
   },
   "summer_half": 283,
   "winter_half": 406
  },
  "ME19": {
   "cells": 51,
   "mm": 712,
   "n": 788,
   "periods": {
    "1961-1990": 692,
    "1981-2010": 697,
    "1991-2020": 712
   },
   "seasons": {
    "djf": 203,
    "jja": 153,
    "mam": 141,
    "son": 216
   },
   "summer_half": 294,
   "winter_half": 418
  },
  "ME2": {
   "cells": 36,
   "mm": 641,
   "n": 950,
   "periods": {
    "1961-1990": 628,
    "1981-2010": 633,
    "1991-2020": 641
   },
   "seasons": {
    "djf": 176,
    "jja": 140,
    "mam": 129,
    "son": 196
   },
   "summer_half": 269,
   "winter_half": 372
  },
  "ME20": {
   "cells": 26,
   "mm": 669,
   "n": 580,
   "periods": {
    "1961-1990": 647,
    "1981-2010": 652,
    "1991-2020": 669
   },
   "seasons": {
    "djf": 188,
    "jja": 143,
    "mam": 136,
    "son": 201
   },
   "summer_half": 279,
   "winter_half": 389
  },
  "ME3": {
   "cells": 86,
   "mm": 563,
   "n": 864,
   "periods": {
    "1961-1990": 558,
    "1981-2010": 555,
    "1991-2020": 563
   },
   "seasons": {
    "djf": 141,
    "jja": 134,
    "mam": 113,
    "son": 174
   },
   "summer_half": 247,
   "winter_half": 316
  },
  "ME4": {
   "cells": 16,
   "mm": 640,
   "n": 796,
   "periods": {
    "1961-1990": 621,
    "1981-2010": 629,
    "1991-2020": 640
   },
   "seasons": {
    "djf": 176,
    "jja": 141,
    "mam": 130,
    "son": 193
   },
   "summer_half": 271,
   "winter_half": 369
  },
  "ME5": {
   "cells": 29,
   "mm": 706,
   "n": 1001,
   "periods": {
    "1961-1990": 691,
    "1981-2010": 696,
    "1991-2020": 706
   },
   "seasons": {
    "djf": 195,
    "jja": 154,
    "mam": 143,
    "son": 214
   },
   "summer_half": 297,
   "winter_half": 409
  },
  "ME6": {
   "cells": 9,
   "mm": 681,
   "n": 312,
   "periods": {
    "1961-1990": 668,
    "1981-2010": 671,
    "1991-2020": 681
   },
   "seasons": {
    "djf": 195,
    "jja": 143,
    "mam": 137,
    "son": 207
   },
   "summer_half": 279,
   "winter_half": 402
  },
  "ME7": {
   "cells": 29,
   "mm": 661,
   "n": 1028,
   "periods": {
    "1961-1990": 643,
    "1981-2010": 649,
    "1991-2020": 661
   },
   "seasons": {
    "djf": 181,
    "jja": 148,
    "mam": 134,
    "son": 198
   },
   "summer_half": 282,
   "winter_half": 379
  },
  "ME8": {
   "cells": 24,
   "mm": 638,
   "n": 1151,
   "periods": {
    "1961-1990": 619,
    "1981-2010": 626,
    "1991-2020": 638
   },
   "seasons": {
    "djf": 175,
    "jja": 140,
    "mam": 131,
    "son": 192
   },
   "summer_half": 271,
   "winter_half": 367
  },
  "ME9": {
   "cells": 149,
   "mm": 658,
   "n": 877,
   "periods": {
    "1961-1990": 649,
    "1981-2010": 652,
    "1991-2020": 658
   },
   "seasons": {
    "djf": 184,
    "jja": 145,
    "mam": 132,
    "son": 198
   },
   "summer_half": 277,
   "winter_half": 382
  },
  "MK1": {
   "cells": 6,
   "mm": 611,
   "n": 107,
   "periods": {
    "1961-1990": 591,
    "1981-2010": 606,
    "1991-2020": 611
   },
   "seasons": {
    "djf": 154,
    "jja": 156,
    "mam": 129,
    "son": 172
   },
   "summer_half": 285,
   "winter_half": 326
  },
  "MK10": {
   "cells": 15,
   "mm": 640,
   "n": 630,
   "periods": {
    "1961-1990": 621,
    "1981-2010": 637,
    "1991-2020": 640
   },
   "seasons": {
    "djf": 158,
    "jja": 153,
    "mam": 138,
    "son": 190
   },
   "summer_half": 291,
   "winter_half": 348
  },
  "MK11": {
   "cells": 9,
   "mm": 648,
   "n": 284,
   "periods": {
    "1961-1990": 612,
    "1981-2010": 639,
    "1991-2020": 648
   },
   "seasons": {
    "djf": 166,
    "jja": 166,
    "mam": 141,
    "son": 175
   },
   "summer_half": 307,
   "winter_half": 341
  },
  "MK12": {
   "cells": 11,
   "mm": 648,
   "n": 297,
   "periods": {
    "1961-1990": 611,
    "1981-2010": 639,
    "1991-2020": 648
   },
   "seasons": {
    "djf": 164,
    "jja": 167,
    "mam": 144,
    "son": 172
   },
   "summer_half": 312,
   "winter_half": 336
  },
  "MK13": {
   "cells": 12,
   "mm": 652,
   "n": 496,
   "periods": {
    "1961-1990": 616,
    "1981-2010": 644,
    "1991-2020": 652
   },
   "seasons": {
    "djf": 164,
    "jja": 173,
    "mam": 144,
    "son": 170
   },
   "summer_half": 317,
   "winter_half": 335
  },
  "MK14": {
   "cells": 15,
   "mm": 645,
   "n": 475,
   "periods": {
    "1961-1990": 608,
    "1981-2010": 638,
    "1991-2020": 645
   },
   "seasons": {
    "djf": 165,
    "jja": 167,
    "mam": 141,
    "son": 172
   },
   "summer_half": 308,
   "winter_half": 338
  },
  "MK15": {
   "cells": 12,
   "mm": 623,
   "n": 215,
   "periods": {
    "1961-1990": 597,
    "1981-2010": 618,
    "1991-2020": 623
   },
   "seasons": {
    "djf": 159,
    "jja": 153,
    "mam": 137,
    "son": 174
   },
   "summer_half": 290,
   "winter_half": 333
  },
  "MK16": {
   "cells": 66,
   "mm": 646,
   "n": 575,
   "periods": {
    "1961-1990": 608,
    "1981-2010": 639,
    "1991-2020": 646
   },
   "seasons": {
    "djf": 161,
    "jja": 160,
    "mam": 141,
    "son": 184
   },
   "summer_half": 301,
   "winter_half": 345
  },
  "MK17": {
   "cells": 142,
   "mm": 670,
   "n": 908,
   "periods": {
    "1961-1990": 644,
    "1981-2010": 665,
    "1991-2020": 670
   },
   "seasons": {
    "djf": 167,
    "jja": 166,
    "mam": 143,
    "son": 195
   },
   "summer_half": 309,
   "winter_half": 362
  },
  "MK18": {
   "cells": 179,
   "mm": 688,
   "n": 1266,
   "periods": {
    "1961-1990": 648,
    "1981-2010": 674,
    "1991-2020": 688
   },
   "seasons": {
    "djf": 175,
    "jja": 169,
    "mam": 149,
    "son": 195
   },
   "summer_half": 317,
   "winter_half": 371
  },
  "MK19": {
   "cells": 58,
   "mm": 662,
   "n": 349,
   "periods": {
    "1961-1990": 616,
    "1981-2010": 652,
    "1991-2020": 662
   },
   "seasons": {
    "djf": 167,
    "jja": 165,
    "mam": 144,
    "son": 185
   },
   "summer_half": 309,
   "winter_half": 353
  },
  "MK2": {
   "cells": 9,
   "mm": 619,
   "n": 384,
   "periods": {
    "1961-1990": 597,
    "1981-2010": 613,
    "1991-2020": 619
   },
   "seasons": {
    "djf": 156,
    "jja": 156,
    "mam": 131,
    "son": 176
   },
   "summer_half": 288,
   "winter_half": 332
  },
  "MK20": {
   "cells": 1,
   "mm": 632,
   "n": 6,
   "periods": {
    "1961-1990": 595,
    "1981-2010": 626,
    "1991-2020": 632
   },
   "seasons": {
    "djf": 162,
    "jja": 157,
    "mam": 136,
    "son": 177
   },
   "summer_half": 293,
   "winter_half": 339
  },
  "MK3": {
   "cells": 17,
   "mm": 647,
   "n": 656,
   "periods": {
    "1961-1990": 617,
    "1981-2010": 639,
    "1991-2020": 647
   },
   "seasons": {
    "djf": 160,
    "jja": 163,
    "mam": 139,
    "son": 186
   },
   "summer_half": 302,
   "winter_half": 345
  },
  "MK4": {
   "cells": 17,
   "mm": 678,
   "n": 624,
   "periods": {
    "1961-1990": 641,
    "1981-2010": 668,
    "1991-2020": 678
   },
   "seasons": {
    "djf": 168,
    "jja": 171,
    "mam": 146,
    "son": 193
   },
   "summer_half": 317,
   "winter_half": 361
  },
  "MK40": {
   "cells": 15,
   "mm": 566,
   "n": 927,
   "periods": {
    "1961-1990": 541,
    "1981-2010": 569,
    "1991-2020": 566
   },
   "seasons": {
    "djf": 135,
    "jja": 147,
    "mam": 120,
    "son": 165
   },
   "summer_half": 266,
   "winter_half": 300
  },
  "MK41": {
   "cells": 39,
   "mm": 585,
   "n": 1056,
   "periods": {
    "1961-1990": 557,
    "1981-2010": 590,
    "1991-2020": 585
   },
   "seasons": {
    "djf": 137,
    "jja": 155,
    "mam": 122,
    "son": 171
   },
   "summer_half": 277,
   "winter_half": 308
  },
  "MK42": {
   "cells": 31,
   "mm": 565,
   "n": 1284,
   "periods": {
    "1961-1990": 547,
    "1981-2010": 569,
    "1991-2020": 565
   },
   "seasons": {
    "djf": 134,
    "jja": 147,
    "mam": 120,
    "son": 164
   },
   "summer_half": 267,
   "winter_half": 298
  },
  "MK43": {
   "cells": 150,
   "mm": 615,
   "n": 1128,
   "periods": {
    "1961-1990": 587,
    "1981-2010": 612,
    "1991-2020": 615
   },
   "seasons": {
    "djf": 151,
    "jja": 156,
    "mam": 130,
    "son": 178
   },
   "summer_half": 285,
   "winter_half": 330
  },
  "MK44": {
   "cells": 178,
   "mm": 611,
   "n": 672,
   "periods": {
    "1961-1990": 573,
    "1981-2010": 606,
    "1991-2020": 611
   },
   "seasons": {
    "djf": 148,
    "jja": 161,
    "mam": 127,
    "son": 175
   },
   "summer_half": 289,
   "winter_half": 323
  },
  "MK45": {
   "cells": 116,
   "mm": 605,
   "n": 1311,
   "periods": {
    "1961-1990": 580,
    "1981-2010": 607,
    "1991-2020": 605
   },
   "seasons": {
    "djf": 148,
    "jja": 152,
    "mam": 128,
    "son": 176
   },
   "summer_half": 280,
   "winter_half": 325
  },
  "MK46": {
   "cells": 37,
   "mm": 640,
   "n": 305,
   "periods": {
    "1961-1990": 612,
    "1981-2010": 631,
    "1991-2020": 640
   },
   "seasons": {
    "djf": 161,
    "jja": 157,
    "mam": 137,
    "son": 185
   },
   "summer_half": 294,
   "winter_half": 346
  },
  "MK5": {
   "cells": 14,
   "mm": 660,
   "n": 422,
   "periods": {
    "1961-1990": 627,
    "1981-2010": 653,
    "1991-2020": 660
   },
   "seasons": {
    "djf": 165,
    "jja": 168,
    "mam": 143,
    "son": 184
   },
   "summer_half": 311,
   "winter_half": 349
  },
  "MK6": {
   "cells": 18,
   "mm": 635,
   "n": 613,
   "periods": {
    "1961-1990": 614,
    "1981-2010": 630,
    "1991-2020": 635
   },
   "seasons": {
    "djf": 159,
    "jja": 159,
    "mam": 137,
    "son": 180
   },
   "summer_half": 296,
   "winter_half": 339
  },
  "MK7": {
   "cells": 12,
   "mm": 633,
   "n": 393,
   "periods": {
    "1961-1990": 618,
    "1981-2010": 630,
    "1991-2020": 633
   },
   "seasons": {
    "djf": 159,
    "jja": 157,
    "mam": 134,
    "son": 183
   },
   "summer_half": 291,
   "winter_half": 342
  },
  "MK77": {
   "cells": 2,
   "mm": 635,
   "n": 64,
   "periods": {
    "1961-1990": 609,
    "1981-2010": 628,
    "1991-2020": 635
   },
   "seasons": {
    "djf": 162,
    "jja": 163,
    "mam": 137,
    "son": 173
   },
   "summer_half": 299,
   "winter_half": 336
  },
  "MK8": {
   "cells": 13,
   "mm": 659,
   "n": 501,
   "periods": {
    "1961-1990": 624,
    "1981-2010": 651,
    "1991-2020": 659
   },
   "seasons": {
    "djf": 166,
    "jja": 171,
    "mam": 145,
    "son": 178
   },
   "summer_half": 316,
   "winter_half": 343
  },
  "MK9": {
   "cells": 9,
   "mm": 656,
   "n": 262,
   "periods": {
    "1961-1990": 628,
    "1981-2010": 649,
    "1991-2020": 656
   },
   "seasons": {
    "djf": 166,
    "jja": 169,
    "mam": 143,
    "son": 178
   },
   "summer_half": 312,
   "winter_half": 344
  },
  "ML1": {
   "cells": 53,
   "mm": 1106,
   "n": 1437,
   "periods": {
    "1961-1990": 990,
    "1981-2010": 1082,
    "1991-2020": 1106
   },
   "seasons": {
    "djf": 330,
    "jja": 263,
    "mam": 203,
    "son": 311
   },
   "summer_half": 466,
   "winter_half": 641
  },
  "ML10": {
   "cells": 62,
   "mm": 1349,
   "n": 350,
   "periods": {
    "1961-1990": 1207,
    "1981-2010": 1315,
    "1991-2020": 1349
   },
   "seasons": {
    "djf": 429,
    "jja": 286,
    "mam": 250,
    "son": 383
   },
   "summer_half": 537,
   "winter_half": 812
  },
  "ML11": {
   "cells": 199,
   "mm": 1092,
   "n": 1090,
   "periods": {
    "1961-1990": 964,
    "1981-2010": 1057,
    "1991-2020": 1092
   },
   "seasons": {
    "djf": 334,
    "jja": 252,
    "mam": 202,
    "son": 304
   },
   "summer_half": 454,
   "winter_half": 638
  },
  "ML12": {
   "cells": 128,
   "mm": 1195,
   "n": 351,
   "periods": {
    "1961-1990": 1070,
    "1981-2010": 1163,
    "1991-2020": 1195
   },
   "seasons": {
    "djf": 364,
    "jja": 270,
    "mam": 225,
    "son": 336
   },
   "summer_half": 495,
   "winter_half": 700
  },
  "ML2": {
   "cells": 40,
   "mm": 1077,
   "n": 888,
   "periods": {
    "1961-1990": 967,
    "1981-2010": 1054,
    "1991-2020": 1077
   },
   "seasons": {
    "djf": 318,
    "jja": 260,
    "mam": 196,
    "son": 304
   },
   "summer_half": 456,
   "winter_half": 621
  },
  "ML3": {
   "cells": 43,
   "mm": 1096,
   "n": 1319,
   "periods": {
    "1961-1990": 981,
    "1981-2010": 1073,
    "1991-2020": 1096
   },
   "seasons": {
    "djf": 345,
    "jja": 242,
    "mam": 200,
    "son": 309
   },
   "summer_half": 442,
   "winter_half": 654
  },
  "ML4": {
   "cells": 16,
   "mm": 1038,
   "n": 573,
   "periods": {
    "1961-1990": 928,
    "1981-2010": 1015,
    "1991-2020": 1038
   },
   "seasons": {
    "djf": 314,
    "jja": 245,
    "mam": 190,
    "son": 289
   },
   "summer_half": 435,
   "winter_half": 603
  },
  "ML5": {
   "cells": 33,
   "mm": 1033,
   "n": 1016,
   "periods": {
    "1961-1990": 939,
    "1981-2010": 1023,
    "1991-2020": 1033
   },
   "seasons": {
    "djf": 306,
    "jja": 248,
    "mam": 192,
    "son": 288
   },
   "summer_half": 439,
   "winter_half": 594
  },
  "ML6": {
   "cells": 68,
   "mm": 1134,
   "n": 1212,
   "periods": {
    "1961-1990": 1023,
    "1981-2010": 1118,
    "1991-2020": 1134
   },
   "seasons": {
    "djf": 326,
    "jja": 278,
    "mam": 213,
    "son": 318
   },
   "summer_half": 491,
   "winter_half": 644
  },
  "ML7": {
   "cells": 39,
   "mm": 1186,
   "n": 414,
   "periods": {
    "1961-1990": 1089,
    "1981-2010": 1184,
    "1991-2020": 1186
   },
   "seasons": {
    "djf": 342,
    "jja": 289,
    "mam": 225,
    "son": 330
   },
   "summer_half": 514,
   "winter_half": 672
  },
  "ML8": {
   "cells": 50,
   "mm": 1003,
   "n": 527,
   "periods": {
    "1961-1990": 889,
    "1981-2010": 968,
    "1991-2020": 1003
   },
   "seasons": {
    "djf": 301,
    "jja": 239,
    "mam": 185,
    "son": 277
   },
   "summer_half": 424,
   "winter_half": 579
  },
  "ML9": {
   "cells": 43,
   "mm": 1043,
   "n": 694,
   "periods": {
    "1961-1990": 929,
    "1981-2010": 1014,
    "1991-2020": 1043
   },
   "seasons": {
    "djf": 322,
    "jja": 236,
    "mam": 189,
    "son": 295
   },
   "summer_half": 426,
   "winter_half": 617
  },
  "N1": {
   "cells": 15,
   "mm": 625,
   "n": 2287,
   "periods": {
    "1961-1990": 610,
    "1981-2010": 614,
    "1991-2020": 625
   },
   "seasons": {
    "djf": 162,
    "jja": 157,
    "mam": 124,
    "son": 183
   },
   "summer_half": 281,
   "winter_half": 345
  },
  "N10": {
   "cells": 9,
   "mm": 724,
   "n": 509,
   "periods": {
    "1961-1990": 696,
    "1981-2010": 717,
    "1991-2020": 724
   },
   "seasons": {
    "djf": 191,
    "jja": 177,
    "mam": 144,
    "son": 211
   },
   "summer_half": 321,
   "winter_half": 403
  },
  "N11": {
   "cells": 13,
   "mm": 708,
   "n": 612,
   "periods": {
    "1961-1990": 686,
    "1981-2010": 702,
    "1991-2020": 708
   },
   "seasons": {
    "djf": 189,
    "jja": 176,
    "mam": 139,
    "son": 204
   },
   "summer_half": 315,
   "winter_half": 393
  },
  "N12": {
   "cells": 11,
   "mm": 725,
   "n": 698,
   "periods": {
    "1961-1990": 703,
    "1981-2010": 719,
    "1991-2020": 725
   },
   "seasons": {
    "djf": 196,
    "jja": 174,
    "mam": 143,
    "son": 212
   },
   "summer_half": 317,
   "winter_half": 408
  },
  "N13": {
   "cells": 9,
   "mm": 671,
   "n": 529,
   "periods": {
    "1961-1990": 654,
    "1981-2010": 666,
    "1991-2020": 671
   },
   "seasons": {
    "djf": 178,
    "jja": 165,
    "mam": 135,
    "son": 193
   },
   "summer_half": 300,
   "winter_half": 372
  },
  "N14": {
   "cells": 12,
   "mm": 700,
   "n": 691,
   "periods": {
    "1961-1990": 675,
    "1981-2010": 693,
    "1991-2020": 700
   },
   "seasons": {
    "djf": 189,
    "jja": 175,
    "mam": 136,
    "son": 200
   },
   "summer_half": 311,
   "winter_half": 389
  },
  "N15": {
   "cells": 10,
   "mm": 635,
   "n": 713,
   "periods": {
    "1961-1990": 628,
    "1981-2010": 631,
    "1991-2020": 635
   },
   "seasons": {
    "djf": 165,
    "jja": 159,
    "mam": 128,
    "son": 184
   },
   "summer_half": 286,
   "winter_half": 349
  },
  "N16": {
   "cells": 12,
   "mm": 620,
   "n": 1124,
   "periods": {
    "1961-1990": 615,
    "1981-2010": 613,
    "1991-2020": 620
   },
   "seasons": {
    "djf": 160,
    "jja": 156,
    "mam": 125,
    "son": 179
   },
   "summer_half": 281,
   "winter_half": 339
  },
  "N17": {
   "cells": 14,
   "mm": 624,
   "n": 1135,
   "periods": {
    "1961-1990": 620,
    "1981-2010": 622,
    "1991-2020": 624
   },
   "seasons": {
    "djf": 163,
    "jja": 155,
    "mam": 125,
    "son": 181
   },
   "summer_half": 280,
   "winter_half": 344
  },
  "N18": {
   "cells": 13,
   "mm": 628,
   "n": 548,
   "periods": {
    "1961-1990": 616,
    "1981-2010": 625,
    "1991-2020": 628
   },
   "seasons": {
    "djf": 165,
    "jja": 153,
    "mam": 127,
    "son": 182
   },
   "summer_half": 280,
   "winter_half": 347
  },
  "N19": {
   "cells": 7,
   "mm": 691,
   "n": 639,
   "periods": {
    "1961-1990": 662,
    "1981-2010": 678,
    "1991-2020": 691
   },
   "seasons": {
    "djf": 181,
    "jja": 169,
    "mam": 136,
    "son": 205
   },
   "summer_half": 305,
   "winter_half": 386
  },
  "N1C": {
   "cells": 5,
   "mm": 635,
   "n": 82,
   "periods": {
    "1961-1990": 616,
    "1981-2010": 621,
    "1991-2020": 635
   },
   "seasons": {
    "djf": 166,
    "jja": 157,
    "mam": 123,
    "son": 188
   },
   "summer_half": 281,
   "winter_half": 354
  },
  "N1P": {
   "cells": 1,
   "mm": 645,
   "n": 655,
   "periods": {
    "1961-1990": 626,
    "1981-2010": 632,
    "1991-2020": 645
   },
   "seasons": {
    "djf": 169,
    "jja": 162,
    "mam": 128,
    "son": 187
   },
   "summer_half": 289,
   "winter_half": 356
  },
  "N2": {
   "cells": 9,
   "mm": 730,
   "n": 544,
   "periods": {
    "1961-1990": 699,
    "1981-2010": 720,
    "1991-2020": 730
   },
   "seasons": {
    "djf": 193,
    "jja": 176,
    "mam": 144,
    "son": 216
   },
   "summer_half": 321,
   "winter_half": 409
  },
  "N20": {
   "cells": 14,
   "mm": 734,
   "n": 535,
   "periods": {
    "1961-1990": 717,
    "1981-2010": 728,
    "1991-2020": 734
   },
   "seasons": {
    "djf": 201,
    "jja": 178,
    "mam": 143,
    "son": 212
   },
   "summer_half": 321,
   "winter_half": 413
  },
  "N21": {
   "cells": 11,
   "mm": 671,
   "n": 557,
   "periods": {
    "1961-1990": 649,
    "1981-2010": 664,
    "1991-2020": 671
   },
   "seasons": {
    "djf": 181,
    "jja": 166,
    "mam": 131,
    "son": 192
   },
   "summer_half": 298,
   "winter_half": 373
  },
  "N22": {
   "cells": 13,
   "mm": 670,
   "n": 718,
   "periods": {
    "1961-1990": 654,
    "1981-2010": 666,
    "1991-2020": 670
   },
   "seasons": {
    "djf": 175,
    "jja": 165,
    "mam": 136,
    "son": 194
   },
   "summer_half": 301,
   "winter_half": 369
  },
  "N3": {
   "cells": 9,
   "mm": 716,
   "n": 630,
   "periods": {
    "1961-1990": 694,
    "1981-2010": 709,
    "1991-2020": 716
   },
   "seasons": {
    "djf": 192,
    "jja": 172,
    "mam": 141,
    "son": 211
   },
   "summer_half": 313,
   "winter_half": 403
  },
  "N4": {
   "cells": 10,
   "mm": 652,
   "n": 872,
   "periods": {
    "1961-1990": 634,
    "1981-2010": 643,
    "1991-2020": 652
   },
   "seasons": {
    "djf": 168,
    "jja": 163,
    "mam": 132,
    "son": 190
   },
   "summer_half": 295,
   "winter_half": 358
  },
  "N5": {
   "cells": 6,
   "mm": 628,
   "n": 415,
   "periods": {
    "1961-1990": 613,
    "1981-2010": 616,
    "1991-2020": 628
   },
   "seasons": {
    "djf": 161,
    "jja": 158,
    "mam": 126,
    "son": 183
   },
   "summer_half": 284,
   "winter_half": 344
  },
  "N6": {
   "cells": 10,
   "mm": 721,
   "n": 495,
   "periods": {
    "1961-1990": 688,
    "1981-2010": 710,
    "1991-2020": 721
   },
   "seasons": {
    "djf": 190,
    "jja": 175,
    "mam": 143,
    "son": 213
   },
   "summer_half": 318,
   "winter_half": 403
  },
  "N7": {
   "cells": 9,
   "mm": 646,
   "n": 900,
   "periods": {
    "1961-1990": 624,
    "1981-2010": 633,
    "1991-2020": 646
   },
   "seasons": {
    "djf": 168,
    "jja": 159,
    "mam": 127,
    "son": 192
   },
   "summer_half": 286,
   "winter_half": 360
  },
  "N8": {
   "cells": 9,
   "mm": 685,
   "n": 698,
   "periods": {
    "1961-1990": 664,
    "1981-2010": 679,
    "1991-2020": 685
   },
   "seasons": {
    "djf": 179,
    "jja": 168,
    "mam": 138,
    "son": 200
   },
   "summer_half": 306,
   "winter_half": 379
  },
  "N81": {
   "cells": 2,
   "mm": 631,
   "n": 3,
   "periods": {
    "1961-1990": 618,
    "1981-2010": 625,
    "1991-2020": 631
   },
   "seasons": {
    "djf": 163,
    "jja": 156,
    "mam": 128,
    "son": 184
   },
   "summer_half": 284,
   "winter_half": 347
  },
  "N9": {
   "cells": 13,
   "mm": 633,
   "n": 878,
   "periods": {
    "1961-1990": 617,
    "1981-2010": 629,
    "1991-2020": 633
   },
   "seasons": {
    "djf": 169,
    "jja": 152,
    "mam": 128,
    "son": 184
   },
   "summer_half": 280,
   "winter_half": 353
  },
  "NE1": {
   "cells": 7,
   "mm": 666,
   "n": 536,
   "periods": {
    "1961-1990": 632,
    "1981-2010": 641,
    "1991-2020": 666
   },
   "seasons": {
    "djf": 145,
    "jja": 191,
    "mam": 134,
    "son": 195
   },
   "summer_half": 325,
   "winter_half": 340
  },
  "NE10": {
   "cells": 25,
   "mm": 669,
   "n": 744,
   "periods": {
    "1961-1990": 628,
    "1981-2010": 642,
    "1991-2020": 669
   },
   "seasons": {
    "djf": 147,
    "jja": 188,
    "mam": 136,
    "son": 199
   },
   "summer_half": 323,
   "winter_half": 345
  },
  "NE11": {
   "cells": 27,
   "mm": 677,
   "n": 480,
   "periods": {
    "1961-1990": 630,
    "1981-2010": 647,
    "1991-2020": 677
   },
   "seasons": {
    "djf": 153,
    "jja": 189,
    "mam": 140,
    "son": 195
   },
   "summer_half": 329,
   "winter_half": 348
  },
  "NE12": {
   "cells": 22,
   "mm": 685,
   "n": 857,
   "periods": {
    "1961-1990": 655,
    "1981-2010": 664,
    "1991-2020": 685
   },
   "seasons": {
    "djf": 151,
    "jja": 198,
    "mam": 137,
    "son": 199
   },
   "summer_half": 335,
   "winter_half": 351
  },
  "NE13": {
   "cells": 39,
   "mm": 689,
   "n": 481,
   "periods": {
    "1961-1990": 656,
    "1981-2010": 672,
    "1991-2020": 689
   },
   "seasons": {
    "djf": 152,
    "jja": 199,
    "mam": 136,
    "son": 202
   },
   "summer_half": 335,
   "winter_half": 353
  },
  "NE15": {
   "cells": 52,
   "mm": 677,
   "n": 912,
   "periods": {
    "1961-1990": 645,
    "1981-2010": 654,
    "1991-2020": 677
   },
   "seasons": {
    "djf": 150,
    "jja": 198,
    "mam": 138,
    "son": 191
   },
   "summer_half": 336,
   "winter_half": 341
  },
  "NE16": {
   "cells": 41,
   "mm": 744,
   "n": 756,
   "periods": {
    "1961-1990": 694,
    "1981-2010": 713,
    "1991-2020": 744
   },
   "seasons": {
    "djf": 171,
    "jja": 209,
    "mam": 155,
    "son": 209
   },
   "summer_half": 364,
   "winter_half": 380
  },
  "NE17": {
   "cells": 14,
   "mm": 729,
   "n": 168,
   "periods": {
    "1961-1990": 698,
    "1981-2010": 703,
    "1991-2020": 729
   },
   "seasons": {
    "djf": 172,
    "jja": 201,
    "mam": 153,
    "son": 203
   },
   "summer_half": 355,
   "winter_half": 375
  },
  "NE18": {
   "cells": 31,
   "mm": 749,
   "n": 70,
   "periods": {
    "1961-1990": 713,
    "1981-2010": 722,
    "1991-2020": 749
   },
   "seasons": {
    "djf": 172,
    "jja": 214,
    "mam": 152,
    "son": 212
   },
   "summer_half": 366,
   "winter_half": 383
  },
  "NE19": {
   "cells": 131,
   "mm": 912,
   "n": 216,
   "periods": {
    "1961-1990": 842,
    "1981-2010": 884,
    "1991-2020": 912
   },
   "seasons": {
    "djf": 247,
    "jja": 230,
    "mam": 180,
    "son": 254
   },
   "summer_half": 411,
   "winter_half": 501
  },
  "NE2": {
   "cells": 13,
   "mm": 687,
   "n": 512,
   "periods": {
    "1961-1990": 655,
    "1981-2010": 664,
    "1991-2020": 687
   },
   "seasons": {
    "djf": 151,
    "jja": 197,
    "mam": 138,
    "son": 201
   },
   "summer_half": 335,
   "winter_half": 352
  },
  "NE20": {
   "cells": 94,
   "mm": 734,
   "n": 437,
   "periods": {
    "1961-1990": 696,
    "1981-2010": 712,
    "1991-2020": 734
   },
   "seasons": {
    "djf": 172,
    "jja": 205,
    "mam": 146,
    "son": 211
   },
   "summer_half": 351,
   "winter_half": 383
  },
  "NE21": {
   "cells": 21,
   "mm": 690,
   "n": 539,
   "periods": {
    "1961-1990": 635,
    "1981-2010": 658,
    "1991-2020": 690
   },
   "seasons": {
    "djf": 158,
    "jja": 197,
    "mam": 141,
    "son": 194
   },
   "summer_half": 338,
   "winter_half": 352
  },
  "NE22": {
   "cells": 27,
   "mm": 663,
   "n": 531,
   "periods": {
    "1961-1990": 641,
    "1981-2010": 657,
    "1991-2020": 663
   },
   "seasons": {
    "djf": 150,
    "jja": 192,
    "mam": 135,
    "son": 186
   },
   "summer_half": 327,
   "winter_half": 336
  },
  "NE23": {
   "cells": 39,
   "mm": 677,
   "n": 1072,
   "periods": {
    "1961-1990": 650,
    "1981-2010": 664,
    "1991-2020": 677
   },
   "seasons": {
    "djf": 151,
    "jja": 199,
    "mam": 138,
    "son": 189
   },
   "summer_half": 337,
   "winter_half": 340
  },
  "NE24": {
   "cells": 27,
   "mm": 654,
   "n": 1126,
   "periods": {
    "1961-1990": 626,
    "1981-2010": 643,
    "1991-2020": 654
   },
   "seasons": {
    "djf": 148,
    "jja": 190,
    "mam": 130,
    "son": 186
   },
   "summer_half": 320,
   "winter_half": 333
  },
  "NE25": {
   "cells": 24,
   "mm": 667,
   "n": 681,
   "periods": {
    "1961-1990": 636,
    "1981-2010": 645,
    "1991-2020": 667
   },
   "seasons": {
    "djf": 150,
    "jja": 192,
    "mam": 131,
    "son": 194
   },
   "summer_half": 323,
   "winter_half": 344
  },
  "NE26": {
   "cells": 16,
   "mm": 654,
   "n": 539,
   "periods": {
    "1961-1990": 624,
    "1981-2010": 632,
    "1991-2020": 654
   },
   "seasons": {
    "djf": 147,
    "jja": 187,
    "mam": 127,
    "son": 192
   },
   "summer_half": 314,
   "winter_half": 339
  },
  "NE27": {
   "cells": 17,
   "mm": 689,
   "n": 344,
   "periods": {
    "1961-1990": 656,
    "1981-2010": 663,
    "1991-2020": 689
   },
   "seasons": {
    "djf": 154,
    "jja": 199,
    "mam": 136,
    "son": 200
   },
   "summer_half": 335,
   "winter_half": 354
  },
  "NE28": {
   "cells": 22,
   "mm": 666,
   "n": 1054,
   "periods": {
    "1961-1990": 635,
    "1981-2010": 640,
    "1991-2020": 666
   },
   "seasons": {
    "djf": 148,
    "jja": 192,
    "mam": 133,
    "son": 193
   },
   "summer_half": 325,
   "winter_half": 341
  },
  "NE29": {
   "cells": 19,
   "mm": 673,
   "n": 954,
   "periods": {
    "1961-1990": 644,
    "1981-2010": 647,
    "1991-2020": 673
   },
   "seasons": {
    "djf": 151,
    "jja": 193,
    "mam": 133,
    "son": 196
   },
   "summer_half": 325,
   "winter_half": 347
  },
  "NE3": {
   "cells": 26,
   "mm": 687,
   "n": 1189,
   "periods": {
    "1961-1990": 649,
    "1981-2010": 664,
    "1991-2020": 687
   },
   "seasons": {
    "djf": 148,
    "jja": 199,
    "mam": 138,
    "son": 202
   },
   "summer_half": 337,
   "winter_half": 350
  },
  "NE30": {
   "cells": 10,
   "mm": 670,
   "n": 636,
   "periods": {
    "1961-1990": 644,
    "1981-2010": 646,
    "1991-2020": 670
   },
   "seasons": {
    "djf": 151,
    "jja": 192,
    "mam": 131,
    "son": 197
   },
   "summer_half": 323,
   "winter_half": 347
  },
  "NE31": {
   "cells": 12,
   "mm": 650,
   "n": 503,
   "periods": {
    "1961-1990": 616,
    "1981-2010": 624,
    "1991-2020": 650
   },
   "seasons": {
    "djf": 142,
    "jja": 187,
    "mam": 131,
    "son": 189
   },
   "summer_half": 319,
   "winter_half": 331
  },
  "NE32": {
   "cells": 15,
   "mm": 646,
   "n": 676,
   "periods": {
    "1961-1990": 615,
    "1981-2010": 620,
    "1991-2020": 646
   },
   "seasons": {
    "djf": 142,
    "jja": 186,
    "mam": 130,
    "son": 188
   },
   "summer_half": 316,
   "winter_half": 330
  },
  "NE33": {
   "cells": 11,
   "mm": 646,
   "n": 766,
   "periods": {
    "1961-1990": 621,
    "1981-2010": 620,
    "1991-2020": 646
   },
   "seasons": {
    "djf": 146,
    "jja": 183,
    "mam": 127,
    "son": 190
   },
   "summer_half": 310,
   "winter_half": 336
  },
  "NE34": {
   "cells": 24,
   "mm": 648,
   "n": 1055,
   "periods": {
    "1961-1990": 623,
    "1981-2010": 623,
    "1991-2020": 648
   },
   "seasons": {
    "djf": 145,
    "jja": 184,
    "mam": 128,
    "son": 190
   },
   "summer_half": 313,
   "winter_half": 335
  },
  "NE35": {
   "cells": 6,
   "mm": 649,
   "n": 132,
   "periods": {
    "1961-1990": 617,
    "1981-2010": 624,
    "1991-2020": 649
   },
   "seasons": {
    "djf": 145,
    "jja": 186,
    "mam": 130,
    "son": 188
   },
   "summer_half": 317,
   "winter_half": 333
  },
  "NE36": {
   "cells": 15,
   "mm": 648,
   "n": 211,
   "periods": {
    "1961-1990": 613,
    "1981-2010": 623,
    "1991-2020": 648
   },
   "seasons": {
    "djf": 145,
    "jja": 186,
    "mam": 131,
    "son": 187
   },
   "summer_half": 316,
   "winter_half": 332
  },
  "NE37": {
   "cells": 20,
   "mm": 707,
   "n": 541,
   "periods": {
    "1961-1990": 658,
    "1981-2010": 679,
    "1991-2020": 707
   },
   "seasons": {
    "djf": 159,
    "jja": 197,
    "mam": 147,
    "son": 204
   },
   "summer_half": 344,
   "winter_half": 363
  },
  "NE38": {
   "cells": 20,
   "mm": 705,
   "n": 652,
   "periods": {
    "1961-1990": 656,
    "1981-2010": 677,
    "1991-2020": 705
   },
   "seasons": {
    "djf": 160,
    "jja": 196,
    "mam": 150,
    "son": 199
   },
   "summer_half": 346,
   "winter_half": 359
  },
  "NE39": {
   "cells": 22,
   "mm": 703,
   "n": 315,
   "periods": {
    "1961-1990": 666,
    "1981-2010": 677,
    "1991-2020": 703
   },
   "seasons": {
    "djf": 163,
    "jja": 198,
    "mam": 145,
    "son": 196
   },
   "summer_half": 344,
   "winter_half": 359
  },
  "NE4": {
   "cells": 14,
   "mm": 680,
   "n": 802,
   "periods": {
    "1961-1990": 630,
    "1981-2010": 651,
    "1991-2020": 680
   },
   "seasons": {
    "djf": 146,
    "jja": 198,
    "mam": 138,
    "son": 197
   },
   "summer_half": 336,
   "winter_half": 343
  },
  "NE40": {
   "cells": 18,
   "mm": 676,
   "n": 513,
   "periods": {
    "1961-1990": 643,
    "1981-2010": 653,
    "1991-2020": 676
   },
   "seasons": {
    "djf": 150,
    "jja": 199,
    "mam": 138,
    "son": 189
   },
   "summer_half": 337,
   "winter_half": 339
  },
  "NE41": {
   "cells": 11,
   "mm": 650,
   "n": 96,
   "periods": {
    "1961-1990": 624,
    "1981-2010": 627,
    "1991-2020": 650
   },
   "seasons": {
    "djf": 147,
    "jja": 190,
    "mam": 133,
    "son": 180
   },
   "summer_half": 323,
   "winter_half": 327
  },
  "NE42": {
   "cells": 18,
   "mm": 739,
   "n": 368,
   "periods": {
    "1961-1990": 706,
    "1981-2010": 712,
    "1991-2020": 739
   },
   "seasons": {
    "djf": 176,
    "jja": 208,
    "mam": 149,
    "son": 206
   },
   "summer_half": 357,
   "winter_half": 382
  },
  "NE43": {
   "cells": 44,
   "mm": 733,
   "n": 221,
   "periods": {
    "1961-1990": 706,
    "1981-2010": 713,
    "1991-2020": 733
   },
   "seasons": {
    "djf": 174,
    "jja": 205,
    "mam": 149,
    "son": 204
   },
   "summer_half": 354,
   "winter_half": 378
  },
  "NE44": {
   "cells": 17,
   "mm": 685,
   "n": 87,
   "periods": {
    "1961-1990": 696,
    "1981-2010": 672,
    "1991-2020": 685
   },
   "seasons": {
    "djf": 172,
    "jja": 186,
    "mam": 139,
    "son": 189
   },
   "summer_half": 324,
   "winter_half": 361
  },
  "NE45": {
   "cells": 29,
   "mm": 728,
   "n": 198,
   "periods": {
    "1961-1990": 706,
    "1981-2010": 706,
    "1991-2020": 728
   },
   "seasons": {
    "djf": 174,
    "jja": 203,
    "mam": 144,
    "son": 206
   },
   "summer_half": 347,
   "winter_half": 381
  },
  "NE46": {
   "cells": 122,
   "mm": 793,
   "n": 838,
   "periods": {
    "1961-1990": 739,
    "1981-2010": 772,
    "1991-2020": 793
   },
   "seasons": {
    "djf": 206,
    "jja": 210,
    "mam": 157,
    "son": 220
   },
   "summer_half": 368,
   "winter_half": 426
  },
  "NE47": {
   "cells": 211,
   "mm": 934,
   "n": 598,
   "periods": {
    "1961-1990": 881,
    "1981-2010": 913,
    "1991-2020": 934
   },
   "seasons": {
    "djf": 263,
    "jja": 227,
    "mam": 184,
    "son": 259
   },
   "summer_half": 412,
   "winter_half": 523
  },
  "NE48": {
   "cells": 197,
   "mm": 988,
   "n": 433,
   "periods": {
    "1961-1990": 904,
    "1981-2010": 952,
    "1991-2020": 988
   },
   "seasons": {
    "djf": 289,
    "jja": 243,
    "mam": 190,
    "son": 266
   },
   "summer_half": 433,
   "winter_half": 555
  },
  "NE49": {
   "cells": 55,
   "mm": 995,
   "n": 284,
   "periods": {
    "1961-1990": 950,
    "1981-2010": 973,
    "1991-2020": 995
   },
   "seasons": {
    "djf": 286,
    "jja": 243,
    "mam": 195,
    "son": 271
   },
   "summer_half": 438,
   "winter_half": 557
  },
  "NE5": {
   "cells": 22,
   "mm": 685,
   "n": 1148,
   "periods": {
    "1961-1990": 635,
    "1981-2010": 657,
    "1991-2020": 685
   },
   "seasons": {
    "djf": 147,
    "jja": 200,
    "mam": 139,
    "son": 199
   },
   "summer_half": 339,
   "winter_half": 346
  },
  "NE6": {
   "cells": 16,
   "mm": 648,
   "n": 1065,
   "periods": {
    "1961-1990": 616,
    "1981-2010": 625,
    "1991-2020": 648
   },
   "seasons": {
    "djf": 140,
    "jja": 187,
    "mam": 131,
    "son": 190
   },
   "summer_half": 318,
   "winter_half": 330
  },
  "NE61": {
   "cells": 256,
   "mm": 760,
   "n": 1542,
   "periods": {
    "1961-1990": 727,
    "1981-2010": 749,
    "1991-2020": 760
   },
   "seasons": {
    "djf": 182,
    "jja": 206,
    "mam": 155,
    "son": 216
   },
   "summer_half": 361,
   "winter_half": 398
  },
  "NE62": {
   "cells": 14,
   "mm": 652,
   "n": 283,
   "periods": {
    "1961-1990": 632,
    "1981-2010": 648,
    "1991-2020": 652
   },
   "seasons": {
    "djf": 148,
    "jja": 189,
    "mam": 131,
    "son": 184
   },
   "summer_half": 320,
   "winter_half": 332
  },
  "NE63": {
   "cells": 23,
   "mm": 654,
   "n": 776,
   "periods": {
    "1961-1990": 636,
    "1981-2010": 648,
    "1991-2020": 654
   },
   "seasons": {
    "djf": 151,
    "jja": 188,
    "mam": 129,
    "son": 186
   },
   "summer_half": 317,
   "winter_half": 337
  },
  "NE64": {
   "cells": 4,
   "mm": 630,
   "n": 184,
   "periods": {
    "1961-1990": 621,
    "1981-2010": 627,
    "1991-2020": 630
   },
   "seasons": {
    "djf": 144,
    "jja": 183,
    "mam": 123,
    "son": 180
   },
   "summer_half": 306,
   "winter_half": 324
  },
  "NE65": {
   "cells": 248,
   "mm": 811,
   "n": 1097,
   "periods": {
    "1961-1990": 766,
    "1981-2010": 797,
    "1991-2020": 811
   },
   "seasons": {
    "djf": 207,
    "jja": 207,
    "mam": 165,
    "son": 232
   },
   "summer_half": 372,
   "winter_half": 439
  },
  "NE66": {
   "cells": 270,
   "mm": 793,
   "n": 1013,
   "periods": {
    "1961-1990": 737,
    "1981-2010": 773,
    "1991-2020": 793
   },
   "seasons": {
    "djf": 198,
    "jja": 209,
    "mam": 156,
    "son": 230
   },
   "summer_half": 365,
   "winter_half": 429
  },
  "NE67": {
   "cells": 41,
   "mm": 731,
   "n": 114,
   "periods": {
    "1961-1990": 693,
    "1981-2010": 717,
    "1991-2020": 731
   },
   "seasons": {
    "djf": 170,
    "jja": 203,
    "mam": 141,
    "son": 216
   },
   "summer_half": 345,
   "winter_half": 386
  },
  "NE68": {
   "cells": 11,
   "mm": 637,
   "n": 111,
   "periods": {
    "1961-1990": 635,
    "1981-2010": 642,
    "1991-2020": 637
   },
   "seasons": {
    "djf": 147,
    "jja": 178,
    "mam": 122,
    "son": 189
   },
   "summer_half": 300,
   "winter_half": 336
  },
  "NE69": {
   "cells": 11,
   "mm": 662,
   "n": 39,
   "periods": {
    "1961-1990": 635,
    "1981-2010": 655,
    "1991-2020": 662
   },
   "seasons": {
    "djf": 153,
    "jja": 192,
    "mam": 124,
    "son": 194
   },
   "summer_half": 315,
   "winter_half": 347
  },
  "NE7": {
   "cells": 10,
   "mm": 685,
   "n": 279,
   "periods": {
    "1961-1990": 657,
    "1981-2010": 663,
    "1991-2020": 685
   },
   "seasons": {
    "djf": 151,
    "jja": 197,
    "mam": 137,
    "son": 200
   },
   "summer_half": 334,
   "winter_half": 351
  },
  "NE70": {
   "cells": 44,
   "mm": 681,
   "n": 131,
   "periods": {
    "1961-1990": 631,
    "1981-2010": 668,
    "1991-2020": 681
   },
   "seasons": {
    "djf": 156,
    "jja": 192,
    "mam": 134,
    "son": 198
   },
   "summer_half": 326,
   "winter_half": 354
  },
  "NE71": {
   "cells": 68,
   "mm": 802,
   "n": 190,
   "periods": {
    "1961-1990": 728,
    "1981-2010": 775,
    "1991-2020": 802
   },
   "seasons": {
    "djf": 200,
    "jja": 212,
    "mam": 161,
    "son": 228
   },
   "summer_half": 373,
   "winter_half": 429
  },
  "NE8": {
   "cells": 13,
   "mm": 653,
   "n": 736,
   "periods": {
    "1961-1990": 614,
    "1981-2010": 627,
    "1991-2020": 653
   },
   "seasons": {
    "djf": 145,
    "jja": 183,
    "mam": 133,
    "son": 192
   },
   "summer_half": 316,
   "winter_half": 337
  },
  "NE85": {
   "cells": 2,
   "mm": 658,
   "n": 4,
   "periods": {
    "1961-1990": 616,
    "1981-2010": 632,
    "1991-2020": 658
   },
   "seasons": {
    "djf": 149,
    "jja": 185,
    "mam": 138,
    "son": 187
   },
   "summer_half": 323,
   "winter_half": 336
  },
  "NE88": {
   "cells": 2,
   "mm": 673,
   "n": 7,
   "periods": {
    "1961-1990": 640,
    "1981-2010": 649,
    "1991-2020": 673
   },
   "seasons": {
    "djf": 152,
    "jja": 190,
    "mam": 136,
    "son": 196
   },
   "summer_half": 325,
   "winter_half": 348
  },
  "NE9": {
   "cells": 16,
   "mm": 726,
   "n": 833,
   "periods": {
    "1961-1990": 677,
    "1981-2010": 695,
    "1991-2020": 726
   },
   "seasons": {
    "djf": 166,
    "jja": 196,
    "mam": 147,
    "son": 217
   },
   "summer_half": 343,
   "winter_half": 384
  },
  "NE92": {
   "cells": 1,
   "mm": 638,
   "n": 40,
   "periods": {
    "1961-1990": 599,
    "1981-2010": 612,
    "1991-2020": 638
   },
   "seasons": {
    "djf": 148,
    "jja": 176,
    "mam": 130,
    "son": 184
   },
   "summer_half": 307,
   "winter_half": 332
  },
  "NE98": {
   "cells": 2,
   "mm": 673,
   "n": 10,
   "periods": {
    "1961-1990": 640,
    "1981-2010": 649,
    "1991-2020": 673
   },
   "seasons": {
    "djf": 152,
    "jja": 190,
    "mam": 136,
    "son": 196
   },
   "summer_half": 325,
   "winter_half": 348
  },
  "NE99": {
   "cells": 3,
   "mm": 662,
   "n": 91,
   "periods": {
    "1961-1990": 626,
    "1981-2010": 637,
    "1991-2020": 662
   },
   "seasons": {
    "djf": 144,
    "jja": 190,
    "mam": 134,
    "son": 193
   },
   "summer_half": 324,
   "winter_half": 338
  },
  "NG1": {
   "cells": 8,
   "mm": 655,
   "n": 654,
   "periods": {
    "1961-1990": 624,
    "1981-2010": 635,
    "1991-2020": 655
   },
   "seasons": {
    "djf": 154,
    "jja": 187,
    "mam": 133,
    "son": 181
   },
   "summer_half": 320,
   "winter_half": 335
  },
  "NG10": {
   "cells": 28,
   "mm": 664,
   "n": 994,
   "periods": {
    "1961-1990": 633,
    "1981-2010": 652,
    "1991-2020": 664
   },
   "seasons": {
    "djf": 159,
    "jja": 187,
    "mam": 134,
    "son": 183
   },
   "summer_half": 322,
   "winter_half": 342
  },
  "NG11": {
   "cells": 49,
   "mm": 632,
   "n": 902,
   "periods": {
    "1961-1990": 587,
    "1981-2010": 612,
    "1991-2020": 632
   },
   "seasons": {
    "djf": 147,
    "jja": 181,
    "mam": 132,
    "son": 174
   },
   "summer_half": 312,
   "winter_half": 320
  },
  "NG12": {
   "cells": 107,
   "mm": 634,
   "n": 1020,
   "periods": {
    "1961-1990": 595,
    "1981-2010": 616,
    "1991-2020": 634
   },
   "seasons": {
    "djf": 146,
    "jja": 186,
    "mam": 129,
    "son": 172
   },
   "summer_half": 316,
   "winter_half": 318
  },
  "NG13": {
   "cells": 100,
   "mm": 605,
   "n": 714,
   "periods": {
    "1961-1990": 571,
    "1981-2010": 589,
    "1991-2020": 605
   },
   "seasons": {
    "djf": 137,
    "jja": 183,
    "mam": 123,
    "son": 161
   },
   "summer_half": 306,
   "winter_half": 299
  },
  "NG14": {
   "cells": 79,
   "mm": 667,
   "n": 594,
   "periods": {
    "1961-1990": 621,
    "1981-2010": 642,
    "1991-2020": 667
   },
   "seasons": {
    "djf": 159,
    "jja": 190,
    "mam": 135,
    "son": 184
   },
   "summer_half": 325,
   "winter_half": 342
  },
  "NG15": {
   "cells": 46,
   "mm": 759,
   "n": 1012,
   "periods": {
    "1961-1990": 729,
    "1981-2010": 742,
    "1991-2020": 759
   },
   "seasons": {
    "djf": 189,
    "jja": 203,
    "mam": 153,
    "son": 214
   },
   "summer_half": 356,
   "winter_half": 403
  },
  "NG16": {
   "cells": 79,
   "mm": 746,
   "n": 1448,
   "periods": {
    "1961-1990": 724,
    "1981-2010": 731,
    "1991-2020": 746
   },
   "seasons": {
    "djf": 187,
    "jja": 198,
    "mam": 151,
    "son": 210
   },
   "summer_half": 349,
   "winter_half": 397
  },
  "NG17": {
   "cells": 57,
   "mm": 800,
   "n": 1640,
   "periods": {
    "1961-1990": 769,
    "1981-2010": 785,
    "1991-2020": 800
   },
   "seasons": {
    "djf": 201,
    "jja": 209,
    "mam": 161,
    "son": 229
   },
   "summer_half": 369,
   "winter_half": 430
  },
  "NG18": {
   "cells": 32,
   "mm": 744,
   "n": 1200,
   "periods": {
    "1961-1990": 715,
    "1981-2010": 728,
    "1991-2020": 744
   },
   "seasons": {
    "djf": 180,
    "jja": 196,
    "mam": 155,
    "son": 214
   },
   "summer_half": 350,
   "winter_half": 394
  },
  "NG19": {
   "cells": 48,
   "mm": 740,
   "n": 1223,
   "periods": {
    "1961-1990": 709,
    "1981-2010": 722,
    "1991-2020": 740
   },
   "seasons": {
    "djf": 185,
    "jja": 200,
    "mam": 148,
    "son": 207
   },
   "summer_half": 348,
   "winter_half": 392
  },
  "NG2": {
   "cells": 34,
   "mm": 630,
   "n": 1446,
   "periods": {
    "1961-1990": 601,
    "1981-2010": 611,
    "1991-2020": 630
   },
   "seasons": {
    "djf": 145,
    "jja": 183,
    "mam": 129,
    "son": 173
   },
   "summer_half": 312,
   "winter_half": 318
  },
  "NG20": {
   "cells": 53,
   "mm": 691,
   "n": 733,
   "periods": {
    "1961-1990": 655,
    "1981-2010": 673,
    "1991-2020": 691
   },
   "seasons": {
    "djf": 168,
    "jja": 189,
    "mam": 140,
    "son": 195
   },
   "summer_half": 329,
   "winter_half": 363
  },
  "NG21": {
   "cells": 47,
   "mm": 709,
   "n": 581,
   "periods": {
    "1961-1990": 678,
    "1981-2010": 688,
    "1991-2020": 709
   },
   "seasons": {
    "djf": 173,
    "jja": 195,
    "mam": 146,
    "son": 194
   },
   "summer_half": 341,
   "winter_half": 368
  },
  "NG22": {
   "cells": 177,
   "mm": 655,
   "n": 927,
   "periods": {
    "1961-1990": 627,
    "1981-2010": 635,
    "1991-2020": 655
   },
   "seasons": {
    "djf": 153,
    "jja": 189,
    "mam": 136,
    "son": 177
   },
   "summer_half": 324,
   "winter_half": 330
  },
  "NG23": {
   "cells": 206,
   "mm": 616,
   "n": 774,
   "periods": {
    "1961-1990": 582,
    "1981-2010": 599,
    "1991-2020": 616
   },
   "seasons": {
    "djf": 140,
    "jja": 185,
    "mam": 125,
    "son": 166
   },
   "summer_half": 310,
   "winter_half": 306
  },
  "NG24": {
   "cells": 59,
   "mm": 610,
   "n": 1321,
   "periods": {
    "1961-1990": 573,
    "1981-2010": 596,
    "1991-2020": 610
   },
   "seasons": {
    "djf": 141,
    "jja": 184,
    "mam": 123,
    "son": 163
   },
   "summer_half": 307,
   "winter_half": 304
  },
  "NG25": {
   "cells": 41,
   "mm": 660,
   "n": 290,
   "periods": {
    "1961-1990": 626,
    "1981-2010": 637,
    "1991-2020": 660
   },
   "seasons": {
    "djf": 160,
    "jja": 189,
    "mam": 133,
    "son": 179
   },
   "summer_half": 322,
   "winter_half": 338
  },
  "NG3": {
   "cells": 22,
   "mm": 699,
   "n": 1031,
   "periods": {
    "1961-1990": 658,
    "1981-2010": 678,
    "1991-2020": 699
   },
   "seasons": {
    "djf": 166,
    "jja": 200,
    "mam": 140,
    "son": 194
   },
   "summer_half": 340,
   "winter_half": 360
  },
  "NG31": {
   "cells": 37,
   "mm": 657,
   "n": 1159,
   "periods": {
    "1961-1990": 626,
    "1981-2010": 647,
    "1991-2020": 657
   },
   "seasons": {
    "djf": 155,
    "jja": 186,
    "mam": 136,
    "son": 180
   },
   "summer_half": 322,
   "winter_half": 335
  },
  "NG32": {
   "cells": 175,
   "mm": 634,
   "n": 625,
   "periods": {
    "1961-1990": 604,
    "1981-2010": 624,
    "1991-2020": 634
   },
   "seasons": {
    "djf": 146,
    "jja": 185,
    "mam": 131,
    "son": 172
   },
   "summer_half": 316,
   "winter_half": 318
  },
  "NG33": {
   "cells": 141,
   "mm": 669,
   "n": 473,
   "periods": {
    "1961-1990": 644,
    "1981-2010": 662,
    "1991-2020": 669
   },
   "seasons": {
    "djf": 159,
    "jja": 184,
    "mam": 142,
    "son": 184
   },
   "summer_half": 326,
   "winter_half": 343
  },
  "NG34": {
   "cells": 210,
   "mm": 606,
   "n": 1368,
   "periods": {
    "1961-1990": 574,
    "1981-2010": 592,
    "1991-2020": 606
   },
   "seasons": {
    "djf": 140,
    "jja": 174,
    "mam": 128,
    "son": 164
   },
   "summer_half": 302,
   "winter_half": 304
  },
  "NG4": {
   "cells": 22,
   "mm": 681,
   "n": 916,
   "periods": {
    "1961-1990": 636,
    "1981-2010": 661,
    "1991-2020": 681
   },
   "seasons": {
    "djf": 160,
    "jja": 195,
    "mam": 137,
    "son": 189
   },
   "summer_half": 331,
   "winter_half": 350
  },
  "NG5": {
   "cells": 39,
   "mm": 711,
   "n": 1928,
   "periods": {
    "1961-1990": 670,
    "1981-2010": 689,
    "1991-2020": 711
   },
   "seasons": {
    "djf": 172,
    "jja": 200,
    "mam": 142,
    "son": 197
   },
   "summer_half": 342,
   "winter_half": 369
  },
  "NG6": {
   "cells": 23,
   "mm": 700,
   "n": 786,
   "periods": {
    "1961-1990": 674,
    "1981-2010": 685,
    "1991-2020": 700
   },
   "seasons": {
    "djf": 172,
    "jja": 191,
    "mam": 142,
    "son": 195
   },
   "summer_half": 333,
   "winter_half": 367
  },
  "NG7": {
   "cells": 21,
   "mm": 647,
   "n": 1180,
   "periods": {
    "1961-1990": 615,
    "1981-2010": 629,
    "1991-2020": 647
   },
   "seasons": {
    "djf": 154,
    "jja": 184,
    "mam": 132,
    "son": 177
   },
   "summer_half": 316,
   "winter_half": 331
  },
  "NG8": {
   "cells": 27,
   "mm": 685,
   "n": 1192,
   "periods": {
    "1961-1990": 658,
    "1981-2010": 670,
    "1991-2020": 685
   },
   "seasons": {
    "djf": 167,
    "jja": 190,
    "mam": 139,
    "son": 189
   },
   "summer_half": 329,
   "winter_half": 356
  },
  "NG80": {
   "cells": 4,
   "mm": 634,
   "n": 20,
   "periods": {
    "1961-1990": 594,
    "1981-2010": 613,
    "1991-2020": 634
   },
   "seasons": {
    "djf": 149,
    "jja": 181,
    "mam": 131,
    "son": 173
   },
   "summer_half": 312,
   "winter_half": 322
  },
  "NG9": {
   "cells": 39,
   "mm": 665,
   "n": 1649,
   "periods": {
    "1961-1990": 632,
    "1981-2010": 649,
    "1991-2020": 665
   },
   "seasons": {
    "djf": 161,
    "jja": 187,
    "mam": 136,
    "son": 182
   },
   "summer_half": 322,
   "winter_half": 342
  },
  "NG90": {
   "cells": 3,
   "mm": 643,
   "n": 19,
   "periods": {
    "1961-1990": 605,
    "1981-2010": 625,
    "1991-2020": 643
   },
   "seasons": {
    "djf": 155,
    "jja": 183,
    "mam": 132,
    "son": 173
   },
   "summer_half": 315,
   "winter_half": 328
  },
  "NN1": {
   "cells": 14,
   "mm": 632,
   "n": 832,
   "periods": {
    "1961-1990": 593,
    "1981-2010": 620,
    "1991-2020": 632
   },
   "seasons": {
    "djf": 157,
    "jja": 162,
    "mam": 135,
    "son": 179
   },
   "summer_half": 296,
   "winter_half": 336
  },
  "NN10": {
   "cells": 30,
   "mm": 652,
   "n": 858,
   "periods": {
    "1961-1990": 608,
    "1981-2010": 638,
    "1991-2020": 652
   },
   "seasons": {
    "djf": 157,
    "jja": 167,
    "mam": 142,
    "son": 186
   },
   "summer_half": 309,
   "winter_half": 343
  },
  "NN11": {
   "cells": 140,
   "mm": 699,
   "n": 1182,
   "periods": {
    "1961-1990": 676,
    "1981-2010": 697,
    "1991-2020": 699
   },
   "seasons": {
    "djf": 169,
    "jja": 180,
    "mam": 153,
    "son": 197
   },
   "summer_half": 333,
   "winter_half": 366
  },
  "NN12": {
   "cells": 136,
   "mm": 706,
   "n": 822,
   "periods": {
    "1961-1990": 667,
    "1981-2010": 698,
    "1991-2020": 706
   },
   "seasons": {
    "djf": 177,
    "jja": 174,
    "mam": 154,
    "son": 201
   },
   "summer_half": 328,
   "winter_half": 378
  },
  "NN13": {
   "cells": 87,
   "mm": 737,
   "n": 565,
   "periods": {
    "1961-1990": 690,
    "1981-2010": 720,
    "1991-2020": 737
   },
   "seasons": {
    "djf": 187,
    "jja": 180,
    "mam": 160,
    "son": 211
   },
   "summer_half": 340,
   "winter_half": 398
  },
  "NN14": {
   "cells": 157,
   "mm": 666,
   "n": 1218,
   "periods": {
    "1961-1990": 618,
    "1981-2010": 651,
    "1991-2020": 666
   },
   "seasons": {
    "djf": 161,
    "jja": 178,
    "mam": 142,
    "son": 186
   },
   "summer_half": 319,
   "winter_half": 347
  },
  "NN15": {
   "cells": 28,
   "mm": 653,
   "n": 949,
   "periods": {
    "1961-1990": 596,
    "1981-2010": 636,
    "1991-2020": 653
   },
   "seasons": {
    "djf": 160,
    "jja": 172,
    "mam": 138,
    "son": 183
   },
   "summer_half": 310,
   "winter_half": 342
  },
  "NN16": {
   "cells": 19,
   "mm": 658,
   "n": 899,
   "periods": {
    "1961-1990": 605,
    "1981-2010": 641,
    "1991-2020": 658
   },
   "seasons": {
    "djf": 159,
    "jja": 176,
    "mam": 140,
    "son": 183
   },
   "summer_half": 316,
   "winter_half": 342
  },
  "NN17": {
   "cells": 61,
   "mm": 682,
   "n": 908,
   "periods": {
    "1961-1990": 627,
    "1981-2010": 660,
    "1991-2020": 682
   },
   "seasons": {
    "djf": 161,
    "jja": 186,
    "mam": 143,
    "son": 192
   },
   "summer_half": 330,
   "winter_half": 352
  },
  "NN18": {
   "cells": 26,
   "mm": 691,
   "n": 658,
   "periods": {
    "1961-1990": 632,
    "1981-2010": 666,
    "1991-2020": 691
   },
   "seasons": {
    "djf": 163,
    "jja": 183,
    "mam": 145,
    "son": 200
   },
   "summer_half": 328,
   "winter_half": 363
  },
  "NN2": {
   "cells": 20,
   "mm": 627,
   "n": 803,
   "periods": {
    "1961-1990": 598,
    "1981-2010": 616,
    "1991-2020": 627
   },
   "seasons": {
    "djf": 156,
    "jja": 158,
    "mam": 137,
    "son": 177
   },
   "summer_half": 295,
   "winter_half": 333
  },
  "NN29": {
   "cells": 41,
   "mm": 636,
   "n": 280,
   "periods": {
    "1961-1990": 606,
    "1981-2010": 627,
    "1991-2020": 636
   },
   "seasons": {
    "djf": 154,
    "jja": 167,
    "mam": 135,
    "son": 180
   },
   "summer_half": 301,
   "winter_half": 335
  },
  "NN3": {
   "cells": 40,
   "mm": 646,
   "n": 1315,
   "periods": {
    "1961-1990": 606,
    "1981-2010": 634,
    "1991-2020": 646
   },
   "seasons": {
    "djf": 161,
    "jja": 163,
    "mam": 139,
    "son": 182
   },
   "summer_half": 302,
   "winter_half": 343
  },
  "NN4": {
   "cells": 36,
   "mm": 652,
   "n": 981,
   "periods": {
    "1961-1990": 602,
    "1981-2010": 635,
    "1991-2020": 652
   },
   "seasons": {
    "djf": 161,
    "jja": 168,
    "mam": 139,
    "son": 183
   },
   "summer_half": 307,
   "winter_half": 344
  },
  "NN5": {
   "cells": 24,
   "mm": 643,
   "n": 887,
   "periods": {
    "1961-1990": 609,
    "1981-2010": 628,
    "1991-2020": 643
   },
   "seasons": {
    "djf": 160,
    "jja": 165,
    "mam": 137,
    "son": 182
   },
   "summer_half": 302,
   "winter_half": 342
  },
  "NN6": {
   "cells": 249,
   "mm": 691,
   "n": 1186,
   "periods": {
    "1961-1990": 659,
    "1981-2010": 680,
    "1991-2020": 691
   },
   "seasons": {
    "djf": 170,
    "jja": 181,
    "mam": 147,
    "son": 193
   },
   "summer_half": 328,
   "winter_half": 363
  },
  "NN7": {
   "cells": 163,
   "mm": 665,
   "n": 856,
   "periods": {
    "1961-1990": 621,
    "1981-2010": 649,
    "1991-2020": 665
   },
   "seasons": {
    "djf": 167,
    "jja": 168,
    "mam": 142,
    "son": 188
   },
   "summer_half": 309,
   "winter_half": 356
  },
  "NN8": {
   "cells": 37,
   "mm": 654,
   "n": 1252,
   "periods": {
    "1961-1990": 604,
    "1981-2010": 639,
    "1991-2020": 654
   },
   "seasons": {
    "djf": 161,
    "jja": 169,
    "mam": 137,
    "son": 187
   },
   "summer_half": 307,
   "winter_half": 347
  },
  "NN9": {
   "cells": 60,
   "mm": 640,
   "n": 675,
   "periods": {
    "1961-1990": 594,
    "1981-2010": 627,
    "1991-2020": 640
   },
   "seasons": {
    "djf": 157,
    "jja": 167,
    "mam": 136,
    "son": 179
   },
   "summer_half": 303,
   "winter_half": 337
  },
  "NP10": {
   "cells": 41,
   "mm": 1212,
   "n": 590,
   "periods": {
    "1961-1990": 1103,
    "1981-2010": 1184,
    "1991-2020": 1212
   },
   "seasons": {
    "djf": 373,
    "jja": 250,
    "mam": 238,
    "son": 351
   },
   "summer_half": 488,
   "winter_half": 724
  },
  "NP11": {
   "cells": 50,
   "mm": 1468,
   "n": 912,
   "periods": {
    "1961-1990": 1356,
    "1981-2010": 1456,
    "1991-2020": 1468
   },
   "seasons": {
    "djf": 464,
    "jja": 288,
    "mam": 284,
    "son": 432
   },
   "summer_half": 573,
   "winter_half": 896
  },
  "NP12": {
   "cells": 48,
   "mm": 1520,
   "n": 903,
   "periods": {
    "1961-1990": 1448,
    "1981-2010": 1532,
    "1991-2020": 1520
   },
   "seasons": {
    "djf": 485,
    "jja": 293,
    "mam": 288,
    "son": 453
   },
   "summer_half": 581,
   "winter_half": 939
  },
  "NP13": {
   "cells": 29,
   "mm": 1496,
   "n": 551,
   "periods": {
    "1961-1990": 1411,
    "1981-2010": 1479,
    "1991-2020": 1496
   },
   "seasons": {
    "djf": 474,
    "jja": 287,
    "mam": 292,
    "son": 443
   },
   "summer_half": 579,
   "winter_half": 918
  },
  "NP15": {
   "cells": 126,
   "mm": 1057,
   "n": 404,
   "periods": {
    "1961-1990": 968,
    "1981-2010": 1037,
    "1991-2020": 1057
   },
   "seasons": {
    "djf": 329,
    "jja": 212,
    "mam": 211,
    "son": 305
   },
   "summer_half": 423,
   "winter_half": 635
  },
  "NP16": {
   "cells": 118,
   "mm": 1052,
   "n": 781,
   "periods": {
    "1961-1990": 966,
    "1981-2010": 1027,
    "1991-2020": 1052
   },
   "seasons": {
    "djf": 315,
    "jja": 221,
    "mam": 213,
    "son": 303
   },
   "summer_half": 434,
   "winter_half": 618
  },
  "NP18": {
   "cells": 59,
   "mm": 1067,
   "n": 486,
   "periods": {
    "1961-1990": 992,
    "1981-2010": 1058,
    "1991-2020": 1067
   },
   "seasons": {
    "djf": 326,
    "jja": 222,
    "mam": 214,
    "son": 305
   },
   "summer_half": 436,
   "winter_half": 631
  },
  "NP19": {
   "cells": 29,
   "mm": 1050,
   "n": 1179,
   "periods": {
    "1961-1990": 975,
    "1981-2010": 1039,
    "1991-2020": 1050
   },
   "seasons": {
    "djf": 318,
    "jja": 222,
    "mam": 210,
    "son": 299
   },
   "summer_half": 432,
   "winter_half": 618
  },
  "NP20": {
   "cells": 28,
   "mm": 1137,
   "n": 1352,
   "periods": {
    "1961-1990": 1044,
    "1981-2010": 1116,
    "1991-2020": 1137
   },
   "seasons": {
    "djf": 350,
    "jja": 235,
    "mam": 224,
    "son": 328
   },
   "summer_half": 459,
   "winter_half": 678
  },
  "NP22": {
   "cells": 34,
   "mm": 1670,
   "n": 601,
   "periods": {
    "1961-1990": 1562,
    "1981-2010": 1639,
    "1991-2020": 1670
   },
   "seasons": {
    "djf": 550,
    "jja": 316,
    "mam": 314,
    "son": 490
   },
   "summer_half": 630,
   "winter_half": 1040
  },
  "NP23": {
   "cells": 33,
   "mm": 1575,
   "n": 882,
   "periods": {
    "1961-1990": 1489,
    "1981-2010": 1547,
    "1991-2020": 1575
   },
   "seasons": {
    "djf": 515,
    "jja": 295,
    "mam": 305,
    "son": 460
   },
   "summer_half": 600,
   "winter_half": 974
  },
  "NP24": {
   "cells": 10,
   "mm": 1678,
   "n": 147,
   "periods": {
    "1961-1990": 1595,
    "1981-2010": 1677,
    "1991-2020": 1678
   },
   "seasons": {
    "djf": 540,
    "jja": 326,
    "mam": 316,
    "son": 496
   },
   "summer_half": 642,
   "winter_half": 1036
  },
  "NP25": {
   "cells": 113,
   "mm": 969,
   "n": 577,
   "periods": {
    "1961-1990": 872,
    "1981-2010": 939,
    "1991-2020": 969
   },
   "seasons": {
    "djf": 287,
    "jja": 205,
    "mam": 199,
    "son": 279
   },
   "summer_half": 404,
   "winter_half": 566
  },
  "NP26": {
   "cells": 55,
   "mm": 959,
   "n": 633,
   "periods": {
    "1961-1990": 906,
    "1981-2010": 943,
    "1991-2020": 959
   },
   "seasons": {
    "djf": 283,
    "jja": 213,
    "mam": 188,
    "son": 275
   },
   "summer_half": 401,
   "winter_half": 558
  },
  "NP4": {
   "cells": 76,
   "mm": 1410,
   "n": 1372,
   "periods": {
    "1961-1990": 1283,
    "1981-2010": 1385,
    "1991-2020": 1410
   },
   "seasons": {
    "djf": 453,
    "jja": 265,
    "mam": 277,
    "son": 415
   },
   "summer_half": 542,
   "winter_half": 868
  },
  "NP44": {
   "cells": 37,
   "mm": 1408,
   "n": 1257,
   "periods": {
    "1961-1990": 1254,
    "1981-2010": 1380,
    "1991-2020": 1408
   },
   "seasons": {
    "djf": 449,
    "jja": 276,
    "mam": 272,
    "son": 410
   },
   "summer_half": 549,
   "winter_half": 859
  },
  "NP7": {
   "cells": 217,
   "mm": 1090,
   "n": 1066,
   "periods": {
    "1961-1990": 1002,
    "1981-2010": 1065,
    "1991-2020": 1090
   },
   "seasons": {
    "djf": 342,
    "jja": 208,
    "mam": 228,
    "son": 312
   },
   "summer_half": 436,
   "winter_half": 654
  },
  "NP8": {
   "cells": 48,
   "mm": 1241,
   "n": 188,
   "periods": {
    "1961-1990": 1132,
    "1981-2010": 1203,
    "1991-2020": 1241
   },
   "seasons": {
    "djf": 402,
    "jja": 222,
    "mam": 247,
    "son": 369
   },
   "summer_half": 469,
   "winter_half": 771
  },
  "NR1": {
   "cells": 16,
   "mm": 664,
   "n": 883,
   "periods": {
    "1961-1990": 621,
    "1981-2010": 660,
    "1991-2020": 664
   },
   "seasons": {
    "djf": 164,
    "jja": 178,
    "mam": 132,
    "son": 190
   },
   "summer_half": 311,
   "winter_half": 353
  },
  "NR10": {
   "cells": 153,
   "mm": 686,
   "n": 735,
   "periods": {
    "1961-1990": 638,
    "1981-2010": 684,
    "1991-2020": 686
   },
   "seasons": {
    "djf": 170,
    "jja": 184,
    "mam": 132,
    "son": 200
   },
   "summer_half": 316,
   "winter_half": 370
  },
  "NR11": {
   "cells": 192,
   "mm": 705,
   "n": 771,
   "periods": {
    "1961-1990": 661,
    "1981-2010": 703,
    "1991-2020": 705
   },
   "seasons": {
    "djf": 172,
    "jja": 187,
    "mam": 136,
    "son": 210
   },
   "summer_half": 323,
   "winter_half": 382
  },
  "NR12": {
   "cells": 161,
   "mm": 652,
   "n": 921,
   "periods": {
    "1961-1990": 607,
    "1981-2010": 647,
    "1991-2020": 652
   },
   "seasons": {
    "djf": 164,
    "jja": 174,
    "mam": 123,
    "son": 191
   },
   "summer_half": 297,
   "winter_half": 355
  },
  "NR13": {
   "cells": 153,
   "mm": 632,
   "n": 1111,
   "periods": {
    "1961-1990": 613,
    "1981-2010": 633,
    "1991-2020": 632
   },
   "seasons": {
    "djf": 157,
    "jja": 166,
    "mam": 121,
    "son": 188
   },
   "summer_half": 287,
   "winter_half": 345
  },
  "NR14": {
   "cells": 166,
   "mm": 649,
   "n": 937,
   "periods": {
    "1961-1990": 604,
    "1981-2010": 642,
    "1991-2020": 649
   },
   "seasons": {
    "djf": 161,
    "jja": 173,
    "mam": 126,
    "son": 189
   },
   "summer_half": 299,
   "winter_half": 350
  },
  "NR15": {
   "cells": 135,
   "mm": 653,
   "n": 603,
   "periods": {
    "1961-1990": 606,
    "1981-2010": 647,
    "1991-2020": 653
   },
   "seasons": {
    "djf": 158,
    "jja": 177,
    "mam": 130,
    "son": 188
   },
   "summer_half": 307,
   "winter_half": 346
  },
  "NR16": {
   "cells": 142,
   "mm": 659,
   "n": 503,
   "periods": {
    "1961-1990": 628,
    "1981-2010": 657,
    "1991-2020": 659
   },
   "seasons": {
    "djf": 162,
    "jja": 180,
    "mam": 132,
    "son": 184
   },
   "summer_half": 312,
   "winter_half": 347
  },
  "NR17": {
   "cells": 96,
   "mm": 659,
   "n": 591,
   "periods": {
    "1961-1990": 643,
    "1981-2010": 663,
    "1991-2020": 659
   },
   "seasons": {
    "djf": 159,
    "jja": 180,
    "mam": 130,
    "son": 189
   },
   "summer_half": 311,
   "winter_half": 348
  },
  "NR18": {
   "cells": 83,
   "mm": 680,
   "n": 710,
   "periods": {
    "1961-1990": 629,
    "1981-2010": 671,
    "1991-2020": 680
   },
   "seasons": {
    "djf": 166,
    "jja": 184,
    "mam": 134,
    "son": 196
   },
   "summer_half": 318,
   "winter_half": 362
  },
  "NR19": {
   "cells": 60,
   "mm": 709,
   "n": 665,
   "periods": {
    "1961-1990": 673,
    "1981-2010": 704,
    "1991-2020": 709
   },
   "seasons": {
    "djf": 176,
    "jja": 188,
    "mam": 141,
    "son": 204
   },
   "summer_half": 329,
   "winter_half": 380
  },
  "NR2": {
   "cells": 12,
   "mm": 674,
   "n": 728,
   "periods": {
    "1961-1990": 630,
    "1981-2010": 672,
    "1991-2020": 674
   },
   "seasons": {
    "djf": 165,
    "jja": 181,
    "mam": 133,
    "son": 195
   },
   "summer_half": 314,
   "winter_half": 360
  },
  "NR20": {
   "cells": 189,
   "mm": 713,
   "n": 865,
   "periods": {
    "1961-1990": 665,
    "1981-2010": 707,
    "1991-2020": 713
   },
   "seasons": {
    "djf": 177,
    "jja": 191,
    "mam": 140,
    "son": 206
   },
   "summer_half": 331,
   "winter_half": 382
  },
  "NR21": {
   "cells": 137,
   "mm": 713,
   "n": 810,
   "periods": {
    "1961-1990": 675,
    "1981-2010": 710,
    "1991-2020": 713
   },
   "seasons": {
    "djf": 176,
    "jja": 189,
    "mam": 141,
    "son": 208
   },
   "summer_half": 329,
   "winter_half": 384
  },
  "NR22": {
   "cells": 19,
   "mm": 682,
   "n": 68,
   "periods": {
    "1961-1990": 648,
    "1981-2010": 677,
    "1991-2020": 682
   },
   "seasons": {
    "djf": 168,
    "jja": 186,
    "mam": 132,
    "son": 196
   },
   "summer_half": 318,
   "winter_half": 364
  },
  "NR23": {
   "cells": 43,
   "mm": 650,
   "n": 232,
   "periods": {
    "1961-1990": 612,
    "1981-2010": 641,
    "1991-2020": 650
   },
   "seasons": {
    "djf": 161,
    "jja": 176,
    "mam": 127,
    "son": 186
   },
   "summer_half": 303,
   "winter_half": 347
  },
  "NR24": {
   "cells": 57,
   "mm": 751,
   "n": 210,
   "periods": {
    "1961-1990": 704,
    "1981-2010": 750,
    "1991-2020": 751
   },
   "seasons": {
    "djf": 181,
    "jja": 198,
    "mam": 146,
    "son": 226
   },
   "summer_half": 343,
   "winter_half": 408
  },
  "NR25": {
   "cells": 88,
   "mm": 695,
   "n": 543,
   "periods": {
    "1961-1990": 648,
    "1981-2010": 688,
    "1991-2020": 695
   },
   "seasons": {
    "djf": 168,
    "jja": 184,
    "mam": 135,
    "son": 208
   },
   "summer_half": 319,
   "winter_half": 376
  },
  "NR26": {
   "cells": 13,
   "mm": 668,
   "n": 296,
   "periods": {
    "1961-1990": 635,
    "1981-2010": 663,
    "1991-2020": 668
   },
   "seasons": {
    "djf": 164,
    "jja": 179,
    "mam": 128,
    "son": 197
   },
   "summer_half": 308,
   "winter_half": 361
  },
  "NR27": {
   "cells": 29,
   "mm": 691,
   "n": 399,
   "periods": {
    "1961-1990": 683,
    "1981-2010": 704,
    "1991-2020": 691
   },
   "seasons": {
    "djf": 169,
    "jja": 186,
    "mam": 131,
    "son": 204
   },
   "summer_half": 317,
   "winter_half": 373
  },
  "NR28": {
   "cells": 86,
   "mm": 665,
   "n": 603,
   "periods": {
    "1961-1990": 620,
    "1981-2010": 662,
    "1991-2020": 665
   },
   "seasons": {
    "djf": 162,
    "jja": 180,
    "mam": 125,
    "son": 198
   },
   "summer_half": 305,
   "winter_half": 360
  },
  "NR29": {
   "cells": 115,
   "mm": 633,
   "n": 742,
   "periods": {
    "1961-1990": 608,
    "1981-2010": 629,
    "1991-2020": 633
   },
   "seasons": {
    "djf": 157,
    "jja": 169,
    "mam": 119,
    "son": 188
   },
   "summer_half": 288,
   "winter_half": 345
  },
  "NR3": {
   "cells": 14,
   "mm": 666,
   "n": 817,
   "periods": {
    "1961-1990": 624,
    "1981-2010": 665,
    "1991-2020": 666
   },
   "seasons": {
    "djf": 164,
    "jja": 177,
    "mam": 131,
    "son": 194
   },
   "summer_half": 307,
   "winter_half": 358
  },
  "NR30": {
   "cells": 20,
   "mm": 594,
   "n": 973,
   "periods": {
    "1961-1990": 574,
    "1981-2010": 593,
    "1991-2020": 594
   },
   "seasons": {
    "djf": 151,
    "jja": 154,
    "mam": 109,
    "son": 180
   },
   "summer_half": 263,
   "winter_half": 331
  },
  "NR31": {
   "cells": 50,
   "mm": 618,
   "n": 1193,
   "periods": {
    "1961-1990": 589,
    "1981-2010": 614,
    "1991-2020": 618
   },
   "seasons": {
    "djf": 151,
    "jja": 160,
    "mam": 120,
    "son": 187
   },
   "summer_half": 280,
   "winter_half": 338
  },
  "NR32": {
   "cells": 44,
   "mm": 628,
   "n": 1107,
   "periods": {
    "1961-1990": 589,
    "1981-2010": 621,
    "1991-2020": 628
   },
   "seasons": {
    "djf": 155,
    "jja": 163,
    "mam": 123,
    "son": 186
   },
   "summer_half": 287,
   "winter_half": 341
  },
  "NR33": {
   "cells": 36,
   "mm": 622,
   "n": 930,
   "periods": {
    "1961-1990": 598,
    "1981-2010": 619,
    "1991-2020": 622
   },
   "seasons": {
    "djf": 152,
    "jja": 162,
    "mam": 124,
    "son": 184
   },
   "summer_half": 286,
   "winter_half": 336
  },
  "NR34": {
   "cells": 177,
   "mm": 628,
   "n": 853,
   "periods": {
    "1961-1990": 601,
    "1981-2010": 626,
    "1991-2020": 628
   },
   "seasons": {
    "djf": 154,
    "jja": 164,
    "mam": 126,
    "son": 184
   },
   "summer_half": 290,
   "winter_half": 338
  },
  "NR35": {
   "cells": 91,
   "mm": 644,
   "n": 454,
   "periods": {
    "1961-1990": 607,
    "1981-2010": 642,
    "1991-2020": 644
   },
   "seasons": {
    "djf": 153,
    "jja": 177,
    "mam": 129,
    "son": 186
   },
   "summer_half": 306,
   "winter_half": 339
  },
  "NR4": {
   "cells": 30,
   "mm": 678,
   "n": 568,
   "periods": {
    "1961-1990": 631,
    "1981-2010": 674,
    "1991-2020": 678
   },
   "seasons": {
    "djf": 163,
    "jja": 191,
    "mam": 136,
    "son": 188
   },
   "summer_half": 326,
   "winter_half": 351
  },
  "NR5": {
   "cells": 19,
   "mm": 696,
   "n": 633,
   "periods": {
    "1961-1990": 645,
    "1981-2010": 693,
    "1991-2020": 696
   },
   "seasons": {
    "djf": 170,
    "jja": 186,
    "mam": 139,
    "son": 202
   },
   "summer_half": 324,
   "winter_half": 372
  },
  "NR6": {
   "cells": 22,
   "mm": 671,
   "n": 641,
   "periods": {
    "1961-1990": 630,
    "1981-2010": 671,
    "1991-2020": 671
   },
   "seasons": {
    "djf": 165,
    "jja": 177,
    "mam": 132,
    "son": 197
   },
   "summer_half": 309,
   "winter_half": 362
  },
  "NR7": {
   "cells": 20,
   "mm": 660,
   "n": 956,
   "periods": {
    "1961-1990": 621,
    "1981-2010": 658,
    "1991-2020": 660
   },
   "seasons": {
    "djf": 165,
    "jja": 173,
    "mam": 128,
    "son": 194
   },
   "summer_half": 301,
   "winter_half": 359
  },
  "NR8": {
   "cells": 28,
   "mm": 709,
   "n": 486,
   "periods": {
    "1961-1990": 648,
    "1981-2010": 700,
    "1991-2020": 709
   },
   "seasons": {
    "djf": 173,
    "jja": 186,
    "mam": 140,
    "son": 209
   },
   "summer_half": 327,
   "winter_half": 383
  },
  "NR9": {
   "cells": 157,
   "mm": 694,
   "n": 727,
   "periods": {
    "1961-1990": 638,
    "1981-2010": 687,
    "1991-2020": 694
   },
   "seasons": {
    "djf": 172,
    "jja": 187,
    "mam": 136,
    "son": 199
   },
   "summer_half": 323,
   "winter_half": 371
  },
  "NR99": {
   "cells": 1,
   "mm": 682,
   "n": 7,
   "periods": {
    "1961-1990": 638,
    "1981-2010": 678,
    "1991-2020": 682
   },
   "seasons": {
    "djf": 168,
    "jja": 183,
    "mam": 136,
    "son": 195
   },
   "summer_half": 319,
   "winter_half": 363
  },
  "NW1": {
   "cells": 14,
   "mm": 648,
   "n": 1659,
   "periods": {
    "1961-1990": 629,
    "1981-2010": 635,
    "1991-2020": 648
   },
   "seasons": {
    "djf": 172,
    "jja": 155,
    "mam": 128,
    "son": 194
   },
   "summer_half": 283,
   "winter_half": 365
  },
  "NW10": {
   "cells": 25,
   "mm": 655,
   "n": 1848,
   "periods": {
    "1961-1990": 631,
    "1981-2010": 646,
    "1991-2020": 655
   },
   "seasons": {
    "djf": 172,
    "jja": 156,
    "mam": 132,
    "son": 195
   },
   "summer_half": 288,
   "winter_half": 367
  },
  "NW11": {
   "cells": 14,
   "mm": 705,
   "n": 833,
   "periods": {
    "1961-1990": 673,
    "1981-2010": 694,
    "1991-2020": 705
   },
   "seasons": {
    "djf": 187,
    "jja": 168,
    "mam": 140,
    "son": 211
   },
   "summer_half": 307,
   "winter_half": 397
  },
  "NW1W": {
   "cells": 2,
   "mm": 631,
   "n": 1035,
   "periods": {
    "1961-1990": 617,
    "1981-2010": 618,
    "1991-2020": 631
   },
   "seasons": {
    "djf": 166,
    "jja": 153,
    "mam": 124,
    "son": 188
   },
   "summer_half": 277,
   "winter_half": 354
  },
  "NW2": {
   "cells": 17,
   "mm": 676,
   "n": 1332,
   "periods": {
    "1961-1990": 646,
    "1981-2010": 667,
    "1991-2020": 676
   },
   "seasons": {
    "djf": 179,
    "jja": 159,
    "mam": 135,
    "son": 203
   },
   "summer_half": 294,
   "winter_half": 382
  },
  "NW26": {
   "cells": 1,
   "mm": 667,
   "n": 39,
   "periods": {
    "1961-1990": 643,
    "1981-2010": 658,
    "1991-2020": 667
   },
   "seasons": {
    "djf": 176,
    "jja": 159,
    "mam": 134,
    "son": 198
   },
   "summer_half": 293,
   "winter_half": 374
  },
  "NW3": {
   "cells": 14,
   "mm": 690,
   "n": 1318,
   "periods": {
    "1961-1990": 658,
    "1981-2010": 678,
    "1991-2020": 690
   },
   "seasons": {
    "djf": 181,
    "jja": 166,
    "mam": 137,
    "son": 206
   },
   "summer_half": 303,
   "winter_half": 388
  },
  "NW4": {
   "cells": 11,
   "mm": 692,
   "n": 754,
   "periods": {
    "1961-1990": 669,
    "1981-2010": 687,
    "1991-2020": 692
   },
   "seasons": {
    "djf": 186,
    "jja": 165,
    "mam": 136,
    "son": 205
   },
   "summer_half": 301,
   "winter_half": 391
  },
  "NW5": {
   "cells": 7,
   "mm": 663,
   "n": 894,
   "periods": {
    "1961-1990": 634,
    "1981-2010": 650,
    "1991-2020": 663
   },
   "seasons": {
    "djf": 174,
    "jja": 161,
    "mam": 129,
    "son": 199
   },
   "summer_half": 290,
   "winter_half": 374
  },
  "NW6": {
   "cells": 13,
   "mm": 667,
   "n": 1290,
   "periods": {
    "1961-1990": 639,
    "1981-2010": 655,
    "1991-2020": 667
   },
   "seasons": {
    "djf": 176,
    "jja": 158,
    "mam": 134,
    "son": 200
   },
   "summer_half": 292,
   "winter_half": 375
  },
  "NW7": {
   "cells": 19,
   "mm": 699,
   "n": 796,
   "periods": {
    "1961-1990": 687,
    "1981-2010": 694,
    "1991-2020": 699
   },
   "seasons": {
    "djf": 190,
    "jja": 167,
    "mam": 139,
    "son": 204
   },
   "summer_half": 306,
   "winter_half": 394
  },
  "NW8": {
   "cells": 8,
   "mm": 661,
   "n": 844,
   "periods": {
    "1961-1990": 637,
    "1981-2010": 647,
    "1991-2020": 661
   },
   "seasons": {
    "djf": 175,
    "jja": 157,
    "mam": 132,
    "son": 198
   },
   "summer_half": 288,
   "winter_half": 373
  },
  "NW9": {
   "cells": 19,
   "mm": 671,
   "n": 1482,
   "periods": {
    "1961-1990": 658,
    "1981-2010": 670,
    "1991-2020": 671
   },
   "seasons": {
    "djf": 181,
    "jja": 161,
    "mam": 132,
    "son": 198
   },
   "summer_half": 293,
   "winter_half": 378
  },
  "OL1": {
   "cells": 20,
   "mm": 1190,
   "n": 779,
   "periods": {
    "1961-1990": 1135,
    "1981-2010": 1162,
    "1991-2020": 1190
   },
   "seasons": {
    "djf": 339,
    "jja": 287,
    "mam": 231,
    "son": 332
   },
   "summer_half": 518,
   "winter_half": 671
  },
  "OL10": {
   "cells": 21,
   "mm": 1197,
   "n": 817,
   "periods": {
    "1961-1990": 1142,
    "1981-2010": 1158,
    "1991-2020": 1197
   },
   "seasons": {
    "djf": 349,
    "jja": 281,
    "mam": 227,
    "son": 341
   },
   "summer_half": 508,
   "winter_half": 689
  },
  "OL11": {
   "cells": 28,
   "mm": 1255,
   "n": 1076,
   "periods": {
    "1961-1990": 1188,
    "1981-2010": 1207,
    "1991-2020": 1255
   },
   "seasons": {
    "djf": 370,
    "jja": 292,
    "mam": 236,
    "son": 356
   },
   "summer_half": 528,
   "winter_half": 727
  },
  "OL12": {
   "cells": 39,
   "mm": 1407,
   "n": 1184,
   "periods": {
    "1961-1990": 1334,
    "1981-2010": 1361,
    "1991-2020": 1407
   },
   "seasons": {
    "djf": 424,
    "jja": 320,
    "mam": 262,
    "son": 400
   },
   "summer_half": 583,
   "winter_half": 825
  },
  "OL13": {
   "cells": 23,
   "mm": 1464,
   "n": 657,
   "periods": {
    "1961-1990": 1382,
    "1981-2010": 1421,
    "1991-2020": 1464
   },
   "seasons": {
    "djf": 446,
    "jja": 326,
    "mam": 279,
    "son": 413
   },
   "summer_half": 605,
   "winter_half": 859
  },
  "OL14": {
   "cells": 45,
   "mm": 1415,
   "n": 788,
   "periods": {
    "1961-1990": 1370,
    "1981-2010": 1389,
    "1991-2020": 1415
   },
   "seasons": {
    "djf": 442,
    "jja": 307,
    "mam": 266,
    "son": 400
   },
   "summer_half": 573,
   "winter_half": 842
  },
  "OL15": {
   "cells": 20,
   "mm": 1284,
   "n": 539,
   "periods": {
    "1961-1990": 1284,
    "1981-2010": 1272,
    "1991-2020": 1284
   },
   "seasons": {
    "djf": 385,
    "jja": 291,
    "mam": 243,
    "son": 365
   },
   "summer_half": 534,
   "winter_half": 750
  },
  "OL16": {
   "cells": 31,
   "mm": 1255,
   "n": 1125,
   "periods": {
    "1961-1990": 1231,
    "1981-2010": 1234,
    "1991-2020": 1255
   },
   "seasons": {
    "djf": 369,
    "jja": 294,
    "mam": 238,
    "son": 354
   },
   "summer_half": 532,
   "winter_half": 723
  },
  "OL2": {
   "cells": 24,
   "mm": 1225,
   "n": 1090,
   "periods": {
    "1961-1990": 1171,
    "1981-2010": 1197,
    "1991-2020": 1225
   },
   "seasons": {
    "djf": 352,
    "jja": 294,
    "mam": 236,
    "son": 342
   },
   "summer_half": 531,
   "winter_half": 694
  },
  "OL3": {
   "cells": 39,
   "mm": 1332,
   "n": 595,
   "periods": {
    "1961-1990": 1333,
    "1981-2010": 1316,
    "1991-2020": 1332
   },
   "seasons": {
    "djf": 387,
    "jja": 312,
    "mam": 261,
    "son": 371
   },
   "summer_half": 573,
   "winter_half": 758
  },
  "OL4": {
   "cells": 26,
   "mm": 1245,
   "n": 1048,
   "periods": {
    "1961-1990": 1222,
    "1981-2010": 1232,
    "1991-2020": 1245
   },
   "seasons": {
    "djf": 356,
    "jja": 299,
    "mam": 242,
    "son": 349
   },
   "summer_half": 541,
   "winter_half": 705
  },
  "OL5": {
   "cells": 10,
   "mm": 1203,
   "n": 370,
   "periods": {
    "1961-1990": 1184,
    "1981-2010": 1183,
    "1991-2020": 1203
   },
   "seasons": {
    "djf": 340,
    "jja": 293,
    "mam": 232,
    "son": 338
   },
   "summer_half": 525,
   "winter_half": 678
  },
  "OL6": {
   "cells": 19,
   "mm": 1069,
   "n": 899,
   "periods": {
    "1961-1990": 1031,
    "1981-2010": 1041,
    "1991-2020": 1069
   },
   "seasons": {
    "djf": 299,
    "jja": 268,
    "mam": 207,
    "son": 295
   },
   "summer_half": 475,
   "winter_half": 594
  },
  "OL7": {
   "cells": 12,
   "mm": 1020,
   "n": 420,
   "periods": {
    "1961-1990": 976,
    "1981-2010": 994,
    "1991-2020": 1020
   },
   "seasons": {
    "djf": 282,
    "jja": 256,
    "mam": 198,
    "son": 284
   },
   "summer_half": 454,
   "winter_half": 566
  },
  "OL8": {
   "cells": 17,
   "mm": 1103,
   "n": 848,
   "periods": {
    "1961-1990": 1060,
    "1981-2010": 1075,
    "1991-2020": 1103
   },
   "seasons": {
    "djf": 307,
    "jja": 272,
    "mam": 214,
    "son": 310
   },
   "summer_half": 486,
   "winter_half": 617
  },
  "OL9": {
   "cells": 21,
   "mm": 1103,
   "n": 972,
   "periods": {
    "1961-1990": 1040,
    "1981-2010": 1069,
    "1991-2020": 1103
   },
   "seasons": {
    "djf": 309,
    "jja": 270,
    "mam": 214,
    "son": 309
   },
   "summer_half": 484,
   "winter_half": 618
  },
  "OX1": {
   "cells": 32,
   "mm": 680,
   "n": 847,
   "periods": {
    "1961-1990": 638,
    "1981-2010": 665,
    "1991-2020": 680
   },
   "seasons": {
    "djf": 172,
    "jja": 164,
    "mam": 146,
    "son": 198
   },
   "summer_half": 310,
   "winter_half": 370
  },
  "OX10": {
   "cells": 105,
   "mm": 658,
   "n": 1040,
   "periods": {
    "1961-1990": 629,
    "1981-2010": 643,
    "1991-2020": 658
   },
   "seasons": {
    "djf": 170,
    "jja": 150,
    "mam": 142,
    "son": 195
   },
   "summer_half": 293,
   "winter_half": 365
  },
  "OX11": {
   "cells": 68,
   "mm": 666,
   "n": 1179,
   "periods": {
    "1961-1990": 631,
    "1981-2010": 648,
    "1991-2020": 666
   },
   "seasons": {
    "djf": 177,
    "jja": 151,
    "mam": 144,
    "son": 194
   },
   "summer_half": 295,
   "winter_half": 371
  },
  "OX12": {
   "cells": 108,
   "mm": 694,
   "n": 1027,
   "periods": {
    "1961-1990": 664,
    "1981-2010": 680,
    "1991-2020": 694
   },
   "seasons": {
    "djf": 185,
    "jja": 157,
    "mam": 151,
    "son": 201
   },
   "summer_half": 308,
   "winter_half": 386
  },
  "OX13": {
   "cells": 75,
   "mm": 638,
   "n": 476,
   "periods": {
    "1961-1990": 601,
    "1981-2010": 622,
    "1991-2020": 638
   },
   "seasons": {
    "djf": 160,
    "jja": 152,
    "mam": 139,
    "son": 188
   },
   "summer_half": 290,
   "winter_half": 348
  },
  "OX14": {
   "cells": 66,
   "mm": 623,
   "n": 1337,
   "periods": {
    "1961-1990": 591,
    "1981-2010": 608,
    "1991-2020": 623
   },
   "seasons": {
    "djf": 157,
    "jja": 149,
    "mam": 136,
    "son": 181
   },
   "summer_half": 285,
   "winter_half": 338
  },
  "OX15": {
   "cells": 151,
   "mm": 706,
   "n": 834,
   "periods": {
    "1961-1990": 667,
    "1981-2010": 688,
    "1991-2020": 706
   },
   "seasons": {
    "djf": 179,
    "jja": 171,
    "mam": 158,
    "son": 199
   },
   "summer_half": 329,
   "winter_half": 377
  },
  "OX16": {
   "cells": 27,
   "mm": 692,
   "n": 1364,
   "periods": {
    "1961-1990": 656,
    "1981-2010": 683,
    "1991-2020": 692
   },
   "seasons": {
    "djf": 176,
    "jja": 165,
    "mam": 154,
    "son": 197
   },
   "summer_half": 319,
   "winter_half": 373
  },
  "OX17": {
   "cells": 137,
   "mm": 722,
   "n": 716,
   "periods": {
    "1961-1990": 680,
    "1981-2010": 708,
    "1991-2020": 722
   },
   "seasons": {
    "djf": 179,
    "jja": 180,
    "mam": 157,
    "son": 206
   },
   "summer_half": 337,
   "winter_half": 385
  },
  "OX18": {
   "cells": 105,
   "mm": 744,
   "n": 930,
   "periods": {
    "1961-1990": 677,
    "1981-2010": 722,
    "1991-2020": 744
   },
   "seasons": {
    "djf": 201,
    "jja": 172,
    "mam": 161,
    "son": 209
   },
   "summer_half": 333,
   "winter_half": 411
  },
  "OX2": {
   "cells": 46,
   "mm": 686,
   "n": 1022,
   "periods": {
    "1961-1990": 643,
    "1981-2010": 668,
    "1991-2020": 686
   },
   "seasons": {
    "djf": 174,
    "jja": 165,
    "mam": 147,
    "son": 199
   },
   "summer_half": 312,
   "winter_half": 373
  },
  "OX20": {
   "cells": 38,
   "mm": 720,
   "n": 275,
   "periods": {
    "1961-1990": 658,
    "1981-2010": 703,
    "1991-2020": 720
   },
   "seasons": {
    "djf": 186,
    "jja": 174,
    "mam": 158,
    "son": 202
   },
   "summer_half": 332,
   "winter_half": 388
  },
  "OX25": {
   "cells": 97,
   "mm": 691,
   "n": 524,
   "periods": {
    "1961-1990": 650,
    "1981-2010": 673,
    "1991-2020": 691
   },
   "seasons": {
    "djf": 178,
    "jja": 165,
    "mam": 152,
    "son": 195
   },
   "summer_half": 317,
   "winter_half": 374
  },
  "OX26": {
   "cells": 32,
   "mm": 677,
   "n": 937,
   "periods": {
    "1961-1990": 646,
    "1981-2010": 661,
    "1991-2020": 677
   },
   "seasons": {
    "djf": 172,
    "jja": 160,
    "mam": 155,
    "son": 190
   },
   "summer_half": 315,
   "winter_half": 362
  },
  "OX27": {
   "cells": 82,
   "mm": 707,
   "n": 370,
   "periods": {
    "1961-1990": 654,
    "1981-2010": 684,
    "1991-2020": 707
   },
   "seasons": {
    "djf": 182,
    "jja": 172,
    "mam": 154,
    "son": 199
   },
   "summer_half": 326,
   "winter_half": 382
  },
  "OX28": {
   "cells": 15,
   "mm": 692,
   "n": 775,
   "periods": {
    "1961-1990": 638,
    "1981-2010": 675,
    "1991-2020": 692
   },
   "seasons": {
    "djf": 187,
    "jja": 163,
    "mam": 143,
    "son": 199
   },
   "summer_half": 307,
   "winter_half": 386
  },
  "OX29": {
   "cells": 151,
   "mm": 711,
   "n": 1013,
   "periods": {
    "1961-1990": 653,
    "1981-2010": 692,
    "1991-2020": 711
   },
   "seasons": {
    "djf": 188,
    "jja": 167,
    "mam": 153,
    "son": 203
   },
   "summer_half": 320,
   "winter_half": 390
  },
  "OX3": {
   "cells": 36,
   "mm": 686,
   "n": 999,
   "periods": {
    "1961-1990": 652,
    "1981-2010": 675,
    "1991-2020": 686
   },
   "seasons": {
    "djf": 172,
    "jja": 167,
    "mam": 147,
    "son": 200
   },
   "summer_half": 314,
   "winter_half": 372
  },
  "OX33": {
   "cells": 41,
   "mm": 660,
   "n": 280,
   "periods": {
    "1961-1990": 644,
    "1981-2010": 653,
    "1991-2020": 660
   },
   "seasons": {
    "djf": 164,
    "jja": 162,
    "mam": 142,
    "son": 192
   },
   "summer_half": 305,
   "winter_half": 355
  },
  "OX39": {
   "cells": 25,
   "mm": 735,
   "n": 260,
   "periods": {
    "1961-1990": 700,
    "1981-2010": 729,
    "1991-2020": 735
   },
   "seasons": {
    "djf": 195,
    "jja": 163,
    "mam": 155,
    "son": 221
   },
   "summer_half": 319,
   "winter_half": 416
  },
  "OX4": {
   "cells": 24,
   "mm": 662,
   "n": 1365,
   "periods": {
    "1961-1990": 619,
    "1981-2010": 651,
    "1991-2020": 662
   },
   "seasons": {
    "djf": 167,
    "jja": 161,
    "mam": 143,
    "son": 190
   },
   "summer_half": 304,
   "winter_half": 357
  },
  "OX44": {
   "cells": 62,
   "mm": 654,
   "n": 346,
   "periods": {
    "1961-1990": 630,
    "1981-2010": 645,
    "1991-2020": 654
   },
   "seasons": {
    "djf": 165,
    "jja": 155,
    "mam": 142,
    "son": 191
   },
   "summer_half": 298,
   "winter_half": 356
  },
  "OX49": {
   "cells": 50,
   "mm": 736,
   "n": 231,
   "periods": {
    "1961-1990": 702,
    "1981-2010": 723,
    "1991-2020": 736
   },
   "seasons": {
    "djf": 191,
    "jja": 166,
    "mam": 159,
    "son": 221
   },
   "summer_half": 325,
   "winter_half": 411
  },
  "OX5": {
   "cells": 73,
   "mm": 667,
   "n": 702,
   "periods": {
    "1961-1990": 623,
    "1981-2010": 653,
    "1991-2020": 667
   },
   "seasons": {
    "djf": 169,
    "jja": 161,
    "mam": 149,
    "son": 189
   },
   "summer_half": 309,
   "winter_half": 358
  },
  "OX7": {
   "cells": 222,
   "mm": 781,
   "n": 1082,
   "periods": {
    "1961-1990": 717,
    "1981-2010": 760,
    "1991-2020": 781
   },
   "seasons": {
    "djf": 208,
    "jja": 182,
    "mam": 169,
    "son": 222
   },
   "summer_half": 351,
   "winter_half": 430
  },
  "OX9": {
   "cells": 60,
   "mm": 645,
   "n": 563,
   "periods": {
    "1961-1990": 622,
    "1981-2010": 635,
    "1991-2020": 645
   },
   "seasons": {
    "djf": 165,
    "jja": 149,
    "mam": 141,
    "son": 190
   },
   "summer_half": 290,
   "winter_half": 355
  },
  "PA1": {
   "cells": 16,
   "mm": 1240,
   "n": 607,
   "periods": {
    "1961-1990": 1136,
    "1981-2010": 1231,
    "1991-2020": 1240
   },
   "seasons": {
    "djf": 404,
    "jja": 248,
    "mam": 232,
    "son": 357
   },
   "summer_half": 479,
   "winter_half": 761
  },
  "PA10": {
   "cells": 18,
   "mm": 1705,
   "n": 133,
   "periods": {
    "1961-1990": 1567,
    "1981-2010": 1676,
    "1991-2020": 1705
   },
   "seasons": {
    "djf": 553,
    "jja": 335,
    "mam": 320,
    "son": 498
   },
   "summer_half": 655,
   "winter_half": 1051
  },
  "PA11": {
   "cells": 21,
   "mm": 1749,
   "n": 206,
   "periods": {
    "1961-1990": 1597,
    "1981-2010": 1717,
    "1991-2020": 1749
   },
   "seasons": {
    "djf": 578,
    "jja": 323,
    "mam": 326,
    "son": 522
   },
   "summer_half": 649,
   "winter_half": 1100
  },
  "PA12": {
   "cells": 28,
   "mm": 1780,
   "n": 114,
   "periods": {
    "1961-1990": 1638,
    "1981-2010": 1748,
    "1991-2020": 1780
   },
   "seasons": {
    "djf": 568,
    "jja": 353,
    "mam": 345,
    "son": 515
   },
   "summer_half": 698,
   "winter_half": 1082
  },
  "PA13": {
   "cells": 25,
   "mm": 1796,
   "n": 209,
   "periods": {
    "1961-1990": 1648,
    "1981-2010": 1774,
    "1991-2020": 1796
   },
   "seasons": {
    "djf": 606,
    "jja": 331,
    "mam": 341,
    "son": 518
   },
   "summer_half": 671,
   "winter_half": 1125
  },
  "PA14": {
   "cells": 23,
   "mm": 1642,
   "n": 409,
   "periods": {
    "1961-1990": 1517,
    "1981-2010": 1629,
    "1991-2020": 1642
   },
   "seasons": {
    "djf": 558,
    "jja": 313,
    "mam": 302,
    "son": 469
   },
   "summer_half": 615,
   "winter_half": 1027
  },
  "PA15": {
   "cells": 10,
   "mm": 1683,
   "n": 593,
   "periods": {
    "1961-1990": 1573,
    "1981-2010": 1694,
    "1991-2020": 1683
   },
   "seasons": {
    "djf": 559,
    "jja": 313,
    "mam": 315,
    "son": 495
   },
   "summer_half": 629,
   "winter_half": 1054
  },
  "PA16": {
   "cells": 32,
   "mm": 1788,
   "n": 781,
   "periods": {
    "1961-1990": 1653,
    "1981-2010": 1775,
    "1991-2020": 1788
   },
   "seasons": {
    "djf": 581,
    "jja": 346,
    "mam": 344,
    "son": 518
   },
   "summer_half": 690,
   "winter_half": 1099
  },
  "PA17": {
   "cells": 8,
   "mm": 1600,
   "n": 72,
   "periods": {
    "1961-1990": 1411,
    "1981-2010": 1551,
    "1991-2020": 1600
   },
   "seasons": {
    "djf": 495,
    "jja": 333,
    "mam": 308,
    "son": 464
   },
   "summer_half": 641,
   "winter_half": 959
  },
  "PA18": {
   "cells": 4,
   "mm": 1853,
   "n": 63,
   "periods": {
    "1961-1990": 1661,
    "1981-2010": 1806,
    "1991-2020": 1853
   },
   "seasons": {
    "djf": 584,
    "jja": 373,
    "mam": 356,
    "son": 540
   },
   "summer_half": 729,
   "winter_half": 1124
  },
  "PA19": {
   "cells": 11,
   "mm": 1796,
   "n": 283,
   "periods": {
    "1961-1990": 1682,
    "1981-2010": 1781,
    "1991-2020": 1796
   },
   "seasons": {
    "djf": 583,
    "jja": 356,
    "mam": 348,
    "son": 508
   },
   "summer_half": 705,
   "winter_half": 1091
  },
  "PA2": {
   "cells": 28,
   "mm": 1383,
   "n": 1000,
   "periods": {
    "1961-1990": 1268,
    "1981-2010": 1367,
    "1991-2020": 1383
   },
   "seasons": {
    "djf": 447,
    "jja": 276,
    "mam": 262,
    "son": 398
   },
   "summer_half": 538,
   "winter_half": 845
  },
  "PA20": {
   "cells": 38,
   "mm": 1475,
   "n": 270,
   "periods": {
    "1961-1990": 1379,
    "1981-2010": 1465,
    "1991-2020": 1475
   },
   "seasons": {
    "djf": 443,
    "jja": 318,
    "mam": 282,
    "son": 432
   },
   "summer_half": 600,
   "winter_half": 875
  },
  "PA21": {
   "cells": 18,
   "mm": 1711,
   "n": 46,
   "periods": {
    "1961-1990": 1614,
    "1981-2010": 1705,
    "1991-2020": 1711
   },
   "seasons": {
    "djf": 536,
    "jja": 350,
    "mam": 321,
    "son": 504
   },
   "summer_half": 670,
   "winter_half": 1041
  },
  "PA22": {
   "cells": 11,
   "mm": 2149,
   "n": 16,
   "periods": {
    "1961-1990": 1966,
    "1981-2010": 2129,
    "1991-2020": 2149
   },
   "seasons": {
    "djf": 681,
    "jja": 427,
    "mam": 412,
    "son": 629
   },
   "summer_half": 839,
   "winter_half": 1310
  },
  "PA23": {
   "cells": 39,
   "mm": 2210,
   "n": 425,
   "periods": {
    "1961-1990": 1998,
    "1981-2010": 2159,
    "1991-2020": 2210
   },
   "seasons": {
    "djf": 730,
    "jja": 413,
    "mam": 422,
    "son": 644
   },
   "summer_half": 836,
   "winter_half": 1374
  },
  "PA24": {
   "cells": 7,
   "mm": 2745,
   "n": 15,
   "periods": {
    "1961-1990": 2491,
    "1981-2010": 2680,
    "1991-2020": 2745
   },
   "seasons": {
    "djf": 933,
    "jja": 486,
    "mam": 540,
    "son": 786
   },
   "summer_half": 1026,
   "winter_half": 1719
  },
  "PA25": {
   "cells": 1,
   "mm": 2553,
   "n": 3,
   "periods": {
    "1961-1990": 2263,
    "1981-2010": 2495,
    "1991-2020": 2553
   },
   "seasons": {
    "djf": 869,
    "jja": 457,
    "mam": 479,
    "son": 748
   },
   "summer_half": 936,
   "winter_half": 1617
  },
  "PA26": {
   "cells": 8,
   "mm": 2388,
   "n": 9,
   "periods": {
    "1961-1990": 2178,
    "1981-2010": 2331,
    "1991-2020": 2388
   },
   "seasons": {
    "djf": 850,
    "jja": 433,
    "mam": 402,
    "son": 702
   },
   "summer_half": 835,
   "winter_half": 1553
  },
  "PA27": {
   "cells": 9,
   "mm": 2470,
   "n": 23,
   "periods": {
    "1961-1990": 2186,
    "1981-2010": 2413,
    "1991-2020": 2470
   },
   "seasons": {
    "djf": 815,
    "jja": 434,
    "mam": 497,
    "son": 723
   },
   "summer_half": 931,
   "winter_half": 1538
  },
  "PA28": {
   "cells": 55,
   "mm": 1416,
   "n": 227,
   "periods": {
    "1961-1990": 1311,
    "1981-2010": 1387,
    "1991-2020": 1416
   },
   "seasons": {
    "djf": 426,
    "jja": 294,
    "mam": 267,
    "son": 429
   },
   "summer_half": 561,
   "winter_half": 855
  },
  "PA29": {
   "cells": 26,
   "mm": 1555,
   "n": 79,
   "periods": {
    "1961-1990": 1456,
    "1981-2010": 1540,
    "1991-2020": 1555
   },
   "seasons": {
    "djf": 487,
    "jja": 314,
    "mam": 290,
    "son": 464
   },
   "summer_half": 604,
   "winter_half": 951
  },
  "PA3": {
   "cells": 27,
   "mm": 1253,
   "n": 689,
   "periods": {
    "1961-1990": 1147,
    "1981-2010": 1243,
    "1991-2020": 1253
   },
   "seasons": {
    "djf": 409,
    "jja": 249,
    "mam": 234,
    "son": 361
   },
   "summer_half": 483,
   "winter_half": 770
  },
  "PA30": {
   "cells": 6,
   "mm": 2043,
   "n": 43,
   "periods": {
    "1961-1990": 1876,
    "1981-2010": 2053,
    "1991-2020": 2043
   },
   "seasons": {
    "djf": 656,
    "jja": 378,
    "mam": 376,
    "son": 633
   },
   "summer_half": 754,
   "winter_half": 1289
  },
  "PA31": {
   "cells": 54,
   "mm": 1858,
   "n": 223,
   "periods": {
    "1961-1990": 1687,
    "1981-2010": 1829,
    "1991-2020": 1858
   },
   "seasons": {
    "djf": 580,
    "jja": 376,
    "mam": 345,
    "son": 557
   },
   "summer_half": 721,
   "winter_half": 1137
  },
  "PA32": {
   "cells": 11,
   "mm": 2381,
   "n": 57,
   "periods": {
    "1961-1990": 2134,
    "1981-2010": 2338,
    "1991-2020": 2381
   },
   "seasons": {
    "djf": 784,
    "jja": 451,
    "mam": 448,
    "son": 699
   },
   "summer_half": 899,
   "winter_half": 1482
  },
  "PA33": {
   "cells": 22,
   "mm": 2529,
   "n": 33,
   "periods": {
    "1961-1990": 2264,
    "1981-2010": 2460,
    "1991-2020": 2529
   },
   "seasons": {
    "djf": 846,
    "jja": 462,
    "mam": 479,
    "son": 742
   },
   "summer_half": 941,
   "winter_half": 1588
  },
  "PA34": {
   "cells": 56,
   "mm": 1950,
   "n": 366,
   "periods": {
    "1961-1990": 1783,
    "1981-2010": 1908,
    "1991-2020": 1950
   },
   "seasons": {
    "djf": 615,
    "jja": 391,
    "mam": 366,
    "son": 578
   },
   "summer_half": 757,
   "winter_half": 1193
  },
  "PA35": {
   "cells": 23,
   "mm": 2300,
   "n": 39,
   "periods": {
    "1961-1990": 2045,
    "1981-2010": 2251,
    "1991-2020": 2300
   },
   "seasons": {
    "djf": 770,
    "jja": 419,
    "mam": 430,
    "son": 681
   },
   "summer_half": 849,
   "winter_half": 1451
  },
  "PA36": {
   "cells": 5,
   "mm": 2740,
   "n": 7,
   "periods": {
    "1961-1990": 2426,
    "1981-2010": 2697,
    "1991-2020": 2740
   },
   "seasons": {
    "djf": 974,
    "jja": 454,
    "mam": 513,
    "son": 799
   },
   "summer_half": 967,
   "winter_half": 1773
  },
  "PA37": {
   "cells": 27,
   "mm": 1835,
   "n": 102,
   "periods": {
    "1961-1990": 1664,
    "1981-2010": 1799,
    "1991-2020": 1835
   },
   "seasons": {
    "djf": 600,
    "jja": 359,
    "mam": 339,
    "son": 537
   },
   "summer_half": 698,
   "winter_half": 1137
  },
  "PA38": {
   "cells": 18,
   "mm": 2087,
   "n": 33,
   "periods": {
    "1961-1990": 1888,
    "1981-2010": 2047,
    "1991-2020": 2087
   },
   "seasons": {
    "djf": 705,
    "jja": 385,
    "mam": 409,
    "son": 588
   },
   "summer_half": 794,
   "winter_half": 1293
  },
  "PA4": {
   "cells": 23,
   "mm": 1181,
   "n": 604,
   "periods": {
    "1961-1990": 1075,
    "1981-2010": 1172,
    "1991-2020": 1181
   },
   "seasons": {
    "djf": 382,
    "jja": 243,
    "mam": 219,
    "son": 336
   },
   "summer_half": 462,
   "winter_half": 718
  },
  "PA41": {
   "cells": 3,
   "mm": 1140,
   "n": 5,
   "periods": {
    "1961-1990": 1103,
    "1981-2010": 1152,
    "1991-2020": 1140
   },
   "seasons": {
    "djf": 343,
    "jja": 240,
    "mam": 209,
    "son": 348
   },
   "summer_half": 449,
   "winter_half": 690
  },
  "PA42": {
   "cells": 17,
   "mm": 1298,
   "n": 57,
   "periods": {
    "1961-1990": 1225,
    "1981-2010": 1275,
    "1991-2020": 1298
   },
   "seasons": {
    "djf": 393,
    "jja": 278,
    "mam": 242,
    "son": 386
   },
   "summer_half": 519,
   "winter_half": 779
  },
  "PA43": {
   "cells": 7,
   "mm": 1490,
   "n": 39,
   "periods": {
    "1961-1990": 1362,
    "1981-2010": 1437,
    "1991-2020": 1490
   },
   "seasons": {
    "djf": 461,
    "jja": 308,
    "mam": 273,
    "son": 449
   },
   "summer_half": 581,
   "winter_half": 910
  },
  "PA44": {
   "cells": 16,
   "mm": 1456,
   "n": 20,
   "periods": {
    "1961-1990": 1322,
    "1981-2010": 1398,
    "1991-2020": 1456
   },
   "seasons": {
    "djf": 460,
    "jja": 313,
    "mam": 264,
    "son": 419
   },
   "summer_half": 577,
   "winter_half": 879
  },
  "PA45": {
   "cells": 6,
   "mm": 1600,
   "n": 6,
   "periods": {
    "1961-1990": 1476,
    "1981-2010": 1554,
    "1991-2020": 1600
   },
   "seasons": {
    "djf": 506,
    "jja": 319,
    "mam": 296,
    "son": 479
   },
   "summer_half": 615,
   "winter_half": 985
  },
  "PA46": {
   "cells": 5,
   "mm": 1687,
   "n": 13,
   "periods": {
    "1961-1990": 1613,
    "1981-2010": 1667,
    "1991-2020": 1687
   },
   "seasons": {
    "djf": 555,
    "jja": 331,
    "mam": 299,
    "son": 501
   },
   "summer_half": 631,
   "winter_half": 1056
  },
  "PA47": {
   "cells": 4,
   "mm": 1362,
   "n": 15,
   "periods": {
    "1961-1990": 1283,
    "1981-2010": 1328,
    "1991-2020": 1362
   },
   "seasons": {
    "djf": 394,
    "jja": 310,
    "mam": 271,
    "son": 388
   },
   "summer_half": 581,
   "winter_half": 781
  },
  "PA48": {
   "cells": 4,
   "mm": 1410,
   "n": 17,
   "periods": {
    "1961-1990": 1311,
    "1981-2010": 1367,
    "1991-2020": 1410
   },
   "seasons": {
    "djf": 428,
    "jja": 311,
    "mam": 265,
    "son": 407
   },
   "summer_half": 575,
   "winter_half": 835
  },
  "PA49": {
   "cells": 4,
   "mm": 1448,
   "n": 6,
   "periods": {
    "1961-1990": 1322,
    "1981-2010": 1391,
    "1991-2020": 1448
   },
   "seasons": {
    "djf": 460,
    "jja": 327,
    "mam": 262,
    "son": 399
   },
   "summer_half": 589,
   "winter_half": 859
  },
  "PA5": {
   "cells": 19,
   "mm": 1479,
   "n": 597,
   "periods": {
    "1961-1990": 1359,
    "1981-2010": 1459,
    "1991-2020": 1479
   },
   "seasons": {
    "djf": 478,
    "jja": 296,
    "mam": 279,
    "son": 427
   },
   "summer_half": 574,
   "winter_half": 905
  },
  "PA6": {
   "cells": 24,
   "mm": 1478,
   "n": 170,
   "periods": {
    "1961-1990": 1356,
    "1981-2010": 1454,
    "1991-2020": 1478
   },
   "seasons": {
    "djf": 486,
    "jja": 283,
    "mam": 275,
    "son": 434
   },
   "summer_half": 558,
   "winter_half": 919
  },
  "PA60": {
   "cells": 9,
   "mm": 1757,
   "n": 20,
   "periods": {
    "1961-1990": 1588,
    "1981-2010": 1696,
    "1991-2020": 1757
   },
   "seasons": {
    "djf": 553,
    "jja": 344,
    "mam": 328,
    "son": 533
   },
   "summer_half": 672,
   "winter_half": 1086
  },
  "PA61": {
   "cells": 6,
   "mm": 1265,
   "n": 9,
   "periods": {
    "1961-1990": 1228,
    "1981-2010": 1234,
    "1991-2020": 1265
   },
   "seasons": {
    "djf": 374,
    "jja": 272,
    "mam": 228,
    "son": 390
   },
   "summer_half": 500,
   "winter_half": 765
  },
  "PA62": {
   "cells": 1,
   "mm": 3206,
   "n": 1,
   "periods": {
    "1961-1990": 2924,
    "1981-2010": 3115,
    "1991-2020": 3206
   },
   "seasons": {
    "djf": 1035,
    "jja": 648,
    "mam": 579,
    "son": 944
   },
   "summer_half": 1227,
   "winter_half": 1979
  },
  "PA64": {
   "cells": 1,
   "mm": 2543,
   "n": 2,
   "periods": {
    "1961-1990": 2289,
    "1981-2010": 2464,
    "1991-2020": 2543
   },
   "seasons": {
    "djf": 865,
    "jja": 464,
    "mam": 466,
    "son": 747
   },
   "summer_half": 930,
   "winter_half": 1612
  },
  "PA65": {
   "cells": 4,
   "mm": 2521,
   "n": 8,
   "periods": {
    "1961-1990": 2278,
    "1981-2010": 2451,
    "1991-2020": 2521
   },
   "seasons": {
    "djf": 851,
    "jja": 470,
    "mam": 458,
    "son": 743
   },
   "summer_half": 928,
   "winter_half": 1593
  },
  "PA66": {
   "cells": 6,
   "mm": 1313,
   "n": 8,
   "periods": {
    "1961-1990": 1198,
    "1981-2010": 1281,
    "1991-2020": 1313
   },
   "seasons": {
    "djf": 398,
    "jja": 276,
    "mam": 243,
    "son": 397
   },
   "summer_half": 519,
   "winter_half": 795
  },
  "PA67": {
   "cells": 12,
   "mm": 1550,
   "n": 15,
   "periods": {
    "1961-1990": 1415,
    "1981-2010": 1508,
    "1991-2020": 1550
   },
   "seasons": {
    "djf": 470,
    "jja": 327,
    "mam": 285,
    "son": 468
   },
   "summer_half": 613,
   "winter_half": 938
  },
  "PA68": {
   "cells": 2,
   "mm": 1932,
   "n": 3,
   "periods": {
    "1961-1990": 1794,
    "1981-2010": 1882,
    "1991-2020": 1932
   },
   "seasons": {
    "djf": 595,
    "jja": 401,
    "mam": 352,
    "son": 585
   },
   "summer_half": 752,
   "winter_half": 1179
  },
  "PA69": {
   "cells": 4,
   "mm": 2282,
   "n": 4,
   "periods": {
    "1961-1990": 2084,
    "1981-2010": 2216,
    "1991-2020": 2282
   },
   "seasons": {
    "djf": 707,
    "jja": 470,
    "mam": 417,
    "son": 688
   },
   "summer_half": 887,
   "winter_half": 1395
  },
  "PA7": {
   "cells": 16,
   "mm": 1350,
   "n": 262,
   "periods": {
    "1961-1990": 1239,
    "1981-2010": 1328,
    "1991-2020": 1350
   },
   "seasons": {
    "djf": 436,
    "jja": 272,
    "mam": 250,
    "son": 392
   },
   "summer_half": 522,
   "winter_half": 828
  },
  "PA70": {
   "cells": 4,
   "mm": 2614,
   "n": 6,
   "periods": {
    "1961-1990": 2374,
    "1981-2010": 2538,
    "1991-2020": 2614
   },
   "seasons": {
    "djf": 826,
    "jja": 530,
    "mam": 477,
    "son": 781
   },
   "summer_half": 1007,
   "winter_half": 1607
  },
  "PA71": {
   "cells": 4,
   "mm": 2227,
   "n": 4,
   "periods": {
    "1961-1990": 2017,
    "1981-2010": 2167,
    "1991-2020": 2227
   },
   "seasons": {
    "djf": 712,
    "jja": 414,
    "mam": 414,
    "son": 687
   },
   "summer_half": 828,
   "winter_half": 1399
  },
  "PA72": {
   "cells": 8,
   "mm": 2097,
   "n": 20,
   "periods": {
    "1961-1990": 1870,
    "1981-2010": 2038,
    "1991-2020": 2097
   },
   "seasons": {
    "djf": 670,
    "jja": 400,
    "mam": 383,
    "son": 644
   },
   "summer_half": 783,
   "winter_half": 1314
  },
  "PA73": {
   "cells": 6,
   "mm": 1820,
   "n": 6,
   "periods": {
    "1961-1990": 1694,
    "1981-2010": 1776,
    "1991-2020": 1820
   },
   "seasons": {
    "djf": 560,
    "jja": 376,
    "mam": 334,
    "son": 550
   },
   "summer_half": 710,
   "winter_half": 1110
  },
  "PA74": {
   "cells": 1,
   "mm": 1945,
   "n": 1,
   "periods": {
    "1961-1990": 1799,
    "1981-2010": 1902,
    "1991-2020": 1945
   },
   "seasons": {
    "djf": 594,
    "jja": 395,
    "mam": 355,
    "son": 600
   },
   "summer_half": 750,
   "winter_half": 1195
  },
  "PA75": {
   "cells": 21,
   "mm": 1960,
   "n": 61,
   "periods": {
    "1961-1990": 1775,
    "1981-2010": 1919,
    "1991-2020": 1960
   },
   "seasons": {
    "djf": 610,
    "jja": 381,
    "mam": 357,
    "son": 612
   },
   "summer_half": 738,
   "winter_half": 1222
  },
  "PA76": {
   "cells": 3,
   "mm": 1295,
   "n": 7,
   "periods": {
    "1961-1990": 1184,
    "1981-2010": 1264,
    "1991-2020": 1295
   },
   "seasons": {
    "djf": 384,
    "jja": 274,
    "mam": 242,
    "son": 395
   },
   "summer_half": 516,
   "winter_half": 779
  },
  "PA77": {
   "cells": 27,
   "mm": 1241,
   "n": 38,
   "periods": {
    "1961-1990": 1134,
    "1981-2010": 1221,
    "1991-2020": 1241
   },
   "seasons": {
    "djf": 381,
    "jja": 253,
    "mam": 224,
    "son": 383
   },
   "summer_half": 478,
   "winter_half": 764
  },
  "PA78": {
   "cells": 4,
   "mm": 1698,
   "n": 5,
   "periods": {
    "1961-1990": 1602,
    "1981-2010": 1662,
    "1991-2020": 1698
   },
   "seasons": {
    "djf": 521,
    "jja": 345,
    "mam": 311,
    "son": 521
   },
   "summer_half": 656,
   "winter_half": 1042
  },
  "PA8": {
   "cells": 10,
   "mm": 1276,
   "n": 220,
   "periods": {
    "1961-1990": 1167,
    "1981-2010": 1261,
    "1991-2020": 1276
   },
   "seasons": {
    "djf": 412,
    "jja": 258,
    "mam": 237,
    "son": 370
   },
   "summer_half": 495,
   "winter_half": 782
  },
  "PA80": {
   "cells": 12,
   "mm": 2242,
   "n": 19,
   "periods": {
    "1961-1990": 2030,
    "1981-2010": 2191,
    "1991-2020": 2242
   },
   "seasons": {
    "djf": 731,
    "jja": 428,
    "mam": 420,
    "son": 663
   },
   "summer_half": 848,
   "winter_half": 1394
  },
  "PA9": {
   "cells": 14,
   "mm": 1586,
   "n": 59,
   "periods": {
    "1961-1990": 1460,
    "1981-2010": 1562,
    "1991-2020": 1586
   },
   "seasons": {
    "djf": 493,
    "jja": 331,
    "mam": 305,
    "son": 457
   },
   "summer_half": 635,
   "winter_half": 950
  },
  "PE1": {
   "cells": 24,
   "mm": 597,
   "n": 1175,
   "periods": {
    "1961-1990": 542,
    "1981-2010": 576,
    "1991-2020": 597
   },
   "seasons": {
    "djf": 136,
    "jja": 170,
    "mam": 126,
    "son": 165
   },
   "summer_half": 296,
   "winter_half": 301
  },
  "PE10": {
   "cells": 88,
   "mm": 609,
   "n": 698,
   "periods": {
    "1961-1990": 582,
    "1981-2010": 602,
    "1991-2020": 609
   },
   "seasons": {
    "djf": 142,
    "jja": 172,
    "mam": 128,
    "son": 166
   },
   "summer_half": 300,
   "winter_half": 308
  },
  "PE11": {
   "cells": 140,
   "mm": 594,
   "n": 1351,
   "periods": {
    "1961-1990": 556,
    "1981-2010": 586,
    "1991-2020": 594
   },
   "seasons": {
    "djf": 134,
    "jja": 175,
    "mam": 123,
    "son": 161
   },
   "summer_half": 299,
   "winter_half": 295
  },
  "PE12": {
   "cells": 294,
   "mm": 610,
   "n": 1294,
   "periods": {
    "1961-1990": 569,
    "1981-2010": 594,
    "1991-2020": 610
   },
   "seasons": {
    "djf": 141,
    "jja": 175,
    "mam": 126,
    "son": 168
   },
   "summer_half": 301,
   "winter_half": 309
  },
  "PE13": {
   "cells": 126,
   "mm": 597,
   "n": 1097,
   "periods": {
    "1961-1990": 563,
    "1981-2010": 588,
    "1991-2020": 597
   },
   "seasons": {
    "djf": 137,
    "jja": 167,
    "mam": 123,
    "son": 170
   },
   "summer_half": 290,
   "winter_half": 307
  },
  "PE14": {
   "cells": 180,
   "mm": 589,
   "n": 718,
   "periods": {
    "1961-1990": 564,
    "1981-2010": 586,
    "1991-2020": 589
   },
   "seasons": {
    "djf": 137,
    "jja": 166,
    "mam": 119,
    "son": 167
   },
   "summer_half": 285,
   "winter_half": 304
  },
  "PE15": {
   "cells": 104,
   "mm": 579,
   "n": 966,
   "periods": {
    "1961-1990": 551,
    "1981-2010": 575,
    "1991-2020": 579
   },
   "seasons": {
    "djf": 134,
    "jja": 163,
    "mam": 118,
    "son": 164
   },
   "summer_half": 281,
   "winter_half": 298
  },
  "PE16": {
   "cells": 35,
   "mm": 573,
   "n": 303,
   "periods": {
    "1961-1990": 542,
    "1981-2010": 567,
    "1991-2020": 573
   },
   "seasons": {
    "djf": 134,
    "jja": 160,
    "mam": 115,
    "son": 164
   },
   "summer_half": 275,
   "winter_half": 298
  },
  "PE19": {
   "cells": 110,
   "mm": 585,
   "n": 1295,
   "periods": {
    "1961-1990": 547,
    "1981-2010": 576,
    "1991-2020": 585
   },
   "seasons": {
    "djf": 141,
    "jja": 160,
    "mam": 118,
    "son": 166
   },
   "summer_half": 278,
   "winter_half": 307
  },
  "PE2": {
   "cells": 33,
   "mm": 599,
   "n": 978,
   "periods": {
    "1961-1990": 540,
    "1981-2010": 577,
    "1991-2020": 599
   },
   "seasons": {
    "djf": 137,
    "jja": 167,
    "mam": 128,
    "son": 167
   },
   "summer_half": 295,
   "winter_half": 304
  },
  "PE20": {
   "cells": 138,
   "mm": 598,
   "n": 620,
   "periods": {
    "1961-1990": 564,
    "1981-2010": 586,
    "1991-2020": 598
   },
   "seasons": {
    "djf": 137,
    "jja": 177,
    "mam": 121,
    "son": 163
   },
   "summer_half": 299,
   "winter_half": 300
  },
  "PE21": {
   "cells": 45,
   "mm": 636,
   "n": 1114,
   "periods": {
    "1961-1990": 587,
    "1981-2010": 618,
    "1991-2020": 636
   },
   "seasons": {
    "djf": 147,
    "jja": 190,
    "mam": 128,
    "son": 171
   },
   "summer_half": 318,
   "winter_half": 318
  },
  "PE22": {
   "cells": 252,
   "mm": 626,
   "n": 773,
   "periods": {
    "1961-1990": 590,
    "1981-2010": 611,
    "1991-2020": 626
   },
   "seasons": {
    "djf": 145,
    "jja": 181,
    "mam": 126,
    "son": 173
   },
   "summer_half": 307,
   "winter_half": 319
  },
  "PE23": {
   "cells": 111,
   "mm": 686,
   "n": 389,
   "periods": {
    "1961-1990": 655,
    "1981-2010": 676,
    "1991-2020": 686
   },
   "seasons": {
    "djf": 166,
    "jja": 188,
    "mam": 138,
    "son": 193
   },
   "summer_half": 326,
   "winter_half": 359
  },
  "PE24": {
   "cells": 111,
   "mm": 636,
   "n": 539,
   "periods": {
    "1961-1990": 613,
    "1981-2010": 625,
    "1991-2020": 636
   },
   "seasons": {
    "djf": 153,
    "jja": 179,
    "mam": 125,
    "son": 179
   },
   "summer_half": 303,
   "winter_half": 332
  },
  "PE25": {
   "cells": 22,
   "mm": 631,
   "n": 722,
   "periods": {
    "1961-1990": 606,
    "1981-2010": 620,
    "1991-2020": 631
   },
   "seasons": {
    "djf": 154,
    "jja": 176,
    "mam": 119,
    "son": 182
   },
   "summer_half": 295,
   "winter_half": 336
  },
  "PE26": {
   "cells": 58,
   "mm": 573,
   "n": 368,
   "periods": {
    "1961-1990": 542,
    "1981-2010": 563,
    "1991-2020": 573
   },
   "seasons": {
    "djf": 134,
    "jja": 158,
    "mam": 118,
    "son": 163
   },
   "summer_half": 277,
   "winter_half": 297
  },
  "PE27": {
   "cells": 20,
   "mm": 563,
   "n": 548,
   "periods": {
    "1961-1990": 539,
    "1981-2010": 557,
    "1991-2020": 563
   },
   "seasons": {
    "djf": 132,
    "jja": 154,
    "mam": 116,
    "son": 161
   },
   "summer_half": 270,
   "winter_half": 293
  },
  "PE28": {
   "cells": 290,
   "mm": 593,
   "n": 1593,
   "periods": {
    "1961-1990": 557,
    "1981-2010": 583,
    "1991-2020": 593
   },
   "seasons": {
    "djf": 140,
    "jja": 160,
    "mam": 123,
    "son": 169
   },
   "summer_half": 283,
   "winter_half": 309
  },
  "PE29": {
   "cells": 26,
   "mm": 571,
   "n": 1021,
   "periods": {
    "1961-1990": 539,
    "1981-2010": 563,
    "1991-2020": 571
   },
   "seasons": {
    "djf": 134,
    "jja": 155,
    "mam": 117,
    "son": 165
   },
   "summer_half": 273,
   "winter_half": 298
  },
  "PE3": {
   "cells": 17,
   "mm": 594,
   "n": 602,
   "periods": {
    "1961-1990": 544,
    "1981-2010": 577,
    "1991-2020": 594
   },
   "seasons": {
    "djf": 137,
    "jja": 166,
    "mam": 126,
    "son": 165
   },
   "summer_half": 292,
   "winter_half": 302
  },
  "PE30": {
   "cells": 31,
   "mm": 662,
   "n": 1251,
   "periods": {
    "1961-1990": 625,
    "1981-2010": 650,
    "1991-2020": 662
   },
   "seasons": {
    "djf": 160,
    "jja": 187,
    "mam": 127,
    "son": 188
   },
   "summer_half": 314,
   "winter_half": 347
  },
  "PE31": {
   "cells": 160,
   "mm": 688,
   "n": 893,
   "periods": {
    "1961-1990": 650,
    "1981-2010": 679,
    "1991-2020": 688
   },
   "seasons": {
    "djf": 169,
    "jja": 186,
    "mam": 136,
    "son": 197
   },
   "summer_half": 321,
   "winter_half": 366
  },
  "PE32": {
   "cells": 173,
   "mm": 711,
   "n": 600,
   "periods": {
    "1961-1990": 672,
    "1981-2010": 704,
    "1991-2020": 711
   },
   "seasons": {
    "djf": 175,
    "jja": 192,
    "mam": 140,
    "son": 203
   },
   "summer_half": 332,
   "winter_half": 378
  },
  "PE33": {
   "cells": 122,
   "mm": 642,
   "n": 545,
   "periods": {
    "1961-1990": 609,
    "1981-2010": 633,
    "1991-2020": 642
   },
   "seasons": {
    "djf": 153,
    "jja": 180,
    "mam": 129,
    "son": 179
   },
   "summer_half": 309,
   "winter_half": 333
  },
  "PE34": {
   "cells": 113,
   "mm": 617,
   "n": 442,
   "periods": {
    "1961-1990": 588,
    "1981-2010": 610,
    "1991-2020": 617
   },
   "seasons": {
    "djf": 148,
    "jja": 171,
    "mam": 124,
    "son": 173
   },
   "summer_half": 296,
   "winter_half": 321
  },
  "PE35": {
   "cells": 8,
   "mm": 685,
   "n": 13,
   "periods": {
    "1961-1990": 673,
    "1981-2010": 681,
    "1991-2020": 685
   },
   "seasons": {
    "djf": 168,
    "jja": 189,
    "mam": 131,
    "son": 196
   },
   "summer_half": 321,
   "winter_half": 365
  },
  "PE36": {
   "cells": 29,
   "mm": 634,
   "n": 330,
   "periods": {
    "1961-1990": 615,
    "1981-2010": 629,
    "1991-2020": 634
   },
   "seasons": {
    "djf": 151,
    "jja": 176,
    "mam": 126,
    "son": 180
   },
   "summer_half": 303,
   "winter_half": 331
  },
  "PE37": {
   "cells": 51,
   "mm": 712,
   "n": 426,
   "periods": {
    "1961-1990": 680,
    "1981-2010": 706,
    "1991-2020": 712
   },
   "seasons": {
    "djf": 176,
    "jja": 189,
    "mam": 141,
    "son": 206
   },
   "summer_half": 330,
   "winter_half": 381
  },
  "PE38": {
   "cells": 69,
   "mm": 611,
   "n": 487,
   "periods": {
    "1961-1990": 572,
    "1981-2010": 602,
    "1991-2020": 611
   },
   "seasons": {
    "djf": 144,
    "jja": 172,
    "mam": 123,
    "son": 172
   },
   "summer_half": 294,
   "winter_half": 316
  },
  "PE4": {
   "cells": 16,
   "mm": 594,
   "n": 492,
   "periods": {
    "1961-1990": 550,
    "1981-2010": 582,
    "1991-2020": 594
   },
   "seasons": {
    "djf": 135,
    "jja": 169,
    "mam": 126,
    "son": 165
   },
   "summer_half": 294,
   "winter_half": 300
  },
  "PE5": {
   "cells": 9,
   "mm": 577,
   "n": 52,
   "periods": {
    "1961-1990": 539,
    "1981-2010": 569,
    "1991-2020": 577
   },
   "seasons": {
    "djf": 127,
    "jja": 160,
    "mam": 126,
    "son": 165
   },
   "summer_half": 285,
   "winter_half": 292
  },
  "PE6": {
   "cells": 185,
   "mm": 588,
   "n": 1043,
   "periods": {
    "1961-1990": 550,
    "1981-2010": 577,
    "1991-2020": 588
   },
   "seasons": {
    "djf": 132,
    "jja": 171,
    "mam": 123,
    "son": 162
   },
   "summer_half": 294,
   "winter_half": 294
  },
  "PE7": {
   "cells": 134,
   "mm": 590,
   "n": 1304,
   "periods": {
    "1961-1990": 546,
    "1981-2010": 578,
    "1991-2020": 590
   },
   "seasons": {
    "djf": 137,
    "jja": 164,
    "mam": 125,
    "son": 165
   },
   "summer_half": 289,
   "winter_half": 302
  },
  "PE8": {
   "cells": 137,
   "mm": 609,
   "n": 649,
   "periods": {
    "1961-1990": 574,
    "1981-2010": 598,
    "1991-2020": 609
   },
   "seasons": {
    "djf": 142,
    "jja": 164,
    "mam": 132,
    "son": 172
   },
   "summer_half": 296,
   "winter_half": 314
  },
  "PE9": {
   "cells": 120,
   "mm": 633,
   "n": 1028,
   "periods": {
    "1961-1990": 590,
    "1981-2010": 619,
    "1991-2020": 633
   },
   "seasons": {
    "djf": 149,
    "jja": 177,
    "mam": 134,
    "son": 173
   },
   "summer_half": 311,
   "winter_half": 322
  },
  "PH1": {
   "cells": 164,
   "mm": 967,
   "n": 1254,
   "periods": {
    "1961-1990": 879,
    "1981-2010": 952,
    "1991-2020": 967
   },
   "seasons": {
    "djf": 278,
    "jja": 236,
    "mam": 184,
    "son": 269
   },
   "summer_half": 420,
   "winter_half": 547
  },
  "PH10": {
   "cells": 100,
   "mm": 982,
   "n": 478,
   "periods": {
    "1961-1990": 883,
    "1981-2010": 947,
    "1991-2020": 982
   },
   "seasons": {
    "djf": 272,
    "jja": 245,
    "mam": 186,
    "son": 279
   },
   "summer_half": 432,
   "winter_half": 550
  },
  "PH11": {
   "cells": 64,
   "mm": 1001,
   "n": 186,
   "periods": {
    "1961-1990": 860,
    "1981-2010": 941,
    "1991-2020": 1001
   },
   "seasons": {
    "djf": 271,
    "jja": 253,
    "mam": 191,
    "son": 285
   },
   "summer_half": 445,
   "winter_half": 556
  },
  "PH12": {
   "cells": 33,
   "mm": 856,
   "n": 97,
   "periods": {
    "1961-1990": 737,
    "1981-2010": 795,
    "1991-2020": 856
   },
   "seasons": {
    "djf": 223,
    "jja": 240,
    "mam": 165,
    "son": 228
   },
   "summer_half": 405,
   "winter_half": 451
  },
  "PH13": {
   "cells": 57,
   "mm": 843,
   "n": 184,
   "periods": {
    "1961-1990": 743,
    "1981-2010": 803,
    "1991-2020": 843
   },
   "seasons": {
    "djf": 215,
    "jja": 237,
    "mam": 160,
    "son": 231
   },
   "summer_half": 397,
   "winter_half": 446
  },
  "PH14": {
   "cells": 32,
   "mm": 804,
   "n": 70,
   "periods": {
    "1961-1990": 715,
    "1981-2010": 768,
    "1991-2020": 804
   },
   "seasons": {
    "djf": 207,
    "jja": 219,
    "mam": 156,
    "son": 221
   },
   "summer_half": 376,
   "winter_half": 428
  },
  "PH15": {
   "cells": 65,
   "mm": 1254,
   "n": 179,
   "periods": {
    "1961-1990": 1131,
    "1981-2010": 1245,
    "1991-2020": 1254
   },
   "seasons": {
    "djf": 433,
    "jja": 228,
    "mam": 240,
    "son": 353
   },
   "summer_half": 468,
   "winter_half": 787
  },
  "PH16": {
   "cells": 53,
   "mm": 1077,
   "n": 229,
   "periods": {
    "1961-1990": 948,
    "1981-2010": 1053,
    "1991-2020": 1077
   },
   "seasons": {
    "djf": 351,
    "jja": 218,
    "mam": 205,
    "son": 303
   },
   "summer_half": 423,
   "winter_half": 654
  },
  "PH17": {
   "cells": 12,
   "mm": 1388,
   "n": 13,
   "periods": {
    "1961-1990": 1261,
    "1981-2010": 1384,
    "1991-2020": 1388
   },
   "seasons": {
    "djf": 501,
    "jja": 234,
    "mam": 260,
    "son": 393
   },
   "summer_half": 494,
   "winter_half": 893
  },
  "PH18": {
   "cells": 20,
   "mm": 1148,
   "n": 46,
   "periods": {
    "1961-1990": 1018,
    "1981-2010": 1124,
    "1991-2020": 1148
   },
   "seasons": {
    "djf": 372,
    "jja": 231,
    "mam": 215,
    "son": 329
   },
   "summer_half": 447,
   "winter_half": 701
  },
  "PH19": {
   "cells": 3,
   "mm": 1500,
   "n": 7,
   "periods": {
    "1961-1990": 1383,
    "1981-2010": 1520,
    "1991-2020": 1500
   },
   "seasons": {
    "djf": 518,
    "jja": 254,
    "mam": 286,
    "son": 441
   },
   "summer_half": 540,
   "winter_half": 960
  },
  "PH2": {
   "cells": 254,
   "mm": 876,
   "n": 1266,
   "periods": {
    "1961-1990": 802,
    "1981-2010": 858,
    "1991-2020": 876
   },
   "seasons": {
    "djf": 244,
    "jja": 226,
    "mam": 168,
    "son": 239
   },
   "summer_half": 393,
   "winter_half": 482
  },
  "PH20": {
   "cells": 13,
   "mm": 1088,
   "n": 54,
   "periods": {
    "1961-1990": 1009,
    "1981-2010": 1099,
    "1991-2020": 1088
   },
   "seasons": {
    "djf": 369,
    "jja": 201,
    "mam": 210,
    "son": 308
   },
   "summer_half": 411,
   "winter_half": 677
  },
  "PH21": {
   "cells": 26,
   "mm": 882,
   "n": 108,
   "periods": {
    "1961-1990": 817,
    "1981-2010": 872,
    "1991-2020": 882
   },
   "seasons": {
    "djf": 266,
    "jja": 191,
    "mam": 174,
    "son": 251
   },
   "summer_half": 365,
   "winter_half": 517
  },
  "PH22": {
   "cells": 20,
   "mm": 946,
   "n": 128,
   "periods": {
    "1961-1990": 888,
    "1981-2010": 941,
    "1991-2020": 946
   },
   "seasons": {
    "djf": 280,
    "jja": 210,
    "mam": 190,
    "son": 265
   },
   "summer_half": 401,
   "winter_half": 545
  },
  "PH23": {
   "cells": 10,
   "mm": 845,
   "n": 33,
   "periods": {
    "1961-1990": 765,
    "1981-2010": 829,
    "1991-2020": 845
   },
   "seasons": {
    "djf": 233,
    "jja": 214,
    "mam": 168,
    "son": 230
   },
   "summer_half": 382,
   "winter_half": 463
  },
  "PH24": {
   "cells": 10,
   "mm": 852,
   "n": 24,
   "periods": {
    "1961-1990": 782,
    "1981-2010": 840,
    "1991-2020": 852
   },
   "seasons": {
    "djf": 238,
    "jja": 209,
    "mam": 171,
    "son": 234
   },
   "summer_half": 380,
   "winter_half": 472
  },
  "PH25": {
   "cells": 9,
   "mm": 847,
   "n": 36,
   "periods": {
    "1961-1990": 777,
    "1981-2010": 838,
    "1991-2020": 847
   },
   "seasons": {
    "djf": 216,
    "jja": 223,
    "mam": 168,
    "son": 240
   },
   "summer_half": 391,
   "winter_half": 456
  },
  "PH26": {
   "cells": 41,
   "mm": 852,
   "n": 140,
   "periods": {
    "1961-1990": 797,
    "1981-2010": 843,
    "1991-2020": 852
   },
   "seasons": {
    "djf": 213,
    "jja": 228,
    "mam": 174,
    "son": 238
   },
   "summer_half": 401,
   "winter_half": 451
  },
  "PH3": {
   "cells": 61,
   "mm": 1091,
   "n": 247,
   "periods": {
    "1961-1990": 954,
    "1981-2010": 1061,
    "1991-2020": 1091
   },
   "seasons": {
    "djf": 345,
    "jja": 246,
    "mam": 205,
    "son": 295
   },
   "summer_half": 451,
   "winter_half": 640
  },
  "PH30": {
   "cells": 1,
   "mm": 2202,
   "n": 1,
   "periods": {
    "1961-1990": 2046,
    "1981-2010": 2199,
    "1991-2020": 2202
   },
   "seasons": {
    "djf": 786,
    "jja": 329,
    "mam": 454,
    "son": 633
   },
   "summer_half": 783,
   "winter_half": 1420
  },
  "PH31": {
   "cells": 8,
   "mm": 1859,
   "n": 13,
   "periods": {
    "1961-1990": 1734,
    "1981-2010": 1865,
    "1991-2020": 1859
   },
   "seasons": {
    "djf": 665,
    "jja": 301,
    "mam": 353,
    "son": 539
   },
   "summer_half": 654,
   "winter_half": 1205
  },
  "PH32": {
   "cells": 7,
   "mm": 1386,
   "n": 38,
   "periods": {
    "1961-1990": 1240,
    "1981-2010": 1392,
    "1991-2020": 1386
   },
   "seasons": {
    "djf": 502,
    "jja": 229,
    "mam": 270,
    "son": 386
   },
   "summer_half": 498,
   "winter_half": 888
  },
  "PH33": {
   "cells": 39,
   "mm": 2229,
   "n": 442,
   "periods": {
    "1961-1990": 1966,
    "1981-2010": 2181,
    "1991-2020": 2229
   },
   "seasons": {
    "djf": 763,
    "jja": 386,
    "mam": 434,
    "son": 646
   },
   "summer_half": 820,
   "winter_half": 1409
  },
  "PH34": {
   "cells": 14,
   "mm": 2072,
   "n": 26,
   "periods": {
    "1961-1990": 1873,
    "1981-2010": 2045,
    "1991-2020": 2072
   },
   "seasons": {
    "djf": 734,
    "jja": 339,
    "mam": 398,
    "son": 600
   },
   "summer_half": 737,
   "winter_half": 1335
  },
  "PH35": {
   "cells": 10,
   "mm": 2161,
   "n": 15,
   "periods": {
    "1961-1990": 1948,
    "1981-2010": 2153,
    "1991-2020": 2161
   },
   "seasons": {
    "djf": 785,
    "jja": 346,
    "mam": 423,
    "son": 607
   },
   "summer_half": 769,
   "winter_half": 1392
  },
  "PH36": {
   "cells": 26,
   "mm": 2136,
   "n": 34,
   "periods": {
    "1961-1990": 1931,
    "1981-2010": 2090,
    "1991-2020": 2136
   },
   "seasons": {
    "djf": 692,
    "jja": 402,
    "mam": 390,
    "son": 652
   },
   "summer_half": 792,
   "winter_half": 1344
  },
  "PH37": {
   "cells": 4,
   "mm": 2921,
   "n": 5,
   "periods": {
    "1961-1990": 2654,
    "1981-2010": 2886,
    "1991-2020": 2921
   },
   "seasons": {
    "djf": 990,
    "jja": 510,
    "mam": 545,
    "son": 876
   },
   "summer_half": 1055,
   "winter_half": 1866
  },
  "PH38": {
   "cells": 5,
   "mm": 2336,
   "n": 5,
   "periods": {
    "1961-1990": 2147,
    "1981-2010": 2313,
    "1991-2020": 2336
   },
   "seasons": {
    "djf": 737,
    "jja": 453,
    "mam": 439,
    "son": 706
   },
   "summer_half": 892,
   "winter_half": 1444
  },
  "PH39": {
   "cells": 6,
   "mm": 1775,
   "n": 14,
   "periods": {
    "1961-1990": 1642,
    "1981-2010": 1755,
    "1991-2020": 1775
   },
   "seasons": {
    "djf": 535,
    "jja": 364,
    "mam": 325,
    "son": 551
   },
   "summer_half": 689,
   "winter_half": 1085
  },
  "PH4": {
   "cells": 11,
   "mm": 1302,
   "n": 33,
   "periods": {
    "1961-1990": 1142,
    "1981-2010": 1273,
    "1991-2020": 1302
   },
   "seasons": {
    "djf": 426,
    "jja": 276,
    "mam": 246,
    "son": 354
   },
   "summer_half": 522,
   "winter_half": 781
  },
  "PH40": {
   "cells": 5,
   "mm": 1977,
   "n": 10,
   "periods": {
    "1961-1990": 1830,
    "1981-2010": 1965,
    "1991-2020": 1977
   },
   "seasons": {
    "djf": 614,
    "jja": 383,
    "mam": 373,
    "son": 606
   },
   "summer_half": 757,
   "winter_half": 1220
  },
  "PH41": {
   "cells": 8,
   "mm": 2084,
   "n": 40,
   "periods": {
    "1961-1990": 1940,
    "1981-2010": 2070,
    "1991-2020": 2084
   },
   "seasons": {
    "djf": 646,
    "jja": 408,
    "mam": 400,
    "son": 631
   },
   "summer_half": 808,
   "winter_half": 1276
  },
  "PH42": {
   "cells": 1,
   "mm": 1832,
   "n": 1,
   "periods": {
    "1961-1990": 1714,
    "1981-2010": 1794,
    "1991-2020": 1832
   },
   "seasons": {
    "djf": 543,
    "jja": 383,
    "mam": 337,
    "son": 568
   },
   "summer_half": 720,
   "winter_half": 1112
  },
  "PH43": {
   "cells": 1,
   "mm": 2709,
   "n": 1,
   "periods": {
    "1961-1990": 2511,
    "1981-2010": 2663,
    "1991-2020": 2709
   },
   "seasons": {
    "djf": 846,
    "jja": 508,
    "mam": 518,
    "son": 837
   },
   "summer_half": 1026,
   "winter_half": 1683
  },
  "PH44": {
   "cells": 1,
   "mm": 2562,
   "n": 1,
   "periods": {
    "1961-1990": 2342,
    "1981-2010": 2515,
    "1991-2020": 2562
   },
   "seasons": {
    "djf": 800,
    "jja": 520,
    "mam": 465,
    "son": 777
   },
   "summer_half": 985,
   "winter_half": 1577
  },
  "PH49": {
   "cells": 15,
   "mm": 2791,
   "n": 41,
   "periods": {
    "1961-1990": 2455,
    "1981-2010": 2727,
    "1991-2020": 2791
   },
   "seasons": {
    "djf": 983,
    "jja": 465,
    "mam": 541,
    "son": 802
   },
   "summer_half": 1006,
   "winter_half": 1784
  },
  "PH5": {
   "cells": 21,
   "mm": 1262,
   "n": 43,
   "periods": {
    "1961-1990": 1117,
    "1981-2010": 1241,
    "1991-2020": 1262
   },
   "seasons": {
    "djf": 403,
    "jja": 266,
    "mam": 239,
    "son": 354
   },
   "summer_half": 505,
   "winter_half": 757
  },
  "PH50": {
   "cells": 7,
   "mm": 2919,
   "n": 46,
   "periods": {
    "1961-1990": 2557,
    "1981-2010": 2827,
    "1991-2020": 2919
   },
   "seasons": {
    "djf": 1017,
    "jja": 495,
    "mam": 565,
    "son": 842
   },
   "summer_half": 1060,
   "winter_half": 1859
  },
  "PH6": {
   "cells": 31,
   "mm": 1508,
   "n": 115,
   "periods": {
    "1961-1990": 1348,
    "1981-2010": 1483,
    "1991-2020": 1508
   },
   "seasons": {
    "djf": 502,
    "jja": 276,
    "mam": 289,
    "son": 442
   },
   "summer_half": 564,
   "winter_half": 943
  },
  "PH7": {
   "cells": 78,
   "mm": 1129,
   "n": 368,
   "periods": {
    "1961-1990": 1007,
    "1981-2010": 1112,
    "1991-2020": 1129
   },
   "seasons": {
    "djf": 343,
    "jja": 249,
    "mam": 214,
    "son": 323
   },
   "summer_half": 463,
   "winter_half": 667
  },
  "PH8": {
   "cells": 53,
   "mm": 1120,
   "n": 115,
   "periods": {
    "1961-1990": 1008,
    "1981-2010": 1096,
    "1991-2020": 1120
   },
   "seasons": {
    "djf": 338,
    "jja": 247,
    "mam": 216,
    "son": 319
   },
   "summer_half": 463,
   "winter_half": 657
  },
  "PH9": {
   "cells": 29,
   "mm": 975,
   "n": 44,
   "periods": {
    "1961-1990": 862,
    "1981-2010": 955,
    "1991-2020": 975
   },
   "seasons": {
    "djf": 300,
    "jja": 216,
    "mam": 188,
    "son": 271
   },
   "summer_half": 404,
   "winter_half": 570
  },
  "PL1": {
   "cells": 8,
   "mm": 1027,
   "n": 868,
   "periods": {
    "1961-1990": 967,
    "1981-2010": 1002,
    "1991-2020": 1027
   },
   "seasons": {
    "djf": 320,
    "jja": 210,
    "mam": 204,
    "son": 293
   },
   "summer_half": 414,
   "winter_half": 613
  },
  "PL10": {
   "cells": 16,
   "mm": 1084,
   "n": 177,
   "periods": {
    "1961-1990": 1039,
    "1981-2010": 1070,
    "1991-2020": 1084
   },
   "seasons": {
    "djf": 333,
    "jja": 224,
    "mam": 216,
    "son": 311
   },
   "summer_half": 440,
   "winter_half": 644
  },
  "PL11": {
   "cells": 38,
   "mm": 1141,
   "n": 325,
   "periods": {
    "1961-1990": 1103,
    "1981-2010": 1127,
    "1991-2020": 1141
   },
   "seasons": {
    "djf": 360,
    "jja": 230,
    "mam": 225,
    "son": 327
   },
   "summer_half": 454,
   "winter_half": 687
  },
  "PL12": {
   "cells": 95,
   "mm": 1251,
   "n": 753,
   "periods": {
    "1961-1990": 1155,
    "1981-2010": 1207,
    "1991-2020": 1251
   },
   "seasons": {
    "djf": 397,
    "jja": 251,
    "mam": 242,
    "son": 362
   },
   "summer_half": 492,
   "winter_half": 759
  },
  "PL13": {
   "cells": 64,
   "mm": 1250,
   "n": 446,
   "periods": {
    "1961-1990": 1185,
    "1981-2010": 1221,
    "1991-2020": 1250
   },
   "seasons": {
    "djf": 388,
    "jja": 259,
    "mam": 244,
    "son": 359
   },
   "summer_half": 503,
   "winter_half": 747
  },
  "PL14": {
   "cells": 186,
   "mm": 1452,
   "n": 1026,
   "periods": {
    "1961-1990": 1346,
    "1981-2010": 1409,
    "1991-2020": 1452
   },
   "seasons": {
    "djf": 466,
    "jja": 286,
    "mam": 276,
    "son": 424
   },
   "summer_half": 562,
   "winter_half": 890
  },
  "PL15": {
   "cells": 232,
   "mm": 1352,
   "n": 813,
   "periods": {
    "1961-1990": 1266,
    "1981-2010": 1328,
    "1991-2020": 1352
   },
   "seasons": {
    "djf": 443,
    "jja": 258,
    "mam": 246,
    "son": 404
   },
   "summer_half": 505,
   "winter_half": 847
  },
  "PL16": {
   "cells": 36,
   "mm": 1194,
   "n": 115,
   "periods": {
    "1961-1990": 1120,
    "1981-2010": 1169,
    "1991-2020": 1194
   },
   "seasons": {
    "djf": 376,
    "jja": 243,
    "mam": 219,
    "son": 357
   },
   "summer_half": 462,
   "winter_half": 732
  },
  "PL17": {
   "cells": 86,
   "mm": 1379,
   "n": 425,
   "periods": {
    "1961-1990": 1282,
    "1981-2010": 1340,
    "1991-2020": 1379
   },
   "seasons": {
    "djf": 446,
    "jja": 266,
    "mam": 260,
    "son": 407
   },
   "summer_half": 526,
   "winter_half": 853
  },
  "PL18": {
   "cells": 19,
   "mm": 1360,
   "n": 228,
   "periods": {
    "1961-1990": 1226,
    "1981-2010": 1289,
    "1991-2020": 1360
   },
   "seasons": {
    "djf": 435,
    "jja": 275,
    "mam": 249,
    "son": 401
   },
   "summer_half": 524,
   "winter_half": 836
  },
  "PL19": {
   "cells": 118,
   "mm": 1481,
   "n": 684,
   "periods": {
    "1961-1990": 1366,
    "1981-2010": 1431,
    "1991-2020": 1481
   },
   "seasons": {
    "djf": 471,
    "jja": 304,
    "mam": 271,
    "son": 435
   },
   "summer_half": 575,
   "winter_half": 906
  },
  "PL2": {
   "cells": 10,
   "mm": 1064,
   "n": 649,
   "periods": {
    "1961-1990": 1021,
    "1981-2010": 1047,
    "1991-2020": 1064
   },
   "seasons": {
    "djf": 331,
    "jja": 215,
    "mam": 212,
    "son": 305
   },
   "summer_half": 427,
   "winter_half": 636
  },
  "PL20": {
   "cells": 99,
   "mm": 1604,
   "n": 504,
   "periods": {
    "1961-1990": 1478,
    "1981-2010": 1555,
    "1991-2020": 1604
   },
   "seasons": {
    "djf": 516,
    "jja": 318,
    "mam": 302,
    "son": 468
   },
   "summer_half": 620,
   "winter_half": 984
  },
  "PL21": {
   "cells": 88,
   "mm": 1393,
   "n": 655,
   "periods": {
    "1961-1990": 1303,
    "1981-2010": 1365,
    "1991-2020": 1393
   },
   "seasons": {
    "djf": 446,
    "jja": 283,
    "mam": 264,
    "son": 400
   },
   "summer_half": 547,
   "winter_half": 847
  },
  "PL22": {
   "cells": 53,
   "mm": 1369,
   "n": 210,
   "periods": {
    "1961-1990": 1272,
    "1981-2010": 1326,
    "1991-2020": 1369
   },
   "seasons": {
    "djf": 440,
    "jja": 263,
    "mam": 257,
    "son": 409
   },
   "summer_half": 520,
   "winter_half": 849
  },
  "PL23": {
   "cells": 21,
   "mm": 1120,
   "n": 171,
   "periods": {
    "1961-1990": 1066,
    "1981-2010": 1105,
    "1991-2020": 1120
   },
   "seasons": {
    "djf": 360,
    "jja": 219,
    "mam": 214,
    "son": 327
   },
   "summer_half": 433,
   "winter_half": 687
  },
  "PL24": {
   "cells": 25,
   "mm": 1246,
   "n": 255,
   "periods": {
    "1961-1990": 1177,
    "1981-2010": 1222,
    "1991-2020": 1246
   },
   "seasons": {
    "djf": 406,
    "jja": 236,
    "mam": 235,
    "son": 370
   },
   "summer_half": 471,
   "winter_half": 776
  },
  "PL25": {
   "cells": 25,
   "mm": 1284,
   "n": 787,
   "periods": {
    "1961-1990": 1236,
    "1981-2010": 1264,
    "1991-2020": 1284
   },
   "seasons": {
    "djf": 407,
    "jja": 247,
    "mam": 244,
    "son": 385
   },
   "summer_half": 491,
   "winter_half": 792
  },
  "PL26": {
   "cells": 146,
   "mm": 1301,
   "n": 890,
   "periods": {
    "1961-1990": 1241,
    "1981-2010": 1279,
    "1991-2020": 1301
   },
   "seasons": {
    "djf": 409,
    "jja": 255,
    "mam": 250,
    "son": 388
   },
   "summer_half": 504,
   "winter_half": 796
  },
  "PL27": {
   "cells": 94,
   "mm": 1058,
   "n": 590,
   "periods": {
    "1961-1990": 1031,
    "1981-2010": 1050,
    "1991-2020": 1058
   },
   "seasons": {
    "djf": 322,
    "jja": 213,
    "mam": 201,
    "son": 322
   },
   "summer_half": 414,
   "winter_half": 644
  },
  "PL28": {
   "cells": 31,
   "mm": 969,
   "n": 249,
   "periods": {
    "1961-1990": 961,
    "1981-2010": 964,
    "1991-2020": 969
   },
   "seasons": {
    "djf": 292,
    "jja": 195,
    "mam": 182,
    "son": 300
   },
   "summer_half": 377,
   "winter_half": 593
  },
  "PL29": {
   "cells": 15,
   "mm": 1020,
   "n": 59,
   "periods": {
    "1961-1990": 979,
    "1981-2010": 1001,
    "1991-2020": 1020
   },
   "seasons": {
    "djf": 313,
    "jja": 214,
    "mam": 181,
    "son": 312
   },
   "summer_half": 395,
   "winter_half": 626
  },
  "PL3": {
   "cells": 17,
   "mm": 1085,
   "n": 694,
   "periods": {
    "1961-1990": 1036,
    "1981-2010": 1066,
    "1991-2020": 1085
   },
   "seasons": {
    "djf": 337,
    "jja": 221,
    "mam": 213,
    "son": 314
   },
   "summer_half": 434,
   "winter_half": 651
  },
  "PL30": {
   "cells": 232,
   "mm": 1342,
   "n": 544,
   "periods": {
    "1961-1990": 1254,
    "1981-2010": 1305,
    "1991-2020": 1342
   },
   "seasons": {
    "djf": 420,
    "jja": 269,
    "mam": 250,
    "son": 402
   },
   "summer_half": 520,
   "winter_half": 822
  },
  "PL31": {
   "cells": 17,
   "mm": 1324,
   "n": 493,
   "periods": {
    "1961-1990": 1197,
    "1981-2010": 1262,
    "1991-2020": 1324
   },
   "seasons": {
    "djf": 422,
    "jja": 255,
    "mam": 249,
    "son": 398
   },
   "summer_half": 505,
   "winter_half": 820
  },
  "PL32": {
   "cells": 60,
   "mm": 1455,
   "n": 172,
   "periods": {
    "1961-1990": 1390,
    "1981-2010": 1424,
    "1991-2020": 1455
   },
   "seasons": {
    "djf": 446,
    "jja": 311,
    "mam": 262,
    "son": 437
   },
   "summer_half": 572,
   "winter_half": 883
  },
  "PL33": {
   "cells": 15,
   "mm": 1194,
   "n": 78,
   "periods": {
    "1961-1990": 1152,
    "1981-2010": 1173,
    "1991-2020": 1194
   },
   "seasons": {
    "djf": 352,
    "jja": 267,
    "mam": 216,
    "son": 358
   },
   "summer_half": 483,
   "winter_half": 711
  },
  "PL34": {
   "cells": 11,
   "mm": 1089,
   "n": 79,
   "periods": {
    "1961-1990": 1061,
    "1981-2010": 1073,
    "1991-2020": 1089
   },
   "seasons": {
    "djf": 322,
    "jja": 248,
    "mam": 193,
    "son": 327
   },
   "summer_half": 441,
   "winter_half": 649
  },
  "PL35": {
   "cells": 23,
   "mm": 1339,
   "n": 80,
   "periods": {
    "1961-1990": 1249,
    "1981-2010": 1304,
    "1991-2020": 1339
   },
   "seasons": {
    "djf": 410,
    "jja": 291,
    "mam": 240,
    "son": 399
   },
   "summer_half": 531,
   "winter_half": 809
  },
  "PL4": {
   "cells": 8,
   "mm": 1072,
   "n": 827,
   "periods": {
    "1961-1990": 1006,
    "1981-2010": 1044,
    "1991-2020": 1072
   },
   "seasons": {
    "djf": 333,
    "jja": 218,
    "mam": 207,
    "son": 313
   },
   "summer_half": 426,
   "winter_half": 646
  },
  "PL5": {
   "cells": 24,
   "mm": 1149,
   "n": 901,
   "periods": {
    "1961-1990": 1117,
    "1981-2010": 1129,
    "1991-2020": 1149
   },
   "seasons": {
    "djf": 361,
    "jja": 234,
    "mam": 221,
    "son": 333
   },
   "summer_half": 456,
   "winter_half": 694
  },
  "PL6": {
   "cells": 40,
   "mm": 1289,
   "n": 1021,
   "periods": {
    "1961-1990": 1245,
    "1981-2010": 1266,
    "1991-2020": 1289
   },
   "seasons": {
    "djf": 401,
    "jja": 266,
    "mam": 244,
    "son": 377
   },
   "summer_half": 510,
   "winter_half": 778
  },
  "PL7": {
   "cells": 51,
   "mm": 1352,
   "n": 741,
   "periods": {
    "1961-1990": 1282,
    "1981-2010": 1334,
    "1991-2020": 1352
   },
   "seasons": {
    "djf": 425,
    "jja": 278,
    "mam": 255,
    "son": 395
   },
   "summer_half": 533,
   "winter_half": 819
  },
  "PL8": {
   "cells": 56,
   "mm": 1162,
   "n": 314,
   "periods": {
    "1961-1990": 1098,
    "1981-2010": 1146,
    "1991-2020": 1162
   },
   "seasons": {
    "djf": 359,
    "jja": 239,
    "mam": 226,
    "son": 338
   },
   "summer_half": 465,
   "winter_half": 698
  },
  "PL9": {
   "cells": 36,
   "mm": 1127,
   "n": 1014,
   "periods": {
    "1961-1990": 1061,
    "1981-2010": 1098,
    "1991-2020": 1127
   },
   "seasons": {
    "djf": 350,
    "jja": 232,
    "mam": 218,
    "son": 326
   },
   "summer_half": 451,
   "winter_half": 677
  },
  "PL95": {
   "cells": 1,
   "mm": 1066,
   "n": 30,
   "periods": {
    "1961-1990": 1003,
    "1981-2010": 1033,
    "1991-2020": 1066
   },
   "seasons": {
    "djf": 331,
    "jja": 215,
    "mam": 209,
    "son": 311
   },
   "summer_half": 424,
   "winter_half": 642
  },
  "PO1": {
   "cells": 8,
   "mm": 762,
   "n": 915,
   "periods": {
    "1961-1990": 706,
    "1981-2010": 736,
    "1991-2020": 762
   },
   "seasons": {
    "djf": 231,
    "jja": 149,
    "mam": 141,
    "son": 241
   },
   "summer_half": 291,
   "winter_half": 472
  },
  "PO10": {
   "cells": 28,
   "mm": 839,
   "n": 613,
   "periods": {
    "1961-1990": 766,
    "1981-2010": 803,
    "1991-2020": 839
   },
   "seasons": {
    "djf": 255,
    "jja": 169,
    "mam": 152,
    "son": 263
   },
   "summer_half": 321,
   "winter_half": 518
  },
  "PO11": {
   "cells": 17,
   "mm": 746,
   "n": 472,
   "periods": {
    "1961-1990": 686,
    "1981-2010": 717,
    "1991-2020": 746
   },
   "seasons": {
    "djf": 227,
    "jja": 146,
    "mam": 138,
    "son": 236
   },
   "summer_half": 283,
   "winter_half": 463
  },
  "PO12": {
   "cells": 14,
   "mm": 790,
   "n": 1067,
   "periods": {
    "1961-1990": 725,
    "1981-2010": 762,
    "1991-2020": 790
   },
   "seasons": {
    "djf": 240,
    "jja": 156,
    "mam": 147,
    "son": 247
   },
   "summer_half": 303,
   "winter_half": 487
  },
  "PO13": {
   "cells": 20,
   "mm": 775,
   "n": 789,
   "periods": {
    "1961-1990": 706,
    "1981-2010": 748,
    "1991-2020": 775
   },
   "seasons": {
    "djf": 230,
    "jja": 158,
    "mam": 142,
    "son": 245
   },
   "summer_half": 300,
   "winter_half": 475
  },
  "PO14": {
   "cells": 34,
   "mm": 800,
   "n": 1039,
   "periods": {
    "1961-1990": 733,
    "1981-2010": 772,
    "1991-2020": 800
   },
   "seasons": {
    "djf": 238,
    "jja": 162,
    "mam": 148,
    "son": 253
   },
   "summer_half": 310,
   "winter_half": 490
  },
  "PO15": {
   "cells": 25,
   "mm": 837,
   "n": 708,
   "periods": {
    "1961-1990": 769,
    "1981-2010": 806,
    "1991-2020": 837
   },
   "seasons": {
    "djf": 249,
    "jja": 171,
    "mam": 156,
    "son": 261
   },
   "summer_half": 327,
   "winter_half": 510
  },
  "PO16": {
   "cells": 19,
   "mm": 820,
   "n": 997,
   "periods": {
    "1961-1990": 753,
    "1981-2010": 790,
    "1991-2020": 820
   },
   "seasons": {
    "djf": 244,
    "jja": 169,
    "mam": 152,
    "son": 255
   },
   "summer_half": 321,
   "winter_half": 499
  },
  "PO17": {
   "cells": 55,
   "mm": 878,
   "n": 334,
   "periods": {
    "1961-1990": 803,
    "1981-2010": 841,
    "1991-2020": 878
   },
   "seasons": {
    "djf": 262,
    "jja": 181,
    "mam": 162,
    "son": 272
   },
   "summer_half": 343,
   "winter_half": 535
  },
  "PO18": {
   "cells": 143,
   "mm": 923,
   "n": 696,
   "periods": {
    "1961-1990": 843,
    "1981-2010": 880,
    "1991-2020": 923
   },
   "seasons": {
    "djf": 281,
    "jja": 186,
    "mam": 166,
    "son": 290
   },
   "summer_half": 353,
   "winter_half": 570
  },
  "PO19": {
   "cells": 21,
   "mm": 827,
   "n": 1252,
   "periods": {
    "1961-1990": 762,
    "1981-2010": 797,
    "1991-2020": 827
   },
   "seasons": {
    "djf": 250,
    "jja": 170,
    "mam": 149,
    "son": 259
   },
   "summer_half": 318,
   "winter_half": 509
  },
  "PO2": {
   "cells": 9,
   "mm": 755,
   "n": 751,
   "periods": {
    "1961-1990": 698,
    "1981-2010": 730,
    "1991-2020": 755
   },
   "seasons": {
    "djf": 227,
    "jja": 151,
    "mam": 141,
    "son": 236
   },
   "summer_half": 292,
   "winter_half": 463
  },
  "PO20": {
   "cells": 105,
   "mm": 767,
   "n": 1274,
   "periods": {
    "1961-1990": 714,
    "1981-2010": 739,
    "1991-2020": 767
   },
   "seasons": {
    "djf": 233,
    "jja": 155,
    "mam": 141,
    "son": 239
   },
   "summer_half": 296,
   "winter_half": 472
  },
  "PO21": {
   "cells": 20,
   "mm": 751,
   "n": 1350,
   "periods": {
    "1961-1990": 713,
    "1981-2010": 733,
    "1991-2020": 751
   },
   "seasons": {
    "djf": 228,
    "jja": 151,
    "mam": 138,
    "son": 234
   },
   "summer_half": 289,
   "winter_half": 462
  },
  "PO22": {
   "cells": 28,
   "mm": 775,
   "n": 996,
   "periods": {
    "1961-1990": 738,
    "1981-2010": 759,
    "1991-2020": 775
   },
   "seasons": {
    "djf": 236,
    "jja": 155,
    "mam": 142,
    "son": 242
   },
   "summer_half": 297,
   "winter_half": 478
  },
  "PO3": {
   "cells": 14,
   "mm": 753,
   "n": 441,
   "periods": {
    "1961-1990": 697,
    "1981-2010": 729,
    "1991-2020": 753
   },
   "seasons": {
    "djf": 226,
    "jja": 150,
    "mam": 142,
    "son": 234
   },
   "summer_half": 292,
   "winter_half": 461
  },
  "PO30": {
   "cells": 124,
   "mm": 864,
   "n": 1084,
   "periods": {
    "1961-1990": 810,
    "1981-2010": 826,
    "1991-2020": 864
   },
   "seasons": {
    "djf": 269,
    "jja": 160,
    "mam": 157,
    "son": 279
   },
   "summer_half": 316,
   "winter_half": 547
  },
  "PO31": {
   "cells": 18,
   "mm": 842,
   "n": 466,
   "periods": {
    "1961-1990": 787,
    "1981-2010": 818,
    "1991-2020": 842
   },
   "seasons": {
    "djf": 260,
    "jja": 157,
    "mam": 153,
    "son": 273
   },
   "summer_half": 309,
   "winter_half": 533
  },
  "PO32": {
   "cells": 16,
   "mm": 828,
   "n": 252,
   "periods": {
    "1961-1990": 779,
    "1981-2010": 803,
    "1991-2020": 828
   },
   "seasons": {
    "djf": 258,
    "jja": 151,
    "mam": 149,
    "son": 269
   },
   "summer_half": 301,
   "winter_half": 527
  },
  "PO33": {
   "cells": 44,
   "mm": 812,
   "n": 1006,
   "periods": {
    "1961-1990": 777,
    "1981-2010": 792,
    "1991-2020": 812
   },
   "seasons": {
    "djf": 255,
    "jja": 148,
    "mam": 147,
    "son": 262
   },
   "summer_half": 295,
   "winter_half": 517
  },
  "PO34": {
   "cells": 4,
   "mm": 808,
   "n": 122,
   "periods": {
    "1961-1990": 773,
    "1981-2010": 789,
    "1991-2020": 808
   },
   "seasons": {
    "djf": 259,
    "jja": 152,
    "mam": 145,
    "son": 253
   },
   "summer_half": 297,
   "winter_half": 511
  },
  "PO35": {
   "cells": 4,
   "mm": 810,
   "n": 164,
   "periods": {
    "1961-1990": 765,
    "1981-2010": 783,
    "1991-2020": 810
   },
   "seasons": {
    "djf": 263,
    "jja": 153,
    "mam": 146,
    "son": 249
   },
   "summer_half": 298,
   "winter_half": 512
  },
  "PO36": {
   "cells": 31,
   "mm": 857,
   "n": 552,
   "periods": {
    "1961-1990": 801,
    "1981-2010": 826,
    "1991-2020": 857
   },
   "seasons": {
    "djf": 272,
    "jja": 153,
    "mam": 154,
    "son": 277
   },
   "summer_half": 307,
   "winter_half": 550
  },
  "PO37": {
   "cells": 8,
   "mm": 945,
   "n": 330,
   "periods": {
    "1961-1990": 868,
    "1981-2010": 881,
    "1991-2020": 945
   },
   "seasons": {
    "djf": 298,
    "jja": 173,
    "mam": 168,
    "son": 305
   },
   "summer_half": 341,
   "winter_half": 603
  },
  "PO38": {
   "cells": 65,
   "mm": 852,
   "n": 598,
   "periods": {
    "1961-1990": 820,
    "1981-2010": 813,
    "1991-2020": 852
   },
   "seasons": {
    "djf": 265,
    "jja": 158,
    "mam": 157,
    "son": 272
   },
   "summer_half": 315,
   "winter_half": 536
  },
  "PO39": {
   "cells": 5,
   "mm": 843,
   "n": 117,
   "periods": {
    "1961-1990": 802,
    "1981-2010": 829,
    "1991-2020": 843
   },
   "seasons": {
    "djf": 257,
    "jja": 156,
    "mam": 158,
    "son": 271
   },
   "summer_half": 314,
   "winter_half": 529
  },
  "PO4": {
   "cells": 8,
   "mm": 761,
   "n": 738,
   "periods": {
    "1961-1990": 707,
    "1981-2010": 736,
    "1991-2020": 761
   },
   "seasons": {
    "djf": 233,
    "jja": 145,
    "mam": 140,
    "son": 243
   },
   "summer_half": 285,
   "winter_half": 476
  },
  "PO40": {
   "cells": 10,
   "mm": 803,
   "n": 293,
   "periods": {
    "1961-1990": 770,
    "1981-2010": 793,
    "1991-2020": 803
   },
   "seasons": {
    "djf": 247,
    "jja": 148,
    "mam": 150,
    "son": 259
   },
   "summer_half": 297,
   "winter_half": 506
  },
  "PO41": {
   "cells": 25,
   "mm": 825,
   "n": 151,
   "periods": {
    "1961-1990": 774,
    "1981-2010": 796,
    "1991-2020": 825
   },
   "seasons": {
    "djf": 252,
    "jja": 154,
    "mam": 152,
    "son": 266
   },
   "summer_half": 306,
   "winter_half": 519
  },
  "PO5": {
   "cells": 8,
   "mm": 759,
   "n": 660,
   "periods": {
    "1961-1990": 704,
    "1981-2010": 733,
    "1991-2020": 759
   },
   "seasons": {
    "djf": 231,
    "jja": 146,
    "mam": 140,
    "son": 241
   },
   "summer_half": 287,
   "winter_half": 472
  },
  "PO6": {
   "cells": 19,
   "mm": 803,
   "n": 917,
   "periods": {
    "1961-1990": 742,
    "1981-2010": 777,
    "1991-2020": 803
   },
   "seasons": {
    "djf": 239,
    "jja": 165,
    "mam": 152,
    "son": 247
   },
   "summer_half": 317,
   "winter_half": 486
  },
  "PO7": {
   "cells": 57,
   "mm": 907,
   "n": 1259,
   "periods": {
    "1961-1990": 813,
    "1981-2010": 861,
    "1991-2020": 907
   },
   "seasons": {
    "djf": 270,
    "jja": 187,
    "mam": 167,
    "son": 282
   },
   "summer_half": 354,
   "winter_half": 552
  },
  "PO8": {
   "cells": 48,
   "mm": 1003,
   "n": 871,
   "periods": {
    "1961-1990": 923,
    "1981-2010": 956,
    "1991-2020": 1003
   },
   "seasons": {
    "djf": 301,
    "jja": 206,
    "mam": 184,
    "son": 312
   },
   "summer_half": 390,
   "winter_half": 613
  },
  "PO9": {
   "cells": 40,
   "mm": 872,
   "n": 1222,
   "periods": {
    "1961-1990": 808,
    "1981-2010": 844,
    "1991-2020": 872
   },
   "seasons": {
    "djf": 257,
    "jja": 179,
    "mam": 159,
    "son": 277
   },
   "summer_half": 338,
   "winter_half": 534
  },
  "PR0": {
   "cells": 1,
   "mm": 1062,
   "n": 17,
   "periods": {
    "1961-1990": 1010,
    "1981-2010": 1030,
    "1991-2020": 1062
   },
   "seasons": {
    "djf": 294,
    "jja": 266,
    "mam": 183,
    "son": 318
   },
   "summer_half": 449,
   "winter_half": 613
  },
  "PR1": {
   "cells": 33,
   "mm": 1038,
   "n": 1689,
   "periods": {
    "1961-1990": 989,
    "1981-2010": 1011,
    "1991-2020": 1038
   },
   "seasons": {
    "djf": 286,
    "jja": 260,
    "mam": 179,
    "son": 313
   },
   "summer_half": 440,
   "winter_half": 599
  },
  "PR11": {
   "cells": 2,
   "mm": 1091,
   "n": 53,
   "periods": {
    "1961-1990": 1041,
    "1981-2010": 1060,
    "1991-2020": 1091
   },
   "seasons": {
    "djf": 304,
    "jja": 272,
    "mam": 188,
    "son": 327
   },
   "summer_half": 460,
   "winter_half": 630
  },
  "PR2": {
   "cells": 49,
   "mm": 1065,
   "n": 1791,
   "periods": {
    "1961-1990": 1026,
    "1981-2010": 1042,
    "1991-2020": 1065
   },
   "seasons": {
    "djf": 295,
    "jja": 263,
    "mam": 186,
    "son": 320
   },
   "summer_half": 450,
   "winter_half": 616
  },
  "PR25": {
   "cells": 21,
   "mm": 994,
   "n": 768,
   "periods": {
    "1961-1990": 947,
    "1981-2010": 973,
    "1991-2020": 994
   },
   "seasons": {
    "djf": 288,
    "jja": 244,
    "mam": 167,
    "son": 294
   },
   "summer_half": 411,
   "winter_half": 582
  },
  "PR26": {
   "cells": 39,
   "mm": 950,
   "n": 348,
   "periods": {
    "1961-1990": 910,
    "1981-2010": 934,
    "1991-2020": 950
   },
   "seasons": {
    "djf": 271,
    "jja": 235,
    "mam": 161,
    "son": 283
   },
   "summer_half": 396,
   "winter_half": 554
  },
  "PR3": {
   "cells": 262,
   "mm": 1169,
   "n": 1471,
   "periods": {
    "1961-1990": 1120,
    "1981-2010": 1144,
    "1991-2020": 1169
   },
   "seasons": {
    "djf": 328,
    "jja": 281,
    "mam": 207,
    "son": 353
   },
   "summer_half": 488,
   "winter_half": 681
  },
  "PR4": {
   "cells": 177,
   "mm": 965,
   "n": 1834,
   "periods": {
    "1961-1990": 935,
    "1981-2010": 956,
    "1991-2020": 965
   },
   "seasons": {
    "djf": 261,
    "jja": 238,
    "mam": 171,
    "son": 294
   },
   "summer_half": 409,
   "winter_half": 556
  },
  "PR5": {
   "cells": 53,
   "mm": 1058,
   "n": 993,
   "periods": {
    "1961-1990": 1016,
    "1981-2010": 1037,
    "1991-2020": 1058
   },
   "seasons": {
    "djf": 296,
    "jja": 264,
    "mam": 187,
    "son": 311
   },
   "summer_half": 451,
   "winter_half": 607
  },
  "PR6": {
   "cells": 72,
   "mm": 1185,
   "n": 1060,
   "periods": {
    "1961-1990": 1134,
    "1981-2010": 1159,
    "1991-2020": 1185
   },
   "seasons": {
    "djf": 332,
    "jja": 289,
    "mam": 216,
    "son": 348
   },
   "summer_half": 505,
   "winter_half": 680
  },
  "PR7": {
   "cells": 71,
   "mm": 1070,
   "n": 1505,
   "periods": {
    "1961-1990": 1025,
    "1981-2010": 1046,
    "1991-2020": 1070
   },
   "seasons": {
    "djf": 295,
    "jja": 264,
    "mam": 193,
    "son": 319
   },
   "summer_half": 457,
   "winter_half": 613
  },
  "PR8": {
   "cells": 36,
   "mm": 877,
   "n": 1257,
   "periods": {
    "1961-1990": 847,
    "1981-2010": 863,
    "1991-2020": 877
   },
   "seasons": {
    "djf": 230,
    "jja": 217,
    "mam": 157,
    "son": 273
   },
   "summer_half": 375,
   "winter_half": 502
  },
  "PR9": {
   "cells": 43,
   "mm": 889,
   "n": 941,
   "periods": {
    "1961-1990": 865,
    "1981-2010": 880,
    "1991-2020": 889
   },
   "seasons": {
    "djf": 236,
    "jja": 217,
    "mam": 158,
    "son": 277
   },
   "summer_half": 376,
   "winter_half": 513
  },
  "RG1": {
   "cells": 15,
   "mm": 651,
   "n": 1254,
   "periods": {
    "1961-1990": 634,
    "1981-2010": 628,
    "1991-2020": 651
   },
   "seasons": {
    "djf": 176,
    "jja": 149,
    "mam": 132,
    "son": 194
   },
   "summer_half": 281,
   "winter_half": 370
  },
  "RG10": {
   "cells": 60,
   "mm": 679,
   "n": 677,
   "periods": {
    "1961-1990": 657,
    "1981-2010": 661,
    "1991-2020": 679
   },
   "seasons": {
    "djf": 181,
    "jja": 156,
    "mam": 138,
    "son": 203
   },
   "summer_half": 294,
   "winter_half": 384
  },
  "RG12": {
   "cells": 23,
   "mm": 697,
   "n": 1076,
   "periods": {
    "1961-1990": 679,
    "1981-2010": 690,
    "1991-2020": 697
   },
   "seasons": {
    "djf": 182,
    "jja": 162,
    "mam": 144,
    "son": 209
   },
   "summer_half": 306,
   "winter_half": 392
  },
  "RG14": {
   "cells": 38,
   "mm": 800,
   "n": 1298,
   "periods": {
    "1961-1990": 751,
    "1981-2010": 774,
    "1991-2020": 800
   },
   "seasons": {
    "djf": 224,
    "jja": 176,
    "mam": 164,
    "son": 236
   },
   "summer_half": 340,
   "winter_half": 460
  },
  "RG17": {
   "cells": 132,
   "mm": 813,
   "n": 663,
   "periods": {
    "1961-1990": 774,
    "1981-2010": 803,
    "1991-2020": 813
   },
   "seasons": {
    "djf": 232,
    "jja": 172,
    "mam": 174,
    "son": 235
   },
   "summer_half": 346,
   "winter_half": 467
  },
  "RG18": {
   "cells": 67,
   "mm": 735,
   "n": 543,
   "periods": {
    "1961-1990": 701,
    "1981-2010": 713,
    "1991-2020": 735
   },
   "seasons": {
    "djf": 202,
    "jja": 160,
    "mam": 154,
    "son": 219
   },
   "summer_half": 313,
   "winter_half": 422
  },
  "RG19": {
   "cells": 40,
   "mm": 761,
   "n": 492,
   "periods": {
    "1961-1990": 729,
    "1981-2010": 744,
    "1991-2020": 761
   },
   "seasons": {
    "djf": 216,
    "jja": 163,
    "mam": 157,
    "son": 225
   },
   "summer_half": 320,
   "winter_half": 440
  },
  "RG2": {
   "cells": 35,
   "mm": 657,
   "n": 1050,
   "periods": {
    "1961-1990": 632,
    "1981-2010": 638,
    "1991-2020": 657
   },
   "seasons": {
    "djf": 180,
    "jja": 150,
    "mam": 134,
    "son": 193
   },
   "summer_half": 284,
   "winter_half": 373
  },
  "RG20": {
   "cells": 201,
   "mm": 808,
   "n": 934,
   "periods": {
    "1961-1990": 770,
    "1981-2010": 789,
    "1991-2020": 808
   },
   "seasons": {
    "djf": 229,
    "jja": 172,
    "mam": 168,
    "son": 239
   },
   "summer_half": 340,
   "winter_half": 468
  },
  "RG21": {
   "cells": 14,
   "mm": 790,
   "n": 758,
   "periods": {
    "1961-1990": 751,
    "1981-2010": 776,
    "1991-2020": 790
   },
   "seasons": {
    "djf": 229,
    "jja": 164,
    "mam": 161,
    "son": 235
   },
   "summer_half": 325,
   "winter_half": 465
  },
  "RG22": {
   "cells": 21,
   "mm": 837,
   "n": 776,
   "periods": {
    "1961-1990": 785,
    "1981-2010": 816,
    "1991-2020": 837
   },
   "seasons": {
    "djf": 245,
    "jja": 173,
    "mam": 169,
    "son": 250
   },
   "summer_half": 342,
   "winter_half": 495
  },
  "RG23": {
   "cells": 32,
   "mm": 844,
   "n": 421,
   "periods": {
    "1961-1990": 792,
    "1981-2010": 823,
    "1991-2020": 844
   },
   "seasons": {
    "djf": 248,
    "jja": 173,
    "mam": 170,
    "son": 252
   },
   "summer_half": 344,
   "winter_half": 500
  },
  "RG24": {
   "cells": 34,
   "mm": 752,
   "n": 897,
   "periods": {
    "1961-1990": 718,
    "1981-2010": 739,
    "1991-2020": 752
   },
   "seasons": {
    "djf": 217,
    "jja": 157,
    "mam": 153,
    "son": 224
   },
   "summer_half": 311,
   "winter_half": 442
  },
  "RG25": {
   "cells": 101,
   "mm": 869,
   "n": 395,
   "periods": {
    "1961-1990": 807,
    "1981-2010": 841,
    "1991-2020": 869
   },
   "seasons": {
    "djf": 254,
    "jja": 181,
    "mam": 173,
    "son": 261
   },
   "summer_half": 353,
   "winter_half": 515
  },
  "RG26": {
   "cells": 80,
   "mm": 784,
   "n": 651,
   "periods": {
    "1961-1990": 746,
    "1981-2010": 770,
    "1991-2020": 784
   },
   "seasons": {
    "djf": 224,
    "jja": 165,
    "mam": 161,
    "son": 234
   },
   "summer_half": 326,
   "winter_half": 458
  },
  "RG27": {
   "cells": 115,
   "mm": 717,
   "n": 849,
   "periods": {
    "1961-1990": 679,
    "1981-2010": 700,
    "1991-2020": 717
   },
   "seasons": {
    "djf": 200,
    "jja": 158,
    "mam": 145,
    "son": 215
   },
   "summer_half": 303,
   "winter_half": 415
  },
  "RG28": {
   "cells": 43,
   "mm": 843,
   "n": 235,
   "periods": {
    "1961-1990": 788,
    "1981-2010": 821,
    "1991-2020": 843
   },
   "seasons": {
    "djf": 241,
    "jja": 180,
    "mam": 168,
    "son": 254
   },
   "summer_half": 348,
   "winter_half": 495
  },
  "RG29": {
   "cells": 40,
   "mm": 805,
   "n": 274,
   "periods": {
    "1961-1990": 747,
    "1981-2010": 780,
    "1991-2020": 805
   },
   "seasons": {
    "djf": 234,
    "jja": 168,
    "mam": 158,
    "son": 245
   },
   "summer_half": 326,
   "winter_half": 479
  },
  "RG30": {
   "cells": 31,
   "mm": 674,
   "n": 969,
   "periods": {
    "1961-1990": 650,
    "1981-2010": 655,
    "1991-2020": 674
   },
   "seasons": {
    "djf": 185,
    "jja": 150,
    "mam": 139,
    "son": 201
   },
   "summer_half": 289,
   "winter_half": 385
  },
  "RG31": {
   "cells": 16,
   "mm": 688,
   "n": 639,
   "periods": {
    "1961-1990": 666,
    "1981-2010": 670,
    "1991-2020": 688
   },
   "seasons": {
    "djf": 190,
    "jja": 152,
    "mam": 142,
    "son": 204
   },
   "summer_half": 294,
   "winter_half": 394
  },
  "RG4": {
   "cells": 53,
   "mm": 714,
   "n": 1000,
   "periods": {
    "1961-1990": 691,
    "1981-2010": 693,
    "1991-2020": 714
   },
   "seasons": {
    "djf": 194,
    "jja": 160,
    "mam": 146,
    "son": 214
   },
   "summer_half": 306,
   "winter_half": 408
  },
  "RG40": {
   "cells": 57,
   "mm": 690,
   "n": 1006,
   "periods": {
    "1961-1990": 661,
    "1981-2010": 674,
    "1991-2020": 690
   },
   "seasons": {
    "djf": 184,
    "jja": 159,
    "mam": 140,
    "son": 208
   },
   "summer_half": 298,
   "winter_half": 391
  },
  "RG41": {
   "cells": 26,
   "mm": 677,
   "n": 769,
   "periods": {
    "1961-1990": 652,
    "1981-2010": 658,
    "1991-2020": 677
   },
   "seasons": {
    "djf": 182,
    "jja": 155,
    "mam": 136,
    "son": 204
   },
   "summer_half": 291,
   "winter_half": 386
  },
  "RG42": {
   "cells": 39,
   "mm": 646,
   "n": 964,
   "periods": {
    "1961-1990": 650,
    "1981-2010": 642,
    "1991-2020": 646
   },
   "seasons": {
    "djf": 170,
    "jja": 150,
    "mam": 132,
    "son": 194
   },
   "summer_half": 282,
   "winter_half": 364
  },
  "RG45": {
   "cells": 16,
   "mm": 693,
   "n": 456,
   "periods": {
    "1961-1990": 658,
    "1981-2010": 681,
    "1991-2020": 693
   },
   "seasons": {
    "djf": 187,
    "jja": 157,
    "mam": 140,
    "son": 208
   },
   "summer_half": 298,
   "winter_half": 395
  },
  "RG5": {
   "cells": 14,
   "mm": 654,
   "n": 503,
   "periods": {
    "1961-1990": 631,
    "1981-2010": 634,
    "1991-2020": 654
   },
   "seasons": {
    "djf": 175,
    "jja": 151,
    "mam": 132,
    "son": 196
   },
   "summer_half": 284,
   "winter_half": 371
  },
  "RG6": {
   "cells": 20,
   "mm": 655,
   "n": 752,
   "periods": {
    "1961-1990": 634,
    "1981-2010": 634,
    "1991-2020": 655
   },
   "seasons": {
    "djf": 175,
    "jja": 153,
    "mam": 133,
    "son": 195
   },
   "summer_half": 285,
   "winter_half": 370
  },
  "RG7": {
   "cells": 193,
   "mm": 712,
   "n": 1516,
   "periods": {
    "1961-1990": 671,
    "1981-2010": 693,
    "1991-2020": 712
   },
   "seasons": {
    "djf": 195,
    "jja": 158,
    "mam": 146,
    "son": 212
   },
   "summer_half": 305,
   "winter_half": 407
  },
  "RG8": {
   "cells": 103,
   "mm": 732,
   "n": 849,
   "periods": {
    "1961-1990": 704,
    "1981-2010": 720,
    "1991-2020": 732
   },
   "seasons": {
    "djf": 198,
    "jja": 161,
    "mam": 154,
    "son": 219
   },
   "summer_half": 315,
   "winter_half": 417
  },
  "RG9": {
   "cells": 143,
   "mm": 761,
   "n": 1135,
   "periods": {
    "1961-1990": 734,
    "1981-2010": 746,
    "1991-2020": 761
   },
   "seasons": {
    "djf": 205,
    "jja": 168,
    "mam": 161,
    "son": 227
   },
   "summer_half": 329,
   "winter_half": 432
  },
  "RH1": {
   "cells": 69,
   "mm": 798,
   "n": 1246,
   "periods": {
    "1961-1990": 757,
    "1981-2010": 777,
    "1991-2020": 798
   },
   "seasons": {
    "djf": 236,
    "jja": 168,
    "mam": 153,
    "son": 241
   },
   "summer_half": 321,
   "winter_half": 477
  },
  "RH10": {
   "cells": 63,
   "mm": 871,
   "n": 1912,
   "periods": {
    "1961-1990": 825,
    "1981-2010": 840,
    "1991-2020": 871
   },
   "seasons": {
    "djf": 266,
    "jja": 177,
    "mam": 163,
    "son": 265
   },
   "summer_half": 340,
   "winter_half": 531
  },
  "RH11": {
   "cells": 36,
   "mm": 860,
   "n": 1186,
   "periods": {
    "1961-1990": 813,
    "1981-2010": 826,
    "1991-2020": 860
   },
   "seasons": {
    "djf": 260,
    "jja": 175,
    "mam": 163,
    "son": 262
   },
   "summer_half": 338,
   "winter_half": 522
  },
  "RH12": {
   "cells": 100,
   "mm": 843,
   "n": 1384,
   "periods": {
    "1961-1990": 798,
    "1981-2010": 813,
    "1991-2020": 843
   },
   "seasons": {
    "djf": 252,
    "jja": 172,
    "mam": 160,
    "son": 259
   },
   "summer_half": 332,
   "winter_half": 510
  },
  "RH13": {
   "cells": 154,
   "mm": 828,
   "n": 1125,
   "periods": {
    "1961-1990": 785,
    "1981-2010": 807,
    "1991-2020": 828
   },
   "seasons": {
    "djf": 249,
    "jja": 167,
    "mam": 156,
    "son": 256
   },
   "summer_half": 323,
   "winter_half": 505
  },
  "RH14": {
   "cells": 95,
   "mm": 829,
   "n": 599,
   "periods": {
    "1961-1990": 780,
    "1981-2010": 811,
    "1991-2020": 829
   },
   "seasons": {
    "djf": 250,
    "jja": 166,
    "mam": 155,
    "son": 258
   },
   "summer_half": 321,
   "winter_half": 508
  },
  "RH15": {
   "cells": 23,
   "mm": 871,
   "n": 910,
   "periods": {
    "1961-1990": 816,
    "1981-2010": 845,
    "1991-2020": 871
   },
   "seasons": {
    "djf": 265,
    "jja": 176,
    "mam": 158,
    "son": 273
   },
   "summer_half": 334,
   "winter_half": 538
  },
  "RH16": {
   "cells": 30,
   "mm": 886,
   "n": 1118,
   "periods": {
    "1961-1990": 823,
    "1981-2010": 853,
    "1991-2020": 886
   },
   "seasons": {
    "djf": 269,
    "jja": 178,
    "mam": 161,
    "son": 278
   },
   "summer_half": 339,
   "winter_half": 547
  },
  "RH17": {
   "cells": 149,
   "mm": 888,
   "n": 718,
   "periods": {
    "1961-1990": 834,
    "1981-2010": 859,
    "1991-2020": 888
   },
   "seasons": {
    "djf": 268,
    "jja": 181,
    "mam": 164,
    "son": 275
   },
   "summer_half": 345,
   "winter_half": 543
  },
  "RH18": {
   "cells": 22,
   "mm": 918,
   "n": 141,
   "periods": {
    "1961-1990": 880,
    "1981-2010": 898,
    "1991-2020": 918
   },
   "seasons": {
    "djf": 283,
    "jja": 184,
    "mam": 171,
    "son": 280
   },
   "summer_half": 355,
   "winter_half": 563
  },
  "RH19": {
   "cells": 77,
   "mm": 892,
   "n": 1113,
   "periods": {
    "1961-1990": 838,
    "1981-2010": 863,
    "1991-2020": 892
   },
   "seasons": {
    "djf": 274,
    "jja": 177,
    "mam": 169,
    "son": 272
   },
   "summer_half": 347,
   "winter_half": 546
  },
  "RH2": {
   "cells": 48,
   "mm": 797,
   "n": 841,
   "periods": {
    "1961-1990": 751,
    "1981-2010": 772,
    "1991-2020": 797
   },
   "seasons": {
    "djf": 241,
    "jja": 161,
    "mam": 155,
    "son": 240
   },
   "summer_half": 316,
   "winter_half": 481
  },
  "RH20": {
   "cells": 121,
   "mm": 937,
   "n": 894,
   "periods": {
    "1961-1990": 863,
    "1981-2010": 907,
    "1991-2020": 937
   },
   "seasons": {
    "djf": 286,
    "jja": 185,
    "mam": 175,
    "son": 291
   },
   "summer_half": 360,
   "winter_half": 577
  },
  "RH3": {
   "cells": 20,
   "mm": 799,
   "n": 145,
   "periods": {
    "1961-1990": 757,
    "1981-2010": 775,
    "1991-2020": 799
   },
   "seasons": {
    "djf": 241,
    "jja": 159,
    "mam": 156,
    "son": 243
   },
   "summer_half": 315,
   "winter_half": 484
  },
  "RH4": {
   "cells": 24,
   "mm": 828,
   "n": 667,
   "periods": {
    "1961-1990": 794,
    "1981-2010": 811,
    "1991-2020": 828
   },
   "seasons": {
    "djf": 249,
    "jja": 169,
    "mam": 161,
    "son": 249
   },
   "summer_half": 330,
   "winter_half": 498
  },
  "RH5": {
   "cells": 130,
   "mm": 854,
   "n": 642,
   "periods": {
    "1961-1990": 811,
    "1981-2010": 829,
    "1991-2020": 854
   },
   "seasons": {
    "djf": 255,
    "jja": 176,
    "mam": 165,
    "son": 258
   },
   "summer_half": 341,
   "winter_half": 513
  },
  "RH6": {
   "cells": 59,
   "mm": 807,
   "n": 893,
   "periods": {
    "1961-1990": 761,
    "1981-2010": 777,
    "1991-2020": 807
   },
   "seasons": {
    "djf": 241,
    "jja": 166,
    "mam": 154,
    "son": 246
   },
   "summer_half": 320,
   "winter_half": 487
  },
  "RH7": {
   "cells": 40,
   "mm": 789,
   "n": 236,
   "periods": {
    "1961-1990": 749,
    "1981-2010": 766,
    "1991-2020": 789
   },
   "seasons": {
    "djf": 237,
    "jja": 162,
    "mam": 150,
    "son": 239
   },
   "summer_half": 312,
   "winter_half": 477
  },
  "RH77": {
   "cells": 1,
   "mm": 800,
   "n": 16,
   "periods": {
    "1961-1990": 760,
    "1981-2010": 766,
    "1991-2020": 800
   },
   "seasons": {
    "djf": 242,
    "jja": 161,
    "mam": 152,
    "son": 245
   },
   "summer_half": 313,
   "winter_half": 487
  },
  "RH8": {
   "cells": 35,
   "mm": 801,
   "n": 421,
   "periods": {
    "1961-1990": 770,
    "1981-2010": 783,
    "1991-2020": 801
   },
   "seasons": {
    "djf": 238,
    "jja": 167,
    "mam": 155,
    "son": 242
   },
   "summer_half": 321,
   "winter_half": 479
  },
  "RH9": {
   "cells": 26,
   "mm": 806,
   "n": 151,
   "periods": {
    "1961-1990": 775,
    "1981-2010": 789,
    "1991-2020": 806
   },
   "seasons": {
    "djf": 240,
    "jja": 168,
    "mam": 153,
    "son": 245
   },
   "summer_half": 321,
   "winter_half": 484
  },
  "RM1": {
   "cells": 13,
   "mm": 596,
   "n": 511,
   "periods": {
    "1961-1990": 581,
    "1981-2010": 588,
    "1991-2020": 596
   },
   "seasons": {
    "djf": 148,
    "jja": 154,
    "mam": 121,
    "son": 173
   },
   "summer_half": 275,
   "winter_half": 321
  },
  "RM10": {
   "cells": 12,
   "mm": 581,
   "n": 583,
   "periods": {
    "1961-1990": 559,
    "1981-2010": 566,
    "1991-2020": 581
   },
   "seasons": {
    "djf": 149,
    "jja": 144,
    "mam": 119,
    "son": 169
   },
   "summer_half": 263,
   "winter_half": 318
  },
  "RM11": {
   "cells": 17,
   "mm": 592,
   "n": 572,
   "periods": {
    "1961-1990": 581,
    "1981-2010": 585,
    "1991-2020": 592
   },
   "seasons": {
    "djf": 151,
    "jja": 147,
    "mam": 122,
    "son": 173
   },
   "summer_half": 269,
   "winter_half": 324
  },
  "RM12": {
   "cells": 15,
   "mm": 585,
   "n": 628,
   "periods": {
    "1961-1990": 571,
    "1981-2010": 575,
    "1991-2020": 585
   },
   "seasons": {
    "djf": 149,
    "jja": 145,
    "mam": 121,
    "son": 170
   },
   "summer_half": 266,
   "winter_half": 319
  },
  "RM13": {
   "cells": 21,
   "mm": 573,
   "n": 659,
   "periods": {
    "1961-1990": 549,
    "1981-2010": 556,
    "1991-2020": 573
   },
   "seasons": {
    "djf": 149,
    "jja": 140,
    "mam": 116,
    "son": 168
   },
   "summer_half": 256,
   "winter_half": 317
  },
  "RM14": {
   "cells": 44,
   "mm": 589,
   "n": 619,
   "periods": {
    "1961-1990": 578,
    "1981-2010": 582,
    "1991-2020": 589
   },
   "seasons": {
    "djf": 150,
    "jja": 147,
    "mam": 120,
    "son": 172
   },
   "summer_half": 267,
   "winter_half": 322
  },
  "RM15": {
   "cells": 23,
   "mm": 589,
   "n": 574,
   "periods": {
    "1961-1990": 570,
    "1981-2010": 576,
    "1991-2020": 589
   },
   "seasons": {
    "djf": 150,
    "jja": 148,
    "mam": 118,
    "son": 172
   },
   "summer_half": 266,
   "winter_half": 322
  },
  "RM16": {
   "cells": 37,
   "mm": 568,
   "n": 697,
   "periods": {
    "1961-1990": 551,
    "1981-2010": 557,
    "1991-2020": 568
   },
   "seasons": {
    "djf": 145,
    "jja": 147,
    "mam": 113,
    "son": 164
   },
   "summer_half": 260,
   "winter_half": 308
  },
  "RM17": {
   "cells": 11,
   "mm": 546,
   "n": 534,
   "periods": {
    "1961-1990": 524,
    "1981-2010": 534,
    "1991-2020": 546
   },
   "seasons": {
    "djf": 138,
    "jja": 145,
    "mam": 107,
    "son": 157
   },
   "summer_half": 252,
   "winter_half": 294
  },
  "RM18": {
   "cells": 22,
   "mm": 550,
   "n": 332,
   "periods": {
    "1961-1990": 532,
    "1981-2010": 535,
    "1991-2020": 550
   },
   "seasons": {
    "djf": 140,
    "jja": 137,
    "mam": 111,
    "son": 163
   },
   "summer_half": 247,
   "winter_half": 303
  },
  "RM19": {
   "cells": 7,
   "mm": 565,
   "n": 143,
   "periods": {
    "1961-1990": 543,
    "1981-2010": 551,
    "1991-2020": 565
   },
   "seasons": {
    "djf": 145,
    "jja": 139,
    "mam": 114,
    "son": 167
   },
   "summer_half": 253,
   "winter_half": 312
  },
  "RM2": {
   "cells": 10,
   "mm": 590,
   "n": 268,
   "periods": {
    "1961-1990": 575,
    "1981-2010": 581,
    "1991-2020": 590
   },
   "seasons": {
    "djf": 150,
    "jja": 147,
    "mam": 120,
    "son": 173
   },
   "summer_half": 267,
   "winter_half": 323
  },
  "RM20": {
   "cells": 10,
   "mm": 557,
   "n": 160,
   "periods": {
    "1961-1990": 535,
    "1981-2010": 547,
    "1991-2020": 557
   },
   "seasons": {
    "djf": 142,
    "jja": 140,
    "mam": 111,
    "son": 164
   },
   "summer_half": 251,
   "winter_half": 306
  },
  "RM3": {
   "cells": 17,
   "mm": 597,
   "n": 924,
   "periods": {
    "1961-1990": 585,
    "1981-2010": 592,
    "1991-2020": 597
   },
   "seasons": {
    "djf": 148,
    "jja": 151,
    "mam": 122,
    "son": 176
   },
   "summer_half": 273,
   "winter_half": 324
  },
  "RM4": {
   "cells": 46,
   "mm": 642,
   "n": 160,
   "periods": {
    "1961-1990": 627,
    "1981-2010": 636,
    "1991-2020": 642
   },
   "seasons": {
    "djf": 162,
    "jja": 165,
    "mam": 127,
    "son": 188
   },
   "summer_half": 292,
   "winter_half": 350
  },
  "RM5": {
   "cells": 10,
   "mm": 616,
   "n": 379,
   "periods": {
    "1961-1990": 594,
    "1981-2010": 607,
    "1991-2020": 616
   },
   "seasons": {
    "djf": 154,
    "jja": 159,
    "mam": 123,
    "son": 180
   },
   "summer_half": 283,
   "winter_half": 333
  },
  "RM6": {
   "cells": 12,
   "mm": 621,
   "n": 530,
   "periods": {
    "1961-1990": 600,
    "1981-2010": 606,
    "1991-2020": 621
   },
   "seasons": {
    "djf": 160,
    "jja": 156,
    "mam": 123,
    "son": 182
   },
   "summer_half": 280,
   "winter_half": 342
  },
  "RM7": {
   "cells": 14,
   "mm": 591,
   "n": 576,
   "periods": {
    "1961-1990": 574,
    "1981-2010": 580,
    "1991-2020": 591
   },
   "seasons": {
    "djf": 150,
    "jja": 149,
    "mam": 120,
    "son": 172
   },
   "summer_half": 269,
   "winter_half": 322
  },
  "RM8": {
   "cells": 12,
   "mm": 589,
   "n": 587,
   "periods": {
    "1961-1990": 570,
    "1981-2010": 575,
    "1991-2020": 589
   },
   "seasons": {
    "djf": 152,
    "jja": 147,
    "mam": 119,
    "son": 172
   },
   "summer_half": 266,
   "winter_half": 324
  },
  "RM9": {
   "cells": 18,
   "mm": 583,
   "n": 566,
   "periods": {
    "1961-1990": 557,
    "1981-2010": 565,
    "1991-2020": 583
   },
   "seasons": {
    "djf": 151,
    "jja": 144,
    "mam": 118,
    "son": 170
   },
   "summer_half": 262,
   "winter_half": 321
  },
  "S1": {
   "cells": 4,
   "mm": 778,
   "n": 518,
   "periods": {
    "1961-1990": 762,
    "1981-2010": 778,
    "1991-2020": 778
   },
   "seasons": {
    "djf": 215,
    "jja": 189,
    "mam": 163,
    "son": 211
   },
   "summer_half": 353,
   "winter_half": 426
  },
  "S10": {
   "cells": 28,
   "mm": 965,
   "n": 927,
   "periods": {
    "1961-1990": 922,
    "1981-2010": 952,
    "1991-2020": 965
   },
   "seasons": {
    "djf": 269,
    "jja": 229,
    "mam": 200,
    "son": 266
   },
   "summer_half": 429,
   "winter_half": 536
  },
  "S11": {
   "cells": 23,
   "mm": 934,
   "n": 659,
   "periods": {
    "1961-1990": 902,
    "1981-2010": 924,
    "1991-2020": 934
   },
   "seasons": {
    "djf": 259,
    "jja": 225,
    "mam": 192,
    "son": 258
   },
   "summer_half": 417,
   "winter_half": 517
  },
  "S12": {
   "cells": 20,
   "mm": 820,
   "n": 655,
   "periods": {
    "1961-1990": 794,
    "1981-2010": 815,
    "1991-2020": 820
   },
   "seasons": {
    "djf": 216,
    "jja": 209,
    "mam": 167,
    "son": 227
   },
   "summer_half": 376,
   "winter_half": 444
  },
  "S13": {
   "cells": 20,
   "mm": 755,
   "n": 590,
   "periods": {
    "1961-1990": 724,
    "1981-2010": 748,
    "1991-2020": 755
   },
   "seasons": {
    "djf": 194,
    "jja": 197,
    "mam": 154,
    "son": 210
   },
   "summer_half": 351,
   "winter_half": 404
  },
  "S14": {
   "cells": 6,
   "mm": 881,
   "n": 183,
   "periods": {
    "1961-1990": 867,
    "1981-2010": 880,
    "1991-2020": 881
   },
   "seasons": {
    "djf": 238,
    "jja": 217,
    "mam": 182,
    "son": 244
   },
   "summer_half": 399,
   "winter_half": 482
  },
  "S17": {
   "cells": 17,
   "mm": 887,
   "n": 366,
   "periods": {
    "1961-1990": 871,
    "1981-2010": 883,
    "1991-2020": 887
   },
   "seasons": {
    "djf": 247,
    "jja": 209,
    "mam": 187,
    "son": 244
   },
   "summer_half": 396,
   "winter_half": 491
  },
  "S18": {
   "cells": 39,
   "mm": 824,
   "n": 594,
   "periods": {
    "1961-1990": 809,
    "1981-2010": 820,
    "1991-2020": 824
   },
   "seasons": {
    "djf": 220,
    "jja": 202,
    "mam": 174,
    "son": 228
   },
   "summer_half": 376,
   "winter_half": 448
  },
  "S2": {
   "cells": 19,
   "mm": 810,
   "n": 981,
   "periods": {
    "1961-1990": 790,
    "1981-2010": 808,
    "1991-2020": 810
   },
   "seasons": {
    "djf": 219,
    "jja": 200,
    "mam": 168,
    "son": 222
   },
   "summer_half": 368,
   "winter_half": 442
  },
  "S20": {
   "cells": 19,
   "mm": 729,
   "n": 635,
   "periods": {
    "1961-1990": 702,
    "1981-2010": 721,
    "1991-2020": 729
   },
   "seasons": {
    "djf": 185,
    "jja": 192,
    "mam": 149,
    "son": 202
   },
   "summer_half": 341,
   "winter_half": 388
  },
  "S21": {
   "cells": 32,
   "mm": 724,
   "n": 466,
   "periods": {
    "1961-1990": 702,
    "1981-2010": 714,
    "1991-2020": 724
   },
   "seasons": {
    "djf": 185,
    "jja": 189,
    "mam": 149,
    "son": 201
   },
   "summer_half": 338,
   "winter_half": 386
  },
  "S25": {
   "cells": 21,
   "mm": 687,
   "n": 503,
   "periods": {
    "1961-1990": 683,
    "1981-2010": 683,
    "1991-2020": 687
   },
   "seasons": {
    "djf": 159,
    "jja": 196,
    "mam": 140,
    "son": 191
   },
   "summer_half": 336,
   "winter_half": 350
  },
  "S26": {
   "cells": 34,
   "mm": 688,
   "n": 547,
   "periods": {
    "1961-1990": 673,
    "1981-2010": 680,
    "1991-2020": 688
   },
   "seasons": {
    "djf": 165,
    "jja": 191,
    "mam": 140,
    "son": 192
   },
   "summer_half": 331,
   "winter_half": 357
  },
  "S3": {
   "cells": 8,
   "mm": 773,
   "n": 532,
   "periods": {
    "1961-1990": 755,
    "1981-2010": 773,
    "1991-2020": 773
   },
   "seasons": {
    "djf": 212,
    "jja": 189,
    "mam": 163,
    "son": 210
   },
   "summer_half": 352,
   "winter_half": 422
  },
  "S32": {
   "cells": 34,
   "mm": 1005,
   "n": 206,
   "periods": {
    "1961-1990": 980,
    "1981-2010": 1004,
    "1991-2020": 1005
   },
   "seasons": {
    "djf": 288,
    "jja": 234,
    "mam": 205,
    "son": 278
   },
   "summer_half": 439,
   "winter_half": 566
  },
  "S33": {
   "cells": 37,
   "mm": 1159,
   "n": 168,
   "periods": {
    "1961-1990": 1112,
    "1981-2010": 1144,
    "1991-2020": 1159
   },
   "seasons": {
    "djf": 345,
    "jja": 257,
    "mam": 232,
    "son": 324
   },
   "summer_half": 489,
   "winter_half": 670
  },
  "S35": {
   "cells": 60,
   "mm": 827,
   "n": 890,
   "periods": {
    "1961-1990": 824,
    "1981-2010": 827,
    "1991-2020": 827
   },
   "seasons": {
    "djf": 230,
    "jja": 200,
    "mam": 174,
    "son": 223
   },
   "summer_half": 374,
   "winter_half": 453
  },
  "S36": {
   "cells": 77,
   "mm": 1040,
   "n": 763,
   "periods": {
    "1961-1990": 1032,
    "1981-2010": 1038,
    "1991-2020": 1040
   },
   "seasons": {
    "djf": 308,
    "jja": 234,
    "mam": 215,
    "son": 282
   },
   "summer_half": 450,
   "winter_half": 590
  },
  "S4": {
   "cells": 12,
   "mm": 749,
   "n": 298,
   "periods": {
    "1961-1990": 728,
    "1981-2010": 747,
    "1991-2020": 749
   },
   "seasons": {
    "djf": 201,
    "jja": 187,
    "mam": 158,
    "son": 204
   },
   "summer_half": 345,
   "winter_half": 405
  },
  "S40": {
   "cells": 19,
   "mm": 782,
   "n": 1086,
   "periods": {
    "1961-1990": 761,
    "1981-2010": 771,
    "1991-2020": 782
   },
   "seasons": {
    "djf": 210,
    "jja": 188,
    "mam": 162,
    "son": 222
   },
   "summer_half": 349,
   "winter_half": 432
  },
  "S41": {
   "cells": 33,
   "mm": 763,
   "n": 1003,
   "periods": {
    "1961-1990": 739,
    "1981-2010": 751,
    "1991-2020": 763
   },
   "seasons": {
    "djf": 204,
    "jja": 186,
    "mam": 157,
    "son": 216
   },
   "summer_half": 343,
   "winter_half": 420
  },
  "S42": {
   "cells": 69,
   "mm": 846,
   "n": 848,
   "periods": {
    "1961-1990": 816,
    "1981-2010": 831,
    "1991-2020": 846
   },
   "seasons": {
    "djf": 226,
    "jja": 206,
    "mam": 176,
    "son": 238
   },
   "summer_half": 383,
   "winter_half": 463
  },
  "S43": {
   "cells": 49,
   "mm": 716,
   "n": 1109,
   "periods": {
    "1961-1990": 693,
    "1981-2010": 702,
    "1991-2020": 716
   },
   "seasons": {
    "djf": 182,
    "jja": 188,
    "mam": 147,
    "son": 199
   },
   "summer_half": 335,
   "winter_half": 381
  },
  "S44": {
   "cells": 57,
   "mm": 747,
   "n": 622,
   "periods": {
    "1961-1990": 718,
    "1981-2010": 732,
    "1991-2020": 747
   },
   "seasons": {
    "djf": 193,
    "jja": 191,
    "mam": 154,
    "son": 209
   },
   "summer_half": 345,
   "winter_half": 402
  },
  "S45": {
   "cells": 57,
   "mm": 895,
   "n": 516,
   "periods": {
    "1961-1990": 851,
    "1981-2010": 876,
    "1991-2020": 895
   },
   "seasons": {
    "djf": 236,
    "jja": 220,
    "mam": 186,
    "son": 253
   },
   "summer_half": 406,
   "winter_half": 489
  },
  "S49": {
   "cells": 1,
   "mm": 763,
   "n": 8,
   "periods": {
    "1961-1990": 744,
    "1981-2010": 753,
    "1991-2020": 763
   },
   "seasons": {
    "djf": 207,
    "jja": 180,
    "mam": 155,
    "son": 221
   },
   "summer_half": 335,
   "winter_half": 428
  },
  "S5": {
   "cells": 22,
   "mm": 762,
   "n": 1051,
   "periods": {
    "1961-1990": 740,
    "1981-2010": 757,
    "1991-2020": 762
   },
   "seasons": {
    "djf": 202,
    "jja": 189,
    "mam": 162,
    "son": 208
   },
   "summer_half": 351,
   "winter_half": 410
  },
  "S6": {
   "cells": 57,
   "mm": 966,
   "n": 1235,
   "periods": {
    "1961-1990": 934,
    "1981-2010": 955,
    "1991-2020": 966
   },
   "seasons": {
    "djf": 281,
    "jja": 220,
    "mam": 200,
    "son": 264
   },
   "summer_half": 421,
   "winter_half": 545
  },
  "S60": {
   "cells": 37,
   "mm": 684,
   "n": 1118,
   "periods": {
    "1961-1990": 661,
    "1981-2010": 678,
    "1991-2020": 684
   },
   "seasons": {
    "djf": 166,
    "jja": 186,
    "mam": 142,
    "son": 190
   },
   "summer_half": 328,
   "winter_half": 355
  },
  "S61": {
   "cells": 28,
   "mm": 712,
   "n": 869,
   "periods": {
    "1961-1990": 695,
    "1981-2010": 707,
    "1991-2020": 712
   },
   "seasons": {
    "djf": 179,
    "jja": 189,
    "mam": 148,
    "son": 196
   },
   "summer_half": 337,
   "winter_half": 374
  },
  "S62": {
   "cells": 26,
   "mm": 675,
   "n": 620,
   "periods": {
    "1961-1990": 668,
    "1981-2010": 670,
    "1991-2020": 675
   },
   "seasons": {
    "djf": 164,
    "jja": 185,
    "mam": 141,
    "son": 185
   },
   "summer_half": 326,
   "winter_half": 349
  },
  "S63": {
   "cells": 35,
   "mm": 610,
   "n": 1156,
   "periods": {
    "1961-1990": 604,
    "1981-2010": 604,
    "1991-2020": 610
   },
   "seasons": {
    "djf": 138,
    "jja": 177,
    "mam": 129,
    "son": 166
   },
   "summer_half": 306,
   "winter_half": 304
  },
  "S64": {
   "cells": 23,
   "mm": 587,
   "n": 680,
   "periods": {
    "1961-1990": 588,
    "1981-2010": 583,
    "1991-2020": 587
   },
   "seasons": {
    "djf": 131,
    "jja": 170,
    "mam": 124,
    "son": 161
   },
   "summer_half": 294,
   "winter_half": 292
  },
  "S65": {
   "cells": 33,
   "mm": 658,
   "n": 830,
   "periods": {
    "1961-1990": 656,
    "1981-2010": 655,
    "1991-2020": 658
   },
   "seasons": {
    "djf": 153,
    "jja": 183,
    "mam": 139,
    "son": 183
   },
   "summer_half": 322,
   "winter_half": 336
  },
  "S66": {
   "cells": 53,
   "mm": 686,
   "n": 1098,
   "periods": {
    "1961-1990": 685,
    "1981-2010": 683,
    "1991-2020": 686
   },
   "seasons": {
    "djf": 158,
    "jja": 195,
    "mam": 140,
    "son": 194
   },
   "summer_half": 334,
   "winter_half": 352
  },
  "S7": {
   "cells": 10,
   "mm": 821,
   "n": 302,
   "periods": {
    "1961-1990": 805,
    "1981-2010": 817,
    "1991-2020": 821
   },
   "seasons": {
    "djf": 228,
    "jja": 197,
    "mam": 172,
    "son": 224
   },
   "summer_half": 368,
   "winter_half": 452
  },
  "S70": {
   "cells": 26,
   "mm": 694,
   "n": 1292,
   "periods": {
    "1961-1990": 683,
    "1981-2010": 688,
    "1991-2020": 694
   },
   "seasons": {
    "djf": 171,
    "jja": 191,
    "mam": 146,
    "son": 186
   },
   "summer_half": 337,
   "winter_half": 357
  },
  "S71": {
   "cells": 39,
   "mm": 670,
   "n": 1222,
   "periods": {
    "1961-1990": 647,
    "1981-2010": 659,
    "1991-2020": 670
   },
   "seasons": {
    "djf": 160,
    "jja": 188,
    "mam": 142,
    "son": 180
   },
   "summer_half": 330,
   "winter_half": 340
  },
  "S72": {
   "cells": 36,
   "mm": 665,
   "n": 715,
   "periods": {
    "1961-1990": 640,
    "1981-2010": 652,
    "1991-2020": 665
   },
   "seasons": {
    "djf": 154,
    "jja": 190,
    "mam": 141,
    "son": 180
   },
   "summer_half": 331,
   "winter_half": 334
  },
  "S73": {
   "cells": 21,
   "mm": 653,
   "n": 755,
   "periods": {
    "1961-1990": 640,
    "1981-2010": 646,
    "1991-2020": 653
   },
   "seasons": {
    "djf": 155,
    "jja": 182,
    "mam": 138,
    "son": 178
   },
   "summer_half": 320,
   "winter_half": 333
  },
  "S74": {
   "cells": 18,
   "mm": 690,
   "n": 521,
   "periods": {
    "1961-1990": 687,
    "1981-2010": 686,
    "1991-2020": 690
   },
   "seasons": {
    "djf": 172,
    "jja": 188,
    "mam": 144,
    "son": 186
   },
   "summer_half": 332,
   "winter_half": 358
  },
  "S75": {
   "cells": 78,
   "mm": 752,
   "n": 1345,
   "periods": {
    "1961-1990": 734,
    "1981-2010": 739,
    "1991-2020": 752
   },
   "seasons": {
    "djf": 198,
    "jja": 195,
    "mam": 159,
    "son": 199
   },
   "summer_half": 355,
   "winter_half": 397
  },
  "S8": {
   "cells": 24,
   "mm": 842,
   "n": 850,
   "periods": {
    "1961-1990": 829,
    "1981-2010": 840,
    "1991-2020": 842
   },
   "seasons": {
    "djf": 231,
    "jja": 203,
    "mam": 176,
    "son": 231
   },
   "summer_half": 379,
   "winter_half": 462
  },
  "S80": {
   "cells": 78,
   "mm": 657,
   "n": 1035,
   "periods": {
    "1961-1990": 639,
    "1981-2010": 644,
    "1991-2020": 657
   },
   "seasons": {
    "djf": 156,
    "jja": 184,
    "mam": 133,
    "son": 184
   },
   "summer_half": 317,
   "winter_half": 341
  },
  "S81": {
   "cells": 67,
   "mm": 636,
   "n": 1108,
   "periods": {
    "1961-1990": 621,
    "1981-2010": 630,
    "1991-2020": 636
   },
   "seasons": {
    "djf": 147,
    "jja": 182,
    "mam": 131,
    "son": 177
   },
   "summer_half": 312,
   "winter_half": 323
  },
  "S9": {
   "cells": 28,
   "mm": 732,
   "n": 706,
   "periods": {
    "1961-1990": 709,
    "1981-2010": 727,
    "1991-2020": 732
   },
   "seasons": {
    "djf": 190,
    "jja": 188,
    "mam": 152,
    "son": 202
   },
   "summer_half": 341,
   "winter_half": 392
  },
  "S95": {
   "cells": 3,
   "mm": 701,
   "n": 28,
   "periods": {
    "1961-1990": 685,
    "1981-2010": 698,
    "1991-2020": 701
   },
   "seasons": {
    "djf": 180,
    "jja": 179,
    "mam": 150,
    "son": 191
   },
   "summer_half": 330,
   "winter_half": 371
  },
  "S96": {
   "cells": 2,
   "mm": 704,
   "n": 14,
   "periods": {
    "1961-1990": 682,
    "1981-2010": 700,
    "1991-2020": 704
   },
   "seasons": {
    "djf": 184,
    "jja": 179,
    "mam": 148,
    "son": 193
   },
   "summer_half": 327,
   "winter_half": 377
  },
  "S97": {
   "cells": 2,
   "mm": 636,
   "n": 39,
   "periods": {
    "1961-1990": 624,
    "1981-2010": 631,
    "1991-2020": 636
   },
   "seasons": {
    "djf": 156,
    "jja": 173,
    "mam": 135,
    "son": 172
   },
   "summer_half": 308,
   "winter_half": 328
  },
  "S98": {
   "cells": 2,
   "mm": 736,
   "n": 195,
   "periods": {
    "1961-1990": 717,
    "1981-2010": 734,
    "1991-2020": 736
   },
   "seasons": {
    "djf": 198,
    "jja": 183,
    "mam": 155,
    "son": 200
   },
   "summer_half": 338,
   "winter_half": 398
  },
  "S99": {
   "cells": 1,
   "mm": 704,
   "n": 35,
   "periods": {
    "1961-1990": 682,
    "1981-2010": 700,
    "1991-2020": 704
   },
   "seasons": {
    "djf": 186,
    "jja": 177,
    "mam": 149,
    "son": 192
   },
   "summer_half": 326,
   "winter_half": 377
  },
  "SA1": {
   "cells": 25,
   "mm": 1287,
   "n": 1299,
   "periods": {
    "1961-1990": 1283,
    "1981-2010": 1317,
    "1991-2020": 1287
   },
   "seasons": {
    "djf": 381,
    "jja": 279,
    "mam": 240,
    "son": 387
   },
   "summer_half": 520,
   "winter_half": 768
  },
  "SA10": {
   "cells": 70,
   "mm": 1653,
   "n": 777,
   "periods": {
    "1961-1990": 1585,
    "1981-2010": 1660,
    "1991-2020": 1653
   },
   "seasons": {
    "djf": 502,
    "jja": 357,
    "mam": 301,
    "son": 492
   },
   "summer_half": 659,
   "winter_half": 994
  },
  "SA11": {
   "cells": 54,
   "mm": 1623,
   "n": 989,
   "periods": {
    "1961-1990": 1554,
    "1981-2010": 1630,
    "1991-2020": 1623
   },
   "seasons": {
    "djf": 500,
    "jja": 347,
    "mam": 296,
    "son": 481
   },
   "summer_half": 642,
   "winter_half": 981
  },
  "SA12": {
   "cells": 34,
   "mm": 1486,
   "n": 788,
   "periods": {
    "1961-1990": 1413,
    "1981-2010": 1471,
    "1991-2020": 1486
   },
   "seasons": {
    "djf": 430,
    "jja": 346,
    "mam": 275,
    "son": 434
   },
   "summer_half": 622,
   "winter_half": 864
  },
  "SA13": {
   "cells": 55,
   "mm": 1651,
   "n": 563,
   "periods": {
    "1961-1990": 1539,
    "1981-2010": 1624,
    "1991-2020": 1651
   },
   "seasons": {
    "djf": 486,
    "jja": 369,
    "mam": 304,
    "son": 491
   },
   "summer_half": 673,
   "winter_half": 977
  },
  "SA14": {
   "cells": 109,
   "mm": 1502,
   "n": 884,
   "periods": {
    "1961-1990": 1451,
    "1981-2010": 1503,
    "1991-2020": 1502
   },
   "seasons": {
    "djf": 450,
    "jja": 322,
    "mam": 278,
    "son": 451
   },
   "summer_half": 601,
   "winter_half": 902
  },
  "SA15": {
   "cells": 79,
   "mm": 1377,
   "n": 1015,
   "periods": {
    "1961-1990": 1335,
    "1981-2010": 1377,
    "1991-2020": 1377
   },
   "seasons": {
    "djf": 404,
    "jja": 302,
    "mam": 258,
    "son": 414
   },
   "summer_half": 560,
   "winter_half": 818
  },
  "SA16": {
   "cells": 24,
   "mm": 1160,
   "n": 261,
   "periods": {
    "1961-1990": 1133,
    "1981-2010": 1164,
    "1991-2020": 1160
   },
   "seasons": {
    "djf": 333,
    "jja": 250,
    "mam": 222,
    "son": 355
   },
   "summer_half": 472,
   "winter_half": 688
  },
  "SA17": {
   "cells": 91,
   "mm": 1379,
   "n": 428,
   "periods": {
    "1961-1990": 1299,
    "1981-2010": 1357,
    "1991-2020": 1379
   },
   "seasons": {
    "djf": 401,
    "jja": 297,
    "mam": 258,
    "son": 423
   },
   "summer_half": 555,
   "winter_half": 824
  },
  "SA18": {
   "cells": 106,
   "mm": 1614,
   "n": 772,
   "periods": {
    "1961-1990": 1516,
    "1981-2010": 1605,
    "1991-2020": 1614
   },
   "seasons": {
    "djf": 493,
    "jja": 337,
    "mam": 299,
    "son": 486
   },
   "summer_half": 635,
   "winter_half": 978
  },
  "SA19": {
   "cells": 361,
   "mm": 1559,
   "n": 827,
   "periods": {
    "1961-1990": 1471,
    "1981-2010": 1557,
    "1991-2020": 1559
   },
   "seasons": {
    "djf": 491,
    "jja": 316,
    "mam": 290,
    "son": 461
   },
   "summer_half": 607,
   "winter_half": 952
  },
  "SA2": {
   "cells": 37,
   "mm": 1259,
   "n": 773,
   "periods": {
    "1961-1990": 1273,
    "1981-2010": 1296,
    "1991-2020": 1259
   },
   "seasons": {
    "djf": 370,
    "jja": 272,
    "mam": 237,
    "son": 379
   },
   "summer_half": 509,
   "winter_half": 749
  },
  "SA20": {
   "cells": 109,
   "mm": 1517,
   "n": 237,
   "periods": {
    "1961-1990": 1438,
    "1981-2010": 1522,
    "1991-2020": 1517
   },
   "seasons": {
    "djf": 485,
    "jja": 300,
    "mam": 289,
    "son": 443
   },
   "summer_half": 589,
   "winter_half": 928
  },
  "SA3": {
   "cells": 90,
   "mm": 1131,
   "n": 728,
   "periods": {
    "1961-1990": 1169,
    "1981-2010": 1175,
    "1991-2020": 1131
   },
   "seasons": {
    "djf": 327,
    "jja": 250,
    "mam": 214,
    "son": 340
   },
   "summer_half": 464,
   "winter_half": 667
  },
  "SA31": {
   "cells": 32,
   "mm": 1392,
   "n": 577,
   "periods": {
    "1961-1990": 1331,
    "1981-2010": 1372,
    "1991-2020": 1392
   },
   "seasons": {
    "djf": 417,
    "jja": 305,
    "mam": 266,
    "son": 403
   },
   "summer_half": 572,
   "winter_half": 820
  },
  "SA32": {
   "cells": 229,
   "mm": 1587,
   "n": 399,
   "periods": {
    "1961-1990": 1492,
    "1981-2010": 1560,
    "1991-2020": 1587
   },
   "seasons": {
    "djf": 481,
    "jja": 342,
    "mam": 292,
    "son": 471
   },
   "summer_half": 634,
   "winter_half": 952
  },
  "SA33": {
   "cells": 292,
   "mm": 1504,
   "n": 642,
   "periods": {
    "1961-1990": 1434,
    "1981-2010": 1491,
    "1991-2020": 1504
   },
   "seasons": {
    "djf": 450,
    "jja": 318,
    "mam": 280,
    "son": 456
   },
   "summer_half": 598,
   "winter_half": 906
  },
  "SA34": {
   "cells": 116,
   "mm": 1508,
   "n": 232,
   "periods": {
    "1961-1990": 1432,
    "1981-2010": 1483,
    "1991-2020": 1508
   },
   "seasons": {
    "djf": 459,
    "jja": 308,
    "mam": 283,
    "son": 459
   },
   "summer_half": 591,
   "winter_half": 917
  },
  "SA35": {
   "cells": 31,
   "mm": 1681,
   "n": 42,
   "periods": {
    "1961-1990": 1585,
    "1981-2010": 1663,
    "1991-2020": 1681
   },
   "seasons": {
    "djf": 526,
    "jja": 330,
    "mam": 307,
    "son": 517
   },
   "summer_half": 637,
   "winter_half": 1044
  },
  "SA36": {
   "cells": 4,
   "mm": 1694,
   "n": 11,
   "periods": {
    "1961-1990": 1602,
    "1981-2010": 1687,
    "1991-2020": 1694
   },
   "seasons": {
    "djf": 530,
    "jja": 328,
    "mam": 315,
    "son": 521
   },
   "summer_half": 643,
   "winter_half": 1051
  },
  "SA37": {
   "cells": 37,
   "mm": 1455,
   "n": 59,
   "periods": {
    "1961-1990": 1359,
    "1981-2010": 1435,
    "1991-2020": 1455
   },
   "seasons": {
    "djf": 451,
    "jja": 285,
    "mam": 267,
    "son": 452
   },
   "summer_half": 552,
   "winter_half": 903
  },
  "SA38": {
   "cells": 72,
   "mm": 1385,
   "n": 189,
   "periods": {
    "1961-1990": 1294,
    "1981-2010": 1356,
    "1991-2020": 1385
   },
   "seasons": {
    "djf": 428,
    "jja": 270,
    "mam": 251,
    "son": 436
   },
   "summer_half": 521,
   "winter_half": 864
  },
  "SA39": {
   "cells": 53,
   "mm": 1655,
   "n": 117,
   "periods": {
    "1961-1990": 1560,
    "1981-2010": 1648,
    "1991-2020": 1655
   },
   "seasons": {
    "djf": 519,
    "jja": 350,
    "mam": 300,
    "son": 485
   },
   "summer_half": 650,
   "winter_half": 1005
  },
  "SA4": {
   "cells": 86,
   "mm": 1380,
   "n": 1147,
   "periods": {
    "1961-1990": 1390,
    "1981-2010": 1420,
    "1991-2020": 1380
   },
   "seasons": {
    "djf": 412,
    "jja": 294,
    "mam": 256,
    "son": 419
   },
   "summer_half": 550,
   "winter_half": 831
  },
  "SA40": {
   "cells": 49,
   "mm": 1425,
   "n": 107,
   "periods": {
    "1961-1990": 1366,
    "1981-2010": 1420,
    "1991-2020": 1425
   },
   "seasons": {
    "djf": 457,
    "jja": 291,
    "mam": 263,
    "son": 414
   },
   "summer_half": 554,
   "winter_half": 871
  },
  "SA41": {
   "cells": 62,
   "mm": 1485,
   "n": 112,
   "periods": {
    "1961-1990": 1374,
    "1981-2010": 1453,
    "1991-2020": 1485
   },
   "seasons": {
    "djf": 453,
    "jja": 295,
    "mam": 269,
    "son": 467
   },
   "summer_half": 564,
   "winter_half": 920
  },
  "SA42": {
   "cells": 43,
   "mm": 1278,
   "n": 155,
   "periods": {
    "1961-1990": 1194,
    "1981-2010": 1245,
    "1991-2020": 1278
   },
   "seasons": {
    "djf": 391,
    "jja": 252,
    "mam": 231,
    "son": 403
   },
   "summer_half": 484,
   "winter_half": 795
  },
  "SA43": {
   "cells": 132,
   "mm": 1192,
   "n": 562,
   "periods": {
    "1961-1990": 1102,
    "1981-2010": 1168,
    "1991-2020": 1192
   },
   "seasons": {
    "djf": 360,
    "jja": 245,
    "mam": 219,
    "son": 368
   },
   "summer_half": 464,
   "winter_half": 728
  },
  "SA44": {
   "cells": 229,
   "mm": 1406,
   "n": 667,
   "periods": {
    "1961-1990": 1319,
    "1981-2010": 1378,
    "1991-2020": 1406
   },
   "seasons": {
    "djf": 430,
    "jja": 289,
    "mam": 254,
    "son": 433
   },
   "summer_half": 543,
   "winter_half": 863
  },
  "SA45": {
   "cells": 15,
   "mm": 1111,
   "n": 94,
   "periods": {
    "1961-1990": 1050,
    "1981-2010": 1091,
    "1991-2020": 1111
   },
   "seasons": {
    "djf": 333,
    "jja": 231,
    "mam": 204,
    "son": 343
   },
   "summer_half": 435,
   "winter_half": 676
  },
  "SA46": {
   "cells": 18,
   "mm": 1120,
   "n": 130,
   "periods": {
    "1961-1990": 1033,
    "1981-2010": 1098,
    "1991-2020": 1120
   },
   "seasons": {
    "djf": 356,
    "jja": 234,
    "mam": 209,
    "son": 321
   },
   "summer_half": 443,
   "winter_half": 677
  },
  "SA47": {
   "cells": 27,
   "mm": 1210,
   "n": 73,
   "periods": {
    "1961-1990": 1131,
    "1981-2010": 1188,
    "1991-2020": 1210
   },
   "seasons": {
    "djf": 369,
    "jja": 251,
    "mam": 224,
    "son": 367
   },
   "summer_half": 475,
   "winter_half": 735
  },
  "SA48": {
   "cells": 171,
   "mm": 1339,
   "n": 378,
   "periods": {
    "1961-1990": 1258,
    "1981-2010": 1323,
    "1991-2020": 1339
   },
   "seasons": {
    "djf": 428,
    "jja": 277,
    "mam": 245,
    "son": 388
   },
   "summer_half": 523,
   "winter_half": 816
  },
  "SA5": {
   "cells": 48,
   "mm": 1457,
   "n": 746,
   "periods": {
    "1961-1990": 1439,
    "1981-2010": 1484,
    "1991-2020": 1457
   },
   "seasons": {
    "djf": 431,
    "jja": 316,
    "mam": 270,
    "son": 440
   },
   "summer_half": 586,
   "winter_half": 871
  },
  "SA6": {
   "cells": 42,
   "mm": 1502,
   "n": 764,
   "periods": {
    "1961-1990": 1448,
    "1981-2010": 1515,
    "1991-2020": 1502
   },
   "seasons": {
    "djf": 444,
    "jja": 326,
    "mam": 278,
    "son": 454
   },
   "summer_half": 604,
   "winter_half": 898
  },
  "SA61": {
   "cells": 19,
   "mm": 1243,
   "n": 460,
   "periods": {
    "1961-1990": 1178,
    "1981-2010": 1223,
    "1991-2020": 1243
   },
   "seasons": {
    "djf": 350,
    "jja": 267,
    "mam": 233,
    "son": 393
   },
   "summer_half": 500,
   "winter_half": 743
  },
  "SA62": {
   "cells": 386,
   "mm": 1206,
   "n": 1007,
   "periods": {
    "1961-1990": 1155,
    "1981-2010": 1197,
    "1991-2020": 1206
   },
   "seasons": {
    "djf": 351,
    "jja": 251,
    "mam": 226,
    "son": 379
   },
   "summer_half": 477,
   "winter_half": 730
  },
  "SA63": {
   "cells": 43,
   "mm": 1486,
   "n": 88,
   "periods": {
    "1961-1990": 1375,
    "1981-2010": 1427,
    "1991-2020": 1486
   },
   "seasons": {
    "djf": 452,
    "jja": 303,
    "mam": 269,
    "son": 462
   },
   "summer_half": 572,
   "winter_half": 914
  },
  "SA64": {
   "cells": 22,
   "mm": 1112,
   "n": 105,
   "periods": {
    "1961-1990": 1090,
    "1981-2010": 1117,
    "1991-2020": 1112
   },
   "seasons": {
    "djf": 318,
    "jja": 220,
    "mam": 211,
    "son": 364
   },
   "summer_half": 430,
   "winter_half": 681
  },
  "SA65": {
   "cells": 41,
   "mm": 1417,
   "n": 200,
   "periods": {
    "1961-1990": 1336,
    "1981-2010": 1387,
    "1991-2020": 1417
   },
   "seasons": {
    "djf": 435,
    "jja": 277,
    "mam": 262,
    "son": 444
   },
   "summer_half": 539,
   "winter_half": 879
  },
  "SA66": {
   "cells": 74,
   "mm": 1556,
   "n": 164,
   "periods": {
    "1961-1990": 1434,
    "1981-2010": 1497,
    "1991-2020": 1556
   },
   "seasons": {
    "djf": 474,
    "jja": 315,
    "mam": 287,
    "son": 481
   },
   "summer_half": 602,
   "winter_half": 955
  },
  "SA67": {
   "cells": 111,
   "mm": 1364,
   "n": 362,
   "periods": {
    "1961-1990": 1292,
    "1981-2010": 1325,
    "1991-2020": 1364
   },
   "seasons": {
    "djf": 406,
    "jja": 282,
    "mam": 258,
    "son": 418
   },
   "summer_half": 540,
   "winter_half": 824
  },
  "SA68": {
   "cells": 46,
   "mm": 1294,
   "n": 153,
   "periods": {
    "1961-1990": 1229,
    "1981-2010": 1253,
    "1991-2020": 1294
   },
   "seasons": {
    "djf": 382,
    "jja": 275,
    "mam": 235,
    "son": 403
   },
   "summer_half": 510,
   "winter_half": 785
  },
  "SA69": {
   "cells": 14,
   "mm": 1243,
   "n": 157,
   "periods": {
    "1961-1990": 1170,
    "1981-2010": 1210,
    "1991-2020": 1243
   },
   "seasons": {
    "djf": 370,
    "jja": 264,
    "mam": 229,
    "son": 379
   },
   "summer_half": 494,
   "winter_half": 749
  },
  "SA7": {
   "cells": 25,
   "mm": 1403,
   "n": 349,
   "periods": {
    "1961-1990": 1360,
    "1981-2010": 1418,
    "1991-2020": 1403
   },
   "seasons": {
    "djf": 418,
    "jja": 304,
    "mam": 259,
    "son": 422
   },
   "summer_half": 563,
   "winter_half": 840
  },
  "SA70": {
   "cells": 58,
   "mm": 1201,
   "n": 425,
   "periods": {
    "1961-1990": 1128,
    "1981-2010": 1170,
    "1991-2020": 1201
   },
   "seasons": {
    "djf": 355,
    "jja": 256,
    "mam": 225,
    "son": 365
   },
   "summer_half": 481,
   "winter_half": 720
  },
  "SA71": {
   "cells": 76,
   "mm": 1148,
   "n": 407,
   "periods": {
    "1961-1990": 1061,
    "1981-2010": 1110,
    "1991-2020": 1148
   },
   "seasons": {
    "djf": 332,
    "jja": 247,
    "mam": 213,
    "son": 356
   },
   "summer_half": 460,
   "winter_half": 688
  },
  "SA72": {
   "cells": 19,
   "mm": 1201,
   "n": 306,
   "periods": {
    "1961-1990": 1106,
    "1981-2010": 1153,
    "1991-2020": 1201
   },
   "seasons": {
    "djf": 356,
    "jja": 251,
    "mam": 221,
    "son": 372
   },
   "summer_half": 473,
   "winter_half": 728
  },
  "SA73": {
   "cells": 51,
   "mm": 1150,
   "n": 629,
   "periods": {
    "1961-1990": 1084,
    "1981-2010": 1130,
    "1991-2020": 1150
   },
   "seasons": {
    "djf": 331,
    "jja": 243,
    "mam": 214,
    "son": 362
   },
   "summer_half": 457,
   "winter_half": 693
  },
  "SA8": {
   "cells": 36,
   "mm": 1744,
   "n": 305,
   "periods": {
    "1961-1990": 1624,
    "1981-2010": 1715,
    "1991-2020": 1744
   },
   "seasons": {
    "djf": 526,
    "jja": 372,
    "mam": 324,
    "son": 521
   },
   "summer_half": 697,
   "winter_half": 1048
  },
  "SA80": {
   "cells": 2,
   "mm": 1326,
   "n": 6,
   "periods": {
    "1961-1990": 1314,
    "1981-2010": 1352,
    "1991-2020": 1326
   },
   "seasons": {
    "djf": 397,
    "jja": 284,
    "mam": 246,
    "son": 399
   },
   "summer_half": 530,
   "winter_half": 796
  },
  "SA9": {
   "cells": 57,
   "mm": 1939,
   "n": 554,
   "periods": {
    "1961-1990": 1836,
    "1981-2010": 1921,
    "1991-2020": 1939
   },
   "seasons": {
    "djf": 606,
    "jja": 399,
    "mam": 363,
    "son": 571
   },
   "summer_half": 762,
   "winter_half": 1177
  },
  "SA99": {
   "cells": 1,
   "mm": 1463,
   "n": 65,
   "periods": {
    "1961-1990": 1441,
    "1981-2010": 1485,
    "1991-2020": 1463
   },
   "seasons": {
    "djf": 435,
    "jja": 317,
    "mam": 270,
    "son": 440
   },
   "summer_half": 588,
   "winter_half": 875
  },
  "SE1": {
   "cells": 15,
   "mm": 608,
   "n": 2008,
   "periods": {
    "1961-1990": 596,
    "1981-2010": 596,
    "1991-2020": 608
   },
   "seasons": {
    "djf": 156,
    "jja": 152,
    "mam": 123,
    "son": 178
   },
   "summer_half": 275,
   "winter_half": 334
  },
  "SE10": {
   "cells": 13,
   "mm": 590,
   "n": 842,
   "periods": {
    "1961-1990": 577,
    "1981-2010": 578,
    "1991-2020": 590
   },
   "seasons": {
    "djf": 148,
    "jja": 146,
    "mam": 120,
    "son": 175
   },
   "summer_half": 267,
   "winter_half": 323
  },
  "SE11": {
   "cells": 7,
   "mm": 604,
   "n": 496,
   "periods": {
    "1961-1990": 593,
    "1981-2010": 592,
    "1991-2020": 604
   },
   "seasons": {
    "djf": 154,
    "jja": 149,
    "mam": 122,
    "son": 179
   },
   "summer_half": 271,
   "winter_half": 333
  },
  "SE12": {
   "cells": 13,
   "mm": 614,
   "n": 515,
   "periods": {
    "1961-1990": 603,
    "1981-2010": 603,
    "1991-2020": 614
   },
   "seasons": {
    "djf": 158,
    "jja": 149,
    "mam": 127,
    "son": 180
   },
   "summer_half": 275,
   "winter_half": 338
  },
  "SE13": {
   "cells": 10,
   "mm": 597,
   "n": 737,
   "periods": {
    "1961-1990": 584,
    "1981-2010": 586,
    "1991-2020": 597
   },
   "seasons": {
    "djf": 152,
    "jja": 146,
    "mam": 123,
    "son": 176
   },
   "summer_half": 269,
   "winter_half": 328
  },
  "SE14": {
   "cells": 8,
   "mm": 621,
   "n": 419,
   "periods": {
    "1961-1990": 606,
    "1981-2010": 609,
    "1991-2020": 621
   },
   "seasons": {
    "djf": 158,
    "jja": 156,
    "mam": 127,
    "son": 180
   },
   "summer_half": 283,
   "winter_half": 338
  },
  "SE15": {
   "cells": 12,
   "mm": 619,
   "n": 1197,
   "periods": {
    "1961-1990": 606,
    "1981-2010": 611,
    "1991-2020": 619
   },
   "seasons": {
    "djf": 157,
    "jja": 155,
    "mam": 127,
    "son": 180
   },
   "summer_half": 282,
   "winter_half": 337
  },
  "SE16": {
   "cells": 11,
   "mm": 620,
   "n": 1108,
   "periods": {
    "1961-1990": 602,
    "1981-2010": 609,
    "1991-2020": 620
   },
   "seasons": {
    "djf": 157,
    "jja": 159,
    "mam": 125,
    "son": 179
   },
   "summer_half": 284,
   "winter_half": 336
  },
  "SE17": {
   "cells": 6,
   "mm": 605,
   "n": 682,
   "periods": {
    "1961-1990": 593,
    "1981-2010": 595,
    "1991-2020": 605
   },
   "seasons": {
    "djf": 153,
    "jja": 150,
    "mam": 124,
    "son": 178
   },
   "summer_half": 274,
   "winter_half": 331
  },
  "SE18": {
   "cells": 20,
   "mm": 598,
   "n": 1455,
   "periods": {
    "1961-1990": 585,
    "1981-2010": 586,
    "1991-2020": 598
   },
   "seasons": {
    "djf": 156,
    "jja": 147,
    "mam": 123,
    "son": 172
   },
   "summer_half": 270,
   "winter_half": 328
  },
  "SE19": {
   "cells": 10,
   "mm": 655,
   "n": 600,
   "periods": {
    "1961-1990": 655,
    "1981-2010": 659,
    "1991-2020": 655
   },
   "seasons": {
    "djf": 174,
    "jja": 157,
    "mam": 133,
    "son": 191
   },
   "summer_half": 291,
   "winter_half": 365
  },
  "SE1P": {
   "cells": 2,
   "mm": 612,
   "n": 930,
   "periods": {
    "1961-1990": 599,
    "1981-2010": 602,
    "1991-2020": 612
   },
   "seasons": {
    "djf": 156,
    "jja": 155,
    "mam": 124,
    "son": 178
   },
   "summer_half": 279,
   "winter_half": 334
  },
  "SE2": {
   "cells": 10,
   "mm": 582,
   "n": 462,
   "periods": {
    "1961-1990": 559,
    "1981-2010": 566,
    "1991-2020": 582
   },
   "seasons": {
    "djf": 151,
    "jja": 142,
    "mam": 118,
    "son": 171
   },
   "summer_half": 260,
   "winter_half": 322
  },
  "SE20": {
   "cells": 7,
   "mm": 657,
   "n": 485,
   "periods": {
    "1961-1990": 644,
    "1981-2010": 654,
    "1991-2020": 657
   },
   "seasons": {
    "djf": 177,
    "jja": 157,
    "mam": 134,
    "son": 190
   },
   "summer_half": 290,
   "winter_half": 367
  },
  "SE21": {
   "cells": 11,
   "mm": 623,
   "n": 295,
   "periods": {
    "1961-1990": 626,
    "1981-2010": 627,
    "1991-2020": 623
   },
   "seasons": {
    "djf": 161,
    "jja": 151,
    "mam": 129,
    "son": 182
   },
   "summer_half": 280,
   "winter_half": 343
  },
  "SE22": {
   "cells": 7,
   "mm": 613,
   "n": 508,
   "periods": {
    "1961-1990": 606,
    "1981-2010": 609,
    "1991-2020": 613
   },
   "seasons": {
    "djf": 160,
    "jja": 149,
    "mam": 125,
    "son": 178
   },
   "summer_half": 275,
   "winter_half": 338
  },
  "SE23": {
   "cells": 9,
   "mm": 603,
   "n": 629,
   "periods": {
    "1961-1990": 596,
    "1981-2010": 598,
    "1991-2020": 603
   },
   "seasons": {
    "djf": 162,
    "jja": 145,
    "mam": 122,
    "son": 174
   },
   "summer_half": 267,
   "winter_half": 336
  },
  "SE24": {
   "cells": 8,
   "mm": 633,
   "n": 294,
   "periods": {
    "1961-1990": 630,
    "1981-2010": 633,
    "1991-2020": 633
   },
   "seasons": {
    "djf": 160,
    "jja": 153,
    "mam": 133,
    "son": 187
   },
   "summer_half": 286,
   "winter_half": 347
  },
  "SE25": {
   "cells": 12,
   "mm": 653,
   "n": 636,
   "periods": {
    "1961-1990": 638,
    "1981-2010": 649,
    "1991-2020": 653
   },
   "seasons": {
    "djf": 177,
    "jja": 153,
    "mam": 133,
    "son": 190
   },
   "summer_half": 286,
   "winter_half": 367
  },
  "SE26": {
   "cells": 11,
   "mm": 634,
   "n": 628,
   "periods": {
    "1961-1990": 630,
    "1981-2010": 633,
    "1991-2020": 634
   },
   "seasons": {
    "djf": 168,
    "jja": 153,
    "mam": 129,
    "son": 184
   },
   "summer_half": 283,
   "winter_half": 351
  },
  "SE27": {
   "cells": 6,
   "mm": 630,
   "n": 379,
   "periods": {
    "1961-1990": 637,
    "1981-2010": 638,
    "1991-2020": 630
   },
   "seasons": {
    "djf": 162,
    "jja": 154,
    "mam": 130,
    "son": 185
   },
   "summer_half": 284,
   "winter_half": 347
  },
  "SE28": {
   "cells": 8,
   "mm": 567,
   "n": 436,
   "periods": {
    "1961-1990": 545,
    "1981-2010": 551,
    "1991-2020": 567
   },
   "seasons": {
    "djf": 146,
    "jja": 139,
    "mam": 116,
    "son": 166
   },
   "summer_half": 255,
   "winter_half": 312
  },
  "SE3": {
   "cells": 16,
   "mm": 596,
   "n": 792,
   "periods": {
    "1961-1990": 585,
    "1981-2010": 585,
    "1991-2020": 596
   },
   "seasons": {
    "djf": 151,
    "jja": 146,
    "mam": 123,
    "son": 175
   },
   "summer_half": 270,
   "winter_half": 326
  },
  "SE4": {
   "cells": 8,
   "mm": 616,
   "n": 463,
   "periods": {
    "1961-1990": 602,
    "1981-2010": 605,
    "1991-2020": 616
   },
   "seasons": {
    "djf": 159,
    "jja": 152,
    "mam": 126,
    "son": 179
   },
   "summer_half": 278,
   "winter_half": 338
  },
  "SE5": {
   "cells": 10,
   "mm": 618,
   "n": 884,
   "periods": {
    "1961-1990": 608,
    "1981-2010": 612,
    "1991-2020": 618
   },
   "seasons": {
    "djf": 155,
    "jja": 151,
    "mam": 129,
    "son": 182
   },
   "summer_half": 281,
   "winter_half": 337
  },
  "SE6": {
   "cells": 14,
   "mm": 612,
   "n": 865,
   "periods": {
    "1961-1990": 601,
    "1981-2010": 606,
    "1991-2020": 612
   },
   "seasons": {
    "djf": 160,
    "jja": 149,
    "mam": 125,
    "son": 178
   },
   "summer_half": 274,
   "winter_half": 338
  },
  "SE7": {
   "cells": 7,
   "mm": 583,
   "n": 428,
   "periods": {
    "1961-1990": 572,
    "1981-2010": 573,
    "1991-2020": 583
   },
   "seasons": {
    "djf": 149,
    "jja": 147,
    "mam": 119,
    "son": 168
   },
   "summer_half": 266,
   "winter_half": 317
  },
  "SE8": {
   "cells": 8,
   "mm": 607,
   "n": 580,
   "periods": {
    "1961-1990": 589,
    "1981-2010": 592,
    "1991-2020": 607
   },
   "seasons": {
    "djf": 154,
    "jja": 152,
    "mam": 123,
    "son": 177
   },
   "summer_half": 275,
   "winter_half": 332
  },
  "SE9": {
   "cells": 24,
   "mm": 624,
   "n": 1210,
   "periods": {
    "1961-1990": 615,
    "1981-2010": 612,
    "1991-2020": 624
   },
   "seasons": {
    "djf": 165,
    "jja": 148,
    "mam": 130,
    "son": 182
   },
   "summer_half": 278,
   "winter_half": 346
  },
  "SG1": {
   "cells": 26,
   "mm": 651,
   "n": 1275,
   "periods": {
    "1961-1990": 629,
    "1981-2010": 646,
    "1991-2020": 651
   },
   "seasons": {
    "djf": 168,
    "jja": 171,
    "mam": 131,
    "son": 182
   },
   "summer_half": 302,
   "winter_half": 349
  },
  "SG10": {
   "cells": 18,
   "mm": 652,
   "n": 108,
   "periods": {
    "1961-1990": 622,
    "1981-2010": 648,
    "1991-2020": 652
   },
   "seasons": {
    "djf": 167,
    "jja": 166,
    "mam": 130,
    "son": 189
   },
   "summer_half": 296,
   "winter_half": 356
  },
  "SG11": {
   "cells": 68,
   "mm": 655,
   "n": 379,
   "periods": {
    "1961-1990": 633,
    "1981-2010": 654,
    "1991-2020": 655
   },
   "seasons": {
    "djf": 168,
    "jja": 171,
    "mam": 129,
    "son": 187
   },
   "summer_half": 300,
   "winter_half": 355
  },
  "SG12": {
   "cells": 80,
   "mm": 632,
   "n": 941,
   "periods": {
    "1961-1990": 621,
    "1981-2010": 636,
    "1991-2020": 632
   },
   "seasons": {
    "djf": 164,
    "jja": 158,
    "mam": 126,
    "son": 184
   },
   "summer_half": 284,
   "winter_half": 348
  },
  "SG13": {
   "cells": 45,
   "mm": 656,
   "n": 531,
   "periods": {
    "1961-1990": 649,
    "1981-2010": 661,
    "1991-2020": 656
   },
   "seasons": {
    "djf": 175,
    "jja": 159,
    "mam": 133,
    "son": 189
   },
   "summer_half": 292,
   "winter_half": 363
  },
  "SG14": {
   "cells": 44,
   "mm": 628,
   "n": 624,
   "periods": {
    "1961-1990": 620,
    "1981-2010": 635,
    "1991-2020": 628
   },
   "seasons": {
    "djf": 166,
    "jja": 153,
    "mam": 128,
    "son": 181
   },
   "summer_half": 281,
   "winter_half": 347
  },
  "SG15": {
   "cells": 9,
   "mm": 551,
   "n": 120,
   "periods": {
    "1961-1990": 535,
    "1981-2010": 551,
    "1991-2020": 551
   },
   "seasons": {
    "djf": 132,
    "jja": 150,
    "mam": 114,
    "son": 156
   },
   "summer_half": 263,
   "winter_half": 288
  },
  "SG16": {
   "cells": 16,
   "mm": 580,
   "n": 196,
   "periods": {
    "1961-1990": 567,
    "1981-2010": 581,
    "1991-2020": 580
   },
   "seasons": {
    "djf": 139,
    "jja": 153,
    "mam": 118,
    "son": 171
   },
   "summer_half": 271,
   "winter_half": 309
  },
  "SG17": {
   "cells": 28,
   "mm": 585,
   "n": 403,
   "periods": {
    "1961-1990": 571,
    "1981-2010": 588,
    "1991-2020": 585
   },
   "seasons": {
    "djf": 140,
    "jja": 153,
    "mam": 123,
    "son": 170
   },
   "summer_half": 276,
   "winter_half": 310
  },
  "SG18": {
   "cells": 66,
   "mm": 570,
   "n": 762,
   "periods": {
    "1961-1990": 549,
    "1981-2010": 570,
    "1991-2020": 570
   },
   "seasons": {
    "djf": 136,
    "jja": 151,
    "mam": 119,
    "son": 164
   },
   "summer_half": 269,
   "winter_half": 300
  },
  "SG19": {
   "cells": 86,
   "mm": 587,
   "n": 680,
   "periods": {
    "1961-1990": 556,
    "1981-2010": 581,
    "1991-2020": 587
   },
   "seasons": {
    "djf": 141,
    "jja": 152,
    "mam": 121,
    "son": 173
   },
   "summer_half": 273,
   "winter_half": 314
  },
  "SG2": {
   "cells": 47,
   "mm": 655,
   "n": 854,
   "periods": {
    "1961-1990": 640,
    "1981-2010": 653,
    "1991-2020": 655
   },
   "seasons": {
    "djf": 170,
    "jja": 167,
    "mam": 134,
    "son": 184
   },
   "summer_half": 301,
   "winter_half": 354
  },
  "SG3": {
   "cells": 15,
   "mm": 671,
   "n": 206,
   "periods": {
    "1961-1990": 655,
    "1981-2010": 672,
    "1991-2020": 671
   },
   "seasons": {
    "djf": 180,
    "jja": 168,
    "mam": 136,
    "son": 187
   },
   "summer_half": 304,
   "winter_half": 367
  },
  "SG4": {
   "cells": 96,
   "mm": 656,
   "n": 906,
   "periods": {
    "1961-1990": 635,
    "1981-2010": 652,
    "1991-2020": 656
   },
   "seasons": {
    "djf": 168,
    "jja": 168,
    "mam": 133,
    "son": 186
   },
   "summer_half": 302,
   "winter_half": 354
  },
  "SG5": {
   "cells": 64,
   "mm": 618,
   "n": 952,
   "periods": {
    "1961-1990": 589,
    "1981-2010": 613,
    "1991-2020": 618
   },
   "seasons": {
    "djf": 151,
    "jja": 159,
    "mam": 128,
    "son": 180
   },
   "summer_half": 287,
   "winter_half": 331
  },
  "SG6": {
   "cells": 21,
   "mm": 613,
   "n": 980,
   "periods": {
    "1961-1990": 590,
    "1981-2010": 608,
    "1991-2020": 613
   },
   "seasons": {
    "djf": 152,
    "jja": 158,
    "mam": 127,
    "son": 175
   },
   "summer_half": 286,
   "winter_half": 327
  },
  "SG7": {
   "cells": 55,
   "mm": 598,
   "n": 442,
   "periods": {
    "1961-1990": 578,
    "1981-2010": 598,
    "1991-2020": 598
   },
   "seasons": {
    "djf": 145,
    "jja": 159,
    "mam": 122,
    "son": 171
   },
   "summer_half": 281,
   "winter_half": 317
  },
  "SG8": {
   "cells": 186,
   "mm": 594,
   "n": 1298,
   "periods": {
    "1961-1990": 568,
    "1981-2010": 591,
    "1991-2020": 594
   },
   "seasons": {
    "djf": 144,
    "jja": 162,
    "mam": 121,
    "son": 167
   },
   "summer_half": 283,
   "winter_half": 311
  },
  "SG9": {
   "cells": 98,
   "mm": 651,
   "n": 515,
   "periods": {
    "1961-1990": 633,
    "1981-2010": 649,
    "1991-2020": 651
   },
   "seasons": {
    "djf": 166,
    "jja": 172,
    "mam": 129,
    "son": 185
   },
   "summer_half": 301,
   "winter_half": 350
  },
  "SK1": {
   "cells": 9,
   "mm": 933,
   "n": 503,
   "periods": {
    "1961-1990": 899,
    "1981-2010": 913,
    "1991-2020": 933
   },
   "seasons": {
    "djf": 241,
    "jja": 253,
    "mam": 179,
    "son": 261
   },
   "summer_half": 431,
   "winter_half": 502
  },
  "SK10": {
   "cells": 95,
   "mm": 957,
   "n": 1480,
   "periods": {
    "1961-1990": 917,
    "1981-2010": 937,
    "1991-2020": 957
   },
   "seasons": {
    "djf": 252,
    "jja": 247,
    "mam": 187,
    "son": 271
   },
   "summer_half": 434,
   "winter_half": 524
  },
  "SK11": {
   "cells": 138,
   "mm": 969,
   "n": 1111,
   "periods": {
    "1961-1990": 942,
    "1981-2010": 951,
    "1991-2020": 969
   },
   "seasons": {
    "djf": 256,
    "jja": 245,
    "mam": 192,
    "son": 276
   },
   "summer_half": 437,
   "winter_half": 532
  },
  "SK12": {
   "cells": 33,
   "mm": 962,
   "n": 492,
   "periods": {
    "1961-1990": 920,
    "1981-2010": 946,
    "1991-2020": 962
   },
   "seasons": {
    "djf": 257,
    "jja": 250,
    "mam": 185,
    "son": 271
   },
   "summer_half": 435,
   "winter_half": 528
  },
  "SK13": {
   "cells": 44,
   "mm": 1209,
   "n": 999,
   "periods": {
    "1961-1990": 1178,
    "1981-2010": 1185,
    "1991-2020": 1209
   },
   "seasons": {
    "djf": 344,
    "jja": 291,
    "mam": 233,
    "son": 342
   },
   "summer_half": 524,
   "winter_half": 685
  },
  "SK14": {
   "cells": 36,
   "mm": 1071,
   "n": 1306,
   "periods": {
    "1961-1990": 1023,
    "1981-2010": 1047,
    "1991-2020": 1071
   },
   "seasons": {
    "djf": 297,
    "jja": 268,
    "mam": 206,
    "son": 300
   },
   "summer_half": 474,
   "winter_half": 597
  },
  "SK15": {
   "cells": 23,
   "mm": 1133,
   "n": 671,
   "periods": {
    "1961-1990": 1083,
    "1981-2010": 1098,
    "1991-2020": 1133
   },
   "seasons": {
    "djf": 317,
    "jja": 282,
    "mam": 216,
    "son": 318
   },
   "summer_half": 499,
   "winter_half": 634
  },
  "SK16": {
   "cells": 12,
   "mm": 985,
   "n": 457,
   "periods": {
    "1961-1990": 932,
    "1981-2010": 959,
    "1991-2020": 985
   },
   "seasons": {
    "djf": 271,
    "jja": 252,
    "mam": 190,
    "son": 272
   },
   "summer_half": 443,
   "winter_half": 543
  },
  "SK17": {
   "cells": 222,
   "mm": 1195,
   "n": 1229,
   "periods": {
    "1961-1990": 1164,
    "1981-2010": 1188,
    "1991-2020": 1195
   },
   "seasons": {
    "djf": 351,
    "jja": 269,
    "mam": 241,
    "son": 333
   },
   "summer_half": 510,
   "winter_half": 684
  },
  "SK2": {
   "cells": 15,
   "mm": 951,
   "n": 591,
   "periods": {
    "1961-1990": 915,
    "1981-2010": 932,
    "1991-2020": 951
   },
   "seasons": {
    "djf": 246,
    "jja": 258,
    "mam": 180,
    "son": 267
   },
   "summer_half": 438,
   "winter_half": 513
  },
  "SK22": {
   "cells": 35,
   "mm": 1114,
   "n": 387,
   "periods": {
    "1961-1990": 1088,
    "1981-2010": 1100,
    "1991-2020": 1114
   },
   "seasons": {
    "djf": 307,
    "jja": 274,
    "mam": 214,
    "son": 319
   },
   "summer_half": 488,
   "winter_half": 626
  },
  "SK23": {
   "cells": 55,
   "mm": 1152,
   "n": 541,
   "periods": {
    "1961-1990": 1135,
    "1981-2010": 1145,
    "1991-2020": 1152
   },
   "seasons": {
    "djf": 324,
    "jja": 274,
    "mam": 227,
    "son": 326
   },
   "summer_half": 501,
   "winter_half": 651
  },
  "SK3": {
   "cells": 13,
   "mm": 898,
   "n": 612,
   "periods": {
    "1961-1990": 869,
    "1981-2010": 878,
    "1991-2020": 898
   },
   "seasons": {
    "djf": 233,
    "jja": 241,
    "mam": 172,
    "son": 251
   },
   "summer_half": 414,
   "winter_half": 484
  },
  "SK4": {
   "cells": 17,
   "mm": 893,
   "n": 821,
   "periods": {
    "1961-1990": 867,
    "1981-2010": 873,
    "1991-2020": 893
   },
   "seasons": {
    "djf": 234,
    "jja": 235,
    "mam": 173,
    "son": 251
   },
   "summer_half": 408,
   "winter_half": 485
  },
  "SK5": {
   "cells": 15,
   "mm": 911,
   "n": 618,
   "periods": {
    "1961-1990": 878,
    "1981-2010": 891,
    "1991-2020": 911
   },
   "seasons": {
    "djf": 242,
    "jja": 239,
    "mam": 178,
    "son": 253
   },
   "summer_half": 416,
   "winter_half": 495
  },
  "SK6": {
   "cells": 51,
   "mm": 1021,
   "n": 1272,
   "periods": {
    "1961-1990": 985,
    "1981-2010": 1002,
    "1991-2020": 1021
   },
   "seasons": {
    "djf": 274,
    "jja": 262,
    "mam": 196,
    "son": 289
   },
   "summer_half": 458,
   "winter_half": 563
  },
  "SK7": {
   "cells": 34,
   "mm": 900,
   "n": 1038,
   "periods": {
    "1961-1990": 865,
    "1981-2010": 882,
    "1991-2020": 900
   },
   "seasons": {
    "djf": 236,
    "jja": 238,
    "mam": 173,
    "son": 253
   },
   "summer_half": 411,
   "winter_half": 489
  },
  "SK8": {
   "cells": 29,
   "mm": 865,
   "n": 1328,
   "periods": {
    "1961-1990": 838,
    "1981-2010": 846,
    "1991-2020": 865
   },
   "seasons": {
    "djf": 225,
    "jja": 228,
    "mam": 167,
    "son": 245
   },
   "summer_half": 395,
   "winter_half": 470
  },
  "SK9": {
   "cells": 47,
   "mm": 863,
   "n": 1221,
   "periods": {
    "1961-1990": 821,
    "1981-2010": 836,
    "1991-2020": 863
   },
   "seasons": {
    "djf": 226,
    "jja": 222,
    "mam": 169,
    "son": 246
   },
   "summer_half": 392,
   "winter_half": 471
  },
  "SL0": {
   "cells": 26,
   "mm": 652,
   "n": 345,
   "periods": {
    "1961-1990": 645,
    "1981-2010": 643,
    "1991-2020": 652
   },
   "seasons": {
    "djf": 173,
    "jja": 152,
    "mam": 134,
    "son": 194
   },
   "summer_half": 285,
   "winter_half": 367
  },
  "SL1": {
   "cells": 39,
   "mm": 671,
   "n": 1657,
   "periods": {
    "1961-1990": 662,
    "1981-2010": 663,
    "1991-2020": 671
   },
   "seasons": {
    "djf": 178,
    "jja": 153,
    "mam": 137,
    "son": 203
   },
   "summer_half": 290,
   "winter_half": 381
  },
  "SL2": {
   "cells": 42,
   "mm": 676,
   "n": 1132,
   "periods": {
    "1961-1990": 669,
    "1981-2010": 668,
    "1991-2020": 676
   },
   "seasons": {
    "djf": 180,
    "jja": 157,
    "mam": 136,
    "son": 204
   },
   "summer_half": 293,
   "winter_half": 383
  },
  "SL3": {
   "cells": 48,
   "mm": 641,
   "n": 1075,
   "periods": {
    "1961-1990": 637,
    "1981-2010": 634,
    "1991-2020": 641
   },
   "seasons": {
    "djf": 171,
    "jja": 149,
    "mam": 131,
    "son": 190
   },
   "summer_half": 280,
   "winter_half": 361
  },
  "SL4": {
   "cells": 61,
   "mm": 648,
   "n": 1373,
   "periods": {
    "1961-1990": 640,
    "1981-2010": 640,
    "1991-2020": 648
   },
   "seasons": {
    "djf": 174,
    "jja": 146,
    "mam": 134,
    "son": 193
   },
   "summer_half": 280,
   "winter_half": 368
  },
  "SL5": {
   "cells": 42,
   "mm": 719,
   "n": 885,
   "periods": {
    "1961-1990": 692,
    "1981-2010": 705,
    "1991-2020": 719
   },
   "seasons": {
    "djf": 195,
    "jja": 165,
    "mam": 144,
    "son": 215
   },
   "summer_half": 309,
   "winter_half": 410
  },
  "SL6": {
   "cells": 98,
   "mm": 670,
   "n": 2315,
   "periods": {
    "1961-1990": 656,
    "1981-2010": 660,
    "1991-2020": 670
   },
   "seasons": {
    "djf": 177,
    "jja": 156,
    "mam": 137,
    "son": 200
   },
   "summer_half": 293,
   "winter_half": 377
  },
  "SL60": {
   "cells": 1,
   "mm": 649,
   "n": 33,
   "periods": {
    "1961-1990": 637,
    "1981-2010": 637,
    "1991-2020": 649
   },
   "seasons": {
    "djf": 170,
    "jja": 150,
    "mam": 133,
    "son": 196
   },
   "summer_half": 283,
   "winter_half": 366
  },
  "SL7": {
   "cells": 48,
   "mm": 754,
   "n": 694,
   "periods": {
    "1961-1990": 733,
    "1981-2010": 740,
    "1991-2020": 754
   },
   "seasons": {
    "djf": 204,
    "jja": 170,
    "mam": 154,
    "son": 225
   },
   "summer_half": 325,
   "winter_half": 429
  },
  "SL8": {
   "cells": 9,
   "mm": 685,
   "n": 265,
   "periods": {
    "1961-1990": 670,
    "1981-2010": 673,
    "1991-2020": 685
   },
   "seasons": {
    "djf": 185,
    "jja": 157,
    "mam": 139,
    "son": 204
   },
   "summer_half": 296,
   "winter_half": 389
  },
  "SL9": {
   "cells": 32,
   "mm": 711,
   "n": 878,
   "periods": {
    "1961-1990": 708,
    "1981-2010": 704,
    "1991-2020": 711
   },
   "seasons": {
    "djf": 194,
    "jja": 161,
    "mam": 145,
    "son": 212
   },
   "summer_half": 306,
   "winter_half": 405
  },
  "SL95": {
   "cells": 2,
   "mm": 629,
   "n": 23,
   "periods": {
    "1961-1990": 626,
    "1981-2010": 624,
    "1991-2020": 629
   },
   "seasons": {
    "djf": 166,
    "jja": 143,
    "mam": 130,
    "son": 190
   },
   "summer_half": 273,
   "winter_half": 356
  },
  "SM1": {
   "cells": 14,
   "mm": 654,
   "n": 844,
   "periods": {
    "1961-1990": 642,
    "1981-2010": 649,
    "1991-2020": 654
   },
   "seasons": {
    "djf": 176,
    "jja": 155,
    "mam": 132,
    "son": 191
   },
   "summer_half": 287,
   "winter_half": 367
  },
  "SM2": {
   "cells": 14,
   "mm": 677,
   "n": 591,
   "periods": {
    "1961-1990": 669,
    "1981-2010": 671,
    "1991-2020": 677
   },
   "seasons": {
    "djf": 186,
    "jja": 155,
    "mam": 134,
    "son": 202
   },
   "summer_half": 289,
   "winter_half": 389
  },
  "SM3": {
   "cells": 11,
   "mm": 646,
   "n": 379,
   "periods": {
    "1961-1990": 635,
    "1981-2010": 642,
    "1991-2020": 646
   },
   "seasons": {
    "djf": 174,
    "jja": 151,
    "mam": 131,
    "son": 191
   },
   "summer_half": 282,
   "winter_half": 364
  },
  "SM4": {
   "cells": 13,
   "mm": 635,
   "n": 582,
   "periods": {
    "1961-1990": 615,
    "1981-2010": 622,
    "1991-2020": 635
   },
   "seasons": {
    "djf": 168,
    "jja": 151,
    "mam": 129,
    "son": 186
   },
   "summer_half": 281,
   "winter_half": 354
  },
  "SM5": {
   "cells": 19,
   "mm": 673,
   "n": 709,
   "periods": {
    "1961-1990": 653,
    "1981-2010": 660,
    "1991-2020": 673
   },
   "seasons": {
    "djf": 184,
    "jja": 158,
    "mam": 134,
    "son": 196
   },
   "summer_half": 292,
   "winter_half": 381
  },
  "SM6": {
   "cells": 14,
   "mm": 695,
   "n": 756,
   "periods": {
    "1961-1990": 669,
    "1981-2010": 679,
    "1991-2020": 695
   },
   "seasons": {
    "djf": 193,
    "jja": 157,
    "mam": 139,
    "son": 206
   },
   "summer_half": 296,
   "winter_half": 399
  },
  "SM7": {
   "cells": 18,
   "mm": 736,
   "n": 465,
   "periods": {
    "1961-1990": 730,
    "1981-2010": 725,
    "1991-2020": 736
   },
   "seasons": {
    "djf": 210,
    "jja": 159,
    "mam": 143,
    "son": 224
   },
   "summer_half": 302,
   "winter_half": 434
  },
  "SN1": {
   "cells": 15,
   "mm": 731,
   "n": 788,
   "periods": {
    "1961-1990": 680,
    "1981-2010": 724,
    "1991-2020": 731
   },
   "seasons": {
    "djf": 205,
    "jja": 162,
    "mam": 159,
    "son": 205
   },
   "summer_half": 321,
   "winter_half": 410
  },
  "SN10": {
   "cells": 117,
   "mm": 778,
   "n": 1204,
   "periods": {
    "1961-1990": 730,
    "1981-2010": 762,
    "1991-2020": 778
   },
   "seasons": {
    "djf": 213,
    "jja": 182,
    "mam": 160,
    "son": 223
   },
   "summer_half": 342,
   "winter_half": 437
  },
  "SN11": {
   "cells": 80,
   "mm": 808,
   "n": 772,
   "periods": {
    "1961-1990": 745,
    "1981-2010": 786,
    "1991-2020": 808
   },
   "seasons": {
    "djf": 223,
    "jja": 189,
    "mam": 165,
    "son": 231
   },
   "summer_half": 354,
   "winter_half": 454
  },
  "SN12": {
   "cells": 58,
   "mm": 781,
   "n": 824,
   "periods": {
    "1961-1990": 728,
    "1981-2010": 768,
    "1991-2020": 781
   },
   "seasons": {
    "djf": 215,
    "jja": 177,
    "mam": 165,
    "son": 224
   },
   "summer_half": 342,
   "winter_half": 439
  },
  "SN13": {
   "cells": 48,
   "mm": 866,
   "n": 666,
   "periods": {
    "1961-1990": 804,
    "1981-2010": 850,
    "1991-2020": 866
   },
   "seasons": {
    "djf": 245,
    "jja": 197,
    "mam": 179,
    "son": 245
   },
   "summer_half": 376,
   "winter_half": 490
  },
  "SN14": {
   "cells": 152,
   "mm": 883,
   "n": 972,
   "periods": {
    "1961-1990": 818,
    "1981-2010": 864,
    "1991-2020": 883
   },
   "seasons": {
    "djf": 252,
    "jja": 202,
    "mam": 183,
    "son": 246
   },
   "summer_half": 385,
   "winter_half": 498
  },
  "SN15": {
   "cells": 153,
   "mm": 783,
   "n": 1310,
   "periods": {
    "1961-1990": 725,
    "1981-2010": 765,
    "1991-2020": 783
   },
   "seasons": {
    "djf": 216,
    "jja": 184,
    "mam": 163,
    "son": 220
   },
   "summer_half": 347,
   "winter_half": 436
  },
  "SN16": {
   "cells": 110,
   "mm": 818,
   "n": 527,
   "periods": {
    "1961-1990": 771,
    "1981-2010": 804,
    "1991-2020": 818
   },
   "seasons": {
    "djf": 229,
    "jja": 191,
    "mam": 172,
    "son": 227
   },
   "summer_half": 363,
   "winter_half": 455
  },
  "SN2": {
   "cells": 21,
   "mm": 718,
   "n": 956,
   "periods": {
    "1961-1990": 681,
    "1981-2010": 713,
    "1991-2020": 718
   },
   "seasons": {
    "djf": 198,
    "jja": 163,
    "mam": 155,
    "son": 201
   },
   "summer_half": 319,
   "winter_half": 399
  },
  "SN25": {
   "cells": 22,
   "mm": 723,
   "n": 821,
   "periods": {
    "1961-1990": 685,
    "1981-2010": 715,
    "1991-2020": 723
   },
   "seasons": {
    "djf": 198,
    "jja": 169,
    "mam": 156,
    "son": 201
   },
   "summer_half": 324,
   "winter_half": 399
  },
  "SN26": {
   "cells": 11,
   "mm": 732,
   "n": 74,
   "periods": {
    "1961-1990": 684,
    "1981-2010": 718,
    "1991-2020": 732
   },
   "seasons": {
    "djf": 200,
    "jja": 173,
    "mam": 156,
    "son": 203
   },
   "summer_half": 329,
   "winter_half": 403
  },
  "SN3": {
   "cells": 39,
   "mm": 727,
   "n": 1304,
   "periods": {
    "1961-1990": 677,
    "1981-2010": 718,
    "1991-2020": 727
   },
   "seasons": {
    "djf": 201,
    "jja": 165,
    "mam": 158,
    "son": 203
   },
   "summer_half": 323,
   "winter_half": 404
  },
  "SN38": {
   "cells": 6,
   "mm": 739,
   "n": 124,
   "periods": {
    "1961-1990": 691,
    "1981-2010": 731,
    "1991-2020": 739
   },
   "seasons": {
    "djf": 206,
    "jja": 168,
    "mam": 159,
    "son": 207
   },
   "summer_half": 327,
   "winter_half": 413
  },
  "SN4": {
   "cells": 116,
   "mm": 795,
   "n": 912,
   "periods": {
    "1961-1990": 729,
    "1981-2010": 777,
    "1991-2020": 795
   },
   "seasons": {
    "djf": 219,
    "jja": 180,
    "mam": 169,
    "son": 226
   },
   "summer_half": 349,
   "winter_half": 445
  },
  "SN5": {
   "cells": 49,
   "mm": 742,
   "n": 899,
   "periods": {
    "1961-1990": 703,
    "1981-2010": 732,
    "1991-2020": 742
   },
   "seasons": {
    "djf": 202,
    "jja": 174,
    "mam": 158,
    "son": 208
   },
   "summer_half": 332,
   "winter_half": 410
  },
  "SN6": {
   "cells": 106,
   "mm": 715,
   "n": 680,
   "periods": {
    "1961-1990": 672,
    "1981-2010": 700,
    "1991-2020": 715
   },
   "seasons": {
    "djf": 194,
    "jja": 170,
    "mam": 153,
    "son": 198
   },
   "summer_half": 323,
   "winter_half": 392
  },
  "SN7": {
   "cells": 95,
   "mm": 655,
   "n": 562,
   "periods": {
    "1961-1990": 617,
    "1981-2010": 644,
    "1991-2020": 655
   },
   "seasons": {
    "djf": 168,
    "jja": 157,
    "mam": 143,
    "son": 187
   },
   "summer_half": 300,
   "winter_half": 355
  },
  "SN8": {
   "cells": 215,
   "mm": 862,
   "n": 940,
   "periods": {
    "1961-1990": 803,
    "1981-2010": 842,
    "1991-2020": 862
   },
   "seasons": {
    "djf": 246,
    "jja": 186,
    "mam": 181,
    "son": 250
   },
   "summer_half": 367,
   "winter_half": 495
  },
  "SN9": {
   "cells": 62,
   "mm": 807,
   "n": 323,
   "periods": {
    "1961-1990": 755,
    "1981-2010": 789,
    "1991-2020": 807
   },
   "seasons": {
    "djf": 225,
    "jja": 183,
    "mam": 166,
    "son": 234
   },
   "summer_half": 348,
   "winter_half": 459
  },
  "SN99": {
   "cells": 1,
   "mm": 736,
   "n": 18,
   "periods": {
    "1961-1990": 686,
    "1981-2010": 726,
    "1991-2020": 736
   },
   "seasons": {
    "djf": 203,
    "jja": 166,
    "mam": 160,
    "son": 207
   },
   "summer_half": 326,
   "winter_half": 410
  },
  "SO14": {
   "cells": 7,
   "mm": 830,
   "n": 847,
   "periods": {
    "1961-1990": 759,
    "1981-2010": 792,
    "1991-2020": 830
   },
   "seasons": {
    "djf": 252,
    "jja": 156,
    "mam": 161,
    "son": 262
   },
   "summer_half": 316,
   "winter_half": 514
  },
  "SO15": {
   "cells": 15,
   "mm": 860,
   "n": 1164,
   "periods": {
    "1961-1990": 772,
    "1981-2010": 822,
    "1991-2020": 860
   },
   "seasons": {
    "djf": 261,
    "jja": 167,
    "mam": 165,
    "son": 267
   },
   "summer_half": 333,
   "winter_half": 528
  },
  "SO16": {
   "cells": 35,
   "mm": 861,
   "n": 1542,
   "periods": {
    "1961-1990": 782,
    "1981-2010": 826,
    "1991-2020": 861
   },
   "seasons": {
    "djf": 260,
    "jja": 170,
    "mam": 163,
    "son": 268
   },
   "summer_half": 333,
   "winter_half": 528
  },
  "SO17": {
   "cells": 9,
   "mm": 836,
   "n": 441,
   "periods": {
    "1961-1990": 767,
    "1981-2010": 801,
    "1991-2020": 836
   },
   "seasons": {
    "djf": 250,
    "jja": 162,
    "mam": 162,
    "son": 262
   },
   "summer_half": 324,
   "winter_half": 512
  },
  "SO18": {
   "cells": 18,
   "mm": 858,
   "n": 940,
   "periods": {
    "1961-1990": 790,
    "1981-2010": 823,
    "1991-2020": 858
   },
   "seasons": {
    "djf": 258,
    "jja": 169,
    "mam": 164,
    "son": 266
   },
   "summer_half": 334,
   "winter_half": 524
  },
  "SO19": {
   "cells": 17,
   "mm": 845,
   "n": 1194,
   "periods": {
    "1961-1990": 778,
    "1981-2010": 810,
    "1991-2020": 845
   },
   "seasons": {
    "djf": 262,
    "jja": 161,
    "mam": 161,
    "son": 262
   },
   "summer_half": 322,
   "winter_half": 524
  },
  "SO20": {
   "cells": 94,
   "mm": 838,
   "n": 346,
   "periods": {
    "1961-1990": 776,
    "1981-2010": 804,
    "1991-2020": 838
   },
   "seasons": {
    "djf": 248,
    "jja": 170,
    "mam": 169,
    "son": 251
   },
   "summer_half": 339,
   "winter_half": 499
  },
  "SO21": {
   "cells": 175,
   "mm": 864,
   "n": 743,
   "periods": {
    "1961-1990": 807,
    "1981-2010": 827,
    "1991-2020": 864
   },
   "seasons": {
    "djf": 253,
    "jja": 180,
    "mam": 170,
    "son": 261
   },
   "summer_half": 350,
   "winter_half": 514
  },
  "SO22": {
   "cells": 24,
   "mm": 899,
   "n": 745,
   "periods": {
    "1961-1990": 834,
    "1981-2010": 853,
    "1991-2020": 899
   },
   "seasons": {
    "djf": 263,
    "jja": 181,
    "mam": 179,
    "son": 276
   },
   "summer_half": 360,
   "winter_half": 539
  },
  "SO23": {
   "cells": 19,
   "mm": 850,
   "n": 810,
   "periods": {
    "1961-1990": 799,
    "1981-2010": 808,
    "1991-2020": 850
   },
   "seasons": {
    "djf": 250,
    "jja": 169,
    "mam": 171,
    "son": 260
   },
   "summer_half": 340,
   "winter_half": 510
  },
  "SO24": {
   "cells": 115,
   "mm": 930,
   "n": 449,
   "periods": {
    "1961-1990": 861,
    "1981-2010": 898,
    "1991-2020": 930
   },
   "seasons": {
    "djf": 276,
    "jja": 193,
    "mam": 178,
    "son": 284
   },
   "summer_half": 370,
   "winter_half": 559
  },
  "SO25": {
   "cells": 1,
   "mm": 863,
   "n": 1,
   "periods": {
    "1961-1990": 814,
    "1981-2010": 822,
    "1991-2020": 863
   },
   "seasons": {
    "djf": 256,
    "jja": 168,
    "mam": 175,
    "son": 264
   },
   "summer_half": 343,
   "winter_half": 520
  },
  "SO30": {
   "cells": 34,
   "mm": 858,
   "n": 826,
   "periods": {
    "1961-1990": 789,
    "1981-2010": 823,
    "1991-2020": 858
   },
   "seasons": {
    "djf": 259,
    "jja": 174,
    "mam": 162,
    "son": 264
   },
   "summer_half": 335,
   "winter_half": 523
  },
  "SO31": {
   "cells": 41,
   "mm": 855,
   "n": 1186,
   "periods": {
    "1961-1990": 793,
    "1981-2010": 823,
    "1991-2020": 855
   },
   "seasons": {
    "djf": 262,
    "jja": 168,
    "mam": 159,
    "son": 266
   },
   "summer_half": 327,
   "winter_half": 527
  },
  "SO32": {
   "cells": 103,
   "mm": 918,
   "n": 676,
   "periods": {
    "1961-1990": 837,
    "1981-2010": 878,
    "1991-2020": 918
   },
   "seasons": {
    "djf": 273,
    "jja": 191,
    "mam": 172,
    "son": 283
   },
   "summer_half": 362,
   "winter_half": 555
  },
  "SO40": {
   "cells": 57,
   "mm": 895,
   "n": 1079,
   "periods": {
    "1961-1990": 809,
    "1981-2010": 858,
    "1991-2020": 895
   },
   "seasons": {
    "djf": 278,
    "jja": 169,
    "mam": 172,
    "son": 276
   },
   "summer_half": 340,
   "winter_half": 554
  },
  "SO41": {
   "cells": 69,
   "mm": 842,
   "n": 1083,
   "periods": {
    "1961-1990": 785,
    "1981-2010": 813,
    "1991-2020": 842
   },
   "seasons": {
    "djf": 255,
    "jja": 161,
    "mam": 160,
    "son": 266
   },
   "summer_half": 321,
   "winter_half": 521
  },
  "SO42": {
   "cells": 42,
   "mm": 891,
   "n": 164,
   "periods": {
    "1961-1990": 830,
    "1981-2010": 859,
    "1991-2020": 891
   },
   "seasons": {
    "djf": 273,
    "jja": 169,
    "mam": 169,
    "son": 279
   },
   "summer_half": 339,
   "winter_half": 552
  },
  "SO43": {
   "cells": 34,
   "mm": 956,
   "n": 137,
   "periods": {
    "1961-1990": 877,
    "1981-2010": 916,
    "1991-2020": 956
   },
   "seasons": {
    "djf": 295,
    "jja": 182,
    "mam": 186,
    "son": 293
   },
   "summer_half": 368,
   "winter_half": 588
  },
  "SO45": {
   "cells": 38,
   "mm": 860,
   "n": 973,
   "periods": {
    "1961-1990": 795,
    "1981-2010": 825,
    "1991-2020": 860
   },
   "seasons": {
    "djf": 268,
    "jja": 163,
    "mam": 161,
    "son": 268
   },
   "summer_half": 323,
   "winter_half": 537
  },
  "SO50": {
   "cells": 38,
   "mm": 877,
   "n": 1319,
   "periods": {
    "1961-1990": 801,
    "1981-2010": 841,
    "1991-2020": 877
   },
   "seasons": {
    "djf": 261,
    "jja": 182,
    "mam": 168,
    "son": 266
   },
   "summer_half": 350,
   "winter_half": 527
  },
  "SO51": {
   "cells": 121,
   "mm": 878,
   "n": 878,
   "periods": {
    "1961-1990": 812,
    "1981-2010": 846,
    "1991-2020": 878
   },
   "seasons": {
    "djf": 266,
    "jja": 173,
    "mam": 172,
    "son": 267
   },
   "summer_half": 345,
   "winter_half": 533
  },
  "SO52": {
   "cells": 9,
   "mm": 864,
   "n": 185,
   "periods": {
    "1961-1990": 796,
    "1981-2010": 829,
    "1991-2020": 864
   },
   "seasons": {
    "djf": 258,
    "jja": 172,
    "mam": 167,
    "son": 268
   },
   "summer_half": 339,
   "winter_half": 525
  },
  "SO53": {
   "cells": 17,
   "mm": 880,
   "n": 860,
   "periods": {
    "1961-1990": 808,
    "1981-2010": 843,
    "1991-2020": 880
   },
   "seasons": {
    "djf": 260,
    "jja": 183,
    "mam": 169,
    "son": 268
   },
   "summer_half": 352,
   "winter_half": 528
  },
  "SO97": {
   "cells": 1,
   "mm": 826,
   "n": 15,
   "periods": {
    "1961-1990": 762,
    "1981-2010": 794,
    "1991-2020": 826
   },
   "seasons": {
    "djf": 247,
    "jja": 164,
    "mam": 159,
    "son": 256
   },
   "summer_half": 323,
   "winter_half": 503
  },
  "SP1": {
   "cells": 15,
   "mm": 821,
   "n": 671,
   "periods": {
    "1961-1990": 765,
    "1981-2010": 791,
    "1991-2020": 821
   },
   "seasons": {
    "djf": 249,
    "jja": 160,
    "mam": 167,
    "son": 245
   },
   "summer_half": 327,
   "winter_half": 494
  },
  "SP10": {
   "cells": 21,
   "mm": 823,
   "n": 961,
   "periods": {
    "1961-1990": 769,
    "1981-2010": 805,
    "1991-2020": 823
   },
   "seasons": {
    "djf": 236,
    "jja": 171,
    "mam": 167,
    "son": 249
   },
   "summer_half": 338,
   "winter_half": 485
  },
  "SP11": {
   "cells": 224,
   "mm": 857,
   "n": 1297,
   "periods": {
    "1961-1990": 797,
    "1981-2010": 831,
    "1991-2020": 857
   },
   "seasons": {
    "djf": 248,
    "jja": 178,
    "mam": 174,
    "son": 257
   },
   "summer_half": 352,
   "winter_half": 505
  },
  "SP2": {
   "cells": 40,
   "mm": 879,
   "n": 920,
   "periods": {
    "1961-1990": 811,
    "1981-2010": 846,
    "1991-2020": 879
   },
   "seasons": {
    "djf": 266,
    "jja": 174,
    "mam": 175,
    "son": 265
   },
   "summer_half": 349,
   "winter_half": 531
  },
  "SP3": {
   "cells": 148,
   "mm": 918,
   "n": 676,
   "periods": {
    "1961-1990": 854,
    "1981-2010": 898,
    "1991-2020": 918
   },
   "seasons": {
    "djf": 269,
    "jja": 190,
    "mam": 185,
    "son": 274
   },
   "summer_half": 375,
   "winter_half": 543
  },
  "SP4": {
   "cells": 106,
   "mm": 806,
   "n": 1106,
   "periods": {
    "1961-1990": 738,
    "1981-2010": 774,
    "1991-2020": 806
   },
   "seasons": {
    "djf": 233,
    "jja": 171,
    "mam": 162,
    "son": 239
   },
   "summer_half": 334,
   "winter_half": 473
  },
  "SP5": {
   "cells": 242,
   "mm": 912,
   "n": 1037,
   "periods": {
    "1961-1990": 836,
    "1981-2010": 874,
    "1991-2020": 912
   },
   "seasons": {
    "djf": 273,
    "jja": 177,
    "mam": 184,
    "son": 278
   },
   "summer_half": 361,
   "winter_half": 551
  },
  "SP6": {
   "cells": 101,
   "mm": 914,
   "n": 603,
   "periods": {
    "1961-1990": 838,
    "1981-2010": 869,
    "1991-2020": 914
   },
   "seasons": {
    "djf": 276,
    "jja": 175,
    "mam": 184,
    "son": 279
   },
   "summer_half": 359,
   "winter_half": 555
  },
  "SP7": {
   "cells": 104,
   "mm": 916,
   "n": 637,
   "periods": {
    "1961-1990": 844,
    "1981-2010": 880,
    "1991-2020": 916
   },
   "seasons": {
    "djf": 266,
    "jja": 193,
    "mam": 182,
    "son": 275
   },
   "summer_half": 375,
   "winter_half": 541
  },
  "SP8": {
   "cells": 75,
   "mm": 880,
   "n": 567,
   "periods": {
    "1961-1990": 823,
    "1981-2010": 859,
    "1991-2020": 880
   },
   "seasons": {
    "djf": 253,
    "jja": 187,
    "mam": 177,
    "son": 263
   },
   "summer_half": 364,
   "winter_half": 516
  },
  "SP9": {
   "cells": 15,
   "mm": 832,
   "n": 273,
   "periods": {
    "1961-1990": 771,
    "1981-2010": 807,
    "1991-2020": 832
   },
   "seasons": {
    "djf": 237,
    "jja": 179,
    "mam": 167,
    "son": 249
   },
   "summer_half": 347,
   "winter_half": 485
  },
  "SR1": {
   "cells": 7,
   "mm": 660,
   "n": 291,
   "periods": {
    "1961-1990": 623,
    "1981-2010": 635,
    "1991-2020": 660
   },
   "seasons": {
    "djf": 154,
    "jja": 182,
    "mam": 132,
    "son": 191
   },
   "summer_half": 314,
   "winter_half": 346
  },
  "SR2": {
   "cells": 16,
   "mm": 665,
   "n": 866,
   "periods": {
    "1961-1990": 628,
    "1981-2010": 641,
    "1991-2020": 665
   },
   "seasons": {
    "djf": 153,
    "jja": 187,
    "mam": 134,
    "son": 191
   },
   "summer_half": 321,
   "winter_half": 344
  },
  "SR3": {
   "cells": 25,
   "mm": 688,
   "n": 931,
   "periods": {
    "1961-1990": 648,
    "1981-2010": 663,
    "1991-2020": 688
   },
   "seasons": {
    "djf": 156,
    "jja": 195,
    "mam": 141,
    "son": 196
   },
   "summer_half": 336,
   "winter_half": 352
  },
  "SR4": {
   "cells": 22,
   "mm": 677,
   "n": 956,
   "periods": {
    "1961-1990": 636,
    "1981-2010": 651,
    "1991-2020": 677
   },
   "seasons": {
    "djf": 153,
    "jja": 192,
    "mam": 140,
    "son": 191
   },
   "summer_half": 333,
   "winter_half": 344
  },
  "SR5": {
   "cells": 27,
   "mm": 643,
   "n": 1050,
   "periods": {
    "1961-1990": 606,
    "1981-2010": 618,
    "1991-2020": 643
   },
   "seasons": {
    "djf": 144,
    "jja": 183,
    "mam": 132,
    "son": 184
   },
   "summer_half": 314,
   "winter_half": 329
  },
  "SR6": {
   "cells": 20,
   "mm": 630,
   "n": 736,
   "periods": {
    "1961-1990": 600,
    "1981-2010": 606,
    "1991-2020": 630
   },
   "seasons": {
    "djf": 143,
    "jja": 178,
    "mam": 126,
    "son": 183
   },
   "summer_half": 304,
   "winter_half": 326
  },
  "SR7": {
   "cells": 37,
   "mm": 675,
   "n": 871,
   "periods": {
    "1961-1990": 632,
    "1981-2010": 648,
    "1991-2020": 675
   },
   "seasons": {
    "djf": 153,
    "jja": 192,
    "mam": 137,
    "son": 193
   },
   "summer_half": 329,
   "winter_half": 346
  },
  "SR8": {
   "cells": 33,
   "mm": 683,
   "n": 978,
   "periods": {
    "1961-1990": 634,
    "1981-2010": 651,
    "1991-2020": 683
   },
   "seasons": {
    "djf": 153,
    "jja": 192,
    "mam": 138,
    "son": 199
   },
   "summer_half": 331,
   "winter_half": 352
  },
  "SS0": {
   "cells": 12,
   "mm": 533,
   "n": 737,
   "periods": {
    "1961-1990": 520,
    "1981-2010": 519,
    "1991-2020": 533
   },
   "seasons": {
    "djf": 134,
    "jja": 131,
    "mam": 110,
    "son": 158
   },
   "summer_half": 241,
   "winter_half": 292
  },
  "SS1": {
   "cells": 13,
   "mm": 533,
   "n": 690,
   "periods": {
    "1961-1990": 530,
    "1981-2010": 527,
    "1991-2020": 533
   },
   "seasons": {
    "djf": 133,
    "jja": 131,
    "mam": 111,
    "son": 158
   },
   "summer_half": 242,
   "winter_half": 291
  },
  "SS11": {
   "cells": 29,
   "mm": 587,
   "n": 478,
   "periods": {
    "1961-1990": 565,
    "1981-2010": 569,
    "1991-2020": 587
   },
   "seasons": {
    "djf": 151,
    "jja": 145,
    "mam": 118,
    "son": 174
   },
   "summer_half": 263,
   "winter_half": 324
  },
  "SS12": {
   "cells": 18,
   "mm": 568,
   "n": 404,
   "periods": {
    "1961-1990": 546,
    "1981-2010": 553,
    "1991-2020": 568
   },
   "seasons": {
    "djf": 145,
    "jja": 139,
    "mam": 115,
    "son": 169
   },
   "summer_half": 254,
   "winter_half": 313
  },
  "SS13": {
   "cells": 14,
   "mm": 565,
   "n": 495,
   "periods": {
    "1961-1990": 543,
    "1981-2010": 550,
    "1991-2020": 565
   },
   "seasons": {
    "djf": 142,
    "jja": 139,
    "mam": 115,
    "son": 168
   },
   "summer_half": 254,
   "winter_half": 311
  },
  "SS14": {
   "cells": 19,
   "mm": 587,
   "n": 734,
   "periods": {
    "1961-1990": 565,
    "1981-2010": 572,
    "1991-2020": 587
   },
   "seasons": {
    "djf": 150,
    "jja": 145,
    "mam": 119,
    "son": 173
   },
   "summer_half": 264,
   "winter_half": 323
  },
  "SS15": {
   "cells": 15,
   "mm": 602,
   "n": 640,
   "periods": {
    "1961-1990": 588,
    "1981-2010": 589,
    "1991-2020": 602
   },
   "seasons": {
    "djf": 154,
    "jja": 151,
    "mam": 122,
    "son": 175
   },
   "summer_half": 272,
   "winter_half": 329
  },
  "SS16": {
   "cells": 25,
   "mm": 611,
   "n": 658,
   "periods": {
    "1961-1990": 594,
    "1981-2010": 595,
    "1991-2020": 611
   },
   "seasons": {
    "djf": 157,
    "jja": 150,
    "mam": 124,
    "son": 180
   },
   "summer_half": 274,
   "winter_half": 337
  },
  "SS17": {
   "cells": 39,
   "mm": 569,
   "n": 784,
   "periods": {
    "1961-1990": 553,
    "1981-2010": 554,
    "1991-2020": 569
   },
   "seasons": {
    "djf": 144,
    "jja": 142,
    "mam": 116,
    "son": 167
   },
   "summer_half": 258,
   "winter_half": 311
  },
  "SS2": {
   "cells": 22,
   "mm": 534,
   "n": 709,
   "periods": {
    "1961-1990": 524,
    "1981-2010": 523,
    "1991-2020": 534
   },
   "seasons": {
    "djf": 134,
    "jja": 131,
    "mam": 110,
    "son": 158
   },
   "summer_half": 241,
   "winter_half": 293
  },
  "SS22": {
   "cells": 1,
   "mm": 530,
   "n": 3,
   "periods": {
    "1961-1990": 521,
    "1981-2010": 520,
    "1991-2020": 530
   },
   "seasons": {
    "djf": 133,
    "jja": 131,
    "mam": 109,
    "son": 157
   },
   "summer_half": 240,
   "winter_half": 290
  },
  "SS3": {
   "cells": 36,
   "mm": 534,
   "n": 607,
   "periods": {
    "1961-1990": 524,
    "1981-2010": 524,
    "1991-2020": 534
   },
   "seasons": {
    "djf": 132,
    "jja": 134,
    "mam": 111,
    "son": 158
   },
   "summer_half": 245,
   "winter_half": 289
  },
  "SS4": {
   "cells": 49,
   "mm": 534,
   "n": 589,
   "periods": {
    "1961-1990": 519,
    "1981-2010": 520,
    "1991-2020": 534
   },
   "seasons": {
    "djf": 134,
    "jja": 133,
    "mam": 110,
    "son": 158
   },
   "summer_half": 242,
   "winter_half": 292
  },
  "SS5": {
   "cells": 25,
   "mm": 578,
   "n": 544,
   "periods": {
    "1961-1990": 557,
    "1981-2010": 559,
    "1991-2020": 578
   },
   "seasons": {
    "djf": 148,
    "jja": 144,
    "mam": 118,
    "son": 168
   },
   "summer_half": 261,
   "winter_half": 317
  },
  "SS6": {
   "cells": 22,
   "mm": 576,
   "n": 746,
   "periods": {
    "1961-1990": 557,
    "1981-2010": 556,
    "1991-2020": 576
   },
   "seasons": {
    "djf": 148,
    "jja": 143,
    "mam": 118,
    "son": 167
   },
   "summer_half": 260,
   "winter_half": 315
  },
  "SS7": {
   "cells": 30,
   "mm": 564,
   "n": 1120,
   "periods": {
    "1961-1990": 544,
    "1981-2010": 547,
    "1991-2020": 564
   },
   "seasons": {
    "djf": 138,
    "jja": 139,
    "mam": 116,
    "son": 172
   },
   "summer_half": 254,
   "winter_half": 310
  },
  "SS8": {
   "cells": 17,
   "mm": 531,
   "n": 904,
   "periods": {
    "1961-1990": 518,
    "1981-2010": 520,
    "1991-2020": 531
   },
   "seasons": {
    "djf": 129,
    "jja": 132,
    "mam": 110,
    "son": 160
   },
   "summer_half": 242,
   "winter_half": 289
  },
  "SS9": {
   "cells": 18,
   "mm": 559,
   "n": 1052,
   "periods": {
    "1961-1990": 537,
    "1981-2010": 539,
    "1991-2020": 559
   },
   "seasons": {
    "djf": 142,
    "jja": 138,
    "mam": 114,
    "son": 165
   },
   "summer_half": 252,
   "winter_half": 307
  },
  "SS99": {
   "cells": 2,
   "mm": 532,
   "n": 85,
   "periods": {
    "1961-1990": 525,
    "1981-2010": 523,
    "1991-2020": 532
   },
   "seasons": {
    "djf": 134,
    "jja": 131,
    "mam": 110,
    "son": 158
   },
   "summer_half": 240,
   "winter_half": 291
  },
  "ST1": {
   "cells": 17,
   "mm": 862,
   "n": 948,
   "periods": {
    "1961-1990": 823,
    "1981-2010": 849,
    "1991-2020": 862
   },
   "seasons": {
    "djf": 219,
    "jja": 225,
    "mam": 176,
    "son": 242
   },
   "summer_half": 401,
   "winter_half": 461
  },
  "ST10": {
   "cells": 158,
   "mm": 944,
   "n": 826,
   "periods": {
    "1961-1990": 914,
    "1981-2010": 937,
    "1991-2020": 944
   },
   "seasons": {
    "djf": 251,
    "jja": 237,
    "mam": 191,
    "son": 264
   },
   "summer_half": 428,
   "winter_half": 515
  },
  "ST11": {
   "cells": 25,
   "mm": 897,
   "n": 242,
   "periods": {
    "1961-1990": 881,
    "1981-2010": 894,
    "1991-2020": 897
   },
   "seasons": {
    "djf": 233,
    "jja": 231,
    "mam": 186,
    "son": 248
   },
   "summer_half": 416,
   "winter_half": 481
  },
  "ST12": {
   "cells": 12,
   "mm": 846,
   "n": 122,
   "periods": {
    "1961-1990": 794,
    "1981-2010": 829,
    "1991-2020": 846
   },
   "seasons": {
    "djf": 215,
    "jja": 220,
    "mam": 175,
    "son": 236
   },
   "summer_half": 395,
   "winter_half": 451
  },
  "ST13": {
   "cells": 142,
   "mm": 1066,
   "n": 937,
   "periods": {
    "1961-1990": 1046,
    "1981-2010": 1061,
    "1991-2020": 1066
   },
   "seasons": {
    "djf": 292,
    "jja": 260,
    "mam": 212,
    "son": 302
   },
   "summer_half": 472,
   "winter_half": 594
  },
  "ST14": {
   "cells": 95,
   "mm": 798,
   "n": 693,
   "periods": {
    "1961-1990": 776,
    "1981-2010": 790,
    "1991-2020": 798
   },
   "seasons": {
    "djf": 206,
    "jja": 205,
    "mam": 169,
    "son": 219
   },
   "summer_half": 373,
   "winter_half": 424
  },
  "ST15": {
   "cells": 70,
   "mm": 839,
   "n": 689,
   "periods": {
    "1961-1990": 808,
    "1981-2010": 826,
    "1991-2020": 839
   },
   "seasons": {
    "djf": 214,
    "jja": 218,
    "mam": 173,
    "son": 234
   },
   "summer_half": 391,
   "winter_half": 448
  },
  "ST16": {
   "cells": 26,
   "mm": 734,
   "n": 935,
   "periods": {
    "1961-1990": 713,
    "1981-2010": 717,
    "1991-2020": 734
   },
   "seasons": {
    "djf": 184,
    "jja": 193,
    "mam": 155,
    "son": 201
   },
   "summer_half": 348,
   "winter_half": 386
  },
  "ST17": {
   "cells": 40,
   "mm": 735,
   "n": 914,
   "periods": {
    "1961-1990": 710,
    "1981-2010": 720,
    "1991-2020": 735
   },
   "seasons": {
    "djf": 183,
    "jja": 195,
    "mam": 157,
    "son": 199
   },
   "summer_half": 352,
   "winter_half": 383
  },
  "ST18": {
   "cells": 151,
   "mm": 758,
   "n": 611,
   "periods": {
    "1961-1990": 735,
    "1981-2010": 744,
    "1991-2020": 758
   },
   "seasons": {
    "djf": 190,
    "jja": 199,
    "mam": 160,
    "son": 209
   },
   "summer_half": 359,
   "winter_half": 399
  },
  "ST19": {
   "cells": 68,
   "mm": 727,
   "n": 457,
   "periods": {
    "1961-1990": 700,
    "1981-2010": 710,
    "1991-2020": 727
   },
   "seasons": {
    "djf": 178,
    "jja": 198,
    "mam": 154,
    "son": 197
   },
   "summer_half": 351,
   "winter_half": 375
  },
  "ST2": {
   "cells": 23,
   "mm": 900,
   "n": 757,
   "periods": {
    "1961-1990": 863,
    "1981-2010": 887,
    "1991-2020": 900
   },
   "seasons": {
    "djf": 234,
    "jja": 231,
    "mam": 184,
    "son": 252
   },
   "summer_half": 415,
   "winter_half": 485
  },
  "ST20": {
   "cells": 58,
   "mm": 751,
   "n": 219,
   "periods": {
    "1961-1990": 711,
    "1981-2010": 730,
    "1991-2020": 751
   },
   "seasons": {
    "djf": 184,
    "jja": 205,
    "mam": 158,
    "son": 204
   },
   "summer_half": 363,
   "winter_half": 388
  },
  "ST21": {
   "cells": 65,
   "mm": 791,
   "n": 218,
   "periods": {
    "1961-1990": 753,
    "1981-2010": 780,
    "1991-2020": 791
   },
   "seasons": {
    "djf": 197,
    "jja": 211,
    "mam": 162,
    "son": 221
   },
   "summer_half": 374,
   "winter_half": 418
  },
  "ST3": {
   "cells": 40,
   "mm": 894,
   "n": 1650,
   "periods": {
    "1961-1990": 856,
    "1981-2010": 883,
    "1991-2020": 894
   },
   "seasons": {
    "djf": 229,
    "jja": 232,
    "mam": 184,
    "son": 249
   },
   "summer_half": 416,
   "winter_half": 478
  },
  "ST4": {
   "cells": 42,
   "mm": 866,
   "n": 1688,
   "periods": {
    "1961-1990": 816,
    "1981-2010": 849,
    "1991-2020": 866
   },
   "seasons": {
    "djf": 224,
    "jja": 222,
    "mam": 178,
    "son": 242
   },
   "summer_half": 401,
   "winter_half": 466
  },
  "ST5": {
   "cells": 83,
   "mm": 847,
   "n": 2036,
   "periods": {
    "1961-1990": 807,
    "1981-2010": 828,
    "1991-2020": 847
   },
   "seasons": {
    "djf": 216,
    "jja": 220,
    "mam": 174,
    "son": 237
   },
   "summer_half": 394,
   "winter_half": 452
  },
  "ST55": {
   "cells": 2,
   "mm": 861,
   "n": 44,
   "periods": {
    "1961-1990": 821,
    "1981-2010": 841,
    "1991-2020": 861
   },
   "seasons": {
    "djf": 222,
    "jja": 224,
    "mam": 177,
    "son": 239
   },
   "summer_half": 400,
   "winter_half": 461
  },
  "ST6": {
   "cells": 41,
   "mm": 870,
   "n": 1653,
   "periods": {
    "1961-1990": 848,
    "1981-2010": 860,
    "1991-2020": 870
   },
   "seasons": {
    "djf": 225,
    "jja": 223,
    "mam": 177,
    "son": 244
   },
   "summer_half": 400,
   "winter_half": 470
  },
  "ST7": {
   "cells": 82,
   "mm": 776,
   "n": 1356,
   "periods": {
    "1961-1990": 760,
    "1981-2010": 771,
    "1991-2020": 776
   },
   "seasons": {
    "djf": 195,
    "jja": 206,
    "mam": 159,
    "son": 216
   },
   "summer_half": 365,
   "winter_half": 411
  },
  "ST8": {
   "cells": 26,
   "mm": 948,
   "n": 533,
   "periods": {
    "1961-1990": 942,
    "1981-2010": 938,
    "1991-2020": 948
   },
   "seasons": {
    "djf": 245,
    "jja": 246,
    "mam": 193,
    "son": 265
   },
   "summer_half": 438,
   "winter_half": 509
  },
  "ST9": {
   "cells": 53,
   "mm": 975,
   "n": 335,
   "periods": {
    "1961-1990": 929,
    "1981-2010": 959,
    "1991-2020": 975
   },
   "seasons": {
    "djf": 259,
    "jja": 247,
    "mam": 195,
    "son": 274
   },
   "summer_half": 442,
   "winter_half": 533
  },
  "SW10": {
   "cells": 5,
   "mm": 619,
   "n": 468,
   "periods": {
    "1961-1990": 602,
    "1981-2010": 609,
    "1991-2020": 619
   },
   "seasons": {
    "djf": 162,
    "jja": 150,
    "mam": 124,
    "son": 184
   },
   "summer_half": 274,
   "winter_half": 346
  },
  "SW11": {
   "cells": 14,
   "mm": 621,
   "n": 1523,
   "periods": {
    "1961-1990": 607,
    "1981-2010": 613,
    "1991-2020": 621
   },
   "seasons": {
    "djf": 160,
    "jja": 152,
    "mam": 124,
    "son": 186
   },
   "summer_half": 276,
   "winter_half": 345
  },
  "SW12": {
   "cells": 9,
   "mm": 617,
   "n": 593,
   "periods": {
    "1961-1990": 612,
    "1981-2010": 615,
    "1991-2020": 617
   },
   "seasons": {
    "djf": 159,
    "jja": 150,
    "mam": 126,
    "son": 182
   },
   "summer_half": 276,
   "winter_half": 341
  },
  "SW13": {
   "cells": 9,
   "mm": 618,
   "n": 373,
   "periods": {
    "1961-1990": 599,
    "1981-2010": 610,
    "1991-2020": 618
   },
   "seasons": {
    "djf": 161,
    "jja": 146,
    "mam": 125,
    "son": 186
   },
   "summer_half": 271,
   "winter_half": 346
  },
  "SW14": {
   "cells": 8,
   "mm": 632,
   "n": 367,
   "periods": {
    "1961-1990": 607,
    "1981-2010": 623,
    "1991-2020": 632
   },
   "seasons": {
    "djf": 169,
    "jja": 147,
    "mam": 123,
    "son": 193
   },
   "summer_half": 270,
   "winter_half": 362
  },
  "SW15": {
   "cells": 17,
   "mm": 625,
   "n": 1224,
   "periods": {
    "1961-1990": 609,
    "1981-2010": 620,
    "1991-2020": 625
   },
   "seasons": {
    "djf": 166,
    "jja": 147,
    "mam": 125,
    "son": 187
   },
   "summer_half": 272,
   "winter_half": 353
  },
  "SW16": {
   "cells": 18,
   "mm": 617,
   "n": 1357,
   "periods": {
    "1961-1990": 616,
    "1981-2010": 619,
    "1991-2020": 617
   },
   "seasons": {
    "djf": 159,
    "jja": 150,
    "mam": 127,
    "son": 181
   },
   "summer_half": 277,
   "winter_half": 340
  },
  "SW17": {
   "cells": 12,
   "mm": 606,
   "n": 999,
   "periods": {
    "1961-1990": 600,
    "1981-2010": 603,
    "1991-2020": 606
   },
   "seasons": {
    "djf": 156,
    "jja": 148,
    "mam": 123,
    "son": 178
   },
   "summer_half": 272,
   "winter_half": 334
  },
  "SW18": {
   "cells": 13,
   "mm": 612,
   "n": 1239,
   "periods": {
    "1961-1990": 600,
    "1981-2010": 608,
    "1991-2020": 612
   },
   "seasons": {
    "djf": 159,
    "jja": 146,
    "mam": 123,
    "son": 184
   },
   "summer_half": 269,
   "winter_half": 343
  },
  "SW19": {
   "cells": 24,
   "mm": 628,
   "n": 1657,
   "periods": {
    "1961-1990": 612,
    "1981-2010": 620,
    "1991-2020": 628
   },
   "seasons": {
    "djf": 164,
    "jja": 151,
    "mam": 127,
    "son": 186
   },
   "summer_half": 278,
   "winter_half": 350
  },
  "SW1A": {
   "cells": 5,
   "mm": 614,
   "n": 145,
   "periods": {
    "1961-1990": 603,
    "1981-2010": 600,
    "1991-2020": 614
   },
   "seasons": {
    "djf": 159,
    "jja": 149,
    "mam": 123,
    "son": 182
   },
   "summer_half": 273,
   "winter_half": 341
  },
  "SW1E": {
   "cells": 3,
   "mm": 625,
   "n": 88,
   "periods": {
    "1961-1990": 606,
    "1981-2010": 613,
    "1991-2020": 625
   },
   "seasons": {
    "djf": 160,
    "jja": 154,
    "mam": 125,
    "son": 187
   },
   "summer_half": 279,
   "winter_half": 347
  },
  "SW1H": {
   "cells": 2,
   "mm": 616,
   "n": 91,
   "periods": {
    "1961-1990": 599,
    "1981-2010": 603,
    "1991-2020": 616
   },
   "seasons": {
    "djf": 158,
    "jja": 152,
    "mam": 122,
    "son": 183
   },
   "summer_half": 275,
   "winter_half": 341
  },
  "SW1P": {
   "cells": 5,
   "mm": 611,
   "n": 748,
   "periods": {
    "1961-1990": 596,
    "1981-2010": 598,
    "1991-2020": 611
   },
   "seasons": {
    "djf": 157,
    "jja": 151,
    "mam": 122,
    "son": 182
   },
   "summer_half": 273,
   "winter_half": 338
  },
  "SW1V": {
   "cells": 6,
   "mm": 620,
   "n": 573,
   "periods": {
    "1961-1990": 598,
    "1981-2010": 608,
    "1991-2020": 620
   },
   "seasons": {
    "djf": 157,
    "jja": 156,
    "mam": 122,
    "son": 185
   },
   "summer_half": 278,
   "winter_half": 342
  },
  "SW1W": {
   "cells": 4,
   "mm": 624,
   "n": 343,
   "periods": {
    "1961-1990": 600,
    "1981-2010": 612,
    "1991-2020": 624
   },
   "seasons": {
    "djf": 158,
    "jja": 157,
    "mam": 123,
    "son": 186
   },
   "summer_half": 280,
   "winter_half": 344
  },
  "SW1X": {
   "cells": 5,
   "mm": 627,
   "n": 403,
   "periods": {
    "1961-1990": 603,
    "1981-2010": 615,
    "1991-2020": 627
   },
   "seasons": {
    "djf": 159,
    "jja": 157,
    "mam": 124,
    "son": 187
   },
   "summer_half": 281,
   "winter_half": 346
  },
  "SW1Y": {
   "cells": 2,
   "mm": 620,
   "n": 183,
   "periods": {
    "1961-1990": 606,
    "1981-2010": 606,
    "1991-2020": 620
   },
   "seasons": {
    "djf": 160,
    "jja": 153,
    "mam": 123,
    "son": 184
   },
   "summer_half": 276,
   "winter_half": 344
  },
  "SW2": {
   "cells": 10,
   "mm": 621,
   "n": 1036,
   "periods": {
    "1961-1990": 620,
    "1981-2010": 624,
    "1991-2020": 621
   },
   "seasons": {
    "djf": 158,
    "jja": 152,
    "mam": 128,
    "son": 182
   },
   "summer_half": 280,
   "winter_half": 340
  },
  "SW20": {
   "cells": 12,
   "mm": 640,
   "n": 572,
   "periods": {
    "1961-1990": 613,
    "1981-2010": 626,
    "1991-2020": 640
   },
   "seasons": {
    "djf": 170,
    "jja": 152,
    "mam": 129,
    "son": 189
   },
   "summer_half": 281,
   "winter_half": 360
  },
  "SW3": {
   "cells": 8,
   "mm": 625,
   "n": 867,
   "periods": {
    "1961-1990": 606,
    "1981-2010": 615,
    "1991-2020": 625
   },
   "seasons": {
    "djf": 160,
    "jja": 155,
    "mam": 124,
    "son": 187
   },
   "summer_half": 279,
   "winter_half": 346
  },
  "SW4": {
   "cells": 11,
   "mm": 618,
   "n": 929,
   "periods": {
    "1961-1990": 611,
    "1981-2010": 614,
    "1991-2020": 618
   },
   "seasons": {
    "djf": 158,
    "jja": 151,
    "mam": 125,
    "son": 183
   },
   "summer_half": 277,
   "winter_half": 341
  },
  "SW5": {
   "cells": 4,
   "mm": 622,
   "n": 305,
   "periods": {
    "1961-1990": 606,
    "1981-2010": 612,
    "1991-2020": 622
   },
   "seasons": {
    "djf": 162,
    "jja": 150,
    "mam": 125,
    "son": 185
   },
   "summer_half": 275,
   "winter_half": 347
  },
  "SW6": {
   "cells": 12,
   "mm": 613,
   "n": 1511,
   "periods": {
    "1961-1990": 598,
    "1981-2010": 605,
    "1991-2020": 613
   },
   "seasons": {
    "djf": 159,
    "jja": 146,
    "mam": 124,
    "son": 184
   },
   "summer_half": 270,
   "winter_half": 343
  },
  "SW7": {
   "cells": 6,
   "mm": 629,
   "n": 639,
   "periods": {
    "1961-1990": 612,
    "1981-2010": 618,
    "1991-2020": 629
   },
   "seasons": {
    "djf": 162,
    "jja": 153,
    "mam": 126,
    "son": 188
   },
   "summer_half": 279,
   "winter_half": 350
  },
  "SW8": {
   "cells": 9,
   "mm": 612,
   "n": 856,
   "periods": {
    "1961-1990": 597,
    "1981-2010": 602,
    "1991-2020": 612
   },
   "seasons": {
    "djf": 155,
    "jja": 152,
    "mam": 122,
    "son": 182
   },
   "summer_half": 274,
   "winter_half": 338
  },
  "SW9": {
   "cells": 9,
   "mm": 621,
   "n": 970,
   "periods": {
    "1961-1990": 612,
    "1981-2010": 616,
    "1991-2020": 621
   },
   "seasons": {
    "djf": 158,
    "jja": 151,
    "mam": 128,
    "son": 184
   },
   "summer_half": 279,
   "winter_half": 342
  },
  "SW95": {
   "cells": 2,
   "mm": 609,
   "n": 44,
   "periods": {
    "1961-1990": 592,
    "1981-2010": 599,
    "1991-2020": 609
   },
   "seasons": {
    "djf": 154,
    "jja": 153,
    "mam": 121,
    "son": 181
   },
   "summer_half": 274,
   "winter_half": 336
  },
  "SY1": {
   "cells": 18,
   "mm": 662,
   "n": 1035,
   "periods": {
    "1961-1990": 638,
    "1981-2010": 651,
    "1991-2020": 662
   },
   "seasons": {
    "djf": 167,
    "jja": 169,
    "mam": 138,
    "son": 188
   },
   "summer_half": 307,
   "winter_half": 355
  },
  "SY10": {
   "cells": 256,
   "mm": 1090,
   "n": 835,
   "periods": {
    "1961-1990": 1009,
    "1981-2010": 1068,
    "1991-2020": 1090
   },
   "seasons": {
    "djf": 330,
    "jja": 232,
    "mam": 222,
    "son": 305
   },
   "summer_half": 454,
   "winter_half": 636
  },
  "SY11": {
   "cells": 83,
   "mm": 835,
   "n": 993,
   "periods": {
    "1961-1990": 787,
    "1981-2010": 823,
    "1991-2020": 835
   },
   "seasons": {
    "djf": 227,
    "jja": 199,
    "mam": 174,
    "son": 235
   },
   "summer_half": 373,
   "winter_half": 462
  },
  "SY12": {
   "cells": 96,
   "mm": 742,
   "n": 382,
   "periods": {
    "1961-1990": 714,
    "1981-2010": 732,
    "1991-2020": 742
   },
   "seasons": {
    "djf": 192,
    "jja": 183,
    "mam": 158,
    "son": 209
   },
   "summer_half": 341,
   "winter_half": 402
  },
  "SY13": {
   "cells": 202,
   "mm": 734,
   "n": 880,
   "periods": {
    "1961-1990": 710,
    "1981-2010": 724,
    "1991-2020": 734
   },
   "seasons": {
    "djf": 183,
    "jja": 188,
    "mam": 152,
    "son": 211
   },
   "summer_half": 340,
   "winter_half": 394
  },
  "SY14": {
   "cells": 102,
   "mm": 726,
   "n": 347,
   "periods": {
    "1961-1990": 705,
    "1981-2010": 711,
    "1991-2020": 726
   },
   "seasons": {
    "djf": 180,
    "jja": 193,
    "mam": 150,
    "son": 204
   },
   "summer_half": 342,
   "winter_half": 384
  },
  "SY15": {
   "cells": 102,
   "mm": 859,
   "n": 255,
   "periods": {
    "1961-1990": 817,
    "1981-2010": 845,
    "1991-2020": 859
   },
   "seasons": {
    "djf": 248,
    "jja": 199,
    "mam": 181,
    "son": 231
   },
   "summer_half": 380,
   "winter_half": 479
  },
  "SY16": {
   "cells": 155,
   "mm": 1018,
   "n": 690,
   "periods": {
    "1961-1990": 949,
    "1981-2010": 1005,
    "1991-2020": 1018
   },
   "seasons": {
    "djf": 314,
    "jja": 216,
    "mam": 209,
    "son": 280
   },
   "summer_half": 425,
   "winter_half": 593
  },
  "SY17": {
   "cells": 64,
   "mm": 1196,
   "n": 178,
   "periods": {
    "1961-1990": 1116,
    "1981-2010": 1170,
    "1991-2020": 1196
   },
   "seasons": {
    "djf": 387,
    "jja": 241,
    "mam": 230,
    "son": 337
   },
   "summer_half": 472,
   "winter_half": 724
  },
  "SY18": {
   "cells": 83,
   "mm": 1533,
   "n": 225,
   "periods": {
    "1961-1990": 1408,
    "1981-2010": 1504,
    "1991-2020": 1533
   },
   "seasons": {
    "djf": 517,
    "jja": 290,
    "mam": 294,
    "son": 432
   },
   "summer_half": 584,
   "winter_half": 949
  },
  "SY19": {
   "cells": 32,
   "mm": 1695,
   "n": 55,
   "periods": {
    "1961-1990": 1594,
    "1981-2010": 1661,
    "1991-2020": 1695
   },
   "seasons": {
    "djf": 547,
    "jja": 339,
    "mam": 319,
    "son": 490
   },
   "summer_half": 658,
   "winter_half": 1037
  },
  "SY2": {
   "cells": 11,
   "mm": 663,
   "n": 579,
   "periods": {
    "1961-1990": 638,
    "1981-2010": 653,
    "1991-2020": 663
   },
   "seasons": {
    "djf": 168,
    "jja": 169,
    "mam": 139,
    "son": 187
   },
   "summer_half": 308,
   "winter_half": 355
  },
  "SY20": {
   "cells": 141,
   "mm": 1847,
   "n": 422,
   "periods": {
    "1961-1990": 1713,
    "1981-2010": 1811,
    "1991-2020": 1847
   },
   "seasons": {
    "djf": 587,
    "jja": 379,
    "mam": 341,
    "son": 540
   },
   "summer_half": 720,
   "winter_half": 1127
  },
  "SY21": {
   "cells": 286,
   "mm": 1040,
   "n": 871,
   "periods": {
    "1961-1990": 984,
    "1981-2010": 1028,
    "1991-2020": 1040
   },
   "seasons": {
    "djf": 318,
    "jja": 225,
    "mam": 211,
    "son": 287
   },
   "summer_half": 436,
   "winter_half": 604
  },
  "SY22": {
   "cells": 144,
   "mm": 980,
   "n": 419,
   "periods": {
    "1961-1990": 919,
    "1981-2010": 968,
    "1991-2020": 980
   },
   "seasons": {
    "djf": 297,
    "jja": 215,
    "mam": 199,
    "son": 268
   },
   "summer_half": 415,
   "winter_half": 565
  },
  "SY23": {
   "cells": 240,
   "mm": 1290,
   "n": 984,
   "periods": {
    "1961-1990": 1212,
    "1981-2010": 1267,
    "1991-2020": 1290
   },
   "seasons": {
    "djf": 377,
    "jja": 286,
    "mam": 240,
    "son": 386
   },
   "summer_half": 526,
   "winter_half": 763
  },
  "SY24": {
   "cells": 34,
   "mm": 1288,
   "n": 145,
   "periods": {
    "1961-1990": 1201,
    "1981-2010": 1259,
    "1991-2020": 1288
   },
   "seasons": {
    "djf": 365,
    "jja": 288,
    "mam": 226,
    "son": 410
   },
   "summer_half": 514,
   "winter_half": 775
  },
  "SY25": {
   "cells": 102,
   "mm": 1426,
   "n": 218,
   "periods": {
    "1961-1990": 1355,
    "1981-2010": 1404,
    "1991-2020": 1426
   },
   "seasons": {
    "djf": 448,
    "jja": 296,
    "mam": 265,
    "son": 416
   },
   "summer_half": 561,
   "winter_half": 865
  },
  "SY3": {
   "cells": 42,
   "mm": 675,
   "n": 1113,
   "periods": {
    "1961-1990": 649,
    "1981-2010": 661,
    "1991-2020": 675
   },
   "seasons": {
    "djf": 169,
    "jja": 176,
    "mam": 143,
    "son": 187
   },
   "summer_half": 319,
   "winter_half": 356
  },
  "SY4": {
   "cells": 290,
   "mm": 717,
   "n": 1079,
   "periods": {
    "1961-1990": 683,
    "1981-2010": 702,
    "1991-2020": 717
   },
   "seasons": {
    "djf": 179,
    "jja": 190,
    "mam": 150,
    "son": 199
   },
   "summer_half": 340,
   "winter_half": 377
  },
  "SY5": {
   "cells": 330,
   "mm": 756,
   "n": 1069,
   "periods": {
    "1961-1990": 717,
    "1981-2010": 742,
    "1991-2020": 756
   },
   "seasons": {
    "djf": 195,
    "jja": 191,
    "mam": 164,
    "son": 205
   },
   "summer_half": 356,
   "winter_half": 400
  },
  "SY6": {
   "cells": 87,
   "mm": 881,
   "n": 322,
   "periods": {
    "1961-1990": 832,
    "1981-2010": 870,
    "1991-2020": 881
   },
   "seasons": {
    "djf": 236,
    "jja": 210,
    "mam": 187,
    "son": 247
   },
   "summer_half": 398,
   "winter_half": 483
  },
  "SY7": {
   "cells": 232,
   "mm": 886,
   "n": 567,
   "periods": {
    "1961-1990": 846,
    "1981-2010": 870,
    "1991-2020": 886
   },
   "seasons": {
    "djf": 250,
    "jja": 200,
    "mam": 187,
    "son": 249
   },
   "summer_half": 387,
   "winter_half": 499
  },
  "SY8": {
   "cells": 179,
   "mm": 821,
   "n": 823,
   "periods": {
    "1961-1990": 775,
    "1981-2010": 797,
    "1991-2020": 821
   },
   "seasons": {
    "djf": 222,
    "jja": 196,
    "mam": 174,
    "son": 229
   },
   "summer_half": 370,
   "winter_half": 451
  },
  "SY9": {
   "cells": 54,
   "mm": 851,
   "n": 137,
   "periods": {
    "1961-1990": 828,
    "1981-2010": 854,
    "1991-2020": 851
   },
   "seasons": {
    "djf": 237,
    "jja": 193,
    "mam": 180,
    "son": 240
   },
   "summer_half": 373,
   "winter_half": 478
  },
  "SY99": {
   "cells": 2,
   "mm": 652,
   "n": 8,
   "periods": {
    "1961-1990": 630,
    "1981-2010": 642,
    "1991-2020": 652
   },
   "seasons": {
    "djf": 166,
    "jja": 164,
    "mam": 136,
    "son": 186
   },
   "summer_half": 300,
   "winter_half": 352
  },
  "TA1": {
   "cells": 22,
   "mm": 800,
   "n": 1177,
   "periods": {
    "1961-1990": 746,
    "1981-2010": 777,
    "1991-2020": 800
   },
   "seasons": {
    "djf": 237,
    "jja": 168,
    "mam": 158,
    "son": 236
   },
   "summer_half": 326,
   "winter_half": 473
  },
  "TA10": {
   "cells": 70,
   "mm": 760,
   "n": 436,
   "periods": {
    "1961-1990": 708,
    "1981-2010": 733,
    "1991-2020": 760
   },
   "seasons": {
    "djf": 206,
    "jja": 172,
    "mam": 156,
    "son": 226
   },
   "summer_half": 327,
   "winter_half": 432
  },
  "TA11": {
   "cells": 64,
   "mm": 772,
   "n": 423,
   "periods": {
    "1961-1990": 707,
    "1981-2010": 744,
    "1991-2020": 772
   },
   "seasons": {
    "djf": 202,
    "jja": 189,
    "mam": 155,
    "son": 227
   },
   "summer_half": 343,
   "winter_half": 428
  },
  "TA12": {
   "cells": 21,
   "mm": 796,
   "n": 170,
   "periods": {
    "1961-1990": 726,
    "1981-2010": 767,
    "1991-2020": 796
   },
   "seasons": {
    "djf": 224,
    "jja": 168,
    "mam": 162,
    "son": 241
   },
   "summer_half": 331,
   "winter_half": 465
  },
  "TA13": {
   "cells": 20,
   "mm": 830,
   "n": 145,
   "periods": {
    "1961-1990": 749,
    "1981-2010": 794,
    "1991-2020": 830
   },
   "seasons": {
    "djf": 235,
    "jja": 170,
    "mam": 169,
    "son": 256
   },
   "summer_half": 339,
   "winter_half": 492
  },
  "TA14": {
   "cells": 12,
   "mm": 847,
   "n": 89,
   "periods": {
    "1961-1990": 771,
    "1981-2010": 815,
    "1991-2020": 847
   },
   "seasons": {
    "djf": 243,
    "jja": 181,
    "mam": 166,
    "son": 257
   },
   "summer_half": 347,
   "winter_half": 499
  },
  "TA15": {
   "cells": 4,
   "mm": 832,
   "n": 25,
   "periods": {
    "1961-1990": 761,
    "1981-2010": 804,
    "1991-2020": 832
   },
   "seasons": {
    "djf": 243,
    "jja": 184,
    "mam": 164,
    "son": 241
   },
   "summer_half": 348,
   "winter_half": 484
  },
  "TA16": {
   "cells": 4,
   "mm": 886,
   "n": 56,
   "periods": {
    "1961-1990": 821,
    "1981-2010": 852,
    "1991-2020": 886
   },
   "seasons": {
    "djf": 256,
    "jja": 179,
    "mam": 177,
    "son": 274
   },
   "summer_half": 356,
   "winter_half": 530
  },
  "TA17": {
   "cells": 14,
   "mm": 943,
   "n": 35,
   "periods": {
    "1961-1990": 844,
    "1981-2010": 901,
    "1991-2020": 943
   },
   "seasons": {
    "djf": 278,
    "jja": 191,
    "mam": 189,
    "son": 285
   },
   "summer_half": 381,
   "winter_half": 562
  },
  "TA18": {
   "cells": 51,
   "mm": 970,
   "n": 412,
   "periods": {
    "1961-1990": 896,
    "1981-2010": 939,
    "1991-2020": 970
   },
   "seasons": {
    "djf": 282,
    "jja": 196,
    "mam": 193,
    "son": 299
   },
   "summer_half": 389,
   "winter_half": 580
  },
  "TA19": {
   "cells": 66,
   "mm": 883,
   "n": 443,
   "periods": {
    "1961-1990": 812,
    "1981-2010": 854,
    "1991-2020": 883
   },
   "seasons": {
    "djf": 258,
    "jja": 178,
    "mam": 183,
    "son": 265
   },
   "summer_half": 360,
   "winter_half": 523
  },
  "TA2": {
   "cells": 51,
   "mm": 799,
   "n": 747,
   "periods": {
    "1961-1990": 744,
    "1981-2010": 778,
    "1991-2020": 799
   },
   "seasons": {
    "djf": 233,
    "jja": 170,
    "mam": 160,
    "son": 236
   },
   "summer_half": 330,
   "winter_half": 468
  },
  "TA20": {
   "cells": 124,
   "mm": 1091,
   "n": 848,
   "periods": {
    "1961-1990": 982,
    "1981-2010": 1046,
    "1991-2020": 1091
   },
   "seasons": {
    "djf": 329,
    "jja": 212,
    "mam": 222,
    "son": 328
   },
   "summer_half": 434,
   "winter_half": 657
  },
  "TA21": {
   "cells": 99,
   "mm": 986,
   "n": 671,
   "periods": {
    "1961-1990": 921,
    "1981-2010": 961,
    "1991-2020": 986
   },
   "seasons": {
    "djf": 306,
    "jja": 200,
    "mam": 195,
    "son": 285
   },
   "summer_half": 395,
   "winter_half": 591
  },
  "TA22": {
   "cells": 65,
   "mm": 1399,
   "n": 172,
   "periods": {
    "1961-1990": 1307,
    "1981-2010": 1385,
    "1991-2020": 1399
   },
   "seasons": {
    "djf": 447,
    "jja": 284,
    "mam": 265,
    "son": 403
   },
   "summer_half": 549,
   "winter_half": 850
  },
  "TA23": {
   "cells": 43,
   "mm": 1068,
   "n": 254,
   "periods": {
    "1961-1990": 994,
    "1981-2010": 1060,
    "1991-2020": 1068
   },
   "seasons": {
    "djf": 334,
    "jja": 212,
    "mam": 211,
    "son": 310
   },
   "summer_half": 423,
   "winter_half": 645
  },
  "TA24": {
   "cells": 180,
   "mm": 1378,
   "n": 957,
   "periods": {
    "1961-1990": 1282,
    "1981-2010": 1360,
    "1991-2020": 1378
   },
   "seasons": {
    "djf": 456,
    "jja": 260,
    "mam": 256,
    "son": 406
   },
   "summer_half": 516,
   "winter_half": 862
  },
  "TA3": {
   "cells": 174,
   "mm": 883,
   "n": 663,
   "periods": {
    "1961-1990": 825,
    "1981-2010": 857,
    "1991-2020": 883
   },
   "seasons": {
    "djf": 261,
    "jja": 181,
    "mam": 178,
    "son": 262
   },
   "summer_half": 360,
   "winter_half": 523
  },
  "TA4": {
   "cells": 239,
   "mm": 1031,
   "n": 951,
   "periods": {
    "1961-1990": 963,
    "1981-2010": 1011,
    "1991-2020": 1031
   },
   "seasons": {
    "djf": 315,
    "jja": 210,
    "mam": 205,
    "son": 301
   },
   "summer_half": 415,
   "winter_half": 616
  },
  "TA5": {
   "cells": 135,
   "mm": 854,
   "n": 503,
   "periods": {
    "1961-1990": 801,
    "1981-2010": 834,
    "1991-2020": 854
   },
   "seasons": {
    "djf": 242,
    "jja": 186,
    "mam": 174,
    "son": 251
   },
   "summer_half": 360,
   "winter_half": 493
  },
  "TA6": {
   "cells": 45,
   "mm": 789,
   "n": 1412,
   "periods": {
    "1961-1990": 741,
    "1981-2010": 772,
    "1991-2020": 789
   },
   "seasons": {
    "djf": 216,
    "jja": 179,
    "mam": 161,
    "son": 234
   },
   "summer_half": 339,
   "winter_half": 450
  },
  "TA7": {
   "cells": 118,
   "mm": 739,
   "n": 612,
   "periods": {
    "1961-1990": 702,
    "1981-2010": 719,
    "1991-2020": 739
   },
   "seasons": {
    "djf": 197,
    "jja": 177,
    "mam": 151,
    "son": 215
   },
   "summer_half": 327,
   "winter_half": 412
  },
  "TA8": {
   "cells": 18,
   "mm": 791,
   "n": 437,
   "periods": {
    "1961-1990": 750,
    "1981-2010": 778,
    "1991-2020": 791
   },
   "seasons": {
    "djf": 216,
    "jja": 188,
    "mam": 158,
    "son": 229
   },
   "summer_half": 346,
   "winter_half": 445
  },
  "TA9": {
   "cells": 53,
   "mm": 770,
   "n": 468,
   "periods": {
    "1961-1990": 739,
    "1981-2010": 760,
    "1991-2020": 770
   },
   "seasons": {
    "djf": 203,
    "jja": 191,
    "mam": 153,
    "son": 223
   },
   "summer_half": 344,
   "winter_half": 426
  },
  "TD1": {
   "cells": 89,
   "mm": 917,
   "n": 639,
   "periods": {
    "1961-1990": 833,
    "1981-2010": 880,
    "1991-2020": 917
   },
   "seasons": {
    "djf": 259,
    "jja": 221,
    "mam": 177,
    "son": 260
   },
   "summer_half": 399,
   "winter_half": 519
  },
  "TD10": {
   "cells": 20,
   "mm": 824,
   "n": 42,
   "periods": {
    "1961-1990": 748,
    "1981-2010": 790,
    "1991-2020": 824
   },
   "seasons": {
    "djf": 206,
    "jja": 221,
    "mam": 163,
    "son": 234
   },
   "summer_half": 384,
   "winter_half": 440
  },
  "TD11": {
   "cells": 98,
   "mm": 794,
   "n": 297,
   "periods": {
    "1961-1990": 737,
    "1981-2010": 771,
    "1991-2020": 794
   },
   "seasons": {
    "djf": 198,
    "jja": 211,
    "mam": 158,
    "son": 227
   },
   "summer_half": 369,
   "winter_half": 424
  },
  "TD12": {
   "cells": 98,
   "mm": 686,
   "n": 237,
   "periods": {
    "1961-1990": 631,
    "1981-2010": 666,
    "1991-2020": 686
   },
   "seasons": {
    "djf": 163,
    "jja": 195,
    "mam": 135,
    "son": 194
   },
   "summer_half": 329,
   "winter_half": 357
  },
  "TD13": {
   "cells": 18,
   "mm": 784,
   "n": 42,
   "periods": {
    "1961-1990": 712,
    "1981-2010": 754,
    "1991-2020": 784
   },
   "seasons": {
    "djf": 191,
    "jja": 218,
    "mam": 153,
    "son": 221
   },
   "summer_half": 372,
   "winter_half": 412
  },
  "TD14": {
   "cells": 54,
   "mm": 762,
   "n": 258,
   "periods": {
    "1961-1990": 693,
    "1981-2010": 731,
    "1991-2020": 762
   },
   "seasons": {
    "djf": 175,
    "jja": 213,
    "mam": 151,
    "son": 224
   },
   "summer_half": 363,
   "winter_half": 398
  },
  "TD15": {
   "cells": 108,
   "mm": 709,
   "n": 563,
   "periods": {
    "1961-1990": 644,
    "1981-2010": 684,
    "1991-2020": 709
   },
   "seasons": {
    "djf": 166,
    "jja": 204,
    "mam": 140,
    "son": 200
   },
   "summer_half": 343,
   "winter_half": 366
  },
  "TD2": {
   "cells": 40,
   "mm": 894,
   "n": 106,
   "periods": {
    "1961-1990": 836,
    "1981-2010": 872,
    "1991-2020": 894
   },
   "seasons": {
    "djf": 245,
    "jja": 216,
    "mam": 174,
    "son": 258
   },
   "summer_half": 390,
   "winter_half": 504
  },
  "TD3": {
   "cells": 27,
   "mm": 827,
   "n": 46,
   "periods": {
    "1961-1990": 773,
    "1981-2010": 804,
    "1991-2020": 827
   },
   "seasons": {
    "djf": 216,
    "jja": 216,
    "mam": 159,
    "son": 236
   },
   "summer_half": 375,
   "winter_half": 452
  },
  "TD4": {
   "cells": 25,
   "mm": 854,
   "n": 109,
   "periods": {
    "1961-1990": 770,
    "1981-2010": 821,
    "1991-2020": 854
   },
   "seasons": {
    "djf": 226,
    "jja": 215,
    "mam": 167,
    "son": 246
   },
   "summer_half": 382,
   "winter_half": 472
  },
  "TD5": {
   "cells": 150,
   "mm": 761,
   "n": 452,
   "periods": {
    "1961-1990": 694,
    "1981-2010": 738,
    "1991-2020": 761
   },
   "seasons": {
    "djf": 191,
    "jja": 207,
    "mam": 147,
    "son": 216
   },
   "summer_half": 354,
   "winter_half": 408
  },
  "TD6": {
   "cells": 78,
   "mm": 826,
   "n": 423,
   "periods": {
    "1961-1990": 731,
    "1981-2010": 789,
    "1991-2020": 826
   },
   "seasons": {
    "djf": 219,
    "jja": 214,
    "mam": 160,
    "son": 232
   },
   "summer_half": 374,
   "winter_half": 451
  },
  "TD7": {
   "cells": 83,
   "mm": 1108,
   "n": 298,
   "periods": {
    "1961-1990": 986,
    "1981-2010": 1068,
    "1991-2020": 1108
   },
   "seasons": {
    "djf": 334,
    "jja": 246,
    "mam": 215,
    "son": 313
   },
   "summer_half": 461,
   "winter_half": 647
  },
  "TD8": {
   "cells": 87,
   "mm": 833,
   "n": 272,
   "periods": {
    "1961-1990": 763,
    "1981-2010": 809,
    "1991-2020": 833
   },
   "seasons": {
    "djf": 224,
    "jja": 223,
    "mam": 155,
    "son": 231
   },
   "summer_half": 378,
   "winter_half": 455
  },
  "TD9": {
   "cells": 188,
   "mm": 1130,
   "n": 756,
   "periods": {
    "1961-1990": 1015,
    "1981-2010": 1096,
    "1991-2020": 1130
   },
   "seasons": {
    "djf": 338,
    "jja": 265,
    "mam": 216,
    "son": 311
   },
   "summer_half": 481,
   "winter_half": 649
  },
  "TF1": {
   "cells": 30,
   "mm": 704,
   "n": 1110,
   "periods": {
    "1961-1990": 683,
    "1981-2010": 695,
    "1991-2020": 704
   },
   "seasons": {
    "djf": 163,
    "jja": 195,
    "mam": 156,
    "son": 190
   },
   "summer_half": 351,
   "winter_half": 353
  },
  "TF10": {
   "cells": 101,
   "mm": 705,
   "n": 655,
   "periods": {
    "1961-1990": 680,
    "1981-2010": 688,
    "1991-2020": 705
   },
   "seasons": {
    "djf": 170,
    "jja": 194,
    "mam": 150,
    "son": 192
   },
   "summer_half": 344,
   "winter_half": 362
  },
  "TF11": {
   "cells": 105,
   "mm": 724,
   "n": 457,
   "periods": {
    "1961-1990": 699,
    "1981-2010": 707,
    "1991-2020": 724
   },
   "seasons": {
    "djf": 181,
    "jja": 192,
    "mam": 156,
    "son": 195
   },
   "summer_half": 348,
   "winter_half": 376
  },
  "TF12": {
   "cells": 23,
   "mm": 782,
   "n": 238,
   "periods": {
    "1961-1990": 751,
    "1981-2010": 772,
    "1991-2020": 782
   },
   "seasons": {
    "djf": 201,
    "jja": 206,
    "mam": 163,
    "son": 212
   },
   "summer_half": 369,
   "winter_half": 413
  },
  "TF13": {
   "cells": 65,
   "mm": 766,
   "n": 203,
   "periods": {
    "1961-1990": 722,
    "1981-2010": 753,
    "1991-2020": 766
   },
   "seasons": {
    "djf": 195,
    "jja": 195,
    "mam": 165,
    "son": 211
   },
   "summer_half": 361,
   "winter_half": 406
  },
  "TF2": {
   "cells": 32,
   "mm": 745,
   "n": 1142,
   "periods": {
    "1961-1990": 718,
    "1981-2010": 731,
    "1991-2020": 745
   },
   "seasons": {
    "djf": 177,
    "jja": 202,
    "mam": 166,
    "son": 201
   },
   "summer_half": 367,
   "winter_half": 378
  },
  "TF3": {
   "cells": 22,
   "mm": 764,
   "n": 654,
   "periods": {
    "1961-1990": 737,
    "1981-2010": 749,
    "1991-2020": 764
   },
   "seasons": {
    "djf": 187,
    "jja": 206,
    "mam": 166,
    "son": 206
   },
   "summer_half": 372,
   "winter_half": 393
  },
  "TF4": {
   "cells": 20,
   "mm": 762,
   "n": 614,
   "periods": {
    "1961-1990": 737,
    "1981-2010": 749,
    "1991-2020": 762
   },
   "seasons": {
    "djf": 186,
    "jja": 208,
    "mam": 163,
    "son": 206
   },
   "summer_half": 371,
   "winter_half": 392
  },
  "TF5": {
   "cells": 8,
   "mm": 670,
   "n": 119,
   "periods": {
    "1961-1990": 657,
    "1981-2010": 665,
    "1991-2020": 670
   },
   "seasons": {
    "djf": 159,
    "jja": 186,
    "mam": 146,
    "son": 179
   },
   "summer_half": 333,
   "winter_half": 337
  },
  "TF6": {
   "cells": 108,
   "mm": 688,
   "n": 306,
   "periods": {
    "1961-1990": 666,
    "1981-2010": 679,
    "1991-2020": 688
   },
   "seasons": {
    "djf": 166,
    "jja": 189,
    "mam": 147,
    "son": 186
   },
   "summer_half": 336,
   "winter_half": 352
  },
  "TF7": {
   "cells": 17,
   "mm": 747,
   "n": 515,
   "periods": {
    "1961-1990": 718,
    "1981-2010": 731,
    "1991-2020": 747
   },
   "seasons": {
    "djf": 184,
    "jja": 202,
    "mam": 159,
    "son": 203
   },
   "summer_half": 360,
   "winter_half": 387
  },
  "TF8": {
   "cells": 19,
   "mm": 708,
   "n": 183,
   "periods": {
    "1961-1990": 680,
    "1981-2010": 695,
    "1991-2020": 708
   },
   "seasons": {
    "djf": 177,
    "jja": 191,
    "mam": 152,
    "son": 189
   },
   "summer_half": 342,
   "winter_half": 366
  },
  "TF9": {
   "cells": 198,
   "mm": 748,
   "n": 1029,
   "periods": {
    "1961-1990": 716,
    "1981-2010": 736,
    "1991-2020": 748
   },
   "seasons": {
    "djf": 187,
    "jja": 197,
    "mam": 155,
    "son": 209
   },
   "summer_half": 352,
   "winter_half": 396
  },
  "TN1": {
   "cells": 7,
   "mm": 834,
   "n": 399,
   "periods": {
    "1961-1990": 799,
    "1981-2010": 820,
    "1991-2020": 834
   },
   "seasons": {
    "djf": 250,
    "jja": 169,
    "mam": 166,
    "son": 249
   },
   "summer_half": 335,
   "winter_half": 500
  },
  "TN10": {
   "cells": 11,
   "mm": 707,
   "n": 396,
   "periods": {
    "1961-1990": 690,
    "1981-2010": 695,
    "1991-2020": 707
   },
   "seasons": {
    "djf": 209,
    "jja": 144,
    "mam": 143,
    "son": 210
   },
   "summer_half": 287,
   "winter_half": 420
  },
  "TN11": {
   "cells": 104,
   "mm": 722,
   "n": 593,
   "periods": {
    "1961-1990": 702,
    "1981-2010": 713,
    "1991-2020": 722
   },
   "seasons": {
    "djf": 212,
    "jja": 150,
    "mam": 144,
    "son": 216
   },
   "summer_half": 294,
   "winter_half": 428
  },
  "TN12": {
   "cells": 138,
   "mm": 694,
   "n": 1258,
   "periods": {
    "1961-1990": 672,
    "1981-2010": 689,
    "1991-2020": 694
   },
   "seasons": {
    "djf": 201,
    "jja": 143,
    "mam": 141,
    "son": 209
   },
   "summer_half": 283,
   "winter_half": 411
  },
  "TN13": {
   "cells": 22,
   "mm": 784,
   "n": 803,
   "periods": {
    "1961-1990": 764,
    "1981-2010": 770,
    "1991-2020": 784
   },
   "seasons": {
    "djf": 230,
    "jja": 166,
    "mam": 153,
    "son": 235
   },
   "summer_half": 318,
   "winter_half": 465
  },
  "TN14": {
   "cells": 94,
   "mm": 780,
   "n": 581,
   "periods": {
    "1961-1990": 759,
    "1981-2010": 770,
    "1991-2020": 780
   },
   "seasons": {
    "djf": 229,
    "jja": 164,
    "mam": 154,
    "son": 232
   },
   "summer_half": 318,
   "winter_half": 462
  },
  "TN15": {
   "cells": 115,
   "mm": 764,
   "n": 946,
   "periods": {
    "1961-1990": 752,
    "1981-2010": 754,
    "1991-2020": 764
   },
   "seasons": {
    "djf": 222,
    "jja": 163,
    "mam": 151,
    "son": 228
   },
   "summer_half": 314,
   "winter_half": 450
  },
  "TN16": {
   "cells": 52,
   "mm": 837,
   "n": 616,
   "periods": {
    "1961-1990": 817,
    "1981-2010": 830,
    "1991-2020": 837
   },
   "seasons": {
    "djf": 248,
    "jja": 171,
    "mam": 165,
    "son": 253
   },
   "summer_half": 336,
   "winter_half": 501
  },
  "TN17": {
   "cells": 121,
   "mm": 785,
   "n": 668,
   "periods": {
    "1961-1990": 743,
    "1981-2010": 777,
    "1991-2020": 785
   },
   "seasons": {
    "djf": 240,
    "jja": 155,
    "mam": 151,
    "son": 239
   },
   "summer_half": 305,
   "winter_half": 480
  },
  "TN18": {
   "cells": 42,
   "mm": 821,
   "n": 351,
   "periods": {
    "1961-1990": 766,
    "1981-2010": 808,
    "1991-2020": 821
   },
   "seasons": {
    "djf": 251,
    "jja": 163,
    "mam": 153,
    "son": 253
   },
   "summer_half": 316,
   "winter_half": 504
  },
  "TN19": {
   "cells": 43,
   "mm": 884,
   "n": 184,
   "periods": {
    "1961-1990": 833,
    "1981-2010": 870,
    "1991-2020": 884
   },
   "seasons": {
    "djf": 275,
    "jja": 175,
    "mam": 160,
    "son": 273
   },
   "summer_half": 335,
   "winter_half": 549
  },
  "TN2": {
   "cells": 32,
   "mm": 818,
   "n": 817,
   "periods": {
    "1961-1990": 786,
    "1981-2010": 805,
    "1991-2020": 818
   },
   "seasons": {
    "djf": 245,
    "jja": 166,
    "mam": 160,
    "son": 246
   },
   "summer_half": 327,
   "winter_half": 491
  },
  "TN20": {
   "cells": 30,
   "mm": 906,
   "n": 176,
   "periods": {
    "1961-1990": 852,
    "1981-2010": 892,
    "1991-2020": 906
   },
   "seasons": {
    "djf": 282,
    "jja": 179,
    "mam": 167,
    "son": 279
   },
   "summer_half": 346,
   "winter_half": 561
  },
  "TN21": {
   "cells": 93,
   "mm": 915,
   "n": 711,
   "periods": {
    "1961-1990": 860,
    "1981-2010": 896,
    "1991-2020": 915
   },
   "seasons": {
    "djf": 280,
    "jja": 189,
    "mam": 161,
    "son": 285
   },
   "summer_half": 350,
   "winter_half": 565
  },
  "TN22": {
   "cells": 125,
   "mm": 876,
   "n": 1003,
   "periods": {
    "1961-1990": 819,
    "1981-2010": 857,
    "1991-2020": 876
   },
   "seasons": {
    "djf": 267,
    "jja": 179,
    "mam": 156,
    "son": 273
   },
   "summer_half": 335,
   "winter_half": 540
  },
  "TN23": {
   "cells": 27,
   "mm": 762,
   "n": 1033,
   "periods": {
    "1961-1990": 726,
    "1981-2010": 747,
    "1991-2020": 762
   },
   "seasons": {
    "djf": 221,
    "jja": 160,
    "mam": 140,
    "son": 242
   },
   "summer_half": 300,
   "winter_half": 463
  },
  "TN24": {
   "cells": 24,
   "mm": 774,
   "n": 771,
   "periods": {
    "1961-1990": 733,
    "1981-2010": 756,
    "1991-2020": 774
   },
   "seasons": {
    "djf": 224,
    "jja": 163,
    "mam": 141,
    "son": 245
   },
   "summer_half": 304,
   "winter_half": 469
  },
  "TN25": {
   "cells": 169,
   "mm": 793,
   "n": 757,
   "periods": {
    "1961-1990": 751,
    "1981-2010": 773,
    "1991-2020": 793
   },
   "seasons": {
    "djf": 229,
    "jja": 170,
    "mam": 144,
    "son": 250
   },
   "summer_half": 314,
   "winter_half": 479
  },
  "TN26": {
   "cells": 144,
   "mm": 725,
   "n": 522,
   "periods": {
    "1961-1990": 698,
    "1981-2010": 717,
    "1991-2020": 725
   },
   "seasons": {
    "djf": 212,
    "jja": 152,
    "mam": 133,
    "son": 228
   },
   "summer_half": 285,
   "winter_half": 440
  },
  "TN27": {
   "cells": 130,
   "mm": 731,
   "n": 641,
   "periods": {
    "1961-1990": 705,
    "1981-2010": 726,
    "1991-2020": 731
   },
   "seasons": {
    "djf": 214,
    "jja": 154,
    "mam": 142,
    "son": 222
   },
   "summer_half": 296,
   "winter_half": 435
  },
  "TN28": {
   "cells": 13,
   "mm": 706,
   "n": 303,
   "periods": {
    "1961-1990": 683,
    "1981-2010": 693,
    "1991-2020": 706
   },
   "seasons": {
    "djf": 205,
    "jja": 153,
    "mam": 126,
    "son": 221
   },
   "summer_half": 280,
   "winter_half": 426
  },
  "TN29": {
   "cells": 94,
   "mm": 703,
   "n": 527,
   "periods": {
    "1961-1990": 678,
    "1981-2010": 689,
    "1991-2020": 703
   },
   "seasons": {
    "djf": 204,
    "jja": 152,
    "mam": 126,
    "son": 221
   },
   "summer_half": 278,
   "winter_half": 425
  },
  "TN3": {
   "cells": 110,
   "mm": 848,
   "n": 567,
   "periods": {
    "1961-1990": 803,
    "1981-2010": 832,
    "1991-2020": 848
   },
   "seasons": {
    "djf": 261,
    "jja": 172,
    "mam": 162,
    "son": 253
   },
   "summer_half": 333,
   "winter_half": 515
  },
  "TN30": {
   "cells": 58,
   "mm": 729,
   "n": 387,
   "periods": {
    "1961-1990": 703,
    "1981-2010": 721,
    "1991-2020": 729
   },
   "seasons": {
    "djf": 220,
    "jja": 147,
    "mam": 137,
    "son": 225
   },
   "summer_half": 284,
   "winter_half": 445
  },
  "TN31": {
   "cells": 97,
   "mm": 796,
   "n": 540,
   "periods": {
    "1961-1990": 761,
    "1981-2010": 777,
    "1991-2020": 796
   },
   "seasons": {
    "djf": 245,
    "jja": 158,
    "mam": 143,
    "son": 251
   },
   "summer_half": 301,
   "winter_half": 495
  },
  "TN32": {
   "cells": 66,
   "mm": 898,
   "n": 242,
   "periods": {
    "1961-1990": 840,
    "1981-2010": 883,
    "1991-2020": 898
   },
   "seasons": {
    "djf": 283,
    "jja": 174,
    "mam": 160,
    "son": 281
   },
   "summer_half": 334,
   "winter_half": 564
  },
  "TN33": {
   "cells": 94,
   "mm": 872,
   "n": 489,
   "periods": {
    "1961-1990": 820,
    "1981-2010": 852,
    "1991-2020": 872
   },
   "seasons": {
    "djf": 268,
    "jja": 179,
    "mam": 152,
    "son": 274
   },
   "summer_half": 331,
   "winter_half": 541
  },
  "TN34": {
   "cells": 15,
   "mm": 822,
   "n": 719,
   "periods": {
    "1961-1990": 774,
    "1981-2010": 807,
    "1991-2020": 822
   },
   "seasons": {
    "djf": 248,
    "jja": 171,
    "mam": 145,
    "son": 258
   },
   "summer_half": 316,
   "winter_half": 506
  },
  "TN35": {
   "cells": 45,
   "mm": 824,
   "n": 401,
   "periods": {
    "1961-1990": 780,
    "1981-2010": 812,
    "1991-2020": 824
   },
   "seasons": {
    "djf": 252,
    "jja": 167,
    "mam": 144,
    "son": 261
   },
   "summer_half": 311,
   "winter_half": 513
  },
  "TN36": {
   "cells": 15,
   "mm": 791,
   "n": 104,
   "periods": {
    "1961-1990": 761,
    "1981-2010": 774,
    "1991-2020": 791
   },
   "seasons": {
    "djf": 244,
    "jja": 155,
    "mam": 140,
    "son": 252
   },
   "summer_half": 295,
   "winter_half": 496
  },
  "TN37": {
   "cells": 13,
   "mm": 847,
   "n": 460,
   "periods": {
    "1961-1990": 781,
    "1981-2010": 827,
    "1991-2020": 847
   },
   "seasons": {
    "djf": 255,
    "jja": 175,
    "mam": 149,
    "son": 267
   },
   "summer_half": 325,
   "winter_half": 522
  },
  "TN38": {
   "cells": 20,
   "mm": 833,
   "n": 660,
   "periods": {
    "1961-1990": 771,
    "1981-2010": 810,
    "1991-2020": 833
   },
   "seasons": {
    "djf": 252,
    "jja": 172,
    "mam": 146,
    "son": 263
   },
   "summer_half": 318,
   "winter_half": 514
  },
  "TN39": {
   "cells": 26,
   "mm": 799,
   "n": 704,
   "periods": {
    "1961-1990": 747,
    "1981-2010": 773,
    "1991-2020": 799
   },
   "seasons": {
    "djf": 243,
    "jja": 166,
    "mam": 139,
    "son": 251
   },
   "summer_half": 305,
   "winter_half": 494
  },
  "TN4": {
   "cells": 24,
   "mm": 806,
   "n": 779,
   "periods": {
    "1961-1990": 778,
    "1981-2010": 793,
    "1991-2020": 806
   },
   "seasons": {
    "djf": 250,
    "jja": 164,
    "mam": 157,
    "son": 236
   },
   "summer_half": 321,
   "winter_half": 485
  },
  "TN40": {
   "cells": 9,
   "mm": 803,
   "n": 575,
   "periods": {
    "1961-1990": 757,
    "1981-2010": 778,
    "1991-2020": 803
   },
   "seasons": {
    "djf": 246,
    "jja": 165,
    "mam": 139,
    "son": 254
   },
   "summer_half": 304,
   "winter_half": 499
  },
  "TN5": {
   "cells": 71,
   "mm": 890,
   "n": 411,
   "periods": {
    "1961-1990": 840,
    "1981-2010": 879,
    "1991-2020": 890
   },
   "seasons": {
    "djf": 274,
    "jja": 180,
    "mam": 167,
    "son": 269
   },
   "summer_half": 347,
   "winter_half": 543
  },
  "TN6": {
   "cells": 60,
   "mm": 954,
   "n": 858,
   "periods": {
    "1961-1990": 902,
    "1981-2010": 943,
    "1991-2020": 954
   },
   "seasons": {
    "djf": 294,
    "jja": 194,
    "mam": 177,
    "son": 289
   },
   "summer_half": 371,
   "winter_half": 583
  },
  "TN7": {
   "cells": 34,
   "mm": 862,
   "n": 98,
   "periods": {
    "1961-1990": 817,
    "1981-2010": 839,
    "1991-2020": 862
   },
   "seasons": {
    "djf": 266,
    "jja": 172,
    "mam": 161,
    "son": 263
   },
   "summer_half": 333,
   "winter_half": 529
  },
  "TN8": {
   "cells": 96,
   "mm": 775,
   "n": 572,
   "periods": {
    "1961-1990": 733,
    "1981-2010": 755,
    "1991-2020": 775
   },
   "seasons": {
    "djf": 231,
    "jja": 161,
    "mam": 148,
    "son": 236
   },
   "summer_half": 309,
   "winter_half": 466
  },
  "TN9": {
   "cells": 12,
   "mm": 691,
   "n": 550,
   "periods": {
    "1961-1990": 678,
    "1981-2010": 683,
    "1991-2020": 691
   },
   "seasons": {
    "djf": 206,
    "jja": 140,
    "mam": 139,
    "son": 206
   },
   "summer_half": 279,
   "winter_half": 412
  },
  "TQ1": {
   "cells": 17,
   "mm": 962,
   "n": 924,
   "periods": {
    "1961-1990": 917,
    "1981-2010": 936,
    "1991-2020": 962
   },
   "seasons": {
    "djf": 308,
    "jja": 174,
    "mam": 190,
    "son": 290
   },
   "summer_half": 364,
   "winter_half": 598
  },
  "TQ10": {
   "cells": 42,
   "mm": 1683,
   "n": 178,
   "periods": {
    "1961-1990": 1537,
    "1981-2010": 1636,
    "1991-2020": 1683
   },
   "seasons": {
    "djf": 561,
    "jja": 324,
    "mam": 319,
    "son": 478
   },
   "summer_half": 643,
   "winter_half": 1039
  },
  "TQ11": {
   "cells": 31,
   "mm": 1721,
   "n": 157,
   "periods": {
    "1961-1990": 1573,
    "1981-2010": 1672,
    "1991-2020": 1721
   },
   "seasons": {
    "djf": 602,
    "jja": 294,
    "mam": 330,
    "son": 495
   },
   "summer_half": 624,
   "winter_half": 1097
  },
  "TQ12": {
   "cells": 125,
   "mm": 1104,
   "n": 1718,
   "periods": {
    "1961-1990": 1037,
    "1981-2010": 1081,
    "1991-2020": 1104
   },
   "seasons": {
    "djf": 365,
    "jja": 197,
    "mam": 222,
    "son": 320
   },
   "summer_half": 419,
   "winter_half": 685
  },
  "TQ13": {
   "cells": 246,
   "mm": 1405,
   "n": 1047,
   "periods": {
    "1961-1990": 1301,
    "1981-2010": 1365,
    "1991-2020": 1405
   },
   "seasons": {
    "djf": 482,
    "jja": 238,
    "mam": 278,
    "son": 407
   },
   "summer_half": 517,
   "winter_half": 889
  },
  "TQ14": {
   "cells": 23,
   "mm": 984,
   "n": 660,
   "periods": {
    "1961-1990": 912,
    "1981-2010": 949,
    "1991-2020": 984
   },
   "seasons": {
    "djf": 300,
    "jja": 185,
    "mam": 207,
    "son": 292
   },
   "summer_half": 392,
   "winter_half": 592
  },
  "TQ2": {
   "cells": 18,
   "mm": 1008,
   "n": 934,
   "periods": {
    "1961-1990": 958,
    "1981-2010": 982,
    "1991-2020": 1008
   },
   "seasons": {
    "djf": 332,
    "jja": 181,
    "mam": 197,
    "son": 298
   },
   "summer_half": 378,
   "winter_half": 630
  },
  "TQ3": {
   "cells": 24,
   "mm": 1096,
   "n": 750,
   "periods": {
    "1961-1990": 1027,
    "1981-2010": 1065,
    "1991-2020": 1096
   },
   "seasons": {
    "djf": 372,
    "jja": 194,
    "mam": 213,
    "son": 317
   },
   "summer_half": 407,
   "winter_half": 689
  },
  "TQ4": {
   "cells": 23,
   "mm": 1076,
   "n": 604,
   "periods": {
    "1961-1990": 1009,
    "1981-2010": 1038,
    "1991-2020": 1076
   },
   "seasons": {
    "djf": 360,
    "jja": 192,
    "mam": 209,
    "son": 315
   },
   "summer_half": 401,
   "winter_half": 675
  },
  "TQ5": {
   "cells": 20,
   "mm": 1062,
   "n": 651,
   "periods": {
    "1961-1990": 999,
    "1981-2010": 1030,
    "1991-2020": 1062
   },
   "seasons": {
    "djf": 345,
    "jja": 198,
    "mam": 206,
    "son": 313
   },
   "summer_half": 404,
   "winter_half": 658
  },
  "TQ6": {
   "cells": 48,
   "mm": 1183,
   "n": 456,
   "periods": {
    "1961-1990": 1093,
    "1981-2010": 1144,
    "1991-2020": 1183
   },
   "seasons": {
    "djf": 381,
    "jja": 226,
    "mam": 228,
    "son": 348
   },
   "summer_half": 454,
   "winter_half": 728
  },
  "TQ7": {
   "cells": 165,
   "mm": 1139,
   "n": 922,
   "periods": {
    "1961-1990": 1055,
    "1981-2010": 1101,
    "1991-2020": 1139
   },
   "seasons": {
    "djf": 362,
    "jja": 224,
    "mam": 224,
    "son": 329
   },
   "summer_half": 449,
   "winter_half": 691
  },
  "TQ8": {
   "cells": 10,
   "mm": 1148,
   "n": 179,
   "periods": {
    "1961-1990": 1050,
    "1981-2010": 1101,
    "1991-2020": 1148
   },
   "seasons": {
    "djf": 356,
    "jja": 226,
    "mam": 225,
    "son": 341
   },
   "summer_half": 451,
   "winter_half": 696
  },
  "TQ9": {
   "cells": 164,
   "mm": 1310,
   "n": 937,
   "periods": {
    "1961-1990": 1215,
    "1981-2010": 1278,
    "1991-2020": 1310
   },
   "seasons": {
    "djf": 433,
    "jja": 247,
    "mam": 252,
    "son": 379
   },
   "summer_half": 499,
   "winter_half": 811
  },
  "TR1": {
   "cells": 22,
   "mm": 1140,
   "n": 927,
   "periods": {
    "1961-1990": 1073,
    "1981-2010": 1113,
    "1991-2020": 1140
   },
   "seasons": {
    "djf": 375,
    "jja": 215,
    "mam": 213,
    "son": 337
   },
   "summer_half": 428,
   "winter_half": 712
  },
  "TR10": {
   "cells": 32,
   "mm": 1332,
   "n": 381,
   "periods": {
    "1961-1990": 1240,
    "1981-2010": 1297,
    "1991-2020": 1332
   },
   "seasons": {
    "djf": 435,
    "jja": 263,
    "mam": 249,
    "son": 385
   },
   "summer_half": 512,
   "winter_half": 820
  },
  "TR11": {
   "cells": 58,
   "mm": 1215,
   "n": 1036,
   "periods": {
    "1961-1990": 1150,
    "1981-2010": 1193,
    "1991-2020": 1215
   },
   "seasons": {
    "djf": 393,
    "jja": 247,
    "mam": 227,
    "son": 348
   },
   "summer_half": 474,
   "winter_half": 741
  },
  "TR12": {
   "cells": 124,
   "mm": 1070,
   "n": 435,
   "periods": {
    "1961-1990": 1072,
    "1981-2010": 1071,
    "1991-2020": 1070
   },
   "seasons": {
    "djf": 333,
    "jja": 219,
    "mam": 206,
    "son": 311
   },
   "summer_half": 426,
   "winter_half": 644
  },
  "TR13": {
   "cells": 93,
   "mm": 1181,
   "n": 781,
   "periods": {
    "1961-1990": 1151,
    "1981-2010": 1168,
    "1991-2020": 1181
   },
   "seasons": {
    "djf": 366,
    "jja": 245,
    "mam": 225,
    "son": 345
   },
   "summer_half": 470,
   "winter_half": 711
  },
  "TR14": {
   "cells": 66,
   "mm": 1170,
   "n": 857,
   "periods": {
    "1961-1990": 1151,
    "1981-2010": 1152,
    "1991-2020": 1170
   },
   "seasons": {
    "djf": 365,
    "jja": 235,
    "mam": 225,
    "son": 345
   },
   "summer_half": 460,
   "winter_half": 710
  },
  "TR15": {
   "cells": 19,
   "mm": 1182,
   "n": 724,
   "periods": {
    "1961-1990": 1129,
    "1981-2010": 1147,
    "1991-2020": 1182
   },
   "seasons": {
    "djf": 374,
    "jja": 234,
    "mam": 225,
    "son": 348
   },
   "summer_half": 460,
   "winter_half": 722
  },
  "TR16": {
   "cells": 79,
   "mm": 1236,
   "n": 668,
   "periods": {
    "1961-1990": 1166,
    "1981-2010": 1200,
    "1991-2020": 1236
   },
   "seasons": {
    "djf": 393,
    "jja": 243,
    "mam": 235,
    "son": 364
   },
   "summer_half": 478,
   "winter_half": 757
  },
  "TR17": {
   "cells": 8,
   "mm": 1074,
   "n": 93,
   "periods": {
    "1961-1990": 1042,
    "1981-2010": 1050,
    "1991-2020": 1074
   },
   "seasons": {
    "djf": 346,
    "jja": 205,
    "mam": 198,
    "son": 326
   },
   "summer_half": 403,
   "winter_half": 672
  },
  "TR18": {
   "cells": 13,
   "mm": 1175,
   "n": 859,
   "periods": {
    "1961-1990": 1144,
    "1981-2010": 1162,
    "1991-2020": 1175
   },
   "seasons": {
    "djf": 377,
    "jja": 228,
    "mam": 222,
    "son": 349
   },
   "summer_half": 450,
   "winter_half": 726
  },
  "TR19": {
   "cells": 88,
   "mm": 1078,
   "n": 517,
   "periods": {
    "1961-1990": 1059,
    "1981-2010": 1064,
    "1991-2020": 1078
   },
   "seasons": {
    "djf": 342,
    "jja": 223,
    "mam": 201,
    "son": 312
   },
   "summer_half": 424,
   "winter_half": 654
  },
  "TR2": {
   "cells": 152,
   "mm": 1124,
   "n": 535,
   "periods": {
    "1961-1990": 1081,
    "1981-2010": 1113,
    "1991-2020": 1124
   },
   "seasons": {
    "djf": 358,
    "jja": 221,
    "mam": 211,
    "son": 334
   },
   "summer_half": 432,
   "winter_half": 692
  },
  "TR20": {
   "cells": 107,
   "mm": 1168,
   "n": 518,
   "periods": {
    "1961-1990": 1132,
    "1981-2010": 1148,
    "1991-2020": 1168
   },
   "seasons": {
    "djf": 369,
    "jja": 233,
    "mam": 219,
    "son": 347
   },
   "summer_half": 452,
   "winter_half": 716
  },
  "TR21": {
   "cells": 6,
   "mm": 931,
   "n": 73,
   "periods": {
    "1961-1990": 903,
    "1981-2010": 913,
    "1991-2020": 931
   },
   "seasons": {
    "djf": 285,
    "jja": 186,
    "mam": 181,
    "son": 279
   },
   "summer_half": 367,
   "winter_half": 564
  },
  "TR22": {
   "cells": 1,
   "mm": 864,
   "n": 1,
   "periods": {
    "1961-1990": 836,
    "1981-2010": 847,
    "1991-2020": 864
   },
   "seasons": {
    "djf": 262,
    "jja": 176,
    "mam": 167,
    "son": 260
   },
   "summer_half": 343,
   "winter_half": 522
  },
  "TR24": {
   "cells": 3,
   "mm": 890,
   "n": 17,
   "periods": {
    "1961-1990": 847,
    "1981-2010": 874,
    "1991-2020": 890
   },
   "seasons": {
    "djf": 276,
    "jja": 180,
    "mam": 168,
    "son": 265
   },
   "summer_half": 348,
   "winter_half": 542
  },
  "TR25": {
   "cells": 1,
   "mm": 865,
   "n": 3,
   "periods": {
    "1961-1990": 827,
    "1981-2010": 846,
    "1991-2020": 865
   },
   "seasons": {
    "djf": 277,
    "jja": 177,
    "mam": 167,
    "son": 244
   },
   "summer_half": 344,
   "winter_half": 521
  },
  "TR26": {
   "cells": 31,
   "mm": 1190,
   "n": 651,
   "periods": {
    "1961-1990": 1132,
    "1981-2010": 1161,
    "1991-2020": 1190
   },
   "seasons": {
    "djf": 375,
    "jja": 236,
    "mam": 219,
    "son": 360
   },
   "summer_half": 455,
   "winter_half": 735
  },
  "TR27": {
   "cells": 69,
   "mm": 1092,
   "n": 556,
   "periods": {
    "1961-1990": 1047,
    "1981-2010": 1062,
    "1991-2020": 1092
   },
   "seasons": {
    "djf": 348,
    "jja": 215,
    "mam": 205,
    "son": 324
   },
   "summer_half": 421,
   "winter_half": 671
  },
  "TR3": {
   "cells": 63,
   "mm": 1233,
   "n": 488,
   "periods": {
    "1961-1990": 1157,
    "1981-2010": 1199,
    "1991-2020": 1233
   },
   "seasons": {
    "djf": 409,
    "jja": 231,
    "mam": 230,
    "son": 364
   },
   "summer_half": 460,
   "winter_half": 773
  },
  "TR4": {
   "cells": 113,
   "mm": 1129,
   "n": 522,
   "periods": {
    "1961-1990": 1082,
    "1981-2010": 1111,
    "1991-2020": 1129
   },
   "seasons": {
    "djf": 365,
    "jja": 214,
    "mam": 213,
    "son": 337
   },
   "summer_half": 426,
   "winter_half": 702
  },
  "TR5": {
   "cells": 20,
   "mm": 1056,
   "n": 183,
   "periods": {
    "1961-1990": 1026,
    "1981-2010": 1050,
    "1991-2020": 1056
   },
   "seasons": {
    "djf": 332,
    "jja": 206,
    "mam": 203,
    "son": 316
   },
   "summer_half": 409,
   "winter_half": 648
  },
  "TR6": {
   "cells": 13,
   "mm": 1032,
   "n": 154,
   "periods": {
    "1961-1990": 1000,
    "1981-2010": 1014,
    "1991-2020": 1032
   },
   "seasons": {
    "djf": 329,
    "jja": 198,
    "mam": 197,
    "son": 308
   },
   "summer_half": 395,
   "winter_half": 637
  },
  "TR7": {
   "cells": 13,
   "mm": 921,
   "n": 679,
   "periods": {
    "1961-1990": 902,
    "1981-2010": 892,
    "1991-2020": 921
   },
   "seasons": {
    "djf": 283,
    "jja": 183,
    "mam": 171,
    "son": 283
   },
   "summer_half": 355,
   "winter_half": 566
  },
  "TR8": {
   "cells": 137,
   "mm": 1056,
   "n": 599,
   "periods": {
    "1961-1990": 1037,
    "1981-2010": 1043,
    "1991-2020": 1056
   },
   "seasons": {
    "djf": 326,
    "jja": 209,
    "mam": 198,
    "son": 323
   },
   "summer_half": 407,
   "winter_half": 649
  },
  "TR9": {
   "cells": 42,
   "mm": 1175,
   "n": 285,
   "periods": {
    "1961-1990": 1163,
    "1981-2010": 1172,
    "1991-2020": 1175
   },
   "seasons": {
    "djf": 360,
    "jja": 236,
    "mam": 226,
    "son": 353
   },
   "summer_half": 462,
   "winter_half": 713
  },
  "TS1": {
   "cells": 6,
   "mm": 605,
   "n": 608,
   "periods": {
    "1961-1990": 577,
    "1981-2010": 603,
    "1991-2020": 605
   },
   "seasons": {
    "djf": 136,
    "jja": 178,
    "mam": 121,
    "son": 171
   },
   "summer_half": 299,
   "winter_half": 307
  },
  "TS10": {
   "cells": 22,
   "mm": 619,
   "n": 1104,
   "periods": {
    "1961-1990": 580,
    "1981-2010": 599,
    "1991-2020": 619
   },
   "seasons": {
    "djf": 146,
    "jja": 183,
    "mam": 116,
    "son": 175
   },
   "summer_half": 298,
   "winter_half": 321
  },
  "TS11": {
   "cells": 20,
   "mm": 613,
   "n": 360,
   "periods": {
    "1961-1990": 573,
    "1981-2010": 590,
    "1991-2020": 613
   },
   "seasons": {
    "djf": 137,
    "jja": 183,
    "mam": 120,
    "son": 174
   },
   "summer_half": 302,
   "winter_half": 310
  },
  "TS12": {
   "cells": 49,
   "mm": 734,
   "n": 672,
   "periods": {
    "1961-1990": 694,
    "1981-2010": 712,
    "1991-2020": 734
   },
   "seasons": {
    "djf": 174,
    "jja": 201,
    "mam": 143,
    "son": 216
   },
   "summer_half": 344,
   "winter_half": 390
  },
  "TS13": {
   "cells": 62,
   "mm": 710,
   "n": 396,
   "periods": {
    "1961-1990": 668,
    "1981-2010": 696,
    "1991-2020": 710
   },
   "seasons": {
    "djf": 170,
    "jja": 194,
    "mam": 137,
    "son": 210
   },
   "summer_half": 330,
   "winter_half": 380
  },
  "TS14": {
   "cells": 35,
   "mm": 743,
   "n": 517,
   "periods": {
    "1961-1990": 709,
    "1981-2010": 726,
    "1991-2020": 743
   },
   "seasons": {
    "djf": 171,
    "jja": 207,
    "mam": 146,
    "son": 219
   },
   "summer_half": 353,
   "winter_half": 390
  },
  "TS15": {
   "cells": 57,
   "mm": 649,
   "n": 460,
   "periods": {
    "1961-1990": 624,
    "1981-2010": 640,
    "1991-2020": 649
   },
   "seasons": {
    "djf": 145,
    "jja": 192,
    "mam": 129,
    "son": 183
   },
   "summer_half": 321,
   "winter_half": 328
  },
  "TS16": {
   "cells": 19,
   "mm": 635,
   "n": 348,
   "periods": {
    "1961-1990": 601,
    "1981-2010": 624,
    "1991-2020": 635
   },
   "seasons": {
    "djf": 137,
    "jja": 197,
    "mam": 123,
    "son": 179
   },
   "summer_half": 320,
   "winter_half": 315
  },
  "TS17": {
   "cells": 30,
   "mm": 636,
   "n": 1031,
   "periods": {
    "1961-1990": 601,
    "1981-2010": 627,
    "1991-2020": 636
   },
   "seasons": {
    "djf": 140,
    "jja": 190,
    "mam": 127,
    "son": 179
   },
   "summer_half": 316,
   "winter_half": 319
  },
  "TS18": {
   "cells": 22,
   "mm": 631,
   "n": 889,
   "periods": {
    "1961-1990": 592,
    "1981-2010": 620,
    "1991-2020": 631
   },
   "seasons": {
    "djf": 143,
    "jja": 184,
    "mam": 124,
    "son": 180
   },
   "summer_half": 308,
   "winter_half": 323
  },
  "TS19": {
   "cells": 17,
   "mm": 636,
   "n": 1079,
   "periods": {
    "1961-1990": 596,
    "1981-2010": 622,
    "1991-2020": 636
   },
   "seasons": {
    "djf": 146,
    "jja": 184,
    "mam": 125,
    "son": 180
   },
   "summer_half": 310,
   "winter_half": 326
  },
  "TS2": {
   "cells": 13,
   "mm": 583,
   "n": 123,
   "periods": {
    "1961-1990": 554,
    "1981-2010": 577,
    "1991-2020": 583
   },
   "seasons": {
    "djf": 129,
    "jja": 175,
    "mam": 116,
    "son": 163
   },
   "summer_half": 291,
   "winter_half": 292
  },
  "TS20": {
   "cells": 12,
   "mm": 629,
   "n": 525,
   "periods": {
    "1961-1990": 588,
    "1981-2010": 613,
    "1991-2020": 629
   },
   "seasons": {
    "djf": 143,
    "jja": 186,
    "mam": 121,
    "son": 179
   },
   "summer_half": 307,
   "winter_half": 322
  },
  "TS21": {
   "cells": 109,
   "mm": 668,
   "n": 545,
   "periods": {
    "1961-1990": 633,
    "1981-2010": 647,
    "1991-2020": 668
   },
   "seasons": {
    "djf": 151,
    "jja": 197,
    "mam": 136,
    "son": 184
   },
   "summer_half": 333,
   "winter_half": 335
  },
  "TS22": {
   "cells": 36,
   "mm": 658,
   "n": 339,
   "periods": {
    "1961-1990": 621,
    "1981-2010": 640,
    "1991-2020": 658
   },
   "seasons": {
    "djf": 149,
    "jja": 198,
    "mam": 129,
    "son": 182
   },
   "summer_half": 327,
   "winter_half": 331
  },
  "TS23": {
   "cells": 22,
   "mm": 612,
   "n": 767,
   "periods": {
    "1961-1990": 575,
    "1981-2010": 599,
    "1991-2020": 612
   },
   "seasons": {
    "djf": 137,
    "jja": 188,
    "mam": 118,
    "son": 168
   },
   "summer_half": 306,
   "winter_half": 306
  },
  "TS24": {
   "cells": 15,
   "mm": 607,
   "n": 747,
   "periods": {
    "1961-1990": 606,
    "1981-2010": 609,
    "1991-2020": 607
   },
   "seasons": {
    "djf": 138,
    "jja": 174,
    "mam": 121,
    "son": 174
   },
   "summer_half": 295,
   "winter_half": 312
  },
  "TS25": {
   "cells": 25,
   "mm": 596,
   "n": 1062,
   "periods": {
    "1961-1990": 577,
    "1981-2010": 590,
    "1991-2020": 596
   },
   "seasons": {
    "djf": 136,
    "jja": 176,
    "mam": 114,
    "son": 170
   },
   "summer_half": 290,
   "winter_half": 306
  },
  "TS26": {
   "cells": 13,
   "mm": 627,
   "n": 660,
   "periods": {
    "1961-1990": 621,
    "1981-2010": 626,
    "1991-2020": 627
   },
   "seasons": {
    "djf": 143,
    "jja": 179,
    "mam": 124,
    "son": 181
   },
   "summer_half": 303,
   "winter_half": 324
  },
  "TS27": {
   "cells": 55,
   "mm": 682,
   "n": 388,
   "periods": {
    "1961-1990": 648,
    "1981-2010": 663,
    "1991-2020": 682
   },
   "seasons": {
    "djf": 155,
    "jja": 192,
    "mam": 137,
    "son": 198
   },
   "summer_half": 329,
   "winter_half": 353
  },
  "TS28": {
   "cells": 18,
   "mm": 764,
   "n": 165,
   "periods": {
    "1961-1990": 716,
    "1981-2010": 737,
    "1991-2020": 764
   },
   "seasons": {
    "djf": 176,
    "jja": 210,
    "mam": 155,
    "son": 223
   },
   "summer_half": 365,
   "winter_half": 399
  },
  "TS29": {
   "cells": 19,
   "mm": 779,
   "n": 195,
   "periods": {
    "1961-1990": 724,
    "1981-2010": 749,
    "1991-2020": 779
   },
   "seasons": {
    "djf": 181,
    "jja": 216,
    "mam": 157,
    "son": 225
   },
   "summer_half": 373,
   "winter_half": 406
  },
  "TS3": {
   "cells": 17,
   "mm": 619,
   "n": 880,
   "periods": {
    "1961-1990": 590,
    "1981-2010": 618,
    "1991-2020": 619
   },
   "seasons": {
    "djf": 138,
    "jja": 181,
    "mam": 123,
    "son": 177
   },
   "summer_half": 304,
   "winter_half": 315
  },
  "TS4": {
   "cells": 10,
   "mm": 618,
   "n": 513,
   "periods": {
    "1961-1990": 589,
    "1981-2010": 618,
    "1991-2020": 618
   },
   "seasons": {
    "djf": 136,
    "jja": 176,
    "mam": 132,
    "son": 173
   },
   "summer_half": 308,
   "winter_half": 310
  },
  "TS5": {
   "cells": 17,
   "mm": 622,
   "n": 1024,
   "periods": {
    "1961-1990": 592,
    "1981-2010": 620,
    "1991-2020": 622
   },
   "seasons": {
    "djf": 138,
    "jja": 179,
    "mam": 131,
    "son": 174
   },
   "summer_half": 310,
   "winter_half": 312
  },
  "TS6": {
   "cells": 29,
   "mm": 624,
   "n": 916,
   "periods": {
    "1961-1990": 595,
    "1981-2010": 616,
    "1991-2020": 624
   },
   "seasons": {
    "djf": 138,
    "jja": 187,
    "mam": 121,
    "son": 178
   },
   "summer_half": 308,
   "winter_half": 316
  },
  "TS7": {
   "cells": 26,
   "mm": 681,
   "n": 605,
   "periods": {
    "1961-1990": 648,
    "1981-2010": 677,
    "1991-2020": 681
   },
   "seasons": {
    "djf": 154,
    "jja": 198,
    "mam": 134,
    "son": 195
   },
   "summer_half": 332,
   "winter_half": 349
  },
  "TS8": {
   "cells": 26,
   "mm": 675,
   "n": 398,
   "periods": {
    "1961-1990": 642,
    "1981-2010": 670,
    "1991-2020": 675
   },
   "seasons": {
    "djf": 150,
    "jja": 198,
    "mam": 138,
    "son": 189
   },
   "summer_half": 336,
   "winter_half": 339
  },
  "TS9": {
   "cells": 109,
   "mm": 794,
   "n": 548,
   "periods": {
    "1961-1990": 742,
    "1981-2010": 778,
    "1991-2020": 794
   },
   "seasons": {
    "djf": 199,
    "jja": 211,
    "mam": 155,
    "son": 228
   },
   "summer_half": 367,
   "winter_half": 427
  },
  "TW1": {
   "cells": 11,
   "mm": 620,
   "n": 666,
   "periods": {
    "1961-1990": 598,
    "1981-2010": 609,
    "1991-2020": 620
   },
   "seasons": {
    "djf": 162,
    "jja": 148,
    "mam": 125,
    "son": 185
   },
   "summer_half": 274,
   "winter_half": 347
  },
  "TW10": {
   "cells": 18,
   "mm": 638,
   "n": 512,
   "periods": {
    "1961-1990": 611,
    "1981-2010": 627,
    "1991-2020": 638
   },
   "seasons": {
    "djf": 169,
    "jja": 151,
    "mam": 126,
    "son": 192
   },
   "summer_half": 277,
   "winter_half": 361
  },
  "TW11": {
   "cells": 10,
   "mm": 623,
   "n": 558,
   "periods": {
    "1961-1990": 600,
    "1981-2010": 612,
    "1991-2020": 623
   },
   "seasons": {
    "djf": 163,
    "jja": 150,
    "mam": 125,
    "son": 186
   },
   "summer_half": 274,
   "winter_half": 349
  },
  "TW12": {
   "cells": 9,
   "mm": 630,
   "n": 563,
   "periods": {
    "1961-1990": 611,
    "1981-2010": 614,
    "1991-2020": 630
   },
   "seasons": {
    "djf": 165,
    "jja": 150,
    "mam": 126,
    "son": 188
   },
   "summer_half": 276,
   "winter_half": 354
  },
  "TW13": {
   "cells": 15,
   "mm": 633,
   "n": 694,
   "periods": {
    "1961-1990": 609,
    "1981-2010": 618,
    "1991-2020": 633
   },
   "seasons": {
    "djf": 168,
    "jja": 149,
    "mam": 127,
    "son": 190
   },
   "summer_half": 276,
   "winter_half": 358
  },
  "TW14": {
   "cells": 14,
   "mm": 633,
   "n": 478,
   "periods": {
    "1961-1990": 608,
    "1981-2010": 618,
    "1991-2020": 633
   },
   "seasons": {
    "djf": 165,
    "jja": 150,
    "mam": 127,
    "son": 190
   },
   "summer_half": 277,
   "winter_half": 355
  },
  "TW15": {
   "cells": 14,
   "mm": 636,
   "n": 658,
   "periods": {
    "1961-1990": 605,
    "1981-2010": 618,
    "1991-2020": 636
   },
   "seasons": {
    "djf": 169,
    "jja": 151,
    "mam": 128,
    "son": 187
   },
   "summer_half": 279,
   "winter_half": 357
  },
  "TW16": {
   "cells": 13,
   "mm": 634,
   "n": 538,
   "periods": {
    "1961-1990": 597,
    "1981-2010": 620,
    "1991-2020": 634
   },
   "seasons": {
    "djf": 169,
    "jja": 148,
    "mam": 127,
    "son": 190
   },
   "summer_half": 275,
   "winter_half": 360
  },
  "TW17": {
   "cells": 18,
   "mm": 633,
   "n": 415,
   "periods": {
    "1961-1990": 602,
    "1981-2010": 620,
    "1991-2020": 633
   },
   "seasons": {
    "djf": 168,
    "jja": 150,
    "mam": 124,
    "son": 191
   },
   "summer_half": 274,
   "winter_half": 359
  },
  "TW18": {
   "cells": 20,
   "mm": 644,
   "n": 749,
   "periods": {
    "1961-1990": 613,
    "1981-2010": 628,
    "1991-2020": 644
   },
   "seasons": {
    "djf": 172,
    "jja": 152,
    "mam": 130,
    "son": 190
   },
   "summer_half": 282,
   "winter_half": 362
  },
  "TW19": {
   "cells": 24,
   "mm": 637,
   "n": 386,
   "periods": {
    "1961-1990": 617,
    "1981-2010": 624,
    "1991-2020": 637
   },
   "seasons": {
    "djf": 169,
    "jja": 149,
    "mam": 130,
    "son": 189
   },
   "summer_half": 279,
   "winter_half": 359
  },
  "TW2": {
   "cells": 12,
   "mm": 635,
   "n": 550,
   "periods": {
    "1961-1990": 612,
    "1981-2010": 621,
    "1991-2020": 635
   },
   "seasons": {
    "djf": 167,
    "jja": 151,
    "mam": 127,
    "son": 190
   },
   "summer_half": 278,
   "winter_half": 357
  },
  "TW20": {
   "cells": 27,
   "mm": 668,
   "n": 656,
   "periods": {
    "1961-1990": 644,
    "1981-2010": 655,
    "1991-2020": 668
   },
   "seasons": {
    "djf": 180,
    "jja": 154,
    "mam": 135,
    "son": 199
   },
   "summer_half": 289,
   "winter_half": 379
  },
  "TW3": {
   "cells": 8,
   "mm": 640,
   "n": 785,
   "periods": {
    "1961-1990": 615,
    "1981-2010": 626,
    "1991-2020": 640
   },
   "seasons": {
    "djf": 169,
    "jja": 153,
    "mam": 127,
    "son": 191
   },
   "summer_half": 281,
   "winter_half": 359
  },
  "TW4": {
   "cells": 12,
   "mm": 640,
   "n": 428,
   "periods": {
    "1961-1990": 615,
    "1981-2010": 625,
    "1991-2020": 640
   },
   "seasons": {
    "djf": 168,
    "jja": 153,
    "mam": 127,
    "son": 192
   },
   "summer_half": 280,
   "winter_half": 360
  },
  "TW5": {
   "cells": 15,
   "mm": 640,
   "n": 400,
   "periods": {
    "1961-1990": 616,
    "1981-2010": 627,
    "1991-2020": 640
   },
   "seasons": {
    "djf": 168,
    "jja": 153,
    "mam": 130,
    "son": 189
   },
   "summer_half": 283,
   "winter_half": 357
  },
  "TW6": {
   "cells": 16,
   "mm": 630,
   "n": 124,
   "periods": {
    "1961-1990": 610,
    "1981-2010": 617,
    "1991-2020": 630
   },
   "seasons": {
    "djf": 165,
    "jja": 150,
    "mam": 128,
    "son": 188
   },
   "summer_half": 278,
   "winter_half": 353
  },
  "TW7": {
   "cells": 16,
   "mm": 626,
   "n": 761,
   "periods": {
    "1961-1990": 603,
    "1981-2010": 615,
    "1991-2020": 626
   },
   "seasons": {
    "djf": 164,
    "jja": 149,
    "mam": 126,
    "son": 187
   },
   "summer_half": 275,
   "winter_half": 352
  },
  "TW8": {
   "cells": 9,
   "mm": 625,
   "n": 537,
   "periods": {
    "1961-1990": 601,
    "1981-2010": 617,
    "1991-2020": 625
   },
   "seasons": {
    "djf": 163,
    "jja": 148,
    "mam": 127,
    "son": 187
   },
   "summer_half": 275,
   "winter_half": 350
  },
  "TW9": {
   "cells": 10,
   "mm": 625,
   "n": 600,
   "periods": {
    "1961-1990": 600,
    "1981-2010": 616,
    "1991-2020": 625
   },
   "seasons": {
    "djf": 165,
    "jja": 147,
    "mam": 124,
    "son": 188
   },
   "summer_half": 272,
   "winter_half": 353
  },
  "UB1": {
   "cells": 13,
   "mm": 649,
   "n": 614,
   "periods": {
    "1961-1990": 618,
    "1981-2010": 633,
    "1991-2020": 649
   },
   "seasons": {
    "djf": 171,
    "jja": 153,
    "mam": 134,
    "son": 192
   },
   "summer_half": 287,
   "winter_half": 363
  },
  "UB10": {
   "cells": 18,
   "mm": 665,
   "n": 711,
   "periods": {
    "1961-1990": 634,
    "1981-2010": 645,
    "1991-2020": 665
   },
   "seasons": {
    "djf": 177,
    "jja": 151,
    "mam": 139,
    "son": 197
   },
   "summer_half": 291,
   "winter_half": 374
  },
  "UB11": {
   "cells": 4,
   "mm": 645,
   "n": 19,
   "periods": {
    "1961-1990": 623,
    "1981-2010": 630,
    "1991-2020": 645
   },
   "seasons": {
    "djf": 169,
    "jja": 147,
    "mam": 135,
    "son": 194
   },
   "summer_half": 282,
   "winter_half": 363
  },
  "UB18": {
   "cells": 1,
   "mm": 643,
   "n": 59,
   "periods": {
    "1961-1990": 618,
    "1981-2010": 628,
    "1991-2020": 643
   },
   "seasons": {
    "djf": 167,
    "jja": 149,
    "mam": 135,
    "son": 193
   },
   "summer_half": 283,
   "winter_half": 360
  },
  "UB2": {
   "cells": 11,
   "mm": 642,
   "n": 532,
   "periods": {
    "1961-1990": 616,
    "1981-2010": 628,
    "1991-2020": 642
   },
   "seasons": {
    "djf": 168,
    "jja": 151,
    "mam": 131,
    "son": 192
   },
   "summer_half": 282,
   "winter_half": 360
  },
  "UB3": {
   "cells": 19,
   "mm": 638,
   "n": 984,
   "periods": {
    "1961-1990": 613,
    "1981-2010": 623,
    "1991-2020": 638
   },
   "seasons": {
    "djf": 166,
    "jja": 148,
    "mam": 133,
    "son": 191
   },
   "summer_half": 281,
   "winter_half": 357
  },
  "UB4": {
   "cells": 15,
   "mm": 660,
   "n": 704,
   "periods": {
    "1961-1990": 623,
    "1981-2010": 639,
    "1991-2020": 660
   },
   "seasons": {
    "djf": 174,
    "jja": 152,
    "mam": 138,
    "son": 197
   },
   "summer_half": 290,
   "winter_half": 370
  },
  "UB5": {
   "cells": 15,
   "mm": 667,
   "n": 841,
   "periods": {
    "1961-1990": 629,
    "1981-2010": 646,
    "1991-2020": 667
   },
   "seasons": {
    "djf": 176,
    "jja": 157,
    "mam": 139,
    "son": 195
   },
   "summer_half": 296,
   "winter_half": 371
  },
  "UB6": {
   "cells": 20,
   "mm": 657,
   "n": 862,
   "periods": {
    "1961-1990": 631,
    "1981-2010": 643,
    "1991-2020": 657
   },
   "seasons": {
    "djf": 173,
    "jja": 156,
    "mam": 135,
    "son": 193
   },
   "summer_half": 291,
   "winter_half": 366
  },
  "UB7": {
   "cells": 18,
   "mm": 625,
   "n": 632,
   "periods": {
    "1961-1990": 607,
    "1981-2010": 611,
    "1991-2020": 625
   },
   "seasons": {
    "djf": 164,
    "jja": 146,
    "mam": 129,
    "son": 187
   },
   "summer_half": 274,
   "winter_half": 351
  },
  "UB8": {
   "cells": 22,
   "mm": 647,
   "n": 824,
   "periods": {
    "1961-1990": 628,
    "1981-2010": 632,
    "1991-2020": 647
   },
   "seasons": {
    "djf": 172,
    "jja": 146,
    "mam": 135,
    "son": 193
   },
   "summer_half": 281,
   "winter_half": 366
  },
  "UB9": {
   "cells": 35,
   "mm": 665,
   "n": 433,
   "periods": {
    "1961-1990": 658,
    "1981-2010": 657,
    "1991-2020": 665
   },
   "seasons": {
    "djf": 177,
    "jja": 151,
    "mam": 137,
    "son": 201
   },
   "summer_half": 287,
   "winter_half": 378
  },
  "W10": {
   "cells": 9,
   "mm": 643,
   "n": 694,
   "periods": {
    "1961-1990": 622,
    "1981-2010": 633,
    "1991-2020": 643
   },
   "seasons": {
    "djf": 168,
    "jja": 152,
    "mam": 132,
    "son": 190
   },
   "summer_half": 284,
   "winter_half": 359
  },
  "W11": {
   "cells": 9,
   "mm": 630,
   "n": 736,
   "periods": {
    "1961-1990": 612,
    "1981-2010": 620,
    "1991-2020": 630
   },
   "seasons": {
    "djf": 164,
    "jja": 149,
    "mam": 129,
    "son": 188
   },
   "summer_half": 279,
   "winter_half": 351
  },
  "W12": {
   "cells": 10,
   "mm": 623,
   "n": 824,
   "periods": {
    "1961-1990": 604,
    "1981-2010": 613,
    "1991-2020": 623
   },
   "seasons": {
    "djf": 162,
    "jja": 148,
    "mam": 129,
    "son": 185
   },
   "summer_half": 276,
   "winter_half": 347
  },
  "W13": {
   "cells": 10,
   "mm": 642,
   "n": 596,
   "periods": {
    "1961-1990": 619,
    "1981-2010": 629,
    "1991-2020": 642
   },
   "seasons": {
    "djf": 169,
    "jja": 151,
    "mam": 131,
    "son": 192
   },
   "summer_half": 282,
   "winter_half": 360
  },
  "W14": {
   "cells": 8,
   "mm": 622,
   "n": 641,
   "periods": {
    "1961-1990": 606,
    "1981-2010": 612,
    "1991-2020": 622
   },
   "seasons": {
    "djf": 162,
    "jja": 148,
    "mam": 127,
    "son": 185
   },
   "summer_half": 275,
   "winter_half": 347
  },
  "W1A": {
   "cells": 3,
   "mm": 636,
   "n": 144,
   "periods": {
    "1961-1990": 623,
    "1981-2010": 622,
    "1991-2020": 636
   },
   "seasons": {
    "djf": 167,
    "jja": 155,
    "mam": 127,
    "son": 187
   },
   "summer_half": 281,
   "winter_half": 354
  },
  "W1B": {
   "cells": 4,
   "mm": 641,
   "n": 298,
   "periods": {
    "1961-1990": 630,
    "1981-2010": 626,
    "1991-2020": 641
   },
   "seasons": {
    "djf": 170,
    "jja": 152,
    "mam": 128,
    "son": 191
   },
   "summer_half": 280,
   "winter_half": 361
  },
  "W1C": {
   "cells": 4,
   "mm": 642,
   "n": 139,
   "periods": {
    "1961-1990": 628,
    "1981-2010": 628,
    "1991-2020": 642
   },
   "seasons": {
    "djf": 169,
    "jja": 154,
    "mam": 128,
    "son": 191
   },
   "summer_half": 282,
   "winter_half": 360
  },
  "W1D": {
   "cells": 2,
   "mm": 635,
   "n": 695,
   "periods": {
    "1961-1990": 627,
    "1981-2010": 620,
    "1991-2020": 635
   },
   "seasons": {
    "djf": 167,
    "jja": 153,
    "mam": 127,
    "son": 188
   },
   "summer_half": 280,
   "winter_half": 355
  },
  "W1F": {
   "cells": 2,
   "mm": 635,
   "n": 756,
   "periods": {
    "1961-1990": 627,
    "1981-2010": 620,
    "1991-2020": 635
   },
   "seasons": {
    "djf": 167,
    "jja": 153,
    "mam": 127,
    "son": 188
   },
   "summer_half": 280,
   "winter_half": 355
  },
  "W1G": {
   "cells": 3,
   "mm": 639,
   "n": 704,
   "periods": {
    "1961-1990": 625,
    "1981-2010": 625,
    "1991-2020": 639
   },
   "seasons": {
    "djf": 170,
    "jja": 153,
    "mam": 127,
    "son": 189
   },
   "summer_half": 281,
   "winter_half": 359
  },
  "W1H": {
   "cells": 2,
   "mm": 645,
   "n": 691,
   "periods": {
    "1961-1990": 631,
    "1981-2010": 631,
    "1991-2020": 645
   },
   "seasons": {
    "djf": 171,
    "jja": 153,
    "mam": 129,
    "son": 192
   },
   "summer_half": 282,
   "winter_half": 363
  },
  "W1J": {
   "cells": 4,
   "mm": 637,
   "n": 667,
   "periods": {
    "1961-1990": 621,
    "1981-2010": 624,
    "1991-2020": 637
   },
   "seasons": {
    "djf": 166,
    "jja": 155,
    "mam": 128,
    "son": 189
   },
   "summer_half": 283,
   "winter_half": 354
  },
  "W1K": {
   "cells": 4,
   "mm": 644,
   "n": 878,
   "periods": {
    "1961-1990": 626,
    "1981-2010": 631,
    "1991-2020": 644
   },
   "seasons": {
    "djf": 167,
    "jja": 155,
    "mam": 129,
    "son": 193
   },
   "summer_half": 284,
   "winter_half": 360
  },
  "W1S": {
   "cells": 4,
   "mm": 640,
   "n": 558,
   "periods": {
    "1961-1990": 628,
    "1981-2010": 625,
    "1991-2020": 640
   },
   "seasons": {
    "djf": 168,
    "jja": 153,
    "mam": 128,
    "son": 190
   },
   "summer_half": 282,
   "winter_half": 359
  },
  "W1T": {
   "cells": 3,
   "mm": 641,
   "n": 923,
   "periods": {
    "1961-1990": 630,
    "1981-2010": 627,
    "1991-2020": 641
   },
   "seasons": {
    "djf": 171,
    "jja": 153,
    "mam": 128,
    "son": 190
   },
   "summer_half": 280,
   "winter_half": 361
  },
  "W1U": {
   "cells": 4,
   "mm": 647,
   "n": 1070,
   "periods": {
    "1961-1990": 632,
    "1981-2010": 633,
    "1991-2020": 647
   },
   "seasons": {
    "djf": 171,
    "jja": 153,
    "mam": 129,
    "son": 193
   },
   "summer_half": 282,
   "winter_half": 364
  },
  "W1W": {
   "cells": 5,
   "mm": 639,
   "n": 623,
   "periods": {
    "1961-1990": 626,
    "1981-2010": 624,
    "1991-2020": 639
   },
   "seasons": {
    "djf": 169,
    "jja": 154,
    "mam": 127,
    "son": 189
   },
   "summer_half": 281,
   "winter_half": 358
  },
  "W2": {
   "cells": 9,
   "mm": 642,
   "n": 1130,
   "periods": {
    "1961-1990": 624,
    "1981-2010": 629,
    "1991-2020": 642
   },
   "seasons": {
    "djf": 167,
    "jja": 153,
    "mam": 130,
    "son": 192
   },
   "summer_half": 283,
   "winter_half": 359
  },
  "W3": {
   "cells": 14,
   "mm": 624,
   "n": 1158,
   "periods": {
    "1961-1990": 602,
    "1981-2010": 613,
    "1991-2020": 624
   },
   "seasons": {
    "djf": 162,
    "jja": 149,
    "mam": 127,
    "son": 186
   },
   "summer_half": 277,
   "winter_half": 348
  },
  "W4": {
   "cells": 12,
   "mm": 625,
   "n": 1044,
   "periods": {
    "1961-1990": 604,
    "1981-2010": 616,
    "1991-2020": 625
   },
   "seasons": {
    "djf": 163,
    "jja": 149,
    "mam": 127,
    "son": 187
   },
   "summer_half": 276,
   "winter_half": 350
  },
  "W5": {
   "cells": 19,
   "mm": 632,
   "n": 1013,
   "periods": {
    "1961-1990": 611,
    "1981-2010": 620,
    "1991-2020": 632
   },
   "seasons": {
    "djf": 165,
    "jja": 150,
    "mam": 129,
    "son": 188
   },
   "summer_half": 279,
   "winter_half": 353
  },
  "W6": {
   "cells": 9,
   "mm": 623,
   "n": 777,
   "periods": {
    "1961-1990": 607,
    "1981-2010": 614,
    "1991-2020": 623
   },
   "seasons": {
    "djf": 162,
    "jja": 148,
    "mam": 128,
    "son": 185
   },
   "summer_half": 276,
   "winter_half": 347
  },
  "W7": {
   "cells": 10,
   "mm": 638,
   "n": 510,
   "periods": {
    "1961-1990": 611,
    "1981-2010": 625,
    "1991-2020": 638
   },
   "seasons": {
    "djf": 168,
    "jja": 150,
    "mam": 129,
    "son": 191
   },
   "summer_half": 280,
   "winter_half": 358
  },
  "W8": {
   "cells": 7,
   "mm": 626,
   "n": 689,
   "periods": {
    "1961-1990": 611,
    "1981-2010": 615,
    "1991-2020": 626
   },
   "seasons": {
    "djf": 162,
    "jja": 149,
    "mam": 127,
    "son": 188
   },
   "summer_half": 277,
   "winter_half": 349
  },
  "W9": {
   "cells": 9,
   "mm": 646,
   "n": 579,
   "periods": {
    "1961-1990": 626,
    "1981-2010": 635,
    "1991-2020": 646
   },
   "seasons": {
    "djf": 169,
    "jja": 154,
    "mam": 131,
    "son": 193
   },
   "summer_half": 284,
   "winter_half": 362
  },
  "WA1": {
   "cells": 19,
   "mm": 809,
   "n": 775,
   "periods": {
    "1961-1990": 795,
    "1981-2010": 804,
    "1991-2020": 809
   },
   "seasons": {
    "djf": 198,
    "jja": 217,
    "mam": 165,
    "son": 229
   },
   "summer_half": 382,
   "winter_half": 427
  },
  "WA10": {
   "cells": 25,
   "mm": 914,
   "n": 1274,
   "periods": {
    "1961-1990": 873,
    "1981-2010": 898,
    "1991-2020": 914
   },
   "seasons": {
    "djf": 239,
    "jja": 232,
    "mam": 169,
    "son": 274
   },
   "summer_half": 400,
   "winter_half": 513
  },
  "WA11": {
   "cells": 54,
   "mm": 938,
   "n": 1029,
   "periods": {
    "1961-1990": 912,
    "1981-2010": 929,
    "1991-2020": 938
   },
   "seasons": {
    "djf": 246,
    "jja": 236,
    "mam": 176,
    "son": 281
   },
   "summer_half": 412,
   "winter_half": 526
  },
  "WA12": {
   "cells": 18,
   "mm": 905,
   "n": 647,
   "periods": {
    "1961-1990": 884,
    "1981-2010": 894,
    "1991-2020": 905
   },
   "seasons": {
    "djf": 237,
    "jja": 232,
    "mam": 172,
    "son": 264
   },
   "summer_half": 404,
   "winter_half": 502
  },
  "WA13": {
   "cells": 33,
   "mm": 839,
   "n": 492,
   "periods": {
    "1961-1990": 805,
    "1981-2010": 812,
    "1991-2020": 839
   },
   "seasons": {
    "djf": 216,
    "jja": 216,
    "mam": 167,
    "son": 240
   },
   "summer_half": 383,
   "winter_half": 456
  },
  "WA14": {
   "cells": 45,
   "mm": 854,
   "n": 1130,
   "periods": {
    "1961-1990": 816,
    "1981-2010": 821,
    "1991-2020": 854
   },
   "seasons": {
    "djf": 222,
    "jja": 218,
    "mam": 169,
    "son": 244
   },
   "summer_half": 388,
   "winter_half": 467
  },
  "WA15": {
   "cells": 31,
   "mm": 851,
   "n": 1184,
   "periods": {
    "1961-1990": 815,
    "1981-2010": 824,
    "1991-2020": 851
   },
   "seasons": {
    "djf": 221,
    "jja": 220,
    "mam": 165,
    "son": 245
   },
   "summer_half": 386,
   "winter_half": 466
  },
  "WA16": {
   "cells": 142,
   "mm": 835,
   "n": 1199,
   "periods": {
    "1961-1990": 798,
    "1981-2010": 809,
    "1991-2020": 835
   },
   "seasons": {
    "djf": 214,
    "jja": 217,
    "mam": 167,
    "son": 236
   },
   "summer_half": 385,
   "winter_half": 450
  },
  "WA2": {
   "cells": 28,
   "mm": 846,
   "n": 923,
   "periods": {
    "1961-1990": 832,
    "1981-2010": 840,
    "1991-2020": 846
   },
   "seasons": {
    "djf": 209,
    "jja": 225,
    "mam": 166,
    "son": 246
   },
   "summer_half": 391,
   "winter_half": 455
  },
  "WA3": {
   "cells": 83,
   "mm": 862,
   "n": 1518,
   "periods": {
    "1961-1990": 841,
    "1981-2010": 847,
    "1991-2020": 862
   },
   "seasons": {
    "djf": 223,
    "jja": 223,
    "mam": 168,
    "son": 248
   },
   "summer_half": 392,
   "winter_half": 471
  },
  "WA4": {
   "cells": 85,
   "mm": 826,
   "n": 1437,
   "periods": {
    "1961-1990": 798,
    "1981-2010": 817,
    "1991-2020": 826
   },
   "seasons": {
    "djf": 201,
    "jja": 221,
    "mam": 169,
    "son": 235
   },
   "summer_half": 389,
   "winter_half": 437
  },
  "WA5": {
   "cells": 43,
   "mm": 840,
   "n": 1320,
   "periods": {
    "1961-1990": 831,
    "1981-2010": 837,
    "1991-2020": 840
   },
   "seasons": {
    "djf": 214,
    "jja": 214,
    "mam": 162,
    "son": 249
   },
   "summer_half": 376,
   "winter_half": 463
  },
  "WA55": {
   "cells": 2,
   "mm": 818,
   "n": 8,
   "periods": {
    "1961-1990": 817,
    "1981-2010": 822,
    "1991-2020": 818
   },
   "seasons": {
    "djf": 207,
    "jja": 202,
    "mam": 158,
    "son": 251
   },
   "summer_half": 360,
   "winter_half": 458
  },
  "WA6": {
   "cells": 74,
   "mm": 797,
   "n": 974,
   "periods": {
    "1961-1990": 772,
    "1981-2010": 787,
    "1991-2020": 797
   },
   "seasons": {
    "djf": 194,
    "jja": 207,
    "mam": 162,
    "son": 234
   },
   "summer_half": 369,
   "winter_half": 428
  },
  "WA7": {
   "cells": 42,
   "mm": 831,
   "n": 1518,
   "periods": {
    "1961-1990": 787,
    "1981-2010": 817,
    "1991-2020": 831
   },
   "seasons": {
    "djf": 203,
    "jja": 221,
    "mam": 165,
    "son": 242
   },
   "summer_half": 386,
   "winter_half": 445
  },
  "WA8": {
   "cells": 47,
   "mm": 857,
   "n": 1587,
   "periods": {
    "1961-1990": 815,
    "1981-2010": 837,
    "1991-2020": 857
   },
   "seasons": {
    "djf": 216,
    "jja": 225,
    "mam": 166,
    "son": 250
   },
   "summer_half": 391,
   "winter_half": 466
  },
  "WA88": {
   "cells": 1,
   "mm": 844,
   "n": 13,
   "periods": {
    "1961-1990": 794,
    "1981-2010": 819,
    "1991-2020": 844
   },
   "seasons": {
    "djf": 211,
    "jja": 224,
    "mam": 162,
    "son": 246
   },
   "summer_half": 387,
   "winter_half": 457
  },
  "WA9": {
   "cells": 34,
   "mm": 913,
   "n": 1306,
   "periods": {
    "1961-1990": 881,
    "1981-2010": 896,
    "1991-2020": 913
   },
   "seasons": {
    "djf": 239,
    "jja": 231,
    "mam": 173,
    "son": 269
   },
   "summer_half": 405,
   "winter_half": 508
  },
  "WC1A": {
   "cells": 3,
   "mm": 634,
   "n": 150,
   "periods": {
    "1961-1990": 622,
    "1981-2010": 620,
    "1991-2020": 634
   },
   "seasons": {
    "djf": 166,
    "jja": 157,
    "mam": 126,
    "son": 185
   },
   "summer_half": 283,
   "winter_half": 351
  },
  "WC1B": {
   "cells": 5,
   "mm": 635,
   "n": 157,
   "periods": {
    "1961-1990": 622,
    "1981-2010": 620,
    "1991-2020": 635
   },
   "seasons": {
    "djf": 166,
    "jja": 157,
    "mam": 126,
    "son": 185
   },
   "summer_half": 283,
   "winter_half": 352
  },
  "WC1E": {
   "cells": 2,
   "mm": 637,
   "n": 108,
   "periods": {
    "1961-1990": 626,
    "1981-2010": 623,
    "1991-2020": 637
   },
   "seasons": {
    "djf": 168,
    "jja": 154,
    "mam": 127,
    "son": 189
   },
   "summer_half": 280,
   "winter_half": 357
  },
  "WC1H": {
   "cells": 3,
   "mm": 633,
   "n": 306,
   "periods": {
    "1961-1990": 618,
    "1981-2010": 619,
    "1991-2020": 633
   },
   "seasons": {
    "djf": 166,
    "jja": 158,
    "mam": 125,
    "son": 184
   },
   "summer_half": 283,
   "winter_half": 349
  },
  "WC1N": {
   "cells": 3,
   "mm": 633,
   "n": 272,
   "periods": {
    "1961-1990": 619,
    "1981-2010": 619,
    "1991-2020": 633
   },
   "seasons": {
    "djf": 165,
    "jja": 160,
    "mam": 125,
    "son": 183
   },
   "summer_half": 285,
   "winter_half": 348
  },
  "WC1R": {
   "cells": 2,
   "mm": 629,
   "n": 80,
   "periods": {
    "1961-1990": 619,
    "1981-2010": 615,
    "1991-2020": 629
   },
   "seasons": {
    "djf": 164,
    "jja": 158,
    "mam": 125,
    "son": 183
   },
   "summer_half": 282,
   "winter_half": 347
  },
  "WC1V": {
   "cells": 3,
   "mm": 628,
   "n": 96,
   "periods": {
    "1961-1990": 616,
    "1981-2010": 614,
    "1991-2020": 628
   },
   "seasons": {
    "djf": 164,
    "jja": 158,
    "mam": 124,
    "son": 182
   },
   "summer_half": 282,
   "winter_half": 346
  },
  "WC1X": {
   "cells": 6,
   "mm": 633,
   "n": 327,
   "periods": {
    "1961-1990": 618,
    "1981-2010": 619,
    "1991-2020": 633
   },
   "seasons": {
    "djf": 165,
    "jja": 160,
    "mam": 125,
    "son": 184
   },
   "summer_half": 284,
   "winter_half": 348
  },
  "WC2A": {
   "cells": 3,
   "mm": 628,
   "n": 113,
   "periods": {
    "1961-1990": 616,
    "1981-2010": 614,
    "1991-2020": 628
   },
   "seasons": {
    "djf": 164,
    "jja": 158,
    "mam": 124,
    "son": 182
   },
   "summer_half": 282,
   "winter_half": 346
  },
  "WC2B": {
   "cells": 4,
   "mm": 622,
   "n": 175,
   "periods": {
    "1961-1990": 608,
    "1981-2010": 608,
    "1991-2020": 622
   },
   "seasons": {
    "djf": 161,
    "jja": 154,
    "mam": 124,
    "son": 183
   },
   "summer_half": 278,
   "winter_half": 344
  },
  "WC2E": {
   "cells": 2,
   "mm": 622,
   "n": 167,
   "periods": {
    "1961-1990": 614,
    "1981-2010": 607,
    "1991-2020": 622
   },
   "seasons": {
    "djf": 162,
    "jja": 152,
    "mam": 124,
    "son": 183
   },
   "summer_half": 277,
   "winter_half": 345
  },
  "WC2H": {
   "cells": 5,
   "mm": 628,
   "n": 347,
   "periods": {
    "1961-1990": 618,
    "1981-2010": 613,
    "1991-2020": 628
   },
   "seasons": {
    "djf": 164,
    "jja": 153,
    "mam": 125,
    "son": 185
   },
   "summer_half": 279,
   "winter_half": 349
  },
  "WC2N": {
   "cells": 3,
   "mm": 621,
   "n": 143,
   "periods": {
    "1961-1990": 611,
    "1981-2010": 607,
    "1991-2020": 621
   },
   "seasons": {
    "djf": 163,
    "jja": 152,
    "mam": 125,
    "son": 182
   },
   "summer_half": 276,
   "winter_half": 345
  },
  "WC2R": {
   "cells": 5,
   "mm": 619,
   "n": 103,
   "periods": {
    "1961-1990": 608,
    "1981-2010": 605,
    "1991-2020": 619
   },
   "seasons": {
    "djf": 161,
    "jja": 154,
    "mam": 123,
    "son": 181
   },
   "summer_half": 277,
   "winter_half": 342
  },
  "WD17": {
   "cells": 14,
   "mm": 695,
   "n": 571,
   "periods": {
    "1961-1990": 682,
    "1981-2010": 692,
    "1991-2020": 695
   },
   "seasons": {
    "djf": 190,
    "jja": 159,
    "mam": 141,
    "son": 206
   },
   "summer_half": 300,
   "winter_half": 396
  },
  "WD18": {
   "cells": 11,
   "mm": 675,
   "n": 719,
   "periods": {
    "1961-1990": 666,
    "1981-2010": 672,
    "1991-2020": 675
   },
   "seasons": {
    "djf": 184,
    "jja": 152,
    "mam": 139,
    "son": 200
   },
   "summer_half": 291,
   "winter_half": 384
  },
  "WD19": {
   "cells": 15,
   "mm": 688,
   "n": 692,
   "periods": {
    "1961-1990": 677,
    "1981-2010": 683,
    "1991-2020": 688
   },
   "seasons": {
    "djf": 188,
    "jja": 157,
    "mam": 140,
    "son": 203
   },
   "summer_half": 297,
   "winter_half": 391
  },
  "WD23": {
   "cells": 18,
   "mm": 690,
   "n": 774,
   "periods": {
    "1961-1990": 676,
    "1981-2010": 684,
    "1991-2020": 690
   },
   "seasons": {
    "djf": 188,
    "jja": 158,
    "mam": 140,
    "son": 204
   },
   "summer_half": 298,
   "winter_half": 392
  },
  "WD24": {
   "cells": 11,
   "mm": 678,
   "n": 533,
   "periods": {
    "1961-1990": 664,
    "1981-2010": 676,
    "1991-2020": 678
   },
   "seasons": {
    "djf": 182,
    "jja": 157,
    "mam": 138,
    "son": 202
   },
   "summer_half": 294,
   "winter_half": 384
  },
  "WD25": {
   "cells": 27,
   "mm": 682,
   "n": 687,
   "periods": {
    "1961-1990": 671,
    "1981-2010": 682,
    "1991-2020": 682
   },
   "seasons": {
    "djf": 183,
    "jja": 159,
    "mam": 139,
    "son": 201
   },
   "summer_half": 299,
   "winter_half": 384
  },
  "WD3": {
   "cells": 63,
   "mm": 706,
   "n": 1279,
   "periods": {
    "1961-1990": 693,
    "1981-2010": 700,
    "1991-2020": 706
   },
   "seasons": {
    "djf": 195,
    "jja": 160,
    "mam": 144,
    "son": 208
   },
   "summer_half": 303,
   "winter_half": 403
  },
  "WD4": {
   "cells": 30,
   "mm": 745,
   "n": 372,
   "periods": {
    "1961-1990": 727,
    "1981-2010": 740,
    "1991-2020": 745
   },
   "seasons": {
    "djf": 211,
    "jja": 166,
    "mam": 151,
    "son": 216
   },
   "summer_half": 317,
   "winter_half": 428
  },
  "WD5": {
   "cells": 15,
   "mm": 730,
   "n": 261,
   "periods": {
    "1961-1990": 713,
    "1981-2010": 728,
    "1991-2020": 730
   },
   "seasons": {
    "djf": 201,
    "jja": 168,
    "mam": 149,
    "son": 213
   },
   "summer_half": 316,
   "winter_half": 414
  },
  "WD6": {
   "cells": 29,
   "mm": 702,
   "n": 1076,
   "periods": {
    "1961-1990": 704,
    "1981-2010": 699,
    "1991-2020": 702
   },
   "seasons": {
    "djf": 190,
    "jja": 165,
    "mam": 141,
    "son": 205
   },
   "summer_half": 306,
   "winter_half": 396
  },
  "WD7": {
   "cells": 23,
   "mm": 688,
   "n": 430,
   "periods": {
    "1961-1990": 685,
    "1981-2010": 690,
    "1991-2020": 688
   },
   "seasons": {
    "djf": 184,
    "jja": 164,
    "mam": 139,
    "son": 202
   },
   "summer_half": 303,
   "winter_half": 385
  },
  "WD99": {
   "cells": 1,
   "mm": 685,
   "n": 21,
   "periods": {
    "1961-1990": 675,
    "1981-2010": 683,
    "1991-2020": 685
   },
   "seasons": {
    "djf": 188,
    "jja": 154,
    "mam": 140,
    "son": 203
   },
   "summer_half": 295,
   "winter_half": 391
  },
  "WF1": {
   "cells": 30,
   "mm": 646,
   "n": 1256,
   "periods": {
    "1961-1990": 636,
    "1981-2010": 642,
    "1991-2020": 646
   },
   "seasons": {
    "djf": 152,
    "jja": 183,
    "mam": 135,
    "son": 177
   },
   "summer_half": 318,
   "winter_half": 328
  },
  "WF10": {
   "cells": 37,
   "mm": 634,
   "n": 1257,
   "periods": {
    "1961-1990": 618,
    "1981-2010": 624,
    "1991-2020": 634
   },
   "seasons": {
    "djf": 146,
    "jja": 180,
    "mam": 132,
    "son": 176
   },
   "summer_half": 312,
   "winter_half": 322
  },
  "WF11": {
   "cells": 41,
   "mm": 611,
   "n": 544,
   "periods": {
    "1961-1990": 603,
    "1981-2010": 602,
    "1991-2020": 611
   },
   "seasons": {
    "djf": 137,
    "jja": 176,
    "mam": 127,
    "son": 171
   },
   "summer_half": 303,
   "winter_half": 308
  },
  "WF12": {
   "cells": 33,
   "mm": 741,
   "n": 820,
   "periods": {
    "1961-1990": 729,
    "1981-2010": 733,
    "1991-2020": 741
   },
   "seasons": {
    "djf": 190,
    "jja": 198,
    "mam": 155,
    "son": 199
   },
   "summer_half": 353,
   "winter_half": 388
  },
  "WF13": {
   "cells": 15,
   "mm": 689,
   "n": 738,
   "periods": {
    "1961-1990": 691,
    "1981-2010": 680,
    "1991-2020": 689
   },
   "seasons": {
    "djf": 175,
    "jja": 185,
    "mam": 143,
    "son": 186
   },
   "summer_half": 328,
   "winter_half": 361
  },
  "WF14": {
   "cells": 23,
   "mm": 780,
   "n": 583,
   "periods": {
    "1961-1990": 772,
    "1981-2010": 769,
    "1991-2020": 780
   },
   "seasons": {
    "djf": 207,
    "jja": 201,
    "mam": 160,
    "son": 212
   },
   "summer_half": 361,
   "winter_half": 419
  },
  "WF15": {
   "cells": 16,
   "mm": 772,
   "n": 511,
   "periods": {
    "1961-1990": 764,
    "1981-2010": 758,
    "1991-2020": 772
   },
   "seasons": {
    "djf": 202,
    "jja": 202,
    "mam": 157,
    "son": 211
   },
   "summer_half": 359,
   "winter_half": 413
  },
  "WF16": {
   "cells": 9,
   "mm": 704,
   "n": 359,
   "periods": {
    "1961-1990": 700,
    "1981-2010": 690,
    "1991-2020": 704
   },
   "seasons": {
    "djf": 176,
    "jja": 193,
    "mam": 144,
    "son": 190
   },
   "summer_half": 338,
   "winter_half": 366
  },
  "WF17": {
   "cells": 22,
   "mm": 728,
   "n": 1113,
   "periods": {
    "1961-1990": 717,
    "1981-2010": 714,
    "1991-2020": 728
   },
   "seasons": {
    "djf": 181,
    "jja": 202,
    "mam": 151,
    "son": 193
   },
   "summer_half": 354,
   "winter_half": 374
  },
  "WF2": {
   "cells": 43,
   "mm": 664,
   "n": 1329,
   "periods": {
    "1961-1990": 647,
    "1981-2010": 658,
    "1991-2020": 664
   },
   "seasons": {
    "djf": 161,
    "jja": 182,
    "mam": 140,
    "son": 181
   },
   "summer_half": 322,
   "winter_half": 342
  },
  "WF3": {
   "cells": 38,
   "mm": 700,
   "n": 960,
   "periods": {
    "1961-1990": 676,
    "1981-2010": 689,
    "1991-2020": 700
   },
   "seasons": {
    "djf": 172,
    "jja": 190,
    "mam": 147,
    "son": 191
   },
   "summer_half": 337,
   "winter_half": 363
  },
  "WF4": {
   "cells": 98,
   "mm": 710,
   "n": 1267,
   "periods": {
    "1961-1990": 688,
    "1981-2010": 700,
    "1991-2020": 710
   },
   "seasons": {
    "djf": 175,
    "jja": 194,
    "mam": 149,
    "son": 192
   },
   "summer_half": 343,
   "winter_half": 367
  },
  "WF5": {
   "cells": 18,
   "mm": 708,
   "n": 664,
   "periods": {
    "1961-1990": 689,
    "1981-2010": 698,
    "1991-2020": 708
   },
   "seasons": {
    "djf": 178,
    "jja": 191,
    "mam": 149,
    "son": 190
   },
   "summer_half": 340,
   "winter_half": 368
  },
  "WF6": {
   "cells": 20,
   "mm": 648,
   "n": 584,
   "periods": {
    "1961-1990": 629,
    "1981-2010": 641,
    "1991-2020": 648
   },
   "seasons": {
    "djf": 147,
    "jja": 186,
    "mam": 137,
    "son": 177
   },
   "summer_half": 323,
   "winter_half": 325
  },
  "WF7": {
   "cells": 32,
   "mm": 638,
   "n": 572,
   "periods": {
    "1961-1990": 618,
    "1981-2010": 626,
    "1991-2020": 638
   },
   "seasons": {
    "djf": 140,
    "jja": 187,
    "mam": 134,
    "son": 177
   },
   "summer_half": 320,
   "winter_half": 318
  },
  "WF8": {
   "cells": 48,
   "mm": 614,
   "n": 1027,
   "periods": {
    "1961-1990": 605,
    "1981-2010": 604,
    "1991-2020": 614
   },
   "seasons": {
    "djf": 135,
    "jja": 177,
    "mam": 127,
    "son": 175
   },
   "summer_half": 304,
   "winter_half": 311
  },
  "WF9": {
   "cells": 44,
   "mm": 651,
   "n": 1152,
   "periods": {
    "1961-1990": 632,
    "1981-2010": 642,
    "1991-2020": 651
   },
   "seasons": {
    "djf": 144,
    "jja": 191,
    "mam": 136,
    "son": 179
   },
   "summer_half": 327,
   "winter_half": 323
  },
  "WF90": {
   "cells": 1,
   "mm": 610,
   "n": 3,
   "periods": {
    "1961-1990": 599,
    "1981-2010": 609,
    "1991-2020": 610
   },
   "seasons": {
    "djf": 140,
    "jja": 171,
    "mam": 127,
    "son": 172
   },
   "summer_half": 298,
   "winter_half": 312
  },
  "WN1": {
   "cells": 21,
   "mm": 1051,
   "n": 695,
   "periods": {
    "1961-1990": 1017,
    "1981-2010": 1030,
    "1991-2020": 1051
   },
   "seasons": {
    "djf": 289,
    "jja": 254,
    "mam": 194,
    "son": 315
   },
   "summer_half": 447,
   "winter_half": 604
  },
  "WN2": {
   "cells": 53,
   "mm": 1059,
   "n": 1274,
   "periods": {
    "1961-1990": 1026,
    "1981-2010": 1037,
    "1991-2020": 1059
   },
   "seasons": {
    "djf": 292,
    "jja": 258,
    "mam": 198,
    "son": 311
   },
   "summer_half": 456,
   "winter_half": 603
  },
  "WN3": {
   "cells": 15,
   "mm": 984,
   "n": 717,
   "periods": {
    "1961-1990": 961,
    "1981-2010": 969,
    "1991-2020": 984
   },
   "seasons": {
    "djf": 265,
    "jja": 241,
    "mam": 184,
    "son": 293
   },
   "summer_half": 425,
   "winter_half": 559
  },
  "WN4": {
   "cells": 22,
   "mm": 970,
   "n": 604,
   "periods": {
    "1961-1990": 947,
    "1981-2010": 958,
    "1991-2020": 970
   },
   "seasons": {
    "djf": 255,
    "jja": 249,
    "mam": 182,
    "son": 283
   },
   "summer_half": 432,
   "winter_half": 539
  },
  "WN5": {
   "cells": 32,
   "mm": 1000,
   "n": 936,
   "periods": {
    "1961-1990": 983,
    "1981-2010": 989,
    "1991-2020": 1000
   },
   "seasons": {
    "djf": 263,
    "jja": 248,
    "mam": 189,
    "son": 300
   },
   "summer_half": 437,
   "winter_half": 564
  },
  "WN6": {
   "cells": 43,
   "mm": 1027,
   "n": 932,
   "periods": {
    "1961-1990": 989,
    "1981-2010": 1006,
    "1991-2020": 1027
   },
   "seasons": {
    "djf": 278,
    "jja": 255,
    "mam": 188,
    "son": 306
   },
   "summer_half": 443,
   "winter_half": 584
  },
  "WN7": {
   "cells": 31,
   "mm": 928,
   "n": 1215,
   "periods": {
    "1961-1990": 912,
    "1981-2010": 913,
    "1991-2020": 928
   },
   "seasons": {
    "djf": 250,
    "jja": 230,
    "mam": 182,
    "son": 266
   },
   "summer_half": 412,
   "winter_half": 516
  },
  "WN8": {
   "cells": 52,
   "mm": 977,
   "n": 927,
   "periods": {
    "1961-1990": 948,
    "1981-2010": 962,
    "1991-2020": 977
   },
   "seasons": {
    "djf": 258,
    "jja": 241,
    "mam": 181,
    "son": 297
   },
   "summer_half": 422,
   "winter_half": 555
  },
  "WR1": {
   "cells": 6,
   "mm": 679,
   "n": 430,
   "periods": {
    "1961-1990": 604,
    "1981-2010": 660,
    "1991-2020": 679
   },
   "seasons": {
    "djf": 169,
    "jja": 170,
    "mam": 149,
    "son": 191
   },
   "summer_half": 319,
   "winter_half": 360
  },
  "WR10": {
   "cells": 92,
   "mm": 656,
   "n": 675,
   "periods": {
    "1961-1990": 586,
    "1981-2010": 627,
    "1991-2020": 656
   },
   "seasons": {
    "djf": 158,
    "jja": 172,
    "mam": 145,
    "son": 181
   },
   "summer_half": 318,
   "winter_half": 339
  },
  "WR11": {
   "cells": 114,
   "mm": 662,
   "n": 1215,
   "periods": {
    "1961-1990": 615,
    "1981-2010": 643,
    "1991-2020": 662
   },
   "seasons": {
    "djf": 159,
    "jja": 178,
    "mam": 146,
    "son": 179
   },
   "summer_half": 324,
   "winter_half": 338
  },
  "WR12": {
   "cells": 39,
   "mm": 695,
   "n": 206,
   "periods": {
    "1961-1990": 657,
    "1981-2010": 677,
    "1991-2020": 695
   },
   "seasons": {
    "djf": 172,
    "jja": 170,
    "mam": 157,
    "son": 195
   },
   "summer_half": 328,
   "winter_half": 367
  },
  "WR13": {
   "cells": 108,
   "mm": 739,
   "n": 377,
   "periods": {
    "1961-1990": 676,
    "1981-2010": 719,
    "1991-2020": 739
   },
   "seasons": {
    "djf": 186,
    "jja": 184,
    "mam": 161,
    "son": 208
   },
   "summer_half": 344,
   "winter_half": 394
  },
  "WR14": {
   "cells": 36,
   "mm": 783,
   "n": 1085,
   "periods": {
    "1961-1990": 710,
    "1981-2010": 762,
    "1991-2020": 783
   },
   "seasons": {
    "djf": 200,
    "jja": 192,
    "mam": 170,
    "son": 221
   },
   "summer_half": 362,
   "winter_half": 421
  },
  "WR15": {
   "cells": 82,
   "mm": 769,
   "n": 261,
   "periods": {
    "1961-1990": 707,
    "1981-2010": 745,
    "1991-2020": 769
   },
   "seasons": {
    "djf": 201,
    "jja": 187,
    "mam": 164,
    "son": 216
   },
   "summer_half": 351,
   "winter_half": 418
  },
  "WR2": {
   "cells": 51,
   "mm": 704,
   "n": 812,
   "periods": {
    "1961-1990": 628,
    "1981-2010": 685,
    "1991-2020": 704
   },
   "seasons": {
    "djf": 178,
    "jja": 175,
    "mam": 154,
    "son": 197
   },
   "summer_half": 328,
   "winter_half": 375
  },
  "WR3": {
   "cells": 28,
   "mm": 702,
   "n": 535,
   "periods": {
    "1961-1990": 630,
    "1981-2010": 680,
    "1991-2020": 702
   },
   "seasons": {
    "djf": 171,
    "jja": 182,
    "mam": 154,
    "son": 195
   },
   "summer_half": 336,
   "winter_half": 366
  },
  "WR4": {
   "cells": 15,
   "mm": 686,
   "n": 625,
   "periods": {
    "1961-1990": 620,
    "1981-2010": 667,
    "1991-2020": 686
   },
   "seasons": {
    "djf": 167,
    "jja": 176,
    "mam": 152,
    "son": 192
   },
   "summer_half": 328,
   "winter_half": 359
  },
  "WR5": {
   "cells": 46,
   "mm": 678,
   "n": 816,
   "periods": {
    "1961-1990": 614,
    "1981-2010": 660,
    "1991-2020": 678
   },
   "seasons": {
    "djf": 170,
    "jja": 170,
    "mam": 149,
    "son": 190
   },
   "summer_half": 319,
   "winter_half": 359
  },
  "WR6": {
   "cells": 209,
   "mm": 755,
   "n": 522,
   "periods": {
    "1961-1990": 684,
    "1981-2010": 731,
    "1991-2020": 755
   },
   "seasons": {
    "djf": 192,
    "jja": 186,
    "mam": 166,
    "son": 211
   },
   "summer_half": 352,
   "winter_half": 403
  },
  "WR7": {
   "cells": 73,
   "mm": 683,
   "n": 217,
   "periods": {
    "1961-1990": 625,
    "1981-2010": 662,
    "1991-2020": 683
   },
   "seasons": {
    "djf": 164,
    "jja": 178,
    "mam": 151,
    "son": 190
   },
   "summer_half": 329,
   "winter_half": 354
  },
  "WR8": {
   "cells": 88,
   "mm": 682,
   "n": 342,
   "periods": {
    "1961-1990": 615,
    "1981-2010": 657,
    "1991-2020": 682
   },
   "seasons": {
    "djf": 174,
    "jja": 169,
    "mam": 148,
    "son": 191
   },
   "summer_half": 317,
   "winter_half": 365
  },
  "WR9": {
   "cells": 110,
   "mm": 688,
   "n": 893,
   "periods": {
    "1961-1990": 632,
    "1981-2010": 668,
    "1991-2020": 688
   },
   "seasons": {
    "djf": 168,
    "jja": 181,
    "mam": 148,
    "son": 192
   },
   "summer_half": 329,
   "winter_half": 359
  },
  "WR99": {
   "cells": 3,
   "mm": 689,
   "n": 5,
   "periods": {
    "1961-1990": 616,
    "1981-2010": 670,
    "1991-2020": 689
   },
   "seasons": {
    "djf": 171,
    "jja": 173,
    "mam": 152,
    "son": 193
   },
   "summer_half": 325,
   "winter_half": 364
  },
  "WS1": {
   "cells": 11,
   "mm": 740,
   "n": 622,
   "periods": {
    "1961-1990": 695,
    "1981-2010": 725,
    "1991-2020": 740
   },
   "seasons": {
    "djf": 187,
    "jja": 186,
    "mam": 161,
    "son": 207
   },
   "summer_half": 346,
   "winter_half": 394
  },
  "WS10": {
   "cells": 22,
   "mm": 743,
   "n": 933,
   "periods": {
    "1961-1990": 697,
    "1981-2010": 731,
    "1991-2020": 743
   },
   "seasons": {
    "djf": 186,
    "jja": 189,
    "mam": 159,
    "son": 209
   },
   "summer_half": 348,
   "winter_half": 395
  },
  "WS11": {
   "cells": 34,
   "mm": 739,
   "n": 1016,
   "periods": {
    "1961-1990": 697,
    "1981-2010": 719,
    "1991-2020": 739
   },
   "seasons": {
    "djf": 183,
    "jja": 198,
    "mam": 159,
    "son": 200
   },
   "summer_half": 357,
   "winter_half": 382
  },
  "WS12": {
   "cells": 32,
   "mm": 764,
   "n": 754,
   "periods": {
    "1961-1990": 726,
    "1981-2010": 746,
    "1991-2020": 764
   },
   "seasons": {
    "djf": 183,
    "jja": 213,
    "mam": 165,
    "son": 202
   },
   "summer_half": 378,
   "winter_half": 386
  },
  "WS13": {
   "cells": 71,
   "mm": 676,
   "n": 895,
   "periods": {
    "1961-1990": 659,
    "1981-2010": 669,
    "1991-2020": 676
   },
   "seasons": {
    "djf": 167,
    "jja": 179,
    "mam": 149,
    "son": 181
   },
   "summer_half": 328,
   "winter_half": 348
  },
  "WS14": {
   "cells": 65,
   "mm": 683,
   "n": 583,
   "periods": {
    "1961-1990": 658,
    "1981-2010": 671,
    "1991-2020": 683
   },
   "seasons": {
    "djf": 171,
    "jja": 176,
    "mam": 151,
    "son": 185
   },
   "summer_half": 327,
   "winter_half": 357
  },
  "WS15": {
   "cells": 121,
   "mm": 726,
   "n": 1072,
   "periods": {
    "1961-1990": 707,
    "1981-2010": 719,
    "1991-2020": 726
   },
   "seasons": {
    "djf": 180,
    "jja": 192,
    "mam": 160,
    "son": 195
   },
   "summer_half": 352,
   "winter_half": 375
  },
  "WS2": {
   "cells": 20,
   "mm": 750,
   "n": 739,
   "periods": {
    "1961-1990": 698,
    "1981-2010": 735,
    "1991-2020": 750
   },
   "seasons": {
    "djf": 188,
    "jja": 190,
    "mam": 162,
    "son": 210
   },
   "summer_half": 351,
   "winter_half": 398
  },
  "WS3": {
   "cells": 27,
   "mm": 761,
   "n": 1003,
   "periods": {
    "1961-1990": 706,
    "1981-2010": 738,
    "1991-2020": 761
   },
   "seasons": {
    "djf": 191,
    "jja": 197,
    "mam": 165,
    "son": 209
   },
   "summer_half": 361,
   "winter_half": 400
  },
  "WS4": {
   "cells": 13,
   "mm": 755,
   "n": 337,
   "periods": {
    "1961-1990": 701,
    "1981-2010": 732,
    "1991-2020": 755
   },
   "seasons": {
    "djf": 191,
    "jja": 192,
    "mam": 165,
    "son": 207
   },
   "summer_half": 356,
   "winter_half": 398
  },
  "WS5": {
   "cells": 13,
   "mm": 756,
   "n": 377,
   "periods": {
    "1961-1990": 713,
    "1981-2010": 742,
    "1991-2020": 756
   },
   "seasons": {
    "djf": 193,
    "jja": 190,
    "mam": 164,
    "son": 210
   },
   "summer_half": 354,
   "winter_half": 403
  },
  "WS6": {
   "cells": 12,
   "mm": 771,
   "n": 339,
   "periods": {
    "1961-1990": 721,
    "1981-2010": 749,
    "1991-2020": 771
   },
   "seasons": {
    "djf": 194,
    "jja": 201,
    "mam": 166,
    "son": 210
   },
   "summer_half": 367,
   "winter_half": 404
  },
  "WS7": {
   "cells": 24,
   "mm": 718,
   "n": 671,
   "periods": {
    "1961-1990": 687,
    "1981-2010": 706,
    "1991-2020": 718
   },
   "seasons": {
    "djf": 177,
    "jja": 191,
    "mam": 158,
    "son": 191
   },
   "summer_half": 349,
   "winter_half": 368
  },
  "WS8": {
   "cells": 15,
   "mm": 753,
   "n": 323,
   "periods": {
    "1961-1990": 700,
    "1981-2010": 729,
    "1991-2020": 753
   },
   "seasons": {
    "djf": 188,
    "jja": 198,
    "mam": 163,
    "son": 204
   },
   "summer_half": 362,
   "winter_half": 392
  },
  "WS9": {
   "cells": 39,
   "mm": 767,
   "n": 630,
   "periods": {
    "1961-1990": 718,
    "1981-2010": 746,
    "1991-2020": 767
   },
   "seasons": {
    "djf": 195,
    "jja": 195,
    "mam": 168,
    "son": 209
   },
   "summer_half": 363,
   "winter_half": 404
  },
  "WV1": {
   "cells": 12,
   "mm": 754,
   "n": 676,
   "periods": {
    "1961-1990": 704,
    "1981-2010": 732,
    "1991-2020": 754
   },
   "seasons": {
    "djf": 181,
    "jja": 199,
    "mam": 169,
    "son": 205
   },
   "summer_half": 368,
   "winter_half": 386
  },
  "WV10": {
   "cells": 47,
   "mm": 735,
   "n": 1159,
   "periods": {
    "1961-1990": 694,
    "1981-2010": 713,
    "1991-2020": 735
   },
   "seasons": {
    "djf": 179,
    "jja": 196,
    "mam": 158,
    "son": 202
   },
   "summer_half": 354,
   "winter_half": 381
  },
  "WV11": {
   "cells": 28,
   "mm": 780,
   "n": 683,
   "periods": {
    "1961-1990": 730,
    "1981-2010": 759,
    "1991-2020": 780
   },
   "seasons": {
    "djf": 193,
    "jja": 203,
    "mam": 167,
    "son": 216
   },
   "summer_half": 371,
   "winter_half": 409
  },
  "WV12": {
   "cells": 13,
   "mm": 776,
   "n": 501,
   "periods": {
    "1961-1990": 720,
    "1981-2010": 759,
    "1991-2020": 776
   },
   "seasons": {
    "djf": 193,
    "jja": 200,
    "mam": 166,
    "son": 217
   },
   "summer_half": 366,
   "winter_half": 410
  },
  "WV13": {
   "cells": 14,
   "mm": 754,
   "n": 508,
   "periods": {
    "1961-1990": 700,
    "1981-2010": 737,
    "1991-2020": 754
   },
   "seasons": {
    "djf": 186,
    "jja": 196,
    "mam": 162,
    "son": 210
   },
   "summer_half": 358,
   "winter_half": 396
  },
  "WV14": {
   "cells": 22,
   "mm": 770,
   "n": 1038,
   "periods": {
    "1961-1990": 725,
    "1981-2010": 754,
    "1991-2020": 770
   },
   "seasons": {
    "djf": 188,
    "jja": 202,
    "mam": 165,
    "son": 216
   },
   "summer_half": 367,
   "winter_half": 403
  },
  "WV15": {
   "cells": 75,
   "mm": 712,
   "n": 295,
   "periods": {
    "1961-1990": 672,
    "1981-2010": 695,
    "1991-2020": 712
   },
   "seasons": {
    "djf": 184,
    "jja": 181,
    "mam": 153,
    "son": 194
   },
   "summer_half": 334,
   "winter_half": 378
  },
  "WV16": {
   "cells": 136,
   "mm": 787,
   "n": 561,
   "periods": {
    "1961-1990": 735,
    "1981-2010": 766,
    "1991-2020": 787
   },
   "seasons": {
    "djf": 209,
    "jja": 193,
    "mam": 168,
    "son": 217
   },
   "summer_half": 361,
   "winter_half": 426
  },
  "WV2": {
   "cells": 10,
   "mm": 771,
   "n": 455,
   "periods": {
    "1961-1990": 725,
    "1981-2010": 752,
    "1991-2020": 771
   },
   "seasons": {
    "djf": 185,
    "jja": 204,
    "mam": 170,
    "son": 212
   },
   "summer_half": 375,
   "winter_half": 397
  },
  "WV3": {
   "cells": 17,
   "mm": 743,
   "n": 614,
   "periods": {
    "1961-1990": 699,
    "1981-2010": 724,
    "1991-2020": 743
   },
   "seasons": {
    "djf": 177,
    "jja": 199,
    "mam": 166,
    "son": 202
   },
   "summer_half": 364,
   "winter_half": 379
  },
  "WV4": {
   "cells": 28,
   "mm": 742,
   "n": 738,
   "periods": {
    "1961-1990": 702,
    "1981-2010": 726,
    "1991-2020": 742
   },
   "seasons": {
    "djf": 179,
    "jja": 198,
    "mam": 162,
    "son": 203
   },
   "summer_half": 360,
   "winter_half": 382
  },
  "WV5": {
   "cells": 43,
   "mm": 702,
   "n": 471,
   "periods": {
    "1961-1990": 668,
    "1981-2010": 687,
    "1991-2020": 702
   },
   "seasons": {
    "djf": 175,
    "jja": 179,
    "mam": 154,
    "son": 194
   },
   "summer_half": 332,
   "winter_half": 369
  },
  "WV6": {
   "cells": 61,
   "mm": 713,
   "n": 1045,
   "periods": {
    "1961-1990": 677,
    "1981-2010": 695,
    "1991-2020": 713
   },
   "seasons": {
    "djf": 174,
    "jja": 191,
    "mam": 155,
    "son": 194
   },
   "summer_half": 346,
   "winter_half": 367
  },
  "WV7": {
   "cells": 25,
   "mm": 706,
   "n": 204,
   "periods": {
    "1961-1990": 677,
    "1981-2010": 689,
    "1991-2020": 706
   },
   "seasons": {
    "djf": 173,
    "jja": 191,
    "mam": 151,
    "son": 191
   },
   "summer_half": 342,
   "winter_half": 364
  },
  "WV8": {
   "cells": 32,
   "mm": 730,
   "n": 432,
   "periods": {
    "1961-1990": 696,
    "1981-2010": 711,
    "1991-2020": 730
   },
   "seasons": {
    "djf": 177,
    "jja": 198,
    "mam": 157,
    "son": 198
   },
   "summer_half": 355,
   "winter_half": 376
  },
  "WV9": {
   "cells": 23,
   "mm": 719,
   "n": 188,
   "periods": {
    "1961-1990": 682,
    "1981-2010": 698,
    "1991-2020": 719
   },
   "seasons": {
    "djf": 173,
    "jja": 194,
    "mam": 155,
    "son": 196
   },
   "summer_half": 349,
   "winter_half": 370
  },
  "WV98": {
   "cells": 2,
   "mm": 697,
   "n": 396,
   "periods": {
    "1961-1990": 656,
    "1981-2010": 678,
    "1991-2020": 697
   },
   "seasons": {
    "djf": 173,
    "jja": 181,
    "mam": 153,
    "son": 190
   },
   "summer_half": 334,
   "winter_half": 363
  },
  "WV99": {
   "cells": 1,
   "mm": 774,
   "n": 520,
   "periods": {
    "1961-1990": 745,
    "1981-2010": 758,
    "1991-2020": 774
   },
   "seasons": {
    "djf": 193,
    "jja": 204,
    "mam": 172,
    "son": 206
   },
   "summer_half": 376,
   "winter_half": 399
  },
  "YO1": {
   "cells": 5,
   "mm": 665,
   "n": 439,
   "periods": {
    "1961-1990": 634,
    "1981-2010": 641,
    "1991-2020": 665
   },
   "seasons": {
    "djf": 151,
    "jja": 197,
    "mam": 134,
    "son": 183
   },
   "summer_half": 331,
   "winter_half": 334
  },
  "YO10": {
   "cells": 19,
   "mm": 630,
   "n": 643,
   "periods": {
    "1961-1990": 604,
    "1981-2010": 609,
    "1991-2020": 630
   },
   "seasons": {
    "djf": 146,
    "jja": 182,
    "mam": 128,
    "son": 174
   },
   "summer_half": 310,
   "winter_half": 320
  },
  "YO11": {
   "cells": 28,
   "mm": 715,
   "n": 792,
   "periods": {
    "1961-1990": 653,
    "1981-2010": 695,
    "1991-2020": 715
   },
   "seasons": {
    "djf": 178,
    "jja": 197,
    "mam": 142,
    "son": 199
   },
   "summer_half": 339,
   "winter_half": 376
  },
  "YO12": {
   "cells": 57,
   "mm": 740,
   "n": 889,
   "periods": {
    "1961-1990": 686,
    "1981-2010": 719,
    "1991-2020": 740
   },
   "seasons": {
    "djf": 183,
    "jja": 200,
    "mam": 146,
    "son": 211
   },
   "summer_half": 346,
   "winter_half": 394
  },
  "YO13": {
   "cells": 113,
   "mm": 803,
   "n": 419,
   "periods": {
    "1961-1990": 749,
    "1981-2010": 787,
    "1991-2020": 803
   },
   "seasons": {
    "djf": 201,
    "jja": 209,
    "mam": 158,
    "son": 234
   },
   "summer_half": 368,
   "winter_half": 435
  },
  "YO14": {
   "cells": 35,
   "mm": 727,
   "n": 405,
   "periods": {
    "1961-1990": 681,
    "1981-2010": 710,
    "1991-2020": 727
   },
   "seasons": {
    "djf": 184,
    "jja": 194,
    "mam": 147,
    "son": 201
   },
   "summer_half": 341,
   "winter_half": 385
  },
  "YO15": {
   "cells": 33,
   "mm": 678,
   "n": 493,
   "periods": {
    "1961-1990": 669,
    "1981-2010": 678,
    "1991-2020": 678
   },
   "seasons": {
    "djf": 173,
    "jja": 177,
    "mam": 140,
    "son": 188
   },
   "summer_half": 317,
   "winter_half": 361
  },
  "YO16": {
   "cells": 34,
   "mm": 707,
   "n": 681,
   "periods": {
    "1961-1990": 685,
    "1981-2010": 694,
    "1991-2020": 707
   },
   "seasons": {
    "djf": 181,
    "jja": 185,
    "mam": 147,
    "son": 194
   },
   "summer_half": 331,
   "winter_half": 376
  },
  "YO17": {
   "cells": 192,
   "mm": 720,
   "n": 834,
   "periods": {
    "1961-1990": 675,
    "1981-2010": 697,
    "1991-2020": 720
   },
   "seasons": {
    "djf": 180,
    "jja": 196,
    "mam": 142,
    "son": 203
   },
   "summer_half": 338,
   "winter_half": 382
  },
  "YO18": {
   "cells": 109,
   "mm": 847,
   "n": 435,
   "periods": {
    "1961-1990": 812,
    "1981-2010": 837,
    "1991-2020": 847
   },
   "seasons": {
    "djf": 220,
    "jja": 212,
    "mam": 167,
    "son": 247
   },
   "summer_half": 379,
   "winter_half": 467
  },
  "YO19": {
   "cells": 95,
   "mm": 620,
   "n": 493,
   "periods": {
    "1961-1990": 596,
    "1981-2010": 601,
    "1991-2020": 620
   },
   "seasons": {
    "djf": 144,
    "jja": 179,
    "mam": 127,
    "son": 170
   },
   "summer_half": 305,
   "winter_half": 315
  },
  "YO21": {
   "cells": 116,
   "mm": 832,
   "n": 680,
   "periods": {
    "1961-1990": 789,
    "1981-2010": 817,
    "1991-2020": 832
   },
   "seasons": {
    "djf": 215,
    "jja": 211,
    "mam": 161,
    "son": 245
   },
   "summer_half": 372,
   "winter_half": 460
  },
  "YO22": {
   "cells": 78,
   "mm": 759,
   "n": 443,
   "periods": {
    "1961-1990": 725,
    "1981-2010": 753,
    "1991-2020": 759
   },
   "seasons": {
    "djf": 200,
    "jja": 190,
    "mam": 146,
    "son": 223
   },
   "summer_half": 336,
   "winter_half": 423
  },
  "YO23": {
   "cells": 70,
   "mm": 630,
   "n": 585,
   "periods": {
    "1961-1990": 598,
    "1981-2010": 611,
    "1991-2020": 630
   },
   "seasons": {
    "djf": 147,
    "jja": 179,
    "mam": 128,
    "son": 175
   },
   "summer_half": 308,
   "winter_half": 322
  },
  "YO24": {
   "cells": 16,
   "mm": 627,
   "n": 697,
   "periods": {
    "1961-1990": 592,
    "1981-2010": 605,
    "1991-2020": 627
   },
   "seasons": {
    "djf": 144,
    "jja": 179,
    "mam": 127,
    "son": 177
   },
   "summer_half": 306,
   "winter_half": 321
  },
  "YO25": {
   "cells": 317,
   "mm": 723,
   "n": 1396,
   "periods": {
    "1961-1990": 680,
    "1981-2010": 708,
    "1991-2020": 723
   },
   "seasons": {
    "djf": 181,
    "jja": 195,
    "mam": 146,
    "son": 199
   },
   "summer_half": 342,
   "winter_half": 381
  },
  "YO26": {
   "cells": 111,
   "mm": 650,
   "n": 885,
   "periods": {
    "1961-1990": 619,
    "1981-2010": 632,
    "1991-2020": 650
   },
   "seasons": {
    "djf": 154,
    "jja": 182,
    "mam": 134,
    "son": 180
   },
   "summer_half": 315,
   "winter_half": 335
  },
  "YO30": {
   "cells": 45,
   "mm": 642,
   "n": 680,
   "periods": {
    "1961-1990": 607,
    "1981-2010": 623,
    "1991-2020": 642
   },
   "seasons": {
    "djf": 150,
    "jja": 183,
    "mam": 131,
    "son": 177
   },
   "summer_half": 314,
   "winter_half": 327
  },
  "YO31": {
   "cells": 14,
   "mm": 651,
   "n": 810,
   "periods": {
    "1961-1990": 620,
    "1981-2010": 627,
    "1991-2020": 651
   },
   "seasons": {
    "djf": 150,
    "jja": 190,
    "mam": 131,
    "son": 179
   },
   "summer_half": 321,
   "winter_half": 329
  },
  "YO32": {
   "cells": 61,
   "mm": 653,
   "n": 790,
   "periods": {
    "1961-1990": 622,
    "1981-2010": 631,
    "1991-2020": 653
   },
   "seasons": {
    "djf": 155,
    "jja": 186,
    "mam": 133,
    "son": 178
   },
   "summer_half": 319,
   "winter_half": 333
  },
  "YO41": {
   "cells": 100,
   "mm": 720,
   "n": 439,
   "periods": {
    "1961-1990": 685,
    "1981-2010": 700,
    "1991-2020": 720
   },
   "seasons": {
    "djf": 175,
    "jja": 199,
    "mam": 143,
    "son": 202
   },
   "summer_half": 342,
   "winter_half": 377
  },
  "YO42": {
   "cells": 151,
   "mm": 739,
   "n": 736,
   "periods": {
    "1961-1990": 700,
    "1981-2010": 717,
    "1991-2020": 739
   },
   "seasons": {
    "djf": 179,
    "jja": 206,
    "mam": 147,
    "son": 206
   },
   "summer_half": 354,
   "winter_half": 386
  },
  "YO43": {
   "cells": 102,
   "mm": 702,
   "n": 484,
   "periods": {
    "1961-1990": 665,
    "1981-2010": 680,
    "1991-2020": 702
   },
   "seasons": {
    "djf": 169,
    "jja": 198,
    "mam": 138,
    "son": 198
   },
   "summer_half": 336,
   "winter_half": 366
  },
  "YO51": {
   "cells": 40,
   "mm": 667,
   "n": 263,
   "periods": {
    "1961-1990": 624,
    "1981-2010": 641,
    "1991-2020": 667
   },
   "seasons": {
    "djf": 162,
    "jja": 184,
    "mam": 135,
    "son": 186
   },
   "summer_half": 319,
   "winter_half": 348
  },
  "YO60": {
   "cells": 113,
   "mm": 727,
   "n": 257,
   "periods": {
    "1961-1990": 682,
    "1981-2010": 705,
    "1991-2020": 727
   },
   "seasons": {
    "djf": 180,
    "jja": 202,
    "mam": 143,
    "son": 202
   },
   "summer_half": 346,
   "winter_half": 381
  },
  "YO61": {
   "cells": 185,
   "mm": 689,
   "n": 672,
   "periods": {
    "1961-1990": 648,
    "1981-2010": 674,
    "1991-2020": 689
   },
   "seasons": {
    "djf": 165,
    "jja": 193,
    "mam": 139,
    "son": 192
   },
   "summer_half": 332,
   "winter_half": 358
  },
  "YO62": {
   "cells": 196,
   "mm": 813,
   "n": 623,
   "periods": {
    "1961-1990": 765,
    "1981-2010": 794,
    "1991-2020": 813
   },
   "seasons": {
    "djf": 211,
    "jja": 208,
    "mam": 160,
    "son": 234
   },
   "summer_half": 368,
   "winter_half": 445
  },
  "YO7": {
   "cells": 227,
   "mm": 716,
   "n": 969,
   "periods": {
    "1961-1990": 670,
    "1981-2010": 701,
    "1991-2020": 716
   },
   "seasons": {
    "djf": 174,
    "jja": 198,
    "mam": 143,
    "son": 202
   },
   "summer_half": 341,
   "winter_half": 376
  },
  "YO8": {
   "cells": 161,
   "mm": 608,
   "n": 1334,
   "periods": {
    "1961-1990": 582,
    "1981-2010": 591,
    "1991-2020": 608
   },
   "seasons": {
    "djf": 137,
    "jja": 177,
    "mam": 124,
    "son": 170
   },
   "summer_half": 301,
   "winter_half": 307
  },
  "YO90": {
   "cells": 1,
   "mm": 662,
   "n": 10,
   "periods": {
    "1961-1990": 627,
    "1981-2010": 637,
    "1991-2020": 662
   },
   "seasons": {
    "djf": 147,
    "jja": 199,
    "mam": 133,
    "son": 183
   },
   "summer_half": 332,
   "winter_half": 329
  },
  "ZE1": {
   "cells": 21,
   "mm": 1230,
   "n": 327,
   "periods": {
    "1961-1990": 1171,
    "1981-2010": 1230,
    "1991-2020": 1230
   },
   "seasons": {
    "djf": 432,
    "jja": 203,
    "mam": 226,
    "son": 369
   },
   "summer_half": 429,
   "winter_half": 801
  },
  "ZE2": {
   "cells": 171,
   "mm": 1180,
   "n": 319,
   "periods": {
    "1961-1990": 1148,
    "1981-2010": 1188,
    "1991-2020": 1180
   },
   "seasons": {
    "djf": 394,
    "jja": 207,
    "mam": 222,
    "son": 357
   },
   "summer_half": 429,
   "winter_half": 751
  },
  "ZE3": {
   "cells": 4,
   "mm": 1009,
   "n": 12,
   "periods": {
    "1961-1990": 920,
    "1981-2010": 1004,
    "1991-2020": 1009
   },
   "seasons": {
    "djf": 313,
    "jja": 194,
    "mam": 190,
    "son": 312
   },
   "summer_half": 384,
   "winter_half": 625
  }
 }
};